"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[524],{

/***/ 57866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vg": function() { return /* binding */ AtmOpeningHours; },
/* harmony export */   "_Z": function() { return /* binding */ AtmType; },
/* harmony export */   "uv": function() { return /* binding */ BranchServices; },
/* harmony export */   "$q": function() { return /* binding */ ConsultationType; },
/* harmony export */   "lf": function() { return /* binding */ ExchangeRateSource; },
/* harmony export */   "u7": function() { return /* binding */ ExchangeSymbol; },
/* harmony export */   "ab": function() { return /* binding */ GdprUpdateType; },
/* harmony export */   "PX": function() { return /* binding */ IndexType; },
/* harmony export */   "in": function() { return /* binding */ LoanProductPaymentType; },
/* harmony export */   "yp": function() { return /* binding */ Region; },
/* harmony export */   "c": function() { return /* binding */ RequestGdprDataType; },
/* harmony export */   "VF": function() { return /* binding */ ServicePointType; },
/* harmony export */   "hn": function() { return /* binding */ SmartBookingCustomerType; },
/* harmony export */   "dR": function() { return /* binding */ VehicleEmissionType; }
/* harmony export */ });
/* unused harmony exports AssetCompositionType, AukakronurPartnerOrderByOption, AukakronurPartnerType, BankAccountState, BondOrder, Day, DerivativeContractStatus, FeeType, FundCategory, FundOrder, FundType, GeneralKnowledgeAssessment, HistoryGranularity, InterestRateType, MarketInstrumentOrderAction, MarketInstrumentOrderType, MarketOrderStatus, MarketStatus, MarketTransactionAction, MarketTransactionStatus, OpeningHours, OrderByDirection, PaymentType, PortfolioType, ProductType, ServiceLocationType, StockOrder, TradingComplianceInstrumentAction, TradingComplianceInstrumentNotAllowedInformation, TradingComplianceNextAction */
/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var AssetCompositionType;
/**
 * Opening hours for atms
 */

(function (AssetCompositionType) {
  AssetCompositionType["Cash"] = "Cash";
  AssetCompositionType["Instrument"] = "Instrument";
  AssetCompositionType["SharesOutStanding"] = "SharesOutStanding";
  AssetCompositionType["Unknown"] = "Unknown";
})(AssetCompositionType || (AssetCompositionType = {}));

var AtmOpeningHours;
/**
 * Types of Atm. f.x. deposit or currency
 */

(function (AtmOpeningHours) {
  AtmOpeningHours["AlwaysOpen"] = "AlwaysOpen";
  AtmOpeningHours["BranchHours"] = "BranchHours";
  AtmOpeningHours["BusinessHours"] = "BusinessHours";
  AtmOpeningHours["Unknown"] = "Unknown";
})(AtmOpeningHours || (AtmOpeningHours = {}));

var AtmType;

(function (AtmType) {
  AtmType["Atm"] = "Atm";
  AtmType["CoinCounterAtm"] = "CoinCounterAtm";
  AtmType["CoinRollAtm"] = "CoinRollAtm";
  AtmType["CorporateDepositAtm"] = "CorporateDepositAtm";
  AtmType["CurrencyAtm"] = "CurrencyAtm";
  AtmType["DepositAtm"] = "DepositAtm";
  AtmType["GiftCardAtm"] = "GiftCardAtm";
})(AtmType || (AtmType = {}));

var AukakronurPartnerOrderByOption;

(function (AukakronurPartnerOrderByOption) {
  AukakronurPartnerOrderByOption["Discount"] = "Discount";
  AukakronurPartnerOrderByOption["Distance"] = "Distance";
  AukakronurPartnerOrderByOption["Name"] = "Name";
})(AukakronurPartnerOrderByOption || (AukakronurPartnerOrderByOption = {}));

var AukakronurPartnerType;

(function (AukakronurPartnerType) {
  AukakronurPartnerType["Car"] = "Car";
  AukakronurPartnerType["Clothing"] = "Clothing";
  AukakronurPartnerType["Gifts"] = "Gifts";
  AukakronurPartnerType["Groceries"] = "Groceries";
  AukakronurPartnerType["Health"] = "Health";
  AukakronurPartnerType["Hobbies"] = "Hobbies";
  AukakronurPartnerType["Home"] = "Home";
  AukakronurPartnerType["Restaurants"] = "Restaurants";
  AukakronurPartnerType["Traveling"] = "Traveling";
})(AukakronurPartnerType || (AukakronurPartnerType = {}));

var BankAccountState;
/**
 * If you want the highest or lowest change in bonds
 */

(function (BankAccountState) {
  BankAccountState["Closed"] = "Closed";
  BankAccountState["Open"] = "Open";
  BankAccountState["Terminated"] = "Terminated";
})(BankAccountState || (BankAccountState = {}));

var BondOrder;
/**
 * Services available at branches
 */

(function (BondOrder) {
  BondOrder["Low"] = "Low";
  BondOrder["Rise"] = "Rise";
  BondOrder["Turnover"] = "Turnover";
})(BondOrder || (BondOrder = {}));

var BranchServices;

(function (BranchServices) {
  BranchServices["CashierService"] = "CashierService";
  BranchServices["CorporateBankingService"] = "CorporateBankingService";
  BranchServices["FinanceConsultation"] = "FinanceConsultation";
  BranchServices["MailDelivery"] = "MailDelivery";
  BranchServices["RetailBankingService"] = "RetailBankingService";
  BranchServices["ServiceVisit"] = "ServiceVisit";
})(BranchServices || (BranchServices = {}));

var ConsultationType;
/**
 * All days in a week
 */

(function (ConsultationType) {
  ConsultationType["Appointment"] = "Appointment";
  ConsultationType["Phonecall"] = "Phonecall";
  ConsultationType["Videocall"] = "Videocall";
})(ConsultationType || (ConsultationType = {}));

var Day;

(function (Day) {
  Day["Friday"] = "Friday";
  Day["Monday"] = "Monday";
  Day["Saturday"] = "Saturday";
  Day["Sunday"] = "Sunday";
  Day["Thursday"] = "Thursday";
  Day["Tuesday"] = "Tuesday";
  Day["Wednesday"] = "Wednesday";
})(Day || (Day = {}));

var DerivativeContractStatus;
/**
 * What source to read rates from
 */

(function (DerivativeContractStatus) {
  DerivativeContractStatus["Closed"] = "Closed";
  DerivativeContractStatus["Open"] = "Open";
})(DerivativeContractStatus || (DerivativeContractStatus = {}));

var ExchangeRateSource;

(function (ExchangeRateSource) {
  ExchangeRateSource["CentralBank"] = "CentralBank";
  ExchangeRateSource["Customs"] = "Customs";
  ExchangeRateSource["General"] = "General";
  ExchangeRateSource["Notes"] = "Notes";
  ExchangeRateSource["Spot"] = "Spot";
  ExchangeRateSource["Visa"] = "Visa";
})(ExchangeRateSource || (ExchangeRateSource = {}));

var ExchangeSymbol;

(function (ExchangeSymbol) {
  ExchangeSymbol["All"] = "All";
  ExchangeSymbol["FNIS"] = "FNIS";
  ExchangeSymbol["XICE"] = "XICE";
})(ExchangeSymbol || (ExchangeSymbol = {}));

var FeeType;

(function (FeeType) {
  FeeType["Amount"] = "Amount";
  FeeType["Information"] = "Information";
  FeeType["Label"] = "Label";
  FeeType["Percentage"] = "Percentage";
})(FeeType || (FeeType = {}));

var FundCategory;
/**
 * If you want the highest or lowest month return in funds
 */

(function (FundCategory) {
  FundCategory["AllianceBernstein"] = "AllianceBernstein";
  FundCategory["BalancedFund"] = "BalancedFund";
  FundCategory["BondFund"] = "BondFund";
  FundCategory["EquityFund"] = "EquityFund";
  FundCategory["ExchangeTradedFund"] = "ExchangeTradedFund";
  FundCategory["GovernmentBondFund"] = "GovernmentBondFund";
  FundCategory["MoneyMarketFund"] = "MoneyMarketFund";
  FundCategory["PrivateBankingFund"] = "PrivateBankingFund";
  FundCategory["ShortTermFund"] = "ShortTermFund";
  FundCategory["UknownCategory"] = "UknownCategory";
})(FundCategory || (FundCategory = {}));

var FundOrder;

(function (FundOrder) {
  FundOrder["Low"] = "Low";
  FundOrder["Rise"] = "Rise";
})(FundOrder || (FundOrder = {}));

var FundType;

(function (FundType) {
  FundType["Etf"] = "Etf";
  FundType["MutualFund"] = "MutualFund";
})(FundType || (FundType = {}));

var GdprUpdateType;

(function (GdprUpdateType) {
  GdprUpdateType["Correction"] = "Correction";
  GdprUpdateType["Deletion"] = "Deletion";
  GdprUpdateType["Limitation"] = "Limitation";
})(GdprUpdateType || (GdprUpdateType = {}));

var GeneralKnowledgeAssessment;

(function (GeneralKnowledgeAssessment) {
  GeneralKnowledgeAssessment["Advanced"] = "Advanced";
  GeneralKnowledgeAssessment["Basic"] = "Basic";
  GeneralKnowledgeAssessment["Informed"] = "Informed";
  GeneralKnowledgeAssessment["None"] = "None";
})(GeneralKnowledgeAssessment || (GeneralKnowledgeAssessment = {}));

var HistoryGranularity;

(function (HistoryGranularity) {
  HistoryGranularity["OneDay"] = "OneDay";
  HistoryGranularity["OneHour"] = "OneHour";
})(HistoryGranularity || (HistoryGranularity = {}));

var IndexType;

(function (IndexType) {
  IndexType["Indexed"] = "Indexed";
  IndexType["NotIndexed"] = "NotIndexed";
})(IndexType || (IndexType = {}));

var InterestRateType;

(function (InterestRateType) {
  InterestRateType["Deposit"] = "Deposit";
  InterestRateType["Loan"] = "Loan";
})(InterestRateType || (InterestRateType = {}));

var LoanProductPaymentType;

(function (LoanProductPaymentType) {
  LoanProductPaymentType["Annuitet"] = "Annuitet";
  LoanProductPaymentType["EqualInstallments"] = "EqualInstallments";
})(LoanProductPaymentType || (LoanProductPaymentType = {}));

var MarketInstrumentOrderAction;

(function (MarketInstrumentOrderAction) {
  MarketInstrumentOrderAction["Buy"] = "Buy";
  MarketInstrumentOrderAction["Sell"] = "Sell";
})(MarketInstrumentOrderAction || (MarketInstrumentOrderAction = {}));

var MarketInstrumentOrderType;

(function (MarketInstrumentOrderType) {
  MarketInstrumentOrderType["Amount"] = "Amount";
  MarketInstrumentOrderType["Limit"] = "Limit";
  MarketInstrumentOrderType["Market"] = "Market";
})(MarketInstrumentOrderType || (MarketInstrumentOrderType = {}));

var MarketOrderStatus;
/**
 * Is the market closed, open or wasOpen
 */

(function (MarketOrderStatus) {
  MarketOrderStatus["Cancelled"] = "Cancelled";
  MarketOrderStatus["Completed"] = "Completed";
  MarketOrderStatus["Expired"] = "Expired";
  MarketOrderStatus["Open"] = "Open";
  MarketOrderStatus["Rejected"] = "Rejected";
})(MarketOrderStatus || (MarketOrderStatus = {}));

var MarketStatus;

(function (MarketStatus) {
  MarketStatus["Closed"] = "Closed";
  MarketStatus["Open"] = "Open";
  MarketStatus["WasOpen"] = "WasOpen";
})(MarketStatus || (MarketStatus = {}));

var MarketTransactionAction;

(function (MarketTransactionAction) {
  MarketTransactionAction["Buy"] = "Buy";
  MarketTransactionAction["CustodyFee"] = "CustodyFee";
  MarketTransactionAction["Delivery"] = "Delivery";
  MarketTransactionAction["Dividend"] = "Dividend";
  MarketTransactionAction["Installment"] = "Installment";
  MarketTransactionAction["Interest"] = "Interest";
  MarketTransactionAction["PortfolioTransfer"] = "PortfolioTransfer";
  MarketTransactionAction["Reception"] = "Reception";
  MarketTransactionAction["Redemption"] = "Redemption";
  MarketTransactionAction["Sell"] = "Sell";
  MarketTransactionAction["StockSplit"] = "StockSplit";
})(MarketTransactionAction || (MarketTransactionAction = {}));

var MarketTransactionStatus;
/**
 * Opening hours for service locations
 */

(function (MarketTransactionStatus) {
  MarketTransactionStatus["Completed"] = "Completed";
  MarketTransactionStatus["ConfirmedPrice"] = "ConfirmedPrice";
  MarketTransactionStatus["New"] = "New";
  MarketTransactionStatus["Settlement"] = "Settlement";
  MarketTransactionStatus["UnconfirmedPrice"] = "UnconfirmedPrice";
})(MarketTransactionStatus || (MarketTransactionStatus = {}));

var OpeningHours;

(function (OpeningHours) {
  OpeningHours["AlwaysOpen"] = "AlwaysOpen";
  OpeningHours["BusinessHours"] = "BusinessHours";
  OpeningHours["Intervals"] = "Intervals";
  OpeningHours["NotOpen"] = "NotOpen";
  OpeningHours["UnknownPattern"] = "UnknownPattern";
  OpeningHours["Weekdays"] = "Weekdays";
})(OpeningHours || (OpeningHours = {}));

var OrderByDirection;

(function (OrderByDirection) {
  OrderByDirection["Asc"] = "Asc";
  OrderByDirection["Desc"] = "Desc";
})(OrderByDirection || (OrderByDirection = {}));

var PaymentType;
/**
 * Portfolio type
 */

(function (PaymentType) {
  PaymentType["Annuitet"] = "Annuitet";
  PaymentType["EqualInstallments"] = "EqualInstallments";
})(PaymentType || (PaymentType = {}));

var PortfolioType;
/**
 * What type of product e.g. loan, creditcard, account
 */

(function (PortfolioType) {
  PortfolioType["AssetManagement"] = "AssetManagement";
  PortfolioType["Custody"] = "Custody";
  PortfolioType["Storage"] = "Storage";
})(PortfolioType || (PortfolioType = {}));

var ProductType;
/**
 * Regions in Iceland
 */

(function (ProductType) {
  ProductType["Account"] = "Account";
  ProductType["CreditCard"] = "CreditCard";
  ProductType["Loan"] = "Loan";
  ProductType["RealestateLoan"] = "RealestateLoan";
})(ProductType || (ProductType = {}));

var Region;

(function (Region) {
  Region["All"] = "All";
  Region["Austurland"] = "Austurland";
  Region["Hofudborgarsvaedid"] = "Hofudborgarsvaedid";
  Region["Nordurland"] = "Nordurland";
  Region["Sudurland"] = "Sudurland";
  Region["Sudurnes"] = "Sudurnes";
  Region["Vestfirdir"] = "Vestfirdir";
  Region["Vesturland"] = "Vesturland";
})(Region || (Region = {}));

var RequestGdprDataType;
/**
 * The type of service location
 */

(function (RequestGdprDataType) {
  RequestGdprDataType["AssetManagement"] = "AssetManagement";
  RequestGdprDataType["CustomerInfo"] = "CustomerInfo";
  RequestGdprDataType["Debt"] = "Debt";
  RequestGdprDataType["DebtCollection"] = "DebtCollection";
  RequestGdprDataType["Deposit"] = "Deposit";
  RequestGdprDataType["GeneralAnnouncement"] = "GeneralAnnouncement";
  RequestGdprDataType["JobApplication"] = "JobApplication";
  RequestGdprDataType["Loan"] = "Loan";
  RequestGdprDataType["Pension"] = "Pension";
  RequestGdprDataType["Securities"] = "Securities";
})(RequestGdprDataType || (RequestGdprDataType = {}));

var ServiceLocationType;

(function (ServiceLocationType) {
  ServiceLocationType["Atm"] = "Atm";
  ServiceLocationType["Branch"] = "Branch";
  ServiceLocationType["SmartBooking"] = "SmartBooking";
})(ServiceLocationType || (ServiceLocationType = {}));

var ServicePointType;

(function (ServicePointType) {
  ServicePointType["Atm"] = "Atm";
  ServicePointType["Branch"] = "Branch";
})(ServicePointType || (ServicePointType = {}));

var SmartBookingCustomerType;
/**
 * If you want the highest, lowest, turnovers or all in stocks
 */

(function (SmartBookingCustomerType) {
  SmartBookingCustomerType["Company"] = "Company";
  SmartBookingCustomerType["Person"] = "Person";
  SmartBookingCustomerType["PersonAndCompany"] = "PersonAndCompany";
})(SmartBookingCustomerType || (SmartBookingCustomerType = {}));

var StockOrder;

(function (StockOrder) {
  StockOrder["All"] = "All";
  StockOrder["Low"] = "Low";
  StockOrder["MostTraded"] = "MostTraded";
  StockOrder["Rise"] = "Rise";
  StockOrder["Turnover"] = "Turnover";
})(StockOrder || (StockOrder = {}));

var TradingComplianceInstrumentAction;

(function (TradingComplianceInstrumentAction) {
  TradingComplianceInstrumentAction["Buy"] = "Buy";
  TradingComplianceInstrumentAction["Sell"] = "Sell";
  TradingComplianceInstrumentAction["Subscription"] = "Subscription";
})(TradingComplianceInstrumentAction || (TradingComplianceInstrumentAction = {}));

var TradingComplianceInstrumentNotAllowedInformation;

(function (TradingComplianceInstrumentNotAllowedInformation) {
  TradingComplianceInstrumentNotAllowedInformation["AppropriatenessTestUnanswered"] = "AppropriatenessTestUnanswered";
  TradingComplianceInstrumentNotAllowedInformation["IllegalDomicile"] = "IllegalDomicile";
  TradingComplianceInstrumentNotAllowedInformation["InstrumentDoseNotAllowTrading"] = "InstrumentDoseNotAllowTrading";
  TradingComplianceInstrumentNotAllowedInformation["InvalidLei"] = "InvalidLei";
  TradingComplianceInstrumentNotAllowedInformation["InvalidNci"] = "InvalidNci";
  TradingComplianceInstrumentNotAllowedInformation["NoBankAccount"] = "NoBankAccount";
  TradingComplianceInstrumentNotAllowedInformation["NoCustodialAgreement"] = "NoCustodialAgreement";
  TradingComplianceInstrumentNotAllowedInformation["NotAppropriate"] = "NotAppropriate";
  TradingComplianceInstrumentNotAllowedInformation["ReadAccess"] = "ReadAccess";
  TradingComplianceInstrumentNotAllowedInformation["Underage"] = "Underage";
  TradingComplianceInstrumentNotAllowedInformation["UserNotAllowedToTrade"] = "UserNotAllowedToTrade";
})(TradingComplianceInstrumentNotAllowedInformation || (TradingComplianceInstrumentNotAllowedInformation = {}));

var TradingComplianceNextAction;

(function (TradingComplianceNextAction) {
  TradingComplianceNextAction["AnswerAppropriatenessTest"] = "AnswerAppropriatenessTest";
  TradingComplianceNextAction["CanTrade"] = "CanTrade";
  TradingComplianceNextAction["CreateCustodialAccount"] = "CreateCustodialAccount";
  TradingComplianceNextAction["CreateCustodialAgreement"] = "CreateCustodialAgreement";
  TradingComplianceNextAction["NoActionAvailable"] = "NoActionAvailable";
  TradingComplianceNextAction["ShowEducation"] = "ShowEducation";
})(TradingComplianceNextAction || (TradingComplianceNextAction = {}));

var VehicleEmissionType;
/**
 * Svör við tilhlýðileikamati, fyrir kaup og sölu í sjóðum
 */

(function (VehicleEmissionType) {
  VehicleEmissionType["Electric"] = "Electric";
  VehicleEmissionType["Gas"] = "Gas";
  VehicleEmissionType["Hybrid"] = "Hybrid";
})(VehicleEmissionType || (VehicleEmissionType = {})); //==============================================================
// END Enums and Input Objects
//==============================================================

/***/ }),

/***/ 94941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Seperator; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);

var Seperator = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1otsbj10"
} : 0)("padding-top:20px;margin-bottom:30px;background:", function (_ref) {
  var border = _ref.border,
      theme = _ref.theme,
      currentTheme = _ref.currentTheme;
  return !border ? '' : "linear-gradient(".concat(theme.colors[currentTheme], ", ").concat(theme.colors[currentTheme], ") bottom left /27px 1px no-repeat, transparent");
}, ";" + ( true ? "" : 0));

/***/ }),

/***/ 79952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CU": function() { return /* binding */ ListHeaderContainer; },
  "K9": function() { return /* binding */ MarketsBodyBold; },
  "hZ": function() { return /* binding */ MarketsListTitle; },
  "Py": function() { return /* binding */ MarketsListTitleMobile; },
  "Az": function() { return /* binding */ MarketsNumberBold; },
  "q0": function() { return /* binding */ MarketsNumberSmall; },
  "Ws": function() { return /* binding */ MarketsP2; },
  "pV": function() { return /* binding */ MarketsSelectorTabs; },
  "pU": function() { return /* binding */ MarketsSmall; },
  "kO": function() { return /* binding */ RightAlignColumnContainer; },
  "yi": function() { return /* binding */ StickyFirstColumn; },
  "cC": function() { return /* binding */ TwoNumberContainer; }
});

// UNUSED EXPORTS: Arrow, BorderedButton, BuyButton, ColumnContainer, HistoryContainer, InfoColumn, InfoRow, LineDistribution, MarketsBody, MarketsColumn, MarketsContainer, MarketsDateInput, MarketsNumber4Big, MarketsNumberBig, MarketsNumberBond, MarketsNumberSmallBold, MarketsNumberSmallBold20, MarketsPriceColumn, MarketsRow, MarketsSmallBold, MarketsSmallBold20, MarketsSmallFadeToRight, MarketsSmallLeft, MarketsSmallNumberBond, MarketsSpaceBetweenContainer, MarketsSummarySelectorTabs, MarketsSummaryTitle, MarketsTableContainer, MarketsTd, MarketsTh, PriceChangeColumnContainer, PriceChangeContainer, PriceColumn, SecurityPrice, SecurityTitle, StatusColumn, SummaryChartContainer, SummaryFootnoteContainer, TypeContainer

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../packages/ui/src/styles/typography.tsx
var typography = __webpack_require__(52539);
// EXTERNAL MODULE: ../../packages/ui/src/components/table/Th.tsx
var Th = __webpack_require__(36433);
// EXTERNAL MODULE: ../../packages/ui/src/components/table/Td.tsx
var Td = __webpack_require__(39345);
// EXTERNAL MODULE: ../../packages/ui/src/components/grid/Row.tsx
var Row = __webpack_require__(11240);
// EXTERNAL MODULE: ../../packages/ui/src/styles/devices.ts
var devices = __webpack_require__(7949);
// EXTERNAL MODULE: ../../packages/ui/src/components/grid/Column.tsx
var Column = __webpack_require__(30263);
// EXTERNAL MODULE: ../../packages/ui/src/components/buttons/Button.tsx + 1 modules
var Button = __webpack_require__(11709);
// EXTERNAL MODULE: ../../packages/ui/src/components/tabs/SelectorTabs.tsx + 1 modules
var SelectorTabs = __webpack_require__(97602);
// EXTERNAL MODULE: ../../packages/ui/src/styles/mixins.ts
var mixins = __webpack_require__(2522);
// EXTERNAL MODULE: ../../packages/ui/src/components/form/date-input/DateInput.tsx + 1 modules
var DateInput = __webpack_require__(43032);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/slices/src/components/markets/shared/MarketsFormatNumber.tsx
var MarketsFormatNumber = __webpack_require__(40746);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../packages/slices/src/components/icons/arrows/ArrowDown.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function ArrowDown(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", _objectSpread(_objectSpread({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
      children: 'Arrow down'
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
      stroke: "red",
      strokeWidth: 1.152,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        d: "M5.032.576v9.792M9.064 6.336l-4.032 4.032L1 6.336"
      })
    })]
  }));
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/icons/arrows/ArrowUp.tsx


function ArrowUp_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ArrowUp_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ArrowUp_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ArrowUp_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function ArrowUp(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", ArrowUp_objectSpread(ArrowUp_objectSpread({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
      children: 'Arrow upp'
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
      stroke: "#00A651",
      strokeWidth: 1.152,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        d: "M4.968 10.424V.632M.936 4.664L4.968.632 9 4.664"
      })
    })]
  }));
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/shared/PosNegArrow.tsx






function PosNegArrow(_ref) {
  var value = _ref.value,
      className = _ref.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [value !== null && value > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUp, {
      className: className
    }), value !== null && value < 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDown, {
      className: className
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/shared/MarketsComponents.tsx



function MarketsComponents_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MarketsComponents_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MarketsComponents_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MarketsComponents_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




 // Texti +


var MarketsSmall = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1ti4lbk49"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, " white-space:", function (_ref) {
  var noWrap = _ref.noWrap;
  return noWrap ? 'nowrap' : 'normal';
}, ";" + ( true ? "" : 0));
var MarketsSmallFadeToRight = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1ti4lbk48"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, " white-space:nowrap;position:absolute;bottom:8px;", function (props) {
  return props.fading ? "\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 30%;    \n    height: 100%;\n    background-image: linear-gradient(\n      to right,\n      rgba(255, 255, 255, 0) 0%,\n      white 80%,\n      white 100%\n    );\n  }" : '';
}, ";" + ( true ? "" : 0));
var MarketsSmallBold = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1ti4lbk47"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, " font-weight:bold;" + ( true ? "" : 0));
var MarketsSmallBold20 = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1ti4lbk46"
} : 0)(typography/* typography.bodySmallBold */.cp.bodySmallBold, ";" + ( true ? "" : 0));
var MarketsBody = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1ti4lbk45"
} : 0)(typography/* typography.body */.cp.body, ";" + ( true ? "" : 0));
var MarketsBodyBold = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1ti4lbk44"
} : 0)(typography/* typography.body */.cp.body, " font-weight:bold;white-space:", function (_ref2) {
  var noWrap = _ref2.noWrap;
  return noWrap ? 'nowrap' : 'normal';
}, ";" + ( true ? "" : 0));
var MarketsP2 = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1ti4lbk43"
} : 0)(typography/* typography.p2 */.cp.p2, ";" + ( true ? "" : 0));
var MarketsSummaryTitle = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1ti4lbk42"
} : 0)(typography/* typography.h4 */.cp.h4, " padding-bottom:5px;font-weight:500;" + ( true ? "" : 0));
var MarketsListTitle = (0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e1ti4lbk41"
} : 0)(typography/* typography.h2Big */.cp.h2Big, ";" + ( true ? "" : 0));
var MarketsListTitleMobile = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsSmallBold,  true ? {
  target: "e1ti4lbk40"
} : 0)( true ? {
  name: "1ml9tbj",
  styles: "padding-bottom:2px"
} : 0); // Texti -
// Tölur +

var MarketsNumberSmall = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsFormatNumber/* MarketsFormatNumber */.KT,  true ? {
  target: "e1ti4lbk39"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, ";" + ( true ? "" : 0));
var MarketsNumberSmallBold = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsFormatNumber/* MarketsFormatNumber */.KT,  true ? {
  target: "e1ti4lbk38"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, " font-weight:500;" + ( true ? "" : 0));
var MarketsNumberSmallBold20 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsFormatNumber/* MarketsFormatNumber */.KT,  true ? {
  target: "e1ti4lbk37"
} : 0)(typography/* typography.bodySmallBold */.cp.bodySmallBold, ";" + ( true ? "" : 0));
var MarketsNumberBold = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsFormatNumber/* MarketsFormatNumber */.KT,  true ? {
  target: "e1ti4lbk36"
} : 0)(typography/* typography.body */.cp.body, " font-weight:500;" + ( true ? "" : 0));
var MarketsNumber4Big = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsFormatNumber/* MarketsFormatNumber */.KT,  true ? {
  target: "e1ti4lbk35"
} : 0)(typography/* typography.numbers4Big */.cp.numbers4Big, ";" + ( true ? "" : 0));
var MarketsNumberBig = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsFormatNumber/* MarketsFormatNumber */.KT,  true ? {
  target: "e1ti4lbk34"
} : 0)(typography/* typography.numbersBig */.cp.numbersBig, " font-weight:500;padding-bottom:25px;border-bottom:1px solid rgba(37, 46, 72, 0.33);" + ( true ? "" : 0)); // Tölur -
// Töflur +

var MarketsTh = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Th.Th,  true ? {
  target: "e1ti4lbk33"
} : 0)( true ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : 0);
var MarketsTd = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Td.Td,  true ? {
  target: "e1ti4lbk32"
} : 0)( true ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : 0); // Töflur -
// Layout +

var TwoNumberContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk31"
} : 0)( true ? {
  name: "6kz1wu",
  styles: "display:flex;flex-direction:column;align-items:flex-start"
} : 0);
var RightAlignColumnContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk30"
} : 0)( true ? {
  name: "isgvpc",
  styles: "display:flex;flex-direction:column;align-items:flex-end"
} : 0); // Layout -
// Stakt verðbréf +

var InfoRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e1ti4lbk29"
} : 0)("margin-bottom:20px;>div:nth-child(2)>div{border-top:1px solid rgba(37, 46, 72, 0.33);border-bottom:1px solid rgba(37, 46, 72, 0.33);}>div:nth-child(3)>div,>div:nth-child(4)>div{border-bottom:1px solid rgba(37, 46, 72, 0.33);}@media ", devices/* device.tablet */.U.tablet, "{>div:nth-child(2)>:nth-child(2){border-top:none;}>div:nth-child(3)>:first-child,>div:nth-child(4)>:first-child{border-top:1px solid rgba(37, 46, 72, 0.33);}}" + ( true ? "" : 0));
var InfoColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e1ti4lbk28"
} : 0)("display:flex;flex-direction:row;@media ", devices/* device.tablet */.U.tablet, "{flex-direction:column;}" + ( true ? "" : 0));
var PriceColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e1ti4lbk27"
} : 0)("padding-top:0px;padding-bottom:0px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:11px;}@media ", devices/* device.desktop */.U.desktop, "{margin-top:0px;margin-bottom:0px;}" + ( true ? "" : 0));
var SecurityPrice = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsFormatNumber/* MarketsFormatNumber */.KT,  true ? {
  target: "e1ti4lbk26"
} : 0)(typography/* typography.numbersMedium */.cp.numbersMedium, " font-weight:500;padding-bottom:16px;@media ", devices/* device.tablet */.U.tablet, "{", typography/* typography.numbersBig */.cp.numbersBig, " font-weight:500;font-size:60px!important;padding-bottom:0px;border-bottom:none;}" + ( true ? "" : 0));
var ColumnContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(RightAlignColumnContainer,  true ? {
  target: "e1ti4lbk25"
} : 0)("align-items:flex-start;margin-left:10px;padding-bottom:29px;@media ", devices/* device.tablet */.U.tablet, "{border-bottom:none;padding-bottom:8px;}@media ", devices/* device.desktop */.U.desktop, "{align-items:flex-end;border-bottom:none;padding-bottom:8px;}" + ( true ? "" : 0));
var Arrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(PosNegArrow,  true ? {
  target: "e1ti4lbk24"
} : 0)( true ? {
  name: "f4q8rq",
  styles: "margin-right:7px"
} : 0);
var MarketsSmallLeft = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1ti4lbk23"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, " text-align:left;margin-bottom:22px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:10px;}" + ( true ? "" : 0));
var SecurityTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e1ti4lbk22"
} : 0)("padding-top:40px;margin-bottom:45px;position:relative;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:30px;padding-top:65px;}" + ( true ? "" : 0));
var BuyButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref3) {
  var rest = Object.assign({}, _ref3);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, MarketsComponents_objectSpread({}, rest));
},  true ? {
  target: "e1ti4lbk21"
} : 0)("max-width:initial;width:95px;padding:0px!important;display:flex;max-height:40px;min-height:40px;margin-top:30px;margin-bottom:30px;div{font-size:16px;}@media ", devices/* device.tablet */.U.tablet, "{width:100%;margin-top:40px;max-height:52px;min-height:52px;margin-top:0px;margin-bottom:0px;}" + ( true ? "" : 0));
var BorderedButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref4) {
  var rest = Object.assign({}, _ref4);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, MarketsComponents_objectSpread({
    bordered: true
  }, rest));
},  true ? {
  target: "e1ti4lbk20"
} : 0)( true ? {
  name: "o7wifa",
  styles: "min-width:100%;min-height:52px;div{font-size:16px;}"
} : 0);
var MarketsRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e1ti4lbk19"
} : 0)( true ? {
  name: "15u9bv0",
  styles: "margin-bottom:50px"
} : 0);
var MarketsColumn = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk18"
} : 0)("display:flex;flex-direction:column;justify-content:space-between;flex:1;padding-left:0px;padding-top:11px;padding-bottom:1px;min-height:112px;&:first-child{margin-right:10px;}&:last-child{border-top:none;margin-left:10px;}@media ", devices/* device.tablet */.U.tablet, "{padding-left:2px;padding-bottom:0px;&:first-child{margin-right:0px;}&:last-child{margin-left:0px;}}" + ( true ? "" : 0));
var PriceChangeContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk17"
} : 0)("display:flex;flex-direction:row;justify-content:flex-start;flex-grow:1;align-items:flex-end;padding-top:32px;&>span{margin-right:10px;}@media ", devices/* device.desktop */.U.desktop, "{justify-content:space-between;padding-top:0px;&>span{margin-right:0px;}}" + ( true ? "" : 0));
var PriceChangeColumnContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk16"
} : 0)( true ? {
  name: "1dd7tut",
  styles: "display:flex;flex-direction:column;justify-content:flex-end;flex-grow:1;align-items:flex-start"
} : 0);
var MarketsPriceColumn = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk15"
} : 0)("display:flex;flex-direction:column;height:100%;border-bottom:none;@media ", devices/* device.tablet */.U.tablet, "{padding-top:10px;border-top:1px solid rgba(37, 46, 72, 0.33);}@media ", devices/* device.desktop */.U.desktop, "{&:last-child{border-top:1px solid rgba(37, 46, 72, 0.33);}border-bottom:1px solid rgba(37, 46, 72, 0.33);}" + ( true ? "" : 0));
var MarketsSpaceBetweenContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk14"
} : 0)( true ? {
  name: "4c6dm7",
  styles: "display:flex;flex-direction:row;justify-content:space-between"
} : 0);
var MarketsNumberBond = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsFormatNumber/* MarketsFormatNumber */.KT,  true ? {
  target: "e1ti4lbk13"
} : 0)(typography/* typography.numbers4Big */.cp.numbers4Big, " line-height:1;padding-bottom:10px;@media ", devices/* device.tablet */.U.tablet, "{line-height:1.75;padding-bottom:0px;}" + ( true ? "" : 0));
var MarketsSmallNumberBond = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsFormatNumber/* MarketsFormatNumber */.KT,  true ? {
  target: "e1ti4lbk12"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, " font-weight:500;@media ", devices/* device.tablet */.U.tablet, "{", typography/* typography.bodySmallBold */.cp.bodySmallBold, ";}" + ( true ? "" : 0)); // Stakt verðbréf -
// Summary pages +

var MarketsTableContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk11"
} : 0)("padding-top:26px;@media ", devices/* device.tablet */.U.tablet, "{padding-top:30px;}" + ( true ? "" : 0));
var MarketsContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk10"
} : 0)("padding-top:50px;padding-bottom:25px;@media ", devices/* device.tablet */.U.tablet, "{padding-top:37px;}" + ( true ? "" : 0));
var TypeContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e1ti4lbk9"
} : 0)("margin-bottom:3px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:12px;}" + ( true ? "" : 0));
var StatusColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e1ti4lbk8"
} : 0)("display:flex;justify-content:flex-end;margin-bottom:36px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0px;}" + ( true ? "" : 0));
var HistoryContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk7"
} : 0)("padding-top:10px;@media ", devices/* device.tablet */.U.tablet, "{padding-top:", function (props) {
  return !props.open ? ' 48px' : '76px';
}, ";}" + ( true ? "" : 0));
var SummaryChartContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk6"
} : 0)("padding-top:46px;height:245px;@media ", devices/* device.tablet */.U.tablet, "{padding-top:0px;height:210px;}" + ( true ? "" : 0));
var MarketsSummarySelectorTabs = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SelectorTabs/* SelectorTabs */.O,  true ? {
  target: "e1ti4lbk5"
} : 0)("&>div{padding-bottom:0px;}&>div>button{", typography/* typography.bodySmall */.cp.bodySmall, " padding-bottom:0px;min-height:41px;}&>div:last-child{background-color:", function (_ref5) {
  var color = _ref5.color;
  return color;
}, ";}" + ( true ? "" : 0));
var SummaryFootnoteContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk4"
} : 0)( true ? {
  name: "1kxombv",
  styles: "padding-top:8px;display:flex;justify-content:flex-end"
} : 0); // Summary pages -
// List pages +

var ListHeaderContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e1ti4lbk3"
} : 0)("padding-top:26px;margin-bottom:30px;justify-content:space-between;&>div{padding-bottom:18px;}@media ", devices/* device.tablet */.U.tablet, "{padding-top:32px;margin-bottom:60px;&>div{flex-shrink:2;padding-bottom:0px;}&>div:last-child{width:auto;}}" + ( true ? "" : 0));
var MarketsSelectorTabs = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SelectorTabs/* SelectorTabs */.O,  true ? {
  target: "e1ti4lbk2"
} : 0)("justify-content:", function (props) {
  return props.alignLeft ? 'flex-start' : 'flex-end';
}, ";&>div{width:auto;}&>div:nth-last-child(2){width:auto;margin-right:0px;}padding-top:28px;&>div>button{position:relative;}&>div>button:after{content:'';padding:0px 40px;position:absolute;left:-20px;top:0px;width:calc(100% + 40px);height:100%;}&>div:last-child{background-color:", function (_ref6) {
  var color = _ref6.color;
  return color;
}, ";}" + ( true ? "" : 0));
var StickyFirstColumn = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ti4lbk1"
} : 0)(mixins/* stickyFirstColumn */.eY, ";" + ( true ? "" : 0));
var MarketsDateInput = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(DateInput/* DateInput */.W,  true ? {
  target: "e1ti4lbk0"
} : 0)("& input{background-color:rgba(244, 247, 247, 1);}&:hover{box-shadow:0 0 0 0px;}&>div:last-child{top:25%;}@media ", devices/* device.tablet */.U.tablet, "{&>div:last-child{top:50%;}}" + ( true ? "" : 0)); // List pages -
// Enums +

var LineDistribution; // Enums -

(function (LineDistribution) {
  LineDistribution["Linear"] = "linear";
  LineDistribution["Series"] = "series";
})(LineDistribution || (LineDistribution = {}));

/***/ }),

/***/ 40746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KT": function() { return /* binding */ MarketsFormatNumber; },
/* harmony export */   "sw": function() { return /* binding */ NumberType; }
/* harmony export */ });
/* unused harmony export MarketsFormatAmount */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _landsbankinn_l16n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63762);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9462);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);



var _excluded = ["number", "type", "decimalScale", "displayPosNegColor", "isPositive", "displayISK", "hideZero", "hideNullIndicator", "suffix", "className"],
    _excluded2 = (/* unused pure expression or super */ null && (["number", "currency"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var MarketsNumberFormat = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(react_number_format__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,  true ? {
  target: "e1m4a4zq0"
} : 0)(function (props) {
  var _props$isPositive, _props$value;

  return props.showPosNeg && props.value !== 0 ? ((_props$isPositive = props.isPositive) !== null && _props$isPositive !== void 0 ? _props$isPositive : ((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : 0) >= 0) ? "color: ".concat(props.theme.colors.positive) : "color: ".concat(props.theme.colors.negative) : '';
}, ";" + ( true ? "" : 0));

function MarketsFormatNumber(_ref) {
  var number = _ref.number,
      type = _ref.type,
      decimalScale = _ref.decimalScale,
      _ref$displayPosNegCol = _ref.displayPosNegColor,
      displayPosNegColor = _ref$displayPosNegCol === void 0 ? false : _ref$displayPosNegCol,
      isPositive = _ref.isPositive,
      _ref$displayISK = _ref.displayISK,
      displayISK = _ref$displayISK === void 0 ? false : _ref$displayISK,
      _ref$hideZero = _ref.hideZero,
      hideZero = _ref$hideZero === void 0 ? false : _ref$hideZero,
      _ref$hideNullIndicato = _ref.hideNullIndicator,
      hideNullIndicator = _ref$hideNullIndicato === void 0 ? false : _ref$hideNullIndicato,
      suffix = _ref.suffix,
      className = _ref.className,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var _useResource = (0,_landsbankinn_l16n__WEBPACK_IMPORTED_MODULE_2__/* .useResource */ .Wf)(),
      locale = _useResource.locale;

  var resolvedSuffix = type === NumberType.Percentage ? '%' : displayISK ? ' ISK' : suffix;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
    children: number !== null ? !(number === 0 && hideZero) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MarketsNumberFormat, _objectSpread({
      value: type === NumberType.Percentage && number ? number * 100 : number,
      displayType: "text",
      thousandSeparator: locale === 'is' ? '.' : ',',
      decimalSeparator: locale === 'is' ? ',' : '.',
      fixedDecimalScale: true,
      decimalScale: decimalScale,
      suffix: resolvedSuffix,
      showPosNeg: displayPosNegColor,
      isPositive: isPositive,
      className: className
    }, rest)) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("span", {
      className: className,
      children: [hideNullIndicator ? '' : '-', " "]
    })
  });
}
function MarketsFormatAmount(_ref2) {
  var number = _ref2.number,
      currency = _ref2.currency,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return _jsx(MarketsFormatNumber, _objectSpread({
    number: number,
    type: NumberType.Number,
    suffix: " ".concat(currency),
    decimalScale: currency === 'ISK' ? 0 : 2
  }, rest));
}
var NumberType;

(function (NumberType) {
  NumberType[NumberType["Number"] = 0] = "Number";
  NumberType[NumberType["Percentage"] = 1] = "Percentage";
})(NumberType || (NumberType = {}));

/***/ }),

/***/ 22765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ SubItem; },
/* harmony export */   "D": function() { return /* binding */ MobileSubnav; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _landsbankinn_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7949);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32706);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1aguatm10"
} : 0)( true ? {
  name: "uh694d",
  styles: "position:sticky;top:0;z-index:13;@media (min-width: 950px){display:none;}"
} : 0);

var Title = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1aguatm9"
} : 0)("margin-right:15px;font-family:", function (props) {
  return props.theme.font.family;
}, ";font-weight:700;font-size:20px;flex:1;text-align:left;" + ( true ? "" : 0));

var SingleTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Title,  true ? {
  target: "e1aguatm8"
} : 0)("padding:2px 40px 0;padding:", function (props) {
  return "2px ".concat(props.theme.containerGutter, "px 0");
}, ";@media ", _landsbankinn_ui__WEBPACK_IMPORTED_MODULE_3__/* .device.mobile */ .U.mobile, "{padding:", function (props) {
  return "2px ".concat(props.theme.breakpoints.sm.gutter, "px 0");
}, ";}" + ( true ? "" : 0));

var DropdownButton = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button",  true ? {
  target: "e1aguatm7"
} : 0)("display:flex;flex-direction:row;align-items:center;height:80px;margin-right:15px;cursor:pointer;padding:", function (props) {
  return "2px ".concat(props.theme.containerGutter, "px 0");
}, ";@media ", _landsbankinn_ui__WEBPACK_IMPORTED_MODULE_3__/* .device.mobile */ .U.mobile, "{padding:", function (props) {
  return "2px ".concat(props.theme.breakpoints.sm.gutter, "px 0");
}, ";}" + ( true ? "" : 0));

var Top = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1aguatm6"
} : 0)( true ? {
  name: "1mxe7tf",
  styles: "background:white;position:relative;z-index:12;display:flex;flex-direction:row;justify-content:space-between;align-items:center;height:80px"
} : 0);

var Sheet = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1aguatm5"
} : 0)( true ? {
  name: "1i56w6n",
  styles: "top:80px;left:0;right:0;position:absolute;overflow:hidden"
} : 0);

var Items = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.ul,  true ? {
  target: "e1aguatm4"
} : 0)( true ? {
  name: "1kimfeg",
  styles: "position:relative;list-style:none;padding-bottom:60px;margin:0"
} : 0);

var SubItem = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("li",  true ? {
  target: "e1aguatm3"
} : 0)("border:none;padding:0 40px;margin:0;a{position:relative;display:block;padding:13px 0;border-bottom:1px solid #f5f7f7;", function (props) {
  return props.active && 'color: #ccc;';
}, ";&:after{content:'';display:block;position:absolute;bottom:0;left:0;width:0;height:1px;background-color:", function (props) {
  return props.theme.colors.primary;
}, ";transition:width 200ms ease-in-out;}&:hover{&:after{width:32px;}}}" + ( true ? "" : 0));

var Background = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.div,  true ? {
  target: "e1aguatm2"
} : 0)( true ? {
  name: "1cn3azb",
  styles: "position:absolute;top:0;bottom:10px;left:0;right:0;background:white;pointer-events:none;box-shadow:0 2px 10px rgba(0, 0, 0, 0.1)"
} : 0);

var ArrowSvg = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("svg",  true ? {
  target: "e1aguatm1"
} : 0)("transition:transform 400ms ease-in-out;transform:", function (props) {
  return props.open ? 'rotate(180deg)' : 'rotate(0deg)';
}, ";" + ( true ? "" : 0));

var Cta = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1aguatm0"
} : 0)( true ? {
  name: "5n5tey",
  styles: "padding-right:40px;>a{padding-left:20px;padding-right:20px;padding-top:4px;}"
} : 0);

function MobileSubnav(_ref) {
  var title = _ref.title,
      items = _ref.items,
      cta = _ref.cta,
      hasItems = _ref.hasItems;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var background = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)({
    y: open ? '0%' : '-100%',
    delay: open ? 0 : 200
  });
  var itemsStyle = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)({
    opacity: open ? 1 : 0,
    y: open ? 0 : -20,
    delay: open ? 200 : 0
  });
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Host, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Top, {
      children: [!hasItems && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(SingleTitle, {
        children: title
      }), hasItems && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(DropdownButton, {
          onClick: function onClick() {
            return setOpen(function (f) {
              return !f;
            });
          },
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Title, {
            children: title
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ArrowSvg, {
            open: open,
            width: "16",
            height: "10",
            viewBox: "0 0 16 10",
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("path", {
              fill: "none",
              fillRule: "evenodd",
              stroke: "#1E3D5A",
              strokeWidth: "2",
              d: "M14.545455.909091L8 8.272727 1.454545.909091"
            })
          })]
        }), cta && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Cta, {
          children: cta
        })]
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Sheet, {
      style: {
        pointerEvents: open ? 'auto' : 'none'
      },
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Background, {
        style: background
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Items, {
        style: itemsStyle,
        children: items
      })]
    })]
  });
}

/***/ }),

/***/ 11110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ Item; },
/* harmony export */   "G": function() { return /* binding */ Subnav; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8529);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _landsbankinn_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56818);
/* harmony import */ var _landsbankinn_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2522);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32706);
/* harmony import */ var _components_contexts_LayoutContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41696);
/* harmony import */ var _components_mobile_subnav_MobileSubnav__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22765);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Host = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.div,  true ? {
  shouldForwardProp: (0,_landsbankinn_ui__WEBPACK_IMPORTED_MODULE_3__/* .shouldForwardProp */ .x)('div'),
  target: "ezyxcwn7"
} : 0)("display:block;background:", function (props) {
  return props.isTransparent ? 'transparent' : 'white';
}, ";position:relative;left:0;right:0;z-index:10;height:72px;margin-bottom:-20px;@media (max-width: 949px){display:none;}" + ( true ? "" : 0));

var Sticky = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.div,  true ? {
  shouldForwardProp: (0,_landsbankinn_ui__WEBPACK_IMPORTED_MODULE_3__/* .shouldForwardProp */ .x)('div'),
  target: "ezyxcwn6"
} : 0)("position:relative;left:0;right:0;top:0;background:", function (props) {
  return props.isTransparent ? 'transparent' : 'white';
}, ";z-index:110;" + ( true ? "" : 0));

var Container = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("nav",  true ? {
  target: "ezyxcwn5"
} : 0)(_landsbankinn_ui__WEBPACK_IMPORTED_MODULE_4__/* .container */ .nC, " display:flex;flex-direction:row;align-items:center;height:72px;" + ( true ? "" : 0));

var ITEM_GUTTER = 14;
var Item = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("li",  true ? {
  target: "ezyxcwn4"
} : 0)("padding-left:", ITEM_GUTTER, "px;padding-right:", ITEM_GUTTER, "px;padding-bottom:6px;margin-bottom:-8px;transition:opacity 175ms ease-in-out;transition-property:opacity,color;&:hover{opacity:1!important;}" + ( true ? "" : 0));

var List = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ul",  true ? {
  target: "ezyxcwn3"
} : 0)("position:relative;display:flex;flex-direction:row;align-items:center;font-size:16px;&:hover ", Item, "{opacity:0.5;}" + ( true ? "" : 0));

var Underline = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.li,  true ? {
  target: "ezyxcwn2"
} : 0)( true ? {
  name: "1r94r8s",
  styles: "width:100px;height:2px;background:#20446a;position:absolute;bottom:-8px;left:0"
} : 0);

var Cta = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "ezyxcwn1"
} : 0)("display:", function (props) {
  return props.sticky ? 'block' : 'none';
}, ";margin-left:auto;>a{font-size:16px;}" + ( true ? "" : 0));

var SliderList = function SliderList(_ref) {
  var children = _ref.children;
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var _useSpring = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)(function () {
    return {
      x: 0,
      width: 0
    };
  }),
      _useSpring2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_useSpring, 2),
      underline = _useSpring2[0],
      spring = _useSpring2[1];

  var reset = function reset(_ref2) {
    var _ref2$immediate = _ref2.immediate,
        immediate = _ref2$immediate === void 0 ? false : _ref2$immediate;

    if (ref.current) {
      var host = ref.current;
      var activeIndex = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).findIndex(function (node) {
        return node.props.active;
      });
      var item = host.children[activeIndex];
      var hostRect = host.getBoundingClientRect();

      if (item) {
        var itemRect = item.getBoundingClientRect();
        spring.start({
          x: itemRect.x - hostRect.x + ITEM_GUTTER,
          width: itemRect.width - ITEM_GUTTER * 2,
          immediate: immediate
        });
      } else {
        spring.start({
          width: 0
        });
      }
    }
  };

  var onMouseOver = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function (e) {
    if (ref.current) {
      var item = e.currentTarget.getBoundingClientRect();
      var host = ref.current.getBoundingClientRect();
      spring.start({
        x: item.x - host.x + ITEM_GUTTER,
        width: item.width - ITEM_GUTTER * 2
      });
    }
  }, [spring]);

  var onMouseOut = function onMouseOut() {
    reset({
      immediate: false
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setTimeout(function () {
      reset({
        immediate: true
      });
    }, 10);
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(List, {
    ref: ref,
    children: [react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function (child) {
      return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onFocus: onMouseOver,
        onBlur: onMouseOut
      });
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Underline, {
      style: underline
    })]
  });
};

var Title = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h2",  true ? {
  target: "ezyxcwn0"
} : 0)( true ? {
  name: "1f4f5cp",
  styles: "font-weight:bold;line-height:1.2;font-size:16px;margin-bottom:-2px;a{margin-right:14px;}"
} : 0);

function Subnav(_ref3) {
  var title = _ref3.title,
      pageTitle = _ref3.pageTitle,
      children = _ref3.children,
      active = _ref3.active,
      cta = _ref3.cta,
      mobilecta = _ref3.mobilecta,
      mobileItems = _ref3.mobileItems,
      isTransparent = _ref3.isTransparent,
      titleWidth = _ref3.titleWidth,
      className = _ref3.className;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_contexts_LayoutContext__WEBPACK_IMPORTED_MODULE_7__/* .LayoutContext */ .V),
      isSubnav = _useContext.isSubnav,
      setIsSubnav = _useContext.setIsSubnav;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      sticky = _useState[0],
      setSticky = _useState[1];

  var _useSpring3 = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)({
    y: sticky === 2 ? 0 : -80,
    shadow: sticky === 2 ? 1 : 0
  }),
      y = _useSpring3.y,
      shadow = _useSpring3.shadow;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var heroEl = document.querySelector('#hero');
    var boundingRect = heroEl ? heroEl.getBoundingClientRect() : {
      top: 120,
      height: 80
    };

    var onScroll = function onScroll() {
      if (!boundingRect) {
        return;
      }

      if (window.scrollY <= boundingRect.top) {
        setSticky(0);
      } else if (window.scrollY > boundingRect.top + boundingRect.height) {
        setSticky(2);
      } else {
        setSticky(1);
      }
    };

    setIsSubnav(function () {
      return true;
    });
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return function () {
      setIsSubnav(function () {
        return false;
      });
      window.removeEventListener('scroll', onScroll);
    };
  }, [isSubnav, setIsSubnav]);
  var hasItems = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).length > 0;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_mobile_subnav_MobileSubnav__WEBPACK_IMPORTED_MODULE_8__/* .MobileSubnav */ .D, {
      title: pageTitle,
      items: mobileItems,
      cta: mobilecta,
      hasItems: hasItems
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Host, {
      isTransparent: isTransparent,
      className: className,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Sticky, {
        style: {
          position: sticky === 0 ? 'relative' : 'fixed',
          y: sticky > 0 ? y : undefined,
          boxShadow: shadow.to(function (s) {
            return "0 2px 4px rgba(0, 0, 0, ".concat(s * 0.075, ")");
          })
        },
        isTransparent: isTransparent && sticky === 0,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(Container, {
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Title, {
            sticky: sticky,
            style: {
              width: titleWidth
            },
            children: title
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(SliderList, {
            children: children
          }), cta && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Cta, {
            sticky: sticky !== 0,
            children: cta
          })]
        })
      })
    })]
  });
}
Subnav.Host = Host;

/***/ }),

/***/ 90133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ SlicesContainer; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../packages/ui/src/styles/devices.ts
var devices = __webpack_require__(7949);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/prismic/src/isEmptyText.ts
var isEmptyText = __webpack_require__(59071);
// EXTERNAL MODULE: ../../packages/prismic/src/Prismic.tsx + 1 modules
var Prismic = __webpack_require__(1530);
// EXTERNAL MODULE: ../../packages/ui/src/components/segment/Segment.tsx
var Segment = __webpack_require__(62145);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../packages/ui/src/components/reveal/Reveal.tsx
var Reveal = __webpack_require__(56069);
// EXTERNAL MODULE: ../../packages/ui/src/utils/shouldForwardProp.ts
var shouldForwardProp = __webpack_require__(56818);
// EXTERNAL MODULE: ../../packages/ui/src/styles/typography.tsx
var typography = __webpack_require__(52539);
// EXTERNAL MODULE: ../../packages/ui/src/components/grid/Row.tsx
var Row = __webpack_require__(11240);
// EXTERNAL MODULE: ../../packages/ui/src/components/grid/Column.tsx
var Column = __webpack_require__(30263);
// EXTERNAL MODULE: ../../packages/prismic/src/prismicContext.tsx
var prismicContext = __webpack_require__(72066);
// EXTERNAL MODULE: ../../packages/ui/src/styles/mixins.ts
var mixins = __webpack_require__(2522);
// EXTERNAL MODULE: ../../packages/ui/src/components/divider/Divider.tsx
var Divider = __webpack_require__(49505);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(32706);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../packages/ui/src/components/container/Container.tsx
var Container = __webpack_require__(94300);
// EXTERNAL MODULE: ../../packages/ui/src/components/icons/Close.tsx
var Close = __webpack_require__(32634);
;// CONCATENATED MODULE: ../../packages/ui/src/contexts/LayoutContext.tsx



var DEFAULT_BUBBLE = {
  open: false,
  active: 'Front',
  defaultServiceSelected: undefined
};
var LayoutContext = /*#__PURE__*/(0,react.createContext)({
  isMobile: false,
  isIOS: false,
  isEdge: false,
  bubble: DEFAULT_BUBBLE,
  setBubble: function setBubble() {
    return void 0;
  },
  isSubnav: false,
  setIsSubnav: function setIsSubnav() {
    return void 0;
  },
  isNavigationOpen: false,
  setIsNavigationOpen: function setIsNavigationOpen() {
    return void 0;
  },
  lastScrollPosition: 0,
  setLastScrollPosition: function setLastScrollPosition() {
    return void 0;
  },
  scrollDisabled: false,
  setScrollDisabled: function setScrollDisabled() {
    return void 0;
  },
  isIE: false
});
function LayoutProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      isNavigationOpen = _useState[0],
      setIsNavigationOpen = _useState[1];

  var _useState2 = useState(false),
      scrollDisabled = _useState2[0],
      setScrollDisabled = _useState2[1];

  var _useState3 = useState(false),
      isSubnav = _useState3[0],
      setIsSubnav = _useState3[1];

  var _useState4 = useState(0),
      lastScrollPosition = _useState4[0],
      setLastScrollPosition = _useState4[1];

  var _useState5 = useState(DEFAULT_BUBBLE),
      bubble = _useState5[0],
      setBubble = _useState5[1];

  var isMobile = useMedia('sm');
  var isIOS =  true && /iPad|iPhone|iPod/.test(navigator.userAgent);
  var isIE =  true && /Trident\/|MSIE/.test(window.navigator.userAgent);
  var isEdge =  true && navigator.userAgent.indexOf('Edge') !== -1;
  return _jsx(LayoutContext.Provider, {
    value: {
      isMobile: isMobile,
      isIOS: isIOS,
      isIE: isIE,
      isEdge: isEdge,
      bubble: bubble,
      setBubble: setBubble,
      isSubnav: isSubnav,
      setIsSubnav: setIsSubnav,
      isNavigationOpen: isNavigationOpen,
      setIsNavigationOpen: setIsNavigationOpen,
      scrollDisabled: scrollDisabled,
      setScrollDisabled: setScrollDisabled,
      lastScrollPosition: lastScrollPosition,
      setLastScrollPosition: setLastScrollPosition
    },
    children: children
  });
}
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../packages/ui/src/components/modal/Modal.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var CloseButton = (0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "emy02073"
} : 0)( true ? {
  name: "rzilh7",
  styles: "position:absolute;top:16px;right:16px;color:black;padding:15px 19px;cursor:pointer"
} : 0);

var Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "emy02072"
} : 0)( true ? {
  name: "xmu9d4",
  styles: "width:100%;height:100%;position:fixed;top:0;bottom:0;left:0;right:0;z-index:990;overflow-y:auto;background:rgba(244, 247, 247, 1);@supports (backdrop-filter: blur(12px)){backdrop-filter:blur(10px);background:rgba(244, 247, 247, 0.8);}"
} : 0);

var ContentContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Container/* Container */.W,  true ? {
  target: "emy02071"
} : 0)( true ? {
  name: "13udsys",
  styles: "height:100%"
} : 0);

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "emy02070"
} : 0)("padding-top:", function (props) {
  return props.theme.headerHeight;
}, "px;height:100%;display:flex;align-items:center;justify-content:center;" + ( true ? "" : 0));

var Dialog = function Dialog(_ref) {
  var children = _ref.children;

  if (false) {}

  var root = document.getElementById('portal');
  return root ? /*#__PURE__*/(0,react_dom.createPortal)(children, root) : null;
};

var Modal = function Modal(_ref2) {
  var vis = _ref2.visible,
      onClose = _ref2.onClose,
      children = _ref2.children;

  var _useState = (0,react.useState)(vis),
      visible = _useState[0],
      setVisible = _useState[1];

  var _useContext = (0,react.useContext)(LayoutContext),
      setScrollDisabled = _useContext.setScrollDisabled;

  var closeRef = (0,react.useRef)(null);

  var _useSpring = (0,react_spring_esm.useSpring)({
    opacity: visible && vis ? 1 : 0
  }),
      opacity = _useSpring.opacity;

  var onCloseClick = function onCloseClick() {
    onClose();
  };

  (0,react.useEffect)(function () {
    setScrollDisabled(visible);
  }, [visible]);
  (0,react.useEffect)(function () {
    var onKeyUp = function onKeyUp(e) {
      if (e.keyCode === 27) {
        onClose();
      }
    };

    document.addEventListener('keyup', onKeyUp, false);
    return function () {
      document.removeEventListener('keyup', onKeyUp, false);
    };
  }, []);
  (0,react.useLayoutEffect)(function () {
    setTimeout(function () {
      setVisible(vis);
    }, 175);
  }, [vis]);

  if (!visible) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Host, {
      style: {
        pointerEvents: visible ? 'auto' : 'none',
        opacity: opacity
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentContainer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
          children: children
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButton, {
        ref: closeRef,
        tabIndex: 0,
        "aria-label": "Close Modal",
        onClick: onCloseClick,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Close/* Close */.x, {})
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/ui/src/components/buttons/PlayButton.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function PlayButton_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var Overlay = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e7d97mi0"
} : 0)( true ? {
  name: "as97in",
  styles: "display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;right:0;bottom:0;circle{fill:rgba(255, 255, 255, 0);stroke:rgba(255, 255, 255, 1);transition:fill 175ms ease-in-out;}path{stroke:rgba(255, 255, 255, 1);transition:175ms ease-in-out;transition-property:stroke,fill;}path+path{stroke:none;opacity:0;transition:opacity 175ms ease-in-out;}&:hover circle{fill:rgba(255, 255, 255, 1);}&:hover path+path{opacity:1;}"
} : 0);

var PlayButton = function PlayButton(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay, _objectSpread(_objectSpread({}, props), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
      width: "124",
      height: "124",
      viewBox: "0 0 124 124",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
        cx: "61.8",
        cy: "61.8",
        r: "60.8",
        strokeWidth: "1.6"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M44.9599 95.6422v-68.304l51.8322 34.152-51.8322 34.152z"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M44.9599 95.6422v-68.304l51.8322 34.152-51.8322 34.152z",
        fill: "url(#paint0_linear)"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
          id: "paint0_linear",
          x1: "10.8079",
          y1: "18.4981",
          x2: "10.8079",
          y2: "104.482",
          gradientUnits: "userSpaceOnUse",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
            stopColor: "#2F6183"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
            offset: "1",
            stopColor: "#15324C"
          })]
        })
      })]
    })
  }));
};
// EXTERNAL MODULE: ../../packages/ui/src/styles/theme.ts
var theme = __webpack_require__(58176);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
;// CONCATENATED MODULE: ../../packages/slices/src/components/img/Img.tsx



var _excluded = ["src", "alt", "isFit", "percentage", "aspectRatio", "ar", "containerStyle", "isSvg"];

function Img_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Img_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Img_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Img_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Img_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var FitImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1ujv48g2"
} : 0)("position:relative;overflow:hidden;width:100%;&:after{display:block;content:'';padding-top:", function (props) {
  return 1 / props.aspectRatio * 100;
}, "%;}img:first-child{", mixins/* fit */.Tj, " width:100%;height:100%;object-fit:cover;transform:translateZ(0px);backface-visibility:hidden;transition:265ms ease-out;transition-property:transform,opacity;}>img.lazyloaded:not(.ls-is-cached):first-child{transition-property:transform,opacity,filter;}>img.ls-is-cached:first-child{transition-property:transform,opacity;}" + ( true ? "" : 0));

var OverflowHidden = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1ujv48g1"
} : 0)( true ? {
  name: "vabva8",
  styles: "position:relative;overflow:hidden"
} : 0);

var Svg = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ujv48g0"
} : 0)( true ? {
  name: "1y107nx",
  styles: "img{margin:0 auto;}"
} : 0);

var RatioMap = {
  ar_16_9: 16 / 9,
  ar_4_3: 4 / 3,
  ar_1_1: 1 / 1,
  aside: 1 / 1,
  card: 1.527
};

function normalizeSrc(src) {
  return src[0] === '/' ? src.slice(1) : src;
}

var imgixLoader = function imgixLoader(_ref) {
  var _src$match;

  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  var rect = (_src$match = src.match(/rect=((\d+,?){4})/)) === null || _src$match === void 0 ? void 0 : _src$match[0];
  var params = ['auto=format,compress', 'fit=max', 'w=' + width, rect];
  var paramsString = '';

  if (quality) {
    params.push('q=' + quality);
  }

  if (params.length) {
    paramsString = '?' + params.join('&');
  }

  return "".concat(normalizeSrc(src.replace(/\?.*$/, ''))).concat(paramsString);
}; // @todo add <noscript>


var Img = /*#__PURE__*/(0,react.forwardRef)(function InnerImg(_ref2, originRef) {
  var _rest$sizes;

  var src = _ref2.src,
      _ref2$alt = _ref2.alt,
      alt = _ref2$alt === void 0 ? '' : _ref2$alt,
      _ref2$isFit = _ref2.isFit,
      isFit = _ref2$isFit === void 0 ? true : _ref2$isFit,
      _ref2$percentage = _ref2.percentage,
      percentage = _ref2$percentage === void 0 ? 1 : _ref2$percentage,
      aspectRatio = _ref2.aspectRatio,
      _ref2$ar = _ref2.ar,
      ar = _ref2$ar === void 0 ? 'ar_16_9' : _ref2$ar,
      _ref2$containerStyle = _ref2.containerStyle,
      containerStyle = _ref2$containerStyle === void 0 ? {} : _ref2$containerStyle,
      isSvg = _ref2.isSvg,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  var backupRef = (0,react.useRef)();
  var ref = originRef || backupRef;
  var sizes = (_rest$sizes = rest.sizes) !== null && _rest$sizes !== void 0 ? _rest$sizes : "(min-width: ".concat(theme/* theme.breakpoints.md.width */.r.breakpoints.md.width, "px), ").concat(Math.ceil(theme/* theme.pageWidth */.r.pageWidth * percentage), "px, 100vw");

  if (!src || typeof src === 'object' && !src.url) {
    return null;
  }

  var selectedImage = isSvg ? src : typeof src !== 'string' ? src[ar] || src : src;
  var imgSrc = typeof selectedImage !== 'string' ? selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.url : selectedImage;
  var altTitle = typeof src !== 'string' ? src === null || src === void 0 ? void 0 : src.alt : alt;

  var content = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: typeof src === 'string' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", Img_objectSpread(Img_objectSpread({
      src: src,
      alt: altTitle || ''
    }, rest), {}, {
      ref: ref
    })) : isSvg ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", Img_objectSpread(Img_objectSpread({
      src: src.url,
      alt: altTitle || ''
    }, rest), {}, {
      ref: ref
    })) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_image["default"], {
      src: imgSrc,
      alt: altTitle || '',
      layout: 'fill',
      loader: imgixLoader,
      sizes: sizes,
      objectFit: "cover"
    })
  });

  if (isFit) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FitImage, Img_objectSpread(Img_objectSpread({
      aspectRatio: aspectRatio || RatioMap[ar],
      style: Img_objectSpread({}, containerStyle)
    }, rest), {}, {
      children: content
    }));
  }

  if (isSvg) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Svg, {
      children: content
    });
  }

  if (typeof src !== 'string' && selectedImage.base64) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverflowHidden, {
      children: content
    });
  }

  return content;
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/icons/BoxClose.tsx



function BoxClose() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "31",
    height: "31",
    viewBox: "0 0 31 31",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
        stroke: "#1E3D5A",
        transform: "translate(1 1)",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M0 0H29V29H0z"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
          d: "M8 21L21 8"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
          d: "M8 21L21 8",
          transform: "matrix(-1 0 0 1 29 0)"
        })]
      })
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/image-video/ImageVideo.tsx



var ImageVideo_excluded = ["image", "video", "ar"];

function ImageVideo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ImageVideo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ImageVideo_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ImageVideo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ImageVideo_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var ImageVideo_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e171a9gf4"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var Video = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e171a9gf3"
} : 0)( true ? {
  name: "oxg7h2",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;background:#fff"
} : 0);

var Play = (0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e171a9gf2"
} : 0)( true ? {
  name: "1uyglyi",
  styles: "display:flex;position:absolute;align-items:center;justify-content:center;top:0;left:0;right:0;bottom:0;color:rgba(255, 255, 255, 0);transition:color ease-in-out 110ms;width:100%;&:hover{color:rgba(255, 255, 255, 1);}"
} : 0);

var Span = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e171a9gf1"
} : 0)( true ? {
  name: "1nqbf6a",
  styles: "position:absolute;top:-60px;right:0;display:flex;align-items:center;&:hover{cursor:pointer;}svg{margin-left:23px;}"
} : 0);

var Div = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e171a9gf0"
} : 0)( true ? {
  name: "2ufsge",
  styles: "width:100%;height:0px;padding-top:56.25%;position:relative"
} : 0);

// Image with video play button that plays video
function ImageVideo(props) {
  var image = props.image,
      video = props.video,
      ar = props.ar,
      rest = (0,objectWithoutProperties/* default */.Z)(props, ImageVideo_excluded);

  var fullWidthHeightHtml = ((video === null || video === void 0 ? void 0 : video.html) || '').replace(/width="\d+"/, 'width="100%"').replace(/height="\d+"/, 'height="100%"').replace(/src="(.*?)"/, function (value, url) {
    return "src=\"".concat(url).concat(url.indexOf('?') === -1 ? '?' : '&', "autoplay=1\"");
  });

  var _useState = (0,react.useState)(false),
      play = _useState[0],
      setPlay = _useState[1];

  var onPlayClick = function onPlayClick(e) {
    e.preventDefault();
    setPlay(true);
    return false;
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ImageVideo_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, ImageVideo_objectSpread({
      src: image,
      ar: ar
    }, rest)), play && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal, {
      visible: play,
      onClose: function onClose() {
        return setPlay(false);
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Div, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Span, {
          onClick: function onClick() {
            return setPlay(false);
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: "Loka glugga"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BoxClose, {})]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video, {
          dangerouslySetInnerHTML: {
            __html: fullWidthHeightHtml
          }
        })]
      })
    }), !play && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Play, {
      onClick: onPlayClick,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayButton, {})
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/Card.tsx



var Card_excluded = ["children", "padding", "hover"],
    _excluded2 = ["link", "title", "description", "image", "percentage", "ar", "action", "imageAspect", "padding", "backgroundAlt", "backgroundColor", "imageRef", "notLink", "moreBodySpace", "video", "hasTitleMinHeight", "text_in_image", "onClick"];

function Card_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Card_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Card_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Card_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Card_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var CardHostLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e7pinoy7"
} : 0)("display:flex;flex-flow:column nowrap;align-items:flex-start;justify-content:stretch;position:relative;width:auto;cursor:pointer;margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";background-color:", function (props) {
  return props.backgroundAlt ? props.theme.colors.backgroundAlt : props.theme.colors.background;
}, ";&:hover img:first-child{transform:scale(1.025);}", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{width:100%;margin-left:0;margin-right:0;}" + ( true ? "" : 0));

var CardHost = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e7pinoy6"
} : 0)("display:flex;flex-flow:column nowrap;align-items:flex-start;justify-content:stretch;position:relative;width:auto;margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";background-color:", function (props) {
  return props.backgroundAlt ? props.theme.colors.backgroundAlt : props.theme.colors.background;
}, ";", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{width:100%;margin-left:0;margin-right:0;}" + ( true ? "" : 0));

var Body = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7pinoy5"
} : 0)("position:relative;flex:1;padding:", function (props) {
  return props.notLink ? "".concat(props.theme.containerGutter, "px") : "36px ".concat(props.theme.containerGutter, "px");
}, ";@media ", devices/* device.mobile */.U.mobile, "{padding:", function (props) {
  return props.notLink ? "".concat(props.theme.breakpoints.sm.gutter, "px") : "36px ".concat(props.theme.breakpoints.sm.gutter, "px");
}, ";", function (props) {
  return props.text_in_image ? 'padding-top:0;' : '';
}, ";}@media ", devices/* device.tablet */.U.tablet, "{padding:", function (props) {
  return props.padding ? 36 : 0;
}, "px;padding-top:", function (props) {
  return props.padding ? 36 : props.moreBodySpace ? 60 : 24;
}, "px;", function (props) {
  return props.text_in_image ? 'padding-top:0;' : '';
}, ";}", function (props) {
  return props.text_in_image ? 'position:absolute;color:white;top:50%;left:0;width:100%;padding-top: 0;margin-top: -20px;text-align: center;' : '';
}, ";" + ( true ? "" : 0));

var Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e7pinoy4"
} : 0)(typography/* typography.h3 */.cp.h3, ";margin-bottom:3px;", function (props) {
  return props.text_in_image ? "font-family:".concat(props.theme.font.family) : '';
}, ";@media ", devices/* device.tablet */.U.tablet, "{", function (props) {
  return props.hasMinHeight && 'min-height: 72px';
}, ";}" + ( true ? "" : 0));

var Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7pinoy3"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:24px;@media ", devices/* device.tablet */.U.tablet, "{padding-right:28px;}" + ( true ? "" : 0));

var ActionSpace = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7pinoy2"
} : 0)( true ? {
  name: "sem7hj",
  styles: "position:relative;opacity:0;pointer-events:none"
} : 0);

var ActionPosition = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7pinoy1"
} : 0)("display:flex;flex-direction:row;position:absolute;bottom:36px;left:", function (props) {
  return props.theme.breakpoints.sm.gutter;
}, "px;right:", function (props) {
  return props.theme.breakpoints.sm.gutter;
}, "px;@media ", devices/* device.tablet */.U.tablet, "{bottom:", function (props) {
  return props.padding ? 36 : 0;
}, "px;left:", function (props) {
  return props.padding ? 36 : 0;
}, "px;right:", function (props) {
  return props.padding ? 36 : 0;
}, "px;}" + ( true ? "" : 0));

var CardAction = function CardAction(_ref) {
  var children = _ref.children,
      padding = _ref.padding,
      hover = _ref.hover,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Card_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionSpace, {
      children: children
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionPosition, {
      padding: padding,
      children: /*#__PURE__*/react.cloneElement(children, Card_objectSpread(Card_objectSpread({}, rest), {}, {
        hover: hover
      }))
    })]
  });
};
var Card = /*#__PURE__*/(0,react.forwardRef)(function CardFn(props, ref) {
  var link = props.link,
      title = props.title,
      description = props.description,
      image = props.image,
      _props$percentage = props.percentage,
      percentage = _props$percentage === void 0 ? 1 : _props$percentage,
      _props$ar = props.ar,
      ar = _props$ar === void 0 ? 'ar_16_9' : _props$ar,
      action = props.action,
      imageAspect = props.imageAspect,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? true : _props$padding,
      _props$backgroundAlt = props.backgroundAlt,
      backgroundAlt = _props$backgroundAlt === void 0 ? false : _props$backgroundAlt,
      backgroundColor = props.backgroundColor,
      imageRef = props.imageRef,
      notLink = props.notLink,
      moreBodySpace = props.moreBodySpace,
      video = props.video,
      hasTitleMinHeight = props.hasTitleMinHeight,
      text_in_image = props.text_in_image,
      onClick = props.onClick,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded2);

  var router = (0,next_router.useRouter)();

  var _useContext = (0,react.useContext)(prismicContext/* PrismicContext */.Z),
      urlResolver = _useContext.urlResolver;

  var url = Prismic/* Prismic.link */.X5.link(urlResolver, link);

  var onCardClick = function onCardClick(e) {
    var _window, _window$getSelection, _window$getSelection$, _url$href;

    if (((_window = window) === null || _window === void 0 ? void 0 : (_window$getSelection = _window.getSelection) === null || _window$getSelection === void 0 ? void 0 : (_window$getSelection$ = _window$getSelection.call(_window)) === null || _window$getSelection$ === void 0 ? void 0 : _window$getSelection$.type) === 'Range') {
      e.preventDefault();
      return false;
    }

    if (onClick) {
      onClick(e);
    }

    if (url.onClick) {
      return url.onClick(e);
    }

    return router.push((_url$href = url.href) !== null && _url$href !== void 0 ? _url$href : '', url.as);
  };

  var ImgBackground = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Img,  true ? {
    target: "e7pinoy0"
  } : 0)("background-color:", backgroundColor, ";" + ( true ? "" : 0));

  var content = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [!!image && (video ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageVideo, {
      image: image,
      ar: ar,
      aspectRatio: imageAspect,
      video: video
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImgBackground, {
      src: image,
      percentage: percentage,
      ar: ar,
      aspectRatio: imageAspect,
      ref: imageRef
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Body, {
      padding: padding,
      moreBodySpace: moreBodySpace,
      notLink: notLink,
      text_in_image: text_in_image,
      children: [!!title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
        hasMinHeight: hasTitleMinHeight,
        text_in_image: text_in_image,
        children: title
      }), !!title && !!description && !text_in_image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {}), !!description && !text_in_image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Copy, {
        children: description
      }), !!action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardAction, {
        padding: padding,
        children: action
      })]
    })]
  });

  if (notLink) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardHost, Card_objectSpread(Card_objectSpread({
      backgroundAlt: backgroundAlt
    }, rest), {}, {
      children: content
    }));
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardHostLink, Card_objectSpread(Card_objectSpread({
    backgroundAlt: backgroundAlt,
    ref: ref
  }, rest), {}, {
    onClick: onCardClick,
    children: content
  }));
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/SliceWrapper.tsx



var SliceWrapper_excluded = ["left", "right", "isArticle", "align", "mergeTop"];

function SliceWrapper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SliceWrapper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SliceWrapper_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SliceWrapper_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var SliceWrapper_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1tomzng2"
} : 0)( true ? "" : 0);

var Left = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1tomzng1"
} : 0)("margin-bottom:", function (_ref) {
  var noMargin = _ref.noMargin;
  return noMargin ? 0 : '30px';
}, ";@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0;}" + ( true ? "" : 0));

var Right = (0,emotion_styled_base_browser_esm/* default */.Z)("aside",  true ? {
  target: "e1tomzng0"
} : 0)(Title, "{", typography/* typography.bodyEditorial */.cp.bodyEditorial, " font-weight:bold;}" + ( true ? "" : 0));

var SliceWrapper = function SliceWrapper(_ref2) {
  var left = _ref2.left,
      right = _ref2.right,
      isArticle = _ref2.isArticle,
      align = _ref2.align,
      mergeTop = _ref2.mergeTop,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, SliceWrapper_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper_Host, SliceWrapper_objectSpread(SliceWrapper_objectSpread({
    isArticle: isArticle,
    mergeTop: mergeTop
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      reverse: align === 'Left',
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: isArticle ? 7 / 12 : 8 / 12,
          offset: isArticle ? 1 / 12 : 0,
          offsetRight: !isArticle && align === 'Left' ? 1 / 12 : 0
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Left, {
          noMargin: !right,
          className: "left",
          children: left
        })
      }), right && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: isArticle ? 3 / 12 : 4 / 12,
          offset: isArticle ? 1 / 12 : 0
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Right, {
          children: right
        })
      })]
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/RichText.tsx



var RichText = function RichText(_ref) {
  var isArticle = _ref.isArticle,
      children = _ref.children,
      mergeTop = _ref.mergeTop;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: children,
    isArticle: isArticle,
    mergeTop: mergeTop
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/RichTextContainer.tsx





var RichTextContainer = function RichTextContainer(_ref) {
  var text = _ref.text,
      indent = _ref.indent,
      template = _ref.template,
      merge_top = _ref.merge_top;

  if ((0,isEmptyText/* isEmptyText */.W)(text)) {
    return null;
  }

  var isArticle = template === 'article' || indent === true;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    mergeTop: merge_top,
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText, {
      isArticle: isArticle,
      mergeTop: merge_top,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: text,
        isArticle: isArticle
      })
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/@juggle/resize-observer/lib/exports/resize-observer.js + 23 modules
var resize_observer = __webpack_require__(44711);
// EXTERNAL MODULE: ../../node_modules/lodash.get/index.js
var lodash_get = __webpack_require__(77485);
var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
// EXTERNAL MODULE: ../../node_modules/react-use-measure/dist/web.js
var web = __webpack_require__(731);
// EXTERNAL MODULE: ../../packages/ui/src/hooks/useReveal.tsx
var useReveal = __webpack_require__(11637);
;// CONCATENATED MODULE: ../../packages/ui/src/components/buttons/ButtonPlus.tsx



function ButtonPlus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ButtonPlus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ButtonPlus_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ButtonPlus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ButtonPlus_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/* eslint-disable sonarjs/no-identical-functions */





var ButtonPlus_Div = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1f0s4p13"
} : 0)( true ? {
  name: "1evgspx",
  styles: "height:40px;width:40px;min-height:40px;min-width:40px;position:relative"
} : 0);

var PlusLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.line,  true ? {
  target: "e1f0s4p12"
} : 0)("shape-rendering:crispedges;transform-origin:50% 50%;transform:rotate(0deg);opacity:1;", function (props) {
  return props.isHover || props.isOpen ? 'stroke:rgb(255,255,255)' : 'stroke:rgb(30,60,90)';
}, ";" + ( true ? "" : 0));

var MinusLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.line,  true ? {
  target: "e1f0s4p11"
} : 0)("shape-rendering:crispedges;transform-origin:50% 50%;transform:rotate(0deg);", function (props) {
  return props.isHover || props.isOpen ? 'stroke:rgb(255,255,255)' : 'stroke:rgb(30,60,90)';
}, ";" + ( true ? "" : 0));

var Box = (0,emotion_styled_base_browser_esm/* default */.Z)("rect",  true ? {
  target: "e1f0s4p10"
} : 0)("transition:all 0.4s linear;", function (props) {
  return props.isHover || props.isOpen ? 'fill:rgb(30,60,90)' : 'fill:rgb(255,255,255)';
}, ";" + ( true ? "" : 0));

var ButtonPlus = function ButtonPlus(_ref) {
  var isOpen = _ref.isOpen,
      isHover = _ref.isHover;
  var PlusLineRotate = (0,react_spring_esm.useSpring)({
    transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
    config: {
      mass: 10,
      tension: 2000,
      friction: 200,
      duration: 300
    }
  });
  var MinusLineRotate = (0,react_spring_esm.useSpring)({
    opacity: isOpen ? 0 : 1,
    transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
    config: {
      mass: 10,
      tension: 2000,
      friction: 200,
      duration: 300
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonPlus_Div, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
      id: "e2kt2k1630ka1",
      viewBox: "0 0 40 40",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
        id: "e2kt2k1630ka2",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
          id: "e2kt2k1630ka3",
          d: "M39,1L39,39L1,39L1,1L39,1M40,0L0,0L0,40L40,40L40,0Z",
          fill: "rgb(30,60,90)",
          stroke: "none",
          strokeWidth: "1"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
        id: "e2kt2k1630ka4",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
          id: "e2kt2k1630ka5",
          x1: "20",
          y1: "13.500000",
          x2: "20",
          y2: "26.500000",
          fill: "none",
          stroke: "rgb(30,60,90)",
          strokeWidth: "1",
          strokeMiterlimit: "10"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
        id: "e2kt2k1630ka6",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
          id: "e2kt2k1630ka7",
          x1: "26.500000",
          y1: "20",
          x2: "13.500000",
          y2: "20",
          fill: "none",
          stroke: "rgb(30,60,90)",
          strokeWidth: "1",
          strokeMiterlimit: "10"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
        id: "e2kt2k1630ka8",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box, {
          isOpen: isOpen,
          isHover: isHover,
          id: "e2kt2k1630ka9",
          width: "39",
          height: "39",
          rx: "0",
          ry: "0",
          transform: "matrix(1 0 0 1 0.50000000000000 0.50000000000000)",
          stroke: "none",
          strokeWidth: "1",
          strokeOpacity: "0"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
          id: "e2kt2k1630ka10",
          d: "M39,1L39,39L1,39L1,1L39,1M40,0L0,0L0,40L40,40L40,0Z",
          fill: "rgb(30,60,90)",
          stroke: "none",
          strokeWidth: "1"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
        id: "e2kt2k1630ka11",
        opacity: "0",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
          id: "e2kt2k1630ka12",
          x1: "26.500000",
          y1: "20",
          x2: "13.500000",
          y2: "20",
          fill: "none",
          stroke: "rgb(30,60,90)",
          strokeWidth: "1",
          strokeMiterlimit: "10"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MinusLine, {
        id: "e2kt2k1630ka13",
        x1: "20",
        y1: "13.500000",
        x2: "20",
        y2: "26.500000",
        fill: "none",
        stroke: "rgb(30,60,90)",
        strokeWidth: "1",
        strokeMiterlimit: "10",
        style: ButtonPlus_objectSpread({}, MinusLineRotate),
        isHover: isHover,
        isOpen: isOpen
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusLine, {
        id: "e2kt2k1630ka14",
        x1: "26.500000",
        y1: "20",
        x2: "13.500000",
        y2: "20",
        fill: "none",
        stroke: "rgb(30,60,90)",
        strokeWidth: "1",
        strokeMiterlimit: "10",
        style: ButtonPlus_objectSpread({}, PlusLineRotate),
        isHover: isHover,
        isOpen: isOpen
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/ui/src/components/accordion-list/AccordionItem.tsx




function AccordionItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AccordionItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccordionItem_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccordionItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var Item = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3sqi1j4"
} : 0)(function (props) {
  return !props.lineSeperator && "border-bottom: 1px solid ".concat(props.theme.colors.primary, ";");
}, ";", function (props) {
  return props.isOpen && !props.lineSeperator && 'border-color: transparent';
}, ";transition:border-color 200ms ease-in-out;" + ( true ? "" : 0));

var Header = (0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e3sqi1j3"
} : 0)("display:flex;align-items:center;justify-content:space-between;position:relative;padding:", function (props) {
  return "25px ".concat(props.theme.breakpoints.sm.gutter, "px");
}, ";width:100%;text-align:left;background-color:transparent;appearance:none;cursor:pointer;", function (props) {
  return props.lineSeperator && "border-bottom: 1px solid ".concat(props.theme.colors.primary, ";");
}, "@media ", devices/* device.tablet */.U.tablet, "{padding:27px 45px 27px 0;}" + ( true ? "" : 0));

var AccordionItem_Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e3sqi1j2"
} : 0)("padding:", function (props) {
  return props.isFullWidth ? '0' : "0 ".concat(props.theme.breakpoints.sm.gutter, "px");
}, ";height:0px;overflow:hidden;", mixins/* mobileGutterPadding */.Ny, "@media ", devices/* device.tablet */.U.tablet, "{padding:", function (props) {
  return props.isFullWidth ? '0' : '0 45px 0 0';
}, ";}" + ( true ? "" : 0));

var Heading = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e3sqi1j1"
} : 0)(typography/* typography.h4 */.cp.h4, ";margin-right:40px;" + ( true ? "" : 0));

var AccordionMarkdown = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e3sqi1j0"
} : 0)("position:relative;padding:", function (props) {
  return props.lineSeperator ? "0 ".concat(props.theme.containerGutter, "px") : '40px 0';
}, ";", function (props) {
  return props.contentSpacing && 'padding: 40px 20px 60px;';
}, ";width:100%;opacity:0;@media ", devices/* device.mobile */.U.mobile, "{padding:", function (props) {
  return props.lineSeperator ? "0 ".concat(props.theme.breakpoints.sm.gutter, "px") : '40px 0';
}, ";}@media ", devices/* device.tablet */.U.tablet, "{padding:", function (props) {
  return props.lineSeperator ? '0' : '40px 0';
}, ";}@media (min-width: 600px){", function (props) {
  return !props.isFullWidth && "width: 80%;";
}, ";}@media ", devices/* device.desktop */.U.desktop, "{", function (props) {
  return props.contentSpacing && 'padding: 43px 43px 60px;';
}, ";}&:before{content:'';display:", function (props) {
  return props.lineSeperator ? 'none' : 'block';
}, ";position:absolute;top:0;left:", function (props) {
  return props.isFullWidth ? '20px' : '0';
}, ";height:1px;width:27px;background-color:", function (props) {
  return props.theme.colors.foreground;
}, ";@media ", devices/* device.tablet */.U.tablet, "{left:0;}}" + ( true ? "" : 0));

var AccordionItem = function AccordionItem(_ref) {
  var index = _ref.index,
      title = _ref.title,
      content = _ref.content,
      isFullWidth = _ref.isFullWidth,
      lineSeperator = _ref.lineSeperator,
      contentSpacing = _ref.contentSpacing,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      isOpen = _ref.isOpen;

  // const [isOpen, setIsOpen] = useState(isDeafultOpen);
  var _useState = (0,react.useState)(false),
      hover = _useState[0],
      setHover = _useState[1];

  var _useMeasure = (0,web/* default */.Z)({
    polyfill: resize_observer/* ResizeObserver */["do"]
  }),
      _useMeasure2 = (0,slicedToArray/* default */.Z)(_useMeasure, 2),
      copyRef = _useMeasure2[0],
      copySize = _useMeasure2[1]; // const toggle = () => {
  //   setIsOpen((value) => {
  //     props.
  //     return !value;
  //   });
  // };


  var setHeight = (0,react_spring_esm.useSpring)({
    height: isOpen ? "".concat(lodash_get_default()(copySize, 'height', 0), "px") : '0px',
    visability: isOpen ? 'visible' : 'hidden'
  });
  var fadeIn = (0,react_spring_esm.useSpring)({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0px)' : 'translateY(10px)'
  });

  var onEnter = function onEnter(e) {
    setHover(true);

    if (onMouseEnter) {
      onMouseEnter(e);
    }
  };

  var onLeave = function onLeave(e) {
    setHover(false);

    if (onMouseLeave) {
      onMouseLeave(e);
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
    lineSeperator: lineSeperator,
    isOpen: isOpen,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Header, {
      onClick: function onClick() {
        if (onClose && onOpen && index !== undefined) {
          return isOpen ? onClose(index) : onOpen(index);
        }
      },
      role: "button",
      "aria-expanded": isOpen ? true : false,
      "aria-controls": "content",
      isFullWidth: isFullWidth,
      lineSeperator: lineSeperator,
      onMouseLeave: onLeave,
      onMouseEnter: onEnter,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        children: title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonPlus, {
        isOpen: !!isOpen,
        isHover: hover
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem_Content, {
      className: isOpen ? 'open' : '',
      style: AccordionItem_objectSpread(AccordionItem_objectSpread({}, setHeight), {}, {
        visibility: isOpen ? 'visible' : 'hidden'
      }),
      id: "content",
      isFullWidth: isFullWidth,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionMarkdown, {
        ref: copyRef,
        isFullWidth: isFullWidth,
        lineSeperator: lineSeperator,
        contentSpacing: contentSpacing,
        style: AccordionItem_objectSpread({}, fadeIn),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(useReveal/* RevealContext.Provider */.j_.Provider, {
          value: {
            enabled: !!isOpen
          },
          children: content
        })
      })
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(52746);
;// CONCATENATED MODULE: ../../packages/ui/src/components/accordion-list/AccordionList.tsx




function AccordionList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AccordionList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccordionList_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccordionList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function AccordionList_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var AccordionList_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  target: "e32wp7c5"
} : 0)("margin:", function (props) {
  return "0 -".concat(props.theme.breakpoints.sm.gutter, "px");
}, ";", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{margin:0;}" + ( true ? "" : 0));

var AccordionList_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e32wp7c4"
} : 0)(typography/* typography.h2 */.cp.h2, " flex:1;margin-bottom:40px;margin-left:", function (props) {
  return props.theme.breakpoints.sm.gutter;
}, "px;@media ", devices/* device.tablet */.U.tablet, "{margin-left:0;}" + ( true ? "" : 0));

var List = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e32wp7c3"
} : 0)( true ? "" : 0);

var Top = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e32wp7c2"
} : 0)( true ? {
  name: "1yjoxx9",
  styles: "display:flex;flex-flow:row wrap;align-items:center"
} : 0);

var Categories = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e32wp7c1"
} : 0)("padding-left:", function (props) {
  return "".concat(props.theme.breakpoints.sm.gutter, "px");
}, ";margin-right:", function (props) {
  return "".concat(props.theme.breakpoints.sm.gutter, "px");
}, ";margin-left:auto;padding-bottom:", function (props) {
  return props.theme.breakpoints.sm.gutter * 2;
}, "px;@media ", devices/* device.tablet */.U.tablet, "{margin-right:45px;padding-bottom:40px;}" + ( true ? "" : 0));

var Category = (0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e32wp7c0"
} : 0)("border-bottom:1px solid;border-bottom-color:", function (props) {
  return props.active ? '#000' : 'transparent';
}, ";margin-right:20px;cursor:pointer;&:last-child{margin-right:0;}" + ( true ? "" : 0));

var AccordionList = function AccordionList(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$firstOpen = _ref.firstOpen,
      firstOpen = _ref$firstOpen === void 0 ? false : _ref$firstOpen,
      _ref$singleDisplay = _ref.singleDisplay,
      singleDisplay = _ref$singleDisplay === void 0 ? false : _ref$singleDisplay;

  var _useState = (0,react.useState)(firstOpen ? [0] : []),
      activeIndexes = _useState[0],
      setActiveIndexes = _useState[1];

  var onOpen = function onOpen(i) {
    if (singleDisplay) {
      setActiveIndexes([i]);
    } else {
      setActiveIndexes(function (val) {
        return [].concat((0,toConsumableArray/* default */.Z)(val), [i]);
      });
    }
  };

  var onClose = function onClose(i) {
    setActiveIndexes(function (val) {
      return (0,toConsumableArray/* default */.Z)(val.filter(function (n) {
        return n !== i;
      }));
    });
  };

  var childs = react.Children.toArray(children).map(function (el, index) {
    return /*#__PURE__*/react.cloneElement(el, AccordionList_objectSpread(AccordionList_objectSpread({}, el.props), {}, {
      index: index,
      isOpen: activeIndexes.includes(index),
      onOpen: onOpen,
      onClose: onClose
    }));
  });
  var categories = childs.reduce(function (acc, child) {
    var _child$props;

    var category =
    /*         Prismic.text(child?.props?.category?.props?.value) || */
    child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.category;

    if (category && typeof category === 'string' && !acc.includes(category)) {
      acc.push(category);
    }

    return acc;
  }, []);

  var _useState2 = (0,react.useState)(null),
      selectedCategory = _useState2[0],
      setSelectedCategory = _useState2[1];

  var filteredChildren = childs.filter(function (child) {
    if (child !== null && child !== void 0 && child.props) {
      var _child$props2;

      var category =
      /*         Prismic.text(child?.props?.category?.props?.value) || */
      child === null || child === void 0 ? void 0 : (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.category;

      if (category === selectedCategory || selectedCategory === null) {
        return true;
      }

      return false;
    }

    return true;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionList_Host, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Top, {
        children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionList_Title, {
          children: title
        }), categories.length > 0 && typeof categories[0] === 'string' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Categories, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Category, {
            onClick: function onClick() {
              return setSelectedCategory(null);
            },
            active: selectedCategory === null,
            children: "Allt"
          }), categories.map(function (category) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Category, {
              onClick: function onClick() {
                return setSelectedCategory(category);
              },
              active: selectedCategory === category,
              children: category
            }, category);
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
        children: filteredChildren
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/AccordionContainer.tsx


function AccordionContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AccordionContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccordionContainer_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccordionContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var Slices = function Slices(_ref) {
  var data = _ref.data;
  var SliceType;

  (function (SliceType) {
    SliceType["TEXT_WITH_IMAGES"] = "text_with_images";
    SliceType["QUARTERS"] = "quarters";
    SliceType["TABLE"] = "table";
  })(SliceType || (SliceType = {}));

  return _jsx(_Fragment, {
    children: (data || []).map(function (s, i) {
      var key = "slice".concat(s.type, "-").concat(i);

      var props = AccordionContainer_objectSpread(AccordionContainer_objectSpread({}, s), s.primary);

      switch (s.type) {
        case SliceType.QUARTERS:
          return _jsx(QuartersContainer, AccordionContainer_objectSpread({
            hasContainer: false
          }, props), key);

        case SliceType.TEXT_WITH_IMAGES:
          return _jsx(TextWithImagesContainer, AccordionContainer_objectSpread({
            hasContainer: false
          }, props), key);

        case SliceType.TABLE:
          return _jsx(TableContainer, AccordionContainer_objectSpread({}, props), key);

        default:
          if (s.type) {
            console.warn('No slice available for %s %o', s.type, s); // tslint:disable-line
          }

          return null;
      }
    })
  });
};

var renderFaqItem = function renderFaqItem(_ref2, i) {
  var _Prismic$text;

  var page = _ref2.page;
  var slices = page === null || page === void 0 ? void 0 : page.body;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
    title: (_Prismic$text = Prismic/* Prismic.text */.X5.text(page === null || page === void 0 ? void 0 : page.page_title)) !== null && _Prismic$text !== void 0 ? _Prismic$text : '',
    content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SlicesContainer, {
      data: slices
    }),
    isFullWidth: true,
    lineSeperator: true
  }, "".concat(i, "-").concat(Prismic/* Prismic.text */.X5.text(page === null || page === void 0 ? void 0 : page.page_title)));
};

var AccordionContainer = function AccordionContainer(_ref3) {
  var fields = _ref3.fields,
      _ref3$is_open = _ref3.is_open,
      is_open = _ref3$is_open === void 0 ? false : _ref3$is_open,
      _ref3$single_display = _ref3.single_display,
      single_display = _ref3$single_display === void 0 ? false : _ref3$single_display;
  var items = fields === null || fields === void 0 ? void 0 : fields.filter(function (_ref4) {
    var page = _ref4.page;
    return page;
  });

  if (!items.length) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionList, {
    firstOpen: is_open,
    singleDisplay: single_display,
    children: items.map(renderFaqItem)
  });
};
// EXTERNAL MODULE: ../../packages/ui/src/hooks/useMedia.ts
var hooks_useMedia = __webpack_require__(5728);
;// CONCATENATED MODULE: ../../packages/slices/src/components/icons/ScrollDownArrow.tsx


var ScrollDownArrow = function ScrollDownArrow() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "77",
    height: "46",
    fill: "none",
    viewBox: "0 0 77 46",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      stroke: "#fff",
      strokeWidth: "2",
      d: "M75.48 1L38.24 43.56 1 1"
    })
  });
};
// EXTERNAL MODULE: ../../packages/slices/src/components/subnav/Subnav.tsx
var Subnav = __webpack_require__(11110);
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/AnnualHero.tsx



function AnnualHero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var AnnualHero_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e7tz2q86"
} : 0)("position:relative;z-index:0;height:calc(100vh - 80px);overflow:hidden;", Subnav/* Subnav.Host */.G.Host, "+div &:nth-child(1){height:calc(100vh - 80px - 52px);}" + ( true ? "" : 0));

var AnnualHero_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7tz2q85"
} : 0)("position:relative;display:flex;flex-flow:column nowrap;height:100%;background-image:linear-gradient(\n    0deg,\n    rgba(0, 0, 0, ", function (props) {
  return props.shadeOpacity || 0.6;
}, ") 0%,\n    rgba(0, 0, 0, ", function (props) {
  return props.shadeOpacity || 0.1;
}, ") 50%,\n    rgba(0, 0, 0, 0) 70%\n  );" + ( true ? "" : 0));

var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e7tz2q84"
} : 0)( true ? {
  name: "37ps3e",
  styles: "position:relative;display:flex;justify-content:center;align-items:flex-end;height:100%;padding-bottom:40px"
} : 0);

var H1 = (0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e7tz2q83"
} : 0)("font-size:30px;line-height:", 44 / 35, ";text-align:center;text-transform:uppercase;font-weight:500;letter-spacing:0.93px;font-style:normal;color:#fff;@media ", devices/* device.mobile */.U.mobile, "{font-size:35px;}" + ( true ? "" : 0));

var Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.button,  true ? {
  target: "e7tz2q82"
} : 0)( true ? {
  name: "1dv60c",
  styles: "margin-bottom:10px;padding:30px;cursor:pointer;@keyframes bounce-arrow{0%,20%,50%,80%,100%{transform:translateY(0);}40%{transform:translateY(30px);}60%{transform:translateY(15px);}}>svg{transform:translateY(0);transition:transform 200ms ease-in-out;animation:bounce-arrow 2s ease-in-out;animation-delay:0.5s;}&:hover>svg{transform:translateY(10px);}"
} : 0);

var Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e7tz2q81"
} : 0)( true ? {
  name: "1ezizgz",
  styles: "position:fixed;z-index:0;top:0;left:0;right:0;bottom:0;height:100vh;width:100%;object-fit:cover;>div{height:100%;transform:scale(1.05);}"
} : 0);

var SmoothWhiteArea = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e7tz2q80"
} : 0)("position:absolute;bottom:-150px;left:0;right:0;height:150px;background:", function (props) {
  return props.theme.colors.background;
}, ";" + ( true ? "" : 0));

var interpolate = function interpolate(x, x1, y1, x2, y2) {
  if (x1 === x2) {
    return (y1 + y2) / 2;
  }

  return (x - x1) * (y2 - y1) / (x2 - x1) + y1;
};

var clamp = function clamp(value) {
  return function (x) {
    var _window;

    return Math.max(0, Math.min(1, interpolate(x, 0, 0, ( false ? 0 : (_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight) - 80 / 2, 1))) * value;
  };
};

var AnnualHero = function AnnualHero(_ref) {
  var title = _ref.title,
      image = _ref.image,
      shadeOpacity = _ref.shadeOpacity;
  var ref = (0,react.useRef)(null);
  var imgRef = (0,react.useRef)(null);
  var contentRef = (0,react.useRef)(null);

  var _useSpring = (0,react_spring_esm.useSpring)(function () {
    return {
      y: 0 // config: config.gentle,

    };
  }),
      _useSpring2 = (0,slicedToArray/* default */.Z)(_useSpring, 2),
      y = _useSpring2[0].y,
      spring0 = _useSpring2[1]; // animate scroll


  var _useSpring3 = (0,react_spring_esm.useSpring)(function () {
    return {
      y: 0,
      config: react_spring_esm.config.slow,
      onChange: function onChange(props) {
        window.scrollTo(0, props.value.y);
      }
    };
  }),
      _useSpring4 = (0,slicedToArray/* default */.Z)(_useSpring3, 2),
      _ = _useSpring4[0],
      spring = _useSpring4[1]; // on scrolll animate y


  var onScroll = function onScroll() {
    var y = window.scrollY;
    spring0.start({
      y: y
    });
  }; // add scroll events


  (0,react.useEffect)(function () {
    if (false) {}

    var onWheelScroll = function onWheelScroll() {
      return spring.stop();
    };

    window.addEventListener('scroll', onScroll);
    window.addEventListener('wheel', onWheelScroll, false);
    return function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('wheel', onWheelScroll, false);
    };
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AnnualHero_Host, {
    ref: ref,
    id: "hero",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
      ref: imgRef,
      style: {
        y: y.to(clamp(-150))
      },
      children: image
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AnnualHero_Content, {
      ref: contentRef,
      shadeOpacity: shadeOpacity,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, {
        style: {
          y: y.to(clamp(-450))
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H1, {
          children: title
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
        onClick: function onClick() {
          spring.start({
            y: window.innerHeight,
            reset: true,
            from: {
              y: window.scrollY
            }
          });
        },
        style: {
          y: y.to(clamp(-350))
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollDownArrow, {})
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SmoothWhiteArea, {
      style: {
        y: y.to(clamp(-50))
      }
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/AnnualHeroContainer.tsx






var AnnualHeroContainer = function AnnualHeroContainer(_ref) {
  var _Prismic$text;

  var title = _ref.title,
      image = _ref.image,
      shade_opacity = _ref.shade_opacity;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualHero, {
    title: (_Prismic$text = Prismic/* Prismic.text */.X5.text(title)) !== null && _Prismic$text !== void 0 ? _Prismic$text : undefined,
    image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
      src: image,
      ar: isMobile ? 'ar_9_16' : 'ar_16_9',
      percentage: 1
    }),
    shadeOpacity: shade_opacity
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/intro/Intro.tsx






var Intro_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  target: "e15it6fh2"
} : 0)("p{", typography/* typography.p2 */.cp.p2, ";}" + ( true ? "" : 0));

var Intro_Header = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15it6fh1"
} : 0)("margin-bottom:30px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:48px;}" + ( true ? "" : 0));

var Intro_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e15it6fh0"
} : 0)(typography/* typography.h1 */.cp.h1, " margin-bottom:30px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:48px;}" + ( true ? "" : 0));

var Intro = function Intro(_ref) {
  var children = _ref.children,
      title = _ref.title,
      hasSplitter = _ref.hasSplitter,
      id = _ref.id;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Intro_Host, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
      id: id,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
        md: {
          width: hasSplitter ? 1 : 10 / 12,
          offset: {
            left: hasSplitter ? 0 : 1 / 12
          }
        },
        children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Intro_Header, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Intro_Title, {
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
            width: "47px"
          })]
        }), children]
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/AnnualIntroContainer.tsx







var Splitter = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eieofmv0"
} : 0)("text-align:center;position:relative;color:", function (props) {
  return props.theme.colors.primary;
}, ";&:before{content:'';width:100%;position:absolute;top:50%;margin-top:-1px;height:1px;background:", function (props) {
  return props.theme.colors.primary;
}, ";left:0;z-index:1;}p{background:", function (props) {
  return props.theme.colors.background;
}, ";font-family:", function (props) {
  return props.theme.font.familySerifCond;
}, ";font-weight:500;margin:0 auto;position:relative;z-index:2;display:inline-block;padding-left:20px;padding-right:20px;}@media ", devices/* device.tablet */.U.tablet, "{p{width:220px;padding-left:0;padding-right:0;}}" + ( true ? "" : 0));

var AnnualIntroContainer = function AnnualIntroContainer(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      splitter = _ref.splitter;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var hasTitle = title && !(0,isEmptyText/* isEmptyText */.W)(title);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: true,
    className: "intro",
    id: "hero",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Intro, {
      title: hasTitle && Prismic/* Prismic.text */.X5.text(title !== null && title !== void 0 ? title : null),
      hasSplitter: splitter,
      children: splitter ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Splitter, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
          value: copy
        })
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy
      })
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../packages/l16n/src/index.ts + 9 modules
var src = __webpack_require__(63762);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/AnnualModule.tsx




function AnnualModule_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AnnualModule_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AnnualModule_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AnnualModule_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function AnnualModule_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var inviewConfig = {
  delay: 330,
  threshold: 0.2
};

var Countdown = function Countdown(_ref) {
  var num = _ref.num,
      percent = _ref.percent,
      _ref$start = _ref.start,
      start = _ref$start === void 0 ? false : _ref$start;

  var _useState = (0,react.useState)(0),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = (0,react.useState)(false),
      stopped = _useState2[0],
      setStopped = _useState2[1];

  var _useSpring = (0,react_spring_esm.useSpring)({
    count: value,
    onRest: function onRest() {
      return setStopped(true);
    }
  }),
      count = _useSpring.count;

  var _useResource = (0,src/* useResource */.Wf)(),
      locale = _useResource.locale;

  (0,react.useEffect)(function () {
    if (start) {
      setValue(num);
    }
  }, [num, start]);
  return stopped ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
    children: [percent ? num < 0 ? '' : '+' : '', new Intl.NumberFormat(locale === 'is' ? 'de-DE' : 'en-GB', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    }).format(num), percent ? '%' : '']
  }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_spring_esm.animated.span, {
    children: count.to(function (x) {
      return "".concat(percent ? num < 0 ? '' : '+' : '').concat(new Intl.NumberFormat(locale === 'is' ? 'de-DE' : 'en-GB', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }).format(x)).concat(percent ? '%' : '');
    })
  });
};

var AnnualModule_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl18"
} : 0)("background-color:", function (props) {
  return props.background ? '#F4F7F7' : 'transparent';
}, ";padding:50px ", function (props) {
  return props.background ? 44 : 0;
}, "px;@media ", devices/* device.tablet */.U.tablet, "{padding:", function (props) {
  return props.background ? '103px 100px' : '43px 44px 15px';
}, ";", function (props) {
  return props.background && 'margin: 0 -50px;';
}, ";}@media ", devices/* device.ipadPro */.U.ipadPro, "{padding:", function (props) {
  return props.background ? '103px 89px' : '43px 89px 15px';
}, ";}" + ( true ? "" : 0));

var AnnualModule_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl17"
} : 0)("p{", typography/* typography.p2 */.cp.p2, ";font-family:", function (props) {
  return props.serif ? props.theme.font.familySerif : props.theme.font.family;
}, ";}margin-bottom:90px;" + ( true ? "" : 0));

var AnnualModule_Div = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl16"
} : 0)( true ? "" : 0);

var Suffix = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1g4l2tl15"
} : 0)("font-size:", function (props) {
  return props.percentage ? 'inherit' : "18px;";
}, ";" + ( true ? "" : 0));

var AnnualModule_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h5",  true ? {
  target: "e1g4l2tl14"
} : 0)(typography/* typography.body */.cp.body, " color:", function (props) {
  return props.theme.colors.primary;
}, ";font-weight:", function (props) {
  return props.bold ? '500' : 'normal';
}, ";", function (props) {
  return props.color ? "padding-bottom:20px;margin-bottom:40px;\n      border-bottom: 2px solid \n        ".concat(props.theme.shades["".concat(props.color || 'primary', "5")]) : '';
}, ";" + ( true ? "" : 0));

var NumberBox = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl13"
} : 0)("border-bottom:2px solid ", function (props) {
  return props.theme.colors.primary;
}, ";margin:0 30px;" + ( true ? "" : 0));

var ChartBox = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl12"
} : 0)("border-bottom:2px solid ", function (props) {
  return props.theme.shades["".concat(props.color || 'primary', "5")];
}, ";margin:0 40px;@media ", devices/* device.tablet */.U.tablet, "{margin:0 20px;}@media ", devices/* device.ipadPro */.U.ipadPro, "{margin:0 40px;}" + ( true ? "" : 0));

var BubbleBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ChartBox,  true ? {
  target: "e1g4l2tl11"
} : 0)( true ? "" : 0);

var AnnualModule_Row = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl10"
} : 0)("display:flex;flex-direction:row;height:80px;align-items:center;color:", function (props) {
  return props.theme.colors.ternary;
}, ";" + ( true ? "" : 0));

var Value = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl9"
} : 0)(typography/* typography.numbersMedium */.cp.numbersMedium, ";font-family:", function (props) {
  return props.theme.font.familySlab;
}, ";font-weight:400;flex:1;" + ( true ? "" : 0));

var Percentage = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl8"
} : 0)(typography/* typography.numbersMedium */.cp.numbersMedium, ";font-family:", function (props) {
  return props.theme.font.familySlab;
}, ";font-weight:100;opacity:0.5;" + ( true ? "" : 0));

var Items = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl7"
} : 0)("display:flex;flex-direction:row;flex-wrap:wrap;margin:0 -25px;>div{width:100%;margin-bottom:42px;}@media ", devices/* device.tablet */.U.tablet, "{>div{width:", function (props) {
  return props.background ? '33.33%' : '50%';
}, ";}}@media ", devices/* device.desktop */.U.desktop, "{>div{width:33.33%;}}" + ( true ? "" : 0));

var ChartRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(AnnualModule_Row,  true ? {
  target: "e1g4l2tl6"
} : 0)("border-top:2px solid ", function (props) {
  return props.theme.shades["".concat(props.color || 'primary', "5")];
}, ";border-bottom:2px solid ", function (props) {
  return props.theme.shades["".concat(props.color || 'primary', "5")];
}, ";color:", function (props) {
  return props.theme.shades["".concat(props.color || 'primary', "5")];
}, ";margin-top:12px;" + ( true ? "" : 0));

function NumberItem(_ref2) {
  var title = _ref2.title,
      value = _ref2.value,
      suffix = _ref2.suffix,
      percentage = _ref2.percentage;

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(inviewConfig),
      _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NumberBox, {
    ref: ref,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualModule_Title, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AnnualModule_Row, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Value, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Countdown, {
          num: value,
          start: inView
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Suffix, {
          percentage: suffix == '%',
          children: suffix
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Percentage, {
        children: percentage != NaN && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Countdown, {
          percent: true,
          num: percentage * 100,
          start: inView
        })
      })]
    })]
  });
}
var COLUMN_HEIGHT = 258;

var Columns = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl5"
} : 0)( true ? {
  name: "1mkhlhl",
  styles: "display:flex;justify-content:space-between;align-items:flex-end;margin-top:69px;margin-bottom:44px"
} : 0);

var AnnualModule_Column = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl4"
} : 0)("text-align:center;width:35%;@media ", devices/* device.tablet */.U.tablet, "{width:44%;}@media ", devices/* device.ipadPro */.U.ipadPro, "{width:35%;}", typography/* typography.bodySmall */.cp.bodySmall, ";" + ( true ? "" : 0));

var Fill = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl3"
} : 0)("height:", function (props) {
  return props.height;
}, "px;width:100%;background:", function (props) {
  return props.theme.shades["".concat(props.color || 'primary').concat(props.shade || 4)];
}, ";margin-bottom:6px;" + ( true ? "" : 0));

var Bubble = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl2"
} : 0)("background:", function (props) {
  return props.theme.shades["".concat(props.color || 'primary', "4")];
}, ";width:100%;padding-top:100%;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:60px;line-height:70px;color:white;font-family:", function (props) {
  return props.theme.font.familySlab;
}, ";margin-bottom:40px;margin-top:40px;position:Relative;" + ( true ? "" : 0));

var BubbleText = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl1"
} : 0)( true ? {
  name: "t2ptc0",
  styles: "position:absolute;top:50%;margin-top:-35px"
} : 0);

function ChartItem(_ref3) {
  var title = _ref3.title,
      value = _ref3.value,
      percentage = _ref3.percentage,
      color = _ref3.color;

  var _useInView3 = (0,react_intersection_observer_m/* useInView */.YD)(inviewConfig),
      _useInView4 = (0,slicedToArray/* default */.Z)(_useInView3, 2),
      ref = _useInView4[0],
      inView = _useInView4[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ChartBox, {
    color: color,
    ref: ref,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualModule_Title, {
      bold: true,
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ChartRow, {
      color: color,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Value, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Countdown, {
          num: value,
          start: inView
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Percentage, {
        children: !isNaN(percentage) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Countdown, {
          num: percentage * 100,
          percent: true,
          start: inView
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Columns, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AnnualModule_Column, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Fill, {
          height: percentage > 0 ? (1 - percentage) * COLUMN_HEIGHT : COLUMN_HEIGHT,
          color: color,
          shade: 2
        }), "2019"]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AnnualModule_Column, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Fill, {
          height: percentage > 0 ? COLUMN_HEIGHT : (1 + percentage) * COLUMN_HEIGHT,
          color: color,
          shade: 4
        }), "2020"]
      })]
    })]
  });
}
function BubbleItem(_ref4) {
  var title = _ref4.title,
      value = _ref4.value,
      percentage = _ref4.percentage,
      color = _ref4.color;

  var _useInView5 = (0,react_intersection_observer_m/* useInView */.YD)(inviewConfig),
      _useInView6 = (0,slicedToArray/* default */.Z)(_useInView5, 2),
      ref = _useInView6[0],
      inView = _useInView6[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BubbleBox, {
    color: color,
    ref: ref,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualModule_Title, {
      bold: true,
      color: color,
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bubble, {
      color: color,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BubbleText, {
        children: value
      })
    })]
  });
}
var colors = ['ternary', 'secondary', 'primary'];

var Action = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1g4l2tl0"
} : 0)( true ? {
  name: "n0gckg",
  styles: "position:absolute;bottom:-30px;left:0;right:0;display:flex;flex-direction:row;justify-content:center"
} : 0);

function AnnualModule(props) {
  var _props$items;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    container: true,
    isArticle: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AnnualModule_Content, {
      background: props.background,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualModule_Copy, {
        serif: props.background,
        children: props.copy
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Items, {
        background: props.background,
        children: (_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.map(function (item, i) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualModule_Div, {
            type: item.type,
            children: item.type == 'chart' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChartItem, AnnualModule_objectSpread({
              color: colors[i % 3]
            }, item)) : item.type === 'bubble' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BubbleItem, AnnualModule_objectSpread({
              color: colors[i % 3]
            }, item)) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberItem, AnnualModule_objectSpread({}, item))
          }, i);
        })
      }), props.action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Action, {
        children: props.action
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/AnnualModuleContainer.tsx



function AnnualModuleContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AnnualModuleContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AnnualModuleContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AnnualModuleContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function parseNumber(value) {
  return parseFloat(value === null || value === void 0 ? void 0 : value.replace(/,|\./g, function (x) {
    return x === '.' ? '' : '.';
  }));
}

function parseString(value) {
  value = value.replace(/\d/g, '').replace(',', '');
  return value == '.' ? '' : value;
}

var AnnualModuleContainer_Button = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "ek36q2m0"
} : 0)("display:block;width:400px;padding:20px;border:1px solid ", function (props) {
  return props.theme.colors.primary;
}, ";background-color:#fff;", typography/* typography.body */.cp.body, " text-align:center;transition:330ms ease-in-out;transition-property:color,background-color;&:hover,&:active{background-color:", function (props) {
  return props.theme.shades.primary1;
}, ";}" + ( true ? "" : 0));

function AnnualModuleContainer(props) {
  var action_link = props.action_link,
      action_title = props.action_title,
      copy = props.copy,
      charts = props.charts,
      layout_type = props.layout_type,
      fields = props.fields;

  var _useContext = (0,react.useContext)(prismicContext/* PrismicContext */.Z),
      urlResolver = _useContext.urlResolver;

  var items = fields.map(function (field) {
    return {
      title: Prismic/* Prismic.text */.X5.text(field.a_title),
      value: layout_type == 'text' ? parseNumber(field.value) : field.value,
      suffix: parseString(field.value),
      percentage: parseNumber(field.percentage) / 100,
      chart: charts,
      type: layout_type
    };
  });
  var link = action_link && Prismic/* Prismic.link */.X5.link(urlResolver, AnnualModuleContainer_objectSpread({
    _linkType: Prismic/* LinkType.Document */.Un.Document
  }, action_link), action_title);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualModule, {
    background: charts,
    type: layout_type,
    action: link && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_link["default"], {
      href: link.as,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualModuleContainer_Button, AnnualModuleContainer_objectSpread(AnnualModuleContainer_objectSpread({}, link.anchorProps()), {}, {
        children: link.title
      }))
    }),
    copy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
      value: copy
    }),
    items: items
  });
}
// EXTERNAL MODULE: ../../packages/prismic/src/fallback.tsx
var fallback = __webpack_require__(16967);
// EXTERNAL MODULE: ../../node_modules/lodash.isempty/index.js
var lodash_isempty = __webpack_require__(36160);
var lodash_isempty_default = /*#__PURE__*/__webpack_require__.n(lodash_isempty);
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/HorizontalCard.tsx



var HorizontalCard_excluded = ["link", "title", "description", "image", "ar", "reverse", "backgroundAlt", "isProductCard", "onMouseEnter", "onMouseLeave"];

function HorizontalCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function HorizontalCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HorizontalCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HorizontalCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var HorizontalHost = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1j7kp2c5"
} : 0)("display:block;position:relative;width:auto;margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";background-color:", function (props) {
  return props.backgroundAlt ? props.theme.colors.backgroundAlt : props.theme.colors.background;
}, ";display:flex;flex-direction:column;max-width:1179px;cursor:pointer;", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{flex-direction:", function (props) {
  return !props.reverse ? 'row' : 'row-reverse';
}, ";width:100%;margin-left:0;margin-right:0;}&:hover div img{transform:scale(1.025);}" + ( true ? "" : 0));

var HorizontalCard_Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Img,  true ? {
  target: "e1j7kp2c4"
} : 0)("width:100%;@media ", devices/* device.tablet */.U.tablet, "{width:50%;}" + ( true ? "" : 0));

var HorizontalCard_Body = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1j7kp2c3"
} : 0)("display:flex;flex-direction:column;justify-content:center;width:100%;padding:", function (props) {
  return "0 ".concat(props.theme.containerGutter, "px");
}, ";@media ", devices/* device.mobile */.U.mobile, "{padding:", function (props) {
  return "0 ".concat(props.theme.breakpoints.sm.gutter, "px");
}, ";}@media ", devices/* device.tablet */.U.tablet, "{width:50%;padding:0;}" + ( true ? "" : 0));

var HorizontalCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1j7kp2c2"
} : 0)(typography/* typography.h3 */.cp.h3, ";margin-bottom:3px;" + ( true ? "" : 0));

var HorizontalCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1j7kp2c1"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:24px;" + ( true ? "" : 0));

var Center = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1j7kp2c0"
} : 0)("margin:0 auto;padding:", function (props) {
  return props.isProductCard ? '36px 0 0' : '2em 0';
}, ";max-width:100%;@media ", devices/* device.tablet */.U.tablet, "{padding:2.5em;}@media ", devices/* device.desktop */.U.desktop, "{padding:3.5em;}" + ( true ? "" : 0));

var HorizontalCard = /*#__PURE__*/(0,react.forwardRef)(function HCard(_ref, ref) {
  var link = _ref.link,
      title = _ref.title,
      description = _ref.description,
      image = _ref.image,
      _ref$ar = _ref.ar,
      ar = _ref$ar === void 0 ? 'ar_1_1' : _ref$ar,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      _ref$backgroundAlt = _ref.backgroundAlt,
      backgroundAlt = _ref$backgroundAlt === void 0 ? false : _ref$backgroundAlt,
      _ref$isProductCard = _ref.isProductCard,
      isProductCard = _ref$isProductCard === void 0 ? false : _ref$isProductCard,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, HorizontalCard_excluded);

  var router = (0,next_router.useRouter)();

  var _useContext = (0,react.useContext)(prismicContext/* PrismicContext */.Z),
      urlResolver = _useContext.urlResolver;

  var url = Prismic/* Prismic.link */.X5.link(urlResolver, link);

  var _useState = (0,react.useState)(false),
      hover = _useState[0],
      setHover = _useState[1];

  var onEnter = function onEnter(e) {
    setHover(true);

    if (onMouseEnter) {
      onMouseEnter(e);
    }
  };

  var onLeave = function onLeave(e) {
    setHover(false);

    if (onMouseLeave) {
      onMouseLeave(e);
    }
  };

  var onClick = function onClick(e) {
    var _window, _window$getSelection, _window$getSelection$, _url$href;

    if (((_window = window) === null || _window === void 0 ? void 0 : (_window$getSelection = _window.getSelection) === null || _window$getSelection === void 0 ? void 0 : (_window$getSelection$ = _window$getSelection.call(_window)) === null || _window$getSelection$ === void 0 ? void 0 : _window$getSelection$.type) === 'Range') {
      e.preventDefault();
      return false;
    }

    return router.push((_url$href = url.href) !== null && _url$href !== void 0 ? _url$href : '', url.as);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HorizontalHost, HorizontalCard_objectSpread(HorizontalCard_objectSpread({
    reverse: reverse,
    backgroundAlt: backgroundAlt
  }, rest), {}, {
    onMouseEnter: onEnter,
    onMouseLeave: onLeave,
    onClick: onClick,
    ref: ref,
    children: [!!image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalCard_Image, {
      percentage: 0.5,
      src: image,
      ar: ar
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalCard_Body, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Center, {
        isProductCard: isProductCard,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalCard_Title, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
            value: link,
            title: title,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
              children: title
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalCard_Copy, {
          children: description
        })]
      })
    })]
  }));
});
// EXTERNAL MODULE: ../../packages/ui/src/components/buttons/ArrowButton.tsx
var ArrowButton = __webpack_require__(40799);
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/QuoteCard.tsx



var QuoteCard_excluded = ["link", "linkText", "description", "image", "ar", "reverse"];

function QuoteCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function QuoteCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { QuoteCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { QuoteCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var QuoteHost = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1ov40604"
} : 0)("display:block;position:relative;width:auto;margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";background-color:", function (props) {
  return props.theme.colors.primary;
}, ";display:flex;color:#fff;flex-direction:column-reverse;max-width:1179px;", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{flex-direction:", function (props) {
  return !props.reverse ? 'row' : 'row-reverse';
}, ";width:100%;margin-left:0;margin-right:0;}" + ( true ? "" : 0));

var QuoteCard_Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Img,  true ? {
  target: "e1ov40603"
} : 0)("width:100%;@media ", devices/* device.tablet */.U.tablet, "{width:50%;}" + ( true ? "" : 0));

var QuoteCard_Body = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ov40602"
} : 0)("display:flex;flex-direction:column;justify-content:center;width:100%;padding:", function (props) {
  return "0 ".concat(props.theme.containerGutter, "px");
}, ";@media ", devices/* device.mobile */.U.mobile, "{padding:", function (props) {
  return "0 ".concat(props.theme.breakpoints.sm.gutter, "px");
}, ";}@media ", devices/* device.tablet */.U.tablet, "{width:50%;padding:0;}" + ( true ? "" : 0));

var QuoteCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ov40601"
} : 0)("div{", typography/* typography.bodyEditorial */.cp.bodyEditorial, ";font-size:20px;line-height:", 30 / 26, ";@media ", devices/* device.mobile */.U.mobile, "{font-size:26px;}@media ", devices/* device.tablet */.U.tablet, "{font-size:18px;}@media ", devices/* device.desktop */.U.desktop, "{font-size:26px;}}margin-bottom:80px;" + ( true ? "" : 0));

var QuoteCard_Center = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ov40600"
} : 0)("margin:0 auto;padding:4em 0;max-width:100%;@media ", devices/* device.tablet */.U.tablet, "{padding:2.5em;height:100%;display:flex;flex-flow:column;justify-content:space-between;}@media ", devices/* device.desktop */.U.desktop, "{padding:100px 100px 70px;}" + ( true ? "" : 0));

var QuoteCard = /*#__PURE__*/(0,react.forwardRef)(function QCard(_ref, ref) {
  var link = _ref.link,
      linkText = _ref.linkText,
      description = _ref.description,
      image = _ref.image,
      _ref$ar = _ref.ar,
      ar = _ref$ar === void 0 ? 'ar_1_1' : _ref$ar,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, QuoteCard_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(QuoteHost, QuoteCard_objectSpread(QuoteCard_objectSpread({
    reverse: reverse
  }, rest), {}, {
    ref: ref,
    children: [!!image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteCard_Image, {
      percentage: 0.5,
      src: image,
      aspectRatio: 1,
      ar: ar
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteCard_Body, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(QuoteCard_Center, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteCard_Copy, {
          children: description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
          value: link,
          title: linkText,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowButton/* ArrowButton */.b, {
            isWhite: true
          })
        })]
      })
    })]
  }));
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/card-group/QuoteCardGroup.tsx








var Group = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eavvxpk0"
} : 0)("display:flex;flex-flow:row wrap;justify-content:space-between;", function (props) {
  return props.count !== undefined && props.count % 3 === 2 ? "\n  :after{\n    content: \"\";\n    flex: 0.9;    \n  }" : "";
}, ">*{margin-bottom:2em;}>", QuoteHost, "{margin-bottom:64px;}@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:-20px;>", CardHostLink, "{width:calc((6 / 12 * 100%) - 15px);margin-bottom:30px;padding-bottom:0;}>", HorizontalHost, "{margin-bottom:30px;padding-bottom:0;}}@media ", devices/* device.desktop */.U.desktop, "{>", CardHostLink, "{width:calc((4 / 12 * 100%) - 15px);margin-bottom:20px;padding-bottom:0;}>", HorizontalHost, "{margin-bottom:20px;padding-bottom:0;}}" + ( true ? "" : 0));

var QuoteCardGroup = function QuoteCardGroup(_ref) {
  var children = _ref.children,
      count = _ref.count;

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Group, {
    ref: ref,
    count: count,
    children: itemsWithStyleProp
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/AnnualQuoteContainer.tsx


var AnnualQuoteContainer_excluded = ["isReverse"];

function AnnualQuoteContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AnnualQuoteContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AnnualQuoteContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AnnualQuoteContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var CardItem = function CardItem(_ref) {
  var _linkdata$title, _linkdata$abstract, _linkdata$image;

  var field = _ref.field;
  var image = field.image,
      link_text = field.link_text,
      copy = field.copy,
      link = field.link,
      isReverse = field.isReverse,
      style = field.style;
  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var linkText = (0,fallback/* fallbackText */.mn)(link_text, (_linkdata$title = linkdata === null || linkdata === void 0 ? void 0 : linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteCard, {
    link: link,
    linkText: linkText !== null && linkText !== void 0 ? linkText : undefined,
    description: (0,fallback/* fallbackRichText */.K8)(copy, (_linkdata$abstract = linkdata === null || linkdata === void 0 ? void 0 : linkdata.abstract) !== null && _linkdata$abstract !== void 0 ? _linkdata$abstract : undefined),
    image: (0,fallback/* fallbackImage */.bU)(image, (_linkdata$image = linkdata === null || linkdata === void 0 ? void 0 : linkdata.image) !== null && _linkdata$image !== void 0 ? _linkdata$image : undefined),
    reverse: isReverse,
    style: style
  });
};

var AnnualQuoteContainer = function AnnualQuoteContainer(_ref2) {
  var align = _ref2.align,
      fields = _ref2.fields;

  if (lodash_isempty_default()(fields)) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    paddingBottomMobile: 0,
    isArticle: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteCardGroup, {
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (_ref3, index) {
        var isReverse = _ref3.isReverse,
            rest = (0,objectWithoutProperties/* default */.Z)(_ref3, AnnualQuoteContainer_excluded);

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardItem, {
          field: AnnualQuoteContainer_objectSpread({
            isReverse: align === 'Left' && index % 2 === 0
          }, rest)
        }, "card-item-".concat(index));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card-group/ArticleCardGroup.tsx







var ArticleCardGroup_Group = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bxgua20"
} : 0)("display:flex;flex-flow:row wrap;justify-content:space-between;", function (props) {
  return props.count !== undefined && props.count % 3 === 2 ? "\n  :after{\n    content: \"\";\n    flex: 0.9;    \n  }" : "";
}, ">*{padding-bottom:2em;}@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:-20px;>", CardHostLink, "{width:calc((6 / 12 * 100%) - 15px);margin-bottom:30px;padding-bottom:0;}>", HorizontalHost, "{margin-bottom:30px;padding-bottom:0;}}@media ", devices/* device.desktop */.U.desktop, "{>", CardHostLink, "{width:calc((4 / 12 * 100%) - 15px);margin-bottom:20px;padding-bottom:0;}>", HorizontalHost, "{margin-bottom:20px;padding-bottom:0;}}" + ( true ? "" : 0));

var ArticleCardGroup = function ArticleCardGroup(_ref) {
  var children = _ref.children,
      count = _ref.count;

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleCardGroup_Group, {
    ref: ref,
    count: count,
    children: itemsWithStyleProp
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/ArticleCardsContainer.tsx


function ArticleCardsContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ArticleCardsContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ArticleCardsContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ArticleCardsContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var ArticleCardsContainer_CardItem = function CardItem(_ref) {
  var _linkdata$title, _linkdata$abstract, _linkdata$image, _fallbackText, _linkdata$title2, _linkdata$abstract2, _linkdata$image2, _fallbackText2, _linkdata$title3;

  var image = _ref.image,
      heading = _ref.heading,
      copy = _ref.copy,
      link = _ref.link,
      isReverse = _ref.isReverse,
      isHorizontal = _ref.isHorizontal,
      percentage = _ref.percentage,
      style = _ref.style;
  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var title = (0,fallback/* fallbackText */.mn)(heading, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);

  var card = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card, {
    link: link,
    title: link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
      value: link,
      title: title !== null && title !== void 0 ? title : undefined,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        children: title
      })
    }) : title,
    description: (0,fallback/* fallbackRichText */.K8)(copy, (_linkdata$abstract = linkdata.abstract) !== null && _linkdata$abstract !== void 0 ? _linkdata$abstract : undefined),
    image: (0,fallback/* fallbackImage */.bU)(image, (_linkdata$image = linkdata.image) !== null && _linkdata$image !== void 0 ? _linkdata$image : undefined),
    ar: "ar_1_1",
    padding: true,
    backgroundAlt: true // action={
    //   <PrismicLink value={link} title={title}>
    //     <ArrowButton hideText />
    //   </PrismicLink>
    // }
    ,
    style: style,
    percentage: percentage,
    hasTitleMinHeight: true
  });

  var horizontalCard = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalCard, {
    link: link,
    title: (_fallbackText = (0,fallback/* fallbackText */.mn)(heading, (_linkdata$title2 = linkdata.title) !== null && _linkdata$title2 !== void 0 ? _linkdata$title2 : undefined)) !== null && _fallbackText !== void 0 ? _fallbackText : undefined,
    description: (0,fallback/* fallbackRichText */.K8)(copy, (_linkdata$abstract2 = linkdata.abstract) !== null && _linkdata$abstract2 !== void 0 ? _linkdata$abstract2 : undefined),
    image: (0,fallback/* fallbackImage */.bU)(image, (_linkdata$image2 = linkdata.image) !== null && _linkdata$image2 !== void 0 ? _linkdata$image2 : undefined),
    reverse: isReverse,
    backgroundAlt: true,
    style: style
  });

  if (!link && isHorizontal) {
    return horizontalCard;
  }

  if (isHorizontal) {
    return horizontalCard;
  }

  if (!link) {
    return card;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link,
    title: (_fallbackText2 = (0,fallback/* fallbackText */.mn)(heading, (_linkdata$title3 = linkdata.title) !== null && _linkdata$title3 !== void 0 ? _linkdata$title3 : undefined)) !== null && _fallbackText2 !== void 0 ? _fallbackText2 : undefined,
    children: card
  });
};

var ArticleContainer = function ArticleContainer(_ref2) {
  var _fields$length;

  var align = _ref2.align,
      fields = _ref2.fields;
  var isTablet = (0,hooks_useMedia/* useMedia */.G)('md');
  var count = (_fields$length = fields === null || fields === void 0 ? void 0 : fields.length) !== null && _fields$length !== void 0 ? _fields$length : 0;

  if (lodash_isempty_default()(fields)) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    paddingBottomMobile: 0,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleCardGroup, {
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleCardsContainer_CardItem, ArticleCardsContainer_objectSpread({
          isReverse: align === 'Left' && index % 2 === 0,
          isHorizontal: count === 1 || count === 2 || count === 4 && index === 0 || count === 3 && index === 2 && isTablet,
          percentage: count === 3 || count > 4 || count === 4 && index > 0 ? 0.33 : 1
        }, item), "card-item-".concat(index));
      })
    })
  });
};
// EXTERNAL MODULE: ../../packages/ui/src/components/buttons/Button.tsx + 1 modules
var buttons_Button = __webpack_require__(11709);
// EXTERNAL MODULE: ../../node_modules/hyphen/is/index.js
var is = __webpack_require__(40412);
;// CONCATENATED MODULE: ../../packages/slices/src/components/hero-article/ArticlePageHero.tsx



function ArticlePageHero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var isEmpty = function isEmpty(value) {
  if (react.Children.count(value) === 0) {
    return true;
  }

  return String(value !== null && value !== void 0 ? value : '').trim() === '';
};

var ArticlePageHero_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezwz7r911"
} : 0)("position:relative;padding-bottom:1px;margin-bottom:", function (props) {
  return props.hasButton ? '116px' : '72px';
}, ";background:", function (props) {
  return props.theme.shades.ternary2;
}, ";@media ", devices/* device.tablet */.U.tablet, "{padding-top:105px;margin-top:-86px;margin-bottom:116px;}@media (min-width: 950px){padding-top:86px;}" + ( true ? "" : 0));

var Background = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezwz7r910"
} : 0)("position:absolute;top:0;left:0;right:0;bottom:-50px;background:", function (props) {
  return props.theme.shades.ternary2;
}, ";" + ( true ? "" : 0));

var ArticlePageHero_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "ezwz7r99"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{", mixins/* container */.nC, " margin-top:-20px;}" + ( true ? "" : 0));

var ArticlePageHero_Image = (0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "ezwz7r98"
} : 0)( true ? {
  name: "1vfhcql",
  styles: "object-fit:cover"
} : 0).withComponent(Img,  true ? {
  target: "ezwz7r912"
} : 0);

var AspectRatio = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezwz7r97"
} : 0)("position:relative;display:flex;flex-flow:column nowrap;margin-bottom:-50px;@media ", devices/* device.tablet */.U.tablet, "{flex-direction:row-reverse;&:before{padding-bottom:", function () {
  return 0.49 * 100;
}, "%;content:'';float:left;}&:after{display:table;content:'';clear:both;}}" + ( true ? "" : 0));

var ArticlePageHero_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "ezwz7r96"
} : 0)(typography/* typography.h2 */.cp.h2, "@media ", devices/* device.tablet */.U.tablet, "{", typography/* typography.h3 */.cp.h3, ";}@media ", devices/* device.desktop */.U.desktop, "{", typography/* typography.h2 */.cp.h2, " margin-bottom:35px;}" + ( true ? "" : 0));

var Description = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezwz7r95"
} : 0)("@media ", devices/* device.desktop */.U.desktop, "{margin-top:35px;}" + ( true ? "" : 0));

var ImageAspect = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezwz7r94"
} : 0)("width:100%;&:before{content:'';display:block;padding-top:", 1 * 100, "%;@media ", devices/* device.tablet */.U.tablet, "{display:block;}@media ", devices/* device.desktop */.U.desktop, "{display:block;padding-top:", 3 / 4 * 100, "%;}}>:first-child{position:absolute;top:0;left:0;height:100%;width:100%;}@media ", devices/* device.tablet */.U.tablet, "{position:absolute;bottom:-31px;}" + ( true ? "" : 0));

var ArticlePageHero_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezwz7r93"
} : 0)("position:relative;padding:34px 34px 30px;display:flex;flex-direction:column;@media ", devices/* device.mobile */.U.mobile, "{padding:34px 44px 30px;}@media ", devices/* device.tablet */.U.tablet, "{padding:63px 30px 63px 0;padding-top:105px;background-color:transparent;width:calc(50%);}@media ", devices/* device.desktop */.U.desktop, "{width:calc(30% + 53px);}" + ( true ? "" : 0));

var ArticlePageHero_Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "ezwz7r92"
} : 0)("display:flex;flex:1;flex-direction:column;padding-bottom:56px;@media ", devices/* device.tablet */.U.tablet, "{padding-bottom:36px;}" + ( true ? "" : 0));

var Actions = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "ezwz7r91"
} : 0)("margin-bottom:-60px;display:flex;flex-direction:column;align-items:flex-start;>*{margin-top:20px;width:100%;}>*:first-child{margin-top:0;}@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:-94px;>*{margin-top:30px;width:183px;}}" + ( true ? "" : 0));

var ArticlePageHero_Column = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezwz7r90"
} : 0)("position:relative;width:100%;@media ", devices/* device.tablet */.U.tablet, "{width:calc(50%);}@media ", devices/* device.desktop */.U.desktop, "{width:calc(70% - 30px);}" + ( true ? "" : 0));

function ArticlePageHero(props) {
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(useReveal/* inViewConfig */.BT),
      _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  var isDesktop = (0,hooks_useMedia/* useMedia */.G)('lg');
  var isAnimated = props.isAnimated,
      image = props.image,
      title = props.title,
      actions = props.actions,
      description = props.description;
  var hasButton = !!actions;
  var visible = isAnimated !== null && isAnimated !== void 0 ? isAnimated : inView;
  var delay = 0;
  var copyStyle = (0,react_spring_esm.useSpring)({
    opacity: visible ? 1 : 0,
    y: visible ? 0 : 20,
    delay: delay
  });
  var actionsStyle = (0,react_spring_esm.useSpring)({
    opacity: visible ? 1 : 0,
    overflow: 'hidden',
    delay: delay + 100,
    config: {
      tension: 320
    }
  });
  var imageStyle = (0,react_spring_esm.useSpring)({
    x: visible ? '0%' : '101%'
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ArticlePageHero_Host, {
    ref: ref,
    hasButton: hasButton,
    id: "hero",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Background, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticlePageHero_Container, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AspectRatio, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticlePageHero_Column, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageAspect, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_spring_esm.animated.div, {
              style: {
                overflow: 'hidden',
                transform: imageStyle.x.to(function (v) {
                  return "translateX(-".concat(v, ")");
                })
              },
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticlePageHero_Image, {
                src: image,
                ar: isDesktop ? 'ar_4_3' : 'ar_1_1',
                isFit: true,
                containerStyle: imageStyle,
                percentage: 0.7
              })
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ArticlePageHero_Content, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ArticlePageHero_Copy, {
            style: copyStyle,
            children: [!isEmpty(title) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticlePageHero_Title, {
              children: title
            }), !isEmpty(description) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Description, {
                children: [description === null || description === void 0 ? void 0 : description.slice(0, 130), "..."]
              })]
            })]
          }), !isEmpty(actions) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Actions, {
            style: actionsStyle,
            children: actions
          })]
        })]
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/ArticleHeroContainer.tsx


function ArticleHeroContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ArticleHeroContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ArticleHeroContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ArticleHeroContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function ArticleHeroContainer(props) {
  var _props$a_link, _props$a_link2, _props$a_link3, _Prismic$text;

  var _useContext = (0,react.useContext)(prismicContext/* PrismicContext */.Z),
      urlResolver = _useContext.urlResolver;

  var titleText = (0,fallback/* fallbackText */.mn)(props.a_title, (_props$a_link = props.a_link) === null || _props$a_link === void 0 ? void 0 : _props$a_link.title);
  var abstract = (0,fallback/* fallbackText */.mn)(props.a_abstract, (_props$a_link2 = props.a_link) === null || _props$a_link2 === void 0 ? void 0 : _props$a_link2.abstract);
  var image = (0,fallback/* fallbackImage */.bU)(props.a_image, (_props$a_link3 = props.a_link) === null || _props$a_link3 === void 0 ? void 0 : _props$a_link3.image);
  var action = null;
  var title = (0,is.hyphenateSync)((_Prismic$text = Prismic/* Prismic.text */.X5.text(titleText)) !== null && _Prismic$text !== void 0 ? _Prismic$text : '');

  if (props.a_link) {
    var _link$as;

    var link = Prismic/* Prismic.link */.X5.link(urlResolver, ArticleHeroContainer_objectSpread({
      _linkType: Prismic/* LinkType.Document */.Un.Document
    }, props === null || props === void 0 ? void 0 : props.a_link), titleText !== null && titleText !== void 0 ? titleText : undefined);
    var linkText = Prismic/* Prismic.text */.X5.text(props.a_link_text);
    action = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_link["default"], {
      href: link.as,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_Button/* Button */.z, ArticleHeroContainer_objectSpread(ArticleHeroContainer_objectSpread({}, link.anchorProps()), {}, {
        as: "a",
        title: linkText !== null && linkText !== void 0 ? linkText : undefined,
        bg: theme/* theme.colors.secondary */.r.colors.secondary
      }))
    });
    title = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_link["default"], {
      href: (_link$as = link.as) !== null && _link$as !== void 0 ? _link$as : '',
      children: title
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticlePageHero, {
    title: title,
    description: abstract !== null && abstract !== void 0 ? abstract : undefined,
    image: image,
    actions: action
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/card-group/CardGroup.tsx




var CardGroup_Group = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eddxwwx0"
} : 0)("flex-direction:column;>*{margin-bottom:2em;&:last-child{margin-bottom:0;}}@media ", devices/* device.tablet */.U.tablet, "{display:flex;flex-direction:row;flex-wrap:wrap;max-width:1200px;margin:0 -10px -20px;>div,>a{margin:0 10px;margin-bottom:", function (props) {
  return props.count && props.count >= 4 ? '4em' : '20px';
}, ";width:100%;max-width:", function (props) {
  var _props$columns;

  return props.count === 4 ? 'calc(50% - 20px)' : "calc(".concat(1 / ((_props$columns = props === null || props === void 0 ? void 0 : props.columns) !== null && _props$columns !== void 0 ? _props$columns : 1) * 100, "% - 20px)");
}, ";&:last-child{margin-bottom:", function (props) {
  return props.count && props.count >= 4 ? '4em' : '20px';
}, ";}}>*:last-child{", function (props) {
  return props.isFeatured && 'max-width: 100%;';
}, ";}}@media ", devices/* device.desktop */.U.desktop, "{>div,>a{max-width:calc(", function (props) {
  var _props$columns2;

  return 1 / ((_props$columns2 = props === null || props === void 0 ? void 0 : props.columns) !== null && _props$columns2 !== void 0 ? _props$columns2 : 1) * 100;
}, "% - 20px);}}" + ( true ? "" : 0));
var CardGroup = function CardGroup(_ref) {
  var children = _ref.children,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 3 : _ref$columns,
      _ref$isFeatured = _ref.isFeatured,
      isFeatured = _ref$isFeatured === void 0 ? false : _ref$isFeatured;

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  var count = react.Children.toArray(children).length;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardGroup_Group, {
    columns: columns,
    count: count,
    ref: ref,
    isFeatured: isFeatured,
    children: itemsWithStyleProp
  });
};
;// CONCATENATED MODULE: ../../packages/ui/src/components/text/Text.tsx





var TextHost = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e17xjpk30"
} : 0)(function (props) {
  return typography/* typography */.cp[props.variant];
}, ";" + ( true ? "" : 0));

var Text_Text = function Text(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'p' : _ref$as,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'body' : _ref$variant,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextHost, {
    as: as,
    variant: variant,
    children: children
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/AukakronurCard.tsx



var AukakronurCard_excluded = ["link", "title", "image", "backgroundColor", "imageRef", "onMouseEnter", "onMouseLeave", "onClick"];

function AukakronurCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AukakronurCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AukakronurCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AukakronurCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function AukakronurCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var AukakronurCard_CardHostLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e12e81q41"
} : 0)("display:flex;justify-content:space-between;align-items:center;width:100%;height:auto;cursor:pointer;padding-left:24px;padding-top:14px;padding-bottom:14px;padding-right:21px;margin-bottom:16px;background-color:", function (props) {
  return Prismic/* Prismic.text */.X5.text(props.backgroundColor);
}, ";" + ( true ? "" : 0));

var ImgContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12e81q40"
} : 0)( true ? {
  name: "pb59km",
  styles: "min-width:60px;>*:first-child{height:100%;}"
} : 0);

var AukakronurCard = /*#__PURE__*/(0,react.forwardRef)(function CardFn(props, ref) {
  var link = props.link,
      title = props.title,
      image = props.image,
      backgroundColor = props.backgroundColor,
      imageRef = props.imageRef,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onClick = props.onClick,
      rest = (0,objectWithoutProperties/* default */.Z)(props, AukakronurCard_excluded);

  var router = (0,next_router.useRouter)();

  var _useContext = (0,react.useContext)(prismicContext/* PrismicContext */.Z),
      urlResolver = _useContext.urlResolver;

  var url = Prismic/* Prismic.link */.X5.link(urlResolver, link);

  var _useState = (0,react.useState)(false),
      hover = _useState[0],
      setHover = _useState[1];

  var onEnter = function onEnter(e) {
    setHover(true);

    if (onMouseEnter) {
      onMouseEnter(e);
    }
  };

  var onLeave = function onLeave(e) {
    setHover(false);

    if (onMouseLeave) {
      onMouseLeave(e);
    }
  };

  var onCardClick = function onCardClick(e) {
    var _window, _window$getSelection, _window$getSelection$, _url$href;

    if (((_window = window) === null || _window === void 0 ? void 0 : (_window$getSelection = _window.getSelection) === null || _window$getSelection === void 0 ? void 0 : (_window$getSelection$ = _window$getSelection.call(_window)) === null || _window$getSelection$ === void 0 ? void 0 : _window$getSelection$.type) === 'Range') {
      e.preventDefault();
      return false;
    }

    if (onClick) {
      onClick(e);
    }

    if (url.onClick) {
      return url.onClick(e);
    }

    return router.push((_url$href = url.href) !== null && _url$href !== void 0 ? _url$href : '', url.as);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AukakronurCard_CardHostLink, AukakronurCard_objectSpread(AukakronurCard_objectSpread({
    backgroundColor: backgroundColor,
    ref: ref
  }, rest), {}, {
    onMouseLeave: onLeave,
    onMouseEnter: onEnter,
    onClick: onCardClick,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text_Text, {
      variant: 'h3',
      children: Prismic/* Prismic.text */.X5.text(title)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImgContainer, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
        src: image,
        ar: 'ar_1_1',
        aspectRatio: 1,
        percentage: 100,
        ref: imageRef
      })
    })]
  }));
});
;// CONCATENATED MODULE: ../../packages/slices/src/containers/AukakronurCardsContainer.tsx



var AukakronurCardsContainer_excluded = ["image", "title", "link", "color"];

function AukakronurCardsContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AukakronurCardsContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AukakronurCardsContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AukakronurCardsContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function AukakronurCardsContainer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var AukakronurCardsContainer_CardItem = /*#__PURE__*/(0,react.forwardRef)(function CardItem(_ref, ref) {
  var _linkdata$image, _Prismic$text;

  var image = _ref.image,
      title = _ref.title,
      link = _ref.link,
      color = _ref.color,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, AukakronurCardsContainer_excluded);

  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var titled = Prismic/* Prismic.text */.X5.text(title);
  var imageRef = (0,react.useRef)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card, AukakronurCardsContainer_objectSpread({
    link: link,
    imageRef: imageRef,
    title: link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
      value: link,
      title: titled !== null && titled !== void 0 ? titled : undefined,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        children: titled
      })
    }) : titled,
    description: undefined,
    image: (0,fallback/* fallbackImage */.bU)(image, (_linkdata$image = linkdata.image) !== null && _linkdata$image !== void 0 ? _linkdata$image : undefined),
    ar: 'ar_4_3',
    percentage: 2,
    padding: false,
    notLink: !link,
    backgroundColor: (_Prismic$text = Prismic/* Prismic.text */.X5.text(color)) !== null && _Prismic$text !== void 0 ? _Prismic$text : undefined
  }, rest));
});

var CardImageSize = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(AukakronurCardsContainer_CardItem,  true ? {
  target: "e4erclg0"
} : 0)( true ? {
  name: "1fnpw1h",
  styles: "img{width:75%!important;height:75%!important;min-height:0!important;max-width:0!important;object-fit:contain!important;}"
} : 0);

var AukakronurCardsContainer = function AukakronurCardsContainer(_ref2) {
  var fields = _ref2.fields;
  var count = fields.length;
  var colSize = count <= 2 || count === 4 ? 2 : 3;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    paddingBottomMobile: 0,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardGroup, {
      columns: colSize,
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
        var _getDataFromLink$titl;

        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [!isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardImageSize, AukakronurCardsContainer_objectSpread(AukakronurCardsContainer_objectSpread({}, item), {}, {
            count: count
          }), "product-item-".concat(index)), isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AukakronurCard, AukakronurCardsContainer_objectSpread({
            title: (0,fallback/* fallbackText */.mn)(item.title, (_getDataFromLink$titl = (0,fallback/* getDataFromLink */.rm)(item.link).title) !== null && _getDataFromLink$titl !== void 0 ? _getDataFromLink$titl : undefined),
            backgroundColor: item.color
          }, item), "product-item-".concat(index))]
        });
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/become-a-customer/BecomeACustomer.tsx








var BecomeACustomer_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1u4171n5"
} : 0)(mixins/* mobileGutterMargin */.HW, " margin:", function (props) {
  return "0 -".concat(props.theme.containerGutter, "px");
}, ";>div>div:first-child{z-index:2;}@media ", devices/* device.tablet */.U.tablet, "{margin:0;}" + ( true ? "" : 0));

var BecomeACustomer_Background = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1u4171n4"
} : 0)("position:relative;z-index:1;background-image:", function (props) {
  return props.theme.gradients.primary;
}, ";padding:", function (props) {
  return "100px ".concat(props.theme.containerGutter, "px");
}, ";@media ", devices/* device.mobile */.U.mobile, "{padding:", function (props) {
  return "100px ".concat(props.theme.breakpoints.sm.gutter, "px");
}, ";}@media ", devices/* device.tablet */.U.tablet, "{padding:100px;margin:0;}@media ", devices/* device.desktop */.U.desktop, "{padding:100px 72px 60px 72px;}" + ( true ? "" : 0));

var H2 = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1u4171n3"
} : 0)(typography/* typography.h2 */.cp.h2, " margin-bottom:1.5em;color:", function (props) {
  return props.theme.colors.background;
}, ";" + ( true ? "" : 0));

var BecomeACustomer_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1u4171n2"
} : 0)("margin-bottom:4em;color:", function (props) {
  return props.theme.colors.background;
}, ";@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:60px;}" + ( true ? "" : 0));

var ButtonWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1u4171n1"
} : 0)("display:flex;flex-flow:column wrap;a{width:initial;outline-offset:-0.4rem;}@media ", devices/* device.tablet */.U.tablet, "{flex-flow:row wrap;justify-content:flex-start;}" + ( true ? "" : 0));

var ImageWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1u4171n0"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{margin:0;}@media ", devices/* device.desktop */.U.desktop, "{margin-top:120px;margin-left:-200px;}" + ( true ? "" : 0));

var BecomeACustomer = function BecomeACustomer(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      action = _ref.action,
      image = _ref.image;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BecomeACustomer_Host, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* TrailRow */.f, {
      gutter: isMobile ? 0 : undefined,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        style: {
          zIndex: 2
        },
        md: {
          width: 12 / 12
        },
        lg: {
          width: 6 / 12
        },
        sm: {
          gutter: 0
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BecomeACustomer_Background, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H2, {
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BecomeACustomer_Copy, {
            children: copy
          }), action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrap, {
            children: action
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 12 / 12
        },
        lg: {
          width: 6 / 12
        },
        sm: {
          gutter: 0
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrap, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
            src: image,
            ar: "ar_4_3",
            percentage: 0.7
          })
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/BecomeACustomerContainer.tsx





var BecomeACustomerContainer = function BecomeACustomerContainer(_ref) {
  var _buttonLinkdata$title, _images$Math$floor, _Prismic$text;

  var title = _ref.title,
      copy = _ref.copy,
      background = _ref.background,
      link_text = _ref.link_text,
      link = _ref.link,
      images = _ref.images;
  var buttonLinkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var buttonTitle = (0,fallback/* fallbackText */.mn)(link_text, (_buttonLinkdata$title = buttonLinkdata.title) !== null && _buttonLinkdata$title !== void 0 ? _buttonLinkdata$title : undefined);
  var randomImage = images !== null && images !== void 0 && images.length ? (_images$Math$floor = images[Math.floor(Math.random() * images.length)]) === null || _images$Math$floor === void 0 ? void 0 : _images$Math$floor.image : null;
  var action = link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link,
    title: buttonTitle !== null && buttonTitle !== void 0 ? buttonTitle : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_Button/* Button */.z, {
      as: "a",
      bg: theme/* theme.colors.secondary */.r.colors.secondary,
      title: buttonTitle !== null && buttonTitle !== void 0 ? buttonTitle : undefined,
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "16",
        height: "9",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
          fill: "none",
          fillRule: "evenodd",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M6.841-.012l9 4.5-9 4.5V4.987H.207v-1h6.634v-4z",
            fill: "currentColor",
            fillRule: "nonzero"
          })
        })
      })
    })
  }) : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BecomeACustomer, {
      title: (_Prismic$text = Prismic/* Prismic.text */.X5.text(title)) !== null && _Prismic$text !== void 0 ? _Prismic$text : '',
      copy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy
      }),
      action: action,
      image: randomImage !== null && randomImage !== void 0 ? randomImage : undefined
    })
  });
};
// EXTERNAL MODULE: ../../packages/slices/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(57866);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3842);
// EXTERNAL MODULE: ../../packages/utils/src/index.ts + 21 modules
var utils_src = __webpack_require__(10688);
// EXTERNAL MODULE: ../../node_modules/use-immer/dist/use-immer.module.js + 1 modules
var use_immer_module = __webpack_require__(54492);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(10081);
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/Appointment/availableDatesAndTimes.ts


var _templateObject;


var availableDatesAndTimes = (0,lib/* gql */.Ps)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query availableDatesAndTimes(\n    $serviceLocationId: String!\n    $consultationId: String!\n    $consultationType: ConsultationType!\n  ) {\n    node(id: $serviceLocationId) {\n      ... on ServiceLocation {\n        type\n        id\n        availableAppointments(\n          consultationServiceId: $consultationId\n          consultationType: $consultationType\n        ) {\n          date\n          time\n        }\n      }\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/reducer.ts

var initialState = {
  service: undefined,
  serviceType: undefined,
  serviceLocationId: undefined,
  date: undefined,
  skipLocation: false,
  reserveAppointmentId: undefined,
  customerInfo: undefined,
  note: undefined
};
var AppointmentReducer = function AppointmentReducer(draft, action) {
  switch (action.type) {
    case 'selectCustomerType':
      {
        draft.customerType = action.customerType;
        draft.serviceType = undefined;
        draft.serviceLocationId = undefined;
        draft.date = undefined;
        draft.skipLocation = false;
        draft.service = undefined;
        draft.reserveAppointmentId = undefined;
        return;
      }

    case 'selectService':
      {
        draft.serviceType = undefined;
        draft.serviceLocationId = undefined;
        draft.date = undefined;
        draft.skipLocation = false;
        draft.service = action.service;
        draft.reserveAppointmentId = undefined; // types is eather phonecall or meeting. if there only one option we auto select it

        if (action.service && action.service.types.length === 1) {
          var serviceType = action.service.types[0];
          draft.serviceType = serviceType.type; // if there is only one branch to pick, you guessed it, we auto select it

          if (serviceType.availableServiceLocation.length === 1) {
            draft.serviceLocationId = serviceType.availableServiceLocation[0].id; // if there is only one location and this is phone call we hide the locations dropdown

            if (serviceType.type === globalTypes/* ConsultationType.Phonecall */.$q.Phonecall || serviceType.type === globalTypes/* ConsultationType.Videocall */.$q.Videocall) {
              draft.skipLocation = true;
            }
          }
        }

        return;
      }

    case 'selectServiceType':
      {
        var _draft$service;

        draft.serviceLocationId = undefined;
        draft.date = undefined;
        draft.serviceType = action.serviceType;
        draft.skipLocation = false;
        draft.reserveAppointmentId = undefined;
        var type = (_draft$service = draft.service) === null || _draft$service === void 0 ? void 0 : _draft$service.types.find(function (i) {
          return i.type === action.serviceType;
        });

        if (type && type.availableServiceLocation.length === 1) {
          draft.serviceLocationId = type.availableServiceLocation[0].id; // if there is only one location and this is phone call we hide the locations dropdown

          if (type.type === globalTypes/* ConsultationType.Phonecall */.$q.Phonecall || type.type === globalTypes/* ConsultationType.Videocall */.$q.Videocall) {
            draft.skipLocation = true;
          }
        }

        return;
      }

    case 'selectServiceLocationId':
      {
        draft.date = undefined;
        draft.reserveAppointmentId = undefined;
        draft.serviceLocationId = action.serviceLocationId;
        return;
      }

    case 'selectDateAndTime':
      {
        draft.reserveAppointmentId = undefined;
        draft.date = action.date;
        return;
      }

    case 'setReserveAppointmentId':
      {
        draft.reserveAppointmentId = action.id;
        return;
      }

    case 'setCustomerInfo':
      {
        draft.customerInfo = action.customerInfo;
        return;
      }

    case 'setCompanyInfo':
      {
        draft.companyInfo = action.companyInfo;
        return;
      }

    case 'setNote':
      {
        draft.note = action.note;
        return;
      }

    case 'setClearInfo':
      {
        draft.service = undefined;
        draft.serviceType = undefined;
        draft.serviceLocationId = undefined;
        draft.date = undefined;
        draft.skipLocation = false;
        draft.reserveAppointmentId = undefined;
        draft.customerInfo = undefined;
        draft.note = undefined;
        return;
      }

    default:
  }
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/shared/ImageContainer.tsx



var ImageContainer_excluded = ["x"];

function ImageContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ImageContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ImageContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ImageContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ImageContainer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var TitleColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e1shnis42"
} : 0)("margin-bottom:45px;display:flex;justify-content:", function (props) {
  return props.success ? 'space-around' : 'space-between';
}, ";flex-direction:column;padding-top:24px;@media ", devices/* device.tablet */.U.tablet, "{padding-top:100px;margin-bottom:24px;}" + ( true ? "" : 0));

var ImgColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e1shnis41"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var ImageContainer_Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Img,  true ? {
  target: "e1shnis40"
} : 0)( true ? {
  name: "1tr442h",
  styles: "width:100%;height:100%;min-height:740px;max-height:740px;object-fit:cover;transform:translateZ(0px)"
} : 0);

var tempBookAppointmentImage = {
  alt: 'alt texti',
  ar_1_1: {
    alt: null,
    copyright: null,
    dimensions: {
      width: 1920,
      height: 1920
    },
    url: 'https://images.prismic.io/landsbankinn/0d154aff-96d9-430b-985b-92cb8206d356_Landsbankinn_Uloma_V4A0441.png?auto=compress,format&rect=420,0,1080,1080&w=1920&h=1920'
  },
  ar_4_3: {
    alt: null,
    copyright: null,
    dimensions: {
      width: 1920,
      height: 1440
    },
    url: 'https://images.prismic.io/landsbankinn/0d154aff-96d9-430b-985b-92cb8206d356_Landsbankinn_Uloma_V4A0441.png?auto=compress,format&rect=240,0,1440,1080&w=1920&h=1440'
  },
  ar_16_9: {
    alt: null,
    copyright: null,
    dimensions: {
      width: 1920,
      height: 1080
    },
    url: 'https://images.prismic.io/landsbankinn/0d154aff-96d9-430b-985b-92cb8206d356_Landsbankinn_Uloma_V4A0441.png?auto=compress,format&rect=0,0,1920,1080&w=1920&h=1080'
  },
  copyright: null,
  dimensions: {
    width: 1920,
    height: 1080
  },
  url: 'https://images.prismic.io/landsbankinn/0d154aff-96d9-430b-985b-92cb8206d356_Landsbankinn_Uloma_V4A0441.png?auto=compress,format'
};
var ImageContainer = function ImageContainer(_ref) {
  var children = _ref.children,
      reverse = _ref.reverse,
      image = _ref.image,
      onRest = _ref.onRest,
      success = _ref.success;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  var _useSpring = (0,react_spring_esm.useSpring)({
    reverse: reverse,
    onRest: onRest,
    from: {
      opacity: 0,
      x: '100%'
    },
    to: {
      opacity: 1,
      x: '0%'
    },
    config: {
      duration: 300
    }
  }),
      x = _useSpring.x,
      rest = (0,objectWithoutProperties/* default */.Z)(_useSpring, ImageContainer_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleColumn, {
      success: success,
      sm: {
        offset: 1 / 12,
        width: 10 / 12,
        offsetRight: 1 / 12
      },
      md: {
        width: 4 / 12,
        offset: 1 / 12,
        offsetRight: 1 / 12
      },
      children: children
    }), !isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImgColumn, {
      sm: {
        width: 12 / 12
      },
      md: {
        width: 6 / 12
      },
      gutter: 0,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer_Image, {
        style: ImageContainer_objectSpread(ImageContainer_objectSpread({}, rest), {}, {
          transform: x.to(function (x) {
            return "translate3d(".concat(x, ",0,0)");
          })
        }),
        src: image !== null && image !== void 0 ? image : tempBookAppointmentImage,
        ar: 'ar_1_1'
      })
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(33379);
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/Appointment/bookAppointment.ts


var bookAppointment_templateObject;


var BOOK_APPOINTMENT = (0,lib/* gql */.Ps)(bookAppointment_templateObject || (bookAppointment_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation BookAppointment($data: BookAppointmentInput!) {\n    bookAppointment(data: $data) {\n      ... on BookAppointmentPayload {\n        id\n        serviceName\n        activityType\n        startTime\n        branch {\n          name\n        }\n      }\n      ... on Error {\n        error\n      }\n    }\n  }\n"])));
// EXTERNAL MODULE: ../../packages/ui/src/validation/Form.tsx
var Form = __webpack_require__(37330);
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/shared/Title.tsx


function Title_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* Divider */.i,  true ? {
  target: "eu8tvll2"
} : 0)( true ? {
  name: "1a07e8w",
  styles: "margin-bottom:25px"
} : 0);

var StyledTitle = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "eu8tvll1"
} : 0)(typography/* typography.h2 */.cp.h2, " margin-bottom:31px;" + ( true ? "" : 0));

var Title_Body = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "eu8tvll0"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:48px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0px;}" + ( true ? "" : 0));

function Title_Title(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      className = _ref.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: className,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTitle, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {}), subTitle && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title_Body, {
      children: subTitle
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/shared/FormContainer.tsx


function FormContainer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var FormContainer_TitleColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "ejdrwb62"
} : 0)( true ? {
  name: "1vgoj7v",
  styles: "display:flex;flex-direction:column;justify-content:space-between"
} : 0);

var StyledForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Form/* Form */.l,  true ? {
  target: "ejdrwb61"
} : 0)( true ? {
  name: "tinu7p",
  styles: "display:flex;flex-direction:column;height:100%;justify-content:space-between"
} : 0);

var BackButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "ejdrwb60"
} : 0)("width:100%;display:flex;align-self:flex-start;margin-top:24px;@media ", devices/* device.tablet */.U.tablet, "{width:initial;margin-top:0px;}" + ( true ? "" : 0));

function FormContainer(_ref) {
  var onBack = _ref.onBack,
      onSubmit = _ref.onSubmit,
      children = _ref.children,
      title = _ref.title,
      copy = _ref.copy;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormContainer_TitleColumn, {
      sm: {
        offset: 1 / 12,
        width: 10 / 12
      },
      md: {
        width: 4 / 12,
        offset: 1 / 12,
        offsetRight: 2 / 12
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title_Title, {
          title: title !== '' ? title : 'Panta tíma',
          subTitle: copy !== '' ? copy : 'Sérfræðingar okkar taka vel á móti þér í viðtalstíma. Veldu þá þjónustu sem hentar þér.'
        })
      }), !isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackButton, {
        title: "Til baka",
        onClick: onBack,
        bordered: true,
        bg: theme/* theme.colors.primary */.r.colors.primary
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
      sm: {
        width: 10 / 12,
        offset: 1 / 12
      },
      md: {
        width: 4 / 12,
        offsetRight: 1 / 12
      },
      style: {
        position: 'relative'
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledForm, {
        onSubmit: onSubmit,
        children: [children, isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackButton, {
          title: "Til baka",
          onClick: onBack,
          bordered: true,
          bg: theme/* theme.colors.primary */.r.colors.primary
        })]
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/shared/InputContainer.tsx



var InputContainer_excluded = ["x"];

function InputContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function InputContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InputContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InputContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function InputContainer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var InputHost = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1pz8ufl0"
} : 0)( true ? {
  name: "1afhs1n",
  styles: "display:flex;flex-direction:column;&>div{margin-bottom:20px;}"
} : 0);

function InputContainer(_ref) {
  var children = _ref.children,
      className = _ref.className;
  var items = react.Children.toArray(children);
  var trail = (0,react_spring_esm.useTrail)(items.length, {
    config: {
      mass: 2,
      tension: 2000,
      friction: 200
    },
    from: {
      opacity: 0,
      x: 400
    },
    to: {
      opacity: 1,
      x: 0
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputHost, {
    className: className,
    children: trail.map(function (_ref2, index) {
      var x = _ref2.x,
          rest = (0,objectWithoutProperties/* default */.Z)(_ref2, InputContainer_excluded);

      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_spring_esm.animated.div, {
        style: InputContainer_objectSpread(InputContainer_objectSpread({}, rest), {}, {
          transform: x.to(function (x) {
            return "translate3d(".concat(x, "px,0,0)");
          })
        }),
        children: items[index]
      }, index);
    })
  });
}
// EXTERNAL MODULE: ../../packages/ui/src/validation/useEmailValidation.ts
var useEmailValidation = __webpack_require__(90152);
// EXTERNAL MODULE: ../../packages/ui/src/components/form/Input.tsx
var Input = __webpack_require__(51250);
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/CustomerInfo/EmailInput.tsx




function EmailInput(_ref) {
  var placeholder = _ref.placeholder,
      value = _ref.value,
      _onChange = _ref.onChange;

  var _useEmailValidation = (0,useEmailValidation/* useEmailValidation */.$)(value),
      _useEmailValidation2 = (0,slicedToArray/* default */.Z)(_useEmailValidation, 3),
      ref = _useEmailValidation2[0],
      isValid = _useEmailValidation2[1],
      errorMessage = _useEmailValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
    labelVariant: "aboveInput",
    variant: "noBorder",
    errorMessageVariant: "insideInput",
    inputRef: ref,
    errorMessage: errorMessage,
    "aria-required": true,
    label: placeholder,
    value: value,
    isValid: isValid,
    onChange: function onChange(e) {
      return _onChange(e.currentTarget.value);
    }
  });
}
// EXTERNAL MODULE: ../../packages/ui/src/validation/useInputValidation.ts
var useInputValidation = __webpack_require__(46309);
// EXTERNAL MODULE: ../../packages/ui/src/components/form/contact-input/Kennitalanput.tsx
var Kennitalanput = __webpack_require__(90917);
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/CustomerInfo/KennitalaInput.tsx



function KennitalaInput_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var res = {
  kennitalaNotFound: {
    is: 'Kennitala finnst ekki í þjóðskrá',
    en: 'Id. No. not found'
  },
  errorMessage: {
    is: 'Kennitala er ekki á réttu formi'
  }
};

var KennitalaInput_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "esotffu0"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

function KennitalaInput(_ref) {
  var placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      value = _ref.value,
      kennitalaNotFound = _ref.kennitalaNotFound;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(value, [{
    validation: function validation(val) {
      return !!val && val.length === 10;
    },
    message: r(res.errorMessage)
  }, {
    validation: function validation() {
      return !kennitalaNotFound;
    },
    message: r(res.kennitalaNotFound)
  }], [kennitalaNotFound]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 3),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1],
      errorMessage = _useInputValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KennitalaInput_Host, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Kennitalanput/* KennitalaInput */.t, {
      variant: "noBorder",
      labelVariant: "aboveInput",
      errorMessageVariant: "insideInput",
      errorMessage: errorMessage,
      "aria-required": true,
      inputRef: ref,
      label: placeholder,
      value: value,
      type: "tel",
      isValid: isValid,
      onChange: function onChange(e) {
        return _onChange(e.currentTarget.value.replace('-', ''));
      }
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/CustomerInfo/CustomerInfo.res.ts
/* harmony default export */ var CustomerInfo_res = ({
  submit: {
    is: 'Panta tíma',
    en: 'Make an appointment'
  },
  continue: {
    is: 'Áfram',
    en: 'Continue'
  },
  phoneErrorMessage: {
    is: 'Símanúmer er ekki á réttu formi'
  },
  emailErrorMessage: {
    is: 'Netfang er ekki á réttu formi'
  },
  nameErrorMessage: {
    is: 'Nafn verður að vera útfyllt',
    en: 'Name is a required.'
  },
  additionalCustomer: {
    is: 'Mæti með maka',
    en: 'With spouse'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/CustomerInfo/NameInput.tsx






function NameInput(_ref) {
  var placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      value = _ref.value;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(value, [{
    validation: function validation(val) {
      return !!val && val.length > 0;
    },
    message: r(CustomerInfo_res.nameErrorMessage)
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 3),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1],
      errorMessage = _useInputValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
    labelVariant: "aboveInput",
    errorMessageVariant: "insideInput",
    errorMessage: errorMessage,
    "aria-required": true,
    variant: "noBorder",
    inputRef: ref,
    label: placeholder,
    value: value,
    isValid: isValid,
    onChange: function onChange(e) {
      _onChange(e.currentTarget.value);
    }
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/CustomerInfo/PhoneInput.tsx






function PhoneInput(_ref) {
  var placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      value = _ref.value;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(value, [{
    validation: function validation(val) {
      return !!val && val.length >= 7 && /^\+?\d+$/.test(val);
    },
    message: r(CustomerInfo_res.phoneErrorMessage)
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 3),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1],
      errorMessage = _useInputValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
    labelVariant: "aboveInput",
    errorMessageVariant: "insideInput",
    errorMessage: errorMessage,
    "aria-required": true,
    variant: "noBorder",
    inputRef: ref,
    label: placeholder,
    value: value,
    isValid: isValid,
    onChange: function onChange(e) {
      _onChange(e.currentTarget.value);
    }
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/CustomerInfo/CompanyInfo/CompanyInfo.res.ts
/* harmony default export */ var CompanyInfo_res = ({
  companyKennitala: {
    is: 'Kennitala fyrirtækis',
    en: 'Company Id. No.'
  },
  continue: {
    is: 'Áfram',
    en: 'Continue'
  },
  name: {
    is: 'Nafn tengiliðs'
  },
  email: {
    is: 'Netfang tengiliðs'
  },
  phonenumber: {
    is: 'Símanúmer tengiliðs'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/CustomerInfo/CompanyInfo/CompanyInfo.tsx


function CompanyInfo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CompanyInfo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CompanyInfo_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CompanyInfo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












function CompanyInfo() {
  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useAppointmentContex = useAppointmentContext(),
      state = _useAppointmentContex.state,
      dispatch = _useAppointmentContex.dispatch;

  var companyInfo = state.companyInfo;

  var setCompanyInfo = function setCompanyInfo(companyInfo) {
    return dispatch === null || dispatch === void 0 ? void 0 : dispatch({
      type: 'setCompanyInfo',
      companyInfo: companyInfo
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InputContainer, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KennitalaInput, {
      placeholder: r(CompanyInfo_res.companyKennitala),
      value: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.kennitala,
      onChange: function onChange(kennitala) {
        setCompanyInfo(CompanyInfo_objectSpread(CompanyInfo_objectSpread({}, companyInfo), {}, {
          kennitala: kennitala
        }));
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NameInput, {
      placeholder: r(CompanyInfo_res.name),
      value: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.contactName,
      onChange: function onChange(contactName) {
        return setCompanyInfo(CompanyInfo_objectSpread(CompanyInfo_objectSpread({}, companyInfo), {}, {
          contactName: contactName
        }));
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailInput, {
      placeholder: r(CompanyInfo_res.email),
      value: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.contactEmail,
      onChange: function onChange(contactEmail) {
        return setCompanyInfo(CompanyInfo_objectSpread(CompanyInfo_objectSpread({}, companyInfo), {}, {
          contactEmail: contactEmail
        }));
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneInput, {
      placeholder: r(CompanyInfo_res.phonenumber),
      value: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.contactPhone,
      onChange: function onChange(contactPhone) {
        return setCompanyInfo(CompanyInfo_objectSpread(CompanyInfo_objectSpread({}, companyInfo), {}, {
          contactPhone: contactPhone
        }));
      }
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/CustomerInfo/PersonInfo/PersonInfo.res.ts
/* harmony default export */ var PersonInfo_res = ({
  name: {
    is: 'Nafn',
    en: 'Name'
  },
  kennitala: {
    is: 'Kennitala',
    en: 'Id. No.'
  },
  email: {
    is: 'Netfang',
    en: 'Email address'
  },
  phonenumer: {
    is: 'Sími',
    en: 'Phone number'
  },
  withSpouse: {
    is: 'Ég mæti með maka',
    en: 'I will bring my spouse'
  },
  continue: {
    is: 'Áfram',
    en: 'Continue'
  },
  spouseName: {
    is: 'Nafn maka',
    en: 'Name of spouse'
  },
  spouseKennitala: {
    is: 'Kennitala maka',
    en: 'Id. No. of spouse'
  },
  spouseEmail: {
    is: 'Netfang maka',
    en: 'Email address of spouse'
  },
  spousePhonenumer: {
    is: 'Sími maka',
    en: 'Phone number of spuse'
  },
  kennitalaNotFound: {
    is: 'Kennitala finnst ekki í þjóðskrá'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/CustomerInfo/PersonInfo/PersonInfo.tsx


function PersonInfo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PersonInfo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PersonInfo_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PersonInfo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













function PersonInfo(_ref) {
  var _customerInfo$additio, _customerInfo$additio2, _customerInfo$additio3, _customerInfo$additio4;

  var setKennitalaNotFound = _ref.setKennitalaNotFound,
      kennitalaNotFound = _ref.kennitalaNotFound;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useAppointmentContex = useAppointmentContext(),
      state = _useAppointmentContex.state,
      dispatch = _useAppointmentContex.dispatch,
      currentStep = _useAppointmentContex.currentStep;

  var customerInfo = state.customerInfo;

  var setCustomerInfo = function setCustomerInfo(customerInfo) {
    console.log(customerInfo);
    dispatch === null || dispatch === void 0 ? void 0 : dispatch({
      type: 'setCustomerInfo',
      customerInfo: customerInfo
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InputContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NameInput, {
        placeholder: currentStep === AppointmentStep.AdditionalCustomer ? r(PersonInfo_res.spouseName) : r(PersonInfo_res.name),
        value: currentStep === AppointmentStep.AdditionalCustomer ? customerInfo === null || customerInfo === void 0 ? void 0 : (_customerInfo$additio = customerInfo.additionalCustomer) === null || _customerInfo$additio === void 0 ? void 0 : _customerInfo$additio.name : customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.name,
        onChange: function onChange(name) {
          return currentStep === AppointmentStep.AdditionalCustomer ? setCustomerInfo(PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo), {}, {
            additionalCustomer: PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.additionalCustomer), {}, {
              name: name
            })
          })) : setCustomerInfo(PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo), {}, {
            name: name
          }));
        }
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KennitalaInput, {
        placeholder: currentStep === AppointmentStep.AdditionalCustomer ? r(PersonInfo_res.spouseKennitala) : r(PersonInfo_res.kennitala),
        value: currentStep === AppointmentStep.AdditionalCustomer ? customerInfo === null || customerInfo === void 0 ? void 0 : (_customerInfo$additio2 = customerInfo.additionalCustomer) === null || _customerInfo$additio2 === void 0 ? void 0 : _customerInfo$additio2.kennitala : customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.kennitala,
        kennitalaNotFound: kennitalaNotFound,
        onChange: function onChange(kennitala) {
          if (kennitalaNotFound) {
            setKennitalaNotFound(false);
          }

          setCustomerInfo(currentStep === AppointmentStep.AdditionalCustomer ? PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo), {}, {
            additionalCustomer: PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.additionalCustomer), {}, {
              kennitala: kennitala
            })
          }) : PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo), {}, {
            kennitala: kennitala
          }));
        }
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailInput, {
        placeholder: currentStep === AppointmentStep.AdditionalCustomer ? r(PersonInfo_res.spouseEmail) : r(PersonInfo_res.email),
        value: currentStep === AppointmentStep.AdditionalCustomer ? customerInfo === null || customerInfo === void 0 ? void 0 : (_customerInfo$additio3 = customerInfo.additionalCustomer) === null || _customerInfo$additio3 === void 0 ? void 0 : _customerInfo$additio3.email : customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.email,
        onChange: function onChange(email) {
          return currentStep === AppointmentStep.AdditionalCustomer ? setCustomerInfo(PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo), {}, {
            additionalCustomer: PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.additionalCustomer), {}, {
              email: email
            })
          })) : setCustomerInfo(PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo), {}, {
            email: email
          }));
        }
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneInput, {
        placeholder: currentStep === AppointmentStep.AdditionalCustomer ? r(PersonInfo_res.spousePhonenumer) : r(PersonInfo_res.phonenumer),
        value: currentStep === AppointmentStep.AdditionalCustomer ? customerInfo === null || customerInfo === void 0 ? void 0 : (_customerInfo$additio4 = customerInfo.additionalCustomer) === null || _customerInfo$additio4 === void 0 ? void 0 : _customerInfo$additio4.phone : customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.phone,
        onChange: function onChange(phone) {
          return currentStep === AppointmentStep.AdditionalCustomer ? setCustomerInfo(PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo), {}, {
            additionalCustomer: PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.additionalCustomer), {}, {
              phone: phone
            })
          })) : setCustomerInfo(PersonInfo_objectSpread(PersonInfo_objectSpread({}, customerInfo), {}, {
            phone: phone
          }));
        }
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/CustomerInfo/CustomerInfo.tsx



function CustomerInfo_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "et60wl21"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var Margin = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "et60wl20"
} : 0)( true ? {
  name: "1azpx8r",
  styles: "margin-bottom:20px"
} : 0);

function CustomerInfo(_ref) {
  var _state$service;

  var setSuccessData = _ref.setSuccessData,
      title = _ref.title,
      copy = _ref.copy;

  var _useAppointmentContex = useAppointmentContext(),
      state = _useAppointmentContex.state,
      setCurrentStep = _useAppointmentContex.setCurrentStep,
      currentStep = _useAppointmentContex.currentStep;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useResource2 = (0,src/* useResource */.Wf)(),
      locale = _useResource2.locale;

  var _useState = (0,react.useState)(false),
      kennitalaNotFound = _useState[0],
      setKennitalaNotFound = _useState[1];

  var _useMutation = (0,useMutation/* useMutation */.D)(BOOK_APPOINTMENT, {
    client: client,
    onCompleted: function onCompleted(data) {
      if (data.bookAppointment.__typename === 'BookAppointmentPayload') {
        setSuccessData(data.bookAppointment);
        setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(AppointmentStep.Success);
      }

      if (data.bookAppointment.__typename === 'KennitalaNotFoundError') {
        setKennitalaNotFound(true);
      }
    },
    context: {
      headers: {
        'Accept-Language': locale === 'is' ? 'is' : 'en-GB'
      }
    }
  }),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 2),
      bookAppointment = _useMutation2[0],
      loading = _useMutation2[1].loading;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormContainer, {
    onBack: function onBack() {
      currentStep === AppointmentStep.AdditionalCustomer ? setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(AppointmentStep.CustomerInfo) : setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(AppointmentStep.SelectDateAndTime);
    },
    onSubmit: function onSubmit() {
      bookAppointment({
        variables: {
          data: state.customerType === globalTypes/* SmartBookingCustomerType.Company */.hn.Company ? {
            comment: state.note,
            reservationId: state.reserveAppointmentId,
            company: state.companyInfo
          } : {
            comment: state.note,
            customer: state.customerInfo,
            reservationId: state.reserveAppointmentId
          }
        }
      });
    },
    title: title,
    copy: copy,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [state.customerType === globalTypes/* SmartBookingCustomerType.Company */.hn.Company && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyInfo, {}), state.customerType === globalTypes/* SmartBookingCustomerType.Person */.hn.Person && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonInfo, {
        kennitalaNotFound: kennitalaNotFound,
        setKennitalaNotFound: setKennitalaNotFound
      }), ((_state$service = state.service) === null || _state$service === void 0 ? void 0 : _state$service.allowAdditionalCustomer) && currentStep === AppointmentStep.CustomerInfo && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Margin, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
          type: "submit",
          onClick: function onClick(e) {
            e.preventDefault();
            setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(AppointmentStep.AdditionalCustomer);
            return false;
          },
          title: r(CustomerInfo_res.additionalCustomer),
          loading: loading,
          bg: theme/* theme.colors.primary */.r.colors.primary
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
        type: "submit",
        title: r(CustomerInfo_res.submit),
        loading: loading,
        bg: theme/* theme.colors.primary */.r.colors.primary
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/Intro/Intro.res.ts
/* harmony default export */ var Intro_res = ({
  person: {
    is: 'Einstaklingsþjónusta',
    en: 'Personal banking service'
  },
  corporate: {
    is: 'Fyrirtækjaþjónusta',
    en: 'Corporate banking service'
  },
  bookAppointment: {
    is: 'Panta tíma',
    en: 'Make an appointment'
  },
  subTitle: {
    is: 'Sérfræðingar okkar taka vel á móti þér í viðtalstíma. Veldu þá þjónustu sem hentar þér'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/Intro/Intro.tsx


function Intro_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var Intro_StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "exsmfkp0"
} : 0)( true ? {
  name: "1nxi5ed",
  styles: "width:100%;margin-bottom:28px"
} : 0);

function Intro_Intro(_ref) {
  var defaultCustomerType = _ref.defaultCustomerType,
      image = _ref.image,
      title = _ref.title,
      copy = _ref.copy;

  var _useState = (0,react.useState)(false),
      animate = _useState[0],
      toggle = _useState[1];

  var _useAppointmentContex = useAppointmentContext(),
      setCurrentStep = _useAppointmentContex.setCurrentStep,
      dispatch = _useAppointmentContex.dispatch;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ImageContainer, {
    image: image,
    reverse: animate,
    onRest: function onRest() {
      if (animate) {
        setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(AppointmentStep.SelectService);
      }
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title_Title, {
      title: title !== null && title !== void 0 ? title : r(Intro_res.bookAppointment),
      subTitle: copy !== null && copy !== void 0 ? copy : r(Intro_res.subTitle)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [defaultCustomerType && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Intro_StyledButton, {
        title: r(Intro_res.bookAppointment),
        bg: theme/* theme.colors.primary */.r.colors.primary,
        onClick: function onClick() {
          if (dispatch) {
            dispatch({
              type: 'selectCustomerType',
              customerType: defaultCustomerType
            });
          }

          toggle(true);
        }
      }), !defaultCustomerType && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Intro_StyledButton, {
          title: r(Intro_res.person),
          bg: theme/* theme.colors.primary */.r.colors.primary,
          onClick: function onClick() {
            if (dispatch) {
              dispatch({
                type: 'selectCustomerType',
                customerType: globalTypes/* SmartBookingCustomerType.Person */.hn.Person
              });
            }

            toggle(true);
          }
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Intro_StyledButton, {
          title: r(Intro_res.corporate),
          bordered: true,
          bg: theme/* theme.colors.primary */.r.colors.primary,
          onClick: function onClick() {
            if (dispatch) {
              dispatch({
                type: 'selectCustomerType',
                customerType: globalTypes/* SmartBookingCustomerType.Company */.hn.Company
              });
            }

            toggle(true);
          }
        })]
      })]
    })]
  });
}
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(6804);
// EXTERNAL MODULE: ../../packages/ui/src/components/form/Label.tsx
var Label = __webpack_require__(92527);
;// CONCATENATED MODULE: ../../packages/ui/src/components/form/contact-input/TextInput.tsx



var TextInput_excluded = ["label", "inputSize", "id", "isValid", "errorMessage", "placeholder", "setHeight", "variant"];

function TextInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TextInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TextInput_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TextInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var TextArea = (0,emotion_styled_base_browser_esm/* default */.Z)("textarea",  true ? {
  target: "elao2ij0"
} : 0)(Input/* inputCss */.u3, ";padding:20px 20px 12px 15px;", function (props) {
  return props.inputSize === 'small' ? typography/* typography.numbers */.cp.numbers(props) : props.inputSize === 'big' ? typography/* typography.input */.cp.input(props) : typography/* typography.input2 */.cp.input2(props);
}, ";resize:none;outline:none;::placeholder{color:", function (props) {
  return props.theme.shades.primary2;
}, ";}", function (props) {
  return props.setHeight ? "height:".concat(props.setHeight) : '';
}, ";" + ( true ? "" : 0));

function TextInput(_ref) {
  var label = _ref.label,
      inputSize = _ref.inputSize,
      id = _ref.id,
      isValid = _ref.isValid,
      errorMessage = _ref.errorMessage,
      placeholder = _ref.placeholder,
      setHeight = _ref.setHeight,
      variant = _ref.variant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TextInput_excluded);

  var _useState = (0,react.useState)((0,v4/* default */.Z)()),
      uuid = _useState[0];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Input/* InputHost */.IX, {
    children: [label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label/* Label */.__, {
      size: inputSize,
      htmlFor: id !== null && id !== void 0 ? id : uuid,
      children: label
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextArea, TextInput_objectSpread({
      id: id !== null && id !== void 0 ? id : uuid,
      isValid: isValid !== false,
      variant: variant,
      inputSize: inputSize,
      setHeight: setHeight,
      placeholder: placeholder
    }, rest)), isValid === false && errorMessage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label/* ErrorLabel */.hW, {
      size: inputSize,
      children: errorMessage
    })]
  });
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(82276);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isSameMinute/index.js
var isSameMinute = __webpack_require__(86544);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(10405);
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/Appointment/reserveAppointment.ts


var reserveAppointment_templateObject;


var RESERVE_APPOINTMENT = (0,lib/* gql */.Ps)(reserveAppointment_templateObject || (reserveAppointment_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation ReserveAppointment(\n    $serviceLocationId: String!\n    $date: DateTime!\n    $consultationType: ConsultationType!\n    $consultationServiceServiceId: String!\n  ) {\n    reserveAppointment(\n      data: {\n        serviceLocationId: $serviceLocationId\n        date: $date\n        consultationType: $consultationType\n        consultationServiceServiceId: $consultationServiceServiceId\n      }\n    ) {\n      id\n    }\n  }\n"])));
// EXTERNAL MODULE: ../../packages/ui/src/components/form/date-input/DateInput.tsx + 1 modules
var DateInput = __webpack_require__(43032);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/set/index.js
var set = __webpack_require__(44958);
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/SelectDateAndTime/SelectDateAndTime.res.ts
/* harmony default export */ var SelectDateAndTime_res = ({
  pickDate: {
    is: 'Veldu dagsetningu',
    en: 'Select date'
  },
  continue: {
    is: 'Áfram',
    en: 'Continue'
  },
  comment: {
    is: 'Athugasemd',
    en: 'Comment'
  },
  pickTime: {
    is: 'Veldu tíma',
    en: 'Select time'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/SelectDateAndTime/DateInput.tsx








function DateInput_DateInput(_ref) {
  var _state$date;

  var setSelectedTime = _ref.setSelectedTime,
      availableDates = _ref.availableDates;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useAppointmentContex = useAppointmentContext(),
      state = _useAppointmentContex.state,
      dispatch = _useAppointmentContex.dispatch;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(state === null || state === void 0 ? void 0 : (_state$date = state.date) === null || _state$date === void 0 ? void 0 : _state$date.toString(), [{
    validation: function validation(value) {
      return value !== undefined;
    }
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 2),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateInput/* DateInput */.W, {
    isValid: isValid,
    id: "appointmentDate",
    variant: "noBorder",
    label: r(SelectDateAndTime_res.pickDate),
    labelVariant: "aboveInput",
    errorMessageVariant: "insideInput",
    inputSize: "big",
    includeDates: availableDates,
    value: state.date,
    onChange: function onChange(date) {
      setSelectedTime(undefined);
      dispatch === null || dispatch === void 0 ? void 0 : dispatch({
        type: 'selectDateAndTime',
        date: (0,set/* default */.Z)(date, {
          hours: 0,
          minutes: 0,
          seconds: 0
        })
      });
    }
  });
}
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 7 modules
var polished_esm = __webpack_require__(74704);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/react-select.esm.js
var react_select_esm = __webpack_require__(31776);
// EXTERNAL MODULE: ../../node_modules/react-select/creatable/dist/react-select.esm.js
var dist_react_select_esm = __webpack_require__(54319);
;// CONCATENATED MODULE: ../../packages/ui/src/components/form/dropdown/Dropdown.tsx

















var Dropdown_InputHost = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1h7nd5x2"
} : 0)("display:flex;position:relative;flex-direction:column;width:100%;&>*+*{margin-top:8px;}&:hover>label{color:", function (_ref) {
  var _theme$shades$primary;

  var theme = _ref.theme;
  return (0,polished_esm/* rgba */.m4)((_theme$shades$primary = theme.shades.primary5) !== null && _theme$shades$primary !== void 0 ? _theme$shades$primary : '', 1);
}, ";}" + ( true ? "" : 0));

var prefix = 'react-select';

var ReactSelect = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_select_esm/* default */.ZP,  true ? {
  target: "e1h7nd5x1"
} : 0)(".", prefix, "__control{border-width:0;", function (_ref2) {
  var _theme$colors$foregro;

  var variant = _ref2.variant,
      theme = _ref2.theme;
  return variant === 'fullBorder' && "box-shadow: 0 0 0 1px\n        ".concat((0,polished_esm/* rgba */.m4)((_theme$colors$foregro = theme === null || theme === void 0 ? void 0 : theme.colors.foreground) !== null && _theme$colors$foregro !== void 0 ? _theme$colors$foregro : '', 0.7), ";\n        ");
}, ";", function (_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme,
      currentTheme = _ref3.currentTheme;
  return variant === 'bottomBorder' && "border-bottom: 1px solid\n        ".concat((0,polished_esm/* rgba */.m4)(theme.colors[currentTheme], 0.7));
}, ";", function (_ref4) {
  var theme = _ref4.theme,
      isValid = _ref4.isValid;
  return isValid === false && "box-shadow: 0 0 0 2px ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.secondary);
}, ";border-radius:0;background-color:", function (props) {
  return props.fill ? (0,polished_esm/* rgba */.m4)(props.theme.colors[props.currentTheme], 0.3) : '#fff';
}, ";.", prefix, "__single-value{width:100%;top:initial;bottom:initial;transform:none;margin-left:0;margin-right:0;text-align:", function (_ref5) {
  var inputSize = _ref5.inputSize;
  return inputSize !== 'small' ? 'left' : 'center';
}, ";color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.shades.primary5;
}, ";}&::before{content:'';width:12px;height:12px;background:", function (props) {
  return "linear-gradient(\n        to bottom right,\n        transparent 0%,\n        transparent 50%,\n        ".concat((0,polished_esm/* rgba */.m4)(props.theme.colors[props.currentTheme], 0.3), " 50%,\n        ").concat((0,polished_esm/* rgba */.m4)(props.theme.colors[props.currentTheme], 0.3), " 100%\n      )");
}, ";top:-6px;left:", function (_ref7) {
  var indicatorPosition = _ref7.indicatorPosition;
  return indicatorPosition === 'right' ? "calc(75% - 6px)" : indicatorPosition === 'left' ? "calc(25% - 6px)" : "calc(50% - 6px)";
}, ";transform:rotate(224deg);position:absolute;display:", function (props) {
  return props.fill ? 'block' : 'none';
}, ";}&:active{box-shadow:0 0 0 2px ", function (_ref8) {
  var theme = _ref8.theme;
  return theme.shades.primary3;
}, ";}}.", prefix, "__menu{min-width:200px;text-align:left;z-index:99;}.", prefix, "__indicator-separator{display:none;}.", prefix, "__indicator{width:0;height:0;border:solid;border-width:0 1px 1px 0;transform:rotate(45deg);border-color:", function (_ref9) {
  var isValid = _ref9.isValid;
  return isValid === false ? theme/* theme.colors.secondary */.r.colors.secondary : theme/* theme.colors.foreground */.r.colors.foreground;
}, ";padding:5px;margin-right:19px;}.", prefix, "__indicator svg{display:none;}.", prefix, "__value-container{height:", function (_ref10) {
  var inputSize = _ref10.inputSize;
  return inputSize === 'small' ? '40px' : '64px';
}, ";padding-left:15px;justify-content:flex-start;", typography/* typography.numbers2 */.cp.numbers2, ";color:", function (_ref11) {
  var theme = _ref11.theme;
  return theme.shades.primary5;
}, ";}.", prefix, "__placeholder{color:", function (_ref12) {
  var _theme$shades$primary2;

  var theme = _ref12.theme;
  return (0,polished_esm/* rgba */.m4)((_theme$shades$primary2 = theme.shades.primary5) !== null && _theme$shades$primary2 !== void 0 ? _theme$shades$primary2 : '', 0.5);
}, ";display:none;margin:0;bottom:12px;top:initial;transform:none;", function (props) {
  return props.isValid === false && "\n          color: ".concat(theme/* theme */.r === null || theme/* theme */.r === void 0 ? void 0 : theme/* theme.colors.secondary */.r.colors.secondary, ";\n          \n        ");
}, ";}.", prefix, "__control--is-disabled{", function (_ref13) {
  var _theme$colors$foregro2;

  var variant = _ref13.variant,
      theme = _ref13.theme;
  return variant === 'fullBorder' && "box-shadow: 0 0 0 1px\n        ".concat((0,polished_esm/* rgba */.m4)((_theme$colors$foregro2 = theme === null || theme === void 0 ? void 0 : theme.colors.foreground) !== null && _theme$colors$foregro2 !== void 0 ? _theme$colors$foregro2 : '', 0.3), ";\n        ");
}, ";background-color:", function (_ref14) {
  var theme = _ref14.theme;
  return (0,polished_esm/* rgba */.m4)(theme.colors.foreground, 0.05);
}, ";}" + ( true ? "" : 0));

var ReactCreateble = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist_react_select_esm/* default */.ZP,  true ? {
  target: "e1h7nd5x0"
} : 0)(".", prefix, "__control{border:none;border-bottom:1px solid ", function (props) {
  return props.theme.colors[props.currentTheme];
}, ";border-radius:0;background-color:", function (props) {
  return props.fill ? (0,polished_esm/* rgba */.m4)(props.theme.colors[props.currentTheme], 0.3) : 'transparent';
}, ";}.", prefix, "__menu{min-width:200px;text-align:left;z-index:99;}.", prefix, "__indicator-separator{display:none;}.", prefix, "__indicator{width:0;height:0;border-style:solid;border-width:6px 6px 0 6px;border-color:rgb(30, 60, 90) transparent transparent transparent;padding:0;margin-right:5px;}.", prefix, "__indicator svg{display:none;}.", prefix, "__value-container{justify-content:center;padding:8px;", typography/* typography.numbers */.cp.numbers, ";&>div:last-child{padding:0px;margin:0px;}}" + ( true ? "" : 0));

var Dropdown = /*#__PURE__*/(0,react.forwardRef)(function Ddown(_ref15, ref) {
  var options = _ref15.options,
      _ref15$theme = _ref15.theme,
      theme = _ref15$theme === void 0 ? 'primary' : _ref15$theme,
      fill = _ref15.fill,
      _onChange = _ref15.onChange,
      value = _ref15.value,
      buildOption = _ref15.buildOption,
      placeholder = _ref15.placeholder,
      isOptionDisabled = _ref15.isOptionDisabled,
      label = _ref15.label,
      createble = _ref15.createble,
      onCreateOption = _ref15.onCreateOption,
      formatCreateLabel = _ref15.formatCreateLabel,
      isValidNewOption = _ref15.isValidNewOption,
      _ref15$indicatorPosit = _ref15.indicatorPosition,
      indicatorPosition = _ref15$indicatorPosit === void 0 ? 'center' : _ref15$indicatorPosit,
      isValid = _ref15.isValid,
      _ref15$labelVariant = _ref15.labelVariant,
      labelVariant = _ref15$labelVariant === void 0 ? 'aboveInput' : _ref15$labelVariant,
      _ref15$variant = _ref15.variant,
      variant = _ref15$variant === void 0 ? 'fullBorder' : _ref15$variant,
      inputSize = _ref15.inputSize,
      errorMessage = _ref15.errorMessage,
      _ref15$errorMessageVa = _ref15.errorMessageVariant,
      errorMessageVariant = _ref15$errorMessageVa === void 0 ? 'belowInput' : _ref15$errorMessageVa,
      isDisabled = _ref15.isDisabled,
      components = _ref15.components;

  var _useState = (0,react.useState)((0,v4/* default */.Z)()),
      uuid = _useState[0];

  var _useState2 = (0,react.useState)(false),
      visited = _useState2[0],
      setVisited = _useState2[1];

  var _useMeasure = (0,web/* default */.Z)({
    polyfill: resize_observer/* ResizeObserver */["do"]
  }),
      _useMeasure2 = (0,slicedToArray/* default */.Z)(_useMeasure, 2),
      hostRef = _useMeasure2[0],
      bounds = _useMeasure2[1];

  var _useState3 = (0,react.useState)(value),
      selectedValue = _useState3[0],
      setSelectedValue = _useState3[1];

  var formContext = (0,react.useContext)(Form/* FormContext */.q);
  var showValidState = (0,react.useMemo)(function () {
    return formContext.validate && !isValid || visited && selectedValue !== undefined;
  }, [visited, isValid, selectedValue, formContext.validate]);
  (0,react.useEffect)(function () {
    setSelectedValue(value);
  }, [value]);
  (0,react.useEffect)(function () {
    if (options.length === 1) {
      _onChange(buildOption(options[0], true, 0), {});
    }
  }, [buildOption, _onChange, options]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dropdown_InputHost, {
    ref: hostRef,
    children: [label && labelVariant === 'aboveInput' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label/* Label */.__, {
      size: inputSize,
      htmlFor: uuid,
      children: label
    }), !createble ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReactSelect, {
        ref: ref,
        indicatorPosition: indicatorPosition,
        placeholder: labelVariant === 'aboveInput' ? placeholder : undefined,
        fill: fill,
        currentTheme: theme,
        options: options.map(function (x) {
          return buildOption(x, true, bounds.width);
        }),
        classNamePrefix: prefix,
        value: selectedValue === undefined ? null : buildOption(selectedValue, false, bounds.width),
        onChange: function onChange(val, meta) {
          var item = options.find(function (x) {
            var _buildOption;

            return ((_buildOption = buildOption(x, true, bounds.width)) === null || _buildOption === void 0 ? void 0 : _buildOption['value']) === (val === null || val === void 0 ? void 0 : val['value']);
          });

          _onChange(val, meta);

          setSelectedValue(item);
        },
        inputId: uuid,
        isValid: showValidState ? isValid : undefined,
        isSearchable: false,
        isDisabled: isDisabled === undefined ? options.length === 1 : isDisabled,
        isOptionDisabled: isOptionDisabled,
        variant: variant,
        onFocus: function onFocus() {
          return setVisited(true);
        },
        inputSize: inputSize,
        openMenuOnFocus: true,
        components: components
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label/* AnimatedErrorLabel */.P3, {
        visible: isValid === false,
        id: uuid,
        errorMessage: errorMessage
      })]
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReactCreateble, {
      inputId: uuid,
      placeholder: placeholder,
      fill: fill,
      currentTheme: theme,
      options: options.map(function (x) {
        return buildOption(x, true, bounds.width);
      }),
      classNamePrefix: prefix,
      value: buildOption(selectedValue, false, bounds.width),
      onChange: function onChange(val, meta) {
        _onChange(val, meta);
      },
      formatCreateLabel: formatCreateLabel,
      onCreateOption: onCreateOption,
      createOptionPosition: "first",
      isValidNewOption: isValidNewOption
    })]
  });
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/SelectDateAndTime/TimeDropdown.tsx








function TimeDropdown(_ref) {
  var data = _ref.data,
      selectedTime = _ref.selectedTime,
      setSelectedTime = _ref.setSelectedTime;

  var _useAppointmentContex = useAppointmentContext(),
      dispatch = _useAppointmentContex.dispatch,
      state = _useAppointmentContex.state;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var timeOptions = (0,react.useMemo)(function () {
    if (state.date && data) {
      var _data$availableAppoin;

      var selectedDay = (_data$availableAppoin = data.availableAppointments) === null || _data$availableAppoin === void 0 ? void 0 : _data$availableAppoin.find(function (i) {
        return (0,isSameDay["default"])(new Date(i.date), state.date);
      });

      if (selectedDay) {
        return selectedDay.time.map(function (time, index) {
          return {
            label: time,
            value: index
          };
        });
      }
    }

    return [];
  }, [state.date, data]);

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(selectedTime, [{
    validation: function validation(value) {
      return value !== undefined;
    }
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 2),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown, {
    buildOption: function buildOption(op) {
      return op;
    },
    value: timeOptions && selectedTime ? timeOptions[selectedTime] : undefined,
    variant: "noBorder",
    labelVariant: "aboveInput",
    errorMessageVariant: "insideInput",
    isValid: isValid,
    label: r(SelectDateAndTime_res.pickTime),
    isDisabled: false,
    onChange: function onChange(item) {
      if (state.date) {
        var _timeOptions$Number$l = timeOptions[Number(item['value'])].label.split(':'),
            _timeOptions$Number$l2 = (0,slicedToArray/* default */.Z)(_timeOptions$Number$l, 2),
            hour = _timeOptions$Number$l2[0],
            minute = _timeOptions$Number$l2[1];

        dispatch === null || dispatch === void 0 ? void 0 : dispatch({
          type: 'selectDateAndTime',
          date: (0,set/* default */.Z)(state.date, {
            hours: Number(hour),
            minutes: Number(minute)
          })
        });
      }

      setSelectedTime(Number(item['value']));
    },
    options: timeOptions
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/SelectDateAndTime/SelectDateAndTime.tsx




var SelectDateAndTime_excluded = ["x"];

function SelectDateAndTime_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SelectDateAndTime_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SelectDateAndTime_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SelectDateAndTime_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SelectDateAndTime_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var DateStep;

(function (DateStep) {
  DateStep["SelectDate"] = "selectDate";
  DateStep["SelectTime"] = "selectTime";
  DateStep["Note"] = "note";
})(DateStep || (DateStep = {}));

var SelectDateAndTime_StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "e6aonoe2"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var SelectDateAndTime_InputContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e6aonoe1"
} : 0)( true ? {
  name: "1azpx8r",
  styles: "margin-bottom:20px"
} : 0);

var InputsContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e6aonoe0"
} : 0)( true ? {
  name: "164sd4p",
  styles: "min-height:412px"
} : 0);

function SelectDateAndTime(_ref) {
  var data = _ref.data,
      title = _ref.title,
      copy = _ref.copy;

  var _useAppointmentContex = useAppointmentContext(),
      state = _useAppointmentContex.state,
      setCurrentStep = _useAppointmentContex.setCurrentStep,
      dispatch = _useAppointmentContex.dispatch;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var service = state.service,
      serviceType = state.serviceType;

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useState = (0,react.useState)([DateStep.SelectDate]),
      steps = _useState[0],
      setSteps = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      selectedTime = _useState2[0],
      setSelectedTime = _useState2[1];

  (0,react.useEffect)(function () {
    var _state$date, _data$node;

    if (state.date && ((_state$date = state.date) === null || _state$date === void 0 ? void 0 : _state$date.getHours()) > 0 && data && ((_data$node = data.node) === null || _data$node === void 0 ? void 0 : _data$node.__typename) === 'ServiceLocation') {
      var _data$node$availableA, _data$node$availableA2;

      var selectedTimeIndex = (_data$node$availableA = data.node.availableAppointments) === null || _data$node$availableA === void 0 ? void 0 : (_data$node$availableA2 = _data$node$availableA.find(function (i) {
        return (0,isSameDay["default"])(new Date(i.date), state.date);
      })) === null || _data$node$availableA2 === void 0 ? void 0 : _data$node$availableA2.time.findIndex(function (t) {
        var _state$date2, _state$date3;

        var _t$split = t.split(':'),
            _t$split2 = (0,slicedToArray/* default */.Z)(_t$split, 2),
            hour = _t$split2[0],
            minute = _t$split2[1];

        return Number(hour) === ((_state$date2 = state.date) === null || _state$date2 === void 0 ? void 0 : _state$date2.getHours()) && Number(minute) === ((_state$date3 = state.date) === null || _state$date3 === void 0 ? void 0 : _state$date3.getMinutes());
      });
      setSelectedTime(selectedTimeIndex);
    }
  }, [data, state.date, setSelectedTime]);

  var _useMutation = (0,useMutation/* useMutation */.D)(RESERVE_APPOINTMENT, {
    client: client,
    onCompleted: function onCompleted(data) {
      if (setCurrentStep) {
        dispatch === null || dispatch === void 0 ? void 0 : dispatch({
          type: 'setReserveAppointmentId',
          id: data.reserveAppointment.id
        });
        setCurrentStep(AppointmentStep.CustomerInfo);
      }
    }
  }),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 2),
      reserveAppointment = _useMutation2[0],
      reserveLoading = _useMutation2[1].loading;

  var transitions = (0,react_spring_esm.useTransition)(steps, {
    config: {
      mass: 2,
      tension: 2000,
      friction: 200
    },
    from: {
      opacity: 0,
      x: '508px'
    },
    enter: {
      opacity: 1,
      x: '0px'
    },
    leave: {
      opacity: 0,
      x: '508px'
    }
  });
  (0,react.useEffect)(function () {
    var newSteps = [DateStep.SelectDate];

    if (state.date) {
      newSteps.push(DateStep.SelectTime);
    }

    if (state.date && !(0,isSameMinute/* default */.Z)((0,startOfDay["default"])(state.date), state.date) || state.note) {
      newSteps.push(DateStep.Note);
    }

    setSteps(newSteps);
  }, [state, data, setSteps]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormContainer, {
    onBack: function onBack() {
      return setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(AppointmentStep.SelectService);
    },
    onSubmit: function onSubmit() {
      var _state$serviceLocatio, _service$id;

      // user has navigate back from the next step and did not make any changes we use the same reservation
      if (state.reserveAppointmentId) {
        setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(AppointmentStep.CustomerInfo);
        return;
      }

      reserveAppointment({
        variables: {
          date: state.date,
          serviceLocationId: (_state$serviceLocatio = state.serviceLocationId) !== null && _state$serviceLocatio !== void 0 ? _state$serviceLocatio : '',
          consultationServiceServiceId: (_service$id = service === null || service === void 0 ? void 0 : service.id) !== null && _service$id !== void 0 ? _service$id : '',
          consultationType: serviceType !== null && serviceType !== void 0 ? serviceType : globalTypes/* ConsultationType.Appointment */.$q.Appointment
        }
      });
    },
    title: title,
    copy: copy,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputsContainer, {
        children: transitions(function (_ref2, item) {
          var _data$node2, _data$node$availableA3, _data$node3;

          var x = _ref2.x,
              rest = (0,objectWithoutProperties/* default */.Z)(_ref2, SelectDateAndTime_excluded);

          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectDateAndTime_InputContainer, {
            style: SelectDateAndTime_objectSpread(SelectDateAndTime_objectSpread({}, rest), {}, {
              transform: x.to(function (x) {
                return x === '0px' ? 'initial' : "translate3d(".concat(x, ",0,0)");
              })
            }),
            children: [item === DateStep.SelectDate && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateInput_DateInput, {
              setSelectedTime: setSelectedTime,
              availableDates: (data === null || data === void 0 ? void 0 : (_data$node2 = data.node) === null || _data$node2 === void 0 ? void 0 : _data$node2.__typename) === 'ServiceLocation' ? (_data$node$availableA3 = data.node.availableAppointments) === null || _data$node$availableA3 === void 0 ? void 0 : _data$node$availableA3.map(function (i) {
                return new Date(i.date);
              }) : undefined
            }), (data === null || data === void 0 ? void 0 : (_data$node3 = data.node) === null || _data$node3 === void 0 ? void 0 : _data$node3.__typename) === 'ServiceLocation' && item === DateStep.SelectTime && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TimeDropdown, {
              data: data.node,
              selectedTime: selectedTime,
              setSelectedTime: setSelectedTime
            }), item === DateStep.Note && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput, {
              inputSize: "small",
              setHeight: "136px",
              placeholder: r(SelectDateAndTime_res.comment),
              value: state.note,
              onChange: function onChange(e) {
                if (dispatch) {
                  dispatch({
                    type: 'setNote',
                    note: e.target.value
                  });
                }
              }
            })]
          }, item);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectDateAndTime_StyledButton, {
        loading: reserveLoading,
        title: r(SelectDateAndTime_res["continue"]),
        type: "submit",
        bg: theme/* theme.colors.primary */.r.colors.primary
      })]
    })
  });
}
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(24432);
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/Appointment/appointmentServicesAndBranches.ts


var appointmentServicesAndBranches_templateObject;


var APPOINTMENT_SERVICES_AND_BRANCHES = (0,lib/* gql */.Ps)(appointmentServicesAndBranches_templateObject || (appointmentServicesAndBranches_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query appointmentServicesAndBranches(\n    $customerType: SmartBookingCustomerType\n  ) {\n    consultationServices(customerType: $customerType) {\n      name\n      id\n      allowAdditionalCustomer\n      customerType\n      types {\n        type\n        availableServiceLocation {\n          name\n          id\n\n          branchId\n          region\n        }\n      }\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/SelectService/SelectService.res.ts
/* harmony default export */ var SelectService_res = ({
  meeting: {
    is: 'Mæta á fund',
    en: 'Appointment'
  },
  phoneCall: {
    is: 'Fá símtal',
    en: 'Phone call'
  },
  videoCall: {
    is: 'Fjarfundur',
    en: 'Virtual meeting'
  },
  pickAccess: {
    is: 'Veldu símtal/fund',
    en: 'Select phonecall/meeting'
  },
  pickBranch: {
    is: 'Veldu útibú',
    en: 'Select branch'
  },
  pickDate: {
    is: 'Veldu dagsetningu og tíma',
    en: 'Select date and time'
  },
  pickType: {
    is: 'Veldu tegund þjónustu'
  },
  pickService: {
    is: 'Veldu þjónustu',
    en: 'Select service'
  },
  continue: {
    is: 'Áfram',
    en: 'Continue'
  },
  phoneCallDisabled: {
    is: 'Viðtalið er í formi símtals'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/SelectService/AppointmentSelectAccess.tsx



function AppointmentSelectAccess_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Disabled = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1m3hhz71"
} : 0)( true ? {
  name: "19m68nz",
  styles: "padding:24px 0px 16px 16px;width:100%;background-color:rgb(220, 234, 240)"
} : 0);

var DisabledText = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1m3hhz70"
} : 0)(typography/* typography.body */.cp.body, ";" + ( true ? "" : 0));

function AppointmentSelectAccess() {
  var _state$service, _state$service$types, _state$service2, _state$service2$types;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useAppointmentContex = useAppointmentContext(),
      state = _useAppointmentContex.state,
      dispatch = _useAppointmentContex.dispatch;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(state === null || state === void 0 ? void 0 : state.serviceType, [{
    validation: function validation(value) {
      return value !== undefined;
    }
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 2),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1];

  if ((state === null || state === void 0 ? void 0 : (_state$service = state.service) === null || _state$service === void 0 ? void 0 : (_state$service$types = _state$service.types) === null || _state$service$types === void 0 ? void 0 : _state$service$types.length) === 1) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disabled, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisabledText, {
        children: state.serviceType === globalTypes/* ConsultationType.Phonecall */.$q.Phonecall ? r(SelectService_res.phoneCallDisabled) : state.serviceType === globalTypes/* ConsultationType.Appointment */.$q.Appointment ? r(SelectService_res.meeting) : r(SelectService_res.videoCall)
      })
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown, {
      isValid: isValid,
      variant: "noBorder",
      labelVariant: "aboveInput",
      errorMessageVariant: "insideInput",
      buildOption: function buildOption(val) {
        return val;
      },
      options: (state === null || state === void 0 ? void 0 : state.service) !== undefined ? (_state$service2 = state.service) === null || _state$service2 === void 0 ? void 0 : (_state$service2$types = _state$service2.types) === null || _state$service2$types === void 0 ? void 0 : _state$service2$types.map(function (item) {
        return {
          label: item.type === globalTypes/* ConsultationType.Appointment */.$q.Appointment ? r(SelectService_res.meeting) : item.type === globalTypes/* ConsultationType.Phonecall */.$q.Phonecall ? r(SelectService_res.phoneCall) : r(SelectService_res.videoCall),
          value: item.type
        };
      }) : [],
      onChange: function onChange(val) {
        dispatch === null || dispatch === void 0 ? void 0 : dispatch({
          type: 'selectServiceType',
          serviceType: val === null || val === void 0 ? void 0 : val.value
        });
      },
      value: state.serviceType !== undefined ? state.serviceType === globalTypes/* ConsultationType.Appointment */.$q.Appointment ? {
        label: r(SelectService_res.meeting),
        value: globalTypes/* ConsultationType.Appointment */.$q.Appointment
      } : state.serviceType === globalTypes/* ConsultationType.Phonecall */.$q.Phonecall ? {
        label: r(SelectService_res.phoneCall),
        value: globalTypes/* ConsultationType.Phonecall */.$q.Phonecall
      } : {
        label: r(SelectService_res.videoCall),
        value: globalTypes/* ConsultationType.Videocall */.$q.Videocall
      } : undefined,
      label: r(SelectService_res.pickType)
    })
  });
}
// EXTERNAL MODULE: ../../node_modules/lodash.groupby/index.js
var lodash_groupby = __webpack_require__(98572);
var lodash_groupby_default = /*#__PURE__*/__webpack_require__.n(lodash_groupby);
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/filters/RegionFilter.res.ts
/* harmony default export */ var RegionFilter_res = ({
  allregions: {
    is: 'Öll svæði',
    en: 'All regions'
  },
  capitalRegion: {
    is: 'Höfuðborgarsvæðið',
    en: 'Capital region'
  },
  suðurnesPeninsula: {
    is: 'Suðurnes',
    en: 'Suðurnes peninsula'
  },
  westIceland: {
    is: 'Vesturland',
    en: 'West Iceland'
  },
  westFjords: {
    is: 'Vestfirðir',
    en: 'West Fjords'
  },
  northIceland: {
    is: 'Norðurland',
    en: 'North Iceland'
  },
  eastIceland: {
    is: 'Austurland',
    en: 'East Iceland'
  },
  southIcelan: {
    is: 'Suðurland',
    en: 'South Iceland'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/filters/RegionDropdown.tsx






function useRegionOptions() {
  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  return {
    options: [{
      value: globalTypes/* Region.All */.yp.All,
      label: r(RegionFilter_res.allregions)
    }, {
      value: globalTypes/* Region.Hofudborgarsvaedid */.yp.Hofudborgarsvaedid,
      label: r(RegionFilter_res.capitalRegion)
    }, {
      value: globalTypes/* Region.Sudurnes */.yp.Sudurnes,
      label: r(RegionFilter_res["suðurnesPeninsula"])
    }, {
      value: globalTypes/* Region.Vesturland */.yp.Vesturland,
      label: r(RegionFilter_res.westIceland)
    }, {
      value: globalTypes/* Region.Vestfirdir */.yp.Vestfirdir,
      label: r(RegionFilter_res.westFjords)
    }, {
      value: globalTypes/* Region.Nordurland */.yp.Nordurland,
      label: r(RegionFilter_res.northIceland)
    }, {
      value: globalTypes/* Region.Austurland */.yp.Austurland,
      label: r(RegionFilter_res.eastIceland)
    }, {
      value: globalTypes/* Region.Sudurland */.yp.Sudurland,
      label: r(RegionFilter_res.southIcelan)
    }]
  };
}
function RegionDropdown(_ref) {
  var selectedRegion = _ref.selectedRegion,
      setSelectedRegion = _ref.setSelectedRegion,
      className = _ref.className;

  var _useRegionOptions = useRegionOptions(),
      options = _useRegionOptions.options;

  var value = options.find(function (i) {
    return i.value === selectedRegion;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: className,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown, {
      buildOption: function buildOption(val) {
        return val;
      },
      onChange: function onChange(value) {
        return setSelectedRegion(globalTypes/* Region */.yp[value === null || value === void 0 ? void 0 : value['value']]);
      },
      options: options,
      value: value,
      variant: "noBorder"
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/SelectService/AppointmentSelectBranch.tsx










function AppointmentSelectBranch() {
  var _service$types, _service$types$find, _availableLocations$f, _availableLocations$f2;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useRegionOptions = useRegionOptions(),
      options = _useRegionOptions.options;

  var _useAppointmentContex = useAppointmentContext(),
      state = _useAppointmentContex.state,
      dispatch = _useAppointmentContex.dispatch;

  var service = state.service,
      serviceType = state.serviceType,
      serviceLocationId = state.serviceLocationId;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(state === null || state === void 0 ? void 0 : state.serviceLocationId, [{
    validation: function validation(value) {
      return value !== undefined;
    }
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 2),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1];

  var _useState = (0,react.useState)(service === null || service === void 0 ? void 0 : (_service$types = service.types) === null || _service$types === void 0 ? void 0 : (_service$types$find = _service$types.find(function (i) {
    return i.type === serviceType;
  })) === null || _service$types$find === void 0 ? void 0 : _service$types$find.availableServiceLocation),
      availableLocations = _useState[0],
      setAvailableLocations = _useState[1];

  var groupedOptions = (0,react.useMemo)(function () {
    var groupedBrances = lodash_groupby_default()(availableLocations, function (b) {
      return b.region;
    });
    return Object.keys(groupedBrances).map(function (key) {
      var _options$find;

      return {
        label: (_options$find = options.find(function (op) {
          return op.value === globalTypes/* Region */.yp[key];
        })) === null || _options$find === void 0 ? void 0 : _options$find.label,
        options: groupedBrances[key].map(function (item) {
          return {
            label: item === null || item === void 0 ? void 0 : item.name,
            value: item === null || item === void 0 ? void 0 : item.id
          };
        })
      };
    });
  }, [options, availableLocations]);
  (0,react.useEffect)(function () {
    var _service$types2, _service$types2$find;

    setAvailableLocations(service === null || service === void 0 ? void 0 : (_service$types2 = service.types) === null || _service$types2 === void 0 ? void 0 : (_service$types2$find = _service$types2.find(function (i) {
      return i.type === serviceType;
    })) === null || _service$types2$find === void 0 ? void 0 : _service$types2$find.availableServiceLocation);
  }, [serviceType, service]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown, {
    isValid: isValid,
    variant: "noBorder",
    labelVariant: "aboveInput",
    errorMessageVariant: "insideInput",
    buildOption: function buildOption(val) {
      return val;
    },
    options: groupedOptions,
    onChange: function onChange(val) {
      if ((val === null || val === void 0 ? void 0 : val.value) !== undefined) {
        dispatch === null || dispatch === void 0 ? void 0 : dispatch({
          type: 'selectServiceLocationId',
          serviceLocationId: val === null || val === void 0 ? void 0 : val.value
        });
      }
    },
    value: serviceLocationId !== undefined ? {
      label: availableLocations === null || availableLocations === void 0 ? void 0 : (_availableLocations$f = availableLocations.find(function (i) {
        return i.id === serviceLocationId;
      })) === null || _availableLocations$f === void 0 ? void 0 : _availableLocations$f.name,
      value: availableLocations === null || availableLocations === void 0 ? void 0 : (_availableLocations$f2 = availableLocations.find(function (i) {
        return i.id === serviceLocationId;
      })) === null || _availableLocations$f2 === void 0 ? void 0 : _availableLocations$f2.name
    } : undefined,
    label: r(SelectService_res.pickBranch)
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/SelectService/AppointmentSelectService.tsx








function AppointmentSelectService(_ref) {
  var _state$service;

  var services = _ref.services;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useAppointmentContex = useAppointmentContext(),
      state = _useAppointmentContex.state,
      dispatch = _useAppointmentContex.dispatch;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(state === null || state === void 0 ? void 0 : (_state$service = state.service) === null || _state$service === void 0 ? void 0 : _state$service.id, [{
    validation: function validation(value) {
      return value !== undefined;
    }
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 2),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1];

  var options = services === null || services === void 0 ? void 0 : services.map(function (item) {
    return {
      label: item.name,
      value: item.id
    };
  });

  var onServiceChange = function onServiceChange(val) {
    var service = services.find(function (s) {
      return s.id === (val === null || val === void 0 ? void 0 : val.value);
    });
    dispatch === null || dispatch === void 0 ? void 0 : dispatch({
      type: 'selectService',
      service: service
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown // ref={ref}
    , {
      variant: "noBorder",
      labelVariant: "aboveInput",
      errorMessageVariant: "insideInput",
      isValid: isValid,
      buildOption: function buildOption(val) {
        return val;
      },
      options: options,
      onChange: onServiceChange,
      value: state.service ? {
        label: state.service.name,
        value: state.service.id
      } : undefined,
      label: r(SelectService_res.pickService)
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/SelectService/SelectCustomerType.tsx






var options = [{
  value: globalTypes/* SmartBookingCustomerType.Person */.hn.Person,
  label: 'Einstaklingsþjónusta'
}, {
  value: globalTypes/* SmartBookingCustomerType.Company */.hn.Company,
  label: 'Fyrirtækjaþjónusta'
}];
function SelectCustomerType() {
  var _useAppointmentContex = useAppointmentContext(),
      dispatch = _useAppointmentContex.dispatch,
      state = _useAppointmentContex.state;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(state.customerType, [{
    validation: function validation(value) {
      return value !== undefined;
    }
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 2),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown, {
    isValid: isValid,
    variant: "noBorder",
    label: "Veldu tegund",
    labelVariant: "aboveInput",
    errorMessageVariant: "insideInput",
    options: options,
    buildOption: function buildOption(option) {
      return option;
    },
    value: options.find(function (o) {
      return o.value === state.customerType;
    }),
    onChange: function onChange(value) {
      dispatch === null || dispatch === void 0 ? void 0 : dispatch({
        type: 'selectCustomerType',
        customerType: globalTypes/* SmartBookingCustomerType */.hn[value['value']]
      });
    }
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/SelectService/SelectService.tsx



var SelectService_excluded = ["x"];

function SelectService_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SelectService_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SelectService_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SelectService_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SelectService_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




















var SelectService_StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "e5zieqi2"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var SelectService_InputContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e5zieqi1"
} : 0)( true ? {
  name: "1qt1h0j",
  styles: "margin-bottom:20px;position:relative"
} : 0);

var SelectService_InputsContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5zieqi0"
} : 0)( true ? {
  name: "164sd4p",
  styles: "min-height:412px"
} : 0);

var Steps;

(function (Steps) {
  Steps["CustomerType"] = "customerType";
  Steps["SelectService"] = "selectService";
  Steps["SelectAccess"] = "selectAccess";
  Steps["SelectBranch"] = "selectBranch";
})(Steps || (Steps = {}));

function SelectService(_ref) {
  var _state$service2;

  var defaultServiceId = _ref.defaultServiceId,
      fetchDatesAndTime = _ref.fetchDatesAndTime,
      loadingDateAndTime = _ref.loadingDateAndTime,
      title = _ref.title,
      copy = _ref.copy;

  var _useState = (0,react.useState)([Steps.CustomerType]),
      steps = _useState[0],
      setSteps = _useState[1];

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useResource = (0,src/* useResource */.Wf)(),
      locale = _useResource.locale;

  var _useAppointmentContex = useAppointmentContext(),
      state = _useAppointmentContex.state,
      setCurrentStep = _useAppointmentContex.setCurrentStep,
      dispatch = _useAppointmentContex.dispatch;

  var _useResource2 = (0,src/* useResource */.Wf)(),
      r = _useResource2.r;

  var customerType = state.customerType;

  var _useQuery = (0,useQuery/* useQuery */.a)(APPOINTMENT_SERVICES_AND_BRANCHES, {
    client: client,
    fetchPolicy: 'cache-first',
    variables: {
      customerType: customerType
    },
    context: {
      headers: {
        'Accept-Language': locale === 'is' ? 'is' : 'en-GB'
      }
    },
    onCompleted: function onCompleted(data) {
      if (!state.service) {
        if (defaultServiceId) {
          var defaultService = data.consultationServices.find(function (i) {
            return i.id === defaultServiceId;
          });

          if (defaultService) {
            dispatch === null || dispatch === void 0 ? void 0 : dispatch({
              type: 'selectService',
              service: defaultService
            });
            return;
          }
        }

        if (data.consultationServices.length === 1) {
          dispatch === null || dispatch === void 0 ? void 0 : dispatch({
            type: 'selectService',
            service: data.consultationServices[0]
          });
        }
      }
    }
  }),
      data = _useQuery.data;

  var transitions = (0,react_spring_esm.useTransition)(steps, {
    config: {
      mass: 2,
      tension: 2000,
      friction: 200
    },
    from: {
      opacity: 0,
      x: '508px'
    },
    enter: {
      opacity: 1,
      x: '0px'
    },
    leave: {
      opacity: 0,
      x: '508px'
    }
  });
  (0,react.useEffect)(function () {
    var newSteps = [Steps.CustomerType];

    if (data !== null && data !== void 0 && data.consultationServices) {
      newSteps.push(Steps.SelectService);
    }

    if (state.service) {
      newSteps.push(Steps.SelectAccess);
    }

    if (state.serviceType && !state.skipLocation) {
      newSteps.push(Steps.SelectBranch);
    }

    setSteps(newSteps);
  }, [state, data, setSteps]);
  var variables = react.useMemo(function () {
    var _state$serviceLocatio, _state$service$id, _state$service, _state$serviceType;

    return {
      variables: {
        serviceLocationId: (_state$serviceLocatio = state === null || state === void 0 ? void 0 : state.serviceLocationId) !== null && _state$serviceLocatio !== void 0 ? _state$serviceLocatio : '',
        consultationId: (_state$service$id = state === null || state === void 0 ? void 0 : (_state$service = state.service) === null || _state$service === void 0 ? void 0 : _state$service.id) !== null && _state$service$id !== void 0 ? _state$service$id : '',
        consultationType: (_state$serviceType = state === null || state === void 0 ? void 0 : state.serviceType) !== null && _state$serviceType !== void 0 ? _state$serviceType : globalTypes/* ConsultationType.Appointment */.$q.Appointment
      }
    };
  }, [state === null || state === void 0 ? void 0 : (_state$service2 = state.service) === null || _state$service2 === void 0 ? void 0 : _state$service2.id, state === null || state === void 0 ? void 0 : state.serviceLocationId, state === null || state === void 0 ? void 0 : state.serviceType]);
  var onSubmit = (0,react.useCallback)(function () {
    return fetchDatesAndTime(variables);
  }, [fetchDatesAndTime, variables]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormContainer, {
    onBack: function onBack() {
      return setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(AppointmentStep.Intro);
    },
    onSubmit: onSubmit,
    title: title,
    copy: copy,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectService_InputsContainer, {
        children: transitions(function (_ref2, item) {
          var x = _ref2.x,
              rest = (0,objectWithoutProperties/* default */.Z)(_ref2, SelectService_excluded);

          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectService_InputContainer, {
            style: SelectService_objectSpread(SelectService_objectSpread({}, rest), {}, {
              transform: x.to(function (x) {
                return x === '0px' ? 'initial' : "translate3d(".concat(x, ",0,0)");
              })
            }),
            children: [item === Steps.CustomerType && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectCustomerType, {}), (data === null || data === void 0 ? void 0 : data.consultationServices) && item === Steps.SelectService && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppointmentSelectService, {
              services: data.consultationServices
            }), item === Steps.SelectAccess && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppointmentSelectAccess, {}), item === Steps.SelectBranch && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppointmentSelectBranch, {})]
          }, item);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectService_StyledButton, {
        title: r(SelectService_res["continue"]),
        type: "submit",
        loading: loadingDateAndTime,
        bg: theme/* theme.colors.primary */.r.colors.primary
      })]
    })
  });
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(73053);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/locale/is/index.js + 5 modules
var locale_is = __webpack_require__(82215);
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/Success/Success.res.ts
/* harmony default export */ var Success_res = ({
  phoneCall: {
    is: 'Þú átt von á símtali frá sérfræðingi okkar',
    en: 'You can expect a call from our advisor.'
  },
  consultationAppointment: {
    is: 'Þú átt pantaðan tíma með sérfræðingi okkar.',
    en: 'You have made a consultation appointment with one of our advisors.'
  },
  branch: {
    is: 'Staðsetning',
    en: 'Branch'
  },
  type: {
    is: 'Þjónusta',
    en: 'Type of service'
  },
  date: {
    is: 'Dagsetning',
    en: 'Date'
  },
  time: {
    is: 'Klukkan',
    en: 'Time'
  },
  close: {
    is: 'Loka',
    en: 'Close'
  },
  successTitle: {
    is: 'Kærar þakkir',
    en: 'Thank you'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/steps/Success/Success.tsx


function Success_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var Success_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "esusrz34"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:4px;" + ( true ? "" : 0));

var Bold = (0,emotion_styled_base_browser_esm/* default */.Z)("strong",  true ? {
  target: "esusrz33"
} : 0)( true ? {
  name: "1efi8gv",
  styles: "font-weight:bold"
} : 0);

var Success_StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "esusrz32"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var Success_StyledTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Title_Title,  true ? {
  target: "esusrz31"
} : 0)( true ? {
  name: "1azpx8r",
  styles: "margin-bottom:20px"
} : 0);

var DataContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "esusrz30"
} : 0)("margin-bottom:48px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0px;}" + ( true ? "" : 0));

function Success(_ref) {
  var data = _ref.data,
      image = _ref.image;

  var _useAppointmentContex = useAppointmentContext(),
      setCurrentStep = _useAppointmentContex.setCurrentStep,
      dispatch = _useAppointmentContex.dispatch;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r,
      locale = _useResource.locale;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ImageContainer, {
    image: image,
    success: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DataContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Success_StyledTitle, {
        title: r(Success_res.successTitle),
        subTitle: r((data === null || data === void 0 ? void 0 : data.activityType) === globalTypes/* ConsultationType.Phonecall */.$q.Phonecall ? Success_res.phoneCall : Success_res.consultationAppointment)
      }), (data === null || data === void 0 ? void 0 : data.activityType) === globalTypes/* ConsultationType.Appointment */.$q.Appointment && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Success_Text, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Bold, {
          children: [r(Success_res.branch), ":"]
        }), " ", data === null || data === void 0 ? void 0 : data.branch.name]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Success_Text, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Bold, {
          children: [r(Success_res.type), ":"]
        }), " ", data === null || data === void 0 ? void 0 : data.serviceName]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Success_Text, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Bold, {
          children: [r(Success_res.date), ":"]
        }), ' ', data && (0,format["default"])(new Date(data.startTime), 'd. LLLL', {
          locale: locale_is/* default */.Z
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Success_Text, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Bold, {
          children: [r(Success_res.time), ":"]
        }), ' ', (0,src/* formatTime */.mr)(locale, new Date(data === null || data === void 0 ? void 0 : data.startTime))]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Success_StyledButton, {
      title: r(Success_res.close),
      bg: theme/* theme.colors.primary */.r.colors.primary,
      onClick: function onClick() {
        setCurrentStep === null || setCurrentStep === void 0 ? void 0 : setCurrentStep(AppointmentStep.Intro);
        dispatch === null || dispatch === void 0 ? void 0 : dispatch({
          type: 'setClearInfo'
        });
      }
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/book-appointment/BookAppointment.tsx



function BookAppointment_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var StyledRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "eg3k4es1"
} : 0)("overflow:", function (props) {
  return props.withImage ? 'hidden' : 'initial';
}, ";background:", function (props) {
  return props.theme.shades.primary2;
}, ";padding:", function (props) {
  return props.withImage ? '0' : '48px 0px 45px 0px';
}, ";@media ", devices/* device.tablet */.U.tablet, "{padding:", function (props) {
  return props.withImage ? '0' : '100px 0 52px 0';
}, ";min-height:740px;max-height:740px;}" + ( true ? "" : 0));

var OverflowContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eg3k4es0"
} : 0)( true ? {
  name: "12u9c7u",
  styles: "padding-bottom:200px;margin-bottom:-200px;overflow:hidden"
} : 0);

var AppointmentStep;

(function (AppointmentStep) {
  AppointmentStep["Intro"] = "intro";
  AppointmentStep["SelectService"] = "selectService";
  AppointmentStep["SelectDateAndTime"] = "selectDateAndTime";
  AppointmentStep["CustomerInfo"] = "customerInfo";
  AppointmentStep["AdditionalCustomer"] = "additionalCustomer";
  AppointmentStep["InfoText"] = "infoText";
  AppointmentStep["Success"] = "success";
})(AppointmentStep || (AppointmentStep = {}));

var AppointmentContext = /*#__PURE__*/(0,react.createContext)({
  state: initialState
});
function BookAppointment(_ref) {
  var defaultServiceId = _ref.defaultServiceId,
      defaultCustomerType = _ref.defaultCustomerType,
      image = _ref.image,
      title = _ref.title,
      copy = _ref.copy;

  var _useState = (0,react.useState)(AppointmentStep.Intro),
      currentStep = _useState[0],
      setCurrentStep = _useState[1];

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  var _useState2 = (0,react.useState)(undefined),
      successData = _useState2[0],
      setSuccessData = _useState2[1];

  var _useImmerReducer = (0,use_immer_module/* useImmerReducer */.C)(AppointmentReducer, initialState),
      _useImmerReducer2 = (0,slicedToArray/* default */.Z)(_useImmerReducer, 2),
      state = _useImmerReducer2[0],
      dispatch = _useImmerReducer2[1];

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var onCompleted = react.useCallback(function () {
    setCurrentStep(AppointmentStep.SelectDateAndTime);
  }, []);

  var _useLazyQuery = (0,useLazyQuery/* useLazyQuery */.t)(availableDatesAndTimes, {
    client: client,
    fetchPolicy: 'network-only',
    onCompleted: onCompleted
  }),
      _useLazyQuery2 = (0,slicedToArray/* default */.Z)(_useLazyQuery, 2),
      fetchDatesAndTime = _useLazyQuery2[0],
      _useLazyQuery2$ = _useLazyQuery2[1],
      data = _useLazyQuery2$.data,
      loading = _useLazyQuery2$.loading;

  (0,react.useEffect)(function () {
    if (defaultServiceId && defaultCustomerType) {
      dispatch({
        type: 'selectCustomerType',
        customerType: defaultCustomerType
      });
    }
  }, [defaultServiceId, defaultCustomerType, dispatch]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppointmentContext.Provider, {
    value: {
      state: state,
      dispatch: dispatch,
      currentStep: currentStep,
      setCurrentStep: setCurrentStep
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      id: "book-appointment",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentContainer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OverflowContainer, {
          children: [isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
            src: image !== null && image !== void 0 ? image : tempBookAppointmentImage,
            aspectRatio: 4 / 3
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledRow, {
            gutter: isMobile ? 0 : undefined,
            withImage: currentStep === AppointmentStep.Intro || currentStep === AppointmentStep.Success,
            children: [currentStep === AppointmentStep.Intro && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Intro_Intro, {
              defaultCustomerType: defaultCustomerType,
              image: image,
              title: title,
              copy: copy
            }), currentStep === AppointmentStep.SelectService && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectService, {
              defaultServiceId: defaultServiceId,
              fetchDatesAndTime: fetchDatesAndTime,
              loadingDateAndTime: loading,
              title: title,
              copy: copy
            }), currentStep === AppointmentStep.SelectDateAndTime && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectDateAndTime, {
              data: data,
              title: title,
              copy: copy
            }), currentStep === AppointmentStep.CustomerInfo && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerInfo, {
              setSuccessData: setSuccessData,
              title: title,
              copy: copy
            }), currentStep === AppointmentStep.AdditionalCustomer && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerInfo, {
              setSuccessData: setSuccessData,
              title: title,
              copy: copy
            }), currentStep === AppointmentStep.Success && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Success, {
              data: successData,
              image: image
            })]
          })]
        })
      })
    })
  });
}
var useAppointmentContext = function useAppointmentContext() {
  return (0,react.useContext)(AppointmentContext);
};

var SegmentContainer = function SegmentContainer(_ref2) {
  var children = _ref2.children;
  var isDesktop = (0,hooks_useMedia/* useMedia */.G)('lg');
  return !isDesktop ? children : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: children
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/BookAppointmentContainer.tsx





function BookAppointmentContainer(_ref) {
  var _default_personal_ser, _default_personal_ser2, _default_corporate_se;

  var type = _ref.type,
      default_corporate_service = _ref.default_corporate_service,
      default_personal_service = _ref.default_personal_service,
      image = _ref.image,
      title = _ref.title,
      copy = _ref.copy;
  var defaultServiceId = (_default_personal_ser = default_personal_service === null || default_personal_service === void 0 ? void 0 : (_default_personal_ser2 = default_personal_service.match(/:(.*)/)) === null || _default_personal_ser2 === void 0 ? void 0 : _default_personal_ser2[1]) !== null && _default_personal_ser !== void 0 ? _default_personal_ser : default_corporate_service === null || default_corporate_service === void 0 ? void 0 : (_default_corporate_se = default_corporate_service.match(/:(.*)/)) === null || _default_corporate_se === void 0 ? void 0 : _default_corporate_se[1];

  var getDefaultCustomerType = function getDefaultCustomerType() {
    if (type === 'Company' || default_corporate_service) {
      return globalTypes/* SmartBookingCustomerType.Company */.hn.Company;
    } else if (type === 'Person' || default_personal_service) {
      return globalTypes/* SmartBookingCustomerType.Person */.hn.Person;
    }
  };

  var _title = Prismic/* Prismic.text */.X5.text(title);

  var _copy = Prismic/* Prismic.text */.X5.text(copy);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookAppointment, {
    image: image,
    defaultServiceId: defaultServiceId,
    defaultCustomerType: getDefaultCustomerType(),
    title: _title !== null ? _title : '',
    copy: _copy !== null ? _copy : ''
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/box/Box.tsx






var Box_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1h4wglc0"
} : 0)("display:", function (props) {
  return props.noPadding ? 'block' : 'flex';
}, ";flex-flow:column nowrap;justify-content:", function (props) {
  return props.center === 'Center' ? 'center' : 'flex-start';
}, ";padding:", function (props) {
  return props.noPadding ? 0 : '40px';
}, ";background-color:", function (props) {
  return !props.noPadding && props.theme.colors.backgroundAlt;
}, ";overflow:hidden;", function (props) {
  return props.noPadding && 'margin-bottom: 0';
}, ";&:nth-child(3){", function (props) {
  return props.noPadding && 'order: 4';
}, ";}&:nth-child(4){", function (props) {
  return props.noPadding && 'order: 3';
}, ";}", FitImage, "{@media ", devices/* device.tablet */.U.tablet, "{height:100%;object-fit:cover;margin-bottom:0;}}div{h2{margin-bottom:48px;}}@media ", devices/* device.tablet */.U.tablet, "{min-height:auto;", function (props) {
  return props.noPadding && 'margin-bottom: 0';
}, ";padding:", function (props) {
  return props.noPadding ? 0 : props.isTable ? '44px 58px' : '84px 58px';
}, ";}@media ", devices/* device.ipadPro */.U.ipadPro, "{min-height:442px;padding:", function (props) {
  return props.noPadding ? 0 : '44px 36px';
}, ";", function (props) {
  return props.noPadding && 'margin-bottom: 20px';
}, ";&:nth-child(3){", function (props) {
  return props.noPadding && 'order: initial';
}, ";}&:nth-child(4){", function (props) {
  return props.noPadding && 'order: initial';
}, ";}}@media ", devices/* device.desktop */.U.desktop, "{min-height:570px;padding:", function (props) {
  return props.noPadding ? 0 : '100px';
}, ";}" + ( true ? "" : 0));

var Box_Box = function Box(_ref) {
  var children = _ref.children,
      noPadding = _ref.noPadding,
      center = _ref.center,
      isTable = _ref.isTable;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Host, {
    noPadding: noPadding,
    center: center,
    isTable: isTable,
    children: children
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/box/BoxGroup.tsx





var BoxGroup_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1n8b6cr0"
} : 0)("display:flex;flex-flow:column nowrap;margin-bottom:-20px;>*{margin-bottom:20px;&:nth-child(3){order:4;}&:nth-child(4){order:3;}}@media ", devices/* device.ipadPro */.U.ipadPro, "{display:flex;flex-flow:row wrap;>*{width:calc(50% - 20px);margin:0 10px 20px;&:nth-child(3){order:initial;}&:nth-child(4){order:initial;}}}" + ( true ? "" : 0));

var BoxGroup = function BoxGroup(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BoxGroup_Host, {
    children: children
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/table/PrismicTable.tsx






var ZebraHost = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fnrt8u5"
} : 0)( true ? "" : 0);

var ZebraTableWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1fnrt8u4"
} : 0)(function (props) {
  return (0,mixins/* zebraTable */.UO)(props.background, props.colorTheme);
}, ";" + ( true ? "" : 0));

var StandardHost = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fnrt8u3"
} : 0)( true ? "" : 0);

var StandardTableWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1fnrt8u2"
} : 0)(function (props) {
  return (0,mixins/* standardTable */._L)(props.background, props.noHeadingUnderline);
}, "@media ", devices/* device.tablet */.U.tablet, "{padding:90px 0;}" + ( true ? "" : 0));

var SmallTableWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1fnrt8u1"
} : 0)(function (props) {
  return (0,mixins/* smallTable */.o)(props.background);
}, ";" + ( true ? "" : 0));

var PrismicTable_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fnrt8u0"
} : 0)("margin-bottom:60px;", devices/* device.tablet */.U.tablet, "{max-width:70%;}" + ( true ? "" : 0));

var PrismicTable = function PrismicTable(_ref) {
  var background = _ref.background,
      layout = _ref.layout,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'primary' : _ref$theme,
      children = _ref.children,
      copy = _ref.copy,
      _ref$noHeadingUnderli = _ref.noHeadingUnderline,
      noHeadingUnderline = _ref$noHeadingUnderli === void 0 ? true : _ref$noHeadingUnderli;

  if (layout === 'Zebra') {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ZebraHost, {
      children: [copy && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrismicTable_Copy, {
        children: copy
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ZebraTableWrapper, {
        background: background,
        colorTheme: theme,
        children: children
      })]
    });
  }

  if (layout === 'Small') {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardHost, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SmallTableWrapper, {
        background: background,
        children: children
      })
    });
  } else {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StandardHost, {
      children: [!!copy && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          lg: {
            width: 7 / 12,
            offset: 1 / 12
          },
          md: {
            width: 8 / 12
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrismicTable_Copy, {
            children: copy
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          lg: {
            width: 10 / 12,
            offset: 1 / 12
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StandardTableWrapper, {
            background: background,
            noHeadingUnderline: noHeadingUnderline,
            children: children
          })
        })
      })]
    });
  }
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/BoxesContainer.tsx








var BoxesContainer = function BoxesContainer(_ref) {
  var fields = _ref.fields;
  var isTablet = (0,hooks_useMedia/* useMedia */.G)('md');

  if (fields.length === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BoxGroup, {
      children: fields.map(function (item, i) {
        var _Prismic$text;

        var copy = !(0,isEmptyText/* isEmptyText */.W)(item.copy) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
          value: item.copy
        }) : null; //const source = Prismic.text(item?.table);

        var source = (_Prismic$text = Prismic/* Prismic.text */.X5.text(item === null || item === void 0 ? void 0 : item.table)) !== null && _Prismic$text !== void 0 ? _Prismic$text : '';
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box_Box, {
          noPadding: !!item.image,
          isTable: !!item.table,
          center: item.align_content,
          children: !!item.image ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reveal/* Reveal */.U, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
              src: item.image,
              ar: isTablet ? 'ar_16_9' : 'ar_1_1',
              aspectRatio: isTablet ? 16 / 9 : 1 / 1
            })
          }) : !!copy ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reveal/* Reveal */.U, {
            children: copy
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrismicTable, {
            noHeadingUnderline: false,
            background: "Gray",
            layout: "Small",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              dangerouslySetInnerHTML: {
                __html: source
              }
            })
          })
        }, "box-".concat(i));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/buzzsprout/Buzzsprout.tsx



function Buzzsprout(_ref) {
  var url = _ref.url;
  var id = 'buzzsprout-player';
  (0,react.useEffect)(function () {
    var script = document.createElement('script');
    script.src = "".concat(url, ".js?container_id=").concat(id, "&player=small");
    script.async = true;
    document.body.appendChild(script);
    return function () {
      document.body.removeChild(script);
    };
  }, [url, id]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      id: id
    }),
    isArticle: true
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/BuzzsproutContainer.tsx





var BuzzsproutContainer = function BuzzsproutContainer(_ref) {
  var url = _ref.url;

  if ((0,isEmptyText/* isEmptyText */.W)(url)) {
    return null;
  }

  var source = Prismic/* Prismic.text */.X5.text(url);

  if (!source) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Buzzsprout, {
      url: source
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/hero/CompactHero.tsx



function CompactHero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var CompactHero_isEmpty = function isEmpty(value) {
  if (react.Children.count(value) === 0) {
    return true;
  }

  return String(value !== null && value !== void 0 ? value : '').trim() === '';
};

var CompactHero_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ad5ev27"
} : 0)("position:relative;padding-bottom:1px;margin-bottom:80px;color:", function (props) {
  return props.theme.colors.background;
}, ";@media ", devices/* device.tablet */.U.tablet, "{padding-top:40px;}" + ( true ? "" : 0));

var CompactHero_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1ad5ev26"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{", mixins/* container */.nC, ";}" + ( true ? "" : 0));

var CompactHero_AspectRatio = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ad5ev25"
} : 0)("position:relative;display:flex;flex-flow:column nowrap;margin-bottom:-50px;@media ", devices/* device.tablet */.U.tablet, "{min-height:483px;flex-direction:row;}" + ( true ? "" : 0));

var CompactHero_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e1ad5ev24"
} : 0)(typography/* typography.heroSmall */.cp.heroSmall, " max-width:calc((690 / ", typography/* sizes.heroSmallSize */.J7.heroSmallSize, ") * 1em);margin:0;margin-bottom:20px;color:inherit;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:calc(", 75 / typography/* sizes.heroSmallSize */.J7.heroSmallSize, " * 1em);max-width:100%;}" + ( true ? "" : 0));

var CompactHero_Description = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ad5ev23"
} : 0)("font-family:", function (props) {
  return props.theme.font.family;
}, ";font-size:24px;letter-spacing:0.38px;text-align:left;line-height:34px;@media ", devices/* device.tablet */.U.tablet, "{margin-top:auto;padding-right:100px;}div{", typography/* typography.p2 */.cp.p2, " p{margin-bottom:36px;}ul li{", typography/* typography.heroListStyle */.cp.heroListStyle, " &::before{background-color:", function (props) {
  return props.theme.colors.secondary;
}, ";}}}" + ( true ? "" : 0));

var CompactHero_Background = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ad5ev22"
} : 0)("position:absolute;top:0;left:0;right:0;bottom:0;background-image:", function (props) {
  return props.theme.gradients.primary;
}, ";" + ( true ? "" : 0));

var CompactHero_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ad5ev21"
} : 0)("position:relative;padding:60px 30px;display:flex;flex-direction:column;background-color:", function (props) {
  return props.theme.colors.primary;
}, ";@media ", devices/* device.tablet */.U.tablet, "{padding:136px 100px 50px 100px;background-color:transparent;}" + ( true ? "" : 0));

var CompactHero_Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1ad5ev20"
} : 0)( true ? {
  name: "1k8t52o",
  styles: "display:flex;flex:1;flex-direction:column"
} : 0);

function CompactHero(props) {
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(useReveal/* inViewConfig */.BT),
      _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  var isAnimated = props.isAnimated,
      title = props.title,
      description = props.description;
  var visible = isAnimated !== null && isAnimated !== void 0 ? isAnimated : inView;
  var copyStyle = (0,react_spring_esm.useSpring)({
    opacity: visible ? 1 : 0,
    y: visible ? 0 : 20
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompactHero_Host, {
    ref: ref,
    id: "hero",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompactHero_Container, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompactHero_AspectRatio, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompactHero_Background, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompactHero_Content, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CompactHero_Copy, {
            style: copyStyle,
            children: [!CompactHero_isEmpty(title) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompactHero_Title, {
              children: title
            }), !CompactHero_isEmpty(description) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompactHero_Description, {
              children: description
            })]
          })
        })]
      })
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/CompactHeroContainer.tsx





var CompactHeroContainer = function CompactHeroContainer(_ref) {
  var _Prismic$text;

  var title = _ref.title,
      copy = _ref.copy;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompactHero, {
    title: (0,is.hyphenateSync)((_Prismic$text = Prismic/* Prismic.text */.X5.text(title)) !== null && _Prismic$text !== void 0 ? _Prismic$text : ''),
    description: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
      value: copy
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/content-nav/Chapter.tsx








var Chapter_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "e1jny3cu1"
} : 0)("padding-top:60px;min-height:100vh;@media ", devices/* device.tablet */.U.tablet, "{padding-top:0;padding-bottom:80vh;}div{p:first-child{", typography/* typography.p2 */.cp.p2, " margin-bottom:calc(", 64 / 24, " * 1em);}}" + ( true ? "" : 0));

var IsMobile = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jny3cu0"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{display:none;}" + ( true ? "" : 0));

var Chapter = function Chapter(_ref) {
  var id = _ref.id,
      children = _ref.children,
      subHeading = _ref.subHeading,
      onChange = _ref.onChange;

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0.1,
    rootMargin: '0px 0px -200px 0px'
  }),
      _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  (0,react.useEffect)(function () {
    if (inView) {
      onChange(id);
    }
  }, [inView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Chapter_Host, {
    id: id,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsMobile, {
      children: subHeading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      ref: ref,
      children: children
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/content-nav/NavItem.tsx




var NavItem_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1ehpi10"
} : 0)("display:block;padding-left:28px;margin-left:-2px;line-height:calc(32 / 18);opacity:", function (_ref) {
  var isActive = _ref.isActive;
  return isActive ? 1 : 0.5;
}, ";border-left:", function (props) {
  return props.isActive ? "2px solid ".concat(props.theme.colors.primary) : '2px solid transparent';
}, ";transition:opacity 200ms ease-in-out,border-color 200ms ease-in-out;" + ( true ? "" : 0));

var NavItem = function NavItem(_ref2) {
  var children = _ref2.children,
      href = _ref2.href,
      isActive = _ref2.isActive,
      onClick = _ref2.onClick;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavItem_Host, {
    href: href,
    title: children,
    isActive: isActive,
    onClick: onClick,
    children: children
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/content-nav/ContentNav.tsx



function ContentNav_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var ContentNav_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1cznj25"
} : 0)("margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";padding:50px;padding:", function (props) {
  return "".concat(props.theme.breakpoints.sm.gutter * 2, "px ").concat(props.theme.breakpoints.sm.gutter, "px");
}, ";background-color:", function (props) {
  return props.theme.colors.backgroundAlt;
}, ";", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{margin:0;padding:50px;}" + ( true ? "" : 0));

var Wrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cznj24"
} : 0)("display:none;@media ", devices/* device.tablet */.U.tablet, "{display:flex;flex-flow:column nowrap;justify-content:space-between;position:relative;height:100%;}" + ( true ? "" : 0));

var TitleWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cznj23"
} : 0)(typography/* typography.h3 */.cp.h3, " position:relative;margin-bottom:30px;overflow:hidden;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:300px;position:sticky;top:160px;}" + ( true ? "" : 0));

var ContentNav_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1cznj22"
} : 0)(typography/* typography.h2 */.cp.h2, " padding-bottom:30px;border-bottom:", function (props) {
  return "1px solid ".concat(props.theme.colors.primary);
}, ";@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:90px;}" + ( true ? "" : 0));

var ContentNav_Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.h2,  true ? {
  target: "e1cznj21"
} : 0)( true ? {
  name: "ke6dao",
  styles: "position:absolute;top:0;left:0;opacity:0"
} : 0);

var Nav = (0,emotion_styled_base_browser_esm/* default */.Z)("nav",  true ? {
  target: "e1cznj20"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{display:block;position:sticky;bottom:50px;margin-top:300px;border-left:2px solid ", function (props) {
  return props.theme.shades.primary2;
}, ";}" + ( true ? "" : 0));

var ContentNav = function ContentNav(_ref) {
  var _chapters$;

  var heading = _ref.heading,
      chapters = _ref.chapters;

  var _useMeasure = (0,web/* default */.Z)({
    polyfill: resize_observer/* ResizeObserver */["do"]
  }),
      _useMeasure2 = (0,slicedToArray/* default */.Z)(_useMeasure, 2),
      copyRef = _useMeasure2[0],
      copySize = _useMeasure2[1];

  var _useState = (0,react.useState)(chapters === null || chapters === void 0 ? void 0 : (_chapters$ = chapters[0]) === null || _chapters$ === void 0 ? void 0 : _chapters$.id),
      activeId = _useState[0],
      setActiveId = _useState[1];

  var transition = (0,react_spring_esm.useTransition)(activeId, {
    from: {
      y: 30,
      opacity: 1
    },
    enter: {
      y: 0,
      opacity: 1
    },
    leave: {
      y: -30,
      opacity: 0
    }
  });

  var _useSpring = (0,react_spring_esm.useSpring)(function () {
    return {
      y: 0,
      onChange: function onChange(props) {
        window.scrollTo(0, props.value.y);
      }
    };
  }),
      _useSpring2 = (0,slicedToArray/* default */.Z)(_useSpring, 2),
      _ = _useSpring2[0],
      spring = _useSpring2[1];

  var onChapterChange = function onChapterChange(id) {
    setActiveId(id);
  };

  (0,react.useEffect)(function () {
    var onScroll = function onScroll() {
      return spring.stop();
    };

    window.addEventListener('wheel', onScroll, false);
    return function () {
      window.removeEventListener('wheel', onScroll, false);
    };
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentNav_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentNav_Title, {
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 5 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrap, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleWrap, {
            style: {
              height: "".concat(copySize.height, "px")
            },
            children: transition(function (style) {
              var _chapters$find;

              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentNav_Heading, {
                ref: copyRef,
                style: style,
                children: (_chapters$find = chapters.find(function (c) {
                  return c.id === activeId;
                })) === null || _chapters$find === void 0 ? void 0 : _chapters$find.title
              });
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Nav, {
            children: chapters.map(function (chapter) {
              var _chapter$title;

              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavItem, {
                href: "#".concat(chapter.id),
                onClick: function onClick(e) {
                  e.preventDefault();
                  var offset = 160;
                  var el = document.getElementById(chapter.id);

                  if (el) {
                    var y = el.getBoundingClientRect().top + window.scrollY - offset;
                    spring.update({
                      y: y,
                      reset: true,
                      from: {
                        y: window.scrollY
                      }
                    });
                  }

                  return false;
                },
                isActive: chapter.id === activeId,
                children: (_chapter$title = chapter.title) !== null && _chapter$title !== void 0 ? _chapter$title : ''
              }, chapter.id);
            })
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 6 / 12,
          offset: 1 / 12
        },
        children: chapters.map(function (chapter) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chapter, {
            id: chapter.id,
            subHeading: chapter.title,
            onChange: onChapterChange,
            children: chapter.content
          }, chapter.id);
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/ContentNavContainer.tsx






var ContentNavContainer = function ContentNavContainer(_ref) {
  var heading = _ref.heading,
      fields = _ref.fields;
  var chapters = fields.map(function (item) {
    var title = Prismic/* Prismic.text */.X5.text(item.subheading);
    var id = (0,utils_src/* slugify */.lV)(title !== null && title !== void 0 ? title : undefined);

    var content = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
      value: item.copy
    });

    return {
      id: id,
      title: title,
      content: content
    };
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentNav, {
      heading: Prismic/* Prismic.text */.X5.text(heading),
      chapters: chapters
    })
  });
};
;// CONCATENATED MODULE: ../../packages/ui/src/components/buttons/SvgButton.tsx



var SvgButton_excluded = ["title", "children", "target"];

function SvgButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SvgButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SvgButton_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SvgButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgButton_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var SvgButton_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1kugwlw1"
} : 0)( true ? {
  name: "1eets8k",
  styles: "cursor:pointer;&:hover{opacity:0.8;}"
} : 0);

var SrOnly = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1kugwlw0"
} : 0)(mixins/* sronly */._7, ";" + ( true ? "" : 0));

var SvgButton = function SvgButton(_ref) {
  var title = _ref.title,
      children = _ref.children,
      target = _ref.target,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SvgButton_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SvgButton_Host, SvgButton_objectSpread(SvgButton_objectSpread({
    target: target,
    title: title
  }, rest), {}, {
    children: [children, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SrOnly, {
      children: title
    })]
  }));
};
;// CONCATENATED MODULE: ../../packages/ui/src/components/icons/Appstore.tsx



var Appstore = function Appstore() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "135",
    height: "40",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "#A6A6A6",
      d: "M130.197 40H4.729A4.74 4.74 0 010 35.267V4.726A4.733 4.733 0 014.729 0h125.468C132.803 0 135 2.12 135 4.726v30.541c0 2.605-2.197 4.733-4.803 4.733z"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M134.032 35.268a3.83 3.83 0 01-3.834 3.83H4.729a3.835 3.835 0 01-3.839-3.83V4.725A3.84 3.84 0 014.729.89h125.468a3.834 3.834 0 013.834 3.835l.001 30.543z"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "#FFF",
      d: "M30.128 19.784c-.029-3.223 2.639-4.791 2.761-4.864-1.511-2.203-3.853-2.504-4.676-2.528-1.967-.207-3.875 1.177-4.877 1.177-1.022 0-2.565-1.157-4.228-1.123-2.14.033-4.142 1.272-5.24 3.196-2.266 3.923-.576 9.688 1.595 12.859 1.086 1.553 2.355 3.287 4.016 3.226 1.625-.067 2.232-1.036 4.193-1.036 1.943 0 2.513 1.036 4.207.997 1.744-.028 2.842-1.56 3.89-3.127 1.255-1.78 1.759-3.533 1.779-3.623-.041-.014-3.387-1.291-3.42-5.154zm-3.2-9.478c.874-1.093 1.472-2.58 1.306-4.089-1.265.056-2.847.875-3.758 1.944-.806.942-1.526 2.486-1.34 3.938 1.421.106 2.88-.717 3.792-1.793zM53.645 31.504h-2.271l-1.244-3.909h-4.324l-1.185 3.909H42.41l4.284-13.308h2.646l4.305 13.308zm-3.89-5.549L48.63 22.48c-.119-.355-.342-1.191-.671-2.507h-.04a96.75 96.75 0 01-.632 2.507l-1.105 3.475h3.573zm14.907.633c0 1.632-.441 2.922-1.323 3.869-.79.843-1.771 1.264-2.942 1.264-1.264 0-2.172-.454-2.725-1.362h-.04v5.055H55.5V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.711-1.146 1.79-1.718 3.238-1.718 1.132 0 2.077.447 2.833 1.342.758.896 1.136 2.074 1.136 3.535zm-2.172.078c0-.934-.21-1.704-.632-2.31-.461-.632-1.08-.948-1.856-.948-.526 0-1.004.176-1.431.523-.428.35-.708.807-.839 1.373-.066.264-.099.48-.099.65v1.6c0 .698.214 1.287.642 1.768s.984.721 1.668.721c.803 0 1.428-.31 1.875-.928.448-.619.672-1.435.672-2.449zm13.209-.078c0 1.632-.441 2.922-1.324 3.869-.789.843-1.77 1.264-2.941 1.264-1.264 0-2.172-.454-2.724-1.362h-.04v5.055h-2.132V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.71-1.146 1.789-1.718 3.238-1.718 1.131 0 2.076.447 2.834 1.342.755.896 1.134 2.074 1.134 3.535zm-2.172.078c0-.934-.211-1.704-.633-2.31-.461-.632-1.078-.948-1.855-.948a2.22 2.22 0 00-1.432.523c-.428.35-.707.807-.838 1.373-.065.264-.099.48-.099.65v1.6c0 .698.214 1.287.64 1.768.428.48.984.721 1.67.721.803 0 1.428-.31 1.875-.928.448-.619.672-1.435.672-2.449zm14.512 1.106c0 1.132-.393 2.053-1.182 2.764-.867.777-2.074 1.165-3.625 1.165-1.432 0-2.58-.276-3.449-.829l.494-1.777c.936.566 1.963.85 3.082.85.803 0 1.428-.182 1.877-.544.447-.362.67-.848.67-1.454 0-.54-.184-.995-.553-1.364-.367-.369-.98-.712-1.836-1.029-2.33-.869-3.494-2.142-3.494-3.816 0-1.094.408-1.991 1.225-2.689.814-.699 1.9-1.048 3.258-1.048 1.211 0 2.217.211 3.02.632l-.533 1.738c-.75-.408-1.598-.612-2.547-.612-.75 0-1.336.185-1.756.553a1.58 1.58 0 00-.533 1.205c0 .526.203.961.611 1.303.355.316 1 .658 1.936 1.027 1.145.461 1.986 1 2.527 1.618.539.616.808 1.387.808 2.307zm7.049-4.264h-2.35v4.659c0 1.185.414 1.777 1.244 1.777.381 0 .697-.033.947-.099l.059 1.619c-.42.157-.973.236-1.658.236-.842 0-1.5-.257-1.975-.77-.473-.514-.711-1.376-.711-2.587v-4.837h-1.4v-1.6h1.4v-1.757l2.094-.632v2.389h2.35v1.602zm10.603 3.119c0 1.475-.422 2.686-1.264 3.633-.883.975-2.055 1.461-3.516 1.461-1.408 0-2.529-.467-3.365-1.401s-1.254-2.113-1.254-3.534c0-1.487.43-2.705 1.293-3.652.861-.948 2.023-1.422 3.484-1.422 1.408 0 2.541.467 3.396 1.402.818.907 1.226 2.078 1.226 3.513zm-2.212.069c0-.885-.189-1.644-.572-2.277-.447-.766-1.086-1.148-1.914-1.148-.857 0-1.508.383-1.955 1.148-.383.634-.572 1.405-.572 2.317 0 .885.189 1.644.572 2.276.461.766 1.105 1.148 1.936 1.148.814 0 1.453-.39 1.914-1.168.393-.645.591-1.412.591-2.296zm9.142-2.913a3.702 3.702 0 00-.672-.059c-.75 0-1.33.283-1.738.85-.355.5-.533 1.132-.533 1.895v5.035h-2.131l.02-6.574c0-1.106-.027-2.113-.08-3.021h1.857l.078 1.836h.059c.225-.631.58-1.139 1.066-1.52a2.578 2.578 0 011.541-.514c.197 0 .375.014.533.039v2.033zm9.535 2.469a5 5 0 01-.078.967h-6.396c.025.948.334 1.673.928 2.173.539.447 1.236.671 2.092.671.947 0 1.811-.151 2.588-.454l.334 1.48c-.908.396-1.98.593-3.217.593-1.488 0-2.656-.438-3.506-1.313-.848-.875-1.273-2.05-1.273-3.524 0-1.447.395-2.652 1.186-3.613.828-1.026 1.947-1.539 3.355-1.539 1.383 0 2.43.513 3.141 1.539.563.815.846 1.823.846 3.02zm-2.033-.553c.014-.632-.125-1.178-.414-1.639-.369-.593-.936-.889-1.699-.889-.697 0-1.264.289-1.697.869-.355.461-.566 1.014-.631 1.658h4.441zM49.05 10.009c0 1.177-.353 2.063-1.058 2.658-.653.549-1.581.824-2.783.824-.596 0-1.106-.026-1.533-.078V6.982c.557-.09 1.157-.136 1.805-.136 1.145 0 2.008.249 2.59.747.652.563.979 1.368.979 2.416zm-1.105.029c0-.763-.202-1.348-.606-1.756-.404-.407-.994-.611-1.771-.611-.33 0-.611.022-.844.068v4.889c.129.02.365.029.708.029.802 0 1.421-.223 1.857-.669s.656-1.096.656-1.95zm6.964.999c0 .725-.207 1.319-.621 1.785-.434.479-1.009.718-1.727.718-.692 0-1.243-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.712-.698c.692 0 1.248.229 1.669.688.4.446.601 1.022.601 1.726zm-1.087.034c0-.435-.094-.808-.281-1.119-.22-.376-.533-.564-.94-.564-.421 0-.741.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .714-.191.94-.574.194-.317.291-.693.291-1.128zm8.943-2.352l-1.475 4.714h-.96l-.611-2.047a15.32 15.32 0 01-.379-1.523h-.019a11.15 11.15 0 01-.379 1.523l-.649 2.047h-.971l-1.387-4.714h1.077l.533 2.241c.129.53.235 1.035.32 1.513h.019c.078-.394.207-.896.389-1.503l.669-2.25h.854l.641 2.202c.155.537.281 1.054.378 1.552h.029c.071-.485.178-1.002.32-1.552l.572-2.202h1.029zm5.433 4.714H67.15v-2.7c0-.832-.316-1.248-.95-1.248a.946.946 0 00-.757.343 1.217 1.217 0 00-.291.808v2.796h-1.048v-3.366c0-.414-.013-.863-.038-1.349h.921l.049.737h.029c.122-.229.304-.418.543-.569.284-.176.602-.265.95-.265.44 0 .806.142 1.097.427.362.349.543.87.543 1.562v2.824zm2.89 0h-1.047V6.556h1.047v6.877zm6.17-2.396c0 .725-.207 1.319-.621 1.785-.434.479-1.01.718-1.727.718-.693 0-1.244-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.711-.698c.693 0 1.248.229 1.67.688.4.446.601 1.022.601 1.726zm-1.088.034c0-.435-.094-.808-.281-1.119-.219-.376-.533-.564-.939-.564-.422 0-.742.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .713-.191.939-.574.195-.317.291-.693.291-1.128zm6.16 2.362h-.941l-.078-.543h-.029c-.322.433-.781.65-1.377.65-.445 0-.805-.143-1.076-.427a1.339 1.339 0 01-.369-.96c0-.576.24-1.015.723-1.319.482-.304 1.16-.453 2.033-.446V10.3c0-.621-.326-.931-.979-.931-.465 0-.875.117-1.229.349l-.213-.688c.438-.271.979-.407 1.617-.407 1.232 0 1.85.65 1.85 1.95v1.736c0 .471.023.846.068 1.124zm-1.088-1.62v-.727c-1.156-.02-1.734.297-1.734.95 0 .246.066.43.201.553a.733.733 0 00.512.184c.23 0 .445-.073.641-.218a.893.893 0 00.38-.742zm7.043 1.62h-.93l-.049-.757h-.029c-.297.576-.803.864-1.514.864-.568 0-1.041-.223-1.416-.669s-.562-1.025-.562-1.736c0-.763.203-1.381.611-1.853.395-.44.879-.66 1.455-.66.633 0 1.076.213 1.328.64h.02V6.556h1.049v5.607c0 .459.012.882.037 1.27zm-1.086-1.988v-.786a1.194 1.194 0 00-.408-.965 1.03 1.03 0 00-.701-.257c-.391 0-.697.155-.922.466-.223.311-.336.708-.336 1.193 0 .466.107.844.322 1.135.227.31.533.465.916.465.344 0 .619-.129.828-.388.202-.239.301-.527.301-.863zm10.049-.408c0 .725-.207 1.319-.621 1.785-.434.479-1.008.718-1.727.718-.691 0-1.242-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.713-.698c.691 0 1.248.229 1.668.688.4.446.601 1.022.601 1.726zm-1.086.034c0-.435-.094-.808-.281-1.119-.221-.376-.533-.564-.941-.564-.42 0-.74.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .715-.191.941-.574.193-.317.291-.693.291-1.128zm6.721 2.362h-1.047v-2.7c0-.832-.316-1.248-.951-1.248-.311 0-.562.114-.756.343s-.291.499-.291.808v2.796h-1.049v-3.366c0-.414-.012-.863-.037-1.349h.92l.049.737h.029a1.53 1.53 0 01.543-.569c.285-.176.602-.265.951-.265.439 0 .805.142 1.096.427.363.349.543.87.543 1.562v2.824zm7.053-3.929h-1.154v2.29c0 .582.205.873.611.873.188 0 .344-.016.467-.049l.027.795c-.207.078-.479.117-.814.117-.414 0-.736-.126-.969-.378-.234-.252-.35-.676-.35-1.271V9.504h-.689v-.785h.689v-.864l1.027-.31v1.173h1.154v.786zm5.548 3.929h-1.049v-2.68c0-.845-.316-1.268-.949-1.268-.486 0-.818.245-1 .735a1.317 1.317 0 00-.049.377v2.835h-1.047V6.556h1.047v2.841h.02c.33-.517.803-.775 1.416-.775.434 0 .793.142 1.078.427.355.355.533.883.533 1.581v2.803zm5.723-2.58c0 .188-.014.346-.039.475h-3.143c.014.466.164.821.455 1.067.266.22.609.33 1.029.33.465 0 .889-.074 1.271-.223l.164.728c-.447.194-.973.291-1.582.291-.73 0-1.305-.215-1.721-.645-.418-.43-.625-1.007-.625-1.731 0-.711.193-1.303.582-1.775.406-.504.955-.756 1.648-.756.678 0 1.193.252 1.541.756.281.4.42.895.42 1.483zm-1-.271a1.411 1.411 0 00-.203-.805c-.182-.291-.459-.437-.834-.437a.995.995 0 00-.834.427 1.586 1.586 0 00-.311.815h2.182z"
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/ui/src/components/icons/PlayStore.tsx



var PlayStore = function PlayStore() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5435.8 1604",
    width: "135",
    height: "40",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fillRule: "evenodd",
      d: "M5234.4 1604h-5033C90.4 1604 0 1513.6 0 1403.5v-1203C0 90 90.4 0 201.4 0h5033c110.9 0 201.4 90 201.4 200.5v1203c0 110.1-90.5 200.5-201.4 200.5z",
      clipRule: "evenodd"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "#a6a6a6",
      fillRule: "evenodd",
      d: "M5234.4 32.1c93.1 0 169.3 75.7 169.3 168.4v1203c0 92.7-75.7 168.4-169.3 168.4h-5033c-93.1 0-169.3-75.7-169.3-168.4v-1203c0-92.7 75.7-168.4 169.3-168.4h5033zm0-32.1h-5033C90.4 0 0 90.4 0 200.5v1203C0 1514 90.4 1604 201.4 1604h5033c110.9 0 201.4-90 201.4-200.5v-1203C5435.8 90.4 5345.3 0 5234.4 0z",
      clipRule: "evenodd"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "#fff",
      d: "M2863.6 530.6c-36.3 0-66.9-12.7-91.1-37.7-24-24.3-37.4-57.8-36.8-92 0-36.5 12.4-67.4 36.8-91.9 24.1-25 54.7-37.7 91-37.7 35.9 0 66.5 12.7 91.1 37.7 24.4 25.3 36.8 56.2 36.8 91.9-.4 36.6-12.8 67.5-36.8 91.9-24.1 25.2-54.7 37.8-91 37.8zm-1080.1 0c-35.5 0-66.3-12.5-91.5-37.2-25-24.6-37.7-55.7-37.7-92.4s12.7-67.8 37.7-92.4c24.7-24.7 55.5-37.2 91.5-37.2 17.6 0 34.7 3.5 51.1 10.6 16.1 6.9 29.2 16.3 38.9 27.8l2.4 2.9-27.1 26.6-2.8-3.3c-15.3-18.2-35.8-27.1-62.9-27.1-24.2 0-45.3 8.6-62.7 25.6-17.5 17.1-26.4 39.5-26.4 66.6s8.9 49.5 26.4 66.6c17.4 17 38.5 25.6 62.7 25.6 25.8 0 47.5-8.6 64.4-25.6 10-10 16.2-24 18.4-41.7H1779v-37.4h124.2l.5 3.4c.9 6.3 1.8 12.8 1.8 18.8 0 34.5-10.4 62.4-31 83-23.4 24.4-54 36.8-91 36.8zm1436.1-5.3h-38.3L3064 337.6l1 33.8v153.8h-38.3V276.7h43.7l1.2 1.9 110.3 176.8-1-33.7v-145h38.7v248.6zm-643.8 0H2537V314.1h-67.3v-37.4H2643v37.4h-67.3v211.2zm-137.7 0h-38.7V276.7h38.7v248.6zm-217.5 0h-38.7V314.1h-67.3v-37.4h173.3v37.4h-67.3v211.2zm-130.5-.4h-148.4V276.7h148.4v37.4h-109.6v68.2h98.9v37h-98.9v68.2h109.6v37.4zm710.8-57.7c17.3 17.3 38.3 26 62.7 26 25.1 0 45.6-8.5 62.7-26 17-17 25.6-39.3 25.6-66.2s-8.6-49.3-25.5-66.2c-17.3-17.3-38.4-26-62.7-26-25.1 0-45.6 8.5-62.6 26-17 17-25.6 39.3-25.6 66.2s8.5 49.3 25.4 66.2z"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M2732.1 872.4c-94.5 0-171.1 71.7-171.1 170.6 0 98 77.1 170.6 171.1 170.6 94.5 0 171.1-72.2 171.1-170.6 0-98.9-76.6-170.6-171.1-170.6zm0 273.6c-51.7 0-96.2-42.8-96.2-103.4 0-61.5 44.6-103.4 96.2-103.4 51.7 0 96.2 41.9 96.2 103.4.1 61-44.5 103.4-96.2 103.4zm-373.3-273.6c-94.5 0-171.1 71.7-171.1 170.6 0 98 77.1 170.6 171.1 170.6 94.5 0 171.1-72.2 171.1-170.6 0-98.9-76.7-170.6-171.1-170.6zm0 273.6c-51.7 0-96.2-42.8-96.2-103.4 0-61.5 44.6-103.4 96.2-103.4 51.7 0 96.2 41.9 96.2 103.4 0 61-44.5 103.4-96.2 103.4zm-444.2-221.5v72.2h173.3c-5.3 40.5-18.7 70.4-39.2 90.9-25.4 25.4-64.6 53-133.7 53-106.5 0-189.8-86-189.8-192.5s83.3-192.5 189.8-192.5c57.5 0 99.4 22.7 130.5 51.7l51.2-51.2c-43.2-41.4-100.7-73.1-181.3-73.1-146.1 0-268.7 119-268.7 264.7 0 146.1 122.5 264.7 268.7 264.7 78.9 0 138.1-25.8 184.9-74.4 47.7-47.7 62.8-115 62.8-169.3 0-16.9-1.3-32.1-4-45h-244.6c.1-.1.1.8.1.8zm1816.9 56.2C3717.2 942.4 3674 872 3585.4 872c-87.8 0-160.8 69.1-160.8 170.6 0 95.8 72.2 170.6 169.3 170.6 78 0 123.4-47.7 142.1-75.7l-57.9-38.8c-19.2 28.5-45.9 47.2-83.8 47.2-38.3 0-65.1-17.4-82.9-51.7l228.1-94.5c0 .1-8-19-8-19zm-232.6 57c-1.8-65.9 51.2-99.4 89.1-99.4 29.9 0 54.8 14.7 63.3 36.1l-152.4 63.3zM3313.6 1203h74.9V701.8h-74.9V1203zm-123-292.7h-2.7c-16.9-20.1-49-38.3-90-38.3-85.1 0-163.5 74.9-163.5 171.1 0 95.8 78 169.8 163.5 169.8 40.5 0 73.1-18.3 90-38.8h2.7v24.5c0 65.1-34.8 100.2-90.9 100.2-45.9 0-74.4-33-86-60.6l-65.1 27.2c18.7 45 68.6 100.7 151 100.7 87.8 0 162.2-51.7 162.2-177.8V882.2H3191v28.1h-.4zm-86 235.7c-51.7 0-94.9-43.2-94.9-102.9 0-60.2 43.2-103.8 94.9-103.8 51.2 0 90.9 44.1 90.9 103.8.5 59.7-39.6 102.9-90.9 102.9zm977.6-444.2h-179.1V1203h74.9v-189.8h104.3c82.9 0 164.4-60.1 164.4-155.5s-81.2-155.9-164.5-155.9zm2.2 241.4h-106.5v-172h106.5c56.1 0 87.8 46.3 87.8 86 0 39.3-32.1 86-87.8 86zm462.5-71.7c-54.4 0-110.5 24.1-133.7 76.6l66.4 27.6c14.3-27.6 40.5-37 68.2-37 38.8 0 78 23.2 78.9 64.6v5.3c-13.4-7.6-42.8-19.2-78-19.2-71.7 0-144.4 39.2-144.4 112.7 0 67.3 58.8 110.5 124.3 110.5 50.3 0 78-22.7 95.3-49h2.7v38.8h72.2v-192c0-89.4-66.4-138.9-151.9-138.9zm-9.4 274.5c-24.5 0-58.8-12-58.8-42.8 0-38.8 42.8-53.5 79.3-53.5 33 0 48.6 7.1 68.2 16.9-5.4 45-43.4 79-88.7 79.4zm424.7-263.8l-86 217.4h-2.7l-89.1-217.4h-80.6l133.7 303.9-76.2 168.9h78L5045 882.2h-82.8zM4288 1203h74.9V701.8H4288V1203z",
      clipRule: "evenodd"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "a",
      x1: "1682.108",
      x2: "1624.292",
      y1: "1339.478",
      y2: "1309.634",
      gradientTransform: "matrix(11.64 0 0 -22.55 -18705.596 30554.37)",
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0",
        stopColor: "#00a0ff"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0.007",
        stopColor: "#00a1ff"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0.26",
        stopColor: "#00beff"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0.512",
        stopColor: "#00d2ff"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0.76",
        stopColor: "#00dfff"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "1",
        stopColor: "#00e3ff"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "url(#a)",
      fillRule: "evenodd",
      d: "M418.4 302.1c-11.6 12.5-18.3 31.6-18.3 56.6v886.7c0 25 6.7 44.1 18.7 56.1l3.1 2.7 496.8-496.8v-11.1L421.5 299.4l-3.1 2.7z",
      clipRule: "evenodd"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "b",
      x1: "1712.662",
      x2: "1606.561",
      y1: "1274.838",
      y2: "1274.838",
      gradientTransform: "matrix(9.145 0 0 -7.7 -14305.538 10618.251)",
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0",
        stopColor: "#ffe000"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0.409",
        stopColor: "#ffbd00"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0.775",
        stopColor: "orange"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "1",
        stopColor: "#ff9c00"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "url(#b)",
      fillRule: "evenodd",
      d: "M1084 973.5L918.3 807.8v-11.6L1084 630.5l3.6 2.2 196 111.4c56.1 31.6 56.1 83.8 0 115.8l-196 111.4-3.6 2.2z",
      clipRule: "evenodd"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "c",
      x1: "1707.441",
      x2: "1646.682",
      y1: "1290.047",
      y2: "1211.223",
      gradientTransform: "matrix(15.02 0 0 -11.5775 -24650.229 15829.648)",
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0",
        stopColor: "#ff3a44"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "1",
        stopColor: "#c31162"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "url(#c)",
      fillRule: "evenodd",
      d: "M1087.6 971.3L918.3 802l-499.9 499.9c18.3 19.6 49 21.8 83.3 2.7l585.9-333.3",
      clipRule: "evenodd"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "d",
      x1: "1660.636",
      x2: "1687.767",
      y1: "1365.668",
      y2: "1330.45",
      gradientTransform: "matrix(15.02 0 0 -11.5715 -24650.229 15809.992)",
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0",
        stopColor: "#32a071"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0.069",
        stopColor: "#2da771"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0.476",
        stopColor: "#15cf74"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "0.801",
        stopColor: "#06e775"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: "1",
        stopColor: "#00f076"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "url(#d)",
      fillRule: "evenodd",
      d: "M1087.6 632.7L501.7 299.9c-34.3-19.6-65.1-16.9-83.3 2.7L918.3 802l169.3-169.3z",
      clipRule: "evenodd"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fillRule: "evenodd",
      d: "M1084 967.7l-581.9 330.6c-32.5 18.7-61.5 17.4-80.2.4l-3.1 3.1 3.1 2.7c18.7 16.9 47.7 18.3 80.2-.4L1088 971.3l-4-3.6z",
      clipRule: "evenodd",
      opacity: "0.2"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fillRule: "evenodd",
      d: "M1283.6 854.1l-200.1 113.6 3.6 3.6 196-111.4c28.1-16 41.9-37 41.9-57.9-1.7 19.2-16 37.4-41.4 52.1z",
      clipRule: "evenodd",
      opacity: "0.12"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M501.7 305.7l781.9 444.2c25.4 14.3 39.7 33 41.9 52.1 0-20.9-13.8-41.9-41.9-57.9L501.7 299.9c-56.1-32.1-101.6-5.3-101.6 58.8v5.8c0-64.2 45.5-90.5 101.6-58.8z",
      clipRule: "evenodd",
      opacity: "0.25"
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/DownloadLinks.tsx






var DownloadLinks_Wrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "er053gq0"
} : 0)("display:flex;flex-flow:column wrap;@media ", devices/* device.mobile */.U.mobile, "{flex-flow:row nowrap;}>*{margin-bottom:10px;&:last-child{margin-bottom:0;}@media ", devices/* device.mobile */.U.mobile, "{margin:0 20px;}}" + ( true ? "" : 0));

var DownloadLinks = function DownloadLinks(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DownloadLinks_Wrap, {
      children: children
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/DownloadLinksContainer.tsx






var DownloadLinksContainer = function DownloadLinksContainer(_ref) {
  var app_store = _ref.app_store,
      google_play = _ref.google_play,
      apple_link_text = _ref.apple_link_text,
      google_link_text = _ref.google_link_text;
  var appleLinkText = Prismic/* Prismic.text */.X5.text(apple_link_text);
  var appstore = app_store ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: app_store,
    title: appleLinkText !== null && appleLinkText !== void 0 ? appleLinkText : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgButton, {
      title: appleLinkText !== null && appleLinkText !== void 0 ? appleLinkText : '',
      target: "_blank",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Appstore, {})
    })
  }) : null;
  var googleLinkText = Prismic/* Prismic.text */.X5.text(google_link_text);
  var googlePlay = google_play ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: google_play,
    title: googleLinkText !== null && googleLinkText !== void 0 ? googleLinkText : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgButton, {
      title: googleLinkText !== null && googleLinkText !== void 0 ? googleLinkText : '',
      target: "_blank",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayStore, {})
    })
  }) : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DownloadLinks, {
      children: [appstore, googlePlay]
    })
  });
};
// EXTERNAL MODULE: ../../packages/prismic/src/Embed.tsx
var Embed = __webpack_require__(10367);
;// CONCATENATED MODULE: ../../packages/slices/src/containers/EmbedContainer.tsx







function getEmbedHtml(embed) {
  if (!embed || lodash_isempty_default()(embed)) {
    return null;
  }

  return (0,Embed/* getRichTextEmbedHtml */.h)(embed);
}

var EmbedContainer = function EmbedContainer(_ref) {
  var embed = _ref.embed,
      embed2 = _ref.embed2,
      height = _ref.height;
  var html1 = getEmbedHtml(embed);
  var html2 = getEmbedHtml(embed2); // set height to 9/16 if no height

  var correctHeight = height ? height / theme/* theme.pageWidth */.r.pageWidth : 9 / 16;

  if (html2) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* Container */.W, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          width: 1 / 2,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Embed/* Embed */.c, {
            type: "inline",
            html: html1,
            ar: correctHeight
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          width: 1 / 2,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Embed/* Embed */.c, {
            type: "inline",
            html: html2,
            ar: correctHeight
          })
        })]
      })
    });
  }

  if (!html1) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Embed/* Embed */.c, {
    html: html1,
    ar: correctHeight
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/Emphasis.tsx






var Emphasis_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e13w7wu00"
} : 0)("p{", typography/* typography.bodyEditorial */.cp.bodyEditorial, ";font-weight:bold;}" + ( true ? "" : 0));

var Emphasis = function Emphasis(_ref) {
  var copy = _ref.copy,
      isArticle = _ref.isArticle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Emphasis_Copy, {
      children: copy
    }),
    isArticle: isArticle
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/EmphasisContainer.tsx





var EmphasisContainer = function EmphasisContainer(_ref) {
  var copy = _ref.copy,
      template = _ref.template;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var isArticle = template === 'article';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Emphasis, {
      copy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy,
        isArticle: isArticle
      }),
      isArticle: isArticle
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../packages/ui/src/components/form/checkbox/Checkbox.tsx
var Checkbox = __webpack_require__(25471);
// EXTERNAL MODULE: ../../packages/ui/src/validation/useKennitalaValidation.ts
var useKennitalaValidation = __webpack_require__(11776);
// EXTERNAL MODULE: ../../packages/ui/src/validation/usePhoneValidation.ts
var usePhoneValidation = __webpack_require__(51539);
// EXTERNAL MODULE: ../../packages/ui/src/components/form/text/FormTitle.tsx
var FormTitle = __webpack_require__(36704);
// EXTERNAL MODULE: ../../packages/ui/src/components/form/contact-input/PhoneInput.tsx
var contact_input_PhoneInput = __webpack_require__(8422);
;// CONCATENATED MODULE: ../../packages/ui/src/components/form/contact-input/EmaiInput.tsx



function EmaiInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function EmaiInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EmaiInput_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EmaiInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var EmaiInput_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1exibjo0"
} : 0)( true ? "" : 0);

function EmaiInput_EmailInput(_ref) {
  var rest = Object.assign({}, _ref);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmaiInput_Host, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, EmaiInput_objectSpread({}, rest))
  });
}
// EXTERNAL MODULE: ../../packages/ui/src/components/form/number-input/NumberInput.tsx
var NumberInput = __webpack_require__(90242);
// EXTERNAL MODULE: ../../node_modules/lodash.keyby/index.js
var lodash_keyby = __webpack_require__(30603);
var lodash_keyby_default = /*#__PURE__*/__webpack_require__.n(lodash_keyby);
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/EventRegistration/eventRegistration.ts


var eventRegistration_templateObject;


var getEvent = (0,lib/* gql */.Ps)(eventRegistration_templateObject || (eventRegistration_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query getEvent($id: String!) {\n    node(id: $id) {\n      ... on EventRegistration {\n        id\n        name\n        maxNumberOfRegistrations\n        numberRegistered\n        registrationOpens\n        registrationCloses\n        status\n        waitlistAvailable\n      }\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/EventRegistration/registerEvent.ts


var registerEvent_templateObject;


var registerEvent = (0,lib/* gql */.Ps)(registerEvent_templateObject || (registerEvent_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation registerEvent(\n    $id: String!\n    $model: EventRegistrationCustomerInput!\n  ) {\n    registerToEvent(data: { id: $id, model: $model }) {\n      name\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/event-registration/EventRegistration.tsx






function EventRegistration_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function EventRegistration_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EventRegistration_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EventRegistration_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function EventRegistration_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck













var EventRegistration_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejm1d5h7"
} : 0)( true ? "" : 0);

var EventRegistration_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "ejm1d5h6"
} : 0)(typography/* typography.h2Big */.cp.h2Big, ";margin-bottom:20px;" + ( true ? "" : 0));

var EventRegistration_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejm1d5h5"
} : 0)("margin-top:20px;", typography/* typography.body */.cp.body, ";" + ( true ? "" : 0));

var MarginRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "ejm1d5h4"
} : 0)( true ? {
  name: "1av4xm2",
  styles: "margin-top:140px;margin-bottom:72px"
} : 0);

var BigButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "ejm1d5h3"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var CheckboxCenter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Checkbox/* Checkbox */.XZ,  true ? {
  target: "ejm1d5h2"
} : 0)("display:block;@media ", devices/* device.tablet */.U.tablet, "{display:flex;justify-content:center;align-items:center;height:100%;}" + ( true ? "" : 0));

var FormSpacer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejm1d5h1"
} : 0)("height:1px;background:", function (props) {
  return (0,polished_esm/* rgba */.m4)(props.theme.colors.primary, 0.1);
}, ";", function (props) {
  return props.smallTop ? 'margin-top: 20px;' : 'margin-top: 40px;';
}, ";margin-bottom:57px;" + ( true ? "" : 0));

var NoPaddingSegment = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Segment/* Segment */.X,  true ? {
  target: "ejm1d5h0"
} : 0)("padding-top:20px;padding-bottom:0;margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{margin-left:initial;margin-right:initial;}&:last-of-type{padding-bottom:57px;}" + ( true ? "" : 0));

function EventRegistration(_ref) {
  var use_phonenumber = _ref.use_phonenumber,
      use_kennitala = _ref.use_kennitala,
      use_company_name = _ref.use_company_name,
      use_company_kennitala = _ref.use_company_kennitala,
      fields = _ref.fields,
      title = _ref.title,
      description = _ref.description,
      max_number_registering = _ref.max_number_registering,
      max_number_registering_label = _ref.max_number_registering_label,
      event_id = _ref.event_id;

  var _useState = (0,react.useState)(false),
      submitted = _useState[0],
      setSubmitted = _useState[1];

  var _useState2 = (0,react.useState)(''),
      errorText = _useState2[0],
      setErrorText = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      successText = _useState3[0],
      setSuccessText = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      name = _useState4[0],
      setName = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      email = _useState5[0],
      setEmail = _useState5[1];

  var _useEmailValidation = (0,useEmailValidation/* useEmailValidation */.$)(email),
      _useEmailValidation2 = (0,slicedToArray/* default */.Z)(_useEmailValidation, 3),
      emailRef = _useEmailValidation2[0],
      isEmailValid = _useEmailValidation2[1],
      errorMessageEmail = _useEmailValidation2[2];

  var _useState6 = (0,react.useState)(''),
      ssn = _useState6[0],
      setSSN = _useState6[1];

  var _useKennitalaValidati = (0,useKennitalaValidation/* useKennitalaValidation */.S)(ssn),
      _useKennitalaValidati2 = (0,slicedToArray/* default */.Z)(_useKennitalaValidati, 3),
      kennitalaRef = _useKennitalaValidati2[0],
      isKennitalaValid = _useKennitalaValidati2[1],
      errorMessageSSN = _useKennitalaValidati2[2];

  var _useState7 = (0,react.useState)(''),
      phonenumber = _useState7[0],
      setPhonenumber = _useState7[1];

  var _usePhoneValidation = (0,usePhoneValidation/* usePhoneValidation */.p)(phonenumber),
      _usePhoneValidation2 = (0,slicedToArray/* default */.Z)(_usePhoneValidation, 3),
      phoneRef = _usePhoneValidation2[0],
      isPhoneValid = _usePhoneValidation2[1],
      errorMessagePhone = _usePhoneValidation2[2];

  var _useState8 = (0,react.useState)(''),
      companyName = _useState8[0],
      setCompanyName = _useState8[1];

  var _useState9 = (0,react.useState)(''),
      companySSN = _useState9[0],
      setCompanySSN = _useState9[1];

  var _useKennitalaValidati3 = (0,useKennitalaValidation/* useKennitalaValidation */.S)(companySSN),
      _useKennitalaValidati4 = (0,slicedToArray/* default */.Z)(_useKennitalaValidati3, 3),
      companyKennitalaRef = _useKennitalaValidati4[0],
      isCompanyKennitalaValid = _useKennitalaValidati4[1],
      errorMessageCompanySSN = _useKennitalaValidati4[2];

  var _useState10 = (0,react.useState)(1),
      numberRegistrations = _useState10[0],
      setMaxNumberRegistering = _useState10[1];

  var _useState11 = (0,react.useState)(lodash_keyby_default()(fields, function (i) {
    return Prismic/* Prismic.text */.X5.text(i.field_name);
  })),
      fieldValues = _useState11[0],
      setFields = _useState11[1];

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useQuery = (0,useQuery/* useQuery */.a)(getEvent, {
    variables: {
      id:  true && window.btoa("EventRegistration:".concat(event_id))
    },
    client: client
  }),
      data = _useQuery.data,
      loading = _useQuery.loading;

  var _useMutation = (0,useMutation/* useMutation */.D)(registerEvent, {
    client: client,
    onCompleted: function onCompleted() {
      setSuccessText('Skráning á biðlista tókst!');
      setSubmitted(true);
    }
  }),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 1),
      eventRegistration = _useMutation2[0];

  function onFormSubmit(_x) {
    return _onFormSubmit.apply(this, arguments);
  }

  function _onFormSubmit() {
    _onFormSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event) {
      var attributes, _key;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              attributes = [];

              for (_key in fieldValues) {
                if (fieldValues.hasOwnProperty(_key) && fieldValues[_key].value !== undefined) {
                  attributes.push({
                    label: _key,
                    value: fieldValues[_key].value
                  });
                }
              }

              eventRegistration({
                variables: {
                  id: event_id,
                  model: {
                    name: name,
                    email: email,
                    kennitala: ssn,
                    numberRegistering: numberRegistrations,
                    companykennitala: companySSN,
                    companyname: companyName,
                    phonenumber: phonenumber,
                    attributes: attributes
                  }
                }
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _onFormSubmit.apply(this, arguments);
  }

  var formData = data !== null && data !== void 0 && data.node && (data === null || data === void 0 ? void 0 : data.node.__typename) === 'EventRegistration' ? data.node : undefined;

  if (loading || !formData) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: "Hle\xF0ur.."
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventRegistration_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarginRow, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        lg: {
          width: 6 / 12
        },
        md: {
          width: 12 / 12
        },
        sm: {
          width: 12 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventRegistration_Title, {
          children: title
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        lg: {
          width: 6 / 12
        },
        md: {
          width: 12 / 12
        },
        sm: {
          width: 12 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventRegistration_Text, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
            value: description
          })
        })
      })]
    }), errorText && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: errorText
    }), successText !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: successText
    }), !submitted && (formData.status === 'open' || formData.status === 'waitlist') && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoPaddingSegment, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: onFormSubmit,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormTitle/* FormTitle */.v, {
          text: formData.status === 'waitlist' ? 'Skráning á biðlista' : 'Skráning'
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12
            },
            md: {
              width: 6 / 12
            },
            sm: {
              width: 12 / 12
            },
            style: {
              marginBottom: '32px'
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
              label: "Nafn",
              type: "text",
              value: name,
              onChange: function onChange(e) {
                return setName(e.currentTarget.value);
              },
              inputSize: "big"
            })
          }), use_phonenumber && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 3 / 12,
              offsetRight: 3 / 12
            },
            md: {
              width: 6 / 12
            },
            sm: {
              width: 12 / 12
            },
            style: {
              marginBottom: '32px'
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contact_input_PhoneInput/* PhoneInput */.s, {
              label: "S\xEDman\xFAmer",
              value: phonenumber,
              onChange: function onChange(e) {
                return setPhonenumber(e.currentTarget.value);
              },
              ref: phoneRef,
              isValid: isPhoneValid,
              errorMessage: errorMessagePhone,
              inputSize: "big"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12
            },
            md: {
              width: 6 / 12
            },
            sm: {
              width: 12 / 12
            },
            style: {
              marginBottom: '32px'
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmaiInput_EmailInput, {
              label: "Netfang",
              value: email,
              onChange: function onChange(e) {
                return setEmail(e.currentTarget.value);
              },
              ref: emailRef,
              isValid: isEmailValid,
              errorMessage: errorMessageEmail,
              inputSize: "big"
            })
          }), use_kennitala && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12
            },
            md: {
              width: 6 / 12
            },
            sm: {
              width: 12 / 12
            },
            style: {
              marginBottom: '32px'
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Kennitalanput/* KennitalaInput */.t, {
              label: "Kennitala",
              value: ssn,
              onChange: function onChange(e) {
                return setSSN(e.currentTarget.value);
              },
              ref: kennitalaRef,
              isValid: isKennitalaValid,
              errorMessage: errorMessageSSN,
              inputSize: "big"
            })
          }), fields && fields.filter(function (x) {
            return x.field_position === 'Person';
          }).map(function (label, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [label.field_type === 'Text' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                lg: label.field_size === 'Big' ? {
                  width: 6 / 12
                } : label.field_size === 'Medium' ? {
                  width: 4 / 12
                } : {
                  width: 12 / 12
                },
                md: {
                  width: 6 / 12
                },
                sm: {
                  width: 12 / 12
                },
                style: {
                  marginBottom: '32px'
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
                  label: Prismic/* Prismic.text */.X5.text(label.field_name),
                  value: fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)].value,
                  inputSize: "big",
                  onChange: function onChange(e) {
                    return setFields(EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues), {}, (0,defineProperty/* default */.Z)({}, Prismic/* Prismic.text */.X5.text(label.field_name), EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)]), {}, {
                      value: e.currentTarget.value
                    }))));
                  }
                })
              }, "person-".concat(key)), label.field_type === 'Boolean' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                lg: {
                  width: 4 / 12
                },
                md: {
                  width: 6 / 12
                },
                sm: {
                  width: 12 / 12
                },
                style: {
                  marginBottom: '32px'
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* Checkbox */.XZ, {
                  checked: fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)].value === 'true' ? true : false,
                  onChange: function onChange(e) {
                    return setFields(EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues), {}, (0,defineProperty/* default */.Z)({}, Prismic/* Prismic.text */.X5.text(label.field_name), EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)]), {}, {
                      value: e ? 'true' : 'false'
                    }))));
                  },
                  id: "event-registration-checkbox-person-".concat(key),
                  label: Prismic/* Prismic.text */.X5.text(label.field_name)
                })
              }, "person-".concat(key))]
            });
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSpacer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
          children: [use_company_name && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12
            },
            md: {
              width: 6 / 12
            },
            sm: {
              width: 12 / 12
            },
            style: {
              marginBottom: '32px'
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
              label: "Nafn fyrirt\xE6kis",
              type: "text",
              value: companyName,
              onChange: function onChange(e) {
                return setCompanyName(e.currentTarget.value);
              },
              inputSize: "big"
            })
          }), use_company_kennitala && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 3 / 12
            },
            md: {
              width: 6 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Kennitalanput/* KennitalaInput */.t, {
              label: "Kennitala fyrirt\xE6kis",
              type: "text",
              value: companySSN,
              onChange: function onChange(e) {
                return setCompanySSN(e.currentTarget.value);
              },
              ref: companyKennitalaRef,
              isValid: isCompanyKennitalaValid,
              errorMessage: errorMessageCompanySSN,
              inputSize: "big"
            })
          }), fields && fields.filter(function (x) {
            return x.field_position === 'Company';
          }).map(function (label, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [label.field_type === 'Text' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                lg: label.field_size === 'Big' ? {
                  width: 6 / 12
                } : label.field_size === 'Medium' ? {
                  width: 4 / 12
                } : {
                  width: 12 / 12
                },
                md: {
                  width: 6 / 12
                },
                sm: {
                  width: 12 / 12
                },
                style: {
                  marginBottom: '32px'
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
                  label: Prismic/* Prismic.text */.X5.text(label.field_name),
                  value: fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)].value,
                  inputSize: "big",
                  onChange: function onChange(e) {
                    return setFields(EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues), {}, (0,defineProperty/* default */.Z)({}, Prismic/* Prismic.text */.X5.text(label.field_name), EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)]), {}, {
                      value: e.currentTarget.value
                    }))));
                  }
                })
              }, "company-".concat(key)), label.field_type === 'Boolean' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                lg: {
                  width: 3 / 12
                },
                md: {
                  width: 6 / 12
                },
                sm: {
                  width: 12 / 12
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxCenter, {
                  checked: fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)].value === 'true' ? true : false,
                  onChange: function onChange(e) {
                    return setFields(EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues), {}, (0,defineProperty/* default */.Z)({}, Prismic/* Prismic.text */.X5.text(label.field_name), EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)]), {}, {
                      value: e ? 'true' : 'false'
                    }))));
                  },
                  id: "event-registration-checkbox-company-".concat(key),
                  label: Prismic/* Prismic.text */.X5.text(label.field_name)
                })
              }, "company-".concat(key))]
            });
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSpacer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
          children: fields && fields.filter(function (x) {
            return x.field_position === 'Spouse';
          }).map(function (label, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [label.field_type === 'Text' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                lg: label.field_size === 'Big' ? {
                  width: 6 / 12
                } : label.field_size === 'Medium' ? {
                  width: 4 / 12
                } : {
                  width: 12 / 12
                },
                md: {
                  width: 6 / 12
                },
                sm: {
                  width: 12 / 12
                },
                style: {
                  marginBottom: '32px'
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
                  label: Prismic/* Prismic.text */.X5.text(label.field_name),
                  value: fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)].value,
                  inputSize: "big",
                  onChange: function onChange(e) {
                    return setFields(EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues), {}, (0,defineProperty/* default */.Z)({}, Prismic/* Prismic.text */.X5.text(label.field_name), EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)]), {}, {
                      value: e.currentTarget.value
                    }))));
                  }
                })
              }, "spouse-".concat(key)), label.field_type === 'Boolean' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                lg: {
                  width: 3 / 12
                },
                md: {
                  width: 6 / 12
                },
                sm: {
                  width: 12 / 12
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxCenter, {
                  checked: fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)].value === 'true' ? true : false,
                  onChange: function onChange(e) {
                    return setFields(EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues), {}, (0,defineProperty/* default */.Z)({}, Prismic/* Prismic.text */.X5.text(label.field_name), EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)]), {}, {
                      value: e ? 'true' : 'false'
                    }))));
                  },
                  id: "event-registration-checkbox-spouse-".concat(key),
                  label: Prismic/* Prismic.text */.X5.text(label.field_name)
                })
              }, "spouse-".concat(key))]
            });
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSpacer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
          children: [fields && fields.filter(function (x) {
            return x.field_position === 'Other';
          }).map(function (label, key) {
            (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [label.field_type === 'Text' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
                  label: Prismic/* Prismic.text */.X5.text(label.field_name),
                  value: fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)].value,
                  inputSize: "big",
                  onChange: function onChange(e) {
                    return setFields(EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues), {}, (0,defineProperty/* default */.Z)({}, Prismic/* Prismic.text */.X5.text(label.field_name), EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)]), {}, {
                      value: e.currentTarget.value
                    }))));
                  }
                })
              }, "other-".concat(key)), label.field_type === 'Boolean' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                lg: {
                  width: 3 / 12
                },
                md: {
                  width: 6 / 12
                },
                sm: {
                  width: 12 / 12
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* Checkbox */.XZ, {
                  checked: fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)].value === 'true' ? true : false,
                  onChange: function onChange(e) {
                    return setFields(EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues), {}, (0,defineProperty/* default */.Z)({}, Prismic/* Prismic.text */.X5.text(label.field_name), EventRegistration_objectSpread(EventRegistration_objectSpread({}, fieldValues[Prismic/* Prismic.text */.X5.text(label.field_name)]), {}, {
                      value: e ? 'true' : 'false'
                    }))));
                  },
                  id: "event-registration-checkbox-other-".concat(key),
                  label: Prismic/* Prismic.text */.X5.text(label.field_name)
                })
              }, "other-".concat(key))]
            });
          }), formData.maxNumberOfRegistrations && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12
            },
            md: {
              width: 6 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberInput/* NumberInput */.Y, {
              id: "max_number",
              label: max_number_registering_label !== null ? max_number_registering_label : "Fj\xF6ldi mi\xF0a (h\xE1mark ".concat(max_number_registering, ")"),
              value: numberRegistrations,
              onChange: function onChange(val) {
                if (val < max_number_registering) {
                  setMaxNumberRegistering(val);
                }
              }
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSpacer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12,
              offset: 6 / 12
            },
            md: {
              width: 6 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BigButton, {
              bg: theme/* theme.colors.primary */.r.colors.primary,
              title: "Senda",
              type: "submit"
            })
          })
        })]
      })
    }), !submitted && formData.status === 'full' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: "\xDEv\xED mi\xF0ur er fullt \xE1 \xFEennan vi\xF0bur\xF0."
    }), !submitted && formData.status === 'closed' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: "Skr\xE1ningarfrestur fyrir \xFEennan vi\xF0bur\xF0 er \xFAtrunninn."
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/EventRegistrationContainer.tsx


var EventRegistrationContainer_excluded = ["event_id", "image", "title", "max_number_registering_label", "max_number_registering"];

function EventRegistrationContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function EventRegistrationContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EventRegistrationContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EventRegistrationContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var EventRegistrationContainer = function EventRegistrationContainer(_ref) {
  var _Prismic$text, _Prismic$text2, _Prismic$text3;

  var event_id = _ref.event_id,
      image = _ref.image,
      title = _ref.title,
      max_number_registering_label = _ref.max_number_registering_label,
      max_number_registering = _ref.max_number_registering,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, EventRegistrationContainer_excluded);

  if ((0,isEmptyText/* isEmptyText */.W)(event_id)) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventRegistration, EventRegistrationContainer_objectSpread(EventRegistrationContainer_objectSpread({}, rest), {}, {
      title: (_Prismic$text = Prismic/* Prismic.text */.X5.text(title)) !== null && _Prismic$text !== void 0 ? _Prismic$text : '',
      event_id: (_Prismic$text2 = Prismic/* Prismic.text */.X5.text(event_id)) !== null && _Prismic$text2 !== void 0 ? _Prismic$text2 : '',
      max_number_registering_label: (_Prismic$text3 = Prismic/* Prismic.text */.X5.text(max_number_registering_label)) !== null && _Prismic$text3 !== void 0 ? _Prismic$text3 : '',
      max_number_registering: max_number_registering === null ? 1 : max_number_registering,
      image: image
    }))
  });
};
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
;// CONCATENATED MODULE: ../../packages/slices/src/containers/FaqContainer.tsx








function renderSchemaOrgQuestion(_ref) {
  var item = _ref.item,
      faqItem = _ref.faqItem;
  var theItem = item || faqItem;
  return {
    '@type': 'Question',
    name: Prismic/* Prismic.text */.X5.text(theItem === null || theItem === void 0 ? void 0 : theItem.question),
    acceptedAnswer: {
      '@type': 'Answer',
      text: Prismic/* Prismic.text */.X5.text(theItem === null || theItem === void 0 ? void 0 : theItem.answer)
    }
  };
}

var FaqContainer = function FaqContainer(_ref2) {
  var heading = _ref2.heading,
      single_display = _ref2.single_display,
      fields = _ref2.fields;
  var items = fields === null || fields === void 0 ? void 0 : fields.filter(function (_ref3) {
    var item = _ref3.item,
        faqItem = _ref3.faqItem;
    return item || faqItem;
  });

  if (!items.length) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(head["default"], {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: items.map(renderSchemaOrgQuestion)
          })
        }
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionList, {
      title: Prismic/* Prismic.text */.X5.text(heading),
      singleDisplay: single_display,
      children: items.map(function (_ref4, index) {
        var _Prismic$text;

        var item = _ref4.item,
            faqItem = _ref4.faqItem,
            category = _ref4.category;
        var theItem = item || faqItem;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
          title: (_Prismic$text = Prismic/* Prismic.text */.X5.text(theItem === null || theItem === void 0 ? void 0 : theItem.question)) !== null && _Prismic$text !== void 0 ? _Prismic$text : undefined,
          content: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
            value: theItem === null || theItem === void 0 ? void 0 : theItem.answer
          }),
          category: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
            value: category === null || category === void 0 ? void 0 : category.title
          })
        }, "".concat(index, "-").concat(Prismic/* Prismic.text */.X5.text(theItem === null || theItem === void 0 ? void 0 : theItem.question)));
      })
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/FeaturedArticlesContainer.tsx


function FeaturedArticlesContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FeaturedArticlesContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FeaturedArticlesContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FeaturedArticlesContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function FeaturedArticlesContainer(_ref) {
  var fields = _ref.fields;

  var _useContext = (0,react.useContext)(prismicContext/* PrismicContext */.Z),
      urlResolver = _useContext.urlResolver;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    paddingBottomMobile: 0,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleCardGroup, {
      count: fields.length,
      children: fields.map(function (item, index) {
        var _link$anchorProps$tit;

        var title = (0,fallback/* fallbackText */.mn)(item.a_title, item.a_article.title);
        var abstract = (0,fallback/* fallbackRichText */.K8)(item.a_abstract, item.a_article.abstract);
        var image = (0,fallback/* fallbackImage */.bU)(item.a_image, item.a_article.image);

        var linkObj = FeaturedArticlesContainer_objectSpread({
          _linkType: Prismic/* LinkType.Document */.Un.Document
        }, item === null || item === void 0 ? void 0 : item.a_article);

        var link = Prismic/* Prismic.link */.X5.link(urlResolver, linkObj, title !== null && title !== void 0 ? title : undefined);
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card, {
          title: Prismic/* Prismic.text */.X5.text(title),
          description: abstract,
          image: image,
          ar: "ar_1_1",
          padding: true,
          backgroundAlt: true,
          action: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_link["default"], FeaturedArticlesContainer_objectSpread(FeaturedArticlesContainer_objectSpread({}, link), {}, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowButton/* ArrowButton */.b, FeaturedArticlesContainer_objectSpread(FeaturedArticlesContainer_objectSpread({
              hideText: true
            }, link.anchorProps()), {}, {
              title: (_link$anchorProps$tit = link.anchorProps().title) !== null && _link$anchorProps$tit !== void 0 ? _link$anchorProps$tit : undefined
            }))
          })),
          link: linkObj,
          percentage: 0.33
        }, index);
      })
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/podcast/Podcast.tsx


function Podcast_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Podcast_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ee66nj5"
} : 0)( true ? "" : 0);

var Podcast_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ee66nj4"
} : 0)("display:flex;flex-flow:column nowrap;margin-bottom:60px;@media ", devices/* device.desktop */.U.desktop, "{margin-bottom:0;height:100%;}" + ( true ? "" : 0));

var Podcast_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ee66nj3"
} : 0)(typography/* typography.h3 */.cp.h3, " margin-bottom:14px;" + ( true ? "" : 0));

var Podcast_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ee66nj2"
} : 0)( true ? {
  name: "1diqm02",
  styles: "margin-top:20px;margin-bottom:40px;max-width:292px"
} : 0);

var Podcast_Action = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ee66nj1"
} : 0)("margin-top:auto;a{color:", function (props) {
  return props.theme.shades.ternary5;
}, ";&:hover{opacity:0.8;}}" + ( true ? "" : 0));

var Childs = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ee66nj0"
} : 0)("display:flex;flex-flow:row wrap;@media ", devices/* device.tablet */.U.tablet, "{flex-flow:row nowrap;}>*{margin-bottom:50px;@media ", devices/* device.mobile */.U.mobile, "{width:calc(50% - 10px);margin-left:20px;&:nth-child(odd){margin-left:0;}}@media ", devices/* device.tablet */.U.tablet, "{width:calc(25% - 15px);margin-bottom:0;&:nth-child(odd){margin-left:20px;}&:first-child{margin-left:0;}}}" + ( true ? "" : 0));

var Podcast = function Podcast(_ref) {
  var title = _ref.title,
      text = _ref.text,
      link = _ref.link,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Podcast_Host, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        lg: {
          width: 4 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Podcast_Content, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Podcast_Title, {
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Podcast_Copy, {
            children: text
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Podcast_Action, {
            children: link
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        lg: {
          width: 8 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Childs, {
          children: children
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/icons/Spotify.tsx


var Spotify = function Spotify() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fill: "#1E3D5A",
      d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0012 0zm5 18.1a.9.9 0 01-1.27.08 8.37 8.37 0 00-4.27-1.78 8.4 8.4 0 00-4.57.52.9.9 0 11-.76-1.63 10.07 10.07 0 015.58-.67 10.05 10.05 0 015.2 2.21.9.9 0 01.09 1.27zm1.19-3.78a1 1 0 01-1.41.09 9.35 9.35 0 00-4.75-2 9.33 9.33 0 00-5.11.59 1 1 0 11-.85-1.81 11.21 11.21 0 016.25-.76 11.22 11.22 0 015.79 2.45 1 1 0 01.09 1.44h-.01zm1.58-3.62a1.15 1.15 0 01-1.62.08 10.62 10.62 0 00-5.55-2.35 10.61 10.61 0 00-6 .72 1.15 1.15 0 01-1-2.07 13 13 0 017.29-.93 13 13 0 016.81 2.92 1.15 1.15 0 01.08 1.62l-.01.01z"
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/podcast/PodcastItem.tsx



var PodcastItem_excluded = ["title", "image", "duration"];

function PodcastItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PodcastItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PodcastItem_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PodcastItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function PodcastItem_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var PodcastItem_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "ezebqkr5"
} : 0)( true ? {
  name: "1jdqazf",
  styles: "display:flex;flex-flow:column nowrap;cursor:pointer;&:hover{img:first-child{transform:scale(1.025);}}"
} : 0);

var PodcastItem_Image = (0,emotion_styled_base_browser_esm/* default */.Z)("figure",  true ? {
  target: "ezebqkr4"
} : 0)( true ? {
  name: "22dm6h",
  styles: "margin-bottom:8px;position:relative;&:before{content:'';padding-bottom:100%;}"
} : 0);

var PodcastItem_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezebqkr3"
} : 0)( true ? {
  name: "1ayp5n7",
  styles: "margin-bottom:14px"
} : 0);

var Meta = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezebqkr2"
} : 0)( true ? {
  name: "duqnjs",
  styles: "display:flex;flex-flow:row nowrap;margin-top:auto"
} : 0);

var Icon = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezebqkr1"
} : 0)( true ? {
  name: "13akx53",
  styles: "height:24px;width:24px;margin-right:25px;background-color:#ccc;border-radius:99px"
} : 0);

var Duration = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ezebqkr0"
} : 0)("font-size:14px;padding-top:3px;line-height:", 20 / 14, ";" + ( true ? "" : 0));

var PodcastItem = function PodcastItem(_ref) {
  var title = _ref.title,
      image = _ref.image,
      duration = _ref.duration,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, PodcastItem_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PodcastItem_Host, PodcastItem_objectSpread(PodcastItem_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PodcastItem_Image, {
      children: image
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PodcastItem_Title, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Meta, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spotify, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Duration, {
        children: duration
      })]
    })]
  }));
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/FeaturedPodcastsContainer.tsx







function FeaturedPodcastsContainer(props) {
  var title = props.title,
      description = props.description,
      button_link = props.button_link,
      button_text = props.button_text,
      fields = props.fields;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Podcast, {
      title: Prismic/* Prismic.text */.X5.text(title),
      text: Prismic/* Prismic.text */.X5.text(description),
      link: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
        value: button_link,
        title: button_text,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          children: Prismic/* Prismic.text */.X5.text(button_text)
        })
      }),
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (_ref, index) {
        var _linkdata$title, _linkdata$image;

        var podcast_duration = _ref.podcast_duration,
            podcast_link = _ref.podcast_link;
        var linkdata = (0,fallback/* getDataFromLink */.rm)(podcast_link);
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
          value: podcast_link,
          title: (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PodcastItem, {
            title: Prismic/* Prismic.text */.X5.text(linkdata.title),
            image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
              src: (_linkdata$image = linkdata.image) !== null && _linkdata$image !== void 0 ? _linkdata$image : undefined,
              percentage: 0.1,
              ar: "ar_1_1"
            }),
            duration: Prismic/* Prismic.text */.X5.text(podcast_duration)
          })
        }, "podcast-item-".concat(index));
      })
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/hero/Hero.tsx



function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var ImageAlignment;

(function (ImageAlignment) {
  ImageAlignment["FULLSCREEN"] = "FULLSCREEN";
  ImageAlignment["CENTER"] = "CENTER";
  ImageAlignment["RIGHT"] = "RIGHT";
  ImageAlignment["LEFT"] = "LEFT";
})(ImageAlignment || (ImageAlignment = {}));

var FontSize;

(function (FontSize) {
  FontSize["Big"] = "Big";
  FontSize["Normal"] = "Normal";
  FontSize["Small"] = "Small";
})(FontSize || (FontSize = {}));

var TitlePosition;

(function (TitlePosition) {
  TitlePosition["Left"] = "Left";
  TitlePosition["Right"] = "Right";
  TitlePosition["Center"] = "Center";
})(TitlePosition || (TitlePosition = {}));

var TitleColor;

(function (TitleColor) {
  TitleColor["White"] = "White";
  TitleColor["Blue"] = "Blue";
})(TitleColor || (TitleColor = {}));

var Hero_isEmpty = function isEmpty(value) {
  if (react.Children.count(value) === 0) {
    return true;
  }

  return String(value !== null && value !== void 0 ? value : '').trim() === '';
};

var full = [ImageAlignment.CENTER, ImageAlignment.FULLSCREEN];

var FullBackground = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e69h19914"
} : 0)("position:absolute;top:0;left:0;right:0;bottom:0;background-color:", function (props) {
  return props.theme.colors.primary;
}, ";background-image:", function (props) {
  return props.theme.gradients.primary;
}, ";" + ( true ? "" : 0));

var Hero_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e69h19913"
} : 0)("position:relative;padding-bottom:1px;margin-bottom:", function (props) {
  return props.noMarginBottom ? 0 : '62px';
}, ";color:", function (props) {
  return props.theme.colors.background;
}, ";@media ", devices/* device.tablet */.U.tablet, "{padding-top:120px;margin-bottom:", function (props) {
  return props.noMarginBottom ? 0 : '60px';
}, ";", function (props) {
  return props.alignment === ImageAlignment.FULLSCREEN ? 'margin-top: 0px;' : 'margin-top: -80px;';
}, ";@media (max-height: 955px){padding-top:90px;margin-bottom:30px;}}" + ( true ? "" : 0));

var Hero_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e69h19912"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{", mixins/* container */.nC, ";}" + ( true ? "" : 0));

var Hero_Image = (0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e69h19911"
} : 0)( true ? {
  name: "1vfhcql",
  styles: "object-fit:cover"
} : 0).withComponent(Img,  true ? {
  target: "e69h19915"
} : 0);

var ImageShade = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e69h19910"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{position:absolute;top:0;", function (props) {
  return props.alignment === ImageAlignment.RIGHT ? 'right: 0px' : 'left: 0px';
}, ";width:", function (props) {
  return full.includes(props.alignment) ? '100%' : '50%';
}, ";height:100%;background-image:linear-gradient(\n      0deg,\n      rgba(0, 0, 0, ", function (props) {
  return props.shadeOpacity || 0.1;
}, "),\n      rgba(0, 0, 0, ", function (props) {
  return (props.shadeOpacity || 0.1) / 4;
}, ")\n    );}" + ( true ? "" : 0));

var Hero_AspectRatio = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e69h1999"
} : 0)("position:relative;display:flex;flex-flow:column nowrap;margin-bottom:", function (props) {
  return props.alignment === ImageAlignment.CENTER ? -30 : 0;
}, "px;&:before{padding-bottom:100%;content:'';display:", function (props) {
  return props.alignment === ImageAlignment.FULLSCREEN ? 'none' : 'block';
}, ";float:left;}&:after{display:table;content:'';clear:both;}@media ", devices/* device.tablet */.U.tablet, "{flex-direction:", function (props) {
  return props.alignment === ImageAlignment.RIGHT ? 'row-reverse' : 'row';
}, ";&:before{padding-bottom:", function () {
  return 1 / (16 / 9) * 100;
}, "%;content:'';display:block;float:left;transition:padding-bottom 200ms ease-in-out;@media (max-height: 955px){padding-bottom:64vh;}}&:after{display:table;content:'';clear:both;}}" + ( true ? "" : 0)); // Only when alignment is Center


var Hero_Background = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e69h1998"
} : 0)("position:absolute;top:0;left:0;right:0;bottom:0;background-image:", function (props) {
  return props.theme.gradients.primary;
}, ";" + ( true ? "" : 0));

var Hero_ImageAspect = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e69h1997"
} : 0)("width:100%;&:before{content:'';display:block;padding-top:100%;}>:first-child{position:absolute;top:0;", function (props) {
  return props.alignment === ImageAlignment.LEFT ? 'right: 0' : 'left: 0';
}, ";height:100%;width:100%;}@media ", devices/* device.tablet */.U.tablet, "{position:absolute;bottom:-31px;}" + ( true ? "" : 0));

var BackgroundImage = (0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e69h1996"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;}" + ( true ? "" : 0)).withComponent(Img,  true ? {
  target: "e69h19916"
} : 0);

var Hero_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e69h1995"
} : 0)("position:relative;padding:45px 30px 55px;display:flex;flex-direction:column;", function (props) {
  return props.center ? 'align-items: center;' : '';
}, " background-color:", function (props) {
  return props.theme.colors.primary;
}, ";@media ", devices/* device.mobile */.U.mobile, "{padding:45px 44px 55px;}@media ", devices/* device.tablet */.U.tablet, "{padding:115px 60px 30px;background-color:transparent;width:", function (props) {
  return [ImageAlignment.LEFT, ImageAlignment.RIGHT].includes(props.alignment) ? 'calc(50% + 60px)' : '100%';
}, ";", function (props) {
  switch (props.alignment) {
    case ImageAlignment.RIGHT:
      return 'padding-right: 0px;';

    case ImageAlignment.LEFT:
      return 'padding-left: 60px; padding-right: 0;';
  }

  return '';
}, ";}" + ( true ? "" : 0));

var Hero_Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e69h1994"
} : 0)("display:flex;flex:1;flex-direction:column;padding-bottom:0;", function (props) {
  return props.center ? "\n    align-items: center;\n    > * { text-align: center; }\n  " : '';
}, " ", function (props) {
  return props.bottom ? 'justify-content: flex-end;' : '';
}, " color:", function (props) {
  return props.theme.colors.background;
}, ";@media ", devices/* device.tablet */.U.tablet, "{", function (props) {
  return [ImageAlignment.LEFT, ImageAlignment.RIGHT].includes(props.alignment) ? 'justify-content: center;' : '';
}, " ", function (props) {
  return props.bottom ? 'justify-content: flex-end;' : '';
}, ";}" + ( true ? "" : 0));

var Hero_Label = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e69h1993"
} : 0)("font-family:", function (props) {
  return props.theme.font.familySerifCond;
}, ";font-weight:500;font-size:30px;letter-spacing:0.25px;line-height:40px;" + ( true ? "" : 0));

var Hero_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e69h1992"
} : 0)("max-width:calc((690 / ", typography/* sizes.h2Size */.J7.h2Size, ") * 1em);margin-bottom:120px;font-family:", function (props) {
  return props.theme.font.familySerifCond;
}, ";font-weight:500;font-size:44px;line-height:", 57 / 44, ";color:'inherit';@media ", devices/* device.tablet */.U.tablet, "{color:", function (props) {
  return props.titleColor === TitleColor.Blue ? props.theme.colors.primary : 'inherit';
}, ";", function (props) {
  return props.fontSize === FontSize.Big ? typography/* typography.h1 */.cp.h1 : props.fontSize === FontSize.Normal ? typography/* typography.heroSmall */.cp.heroSmall : typography/* typography.h2 */.cp.h2;
}, " margin-bottom:calc((60 / ", typography/* sizes.h2Size */.J7.h2Size, ") * 1em);", function (props) {
  switch (props.alignment) {
    case ImageAlignment.LEFT:
      return "max-width: 90%;";

    case ImageAlignment.RIGHT:
      return "max-width: 100%;";

    case ImageAlignment.CENTER:
      return "max-width: 64%;";
  }
}, ";}@media ", devices/* device.desktop */.U.desktop, "{margin-bottom:60px;", function (props) {
  return props.titlePosition === TitlePosition.Left ? '' : props.titlePosition === TitlePosition.Center ? 'align-self:center;text-align:center;' : 'align-self:flex-end;text-align:right;';
}, ";max-width:", function (props) {
  return "".concat(props.titleWidth / 12 * 100, "%");
}, ";}" + ( true ? "" : 0));

var Hero_Actions = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e69h1991"
} : 0)("display:flex;flex-direction:column;", function (props) {
  return props.twoButtons ? 'margin-bottom:-60px;' : 'margin-bottom:0';
}, ";margin-bottom:-88px;a{width:100%;outline-offset:-0.4rem;}@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0;a{width:auto;outline-offset:-0.4rem;}}>*:nth-child(2){margin-top:30px;}", function (props) {
  return props.titlePosition === TitlePosition.Left ? 'align-items: flex-start;' : props.titlePosition === TitlePosition.Center ? 'align-self:center;' : 'align-self:flex-end;';
}, ";" + ( true ? "" : 0));

var Hero_Column = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e69h1990"
} : 0)("position:relative;width:100%;@media ", devices/* device.tablet */.U.tablet, "{width:51%;}" + ( true ? "" : 0));

function Hero(props) {
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(useReveal/* inViewConfig */.BT),
      _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  var isAnimated = props.isAnimated,
      image = props.image,
      label = props.label,
      title = props.title,
      alignment = props.alignment,
      actions = props.actions,
      smallerFont = props.smallerFont,
      center = props.center,
      bottom = props.bottom,
      noMarginBottom = props.noMarginBottom,
      _props$shadeOpacity = props.shadeOpacity,
      shadeOpacity = _props$shadeOpacity === void 0 ? 0.1 : _props$shadeOpacity,
      fontSize = props.fontSize,
      titlePosition = props.titlePosition,
      titleColor = props.titleColor,
      titleWidth = props.titleWidth;
  var isColumn = [ImageAlignment.LEFT, ImageAlignment.RIGHT].includes(alignment) && !!image;
  var visible = isAnimated !== null && isAnimated !== void 0 ? isAnimated : inView;
  var delay = 300;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  var isTablet = (0,hooks_useMedia/* useMedia */.G)('md');
  var backgroundStyle = (0,react_spring_esm.useSpring)({
    y: visible ? '0%' : '-100%'
  });
  var copyStyle = (0,react_spring_esm.useSpring)({
    opacity: visible ? 1 : 0,
    y: visible ? 0 : 20,
    delay: delay
  });
  var actionsStyle = (0,react_spring_esm.useSpring)({
    opacity: visible ? 1 : 0,
    overflow: 'hidden',
    delay: delay + 100,
    config: {
      tension: 320
    }
  });
  var imageStyle = (0,react_spring_esm.useSpring)({
    x: visible ? '0%' : '101%'
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero_Host, {
    ref: ref,
    id: "hero",
    alignment: alignment,
    noMarginBottom: noMarginBottom,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullBackground, {
      style: backgroundStyle
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero_Container, {
      children: [alignment === ImageAlignment.FULLSCREEN && !!image && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackgroundImage, {
          src: image,
          ar: isMobile || isTablet ? 'ar_1_1' : 'ar_16_9',
          alt: ""
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageShade, {
          shadeOpacity: shadeOpacity,
          alignment: alignment
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero_AspectRatio, {
        alignment: alignment,
        children: [alignment === ImageAlignment.CENTER && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Background, {}), isColumn && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Column, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_ImageAspect, {
            alignment: alignment,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_spring_esm.animated.div, {
              style: {
                overflow: 'hidden',
                transform: imageStyle.x.to(function (v) {
                  return "translateX(-".concat(v, ")");
                })
              },
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Image, {
                src: image,
                ar: "ar_1_1",
                alignment: alignment,
                containerStyle: imageStyle
              })
            })
          })
        }), alignment === ImageAlignment.CENTER && !!image && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_spring_esm.animated.div, {
            style: {
              overflow: 'hidden',
              transform: imageStyle.x.to(function (v) {
                return "translateX(-".concat(v, ")");
              }),
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackgroundImage, {
              src: image,
              ar: isMobile ? 'ar_1_1' : 'ar_16_9',
              containerStyle: imageStyle
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageShade, {
            shadeOpacity: shadeOpacity,
            alignment: alignment
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Content, {
          alignment: alignment,
          center: center,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero_Copy, {
            center: center,
            bottom: bottom,
            style: copyStyle,
            alignment: alignment,
            children: [!Hero_isEmpty(label) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Label, {
              children: label
            }), !Hero_isEmpty(title) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Title, {
              center: center,
              alignment: alignment,
              image: image,
              smallerFont: smallerFont,
              fontSize: fontSize,
              titleWidth: titleWidth,
              titlePosition: titlePosition,
              titleColor: titleColor,
              children: title
            }), !Hero_isEmpty(actions) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Actions, {
              alignment: alignment,
              style: actionsStyle,
              titlePosition: titlePosition,
              children: actions
            })]
          })
        })]
      })]
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/FrontPageHeroContainer.tsx








var AlignmentMap = {
  Fullscreen: ImageAlignment.FULLSCREEN,
  Center: ImageAlignment.CENTER,
  Right: ImageAlignment.RIGHT,
  Left: ImageAlignment.LEFT
};
var FrontPageHeroContainer = function FrontPageHeroContainer(_ref) {
  var _buttonLinkdata$title, _buttonLinkdata_2$tit;

  var alignment = _ref.alignment,
      title = _ref.title,
      text_center = _ref.text_center,
      text_bottom = _ref.text_bottom,
      smaller_font = _ref.smaller_font,
      image = _ref.image,
      button_text = _ref.button_text,
      link = _ref.link,
      shade_opacity = _ref.shade_opacity,
      link_2 = _ref.link_2,
      button_text_2 = _ref.button_text_2,
      font_size = _ref.font_size,
      title_width = _ref.title_width,
      title_position = _ref.title_position,
      title_color = _ref.title_color;
  var buttonLinkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var buttonTitle = (0,fallback/* fallbackText */.mn)(button_text, (_buttonLinkdata$title = buttonLinkdata.title) !== null && _buttonLinkdata$title !== void 0 ? _buttonLinkdata$title : undefined);
  var buttonLinkdata_2 = (0,fallback/* getDataFromLink */.rm)(link);
  var buttonTitle_2 = (0,fallback/* fallbackText */.mn)(button_text_2, (_buttonLinkdata_2$tit = buttonLinkdata_2.title) !== null && _buttonLinkdata_2$tit !== void 0 ? _buttonLinkdata_2$tit : undefined);
  var action = link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link,
    title: buttonTitle !== null && buttonTitle !== void 0 ? buttonTitle : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_Button/* Button */.z, {
      as: "a",
      title: buttonTitle !== null && buttonTitle !== void 0 ? buttonTitle : undefined,
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "29",
        height: "10",
        fill: "none",
        viewBox: "0 0 29 10",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
          fill: "#fff",
          d: "M19.7971.115967l9.1304 4.565213-9.1304 4.56522V5.18843H.521729V4.17394H19.7971V.115967z"
        })
      }),
      id: link_2 ? 'secondary_cta_button' : 'main_cta_button'
    })
  }) : null;
  var secondAction = link_2 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link_2,
    title: buttonTitle_2 !== null && buttonTitle_2 !== void 0 ? buttonTitle_2 : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_Button/* Button */.z, {
      as: "a",
      title: buttonTitle_2 !== null && buttonTitle_2 !== void 0 ? buttonTitle_2 : undefined,
      id: "main_cta_button"
    })
  }) : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero, {
    title: (0,utils_src/* hyphenate */.rs)(Prismic/* Prismic.text */.X5.text(title)),
    image: image,
    alignment: AlignmentMap[alignment],
    shadeOpacity: shade_opacity,
    actions: secondAction !== null ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [action, secondAction]
    }) : action,
    center: text_center,
    smallerFont: smaller_font,
    bottom: text_bottom,
    fontSize: FontSize[font_size],
    titleWidth: title_width,
    titlePosition: TitlePosition[title_position],
    titleColor: title_color
  });
};
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 1 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(40368);
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/fetchFunds.ts


var fetchFunds_templateObject;


var FETCH_FUNDS = (0,lib/* gql */.Ps)(fetchFunds_templateObject || (fetchFunds_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query fetchFunds($order: FundOrder, $first: Int) {\n    funds(order: $order, first: $first) {\n      nodes {\n        id\n        name\n        shortName\n        symbol\n        category\n        currency\n        date\n        bid\n        ask\n        cumulativeReturns {\n          oneMonthReturn\n          threeMonthReturn\n          sixMonthReturn\n          oneYearReturn\n          threeYearReturn\n          fiveYearReturn\n          yearToDateReturn\n        }\n        annualizedReturns {\n          oneYearReturn\n          twoYearReturn\n          threeYearReturn\n          fourYearReturn\n          fiveYearReturn\n        }\n        nominalReturns {\n          year\n          return\n        }\n        details {\n          riskRating\n          onlineBuyAllowed\n          onlineSellAllowed\n          ucitsClassification\n        }\n      }\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/fund/fund-type-information/FundTypeInformation.tsx





var FundTypeInfoContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cynxnw0"
} : 0)("background-color:rgb(244, 247, 247);margin-top:20px;padding:60px 0px;margin-bottom:0px;p:last-of-type{padding-top:24px;}@media ", devices/* device.tablet */.U.tablet, "{padding:75px 100px 69px 100px;}" + ( true ? "" : 0));
function FundTypeInformation(_ref) {
  var _fund$details, _fund$details$ucitsCl;

  var fund = _ref.fund,
      ucitsDescription = _ref.ucitsDescription,
      nonUcitsDescription = _ref.nonUcitsDescription;
  return _jsx(FundTypeInfoContainer, {
    children: (_fund$details = fund.details) !== null && _fund$details !== void 0 && (_fund$details$ucitsCl = _fund$details.ucitsClassification) !== null && _fund$details$ucitsCl !== void 0 && _fund$details$ucitsCl.toLocaleLowerCase().includes('non-ucits') ? nonUcitsDescription === null || nonUcitsDescription === void 0 ? void 0 : nonUcitsDescription.map(function (paragraph, i) {
      return _jsx(MarketsBody, {
        children: paragraph
      }, i);
    }) : ucitsDescription === null || ucitsDescription === void 0 ? void 0 : ucitsDescription.map(function (paragraph, i) {
      return _jsx(MarketsBody, {
        children: paragraph
      }, i);
    })
  });
}
// EXTERNAL MODULE: ../../packages/slices/src/components/markets/shared/MarketsComponents.tsx + 3 modules
var MarketsComponents = __webpack_require__(79952);
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/shared/markets-disclaimer/MarketsDisclaimer.tsx


function MarketsDisclaimer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var MarketsDisclaimer_Container = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb65sfo0"
} : 0)( true ? {
  name: "icns00",
  styles: "padding-top:10px"
} : 0);

function MarketsDisclaimer(_ref) {
  var text = _ref.text;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsDisclaimer_Container, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
      children: text
    })
  });
}
// EXTERNAL MODULE: ../../packages/ui/src/components/table/Th.tsx
var Th = __webpack_require__(36433);
// EXTERNAL MODULE: ../../packages/ui/src/components/table/Table.tsx
var Table = __webpack_require__(51599);
// EXTERNAL MODULE: ../../packages/ui/src/components/table/Thead.tsx
var Thead = __webpack_require__(81617);
// EXTERNAL MODULE: ../../packages/ui/src/components/table/Tr.tsx
var Tr = __webpack_require__(5766);
// EXTERNAL MODULE: ../../packages/ui/src/components/table/Tbody.tsx
var Tbody = __webpack_require__(40535);
// EXTERNAL MODULE: ../../packages/ui/src/components/table/Td.tsx
var Td = __webpack_require__(39345);
;// CONCATENATED MODULE: ../../packages/ui/src/components/table/Tfoot.tsx



var Tfoot_excluded = ["children"];

function Tfoot_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Tfoot_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Tfoot_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Tfoot_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Tfoot_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var Footer = (0,emotion_styled_base_browser_esm/* default */.Z)("tfoot",  true ? {
  target: "e106xyvb0"
} : 0)( true ? {
  name: "1537evi",
  styles: "tr{td{border:none;padding:inherit;}td:last-child{font-weight:500;}}"
} : 0);

var Tfoot = function Tfoot(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Tfoot_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, Tfoot_objectSpread(Tfoot_objectSpread({}, rest), {}, {
    children: children
  }));
};
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
// EXTERNAL MODULE: ../../node_modules/react-table/index.js
var react_table = __webpack_require__(13496);
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/shared/OrderByArrow.tsx






var Arrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e4oiay00"
} : 0)("background:", theme/* theme.colors.primary */.r.colors.primary, ";height:1px;width:10px;position:relative;transform:rotate(90deg);cursor:pointer;&:before,&:after{content:'';background:", theme/* theme.colors.primary */.r.colors.primary, ";position:absolute;height:1px;width:4px;}&:before{right:-0.5px;bottom:-1px;transform:rotate(-45deg);}&:after{right:-0.5px;bottom:1px;transform:rotate(45deg);}" + ( true ? "" : 0));

function OrderByArrow(_ref) {
  var desc = _ref.desc;

  var _useState = (0,react.useState)(0),
      deg = _useState[0],
      setDeg = _useState[1];

  react.useEffect(function () {
    // Up / Asc -> 270
    // Down / Desc -> 90
    var isArrowDirectionDesc = deg === 90 || deg - 360 * Math.floor(deg / 360) === 90 ? true : false;

    if (deg === 0) {
      desc ? setDeg(90) : setDeg(270);
    } else {
      if (desc && !isArrowDirectionDesc || !desc && isArrowDirectionDesc) {
        setDeg(deg + 180);
      }
    }
  }, [deg, desc]);
  var rotate = (0,react_spring_esm.useSpring)({
    config: {
      mass: 20,
      tension: 469,
      friction: 20,
      clamp: true
    },
    opacity: 1,
    transform: "rotate(".concat(deg, "deg)")
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arrow, {
    style: rotate
  });
}
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../packages/slices/src/components/table/DataTable.tsx



var DataTable_excluded = ["columns", "data", "rowLink", "initialState", "firstColumnTitle"];

function DataTable_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function DataTable_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DataTable_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DataTable_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function DataTable_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






 // eslint-disable-next-line @typescript-eslint/ban-types




var DataTableTh = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Th.Th,  true ? {
  target: "ex2qeuq2"
} : 0)( true ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : 0);

var HeaderContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ex2qeuq1"
} : 0)( true ? {
  name: "11zmcm1",
  styles: "display:flex;flex-direction:row;align-items:flex-end;justify-content:flex-end"
} : 0);

var ArrowContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ex2qeuq0"
} : 0)("visibility:", function (props) {
  return props.display ? 'visible' : 'hidden';
}, ";padding-right:2px;padding-left:2px;padding-bottom:11px;" + ( true ? "" : 0)); // eslint-disable-next-line @typescript-eslint/ban-types


function DataTable(_ref) {
  var columns = _ref.columns,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      rowLink = _ref.rowLink,
      initialState = _ref.initialState,
      _ref$firstColumnTitle = _ref.firstColumnTitle,
      firstColumnTitle = _ref$firstColumnTitle === void 0 ? true : _ref$firstColumnTitle,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, DataTable_excluded);

  var _useTable = (0,react_table.useTable)({
    columns: columns,
    data: data,
    initialState: initialState,
    disableSortRemove: true
  }, react_table.useSortBy),
      getTableProps = _useTable.getTableProps,
      headerGroups = _useTable.headerGroups,
      getTableBodyProps = _useTable.getTableBodyProps,
      prepareRow = _useTable.prepareRow,
      rows = _useTable.rows,
      footerGroups = _useTable.footerGroups;

  var hasFooter = (0,lodash.find)(columns, function (i) {
    return i.Footer;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Table/* Table */.i, DataTable_objectSpread(DataTable_objectSpread(DataTable_objectSpread({}, rest), getTableProps()), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Thead/* Thead */.h, {
      children: headerGroups.map(function (headerGroup) {
        return (0,emotion_react_browser_esm/* createElement */.az)(Tr.Tr, DataTable_objectSpread(DataTable_objectSpread({}, headerGroup.getHeaderGroupProps()), {}, {
          firstColumnTitle: firstColumnTitle,
          key: "".concat(headerGroup.id)
        }), headerGroup.headers.map(function (header) {
          var _header$isSorted;

          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataTableTh, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderContainer, DataTable_objectSpread(DataTable_objectSpread({}, header.getHeaderProps([{
              style: header.headerStyle
            }, header.getSortByToggleProps()])), {}, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowContainer, {
                display: (_header$isSorted = header.isSorted) !== null && _header$isSorted !== void 0 ? _header$isSorted : false,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderByArrow, {
                  desc: header.isSortedDesc
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: header.render('Header')
              })]
            }))
          }, header.id);
        }));
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tbody/* Tbody */.p, DataTable_objectSpread(DataTable_objectSpread({}, getTableBodyProps()), {}, {
      children: rows.map(function (row, i) {
        prepareRow(row);

        var r = (0,emotion_react_browser_esm/* createElement */.az)(Tr.Tr, DataTable_objectSpread(DataTable_objectSpread({}, row.getRowProps()), {}, {
          key: row.getRowProps().key
        }), row.cells.map(function (cell, i) {
          return (0,emotion_react_browser_esm/* createElement */.az)(Td.Td, DataTable_objectSpread(DataTable_objectSpread({}, cell.getCellProps([{
            style: cell.column.style
          }])), {}, {
            key: cell.getCellProps().key
          }), cell.render('Cell'));
        }));

        if (rowLink) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_link["default"], DataTable_objectSpread(DataTable_objectSpread({}, rowLink(row)), {}, {
            children: r
          }));
        }

        return r;
      })
    })), hasFooter !== undefined && rows.length > 1 && footerGroups.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tfoot, {
      children: footerGroups.map(function (group) {
        return (0,emotion_react_browser_esm/* createElement */.az)(Tr.Tr, DataTable_objectSpread(DataTable_objectSpread({}, group.getFooterGroupProps()), {}, {
          key: group.getFooterGroupProps().key
        }), group.headers.map(function (column) {
          return (0,emotion_react_browser_esm/* createElement */.az)(Td.Td, DataTable_objectSpread(DataTable_objectSpread({}, column.getFooterProps([{
            style: column.style
          }])), {}, {
            key: column.getFooterProps().key
          }), column.render('Footer'));
        }));
      })
    })]
  }));
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/fund-table/FundsTableContainer.tsx






function FundsTableContainer(_ref) {
  var fundDataType = _ref.fundDataType,
      children = _ref.children;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: isMobile && fundDataType === FundDataType.Price ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* StickyFirstColumn */.yi, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: children
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: children
    })
  });
}
// EXTERNAL MODULE: ../../packages/slices/src/components/markets/shared/MarketsFormatNumber.tsx
var MarketsFormatNumber = __webpack_require__(40746);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/getYear/index.js
var getYear = __webpack_require__(81914);
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/returns-selector-tabs/ReturnsSelectorTabs.res.ts
/* harmony default export */ var ReturnsSelectorTabs_res = ({
  oneMonth: {
    is: '1 mánuður',
    en: '1 month'
  },
  threeMonths: {
    is: '3 mánuðir',
    en: '3 months'
  },
  sixMonths: {
    is: '6 mánuðir',
    en: '6 months'
  },
  yearToDate: {
    is: 'Á árinu',
    en: 'Year to date'
  },
  oneYear: {
    is: '1 ár',
    en: '1 year'
  },
  twoYears: {
    is: '2 ár',
    en: '2 years'
  },
  threeYears: {
    is: '3 ár',
    en: '3 years'
  },
  fourYears: {
    is: '4 ár',
    en: '4 years'
  },
  fiveYears: {
    is: '5 ár',
    en: '5 years'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/returns-selector-tabs/useReturnsConfig.ts




function useNominalReturnsOptions() {
  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var currentYear = (0,getYear["default"])(new Date());
  return (0,react.useMemo)(function () {
    return [{
      id: NominalReturnOptions.YearToDateReturn.toString(),
      label: r(ReturnsSelectorTabs_res.yearToDate)
    }, {
      id: NominalReturnOptions.OneMonthReturn.toString(),
      label: r(ReturnsSelectorTabs_res.oneMonth)
    }, {
      id: NominalReturnOptions.ThreeMonthReturn.toString(),
      label: r(ReturnsSelectorTabs_res.threeMonths)
    }, {
      id: NominalReturnOptions.SixMonthReturn.toString(),
      label: r(ReturnsSelectorTabs_res.sixMonths)
    }, {
      id: NominalReturnOptions.OneYearPast.toString(),
      label: (currentYear - 1).toString()
    }, {
      id: NominalReturnOptions.TwoYearPast.toString(),
      label: (currentYear - 2).toString()
    }, {
      id: NominalReturnOptions.ThreeYearPast.toString(),
      label: (currentYear - 3).toString()
    }, {
      id: NominalReturnOptions.FourYearPast.toString(),
      label: (currentYear - 4).toString()
    }, {
      id: NominalReturnOptions.FiveYearPast.toString(),
      label: (currentYear - 5).toString()
    }];
  }, [currentYear]);
}
function useAnnualizedReturnsOptions() {
  var _useResource2 = (0,src/* useResource */.Wf)(),
      r = _useResource2.r;

  return (0,react.useMemo)(function () {
    return [{
      id: AnnualizedReturnOptions.OneYear.toString(),
      label: r(ReturnsSelectorTabs_res.oneYear)
    }, {
      id: AnnualizedReturnOptions.TwoYears.toString(),
      label: r(ReturnsSelectorTabs_res.twoYears)
    }, {
      id: AnnualizedReturnOptions.ThreeYears.toString(),
      label: r(ReturnsSelectorTabs_res.threeYears)
    }, {
      id: AnnualizedReturnOptions.FourYears.toString(),
      label: r(ReturnsSelectorTabs_res.fourYears)
    }, {
      id: AnnualizedReturnOptions.FiveYears.toString(),
      label: r(ReturnsSelectorTabs_res.fiveYears)
    }];
  }, [r]);
}
var NominalReturnOptions;

(function (NominalReturnOptions) {
  NominalReturnOptions[NominalReturnOptions["OneMonthReturn"] = 0] = "OneMonthReturn";
  NominalReturnOptions[NominalReturnOptions["ThreeMonthReturn"] = 1] = "ThreeMonthReturn";
  NominalReturnOptions[NominalReturnOptions["SixMonthReturn"] = 2] = "SixMonthReturn";
  NominalReturnOptions[NominalReturnOptions["YearToDateReturn"] = 3] = "YearToDateReturn";
  NominalReturnOptions[NominalReturnOptions["OneYearPast"] = 4] = "OneYearPast";
  NominalReturnOptions[NominalReturnOptions["TwoYearPast"] = 5] = "TwoYearPast";
  NominalReturnOptions[NominalReturnOptions["ThreeYearPast"] = 6] = "ThreeYearPast";
  NominalReturnOptions[NominalReturnOptions["FourYearPast"] = 7] = "FourYearPast";
  NominalReturnOptions[NominalReturnOptions["FiveYearPast"] = 8] = "FiveYearPast";
})(NominalReturnOptions || (NominalReturnOptions = {}));

var AnnualizedReturnOptions;

(function (AnnualizedReturnOptions) {
  AnnualizedReturnOptions[AnnualizedReturnOptions["OneYear"] = 0] = "OneYear";
  AnnualizedReturnOptions[AnnualizedReturnOptions["TwoYears"] = 1] = "TwoYears";
  AnnualizedReturnOptions[AnnualizedReturnOptions["ThreeYears"] = 2] = "ThreeYears";
  AnnualizedReturnOptions[AnnualizedReturnOptions["FourYears"] = 3] = "FourYears";
  AnnualizedReturnOptions[AnnualizedReturnOptions["FiveYears"] = 4] = "FiveYears";
})(AnnualizedReturnOptions || (AnnualizedReturnOptions = {}));
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/risk-rating/RiskRating.tsx



var RISK_RATINGS = [1, 2, 3, 4, 5, 6, 7];
var RiskRatingChart = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ixzt0f1"
} : 0)("display:flex;justify-content:", function (props) {
  return props.size === RiskRatingSize.Large ? 'flex-start' : 'flex-end';
}, ";align-items:baseline;" + ( true ? "" : 0));
var RiskRatingSize;

(function (RiskRatingSize) {
  RiskRatingSize[RiskRatingSize["Small"] = 0] = "Small";
  RiskRatingSize[RiskRatingSize["Normal"] = 1] = "Normal";
  RiskRatingSize[RiskRatingSize["Large"] = 2] = "Large";
})(RiskRatingSize || (RiskRatingSize = {}));

var RiskRatingBar = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ixzt0f0"
} : 0)("width:", function (props) {
  return props.size === RiskRatingSize.Normal ? '4px' : props.size === RiskRatingSize.Large ? '8px' : '2px';
}, ";margin-right:", function (props) {
  return props.size === RiskRatingSize.Normal ? '2px' : props.size === RiskRatingSize.Large ? '4px' : '1px';
}, ";background:", function (props) {
  return props.active ? props.theme.shades.primary4 : props.theme.shades.primary3;
}, ";opacity:", function (props) {
  return props.active ? 1 : 0.3;
}, ";height:", function (props) {
  return (props.size === RiskRatingSize.Normal ? 2 : props.size === RiskRatingSize.Large ? 4 : 1) * props.rating + (props.size === RiskRatingSize.Small ? 1 : 0);
}, "px;" + ( true ? "" : 0));
function RiskRating(_ref) {
  var value = _ref.value,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? RiskRatingSize.Normal : _ref$size;
  if (value === undefined || value === null) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RiskRatingChart, {
    size: size,
    children: RISK_RATINGS.map(function (rating) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RiskRatingBar, {
        active: rating <= value,
        rating: rating,
        size: size
      }, rating);
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/Funds.res.ts
/* harmony default export */ var Funds_res = ({
  funds: {
    is: 'Sjóðir',
    en: 'Mutual funds'
  },
  fundPrice: {
    is: 'Gengi sjóða',
    en: 'Fund price'
  },
  dataDisclaimer: {
    is: 'Gengi sjóða og ávöxtunartölur uppfærast á hverjum viðskiptadegi.',
    en: 'Fund price and figures on returns are updated daily'
  },
  currency: {
    is: 'Mynt',
    en: 'Currency'
  },
  price: {
    is: 'Gengi',
    en: 'Price'
  },
  oneMonth: {
    is: '1 mán.',
    en: '1M'
  },
  threeMonths: {
    is: '3 mán.',
    en: '3M'
  },
  sixMonths: {
    is: '6 mán.',
    en: '6M'
  },
  yearToDate: {
    is: 'Á árinu',
    en: 'YTD'
  },
  oneYear: {
    is: '1 ár',
    en: '1 year'
  },
  twoYears: {
    is: '2 ár',
    en: '2 years'
  },
  threeYears: {
    is: '3 ár',
    en: '3 years'
  },
  fourYears: {
    is: '4 ár',
    en: '4 years'
  },
  fiveYears: {
    is: '5 ár',
    en: '5 years'
  },
  volatility: {
    is: 'Sveiflur',
    en: 'Volatility'
  },
  buy: {
    is: 'Kaupa',
    en: 'Buy'
  },
  bidRate: {
    is: 'Kaupgengi',
    en: 'Buy'
  },
  askRate: {
    is: 'Sölugengi',
    en: 'Sell'
  },
  nominalReturn: {
    is: 'Nafnávöxtun',
    en: 'Nominal return'
  },
  nominalReturnAnnualized: {
    is: 'Nafnávöxtun á ársgrundvelli',
    en: 'Annualized nominal return'
  },
  rate: {
    is: 'Gengi',
    en: 'Rate'
  },
  date: {
    is: 'Dagsetning',
    en: 'Date'
  },
  foreignCurrencyDisclaimer: {
    landsbref: {
      is: 'Hægt er að eiga viðskipti með hlutdeildarskírteini í sjóði sem gerður er upp í erlendri mynt í gegnum Verðbréfa- og lífeyrisþjónustu Landsbankans í síma 410 4040.',
      en: 'To trade in unit shares in funds that are settled in a foreign currency, please contact Investment Services at +354 410 4040.'
    },
    landsbankinn: {
      is: 'Hægt er að eiga viðskipti með hlutdeildarskírteini í sjóði sem gerður er upp í erlendri mynt í gegnum Verðbréfa- og lífeyrisþjónustu bankans í síma 410 4040.',
      en: 'To trade in unit shares in funds that are settled in a foreign currency, please contact Investment Services at +354 410 4040.'
    }
  },
  einkabrefDisclaimer: {
    landsbref: {
      is: 'Einkabréf eru einungis ætluð viðskiptavinum Einkabankaþjónustu Landsbankans.',
      en: 'Einkabréf is reserved for customers of Landsbankinn Private Banking.'
    },
    landsbankinn: {
      is: 'Einkabréf eru einungis ætluð viðskiptavinum Einkabankaþjónustu bankans.',
      en: 'Einkabréf is reserved for customers of Landsbankinn Private Banking.'
    }
  },
  nonUcitsDisclaimer: {
    is: '*Sérhæfður sjóður fyrir almenna fjárfesta, veita þarf upplýsingar um þekkingu og reynslu áður en fjárfest er í sjóði.',
    en: '*Alternative investment fund for retail investors, requiring customers to provide information about their knowledge and experience prior to investment.'
  },
  fundsDisclaimer: {
    is: 'Ávöxtun sem birt er í töflunni hér fyrir ofan er nafnávöxtun í uppgjörsmynt hvers sjóðs að frádregnum kostnaði sem fallið hefur á sjóðinn á hverjum tíma, svo sem umsýsluþóknun, viðskiptakostnaður og annar kostnaður. Gjald við kaup og afgreiðslugjald sem er innheimt fyrir fjárfestingu er ekki innifalið í útreikningi á ávöxtun sjóðanna.',
    en: 'Return on UCITS and investment funds is presented as nominal return in ISK net of ongoing costs incurred by the fund.'
  },
  fundsDisclaimer2: {
    is: 'Áhætta fylgir ávallt fjárfestingu í sjóðum þar sem gengi þeirra getur bæði hækkað og lækkað vegna verðbreytinga á eignum sjóðanna og vegna gengisflökts gjaldmiðla þegar eignir sjóða eru í erlendum gjaldmiðlum. Ávöxtun í fortíð gefur ekki áreiðanlega vísbendingu um framtíðarárangur og fjárfestar kunna að fá minna til baka en upphaflega var fjárfest fyrir.',
    en: 'Investment in funds always involves risk as the price of units can both increase and decrease, due amongst other things to changes in the value of underlying assets and exchange rate fluctuations where fund assets are in foreign currencies.'
  },
  fundsDisclaimer3: {
    landsbref: {
      is: 'Sjóðirnir eru reknir af Landsbréfum hf., rekstrarfélagi verðbréfasjóða og rekstraraðila sérhæfðra sjóða með starfsleyfi á Íslandi og heyrir undir eftirlit Fjármálaeftirlits Seðlabanka Íslands.',
      en: 'The funds are managed by Landsbréf hf., a management company licensed to operate in Iceland and supervised by the Financial Supervisory Authority of the Central Bank of Iceland. We encourage you to familiarise yourself with the prospectus, key investor information and fact sheet available for each fund. Other information includes terms and conditions, a summary of conflict of interest and risk description for trading in financial instruments.'
    },
    landsbankinn: {
      is: 'Sjóðirnir eru reknir af Landsbréfum hf., rekstrarfélagi með starfsleyfi á Íslandi og heyrir undir eftirlit Fjármálaeftirlits Seðlabanka Íslands. Við bendum þér á að kynna þér útboðslýsingu, lykilupplýsingar og upplýsingablöð sjóðanna sem finna má undir hverjum sjóði. Einnig getur þú kynnt þér skilmála, útdrátt um hagsmunaárekstra og áhættulýsingu vegna viðskipta með fjármálagerninga.',
      en: 'The funds are managed by Landsbréf hf., a management company licensed to operate in Iceland and supervised by the Financial Supervisory Authority of the Central Bank of Iceland. We encourage you to familiarise yourself with the prospectus, key investor information and fact sheet available for each fund. Other information includes terms and conditions, a summary of conflict of interest and risk description for trading in financial instruments.'
    }
  },
  selectInformation: {
    is: 'Veldu upplýsingar',
    en: 'Select information'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/fund-table/useNominalData.tsx


function useNominalData_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var ButtonContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1751fsv0"
} : 0)( true ? {
  name: "1jg8g1p",
  styles: "display:flex;justify-content:flex-end;min-width:80px"
} : 0);
function useNominalData(data, category, selectedReturn, fundBuyUrl, stockBuyUrl) {
  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  var currentYear = (0,getYear["default"])(new Date());
  return react.useMemo(function () {
    if (isMobile) {
      var mobileArray = [{
        Header: category,
        accessor: 'shortName',
        headerStyle: {
          flexDirection: 'row-reverse'
        },
        Cell: function Cell(_ref) {
          var _fund$details;

          var value = _ref.value,
              fund = _ref.row.original;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* MarketsBodyBold */.K9, {
            children: [value, ((_fund$details = fund.details) === null || _fund$details === void 0 ? void 0 : _fund$details.ucitsClassification.toLocaleLowerCase().includes('non-ucits')) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: "*"
            })]
          });
        }
      }, {
        accessor: 'currency',
        style: {
          textAlign: 'right'
        },
        Cell: function Cell(_ref2) {
          var value = _ref2.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
            children: value
          });
        }
      }, {
        accessor: 'details.riskRating',
        Cell: function Cell(_ref3) {
          var value = _ref3.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RiskRating, {
            value: value,
            size: isMobile ? RiskRatingSize.Small : RiskRatingSize.Normal
          });
        },
        style: {
          textAlign: 'right'
        }
      }, selectedReturn === NominalReturnOptions.OneMonthReturn ? {
        accessor: 'cumulativeReturns.oneMonthReturn',
        sortType: 'basic',
        Cell: function Cell(_ref4) {
          var value = _ref4.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === NominalReturnOptions.ThreeMonthReturn ? {
        accessor: 'cumulativeReturns.threeMonthReturn',
        sortType: 'basic',
        Cell: function Cell(_ref5) {
          var value = _ref5.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === NominalReturnOptions.SixMonthReturn ? {
        accessor: 'cumulativeReturns.sixMonthReturn',
        sortType: 'basic',
        Cell: function Cell(_ref6) {
          var value = _ref6.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === NominalReturnOptions.YearToDateReturn ? {
        accessor: 'cumulativeReturns.yearToDateReturn',
        sortType: 'basic',
        Cell: function Cell(_ref7) {
          var value = _ref7.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === NominalReturnOptions.OneYearPast ? {
        id: 'oneYearPast',
        sortType: 'basic',
        accessor: function accessor(fund) {
          var _fund$nominalReturns$, _fund$nominalReturns$2;

          return (_fund$nominalReturns$ = (_fund$nominalReturns$2 = fund.nominalReturns.find(function (nominalReturn) {
            return nominalReturn.year === currentYear - 1;
          })) === null || _fund$nominalReturns$2 === void 0 ? void 0 : _fund$nominalReturns$2.return) !== null && _fund$nominalReturns$ !== void 0 ? _fund$nominalReturns$ : '';
        },
        Cell: function Cell(_ref8) {
          var value = _ref8.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === NominalReturnOptions.TwoYearPast ? {
        id: 'twoYearPast',
        sortType: 'basic',
        accessor: function accessor(fund) {
          var _fund$nominalReturns$3, _fund$nominalReturns$4;

          return (_fund$nominalReturns$3 = (_fund$nominalReturns$4 = fund.nominalReturns.find(function (nominalReturn) {
            return nominalReturn.year === currentYear - 2;
          })) === null || _fund$nominalReturns$4 === void 0 ? void 0 : _fund$nominalReturns$4.return) !== null && _fund$nominalReturns$3 !== void 0 ? _fund$nominalReturns$3 : '';
        },
        Cell: function Cell(_ref9) {
          var value = _ref9.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === NominalReturnOptions.ThreeYearPast ? {
        id: 'threeYearPast',
        sortType: 'basic',
        accessor: function accessor(fund) {
          var _fund$nominalReturns$5, _fund$nominalReturns$6;

          return (_fund$nominalReturns$5 = (_fund$nominalReturns$6 = fund.nominalReturns.find(function (nominalReturn) {
            return nominalReturn.year === currentYear - 3;
          })) === null || _fund$nominalReturns$6 === void 0 ? void 0 : _fund$nominalReturns$6.return) !== null && _fund$nominalReturns$5 !== void 0 ? _fund$nominalReturns$5 : '';
        },
        Cell: function Cell(_ref10) {
          var value = _ref10.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === NominalReturnOptions.FourYearPast ? {
        id: 'fourYearPast',
        sortType: 'basic',
        accessor: function accessor(fund) {
          var _fund$nominalReturns$7, _fund$nominalReturns$8;

          return (_fund$nominalReturns$7 = (_fund$nominalReturns$8 = fund.nominalReturns.find(function (nominalReturn) {
            return nominalReturn.year === currentYear - 4;
          })) === null || _fund$nominalReturns$8 === void 0 ? void 0 : _fund$nominalReturns$8.return) !== null && _fund$nominalReturns$7 !== void 0 ? _fund$nominalReturns$7 : '';
        },
        Cell: function Cell(_ref11) {
          var value = _ref11.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === NominalReturnOptions.FiveYearPast ? {
        id: 'fiveYearPast',
        sortType: 'basic',
        accessor: function accessor(fund) {
          var _fund$nominalReturns$9, _fund$nominalReturns$10;

          return (_fund$nominalReturns$9 = (_fund$nominalReturns$10 = fund.nominalReturns.find(function (nominalReturn) {
            return nominalReturn.year === currentYear - 5;
          })) === null || _fund$nominalReturns$10 === void 0 ? void 0 : _fund$nominalReturns$10.return) !== null && _fund$nominalReturns$9 !== void 0 ? _fund$nominalReturns$9 : '';
        },
        Cell: function Cell(_ref12) {
          var value = _ref12.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null];
      return mobileArray.filter(function (i) {
        return i != null;
      });
    } else {
      return [{
        Header: category,
        accessor: 'shortName',
        headerStyle: {
          flexDirection: 'row-reverse'
        },
        Cell: function Cell(_ref13) {
          var _fund$details2;

          var value = _ref13.value,
              fund = _ref13.row.original;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* MarketsBodyBold */.K9, {
            children: [value, ((_fund$details2 = fund.details) === null || _fund$details2 === void 0 ? void 0 : _fund$details2.ucitsClassification.toLocaleLowerCase().includes('non-ucits')) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: "*"
            })]
          });
        }
      }, {
        Header: r(Funds_res.currency),
        accessor: 'currency',
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.oneMonth),
        accessor: 'cumulativeReturns.oneMonthReturn',
        sortType: 'basic',
        Cell: function Cell(_ref14) {
          var value = _ref14.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.threeMonths),
        accessor: 'cumulativeReturns.threeMonthReturn',
        sortType: 'basic',
        Cell: function Cell(_ref15) {
          var value = _ref15.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.sixMonths),
        accessor: 'cumulativeReturns.sixMonthReturn',
        sortType: 'basic',
        Cell: function Cell(_ref16) {
          var value = _ref16.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.yearToDate),
        accessor: 'cumulativeReturns.yearToDateReturn',
        sortType: 'basic',
        Cell: function Cell(_ref17) {
          var value = _ref17.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        id: 'oneYearPast',
        sortType: 'basic',
        Header: currentYear - 1,
        accessor: function accessor(fund) {
          var _fund$nominalReturns$11, _fund$nominalReturns$12;

          return (_fund$nominalReturns$11 = (_fund$nominalReturns$12 = fund.nominalReturns.find(function (nominalReturn) {
            return nominalReturn.year === currentYear - 1;
          })) === null || _fund$nominalReturns$12 === void 0 ? void 0 : _fund$nominalReturns$12.return) !== null && _fund$nominalReturns$11 !== void 0 ? _fund$nominalReturns$11 : '';
        },
        Cell: function Cell(_ref18) {
          var value = _ref18.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        id: 'twoYearPast',
        sortType: 'basic',
        Header: currentYear - 2,
        accessor: function accessor(fund) {
          var _fund$nominalReturns$13, _fund$nominalReturns$14;

          return (_fund$nominalReturns$13 = (_fund$nominalReturns$14 = fund.nominalReturns.find(function (nominalReturn) {
            return nominalReturn.year === currentYear - 2;
          })) === null || _fund$nominalReturns$14 === void 0 ? void 0 : _fund$nominalReturns$14.return) !== null && _fund$nominalReturns$13 !== void 0 ? _fund$nominalReturns$13 : '';
        },
        Cell: function Cell(_ref19) {
          var value = _ref19.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        id: 'threeYearPast',
        sortType: 'basic',
        Header: currentYear - 3,
        accessor: function accessor(fund) {
          var _fund$nominalReturns$15, _fund$nominalReturns$16;

          return (_fund$nominalReturns$15 = (_fund$nominalReturns$16 = fund.nominalReturns.find(function (nominalReturn) {
            return nominalReturn.year === currentYear - 3;
          })) === null || _fund$nominalReturns$16 === void 0 ? void 0 : _fund$nominalReturns$16.return) !== null && _fund$nominalReturns$15 !== void 0 ? _fund$nominalReturns$15 : '';
        },
        Cell: function Cell(_ref20) {
          var value = _ref20.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        id: 'fourYearPast',
        sortType: 'basic',
        Header: currentYear - 4,
        accessor: function accessor(fund) {
          var _fund$nominalReturns$17, _fund$nominalReturns$18;

          return (_fund$nominalReturns$17 = (_fund$nominalReturns$18 = fund.nominalReturns.find(function (nominalReturn) {
            return nominalReturn.year === currentYear - 4;
          })) === null || _fund$nominalReturns$18 === void 0 ? void 0 : _fund$nominalReturns$18.return) !== null && _fund$nominalReturns$17 !== void 0 ? _fund$nominalReturns$17 : '';
        },
        Cell: function Cell(_ref21) {
          var value = _ref21.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        id: 'fiveYearPast',
        sortType: 'basic',
        Header: currentYear - 5,
        accessor: function accessor(fund) {
          var _fund$nominalReturns$19, _fund$nominalReturns$20;

          return (_fund$nominalReturns$19 = (_fund$nominalReturns$20 = fund.nominalReturns.find(function (nominalReturn) {
            return nominalReturn.year === currentYear - 5;
          })) === null || _fund$nominalReturns$20 === void 0 ? void 0 : _fund$nominalReturns$20.return) !== null && _fund$nominalReturns$19 !== void 0 ? _fund$nominalReturns$19 : '';
        },
        Cell: function Cell(_ref22) {
          var value = _ref22.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.volatility),
        accessor: 'details.riskRating',
        Cell: function Cell(_ref23) {
          var value = _ref23.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RiskRating, {
            value: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: '',
        accessor: 'details.onlineBuyAllowed',
        Cell: function Cell(_ref24) {
          var value = _ref24.value,
              fund = _ref24.row.original;
          return value ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonContainer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_Button/* Button */.z, {
              as: "a",
              title: r(Funds_res.buy),
              isSmall: true,
              href: fund.symbol !== 'LEQ' ? fundBuyUrl(fund.symbol) : stockBuyUrl(fund.symbol),
              bg: theme/* theme.colors.primary */.r.colors.primary,
              onClick: function onClick(e) {
                return e.stopPropagation();
              }
            })
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonContainer, {});
        },
        style: {
          textAlign: 'right'
        }
      }];
    }
  }, [category, currentYear, fundBuyUrl, isMobile, r, selectedReturn, stockBuyUrl]);
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/fund-table/useAnnualizedData.tsx












function useAnnualizedData(data, category, selectedReturn, fundBuyUrl, stockBuyUrl) {
  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  return react.useMemo(function () {
    if (isMobile) {
      var mobileArray = [{
        Header: category,
        accessor: 'shortName',
        headerStyle: {
          flexDirection: 'row-reverse'
        },
        Cell: function Cell(_ref) {
          var _fund$details;

          var value = _ref.value,
              fund = _ref.row.original;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* MarketsBodyBold */.K9, {
            children: [value, ((_fund$details = fund.details) === null || _fund$details === void 0 ? void 0 : _fund$details.ucitsClassification.toLocaleLowerCase().includes('non-ucits')) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: "*"
            })]
          });
        }
      }, {
        accessor: 'currency',
        style: {
          textAlign: 'right'
        },
        Cell: function Cell(_ref2) {
          var value = _ref2.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
            children: value
          });
        }
      }, {
        accessor: 'details.riskRating',
        Cell: function Cell(_ref3) {
          var value = _ref3.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RiskRating, {
            value: value,
            size: isMobile ? RiskRatingSize.Small : RiskRatingSize.Normal
          });
        },
        style: {
          textAlign: 'right'
        }
      }, selectedReturn === AnnualizedReturnOptions.OneYear ? {
        accessor: 'annualizedReturns.oneYearReturn',
        sortType: 'basic',
        Cell: function Cell(_ref4) {
          var value = _ref4.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === AnnualizedReturnOptions.TwoYears ? {
        accessor: 'annualizedReturns.twoYearReturn',
        sortType: 'basic',
        Cell: function Cell(_ref5) {
          var value = _ref5.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === AnnualizedReturnOptions.ThreeYears ? {
        accessor: 'annualizedReturns.threeYearReturn',
        sortType: 'basic',
        Cell: function Cell(_ref6) {
          var value = _ref6.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === AnnualizedReturnOptions.FourYears ? {
        accessor: 'annualizedReturns.fourYearReturn',
        sortType: 'basic',
        Cell: function Cell(_ref7) {
          var value = _ref7.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null, selectedReturn === AnnualizedReturnOptions.FiveYears ? {
        accessor: 'annualizedReturns.fiveYearReturn',
        sortType: 'basic',
        Cell: function Cell(_ref8) {
          var value = _ref8.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      } : null];
      return mobileArray.filter(function (i) {
        return i != null;
      });
    } else {
      return [{
        Header: category,
        accessor: 'shortName',
        headerStyle: {
          flexDirection: 'row-reverse'
        },
        Cell: function Cell(_ref9) {
          var _fund$details2;

          var value = _ref9.value,
              fund = _ref9.row.original;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* MarketsBodyBold */.K9, {
            children: [value, ((_fund$details2 = fund.details) === null || _fund$details2 === void 0 ? void 0 : _fund$details2.ucitsClassification.toLocaleLowerCase().includes('non-ucits')) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: "*"
            })]
          });
        }
      }, {
        Header: r(Funds_res.currency),
        accessor: 'currency',
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.oneYear),
        sortType: 'basic',
        accessor: function accessor(fund) {
          var _fund$annualizedRetur;

          return (_fund$annualizedRetur = fund.annualizedReturns.oneYearReturn) !== null && _fund$annualizedRetur !== void 0 ? _fund$annualizedRetur : '';
        },
        Cell: function Cell(_ref10) {
          var value = _ref10.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.twoYears),
        sortType: 'basic',
        accessor: function accessor(fund) {
          var _fund$annualizedRetur2;

          return (_fund$annualizedRetur2 = fund.annualizedReturns.twoYearReturn) !== null && _fund$annualizedRetur2 !== void 0 ? _fund$annualizedRetur2 : '';
        },
        Cell: function Cell(_ref11) {
          var value = _ref11.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.threeYears),
        sortType: 'basic',
        accessor: function accessor(fund) {
          var _fund$annualizedRetur3;

          return (_fund$annualizedRetur3 = fund.annualizedReturns.threeYearReturn) !== null && _fund$annualizedRetur3 !== void 0 ? _fund$annualizedRetur3 : '';
        },
        Cell: function Cell(_ref12) {
          var value = _ref12.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.fourYears),
        sortType: 'basic',
        accessor: function accessor(fund) {
          var _fund$annualizedRetur4;

          return (_fund$annualizedRetur4 = fund.annualizedReturns.fourYearReturn) !== null && _fund$annualizedRetur4 !== void 0 ? _fund$annualizedRetur4 : '';
        },
        Cell: function Cell(_ref13) {
          var value = _ref13.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.fiveYears),
        sortType: 'basic',
        accessor: function accessor(fund) {
          var _fund$annualizedRetur5;

          return (_fund$annualizedRetur5 = fund.annualizedReturns.fiveYearReturn) !== null && _fund$annualizedRetur5 !== void 0 ? _fund$annualizedRetur5 : '';
        },
        Cell: function Cell(_ref14) {
          var value = _ref14.value;
          return value !== '' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
            decimalScale: 2,
            hideZero: true,
            hideNullIndicator: true,
            displayPosNegColor: true,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.volatility),
        accessor: 'details.riskRating',
        Cell: function Cell(_ref15) {
          var value = _ref15.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RiskRating, {
            value: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: '',
        accessor: 'details.onlineBuyAllowed',
        Cell: function Cell(_ref16) {
          var value = _ref16.value,
              fund = _ref16.row.original;
          return value ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonContainer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_Button/* Button */.z, {
              as: "a",
              title: r(Funds_res.buy),
              isSmall: true,
              href: fund.symbol !== 'LEQ' ? fundBuyUrl(fund.symbol) : stockBuyUrl(fund.symbol),
              bg: theme/* theme.colors.primary */.r.colors.primary,
              onClick: function onClick(e) {
                return e.stopPropagation();
              }
            })
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonContainer, {});
        },
        style: {
          textAlign: 'right'
        }
      }];
    }
  }, [data, selectedReturn]);
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/fund-table/usePriceData.tsx











function usePriceData(data, category, fundBuyUrl, stockBuyUrl) {
  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r,
      locale = _useResource.locale;

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  return react.useMemo(function () {
    if (isMobile) {
      return [{
        Header: category,
        accessor: 'shortName',
        headerStyle: {
          flexDirection: 'row-reverse'
        },
        Cell: function Cell(_ref) {
          var _fund$details;

          var value = _ref.value,
              fund = _ref.row.original;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* MarketsBodyBold */.K9, {
            children: [value, ((_fund$details = fund.details) === null || _fund$details === void 0 ? void 0 : _fund$details.ucitsClassification.toLocaleLowerCase().includes('non-ucits')) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: "*"
            })]
          });
        }
      }, {
        Header: r(Funds_res.currency),
        accessor: 'currency',
        style: {
          textAlign: 'right'
        },
        Cell: function Cell(_ref2) {
          var value = _ref2.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
            children: value
          });
        }
      }, {
        Header: r(Funds_res.date),
        accessor: 'date',
        Cell: function Cell(_ref3) {
          var value = _ref3.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
            children: (0,src/* formatDate */.p6)(locale, new Date(value))
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.bidRate),
        accessor: 'bid',
        Cell: function Cell(_ref4) {
          var value = _ref4.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
            decimalScale: 2,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.askRate),
        accessor: 'ask',
        Cell: function Cell(_ref5) {
          var value = _ref5.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
            type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
            decimalScale: 2,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.volatility),
        accessor: 'details.riskRating',
        Cell: function Cell(_ref6) {
          var value = _ref6.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RiskRating, {
            value: value,
            size: isMobile ? RiskRatingSize.Small : RiskRatingSize.Normal
          });
        },
        style: {
          textAlign: 'right'
        }
      }];
    } else {
      return [{
        Header: category,
        accessor: 'shortName',
        headerStyle: {
          flexDirection: 'row-reverse'
        },
        Cell: function Cell(_ref7) {
          var _fund$details2;

          var value = _ref7.value,
              fund = _ref7.row.original;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* MarketsBodyBold */.K9, {
            children: [value, ((_fund$details2 = fund.details) === null || _fund$details2 === void 0 ? void 0 : _fund$details2.ucitsClassification.toLocaleLowerCase().includes('non-ucits')) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: "*"
            })]
          });
        }
      }, {
        Header: r(Funds_res.currency),
        accessor: 'currency',
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.date),
        accessor: 'date',
        Cell: function Cell(_ref8) {
          var value = _ref8.value;
          return (0,src/* formatDate */.p6)(locale, new Date(value));
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.bidRate),
        accessor: 'bid',
        Cell: function Cell(_ref9) {
          var value = _ref9.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
            decimalScale: 2,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.askRate),
        accessor: 'ask',
        Cell: function Cell(_ref10) {
          var value = _ref10.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
            decimalScale: 2,
            number: value
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: r(Funds_res.volatility),
        accessor: 'details.riskRating',
        Cell: function Cell(_ref11) {
          var value = _ref11.value;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RiskRating, {
            value: value,
            size: isMobile ? RiskRatingSize.Small : RiskRatingSize.Normal
          });
        },
        style: {
          textAlign: 'right'
        }
      }, {
        Header: '',
        accessor: 'details.onlineBuyAllowed',
        Cell: function Cell(_ref12) {
          var value = _ref12.value,
              fund = _ref12.row.original;
          return value ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonContainer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_Button/* Button */.z, {
              as: "a",
              title: r(Funds_res.buy),
              isSmall: true,
              href: fund.symbol !== 'LEQ' ? fundBuyUrl(fund.symbol) : stockBuyUrl(fund.symbol),
              bg: theme/* theme.colors.primary */.r.colors.primary,
              onClick: function onClick(e) {
                return e.stopPropagation();
              }
            })
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonContainer, {});
        },
        style: {
          textAlign: 'right'
        }
      }];
    }
  }, [category, fundBuyUrl, isMobile, locale, r, stockBuyUrl]);
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/fund-table/FundTable.tsx









var FundCategories;

(function (FundCategories) {
  FundCategories["BondFund"] = "Skuldabr\xE9fasj\xF3\xF0ir";
  FundCategories["EquityFund"] = "Hlutabr\xE9fasj\xF3\xF0ir";
  FundCategories["BalancedFund"] = "Blanda\xF0ir sj\xF3\xF0ir";
  FundCategories["ExchangeTradedFund"] = "Kauphallarsj\xF3\xF0ir";
  FundCategories["PrivateBankingFund"] = "Sj\xF3\xF0ir Einkabanka\xFEj\xF3nustu";
  FundCategories["UknownClassification"] = "\xD3\xFEekktur flokkur";
})(FundCategories || (FundCategories = {}));

var FundCategoriesEN;

(function (FundCategoriesEN) {
  FundCategoriesEN["BondFund"] = "Bond funds";
  FundCategoriesEN["EquityFund"] = "Equity funds";
  FundCategoriesEN["BalancedFund"] = "Balanced funds";
  FundCategoriesEN["ExchangeTradedFund"] = "ETFs";
  FundCategoriesEN["PrivateBankingFund"] = "Private banking funds";
  FundCategoriesEN["UknownClassification"] = "Unknown classification";
})(FundCategoriesEN || (FundCategoriesEN = {}));

function FundTable(_ref) {
  var data = _ref.data,
      fundDataType = _ref.fundDataType,
      selectedNominalReturn = _ref.selectedNominalReturn,
      selectedAnnualizedReturn = _ref.selectedAnnualizedReturn,
      category = _ref.category,
      fundDetailPrefix = _ref.fundDetailPrefix,
      fundBuyUrl = _ref.fundBuyUrl,
      stockBuyUrl = _ref.stockBuyUrl;

  var _useResource = (0,src/* useResource */.Wf)(),
      locale = _useResource.locale;

  var nominalReturnColumns = useNominalData(data, locale === 'is' ? FundCategories[category] : FundCategoriesEN[category], selectedNominalReturn, fundBuyUrl, stockBuyUrl);
  var annualizedColumns = useAnnualizedData(data, locale === 'is' ? FundCategories[category] : FundCategoriesEN[category], selectedAnnualizedReturn, fundBuyUrl, stockBuyUrl);
  var priceColumns = usePriceData(data, locale === 'is' ? FundCategories[category] : FundCategoriesEN[category], fundBuyUrl, stockBuyUrl);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FundsTableContainer, {
    fundDataType: fundDataType,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataTable, {
      "aria-label": locale === 'is' ? FundCategories[category] : FundCategoriesEN[category],
      data: data,
      columns: fundDataType === FundDataType.NominalReturn ? nominalReturnColumns : fundDataType === FundDataType.AnnualizedReturn ? annualizedColumns : priceColumns,
      colorTheme: "secondary",
      rowLink: function rowLink(_ref2) {
        var fund = _ref2.original;
        return {
          key: "".concat(fund.symbol),
          href: "".concat(fundDetailPrefix, "[symbol]"),
          as: "".concat(fundDetailPrefix).concat(fund.symbol.toLowerCase())
        };
      },
      isClickable: true
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/returns-selector-tabs/ReturnsSelectorTabs.tsx











function ReturnsSelectorTab(_ref) {
  var fundDataType = _ref.fundDataType,
      initialNominalReturn = _ref.initialNominalReturn,
      initialAnnualizedReturn = _ref.initialAnnualizedReturn,
      onSelectNominalReturn = _ref.onSelectNominalReturn,
      onSelectAnnualizedReturn = _ref.onSelectAnnualizedReturn;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var nominalReturnsConfig = useNominalReturnsOptions();
  var annualizedReturnsConfig = useAnnualizedReturnsOptions();

  var _React$useState = react.useState(initialNominalReturn),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      selectedNominalReturn = _React$useState2[0],
      setSelectedNominalReturn = _React$useState2[1];

  var _React$useState3 = react.useState(initialAnnualizedReturn),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      selectedAnnualizedReturn = _React$useState4[0],
      setSelectedAnnualizedReturn = _React$useState4[1];

  function selectReturn(val) {
    if (fundDataType === FundDataType.NominalReturn) {
      setSelectedNominalReturn(val);
      onSelectNominalReturn(val);
    } else if (fundDataType === FundDataType.AnnualizedReturn) {
      setSelectedAnnualizedReturn(val);
      onSelectAnnualizedReturn(val);
    }
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [fundDataType === FundDataType.NominalReturn && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSelectorTabs */.pV, {
      mobileLabel: r(Funds_res.selectInformation),
      mobileInset: true,
      onSelectTab: function onSelectTab(val) {
        selectReturn(Number(val));
      },
      selectedItemId: selectedNominalReturn.toString(),
      items: nominalReturnsConfig,
      color: theme/* theme.colors.secondary */.r.colors.secondary
    }), fundDataType === FundDataType.AnnualizedReturn && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSelectorTabs */.pV, {
      mobileLabel: r(Funds_res.selectInformation),
      mobileInset: true,
      onSelectTab: function onSelectTab(val) {
        selectReturn(Number(val));
      },
      selectedItemId: selectedAnnualizedReturn.toString(),
      items: annualizedReturnsConfig,
      color: theme/* theme.colors.secondary */.r.colors.secondary
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/funds/Funds.tsx



function Funds_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















var Funds_TableContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "emwar5u2"
} : 0)("margin-bottom:65px;", function (props) {
  return props.last ? 'margin-bottom:0;' : '';
}, ";@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:60px;", function (props) {
  return props.last ? 'margin-bottom:0;' : '';
}, ";}" + ( true ? "" : 0));

var FootnoteContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "emwar5u1"
} : 0)( true ? {
  name: "kyxxdx",
  styles: "padding-top:8px;display:flex;justify-content:flex-start"
} : 0);

var Disclaimer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "emwar5u0"
} : 0)("padding-top:10px;", function (props) {
  return props.marginTop ? 'margin-top:50px;' : '';
}, ";" + ( true ? "" : 0));

function Funds(_ref) {
  var _ref$order = _ref.order,
      order = _ref$order === void 0 ? CategoryOrder.Personal : _ref$order,
      funds = _ref.funds,
      fundDetailPrefix = _ref.fundDetailPrefix,
      fundBuyUrl = _ref.fundBuyUrl,
      stockBuyUrl = _ref.stockBuyUrl,
      disclaimerText = _ref.disclaimerText,
      foreignCurrencyDisclaimer = _ref.foreignCurrencyDisclaimer,
      einkabrefDisclaimer = _ref.einkabrefDisclaimer,
      fundsDisclaimer = _ref.fundsDisclaimer;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  var isTablet = (0,hooks_useMedia/* useMedia */.G)('md');
  var theme = (0,emotion_element_cbed451f_browser_esm.a)();

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useQuery = (0,useQuery/* useQuery */.a)(FETCH_FUNDS, {
    client: client,
    variables: {
      first: 100
    }
  }),
      _useQuery$data = _useQuery.data,
      data = _useQuery$data === void 0 ? funds : _useQuery$data;

  var _React$useState = react.useState(FundDataType.NominalReturn),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      fundDataType = _React$useState2[0],
      setSelectedFundDataType = _React$useState2[1];

  var categories = data === null || data === void 0 ? void 0 : data.funds.nodes.map(function (category) {
    return category.category;
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });

  if (order === CategoryOrder.Corporate) {
    categories === null || categories === void 0 ? void 0 : categories.forEach(function (item, i) {
      if (item === 'BondFund' && i >= 1) {
        var _ref2 = [categories[i], categories[0]];
        categories[0] = _ref2[0];
        categories[i] = _ref2[1];
      }
    });
  }

  var changeDataType = function changeDataType(fundDataType) {
    setSelectedFundDataType(fundDataType);
  };

  var _React$useState3 = react.useState(NominalReturnOptions.YearToDateReturn),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      selectedNominalReturn = _React$useState4[0],
      setSelectedNominalReturn = _React$useState4[1];

  var _React$useState5 = react.useState(AnnualizedReturnOptions.OneYear),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      selectedAnnualizedReturn = _React$useState6[0],
      setSelectedAnnualizedReturn = _React$useState6[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* ListHeaderContainer */.CU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 4 / 12
        },
        lg: {
          width: 5 / 12
        },
        children: !isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsListTitle */.hZ, {
            children: r(Funds_res.funds)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
            children: r(Funds_res.dataDisclaimer)
          })]
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsListTitleMobile */.Py, {
          children: r(Funds_res.fundPrice)
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 5 / 12
        },
        lg: {
          width: 5 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSelectorTabs */.pV, {
          mobileLabel: r(Funds_res.selectInformation),
          mobileInset: true,
          onSelectTab: function onSelectTab(val) {
            changeDataType(Number(val));
          },
          tabSpacing: "40px",
          selectedItemId: fundDataType.toString(),
          items: [{
            id: FundDataType.NominalReturn.toString(),
            label: r(Funds_res.nominalReturn)
          }, {
            id: FundDataType.AnnualizedReturn.toString(),
            label: r(Funds_res.nominalReturnAnnualized)
          }, {
            id: FundDataType.Price.toString(),
            label: r(Funds_res.rate)
          }],
          color: theme.colors.secondary
        })
      }), isMobile && fundDataType !== FundDataType.Price && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 8 / 12
        },
        lg: {
          width: 7 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReturnsSelectorTab, {
          fundDataType: fundDataType,
          initialNominalReturn: selectedNominalReturn,
          initialAnnualizedReturn: selectedAnnualizedReturn,
          onSelectNominalReturn: function onSelectNominalReturn(id) {
            setSelectedNominalReturn(id);
          },
          onSelectAnnualizedReturn: function onSelectAnnualizedReturn(id) {
            setSelectedAnnualizedReturn(id);
          }
        })
      })]
    }), categories === null || categories === void 0 ? void 0 : categories.map(function (category, index) {
      var _data$funds$nodes$fil;

      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Funds_TableContainer, {
        last: categories.length - 1 === index ? true : false,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FundTable, {
          category: category,
          fundBuyUrl: fundBuyUrl,
          stockBuyUrl: stockBuyUrl,
          data: (_data$funds$nodes$fil = data === null || data === void 0 ? void 0 : data.funds.nodes.filter(function (fund) {
            return fund.category === category;
          })) !== null && _data$funds$nodes$fil !== void 0 ? _data$funds$nodes$fil : [],
          fundDataType: fundDataType,
          selectedNominalReturn: selectedNominalReturn,
          selectedAnnualizedReturn: selectedAnnualizedReturn,
          fundDetailPrefix: fundDetailPrefix
        }), category == 'EquityFund' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FootnoteContainer, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
            children: foreignCurrencyDisclaimer
          })
        }), category == 'PrivateBankingFund' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FootnoteContainer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
              children: einkabrefDisclaimer
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FootnoteContainer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
              children: r(Funds_res.nonUcitsDisclaimer)
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FootnoteContainer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
              children: r(Funds_res.fundsDisclaimer)
            })
          })]
        })]
      }, category);
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
        children: fundsDisclaimer
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsDisclaimer, {
      text: disclaimerText
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FundTypeInfoContainer, {
      children: r(Funds_res.fundsDisclaimer2)
    })]
  });
}
var FundDataType;

(function (FundDataType) {
  FundDataType[FundDataType["AnnualizedReturn"] = 0] = "AnnualizedReturn";
  FundDataType[FundDataType["NominalReturn"] = 1] = "NominalReturn";
  FundDataType[FundDataType["Price"] = 2] = "Price";
})(FundDataType || (FundDataType = {}));

var CategoryOrder;

(function (CategoryOrder) {
  CategoryOrder["Personal"] = "Personal";
  CategoryOrder["Corporate"] = "Corporate";
})(CategoryOrder || (CategoryOrder = {}));
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/shared/markets-disclaimer/MarketsDisclaimer.res.ts
/* harmony default export */ var MarketsDisclaimer_res = ({
  disclaimer: {
    landsbref: {
      is: 'Upplýsingar á þessari síðu eru samkvæmt bestu vitund Landsbréfa og ætlaðar til fróðleiks, en ekki sem grundvöllur viðskipta. Landsbréf bera ekki ábyrgð á hugsanlegum villum eða töfum upplýsinga og/eða ákvörðunum byggðum á þeim.',
      en: 'All information made available on this website is believed to be accurate, according to the best knowledge of Landsbréf, and is intended for information purposes only and not to be used as a basis for business transactions. Landsbréf bears no liability for any inaccuracies or delays in updating information and/or for decisions based on such information. Data on this website is subject to at least a 15-minute delay.'
    },
    landsbankinn: {
      is: 'Upplýsingar á þessari síðu eru samkvæmt bestu vitund Landsbankans og ætlaðar til fróðleiks, en ekki sem grundvöllur viðskipta. Landsbankinn ber ekki ábyrgð á hugsanlegum villum eða töfum upplýsinga og/eða ákvörðunum byggðum á þeim.',
      en: 'All information made available on this website is believed to be accurate, according to the best knowledge of Landsbankinn hf., and is intended for information purposes only and not to be used as a basis for business transactions. Landsbankinn hf. bears no liability for any inaccuracies or delays in updating information and/or for decisions based on such information. Data on this website is subject to at least a 15-minute delay.'
    }
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/containers/FundsContainer.tsx










function FundsContainer() {
  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useQuery = (0,useQuery/* useQuery */.a)(FETCH_FUNDS, {
    client: client,
    variables: {
      first: 100
    }
  }),
      data = _useQuery.data;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r,
      locale = _useResource.locale;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Funds, {
      funds: data,
      fundBuyUrl: function fundBuyUrl() {
        return 'https://netbanki.landsbankinn.is/Securities/Overview/Overview.aspx#/funds/market';
      },
      stockBuyUrl: function stockBuyUrl() {
        return 'https://netbanki.landsbankinn.is/Securities/Overview/Overview.aspx#/stocks/market';
      },
      fundDetailPrefix: locale == 'is' ? '/sjodir/' : '/en/mutual-funds/',
      disclaimerText: r(MarketsDisclaimer_res.disclaimer.landsbref),
      einkabrefDisclaimer: r(Funds_res.einkabrefDisclaimer.landsbref),
      foreignCurrencyDisclaimer: r(Funds_res.foreignCurrencyDisclaimer.landsbref),
      fundsDisclaimer: r(Funds_res.fundsDisclaimer3.landsbref)
    })
  });
}
;// CONCATENATED MODULE: ../../packages/ui/src/components/form/text/FormDescription.tsx





var FormDescription_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12y0tju0"
} : 0)(typography/* typography.body */.cp.body, ";" + ( true ? "" : 0));

function FormDescription(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormDescription_Host, {
    children: children
  });
}
// EXTERNAL MODULE: ../../packages/ui/src/components/icons/CheckboxActive.tsx
var CheckboxActive = __webpack_require__(29387);
;// CONCATENATED MODULE: ../../packages/ui/src/components/form/radio-button/CheckboxRadio.tsx



var CheckboxRadio_excluded = ["checked", "onChange", "id", "label", "bordered", "disabled"];

function CheckboxRadio_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CheckboxRadio_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CheckboxRadio_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CheckboxRadio_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function CheckboxRadio_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var CheckboxHost = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1swpqre3"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var CheckboxInput = (0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "e1swpqre2"
} : 0)(mixins/* dynamicInput */.w$, ";" + ( true ? "" : 0));

var dynamicLabel = function dynamicLabel(props) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("position:relative;padding-left:45px;cursor:pointer;white-space:pre-wrap;display:block;&::before{content:'';position:absolute;left:0;top:0px;width:28px;height:28px;border-radius:1px;background-color:", props.theme.colors.background, ";border:1px solid ", props.disabled ? '#a0a0a0' : props.theme.colors.primary, ";border-width:", props.bordered ? '1px' : '0px', ";border-radius:1px;background-color:", props.checked ? props.disabled ? '#a0a0a0' : props.theme.colors.primary : props.theme.colors.background, ";}&:hover::before{background-image:url('data:image/svg+xml;utf8,<svg width=\"16px\" height=\"15px\" viewBox=\"0 0 16 15\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" ><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Assets\" transform=\"translate(-347.000000, -1288.000000)\" stroke=\"%2372DCEB\" stroke-width=\"2\"><polyline id=\"icon-check-hover\" transform=\"translate(355.000000, 1295.000000) scale(-1, 1) rotate(-180.000000) translate(-355.000000, -1295.000000) \" points=\"348 1295.46154 353.5 1289 362 1301\"></polyline></g></g></svg>');background-repeat:no-repeat;background-size:16px;background-position:center;}" + ( true ? "" : 0),  true ? "" : 0);
};

var CheckboxRadio_Label = (0,emotion_styled_base_browser_esm/* default */.Z)("label",  true ? {
  target: "e1swpqre1"
} : 0)(dynamicLabel, " ", typography/* typography.body */.cp.body, " line-height:28px;height:28px;" + ( true ? "" : 0));

var CheckboxSvg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CheckboxActive/* CheckboxActive */.d,  true ? {
  target: "e1swpqre0"
} : 0)( true ? {
  name: "1m19vma",
  styles: "position:absolute;left:0;top:0"
} : 0);

var CheckboxRadio = function CheckboxRadio(_ref) {
  var checked = _ref.checked,
      _onChange = _ref.onChange,
      id = _ref.id,
      label = _ref.label,
      bordered = _ref.bordered,
      disabled = _ref.disabled,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, CheckboxRadio_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CheckboxHost, CheckboxRadio_objectSpread(CheckboxRadio_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxInput, {
      id: "radio_".concat(label, "_").concat(id),
      type: "radio",
      checked: checked,
      disabled: disabled,
      onChange: function onChange() {
        if (_onChange) {
          _onChange(!checked);
        }
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CheckboxRadio_Label, {
      htmlFor: "radio_".concat(label, "_").concat(id),
      checked: checked,
      bordered: bordered,
      disabled: disabled !== null && disabled !== void 0 ? disabled : false,
      children: [checked && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxSvg, {
        height: "28px",
        width: "28px"
      }), label]
    })]
  }));
};
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/gdpr/requestGdprData.ts


var requestGdprData_templateObject;


var REQUEST_GDPR_DATA = (0,lib/* gql */.Ps)(requestGdprData_templateObject || (requestGdprData_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation RequestGdprData($data: RequestGdprDataInput!) {\n    requestGdprData(data: $data) {\n      id\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/phone-authentication/PhoneAuthInput.tsx



function PhoneAuthInput_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var PhoneAuthInput_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1i2a9ku3"
} : 0)( true ? "" : 0);

var PhoneAuthInput_H2 = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1i2a9ku2"
} : 0)(typography/* typography.h2 */.cp.h2, " margin-bottom:20px;" + ( true ? "" : 0));

var P = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1i2a9ku1"
} : 0)( true ? {
  name: "qkomnt",
  styles: "margin-bottom:40px"
} : 0);

var PhoneAuthInput_BigButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "e1i2a9ku0"
} : 0)( true ? {
  name: "ll17t0",
  styles: "width:100%;margin-top:20px"
} : 0);

function PhoneAuthInput(_ref) {
  var title = _ref.title,
      description = _ref.description,
      login = _ref.login,
      loading = _ref.loading,
      error = _ref.error;

  var _useState = (0,react.useState)(''),
      phoneNumber = _useState[0],
      setPhoneNumber = _useState[1];

  var _usePhoneValidation = (0,usePhoneValidation/* usePhoneValidation */.p)(phoneNumber),
      _usePhoneValidation2 = (0,slicedToArray/* default */.Z)(_usePhoneValidation, 3),
      phoneRef = _usePhoneValidation2[0],
      isPhoneValid = _usePhoneValidation2[1],
      errorMessage = _usePhoneValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PhoneAuthInput_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneAuthInput_H2, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(P, {
      children: description
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contact_input_PhoneInput/* PhoneInput */.s, {
      label: "Au\xF0kenna me\xF0 s\xEDman\xFAmeri",
      value: phoneNumber,
      inputRef: phoneRef,
      isValid: isPhoneValid,
      errorMessage: errorMessage,
      onValueChange: function onValueChange(_ref2) {
        var value = _ref2.value;
        return setPhoneNumber(value);
      },
      inputSize: "big",
      variant: "noBorder",
      labelVariant: "aboveInput",
      textAlign: "center"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneAuthInput_BigButton, {
      bg: theme/* theme.colors.primary */.r.colors.primary,
      title: "Au\xF0kenna",
      loading: loading,
      onClick: function onClick() {
        login(phoneNumber.replaceAll('-', ''));
      }
    }), error && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(P, {
      children: "Ekki t\xF3kst a\xF0 skr\xE1 \xFEig inn me\xF0 rafr\xE6num skilr\xEDkjum"
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/phone-authentication/PhoneAuthentication.tsx







var tempImage = {
  alt: 'alt texti',
  ar_1_1: {
    alt: null,
    copyright: null,
    dimensions: {
      width: 1920,
      height: 1920
    },
    url: 'https://images.prismic.io/landsbankinn/94982f1c-642d-4394-a6f4-0379bb6b55d4_Mynd.jpg?auto=compress,format&rect=420,0,1080,1080&w=1920&h=1920'
  },
  ar_4_3: {
    alt: null,
    copyright: null,
    dimensions: {
      width: 1920,
      height: 1440
    },
    url: 'https://images.prismic.io/landsbankinn/94982f1c-642d-4394-a6f4-0379bb6b55d4_Mynd.jpg?auto=compress,format&rect=240,0,1440,1080&w=1920&h=1440'
  },
  ar_16_9: {
    alt: null,
    copyright: null,
    dimensions: {
      width: 1920,
      height: 1080
    },
    url: 'https://images.prismic.io/landsbankinn/94982f1c-642d-4394-a6f4-0379bb6b55d4_Mynd.jpg?auto=compress,format&rect=0,0,1920,1080&w=1920&h=1080'
  },
  copyright: null,
  dimensions: {
    width: 1920,
    height: 1080
  },
  url: 'https://images.prismic.io/landsbankinn/94982f1c-642d-4394-a6f4-0379bb6b55d4_Mynd.jpg?auto=compress,format'
};
var PhoneAuthentication_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1k99yqh2"
} : 0)("display:block;position:relative;width:auto;margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";background-color:", function (props) {
  return props.theme.shades.primary2;
}, ";display:flex;flex-direction:column-reverse;max-width:1179px;min-height:581px;-webkit-user-select:none;-webkit-user-drag:none;-webkit-app-region:no-drag;padding-bottom:40px;cursor:pointer;user-select:text;", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.desktop */.U.desktop, "{flex-direction:row;width:100%;margin-left:0;margin-right:0;margin-bottom:30px;padding-bottom:0px;}&:hover img{transform:scale(1.025);}" + ( true ? "" : 0));

var PhoneAuthentication_Body = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1k99yqh1"
} : 0)("padding-top:72px;padding-left:20px;padding-right:20px;@media screen and (max-width: 720px){width:100%;}display:flex;flex-direction:column;@media ", devices/* device.desktop */.U.desktop, "{width:50%;padding-left:100px;padding-right:120px;}" + ( true ? "" : 0));

var PhoneAuthentication_Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Img,  true ? {
  target: "e1k99yqh0"
} : 0)("@media ", devices/* device.desktop */.U.desktop, "{width:50%;}@media screen and (max-width: 720px){width:100%;}" + ( true ? "" : 0));

function PhoneAuthentication(_ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image,
      login = _ref.login,
      loading = _ref.loading,
      error = _ref.error;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PhoneAuthentication_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneAuthentication_Body, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneAuthInput, {
        title: title,
        description: description,
        login: login,
        loading: loading,
        error: error
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneAuthentication_Image, {
      alt: "Rafr\xE6n au\xF0kenning",
      src: image ? image : tempImage,
      aspectRatio: 4 / 3
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/icons/DatepickerWithCheckmark.tsx



function DatepickerWithCheckmark(_ref) {
  var className = _ref.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "220",
    height: "220",
    viewBox: "0 0 220 220",
    className: className,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
        stroke: "#1E3D5A",
        strokeWidth: "3",
        transform: "translate(-911 -5321)",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
          transform: "translate(913 5323)",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M0 19.5L216 19.5 216 216 0 216z"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M46.5 0L46.5 46.5"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M168 0L168 46.5"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M0 66L216 66"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M154.5 141c0 25.681-20.819 46.5-46.5 46.5S61.5 166.681 61.5 141 82.319 94.5 108 94.5"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M88.5 136.289l15.274 11.283c2.008 1.482 4.843 1.156 6.45-.743L154.5 94.5"
          })]
        })
      })
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gdpr-request/GdprSuccess.tsx


function GdprSuccess_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var GdprSuccess_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e9pqait3"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:", function (props) {
  return props.theme.baseline * 7;
}, "px;" + ( true ? "" : 0));

var SecoundText = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e9pqait2"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:", function (props) {
  return props.theme.baseline * 10;
}, "px;" + ( true ? "" : 0));

var SvgColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e9pqait1"
} : 0)( true ? {
  name: "1wnowod",
  styles: "display:flex;align-items:center;justify-content:center"
} : 0);

var GdprSuccess_Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(DatepickerWithCheckmark,  true ? {
  target: "e9pqait0"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

function GdprSuccess() {
  var isDesktop = (0,hooks_useMedia/* useMedia */.G)('lg');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 10 / 12,
          offset: 1 / 12
        },
        lg: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormTitle/* FormTitle */.v, {
          text: "Bei\xF0nin hefur veri\xF0 m\xF3ttekin"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
            sm: {
              width: 12 / 12
            },
            lg: {
              width: 9.8 / 12
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprSuccess_Text, {
              children: "Landsbankinn hefur m\xF3tteki\xF0 bei\xF0ni \xFE\xEDna og mun n\xFA hefjast handa vi\xF0 a\xF0 afgrei\xF0a bei\xF0nina."
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SecoundText, {
              children: "Landsbankinn leitast vi\xF0 a\xF0 svara \xF6llum bei\xF0num innan 30 daga en eftir atvikum g\xE6ti afgrei\xF0sla erinda tafist \xED lj\xF3si st\xE6r\xF0ar og umfangs starfsemi bankans. Ef svo er ver\xF0ur \xFE\xFA uppl\xFDst(ur) um fyrirhuga\xF0a t\xF6f og \xE1st\xE6\xF0ur hennar."
            })]
          })
        })]
      }), isDesktop && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgColumn, {
        md: {
          width: 5 / 12
        },
        lg: {
          width: 6 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprSuccess_Icon, {})
      })]
    })
  });
}
// EXTERNAL MODULE: ../../node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(51949);
;// CONCATENATED MODULE: ../../packages/slices/src/components/gdpr-request/useLogin.ts




function useLogin_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useLogin_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useLogin_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useLogin_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function getToken(encodedToken) {
  var _parsed, _parsed2;

  // token ""easday""
  var bearer = 'Bearer ';
  var cleaned = encodedToken.startsWith(bearer) ? encodedToken.substring(bearer.length) : encodedToken; // substring because authorization is always "Bearer xyz... "

  var parsed = (0,jwt_decode_esm/* default */.Z)(cleaned); // Patch changes being made to tokens from our identity provider where claims property is omitted.
  // TODO: Should be removed when Identity Provider is same between dev/uat/prod environments

  if ((_parsed = parsed) !== null && _parsed !== void 0 && _parsed.claims && typeof ((_parsed2 = parsed) === null || _parsed2 === void 0 ? void 0 : _parsed2.claims) === typeof '') {
    var parsedClaims = JSON.parse(parsed.claims);
    parsed = useLogin_objectSpread({
      parsed: parsed
    }, parsedClaims);
  }

  return parsed;
}

var getUserFromToken = function getUserFromToken(token) {
  var decoded = getToken(token);
  var name = decoded['customer.actingName'];
  var email = decoded['email'];
  return {
    name: name,
    email: email
  };
};

var useLogin = function useLogin() {
  var _useState = (0,react.useState)({
    data: undefined,
    error: undefined,
    loading: false,
    isLoggedIn: false
  }),
      response = _useState[0],
      setResponse = _useState[1];

  function getPkiSim(_x) {
    return _getPkiSim.apply(this, arguments);
  }

  function _getPkiSim() {
    _getPkiSim = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(phoneNumber) {
      var response, token;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setResponse({
                data: undefined,
                error: undefined,
                loading: true,
                isLoggedIn: false
              });
              _context.next = 3;
              return fetch("https://mobile.landsbankinn.is/services/authentication/pkisim", {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  phoneNumber: phoneNumber
                })
              });

            case 3:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 10;
                break;
              }

              _context.next = 7;
              return response.json();

            case 7:
              token = _context.sent;
              setResponse({
                data: {
                  token: token,
                  user: useLogin_objectSpread(useLogin_objectSpread({}, getUserFromToken(token)), {}, {
                    phoneNumber: phoneNumber
                  })
                },
                error: undefined,
                loading: false,
                isLoggedIn: true
              });
              return _context.abrupt("return");

            case 10:
              setResponse({
                data: undefined,
                error: true,
                loading: false,
                isLoggedIn: false
              });

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _getPkiSim.apply(this, arguments);
  }

  return [getPkiSim, response];
};
// EXTERNAL MODULE: ../../packages/ui/src/components/tooltip/Tooltip.tsx
var Tooltip = __webpack_require__(16172);
;// CONCATENATED MODULE: ../../packages/slices/src/components/gdpr-request/RequestGdprData/GdprCheckbox.tsx




function GdprCheckbox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function GdprCheckbox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GdprCheckbox_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GdprCheckbox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function GdprCheckbox_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var GdprCheckbox_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evx8shn1"
} : 0)( true ? {
  name: "11a4mma",
  styles: "display:flex;flex-direction:row;align-items:center;&>*+*{margin-left:12px;}"
} : 0);

var StyledCheckbox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Checkbox/* Checkbox */.XZ,  true ? {
  target: "evx8shn0"
} : 0)( true ? {
  name: "1qsuvl4",
  styles: "background:transparent"
} : 0);

function GdprCheckbox(_ref) {
  var label = _ref.label,
      setGdprData = _ref.setGdprData,
      gdprData = _ref.gdprData,
      type = _ref.type,
      tooltipText = _ref.tooltipText,
      tooltipTitle = _ref.tooltipTitle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GdprCheckbox_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCheckbox, {
      label: label,
      id: type,
      checked: gdprData.types.includes(type),
      variant: "noBorder",
      onChange: function onChange(checked) {
        if (checked) {
          setGdprData(GdprCheckbox_objectSpread(GdprCheckbox_objectSpread({}, gdprData), {}, {
            types: [].concat((0,toConsumableArray/* default */.Z)(gdprData.types), [type])
          }));
        } else {
          setGdprData(GdprCheckbox_objectSpread(GdprCheckbox_objectSpread({}, gdprData), {}, {
            types: gdprData.types.filter(function (i) {
              return i !== type;
            })
          }));
        }
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* Tooltip */.u, {
      useQuestionMark: true,
      title: tooltipTitle,
      copy: tooltipText,
      bg: theme/* theme.shades.secondary2 */.r.shades.secondary2
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gdpr-request/RequestGdprData/CheckboxContainer.tsx







function CheckboxContainer(_ref) {
  var setGdprData = _ref.setGdprData,
      gdprData = _ref.gdprData;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
      md: {
        width: 6 / 12
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprCheckbox, {
        type: globalTypes/* RequestGdprDataType.Deposit */.c.Deposit,
        label: "Innl\xE1n",
        gdprData: gdprData,
        setGdprData: setGdprData,
        tooltipText: "Uppl\xFDsingar um veltu-, sparireikninga o.fl. (einnig a\xF0gengilegar \xED netbanka vi\xF0skiptavina).",
        tooltipTitle: "Innl\xE1n"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprCheckbox, {
        type: globalTypes/* RequestGdprDataType.Loan */.c.Loan,
        label: "\xDAtl\xE1n",
        gdprData: gdprData,
        setGdprData: setGdprData,
        tooltipText: "Afrit af skuldabr\xE9fi, l\xE1nasamningi, yfirdr\xE6tti og grei\xF0slumati \xE1samt fylgiskj\xF6lum, uppl\xFDsingar um l\xE1nsh\xE6fismat.",
        tooltipTitle: "\xDAtl\xE1n"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprCheckbox, {
        type: globalTypes/* RequestGdprDataType.Debt */.c.Debt,
        label: "Innheimtukr\xF6fur",
        gdprData: gdprData,
        setGdprData: setGdprData,
        tooltipText: "Yfirlit yfir kr\xF6fur sem bankinn innheimtir fyrir \xFEri\xF0ju a\xF0ila (einnig a\xF0gengilegt \xED netbanka vi\xF0skiptavina).",
        tooltipTitle: "Innheimtukr\xF6fur"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprCheckbox, {
        type: globalTypes/* RequestGdprDataType.DebtCollection */.c.DebtCollection,
        label: "Innheimta og vanskil",
        gdprData: gdprData,
        setGdprData: setGdprData,
        tooltipText: "Afrit af innheimtubr\xE9fum, grei\xF0slu\xE1skorunum, stefnu/m kr\xF6ful\xFDsingum, afrit af grei\xF0sluerfi\xF0leikamati og fylgiskj\xF6lum eftir \xFEv\xED sem vi\xF0 \xE1.",
        tooltipTitle: "Innheimta og vanskil"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprCheckbox, {
        type: globalTypes/* RequestGdprDataType.Securities */.c.Securities,
        label: "Ver\xF0br\xE9favi\xF0skipti",
        gdprData: gdprData,
        setGdprData: setGdprData,
        tooltipText: "Afrit af bei\xF0ni um ver\xF0br\xE9favi\xF0skipti og fylgiskj\xF6l, MiFID sta\xF0festing, bei\xF0ni um flokkun \xED ver\xF0br\xE9favi\xF0skiptum, \xE1rei\xF0anleikak\xF6nnun o.fl.",
        tooltipTitle: "Ver\xF0br\xE9favi\xF0skipti"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
      md: {
        width: 6 / 12
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprCheckbox, {
        type: globalTypes/* RequestGdprDataType.AssetManagement */.c.AssetManagement,
        label: "Eignast\xFDring",
        gdprData: gdprData,
        setGdprData: setGdprData,
        tooltipText: "Afrit af samningi um eignast\xFDringu, fj\xE1rfestingastefna, ums\xF3kn um innl\xE1nsreikning, uppl\xFDsingar vegna r\xE1\xF0gjafar o.fl.",
        tooltipTitle: "Eignast\xFDring"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprCheckbox, {
        type: globalTypes/* RequestGdprDataType.Pension */.c.Pension,
        label: "L\xEDfeyrissparna\xF0ur",
        gdprData: gdprData,
        setGdprData: setGdprData,
        tooltipText: "Afrit af samningi um l\xEDfeyris- og vi\xF0b\xF3tarl\xEDfeyrissparna\xF0, ums\xF3kn um \xFAttektir o.fl.",
        tooltipTitle: "L\xEDfeyrissparna\xF0ur"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprCheckbox, {
        type: globalTypes/* RequestGdprDataType.CustomerInfo */.c.CustomerInfo,
        label: "Vi\xF0skiptavinurinn",
        gdprData: gdprData,
        setGdprData: setGdprData,
        tooltipText: "Afrit af \xFEj\xF3nustusamningum t.d. um a\xF0gang a\xF0 netbanka og a\xF0 geymsluh\xF3lfi, afrit af skilr\xEDkjum, umbo\xF0um o.fl.",
        tooltipTitle: "Vi\xF0skiptavinurinn"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprCheckbox, {
        type: globalTypes/* RequestGdprDataType.JobApplication */.c.JobApplication,
        label: "Starfsums\xF3kn og starfsmannauppl.",
        gdprData: gdprData,
        setGdprData: setGdprData,
        tooltipText: "Afrit af starfsums\xF3kn, r\xE1\xF0ningarsamningi, verktakasamningi, tr\xFAna\xF0aryfirl\xFDsingum o.fl.",
        tooltipTitle: "Starfsums\xF3kn og starfsmannauppl\xFDsingar"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprCheckbox, {
        type: globalTypes/* RequestGdprDataType.GeneralAnnouncement */.c.GeneralAnnouncement,
        label: "Almennar tilkynningar og yfirlit",
        gdprData: gdprData,
        setGdprData: setGdprData,
        tooltipText: "Afrit af \xF6llum tilkynningum sem bankinn hefur sent vi\xF0skiptavini og reikningsyfirlitum fr\xE1 upphafi vi\xF0skipta. Vakin er athygli \xE1 \xFEv\xED a\xF0 reikningsyfirlit 6 \xE1r aftur \xED t\xEDmann eru \xFEegar a\xF0gengileg \xED netbanka vi\xF0skiptavinar. Umr\xE6dd g\xF6gn fela \xED s\xE9r talsvert gagnamagn.",
        tooltipTitle: "Almennar tilkynningar og yfirlit"
      })]
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gdpr-request/RequestGdprData/RequestGdprData.tsx




function RequestGdprData_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function RequestGdprData_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { RequestGdprData_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { RequestGdprData_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function RequestGdprData_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var RequestGdprData_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ps1puw5"
} : 0)( true ? "" : 0);

var RequestGdprData_FormSpacer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ps1puw4"
} : 0)("height:1px;background:", function (props) {
  return (0,polished_esm/* rgba */.m4)(props.theme.colors.primary, 0.1);
}, ";", function (props) {
  return props.smallTop ? 'margin-top: 20px;' : 'margin-top: 40px;';
}, ";margin-bottom:40px;" + ( true ? "" : 0));

var BodySmall = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ps1puw3"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, " ", function (props) {
  return props.bold ? 'font-weight:bold;margin-bottom:10px;' : '';
}, ";" + ( true ? "" : 0));

var RowBottom = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e1ps1puw2"
} : 0)( true ? {
  name: "1xfxfdu",
  styles: "height:100%;align-content:flex-end"
} : 0);

var RequestGdprData_BigButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "e1ps1puw1"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var MarginSegment = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Segment/* Segment */.X,  true ? {
  target: "e1ps1puw0"
} : 0)("margin-left:-44px;margin-right:-44px;background-color:", function (props) {
  return props.theme.shades.primary2;
}, ";@media ", devices/* device.tablet */.U.tablet, "{margin-left:initial;margin-right:initial;}" + ( true ? "" : 0));

function RequestGdprData(_ref) {
  var title = _ref.title,
      description = _ref.description,
      login_image = _ref.login_image,
      login_description = _ref.login_description,
      login_title = _ref.login_title;

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useState = (0,react.useState)(false),
      finished = _useState[0],
      setFinished = _useState[1];

  var _useState2 = (0,react.useState)({
    types: [],
    email: '',
    phoneNumber: '',
    formerSPCustomer: null
  }),
      gdprData = _useState2[0],
      setGdprData = _useState2[1];

  var _useEmailValidation = (0,useEmailValidation/* useEmailValidation */.$)(gdprData.email),
      _useEmailValidation2 = (0,slicedToArray/* default */.Z)(_useEmailValidation, 3),
      emailRef = _useEmailValidation2[0],
      isEmailValid = _useEmailValidation2[1],
      errorMessage = _useEmailValidation2[2];

  var _useLogin = useLogin(),
      _useLogin2 = (0,slicedToArray/* default */.Z)(_useLogin, 2),
      login = _useLogin2[0],
      _useLogin2$ = _useLogin2[1],
      data = _useLogin2$.data,
      loading = _useLogin2$.loading,
      isLoggedIn = _useLogin2$.isLoggedIn,
      error = _useLogin2$.error;

  (0,react.useEffect)(function () {
    if (data) {
      var _data$user = data.user,
          phoneNumber = _data$user.phoneNumber,
          email = _data$user.email;
      setGdprData(RequestGdprData_objectSpread(RequestGdprData_objectSpread({}, gdprData), {}, {
        phoneNumber: phoneNumber,
        email: email !== null && email !== void 0 ? email : ''
      }));
    }
  }, [data]);

  var _useMutation = (0,useMutation/* useMutation */.D)(REQUEST_GDPR_DATA, {
    client: client,
    context: {
      headers: {
        authorization: data !== null && data !== void 0 && data.token ? "Bearer ".concat(data.token) : ''
      }
    },
    onCompleted: function onCompleted() {
      return setFinished(true);
    }
  }),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 1),
      requestData = _useMutation2[0];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RequestGdprData_Host, {
    children: [!finished && !isLoggedIn && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneAuthentication, {
      title: login_title,
      description: login_description,
      image: login_image,
      login: login,
      loading: loading,
      error: error
    }), !finished && isLoggedIn && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarginSegment, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          requestData({
            variables: {
              data: gdprData
            }
          });
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 5 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormTitle/* FormTitle */.v, {
              text: title
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12,
              offset: 1 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormDescription, {
              children: description
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxContainer, {
            setGdprData: setGdprData,
            gdprData: gdprData
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequestGdprData_FormSpacer, {
          smallTop: true
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmaiInput_EmailInput, {
              label: "Netfang ums\xE6kjanda",
              isValid: isEmailValid,
              inputRef: emailRef,
              errorMessage: errorMessage,
              value: gdprData.email,
              variant: "noBorder",
              labelVariant: "aboveInput",
              onChange: function onChange(e) {
                return setGdprData(RequestGdprData_objectSpread(RequestGdprData_objectSpread({}, gdprData), {}, {
                  email: e.target.value
                }));
              }
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequestGdprData_FormSpacer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
            lg: {
              width: 6 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BodySmall, {
              bold: true,
              children: "Hefuru \xE1\xF0ur veri\xF0 vi\xF0skiptavinur sparisj\xF3\xF0s e\xF0a fj\xE1rm\xF6gnunarfyrirt\xE6kis sem er n\xFA hluti af Landsbankanum?"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BodySmall, {
              children: "Um er a\xF0 r\xE6\xF0a: Sparisj\xF3\xF0 Keflav\xEDkur, Sparisj\xF3\xF0 Nor\xF0urlands, Sparisj\xF3\xF0 Vestmannaeyja, SP-fj\xE1rm\xF6gnun og Avant sem n\xFA er hluti af Landsbankanum."
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RowBottom, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                lg: {
                  width: 1 / 5
                },
                md: {
                  width: 12 / 12
                },
                sm: {
                  width: 12 / 12
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxRadio, {
                  label: "J\xE1",
                  id: "formerSPCustomer",
                  checked: gdprData.formerSPCustomer === true,
                  onChange: function onChange() {
                    setGdprData(RequestGdprData_objectSpread(RequestGdprData_objectSpread({}, gdprData), {}, {
                      formerSPCustomer: true
                    }));
                  }
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                lg: {
                  width: 1 / 5
                },
                md: {
                  width: 12 / 12
                },
                sm: {
                  width: 12 / 12
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxRadio, {
                  label: "Nei",
                  id: "formerSPCustomer",
                  checked: gdprData.formerSPCustomer === false,
                  onChange: function onChange() {
                    setGdprData(RequestGdprData_objectSpread(RequestGdprData_objectSpread({}, gdprData), {}, {
                      formerSPCustomer: false
                    }));
                  }
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
                lg: {
                  width: 2 / 5
                },
                md: {
                  width: 12 / 12
                },
                sm: {
                  width: 12 / 12
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxRadio, {
                  label: "Veit ekki",
                  id: "formerSPCustomer",
                  checked: gdprData.formerSPCustomer === undefined,
                  onChange: function onChange() {
                    setGdprData(RequestGdprData_objectSpread(RequestGdprData_objectSpread({}, gdprData), {}, {
                      formerSPCustomer: undefined
                    }));
                  }
                })
              })]
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequestGdprData_FormSpacer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              offset: 6 / 12,
              width: 6 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequestGdprData_BigButton, {
              bg: theme/* theme.colors.primary */.r.colors.primary,
              type: "submit",
              title: "Senda bei\xF0ni"
            })
          })
        })]
      })
    }), finished && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprSuccess, {})]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/gdpr/updateGdprData.ts


var updateGdprData_templateObject;


var UPDATE_GDPR_DATA = (0,lib/* gql */.Ps)(updateGdprData_templateObject || (updateGdprData_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation UpdateGdprData($data: UpdateGdprDataInput!) {\n    updateGdprData(data: $data) {\n      id\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/gdpr-request/EmailGdpr.tsx




function EmailGdpr(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange;

  var _useEmailValidation = (0,useEmailValidation/* useEmailValidation */.$)(value),
      _useEmailValidation2 = (0,slicedToArray/* default */.Z)(_useEmailValidation, 3),
      emailRef = _useEmailValidation2[0],
      isEmailValid = _useEmailValidation2[1],
      errorMessage = _useEmailValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmaiInput_EmailInput, {
    label: "Netfang ums\xE6kjanda",
    isValid: isEmailValid,
    variant: "noBorder",
    labelVariant: "aboveInput",
    ref: emailRef,
    errorMessage: errorMessage,
    value: value,
    onChange: function onChange(e) {
      var value = e.currentTarget.value;

      _onChange(value);
    }
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gdpr-request/TextGdpr.tsx




function TextGdpr(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      type = _ref.type;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(value, [{
    validation: function validation(value) {
      return value != undefined && value.length > 0;
    },
    message: 'Lýsingu vantar'
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 3),
      textRef = _useInputValidation2[0],
      isTextValid = _useInputValidation2[1],
      errorMessage = _useInputValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput, {
    inputRef: textRef,
    isValid: isTextValid,
    errorMessage: errorMessage,
    label: type === 'Deletion' ? "Hva\xF0a pers\xF3nuuppl\xFDsingar \xF3skar \xFE\xFA eftir a\xF0 ver\xF0i eytt?" : type === 'Correction' ? "Hva\xF0a pers\xF3nuuppl\xFDsingar \xF3skar \xFE\xFA eftir a\xF0 ver\xF0i lei\xF0r\xE9tt?" : "Hva\xF0a pers\xF3nuuppl\xFDsingar \xF3skar \xFE\xFA eftir a\xF0 ver\xF0i takmarka\xF0ar?",
    setHeight: "236px",
    value: value,
    onChange: function onChange(e) {
      var value = e.currentTarget.value;

      _onChange(value);
    }
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gdpr-request/UpdateGdprData.tsx



function UpdateGdprData_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var UpdateGdprData_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ekv7i3q4"
} : 0)( true ? "" : 0);

var UpdateGdprData_FormSpacer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ekv7i3q3"
} : 0)("height:1px;background:", function (props) {
  return (0,polished_esm/* rgba */.m4)(props.theme.colors.primary, 0.1);
}, ";", function (props) {
  return props.smallTop ? 'margin-top: 20px;' : 'margin-top: 40px;';
}, ";margin-bottom:57px;" + ( true ? "" : 0));

var UpdateGdprData_BigButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "ekv7i3q2"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var UpdateGdprData_NoPaddingSegment = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Segment/* Segment */.X,  true ? {
  target: "ekv7i3q1"
} : 0)("&:last-of-type{padding-bottom:57px;}background-color:", function (props) {
  return props.theme.shades.primary2;
}, ";margin-left:-44px;margin-right:-44px;@media ", devices/* device.tablet */.U.tablet, "{margin-left:initial;margin-right:initial;}" + ( true ? "" : 0));

var RowPadding = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "ekv7i3q0"
} : 0)( true ? {
  name: "1azpx8r",
  styles: "margin-bottom:20px"
} : 0);

function UpdateGdprData(_ref) {
  var type = _ref.type,
      login_title = _ref.login_title,
      login_description = _ref.login_description,
      login_image = _ref.login_image,
      title = _ref.title,
      descriptionText = _ref.descriptionText;

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useState = (0,react.useState)(false),
      finished = _useState[0],
      setFinished = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = (0,react.useState)(undefined),
      description = _useState3[0],
      setDescription = _useState3[1];

  var _useLogin = useLogin(),
      _useLogin2 = (0,slicedToArray/* default */.Z)(_useLogin, 2),
      login = _useLogin2[0],
      _useLogin2$ = _useLogin2[1],
      data = _useLogin2$.data,
      loading = _useLogin2$.loading,
      isLoggedIn = _useLogin2$.isLoggedIn,
      error = _useLogin2$.error;

  var _useMutation = (0,useMutation/* useMutation */.D)(UPDATE_GDPR_DATA, {
    client: client,
    context: {
      headers: {
        authorization: data !== null && data !== void 0 && data.token ? "Bearer ".concat(data.token) : ''
      }
    },
    onCompleted: function onCompleted() {
      return setFinished(true);
    }
  }),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 1),
      update = _useMutation2[0];

  (0,react.useEffect)(function () {
    var _data$user;

    if (data !== null && data !== void 0 && (_data$user = data.user) !== null && _data$user !== void 0 && _data$user.email) {
      setEmail(data.user.email);
    }
  }, [data === null || data === void 0 ? void 0 : data.user]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UpdateGdprData_Host, {
    children: [!finished && !isLoggedIn && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneAuthentication, {
      title: login_title,
      description: login_description,
      image: login_image,
      login: login,
      loading: loading,
      error: error
    }), !finished && isLoggedIn && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpdateGdprData_NoPaddingSegment, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form/* Form */.l, {
        onSubmit: function onSubmit() {
          update({
            variables: {
              data: {
                type: type,
                description: description,
                email: email
              }
            }
          });
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RowPadding, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 5 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormTitle/* FormTitle */.v, {
              text: title
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              offset: 1 / 12,
              width: 6 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormDescription, {
              children: descriptionText
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailGdpr, {
              onChange: setEmail,
              value: email
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              width: 6 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextGdpr, {
              value: description,
              onChange: setDescription,
              type: type
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpdateGdprData_FormSpacer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            lg: {
              offset: 6 / 12,
              width: 6 / 12
            },
            md: {
              width: 12 / 12
            },
            sm: {
              width: 12 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpdateGdprData_BigButton, {
              bg: theme/* theme.colors.primary */.r.colors.primary,
              title: "Senda bei\xF0ni",
              type: "submit"
            })
          })
        })]
      })
    }), finished && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprSuccess, {})]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/GdprRequestContainer.tsx









var typeToGdprUpdateType = function typeToGdprUpdateType(type) {
  switch (type) {
    case 'Leiðrétting':
      return globalTypes/* GdprUpdateType.Correction */.ab.Correction;

    case 'Eyðing':
      return globalTypes/* GdprUpdateType.Deletion */.ab.Deletion;

    case 'Takmörkun':
      return globalTypes/* GdprUpdateType.Limitation */.ab.Limitation;

    default:
      return undefined;
  }
};

var GdprRequestContainer = function GdprRequestContainer(_ref) {
  var _Prismic$text, _Prismic$text2, _Prismic$text3, _Prismic$text4, _typeToGdprUpdateType, _Prismic$text5, _Prismic$text6, _Prismic$text7, _Prismic$text8;

  var type = _ref.type,
      text = _ref.text,
      header = _ref.header,
      login_title = _ref.login_title,
      login_description = _ref.login_description,
      login_image = _ref.login_image;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Segment/* Segment */.X, {
    children: [type === 'Aðgangur' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequestGdprData, {
      title: (_Prismic$text = Prismic/* Prismic.text */.X5.text(header)) !== null && _Prismic$text !== void 0 ? _Prismic$text : '',
      description: (_Prismic$text2 = Prismic/* Prismic.text */.X5.text(text)) !== null && _Prismic$text2 !== void 0 ? _Prismic$text2 : '',
      login_title: (_Prismic$text3 = Prismic/* Prismic.text */.X5.text(login_title)) !== null && _Prismic$text3 !== void 0 ? _Prismic$text3 : '',
      login_description: (_Prismic$text4 = Prismic/* Prismic.text */.X5.text(login_description)) !== null && _Prismic$text4 !== void 0 ? _Prismic$text4 : '',
      login_image: login_image
    }), typeToGdprUpdateType(type) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpdateGdprData, {
      type: (_typeToGdprUpdateType = typeToGdprUpdateType(type)) !== null && _typeToGdprUpdateType !== void 0 ? _typeToGdprUpdateType : globalTypes/* GdprUpdateType.Correction */.ab.Correction,
      title: (_Prismic$text5 = Prismic/* Prismic.text */.X5.text(header)) !== null && _Prismic$text5 !== void 0 ? _Prismic$text5 : '',
      descriptionText: (_Prismic$text6 = Prismic/* Prismic.text */.X5.text(text)) !== null && _Prismic$text6 !== void 0 ? _Prismic$text6 : '',
      login_title: (_Prismic$text7 = Prismic/* Prismic.text */.X5.text(login_title)) !== null && _Prismic$text7 !== void 0 ? _Prismic$text7 : '',
      login_description: (_Prismic$text8 = Prismic/* Prismic.text */.X5.text(login_description)) !== null && _Prismic$text8 !== void 0 ? _Prismic$text8 : '',
      login_image: login_image
    })]
  });
};
// EXTERNAL MODULE: ../../packages/prismic/src/htmlSerializer.tsx
var htmlSerializer = __webpack_require__(41246);
// EXTERNAL MODULE: ../../packages/ui/src/components/icons/index.tsx + 35 modules
var icons = __webpack_require__(5103);
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/PointCard.tsx



var PointCard_excluded = ["copy", "numberText", "prefix", "suffix", "isSplitterLong", "cols", "pointColor", "pointsType", "isBottomAligned", "action", "isDisabled", "isBodySize", "isNumberTextLarge", "isNumberRightAligned", "pointLink"];

function PointCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PointCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PointCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PointCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function PointCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var PointsType;

(function (PointsType) {
  PointsType["EMPTY"] = "Empty";
  PointsType["NUMBERS"] = "Numbers";
  PointsType["TEXT"] = "Text";
  PointsType["ICON"] = "Icon";
})(PointsType || (PointsType = {}));

var PointColor;

(function (PointColor) {
  PointColor["AUTO"] = "Auto";
  PointColor["BLUE"] = "Blue";
  PointColor["LIGHTBLUE"] = "LightBlue";
  PointColor["CYAN"] = "Cyan";
  PointColor["ORANGE"] = "Orange";
})(PointColor || (PointColor = {}));

var autoColor = function autoColor(props) {
  var colors = [props.theme.colors.primary, props.theme.shades.secondary4, props.theme.shades.primary3, props.theme.shades.ternary4, props.theme.shades.secondary3, props.theme.shades.primary2];
  var styles = {};

  for (var index = 0; index < colors.length; index++) {
    styles["&:nth-of-type(".concat(index + 1, ")")] = {
      color: colors[index]
    };
  }

  return styles;
};

var Col = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e1twuexd12"
} : 0)("display:flex;flex-flow:column nowrap;color:", function (props) {
  switch (props.pointColor) {
    case PointColor.AUTO:
      return autoColor;

    case PointColor.BLUE:
      return props.theme.shades.primary3;

    case PointColor.LIGHTBLUE:
      return props.theme.shades.primary2;

    case PointColor.CYAN:
      return props.theme.shades.ternary5;

    case PointColor.ORANGE:
      return props.theme.colors.secondary;
  }

  return props.theme.colors.foreground;
}, ";" + ( true ? "" : 0));

var PointCard_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd11"
} : 0)("display:flex;flex-flow:column nowrap;flex:1;width:100%;", function (props) {
  return props.isDisabled && 'opacity: 0.1;';
}, "@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:4em;}" + ( true ? "" : 0));

var IconWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd10"
} : 0)( true ? {
  name: "alvt80",
  styles: "min-height:55px;width:48px;margin-left:21px;g,path{stroke:currentColor;}"
} : 0);

var PointCard_Number = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd9"
} : 0)(typography/* typography.numbersMedium */.cp.numbersMedium, " color:currentColor;" + ( true ? "" : 0));

var MobileTopContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd8"
} : 0)("display:flex;flex-direction:column;align-items:flex-start;margin-bottom:25px;@media ", devices/* device.tablet */.U.tablet, "{flex-direction:row;align-items:center;margin-bottom:0;&>*+*{margin-left:34px;}}" + ( true ? "" : 0));

var PointCard_Label = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd7"
} : 0)("font-weight:bold;color:", function (props) {
  return props.theme.colors.foreground;
}, ";" + ( true ? "" : 0));

var PointCard_Divider = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd6"
} : 0)("width:", function (props) {
  return props.isLong ? '100%' : '77px';
}, ";height:4px;background-color:currentColor;margin:", function (props) {
  return props.noMarginTop ? '0 0 19px' : '19px 0';
}, ";" + ( true ? "" : 0));

var PointCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd5"
} : 0)("color:", function (props) {
  return props.theme.colors.foreground;
}, ";max-width:500px;padding-right:70px;margin-bottom:44px;&:last-child{margin-bottom:0;}p{margin:16px 0;", function (props) {
  return props.isDisabled && 'padding: 0 !important;';
}, ";", function (props) {
  return props.isDisabled && "background-color: ".concat(theme/* theme.shades.primary2 */.r.shades.primary2);
}, ";}p:first-child{margin:16px 0;padding:0;", function (props) {
  return props.isDisabled && 'max-width: 70%;';
}, ";}div{p{margin:16px 0;padding:0;}a{text-decoration:none;&:hover{text-decoration:underline;}}}@media ", devices/* device.tablet */.U.tablet, "{padding-right:0;}@media ", devices/* device.desktop */.U.desktop, "{", function (props) {
  if (!props.isBottomAligned) return 'padding-right: 15px';

  switch (props.cols) {
    case 6:
      return "\n            padding-right: 140px;\n            ".concat(!props.isBodySize && 'font-size: 24px;', "\n            ").concat(typography/* typography.p2 */.cp.p2(props), "\n          ");

    case 4:
      return "\n            padding-right: 70px;\n            ".concat(!props.isBodySize && 'font-size: 24px;', "\n            ").concat(typography/* typography.p2 */.cp.p2(props), "\n          ");

    case 3:
      return "\n            padding-right: 50px;\n          ";

    case 2.4:
      return "\n            padding-right: 30px;\n          ";

    case 2:
      return "\n            padding-right: 0px;\n            font-size: 14px;\n            ".concat(typography/* typography.bodySmall */.cp.bodySmall(props), "\n        ");
  }

  return '';
}, ";}" + ( true ? "" : 0));

var NumbersWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd4"
} : 0)("display:flex;flex-flow:row wrap;align-items:baseline;@media ", devices/* device.tablet */.U.tablet, "{justify-content:", function (props) {
  return props.isRightAligned ? 'flex-end' : 'flex-start';
}, ";}" + ( true ? "" : 0));

var Prefix = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd3"
} : 0)(typography/* typography.bodyEditorial */.cp.bodyEditorial, " padding-right:7px;" + ( true ? "" : 0));

var LargeNumber = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd2"
} : 0)(function (props) {
  return props.isLarge ? typography/* typography.numbersBig */.cp.numbersBig(props) : typography/* typography.numbersBiggest */.cp.numbersBiggest(props);
}, " font-weight:", function (props) {
  return props.isLarge && '500';
}, ";@media ", devices/* device.desktop */.U.desktop, "{", function (props) {
  switch (props.cols) {
    case 6:
    case 4:
      return "\n            ".concat(typography/* typography.numbersBig */.cp.numbersBig(props), "\n          ");

    case 3:
      return "\n            font-size: 40px;\n          ";

    case 2.4:
      return "\n          font-size: 30px;\n          ";

    case 2:
      return "\n            font-size: 30px;\n        ";
  }

  return '';
}, ";}" + ( true ? "" : 0));

var PointCard_Suffix = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd1"
} : 0)(typography/* typography.bodyEditorial */.cp.bodyEditorial, " padding-left:7px;" + ( true ? "" : 0));

var PointCard_Action = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1twuexd0"
} : 0)( true ? {
  name: "fyn8ip",
  styles: "margin-top:44px;margin-top:auto"
} : 0);

var PointCard_Top = function Top(props) {
  var icon = props.icon,
      label = props.label,
      number = props.number,
      pointsType = props.pointsType;

  switch (pointsType) {
    case PointsType.ICON:
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrap, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons/* Icon */.JO, {
          name: icon !== null && icon !== void 0 ? icon : ''
        })
      });

    case PointsType.NUMBERS:
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Number, {
        children: number
      });

    case PointsType.TEXT:
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Label, {
        children: label
      });
  }

  return null;
};

var PointCard = function PointCard(props) {
  var copy = props.copy,
      numberText = props.numberText,
      prefix = props.prefix,
      suffix = props.suffix,
      isSplitterLong = props.isSplitterLong,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 12 : _props$cols,
      pointColor = props.pointColor,
      pointsType = props.pointsType,
      isBottomAligned = props.isBottomAligned,
      _props$action = props.action,
      action = _props$action === void 0 ? null : _props$action,
      isDisabled = props.isDisabled,
      isBodySize = props.isBodySize,
      isNumberTextLarge = props.isNumberTextLarge,
      isNumberRightAligned = props.isNumberRightAligned,
      pointLink = props.pointLink,
      rest = (0,objectWithoutProperties/* default */.Z)(props, PointCard_excluded);

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col, PointCard_objectSpread(PointCard_objectSpread({
    md: {
      width: cols > 5 ? 6 / 12 : cols < 3 ? 4 / 12 : cols === 3 ? 6 / 12 : cols / 12
    },
    lg: {
      width: cols / 12
    },
    pointColor: pointColor
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [pointLink && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
        value: pointLink,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PointCard_Host, {
            isDisabled: isDisabled,
            "aria-hidden": !!isDisabled,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Top, PointCard_objectSpread({}, props)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Divider, {
              isLong: isSplitterLong,
              noMarginTop: pointsType === PointsType.EMPTY
            }), copy && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Copy, {
              cols: cols,
              isBottomAligned: isBottomAligned,
              isDisabled: isDisabled,
              isBodySize: isBodySize,
              children: copy
            }), numberText && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NumbersWrap, {
              isRightAligned: isNumberRightAligned,
              children: [prefix && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prefix, {
                children: prefix
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LargeNumber, {
                cols: cols,
                isLarge: isNumberTextLarge,
                children: numberText
              }), suffix && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Suffix, {
                children: suffix
              })]
            }), action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Action, {
              children: action
            })]
          })
        })
      }), !pointLink && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PointCard_Host, {
        isDisabled: isDisabled,
        "aria-hidden": !!isDisabled,
        children: [isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Divider, {
            isLong: isSplitterLong,
            noMarginTop: pointsType === PointsType.EMPTY
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileTopContainer, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Top, PointCard_objectSpread({}, props)), copy && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Copy, {
              cols: cols,
              isBottomAligned: isBottomAligned,
              isDisabled: isDisabled,
              isBodySize: isBodySize,
              children: copy
            })]
          })]
        }), !isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Top, PointCard_objectSpread({}, props)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Divider, {
            isLong: isSplitterLong,
            noMarginTop: pointsType === PointsType.EMPTY
          }), copy && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Copy, {
            cols: cols,
            isBottomAligned: isBottomAligned,
            isDisabled: isDisabled,
            isBodySize: isBodySize,
            children: copy
          })]
        }), numberText && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NumbersWrap, {
          isRightAligned: isNumberRightAligned,
          children: [prefix && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prefix, {
            children: prefix
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LargeNumber, {
            cols: cols,
            isLarge: isNumberTextLarge,
            children: numberText
          }), suffix && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Suffix, {
            children: suffix
          })]
        }), action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard_Action, {
          children: action
        })]
      })]
    })
  }));
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/HighlightNumbersContainer.tsx


var HighlightNumbersContainer_excluded = ["title", "copy", "number", "suffix", "prefix", "cols", "pointColor", "isLarge", "isNumberRightAligned"];

function HighlightNumbersContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function HighlightNumbersContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HighlightNumbersContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HighlightNumbersContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var HighlightNumbersContainer_CardItem = function CardItem(_ref) {
  var _Prismic$text;

  var title = _ref.title,
      copy = _ref.copy,
      number = _ref.number,
      suffix = _ref.suffix,
      prefix = _ref.prefix,
      cols = _ref.cols,
      pointColor = _ref.pointColor,
      isLarge = _ref.isLarge,
      isNumberRightAligned = _ref.isNumberRightAligned,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, HighlightNumbersContainer_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard, HighlightNumbersContainer_objectSpread({
    label: (_Prismic$text = Prismic/* Prismic.text */.X5.text(title)) !== null && _Prismic$text !== void 0 ? _Prismic$text : undefined,
    copy: Prismic/* Prismic.text */.X5.text(copy),
    numberText: (0,htmlSerializer/* parseTariff */.aC)(Prismic/* Prismic.text */.X5.text(number)),
    prefix: Prismic/* Prismic.text */.X5.text(prefix),
    suffix: Prismic/* Prismic.text */.X5.text(suffix),
    isSplitterLong: true,
    cols: cols,
    pointColor: pointColor,
    pointsType: "Text",
    isBottomAligned: false,
    isNumberTextLarge: isLarge,
    isNumberRightAligned: isNumberRightAligned
  }, rest));
};

var HighlightNumbersContainer = function HighlightNumbersContainer(_ref2) {
  var size = _ref2.size,
      color = _ref2.color,
      fields = _ref2.fields;
  var pointsCount = fields === null || fields === void 0 ? void 0 : fields.length;
  var hasFirstCopy = !(0,isEmptyText/* isEmptyText */.W)(fields[0].copy);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* TrailRow */.f, {
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNumbersContainer_CardItem, HighlightNumbersContainer_objectSpread({
          cols: 12 / pointsCount,
          pointColor: color,
          isLarge: size === 'Large',
          isNumberRightAligned: hasFirstCopy
        }, item), "".concat(index, "-").concat(Prismic/* Prismic.text */.X5.text(item.copy)));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/IframeContainer.tsx




var IframeContainer = function IframeContainer(_ref) {
  var copy = _ref.copy;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
      value: copy
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/Images.tsx



var Images_excluded = ["title", "copy", "image", "video", "ar", "percentage", "isSvg"];

function Images_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Images_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Images_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Images_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Images_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var Images_ImageContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10g8d6h4"
} : 0)("position:relative;margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{margin:0;}" + ( true ? "" : 0));

var _ref =  true ? {
  name: "1po4248",
  styles: "display:grid;grid-template-columns:1fr 1fr 1fr;grid-template-rows:1fr 1fr;grid-gap:20px;>*{max-width:100%;margin:0!important;}>*:first-child{grid-row:1/3;grid-column:1/3;}>*:nth-child(2){grid-row:1/2;grid-column:3/4;}>*:nth-child(3){grid-row:2/3;grid-column:3/4;}"
} : 0;

var Images_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10g8d6h3"
} : 0)(CardGroup_Group, "{@media ", devices/* device.tablet */.U.tablet, "{", function (props) {
  return props.isFeaturedAndSquere && _ref;
}, ";}}" + ( true ? "" : 0));

var Images_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e10g8d6h2"
} : 0)(typography/* typography.h3 */.cp.h3, ";margin-bottom:3px;margin-top:24px;" + ( true ? "" : 0));

var Images_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10g8d6h1"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:24px;", function (props) {
  return props.paddingTop && 'margin-top: 24px;';
}, "@media ", devices/* device.tablet */.U.tablet, "{padding-right:28px;}" + ( true ? "" : 0));

var Images_Video = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10g8d6h0"
} : 0)( true ? {
  name: "qa9ltb",
  styles: "position:relative;width:100%;&:after{display:block;content:'';padding-top:56.25%;}>iframe{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;}"
} : 0);

var Images_Image = function Image(props) {
  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var title = props.title,
      copy = props.copy,
      image = props.image,
      video = props.video,
      ar = props.ar,
      percentage = props.percentage,
      isSvg = props.isSvg,
      rest = (0,objectWithoutProperties/* default */.Z)(props, Images_excluded);

  var html = String(video === null || video === void 0 ? void 0 : video.html).replace(/src="(.*?)"/, function (value, url) {
    return "src=\"".concat(url).concat(url.indexOf('?') === -1 ? '?' : '&', "autoplay=1&modestbranding=1&listType=user_uploads\"");
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react_spring_esm.animated.div, Images_objectSpread(Images_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Images_ImageContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
        src: image,
        ar: ar,
        isFit: !isSvg,
        isSvg: isSvg,
        percentage: percentage !== null && percentage !== void 0 ? percentage : 1
      }), video && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayButton, {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          setOpen(true);
          return false;
        }
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
        md: {
          width: 10 / 12,
          offset: {
            left: 1 / 12
          }
        },
        children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Images_Title, {
          children: title
        }), copy && title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {}), copy && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Images_Copy, {
          paddingTop: !title,
          children: copy
        })]
      })
    }), video && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal, {
      visible: open,
      onClose: function onClose() {
        return setOpen(false);
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Images_Video, {
        dangerouslySetInnerHTML: {
          __html: html
        }
      })
    })]
  }));
};
var Images = function Images(_ref2) {
  var featured = _ref2.featured,
      children = _ref2.children,
      columns = _ref2.columns,
      isFeaturedAndSquere = _ref2.isFeaturedAndSquere;

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  var count = Math.min(columns, react.Children.count(children) - Number(featured || 0));
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Images_Host, {
    featured: featured,
    isFeaturedAndSquere: isFeaturedAndSquere,
    ref: ref,
    columns: columns,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardGroup, {
      columns: count,
      isFeatured: featured,
      children: itemsWithStyleProp
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/ImagesContainer.tsx





var ImagesContainer = function ImagesContainer(_ref) {
  var aspect_ratio = _ref.aspect_ratio,
      fields = _ref.fields,
      featured = _ref.featured,
      template = _ref.template,
      columns = _ref.columns,
      _ref$issvg = _ref.issvg,
      issvg = _ref$issvg === void 0 ? false : _ref$issvg;
  var items = fields === null || fields === void 0 ? void 0 : fields.filter(function (_ref2) {
    var image = _ref2.image,
        video = _ref2.video;
    return image || video;
  });

  var _columns = columns !== null && columns !== undefined ? columns : 3;

  if (items.length === 0) {
    return null;
  }

  var isArticle = template === 'article';
  var AspectRatioMap = {
    'Ar 16:9': 'ar_16_9',
    'Ar 4:3': 'ar_4_3',
    'Ar 1:1': 'ar_1_1'
  };
  var isFeaturedAndSquere = aspect_ratio === 'Ar 1:1' && featured && items.length === 3;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Images, {
      featured: featured,
      columns: _columns,
      isFeaturedAndSquere: isFeaturedAndSquere,
      children: items.map(function (_ref3, key) {
        var image = _ref3.image,
            video = _ref3.video,
            image_title = _ref3.image_title,
            image_copy = _ref3.image_copy;
        // Make last image featured with aspect ratio 16/9
        var aspectRatio = isFeaturedAndSquere ? 'ar_1_1' : featured && key === items.length - 1 ? 'ar_16_9' : AspectRatioMap[aspect_ratio];
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Images_Image, {
          title: Prismic/* Prismic.text */.X5.text(image_title),
          copy: !(0,isEmptyText/* isEmptyText */.W)(image_copy) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
            value: image_copy
          }),
          image: image,
          video: video,
          ar: aspectRatio,
          isSvg: issvg,
          percentage: 1 / (featured ? key === items.length - 1 ? 1 : items.length - 1 : items.length > 3 ? _columns : items.length)
        }, "image-".concat(key));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/infogram/Infogram.tsx



var Infogram_excluded = ["url", "isSmaller", "background"];

function Infogram_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Infogram_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Infogram_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Infogram_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e11g4m61"
} : 0)("padding:50px 30px;margin:", function (props) {
  return props.isSmaller ? '0 -34px 20px' : '0 -20px';
}, ";background-color:", function (props) {
  return props.background === 'Grey' ? props.theme.colors.backgroundAlt : 'transparent';
}, ";", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{margin:0;margin-bottom:20px;padding:", function (props) {
  return props.isSmaller ? '30px 20px' : '50px 65px';
}, ";}@media ", devices/* device.desktop */.U.desktop, "{margin-bottom:0;padding:", function (props) {
  return props.isSmaller ? '40px 30px' : '60px 100px';
}, ";}" + ( true ? "" : 0));

var Infogram_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11g4m60"
} : 0)( true ? "" : 0);

function Infogram(_ref) {
  var url = _ref.url,
      isSmaller = _ref.isSmaller,
      background = _ref.background,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Infogram_excluded);

  (0,react.useEffect)(function () {
    var script = document.createElement('script');
    script.innerHTML = "!(function (e, i, n, s) {\n      const t = 'InfogramEmbeds',\n      d = e.getElementsByTagName('script')[0];\n      if (window[t] && window[t].initialized)\n        window[t].process && window[t].process();\n      else if (!e.getElementById(n)) {\n        const o = e.createElement('script');\n        (o.async = 1),\n          (o.id = n),\n          (o.src = 'https://e.infogram.com/js/dist/embed-loader-min.js'),\n          d.parentNode.insertBefore(o, d);\n      }\n    })(document, 0, 'infogram-async')";
    script.async = true;
    document.body.appendChild(script);
    return function () {
      document.body.removeChild(script);
    };
  }, [url]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    isSmaller: isSmaller,
    background: background,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Infogram_Host, Infogram_objectSpread({
      className: "infogram-embed",
      "data-id": url,
      "data-type": "interactive",
      "data-title": "Untitled dashboard"
    }, rest))
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/InfogramContainer.tsx






var InfogramContainer = function InfogramContainer(_ref) {
  var infogramid = _ref.infogramid,
      infogramid_2 = _ref.infogramid_2,
      infogramid_3 = _ref.infogramid_3;

  if ((0,isEmptyText/* isEmptyText */.W)(infogramid)) {
    return null;
  }

  var item2 = !(0,isEmptyText/* isEmptyText */.W)(infogramid_2) ? Prismic/* Prismic.text */.X5.text(infogramid_2) : null;
  var item3 = !(0,isEmptyText/* isEmptyText */.W)(infogramid_3) ? Prismic/* Prismic.text */.X5.text(infogramid_3) : null;
  var source = Prismic/* Prismic.text */.X5.text(infogramid);

  if (item2 && !item3) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          md: {
            width: 6 / 12
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Infogram, {
            url: source !== null && source !== void 0 ? source : undefined,
            isSmaller: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          md: {
            width: 6 / 12
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Infogram, {
            url: item2,
            isSmaller: true
          })
        })]
      })
    });
  }

  if (item2 && item3) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          md: {
            width: 6 / 12
          },
          lg: {
            width: 4 / 12
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Infogram, {
            url: source !== null && source !== void 0 ? source : undefined,
            isSmaller: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          md: {
            width: 6 / 12
          },
          lg: {
            width: 4 / 12
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Infogram, {
            url: item2,
            isSmaller: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          md: {
            width: 6 / 12
          },
          lg: {
            width: 4 / 12
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Infogram, {
            url: item3,
            isSmaller: true
          })
        })]
      })
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Infogram, {
      url: source !== null && source !== void 0 ? source : undefined,
      background: "Grey"
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/InterestCard.tsx



var InterestCard_excluded = ["title", "copy", "subTitle", "number", "color", "link", "subTitleAlign"];

function InterestCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function InterestCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InterestCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InterestCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable sonarjs/no-duplicate-string */









function InterestCard_parent() {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-flow:column nowrap;margin-bottom:4em;@media ", devices/* device.tablet */.U.tablet, "{height:100%;margin-bottom:0;}@media ", devices/* device.desktop */.U.desktop, "{padding:0 36px;}" + ( true ? "" : 0),  true ? "" : 0);
}

var InterestCard_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "eo3tj4i6"
} : 0)(InterestCard_parent, " position:relative;" + ( true ? "" : 0));

var Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.a,  true ? {
  target: "eo3tj4i5"
} : 0)(InterestCard_parent, " &:hover{h2{opacity:0.8;}}" + ( true ? "" : 0));

var InterestCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "eo3tj4i4"
} : 0)(typography/* typography.h3 */.cp.h3, " color:", function (props) {
  return props.theme.colors.foreground;
}, ";margin-bottom:calc(", 25 / typography/* sizes.h3Size */.J7.h3Size, " * 1em);" + ( true ? "" : 0));

var InterestCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eo3tj4i3"
} : 0)(typography/* typography.body */.cp.body, " color:", function (props) {
  return props.theme.colors.foreground;
}, ";@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:12px;}" + ( true ? "" : 0));

var InterestCard_Wrapper = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eo3tj4i2"
} : 0)("display:flex;justify-content:space-between;align-items:baseline;flex-direction:", function (_ref) {
  var align = _ref.align;
  return align === 'Top' ? 'column' : align === 'Bottom' ? 'column-reverse' : 'row';
}, ";padding-top:2em;@media ", devices/* device.tablet */.U.tablet, "{flex-direction:", function (_ref2) {
  var align = _ref2.align;
  return align === 'Bottom' ? 'column-reverse' : 'column';
}, ";margin-top:", function (_ref3) {
  var align = _ref3.align;
  return align === 'Left' ? 'auto' : '0';
}, ";padding-top:20px;margin-bottom:-10px;}@media ", devices/* device.desktop */.U.desktop, "{flex-direction:", function (_ref4) {
  var align = _ref4.align;
  return align === 'Top' ? 'column' : align === 'Bottom' ? 'column-reverse' : 'row';
}, ";}" + ( true ? "" : 0));

var SubTitle = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eo3tj4i1"
} : 0)("font-family:", function (props) {
  return props.theme.font.familySerifCond;
}, ";", (0,mixins/* responseFont */.cG)(18, 24), ";margin-bottom:", function (_ref5) {
  var align = _ref5.align;
  return align !== 'Top' ? '0' : '30px';
}, ";margin-top:", function (_ref6) {
  var align = _ref6.align;
  return align === 'Bottom' ? '-10px' : '0';
}, ";margin-right:15px;font-size:24px;font-weight:500;color:", function (props) {
  return props.theme.colors.foreground;
}, ";" + ( true ? "" : 0));

var InterestCard_Number = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eo3tj4i0"
} : 0)("div{", typography/* typography.numbersBiggest */.cp.numbersBiggest, " font-weight:bold;color:", function (_ref7) {
  var color = _ref7.color,
      theme = _ref7.theme;
  return color === 'Orange' ? theme.colors.secondary : theme.colors.foreground;
}, ";}" + ( true ? "" : 0));
var InterestCard = function InterestCard(_ref8) {
  var title = _ref8.title,
      copy = _ref8.copy,
      subTitle = _ref8.subTitle,
      number = _ref8.number,
      color = _ref8.color,
      link = _ref8.link,
      subTitleAlign = _ref8.subTitleAlign,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref8, InterestCard_excluded);

  var content = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InterestCard_Title, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
      margin: "15px 0 28px"
    }), !!copy && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InterestCard_Copy, {
      children: copy
    }), !!subTitle && !!number && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InterestCard_Wrapper, {
      align: subTitleAlign,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, {
        align: subTitleAlign,
        children: subTitle
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InterestCard_Number, {
        color: color,
        children: number
      })]
    })]
  });

  if (!link) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InterestCard_Host, InterestCard_objectSpread(InterestCard_objectSpread({}, rest), {}, {
      children: content
    }));
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link,
    title: title,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, InterestCard_objectSpread(InterestCard_objectSpread({}, rest), {}, {
      children: content
    }))
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/InterestCalloutContainer.tsx


function InterestCalloutContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function InterestCalloutContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InterestCalloutContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InterestCalloutContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var InterestCalloutContainer_Item = function Item(_ref, i) {
  var _Prismic$text;

  var title = _ref.title,
      copy = _ref.copy,
      sub_title = _ref.sub_title,
      number = _ref.number,
      number_color = _ref.number_color,
      link = _ref.link,
      subtitle_position = _ref.subtitle_position,
      style = _ref.style;
  var titleText = !(0,isEmptyText/* isEmptyText */.W)(title) ? Prismic/* Prismic.text */.X5.text(title) : null;
  var copyText = !(0,isEmptyText/* isEmptyText */.W)(copy) ? Prismic/* Prismic.text */.X5.text(copy) : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
    md: 4 / 12,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InterestCard, {
      title: titleText !== null && titleText !== void 0 ? titleText : undefined,
      copy: copyText !== null && copyText !== void 0 ? copyText : undefined,
      subTitle: (_Prismic$text = Prismic/* Prismic.text */.X5.text(sub_title)) !== null && _Prismic$text !== void 0 ? _Prismic$text : undefined,
      number: number ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* WrapText */.f4, {
        children: (0,htmlSerializer/* parseTariff */.aC)(Prismic/* Prismic.text */.X5.text(number))
      }) : undefined,
      color: number_color,
      link: link,
      subTitleAlign: subtitle_position,
      style: style
    }, "".concat(i, "-").concat(Prismic/* Prismic.text */.X5.text(title)))
  }, "interest-callout-".concat(i));
};

var InterestCalloutContainer = function InterestCalloutContainer(_ref2) {
  var fields = _ref2.fields;

  if ((fields === null || fields === void 0 ? void 0 : fields.length) === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    paddingTop: 110,
    paddingBottom: 100,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* TrailRow */.f, {
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InterestCalloutContainer_Item, InterestCalloutContainer_objectSpread({}, item), index);
      })
    })
  });
};
// EXTERNAL MODULE: ../../packages/slices/src/components/intro/PageIntro.tsx
var PageIntro = __webpack_require__(95848);
;// CONCATENATED MODULE: ../../packages/slices/src/containers/IntroTextContainer.tsx






var IntroTextContainer = function IntroTextContainer(_ref) {
  var _linkdata$title;

  var title = _ref.title,
      copy = _ref.copy,
      copy_size = _ref.copy_size,
      link = _ref.link,
      link_text = _ref.link_text,
      template = _ref.template;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var isArticle = template === 'article';
  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var linkText = (0,fallback/* fallbackText */.mn)(link_text, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);
  var action = link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link,
    title: linkText !== null && linkText !== void 0 ? linkText : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowButton/* ArrowButton */.b, {
      title: linkText !== null && linkText !== void 0 ? linkText : '',
      isSmall: true
    })
  }) : null;

  if (isArticle) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
      isArticle: isArticle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Intro, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
          value: copy
        })
      })
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    className: 'intro',
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageIntro/* PageIntro */.O, {
      title: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: title
      }),
      copy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy
      }),
      copySize: copy_size,
      action: action
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/jotform/JotForm.tsx


function JotForm(_ref) {
  var url = _ref.url;
  (0,react.useEffect)(function () {
    var _document$getElementB;

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = "https://eu.jotform.com/jsform/".concat(url, "?appendTo=jotform");
    (_document$getElementB = document.getElementById('jotform')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.appendChild(script);
  }, [url]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    id: "jotform"
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/JotFormContainer.tsx







var BlueSegment = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Segment/* Segment */.X,  true ? {
  target: "e12cjlch0"
} : 0)("&>div{padding-left:10px;padding-right:10px;}background:", function (props) {
  return props.theme.shades.primary2;
}, ";@media ", devices/* device.tablet */.U.tablet, "{&>div{padding-left:44px;padding-right:44px;}background:none;}iframe{min-height:400px;}" + ( true ? "" : 0));

var JotFormContainer = function JotFormContainer(_ref) {
  var _Prismic$text;

  var url = _ref.url;

  if ((0,isEmptyText/* isEmptyText */.W)(url)) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlueSegment, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JotForm, {
      url: (_Prismic$text = Prismic/* Prismic.text */.X5.text(url)) !== null && _Prismic$text !== void 0 ? _Prismic$text : ''
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/kaupholl-news/KauphollNews.tsx



function KauphollNews_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var KauphollNews_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18yg0no1"
} : 0)( true ? {
  name: "lg4l91",
  styles: "&>section>div{margin:0;padding:0;}"
} : 0);

var KauphollNews_Div = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18yg0no0"
} : 0)( true ? {
  name: "1tyyxc3",
  styles: "padding-left:20px"
} : 0);

function KauphollNews(_ref) {
  var count = _ref.count;

  var _React$useState = react.useState([]),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      items = _React$useState2[0],
      setItems = _React$useState2[1];

  (0,react.useEffect)(function () {
    fetch("/api/kaupholl?count=".concat(count)).then(function (response) {
      return response.json();
    }).then(function (data) {
      return setItems(data);
    });
  }, []);

  if (!(items !== null && items !== void 0 && items.length)) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KauphollNews_Host, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionList, {
      firstOpen: false,
      singleDisplay: false,
      children: items.map(RenderFaqItem)
    })
  });
}

var RenderFaqItem = function RenderFaqItem(_ref2, i) {
  var _Prismic$text;

  var content = _ref2.content,
      title = _ref2.title,
      exchange_id = _ref2.exchange_id,
      date = _ref2.date;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
    title: "".concat((_Prismic$text = Prismic/* Prismic.text */.X5.text(title)) === null || _Prismic$text === void 0 ? void 0 : _Prismic$text.replace('Landsbankinn hf.: ', '')),
    content: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(KauphollNews_Div, {
        children: [(0,src/* formatDateShort */.mn)('is', new Date(date)), " "]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KauphollNews_Div, {
        children: Prismic/* Prismic.text */.X5.text(content)
      })]
    })
  }, "".concat(i, "-").concat(exchange_id));
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/KauphollNewsContainer.tsx


function KauphollNewsContainer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var KauphollNewsContainer_P = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e8nfd531"
} : 0)( true ? {
  name: "1y683pt",
  styles: "margin-top:72px!important"
} : 0);

var KauphollNewsContainer_H2 = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e8nfd530"
} : 0)( true ? {
  name: "19ojmcp",
  styles: "margin-top:72px"
} : 0);

function KauphollNewsContainer(_ref) {
  var title = _ref.title,
      description = _ref.description,
      count = _ref.count;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Segment/* Segment */.X, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageIntro/* PageIntro */.O, {
      title: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* WrapText */.f4, {
        isArticle: false,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KauphollNewsContainer_H2, {
          children: Prismic/* Prismic.text */.X5.text(title)
        })
      }),
      copySize: true,
      copy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* WrapText */.f4, {
        isArticle: false,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KauphollNewsContainer_P, {
          children: Prismic/* Prismic.text */.X5.text(description)
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KauphollNews, {
      count: count
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/fetchEmailLists.ts


var fetchEmailLists_templateObject;


var getMailLists = (0,lib/* gql */.Ps)(fetchEmailLists_templateObject || (fetchEmailLists_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query getMailLists {\n    getEmailLists {\n      fields {\n        key\n        value\n      }\n      mailingLists {\n        key\n        value\n      }\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/MailingList/subscribe.ts


var subscribe_templateObject;


var subscribeToEmailList = (0,lib/* gql */.Ps)(subscribe_templateObject || (subscribe_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation subscribeToEmailList($data: SubscribeToEmailListInput!) {\n    subscribeToEmailList(data: $data) {\n      worked\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/mailing-list/MailingList.tsx




function MailingList_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var MailingList_Heading = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "eof53c613"
} : 0)(typography/* typography.h2Big */.cp.h2Big, " margin-bottom:20px;" + ( true ? "" : 0));

var FormInputContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eof53c612"
} : 0)( true ? {
  name: "g46w8s",
  styles: "margin-bottom:30px"
} : 0);

var FormCheckbox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Checkbox/* Checkbox */.XZ,  true ? {
  target: "eof53c611"
} : 0)("margin-bottom:15px;label{color:rgb(30, 61, 90);", typography/* typography.h4 */.cp.h4, " padding-left:50px;height:auto;background:transparent;}label:before{border:1px solid rgb(30, 60, 90);}" + ( true ? "" : 0));

var CategoryHeader = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eof53c610"
} : 0)("color:rgb(30, 61, 90);", typography/* typography.h3 */.cp.h3, " font-weight:500;padding-bottom:25px;width:33.3333%;border-bottom:4px solid ", function (props) {
  return props.index === 0 ? "rgb(32, 68, 106)" : props.index === 1 ? "rgb(255, 175, 112)" : "rgb(114, 220, 235)";
}, ";margin-right:10px;" + ( true ? "" : 0));

var CategoryContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eof53c69"
} : 0)( true ? {
  name: "3aj916",
  styles: "margin-bottom:74px;display:flex"
} : 0);

var CategoryNoText = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eof53c68"
} : 0)( true ? {
  name: "zpzipq",
  styles: "border-bottom:4px solid rgb(232, 235, 238);width:100%"
} : 0);

var ItemText = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eof53c67"
} : 0)( true ? {
  name: "102r3wo",
  styles: "color:rgb(22, 62, 99);margin-left:52px;margin-bottom:72px"
} : 0);

var BackgroundBox = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eof53c66"
} : 0)("background:rgb(244, 247, 247);padding:44px 0px;@media ", devices/* device.tablet */.U.tablet, "{padding:72px 100px;}@media ", devices/* device.desktop */.U.desktop, "{padding:72px 100px;}" + ( true ? "" : 0));

var MailingList_P = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "eof53c65"
} : 0)(typography/* typography.p2 */.cp.p2, " margin-bottom:30px;@media ", devices/* device.desktop */.U.desktop, "{}" + ( true ? "" : 0));

var FormRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "eof53c64"
} : 0)("border-top:4px solid rgba(30, 61, 90, 0.1);padding-top:72px;>div{padding:0;}>div:last-child{margin-top:30px;}@media ", devices/* device.desktop */.U.desktop, "{>div:first-child{padding-left:0px;}>div:last-child{margin-top:0;padding-right:0px;}}" + ( true ? "" : 0));

var FormHeader = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eof53c63"
} : 0)("color:rgb(22, 62, 99);", typography/* typography.h2 */.cp.h2, " line-height:56px;margin-bottom:40px;" + ( true ? "" : 0));

var FormText = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eof53c62"
} : 0)( true ? "" : 0);

var FormButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "eof53c61"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var A = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "eof53c60"
} : 0)( true ? {
  name: "1wbll7q",
  styles: "text-decoration:underline"
} : 0);

var MailingList_FormContainer = function FormContainer(_ref) {
  var children = _ref.children;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  if (isMobile) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackgroundBox, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
        children: children
      })
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackgroundBox, {
      children: children
    })
  });
};

function MailingList(_ref2) {
  var categories = _ref2.categories,
      lists = _ref2.lists;

  var _useState = (0,react.useState)(false),
      submitted = _useState[0],
      setSubmitted = _useState[1];

  var _useState2 = (0,react.useState)(''),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      name = _useState3[0],
      setName = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      checked = _useState4[0],
      setChecked = _useState4[1];

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useState5 = (0,react.useState)([]),
      fields = _useState5[0],
      setFields = _useState5[1];

  var _useMutation = (0,useMutation/* useMutation */.D)(subscribeToEmailList, {
    client: client,
    variables: {
      data: {
        fields: fields,
        mailinglists: checked,
        email: email
      }
    },
    onCompleted: function onCompleted(data) {
      setSubmitted(data.subscribeToEmailList.worked);
    }
  }),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 1),
      onFormSubmit = _useMutation2[0];

  var _useQuery = (0,useQuery/* useQuery */.a)(getMailLists, {
    client: client,
    onCompleted: function onCompleted(data) {
      setFields(data === null || data === void 0 ? void 0 : data.getEmailLists.fields.map(function (x) {
        return {
          key: x.key,
          value: x.value
        };
      }));
    }
  }),
      data = _useQuery.data,
      loading = _useQuery.loading;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          sm: {
            width: 12 / 12
          },
          md: {
            width: 6 / 12
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MailingList_Heading, {
            children: "P\xF3stlistar"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          sm: {
            width: 12 / 12
          },
          md: {
            width: 6 / 12
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MailingList_P, {
            children: "F\xE1\xF0u reglulegar tilkynningar um n\xFDtt \xFAtg\xE1fuefni Landsbankans me\xF0 \xFEv\xED a\xF0 skr\xE1 \xFEig \xE1 einn e\xF0a fleiri \xFEeirra p\xF3stlista sem finna m\xE1 \xE1 \xFEessari s\xED\xF0u."
          })
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MailingList_FormContainer, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          onFormSubmit();
        },
        children: [loading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
          children: "Hle\xF0 inn p\xF3stlistum..."
        }), !loading && categories.split(',').map(function (category, index) {
          return lists.filter(function (x) {
            return x.category === category;
          }).sort(function (y) {
            return y.order;
          }).map(function (listItem) {
            var _data$getEmailLists$m;

            var key = data === null || data === void 0 ? void 0 : (_data$getEmailLists$m = data.getEmailLists.mailingLists.find(function (x) {
              return x.value === listItem.title;
            })) === null || _data$getEmailLists$m === void 0 ? void 0 : _data$getEmailLists$m.key;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [listItem.order === 1 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CategoryContainer, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryHeader, {
                  index: index,
                  children: listItem.category
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategoryNoText, {})]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormCheckbox, {
                  checked: checked.includes(key),
                  label: listItem.title,
                  id: listItem.title,
                  onChange: function onChange(value) {
                    if (value) {
                      setChecked(function (c) {
                        return [].concat((0,toConsumableArray/* default */.Z)(c), [key]);
                      });
                    } else {
                      setChecked(function (c) {
                        return (0,toConsumableArray/* default */.Z)(c.filter(function (b) {
                          return b !== key;
                        }));
                      });
                    }
                  },
                  variant: "noBorder"
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemText, {
                  children: listItem.text
                })]
              })]
            }, listItem.title);
          });
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormRow, {
          children: [submitted && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            sm: 12 / 12,
            lg: 7 / 12,
            width: 7 / 12,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormHeader, {
              children: "Takk fyrir skr\xE1ninguna!"
            })
          }), !submitted && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
            sm: 12 / 12,
            lg: 6 / 12,
            width: 6 / 12,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormHeader, {
              children: "Skr\xE1\xF0u \xFEig \xE1 p\xF3stlista"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormText, {
              children: ["Me\xF0 \xFEv\xED a\xF0 skr\xE1 mig \xE1 p\xF3stlista sam\xFEykki \xE9g", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A, {
                href: "/bankinn/um-bankann/personuvernd",
                children: "pers\xF3nuverndarstefnu"
              }), ' ', "bankans."]
            })]
          }), !submitted && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
            sm: 12 / 12,
            lg: 6 / 12,
            width: 6 / 12,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInputContainer, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
                label: "Nafn",
                value: name,
                onChange: function onChange(e) {
                  return setName(e.currentTarget.value);
                },
                labelVariant: "aboveInput"
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormInputContainer, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmaiInput_EmailInput, {
                label: "Netfang",
                value: email,
                onChange: function onChange(e) {
                  return setEmail(e.currentTarget.value);
                },
                labelVariant: "aboveInput"
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormButton, {
              bg: theme/* theme.colors.primary */.r.colors.primary,
              type: "submit",
              title: "Skr\xE1 mig"
            })]
          })]
        })]
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/MailingListContainer.tsx




var MailingListContainer = function MailingListContainer(_ref) {
  var _Prismic$text;

  var mailing_list_categories = _ref.mailing_list_categories,
      fields = _ref.fields;
  var stringedLists = fields === null || fields === void 0 ? void 0 : fields.map(function (item) {
    return {
      category: Prismic/* Prismic.text */.X5.text(item.mailing_list_category),
      title: Prismic/* Prismic.text */.X5.text(item.mailing_list_title),
      text: Prismic/* Prismic.text */.X5.text(item.mailing_list_text),
      order: item.mailing_list_order
    };
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MailingList, {
    categories: (_Prismic$text = Prismic/* Prismic.text */.X5.text(mailing_list_categories)) !== null && _Prismic$text !== void 0 ? _Prismic$text : '',
    lists: stringedLists
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/fetchBonds.ts


var fetchBonds_templateObject;


var FETCH_BONDS = (0,lib/* gql */.Ps)(fetchBonds_templateObject || (fetchBonds_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query fetchBonds($order: BondOrder, $first: Int, $filter: [String!]) {\n    bonds(order: $order, first: $first, filter: $filter) {\n      bondMarketStatus\n      nodes {\n        id\n        symbol\n        exchangeSymbol\n        bid\n        bidYield\n        ask\n        askYield\n        last\n        lastTradeDate\n        lastYield\n        lastDuration\n        updatedUtc\n        intradayAccumulatedTurnover\n        intradayHighPrice\n        intradayNumberOfTrades\n        intradayPerChange\n        intradayNetChange\n        details {\n          isLinkedToIcelandicCPI\n        }\n      }\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/bonds/Bonds.res.ts
/* harmony default export */ var Bonds_res = ({
  bonds: {
    is: 'Skuldabréf',
    en: 'Bonds'
  },
  marketToday: {
    is: 'Markaðurinn í dag',
    en: 'Market today'
  },
  trades: {
    is: 'Viðskipti dagsins',
    en: 'Today’s trades'
  },
  nasdaq: {
    is: 'Kauphöll Íslands',
    en: 'Nasdaq OMX Iceland'
  },
  disclaimer: {
    is: 'Kauphöll Íslands | Upplýsingar eru a.m.k. 15 mínútna gamlar',
    en: 'Nasdaq OMX Iceland | Data delayed by 15 min.'
  },
  indexed: {
    is: 'Verðtryggt',
    en: 'Indexed'
  },
  nonIndexed: {
    is: 'Óverðtryggt',
    en: 'Non-indexed'
  },
  yield: {
    is: 'Ávöxtunarkrafa',
    en: 'Last yield'
  },
  bidYield: {
    is: 'Kaupkrafa',
    en: 'Bid yield'
  },
  askYield: {
    is: 'Sölukrafa',
    en: 'Ask yield'
  },
  price: {
    is: 'Verð',
    en: 'Price'
  },
  bidPrice: {
    is: 'Kaupverð',
    en: 'Bid price'
  },
  askPrice: {
    is: 'Söluverð',
    en: 'Ask price'
  },
  highestPrice: {
    is: 'Hæsta verð',
    en: 'Highest price'
  },
  lowestPrice: {
    is: 'Lægsta verð',
    en: 'Lowest price'
  },
  numberOfTrades: {
    is: 'Fjöldi',
    en: 'No.'
  },
  nominalValue: {
    is: 'Nafnverð',
    en: 'Nominal value'
  },
  turnover: {
    is: 'Velta (þús. ISK)',
    en: 'Turnover (ISK thousand)'
  },
  priceChange: {
    is: 'Verðbreyting',
    en: 'Price change'
  },
  duration: {
    is: 'Líftími',
    en: 'Modified duration, years'
  },
  bond: {
    is: 'Bréf',
    en: 'Bond'
  },
  value: {
    is: 'Virði',
    en: 'Value'
  },
  time: {
    is: 'Tími',
    en: 'Time'
  },
  selectInformation: {
    is: 'Veldu upplýsingar',
    en: 'Select information'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/bonds/bonds-market-table/BondsMarketTable.tsx


function BondsMarketTable_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var StickyFirstTableContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MarketsComponents/* StickyFirstColumn */.yi,  true ? {
  target: "e1tdoqvl0"
} : 0)( true ? {
  name: "pafk6m",
  styles: "div:first-of-type{table{margin-bottom:60px;}}"
} : 0);

var defaultBondVariables = {
  filter: ['HFF', 'LSS0', 'LSS1', 'LSS2', 'LSS3', 'LSS4', 'LSS5', 'LSS6', 'LSS7', 'LSS8', 'LSS9', 'RIKS', 'RIKV', 'RIKB', 'LBANK CBI', 'LBANK CB '],
  first: 100
};
function BondsMarketTable(_ref) {
  var _tableData$filter, _tableData$filter2;

  var bonds = _ref.bonds,
      prefix = _ref.prefix;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useQuery = (0,useQuery/* useQuery */.a)(FETCH_BONDS, {
    client: client,
    variables: defaultBondVariables
  }),
      _useQuery$data = _useQuery.data,
      data = _useQuery$data === void 0 ? bonds : _useQuery$data;

  var columns = react.useCallback(function (title) {
    return [{
      Header: title,
      accessor: 'symbol',
      // accessor is the "key" in the data
      headerStyle: {
        flexDirection: 'row-reverse'
      },
      Cell: function Cell(_ref2) {
        var value = _ref2.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsBodyBold */.K9, {
          noWrap: true,
          children: value
        });
      }
    }, {
      Header: function Header() {
        return r(Bonds_res["yield"]);
      },
      sortType: 'basic',
      accessor: 'lastYield',
      Cell: function Cell(_ref3) {
        var value = _ref3.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.price);
      },
      accessor: 'last',
      Cell: function Cell(_ref4) {
        var value = _ref4.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.priceChange);
      },
      sortType: 'basic',
      accessor: 'intradayPerChange',
      Cell: function Cell(_ref5) {
        var value = _ref5.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
          decimalScale: 2,
          displayPosNegColor: true,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.bidYield);
      },
      sortType: 'basic',
      accessor: 'bidYield',
      Cell: function Cell(_ref6) {
        var value = _ref6.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.bidPrice);
      },
      accessor: 'bid',
      Cell: function Cell(_ref7) {
        var value = _ref7.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.askPrice);
      },
      accessor: 'ask',
      Cell: function Cell(_ref8) {
        var value = _ref8.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.askYield);
      },
      sortType: 'basic',
      accessor: 'askYield',
      Cell: function Cell(_ref9) {
        var value = _ref9.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.numberOfTrades);
      },
      accessor: 'intradayNumberOfTrades',
      Cell: function Cell(_ref10) {
        var value = _ref10.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 0,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.turnover);
      },
      accessor: 'intradayAccumulatedTurnover',
      Cell: function Cell(_ref11) {
        var value = _ref11.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 0,
          number: value / 1000
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.duration);
      },
      accessor: 'lastDuration',
      Cell: function Cell(_ref12) {
        var value = _ref12.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 2,
          number: value
        });
      }
    }];
  }, []);
  var tableData = react.useMemo(function () {
    return data === null || data === void 0 ? void 0 : data.bonds.nodes.filter(function (s) {
      return s.lastDuration && s.lastDuration > 0;
    });
  }, [data]);

  if (!data) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StickyFirstTableContainer, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataTable, {
      "aria-label": r(Bonds_res.indexed),
      data: (_tableData$filter = tableData === null || tableData === void 0 ? void 0 : tableData.filter(function (bond) {
        var _bond$details;

        return bond.lastDuration && bond.lastDuration > 0 && ((_bond$details = bond.details) === null || _bond$details === void 0 ? void 0 : _bond$details.isLinkedToIcelandicCPI) === true;
      })) !== null && _tableData$filter !== void 0 ? _tableData$filter : [],
      columns: columns(r(Bonds_res.indexed)),
      colorTheme: "primary",
      rowLink: function rowLink(_ref13) {
        var bond = _ref13.original;
        return {
          href: "".concat(prefix, "/[symbol]"),
          as: "".concat(prefix, "/").concat(bond.symbol.split(' ').join('_').toLowerCase())
        };
      },
      isClickable: true
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataTable, {
      "aria-label": r(Bonds_res.nonIndexed),
      data: (_tableData$filter2 = tableData === null || tableData === void 0 ? void 0 : tableData.filter(function (bond) {
        var _bond$details2;

        return bond.lastDuration && bond.lastDuration > 0 && ((_bond$details2 = bond.details) === null || _bond$details2 === void 0 ? void 0 : _bond$details2.isLinkedToIcelandicCPI) === false;
      })) !== null && _tableData$filter2 !== void 0 ? _tableData$filter2 : [],
      columns: columns(r(Bonds_res.nonIndexed)),
      colorTheme: "primary",
      rowLink: function rowLink(_ref14) {
        var bond = _ref14.original;
        return {
          href: "".concat(prefix, "/[symbol]"),
          as: "".concat(prefix, "/").concat(bond.symbol.split(' ').join('_').toLowerCase())
        };
      },
      isClickable: true
    })]
  });
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isToday/index.js
var isToday = __webpack_require__(82236);
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/fetchBondsIntradayHistory.ts


var fetchBondsIntradayHistory_templateObject;


var FETCH_BONDS_INTRADAY_HISTORY = (0,lib/* gql */.Ps)(fetchBondsIntradayHistory_templateObject || (fetchBondsIntradayHistory_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query fetchBondsIntradayHistory {\n    intradayHistory(filter: { type: Bonds }) {\n      id\n      symbol\n      price\n      volume\n      value\n      date\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/bonds/bonds-trades-table/BondsTradesTable.tsx












function BondsTradesTable(_ref) {
  var intraday = _ref.intraday;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useQuery = (0,useQuery/* useQuery */.a)(FETCH_BONDS_INTRADAY_HISTORY, {
    client: client,
    variables: {
      first: 100
    },
    pollInterval: 30000
  }),
      _useQuery$data = _useQuery.data,
      data = _useQuery$data === void 0 ? intraday : _useQuery$data;

  var columns = react.useMemo(function () {
    return [{
      Header: function Header() {
        return r(Bonds_res.bond);
      },
      accessor: 'symbol',
      // accessor is the "key" in the data
      headerStyle: {
        flexDirection: 'row-reverse'
      },
      Cell: function Cell(_ref2) {
        var value = _ref2.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsBodyBold */.K9, {
          children: value
        });
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.price);
      },
      accessor: 'price',
      Cell: function Cell(_ref3) {
        var value = _ref3.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsBodyBold */.K9, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
            type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
            decimalScale: 2,
            number: value
          })
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.nominalValue);
      },
      accessor: 'volume',
      Cell: function Cell(_ref4) {
        var value = _ref4.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 0,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.value);
      },
      accessor: 'value',
      Cell: function Cell(_ref5) {
        var value = _ref5.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 0,
          displayISK: true,
          number: value
        });
      },
      style: {
        textAlign: 'right',
        whiteSpace: 'nowrap'
      }
    }, {
      Header: function Header() {
        return r(Bonds_res.time);
      },
      accessor: 'date',
      Cell: function Cell(_ref6) {
        var value = _ref6.value;
        return (0,isToday/* default */.Z)(new Date(value)) ? (0,format["default"])(new Date(value), 'HH:mm') : (0,format["default"])(new Date(value), 'dd.MM.yyyy HH:mm');
      },
      style: {
        textAlign: 'right'
      }
    }];
  }, []);
  var tableData = react.useMemo(function () {
    return data === null || data === void 0 ? void 0 : data.intradayHistory;
  }, [data]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* StickyFirstColumn */.yi, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataTable, {
      "aria-label": r(Bonds_res.bonds),
      data: tableData !== null && tableData !== void 0 ? tableData : [],
      columns: columns,
      colorTheme: "primary",
      initialState: {
        sortBy: [{
          id: 'date',
          desc: true
        }]
      }
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/bonds/Bonds.tsx












function Bonds(_ref) {
  var bonds = _ref.bonds,
      intraday = _ref.intraday,
      prefix = _ref.prefix,
      disclaimerText = _ref.disclaimerText;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  var _React$useState = react.useState(BondDataType.Market),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      bondDataType = _React$useState2[0],
      setSelectedBondDataType = _React$useState2[1];

  var changeDataType = function changeDataType(BondDataType) {
    setSelectedBondDataType(BondDataType);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* ListHeaderContainer */.CU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 5 / 12
        },
        lg: {
          width: 5 / 12
        },
        children: !isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsListTitle */.hZ, {
            children: r(Bonds_res.bonds)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
            children: r(Bonds_res.disclaimer)
          })]
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsListTitleMobile */.Py, {
          children: r(Bonds_res.nasdaq)
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 8 / 12
        },
        lg: {
          width: 6 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSelectorTabs */.pV, {
          mobileLabel: r(Bonds_res.selectInformation),
          mobileInset: true,
          onSelectTab: function onSelectTab(val) {
            changeDataType(Number(val));
          },
          tabSpacing: "40px",
          selectedItemId: bondDataType.toString(),
          items: [{
            id: BondDataType.Market.toString(),
            label: r(Bonds_res.marketToday)
          }, {
            id: BondDataType.Trades.toString(),
            label: r(Bonds_res.trades)
          }],
          color: theme/* theme.shades.primary3 */.r.shades.primary3
        })
      })]
    }), bondDataType === BondDataType.Market && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BondsMarketTable, {
      bonds: bonds,
      prefix: prefix
    }), bondDataType === BondDataType.Trades && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BondsTradesTable, {
      intraday: intraday
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsDisclaimer, {
      text: disclaimerText
    })]
  });
}
var BondDataType;

(function (BondDataType) {
  BondDataType[BondDataType["Market"] = 0] = "Market";
  BondDataType[BondDataType["Trades"] = 1] = "Trades";
})(BondDataType || (BondDataType = {}));
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/fetchStocks.ts


var fetchStocks_templateObject;


var FETCH_STOCKS = (0,lib/* gql */.Ps)(fetchStocks_templateObject || (fetchStocks_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query fetchStocks(\n    $exchange: ExchangeSymbol\n    $order: StockOrder\n    $first: Int = 10\n  ) {\n    stocks(exchange: $exchange, order: $order, first: $first) {\n      stockMarketStatus\n      nodes {\n        id\n        name\n        symbol\n        exchangeSymbol\n        bid\n        ask\n        last\n        lastPriceDifference\n        intradayHighPrice\n        intradayLowPrice\n        intradayPerChange\n        intradayAccumulatedTurnover\n        lastTradeDate\n        intradayNumberOfTrades\n      }\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/stocks/Stocks.res.ts
/* harmony default export */ var Stocks_res = ({
  stocks: {
    is: 'Hlutabréf',
    en: 'Stocks'
  },
  nasdaq: {
    is: 'Kauphöll Íslands',
    en: 'Nasdaq OMX Iceland'
  },
  disclaimer: {
    is: 'Kauphöll Íslands | Upplýsingar eru a.m.k. 15 mínútna gamlar',
    en: 'Nasdaq OMX Iceland | Data delayed by 15 min.'
  },
  marketToday: {
    is: 'Aðalmarkaður',
    en: 'Aðalmarkaður'
  },
  firstNorth: {
    is: 'First North',
    en: 'First North'
  },
  trades: {
    is: 'Viðskipti dagsins',
    en: 'Today’s trades'
  },
  company: {
    is: 'Félag',
    en: 'Company'
  },
  price: {
    is: 'Gengi',
    en: 'Price'
  },
  change: {
    is: 'Br. í dag',
    en: 'Ch. today'
  },
  bid: {
    is: 'Kaup',
    en: 'Bid'
  },
  ask: {
    is: 'Sala',
    en: 'Ask'
  },
  value: {
    is: 'Virði',
    en: 'Value'
  },
  quantity: {
    is: 'Fjöldi hluta',
    en: 'Number of shares'
  },
  turnover: {
    is: 'Velta (þús. ISK)',
    en: 'Turnover (ISK thousand)'
  },
  time: {
    is: 'Tími',
    en: 'Time'
  },
  numberOfTrades: {
    is: 'Fjöldi',
    en: 'No.'
  },
  Highest: {
    is: 'Hæsta',
    en: 'Highest'
  },
  Lowest: {
    is: 'Lægsta',
    en: 'Lowest'
  },
  buy: {
    is: 'Kaupa',
    en: 'Buy'
  },
  selectInformation: {
    is: 'Veldu upplýsingar',
    en: 'Select information'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/stocks/stocks-market-table/StocksMarketTable.tsx


function StocksMarketTable_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















var StocksMarketTable_ButtonContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2tdpfz0"
} : 0)( true ? {
  name: "skgbeu",
  styles: "display:flex;justify-content:flex-end"
} : 0);

function StocksMarketTable(_ref) {
  var stocks = _ref.stocks,
      exchange = _ref.exchange,
      stockDetailPrefix = _ref.stockDetailPrefix,
      stockBuyUrl = _ref.stockBuyUrl;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r,
      locale = _useResource.locale;

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useQuery = (0,useQuery/* useQuery */.a)(FETCH_STOCKS, {
    client: client,
    variables: {
      exchange: exchange,
      first: 100
    }
  }),
      _useQuery$data = _useQuery.data,
      data = _useQuery$data === void 0 ? stocks : _useQuery$data;

  var columns = react.useMemo(function () {
    return [{
      Header: r(Stocks_res.company),
      accessor: 'symbol',
      // accessor is the "key" in the data
      headerStyle: {
        flexDirection: 'row-reverse'
      },
      Cell: function Cell(_ref2) {
        var value = _ref2.value,
            stock = _ref2.row.original;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* TwoNumberContainer */.cC, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsBodyBold */.K9, {
              children: value
            }), !isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
              noWrap: true,
              children: stock.name
            })]
          })
        });
      }
    }, {
      Header: r(Stocks_res.price),
      accessor: 'last',
      Cell: function Cell(_ref3) {
        var value = _ref3.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberBold */.Az, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: r(Stocks_res.change),
      sortType: 'basic',
      accessor: 'intradayPerChange',
      Cell: function Cell(_ref4) {
        var value = _ref4.value,
            stock = _ref4.row.original;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* RightAlignColumnContainer */.kO, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* TwoNumberContainer */.cC, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
              type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
              decimalScale: 2,
              displayPosNegColor: true,
              hideNullIndicator: true,
              number: stock.lastPriceDifference
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberSmall */.q0, {
              type: MarketsFormatNumber/* NumberType.Percentage */.sw.Percentage,
              decimalScale: 2,
              displayPosNegColor: true,
              hideNullIndicator: true,
              number: value
            })]
          })
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: r(Stocks_res.bid),
      accessor: 'bid',
      Cell: function Cell(_ref5) {
        var value = _ref5.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: r(Stocks_res.ask),
      accessor: 'ask',
      Cell: function Cell(_ref6) {
        var value = _ref6.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: r(Stocks_res.turnover),
      accessor: 'intradayAccumulatedTurnover',
      Cell: function Cell(_ref7) {
        var value = _ref7.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 0,
          number: value / 1000
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: r(Stocks_res.numberOfTrades),
      accessor: 'intradayNumberOfTrades',
      Cell: function Cell(_ref8) {
        var value = _ref8.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 0,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: r(Stocks_res.time),
      accessor: 'lastTradeDate',
      Cell: function Cell(_ref9) {
        var value = _ref9.value;
        return value !== null && (0,isToday/* default */.Z)(new Date(value)) ? (0,format["default"])(new Date(value), 'HH:mm') : (0,src/* formatDate */.p6)(locale, new Date(value));
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: r(Stocks_res.Highest),
      accessor: 'intradayHighPrice',
      Cell: function Cell(_ref10) {
        var value = _ref10.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: r(Stocks_res.Lowest),
      accessor: 'intradayLowPrice',
      Cell: function Cell(_ref11) {
        var value = _ref11.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: '',
      accessor: 'exchangeSymbol',
      Cell: function Cell(_ref12) {
        var value = _ref12.value,
            stock = _ref12.row.original;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StocksMarketTable_ButtonContainer, {
          children: value === globalTypes/* ExchangeSymbol.XICE */.u7.XICE && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_link["default"], {
            href: stockBuyUrl(stock.symbol),
            passHref: true,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_Button/* Button */.z, {
              as: "a",
              title: r(Stocks_res.buy),
              isSmall: true,
              bg: theme/* theme.colors.primary */.r.colors.primary,
              onClick: function onClick(e) {
                return e.stopPropagation();
              }
            })
          })
        });
      }
    }];
  }, [isMobile, locale, r]);
  var tableData = react.useMemo(function () {
    return data === null || data === void 0 ? void 0 : data.stocks.nodes;
  }, [data]);

  if (!data) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* StickyFirstColumn */.yi, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataTable, {
      "aria-label": r(Stocks_res.stocks),
      data: tableData,
      columns: columns,
      colorTheme: "ternary",
      initialState: {
        sortBy: [{
          id: 'symbol',
          desc: false
        }]
      },
      rowLink: function rowLink(_ref13) {
        var stock = _ref13.original;
        return {
          href: "".concat(stockDetailPrefix, "/[symbol]"),
          as: "".concat(stockDetailPrefix, "/").concat(stock.symbol.split(' ').join('_').toLowerCase())
        };
      },
      isClickable: true
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/fetchStocksIntradayHistory.ts


var fetchStocksIntradayHistory_templateObject;


var FETCH_STOCKS_INTRADAY_HISTORY = (0,lib/* gql */.Ps)(fetchStocksIntradayHistory_templateObject || (fetchStocksIntradayHistory_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query fetchStocksIntradayHistory {\n    intradayHistory(filter: { type: Stocks }) {\n      id\n      symbol\n      price\n      volume\n      value\n      date\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/stocks/stocks-trades-table/StocksTradesTable.tsx












function StocksTradesTable(_ref) {
  var intraday = _ref.intraday,
      prefix = _ref.prefix;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r,
      locale = _useResource.locale;

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useQuery = (0,useQuery/* useQuery */.a)(FETCH_STOCKS_INTRADAY_HISTORY, {
    client: client,
    variables: {
      first: 100
    },
    pollInterval: 30000
  }),
      _useQuery$data = _useQuery.data,
      data = _useQuery$data === void 0 ? intraday : _useQuery$data;

  var columns = react.useMemo(function () {
    return [{
      Header: r(Stocks_res.company),
      accessor: 'symbol',
      // accessor is the "key" in the data
      headerStyle: {
        flexDirection: 'row-reverse'
      },
      Cell: function Cell(_ref2) {
        var value = _ref2.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsBodyBold */.K9, {
          children: value
        });
      }
    }, {
      Header: r(Stocks_res.price),
      accessor: 'price',
      Cell: function Cell(_ref3) {
        var value = _ref3.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsNumberBold */.Az, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 2,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: r(Stocks_res.quantity),
      accessor: 'volume',
      Cell: function Cell(_ref4) {
        var value = _ref4.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 0,
          number: value
        });
      },
      style: {
        textAlign: 'right'
      }
    }, {
      Header: r(Stocks_res.value),
      accessor: 'value',
      Cell: function Cell(_ref5) {
        var value = _ref5.value;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsFormatNumber/* MarketsFormatNumber */.KT, {
          type: MarketsFormatNumber/* NumberType.Number */.sw.Number,
          decimalScale: 0,
          displayISK: true,
          number: value
        });
      },
      style: {
        textAlign: 'right',
        whiteSpace: 'nowrap'
      }
    }, {
      Header: r(Stocks_res.time),
      accessor: 'date',
      Cell: function Cell(_ref6) {
        var value = _ref6.value;
        return (0,isToday/* default */.Z)(new Date(value)) ? (0,format["default"])(new Date(value), 'HH:mm') : (0,format["default"])(new Date(value), locale === 'is' ? 'dd.MM.yyyy HH:mm' : 'dd/mm/yyyy HH:mm');
      },
      style: {
        textAlign: 'right'
      }
    }];
  }, []);
  var tableData = react.useMemo(function () {
    return data === null || data === void 0 ? void 0 : data.intradayHistory;
  }, [data]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* StickyFirstColumn */.yi, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataTable, {
      "aria-label": r(Stocks_res.stocks),
      data: tableData,
      columns: columns,
      colorTheme: "ternary",
      initialState: {
        sortBy: [{
          id: 'date',
          desc: true
        }]
      },
      rowLink: function rowLink(_ref7) {
        var stock = _ref7.original;
        return {
          href: "".concat(prefix, "/[symbol]"),
          as: "".concat(prefix, "/").concat(stock.symbol.split(' ').join('_').toLowerCase())
        };
      },
      isClickable: true
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/markets/stocks/Stocks.tsx













function Stocks(_ref) {
  var stocks = _ref.stocks,
      intraday = _ref.intraday,
      stockDetailPrefix = _ref.stockDetailPrefix,
      stockBuyUrl = _ref.stockBuyUrl,
      disclaimerText = _ref.disclaimerText;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  var _React$useState = react.useState(StockDataType.Market),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      stockDataType = _React$useState2[0],
      setSelectedStockDataType = _React$useState2[1];

  var changeDataType = function changeDataType(StockDataType) {
    setSelectedStockDataType(StockDataType);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketsComponents/* ListHeaderContainer */.CU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 5 / 12
        },
        lg: {
          width: 5 / 12
        },
        children: !isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsListTitle */.hZ, {
            children: r(Stocks_res.stocks)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSmall */.pU, {
            children: r(Stocks_res.disclaimer)
          })]
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsListTitleMobile */.Py, {
          children: r(Stocks_res.nasdaq)
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 8 / 12
        },
        lg: {
          width: 5 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsComponents/* MarketsSelectorTabs */.pV, {
          mobileLabel: r(Stocks_res.selectInformation),
          mobileInset: true,
          onSelectTab: function onSelectTab(val) {
            changeDataType(Number(val));
          },
          tabSpacing: "40px",
          selectedItemId: stockDataType.toString(),
          items: [{
            id: StockDataType.Market.toString(),
            label: r(Stocks_res.marketToday)
          }, {
            id: StockDataType.FirstNorth.toString(),
            label: r(Stocks_res.firstNorth)
          }, {
            id: StockDataType.Trades.toString(),
            label: r(Stocks_res.trades)
          }],
          color: "rgb(5, 179, 192)"
        })
      })]
    }), stockDataType === StockDataType.Market && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StocksMarketTable, {
      stocks: stocks,
      exchange: globalTypes/* ExchangeSymbol.XICE */.u7.XICE,
      stockDetailPrefix: stockDetailPrefix,
      stockBuyUrl: stockBuyUrl
    }), stockDataType === StockDataType.FirstNorth && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StocksMarketTable, {
      stocks: stocks,
      exchange: globalTypes/* ExchangeSymbol.FNIS */.u7.FNIS,
      stockDetailPrefix: stockDetailPrefix,
      stockBuyUrl: stockBuyUrl
    }), stockDataType === StockDataType.Trades && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StocksTradesTable, {
      intraday: intraday,
      prefix: stockDetailPrefix
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsDisclaimer, {
      text: disclaimerText
    })]
  });
}
var StockDataType;

(function (StockDataType) {
  StockDataType[StockDataType["Market"] = 0] = "Market";
  StockDataType[StockDataType["FirstNorth"] = 1] = "FirstNorth";
  StockDataType[StockDataType["Trades"] = 2] = "Trades";
})(StockDataType || (StockDataType = {}));
;// CONCATENATED MODULE: ../../packages/slices/src/containers/MarketsContainer.tsx


function MarketsContainer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var MarketsContainer_Disclaimer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18g1kzk0"
} : 0)( true ? {
  name: "os6wsv",
  styles: "margin-top:-30px"
} : 0);

var MarketsContainer = function MarketsContainer(_ref) {
  var instrument = _ref.instrument,
      order = _ref.order,
      disclaimer = _ref.disclaimer;
  var isEmpty = (0,isEmptyText/* isEmptyText */.W)(disclaimer);

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Segment/* Segment */.X, {
    paddingTop: 80,
    children: [instrument === 'Bonds' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reveal/* Reveal */.U, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bonds, {
        prefix: "/markadir/skuldabref",
        disclaimerText: r(MarketsDisclaimer_res.disclaimer.landsbankinn)
      })
    }), instrument === 'Stocks' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reveal/* Reveal */.U, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stocks, {
        stockDetailPrefix: "/markadir/hlutabref",
        stockBuyUrl: function stockBuyUrl() {
          return 'https://netbanki.landsbankinn.is/Securities/Overview/Overview.aspx#/stocks/market';
        },
        disclaimerText: r(MarketsDisclaimer_res.disclaimer.landsbankinn)
      })
    }), instrument === 'Funds' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reveal/* Reveal */.U, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Funds, {
        order: order,
        fundDetailPrefix: "/markadir/sjodir/",
        fundBuyUrl: function fundBuyUrl() {
          return 'https://netbanki.landsbankinn.is/Securities/Overview/Overview.aspx#/funds/market';
        },
        stockBuyUrl: function stockBuyUrl() {
          return 'https://netbanki.landsbankinn.is/Securities/Overview/Overview.aspx#/stocks/market';
        },
        disclaimerText: r(MarketsDisclaimer_res.disclaimer.landsbankinn),
        einkabrefDisclaimer: r(Funds_res.einkabrefDisclaimer.landsbankinn),
        foreignCurrencyDisclaimer: r(Funds_res.foreignCurrencyDisclaimer.landsbankinn),
        fundsDisclaimer: r(Funds_res.fundsDisclaimer3.landsbankinn)
      })
    }), !isEmpty && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reveal/* Reveal */.U, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsContainer_Disclaimer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
          value: disclaimer
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/ui/src/components/icons/ExpandPlus.tsx



function ExpandPlus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ExpandPlus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ExpandPlus_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ExpandPlus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function correctSize(size) {
  switch (size) {
    case 'small':
      return '29px';

    case 'medium':
      return '41px';

    case 'large':
      return '96px';

    default:
      return '96px';
  }
}

function borderSize(size) {
  switch (size) {
    case 'small':
      return '9px';

    case 'medium':
      return '14px';

    case 'large':
      return '30px';

    default:
      return '30px';
  }
}

var ExpandPlus_Div = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e69inuu2"
} : 0)("border-radius:100px;background:", function (_ref) {
  var theme = _ref.theme,
      currentTheme = _ref.currentTheme;
  return theme.colors[currentTheme];
}, ";height:", function (_ref2) {
  var size = _ref2.size;
  return correctSize(size);
}, ";width:", function (_ref3) {
  var size = _ref3.size;
  return correctSize(size);
}, ";display:flex;justify-content:center;align-items:center;" + ( true ? "" : 0));

var NotAnimatedSpan = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.span,  true ? {
  target: "e69inuu1"
} : 0)("height:", function (_ref4) {
  var size = _ref4.size;
  return borderSize(size);
}, ";display:inline-block;width:1px;border-left:1px solid #ffffff;margin-left:", function (_ref5) {
  var size = _ref5.size;
  return size === 'small' || size === 'medium' ? '-1px' : '0px';
}, ";transform-origin:center center;transform:rotate(90deg);" + ( true ? "" : 0));

var AnimatedSpan = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.span,  true ? {
  target: "e69inuu0"
} : 0)("height:", function (_ref6) {
  var size = _ref6.size;
  return borderSize(size);
}, ";border-left:1px solid #ffffff;width:1px;display:inline-block;transform-origin:center center;transform:rotate(90deg);" + ( true ? "" : 0));

var ExpandPlus = function ExpandPlus(_ref7) {
  var isOpen = _ref7.isOpen,
      theme = _ref7.theme,
      size = _ref7.size;
  var rotate = (0,react_spring_esm.useSpring)({
    transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)'
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ExpandPlus_Div, {
    currentTheme: theme,
    size: size,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedSpan, {
      size: size,
      style: ExpandPlus_objectSpread({}, rotate)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotAnimatedSpan, {
      size: size
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card-group/MoreInfoCardGroup.tsx




function MoreInfoCardGroup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MoreInfoCardGroup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MoreInfoCardGroup_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MoreInfoCardGroup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var MoreInfoCardGroup_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1wh2w0o4"
} : 0)("height:", function (props) {
  return props['data-collapsed'] ? '540px' : 'auto';
}, ";overflow:", function (props) {
  return props['data-collapsed'] ? 'hidden' : 'vidible';
}, ";" + ( true ? "" : 0));

var MoreInfoCardGroup_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1wh2w0o3"
} : 0)(typography/* typography.h2 */.cp.h2, " margin-bottom:40px;margin-top:40px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:80px;}" + ( true ? "" : 0));

var MoreInfoCardGroup_CardGroup = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wh2w0o2"
} : 0)("flex-direction:column;>*{margin-left:0;margin-bottom:20px;max-width:100%;}@media ", devices/* device.tablet */.U.tablet, "{display:flex;flex-direction:row;flex-wrap:wrap;max-width:1200px;margin:0 -10px;>*{margin:0 10px;margin-bottom:20px;width:100%;max-width:calc(", function (props) {
  return 1 / props.columns * 100;
}, "% - 20px);}}" + ( true ? "" : 0));

var ExpandBtn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.button,  true ? {
  target: "e1wh2w0o1"
} : 0)("position:absolute;bottom:0;right:1px;left:1px;height:", function (props) {
  return props.isOpen ? '100px' : '200px';
}, ";width:calc(100% - 2px);overflow:visible;cursor:pointer;background-image:linear-gradient(\n    0deg,\n    rgba(244, 247, 247, 1) 0%,\n    rgba(244, 247, 247, 1) 50%,\n    rgba(244, 247, 247, 0) 100%\n  );>div{position:absolute;left:calc(50% - 11px);bottom:-20px;}" + ( true ? "" : 0));

var MoreInfoCardGroup_SrOnly = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1wh2w0o0"
} : 0)(mixins/* sronly */._7, ";" + ( true ? "" : 0));

var MoreInfoCardGroup = function MoreInfoCardGroup(_ref) {
  var children = _ref.children,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 3 : _ref$columns,
      isCollapsed = _ref.isCollapsed,
      title = _ref.title,
      hasImage = _ref.hasImage;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useMeasure = (0,web/* default */.Z)({
    polyfill: resize_observer/* ResizeObserver */["do"]
  }),
      _useMeasure2 = (0,slicedToArray/* default */.Z)(_useMeasure, 2),
      copyRef = _useMeasure2[0],
      copySize = _useMeasure2[1];

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('md');

  var toggle = function toggle() {
    setIsOpen(!isOpen);
  };

  var setHeight = (0,react_spring_esm.useSpring)({
    height: isOpen && isCollapsed && !isMobile ? "".concat((copySize === null || copySize === void 0 ? void 0 : copySize.height) + 160, "px") : !isCollapsed || isMobile ? 'auto' : hasImage ? '800px' : '700px'
  });
  var fadeOut = (0,react_spring_esm.useSpring)({
    backgroundImage: isOpen ? "linear-gradient(\n      0deg,\n      rgba(244, 247, 247, 0) 0%,\n      rgba(244, 247, 247, 0) 50%,\n      rgba(244, 247, 247, 0) 100%\n    )" : "linear-gradient(\n        0deg,\n        rgba(244, 247, 247, 1) 0%,\n        rgba(244, 247, 247, 1) 50%,\n        rgba(244, 247, 247, 0) 100%\n    )"
  });

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children, {
    delay: 300
  }),
      ref = _useRevealTrail.ref,
      items = _useRevealTrail.items;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MoreInfoCardGroup_Host, {
    ref: ref,
    style: MoreInfoCardGroup_objectSpread({}, setHeight),
    "data-collapsed": isCollapsed,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoCardGroup_Title, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoCardGroup_CardGroup, {
      ref: copyRef,
      columns: columns,
      children: items
    }), !!isCollapsed && !isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ExpandBtn, {
      onClick: toggle,
      role: "button",
      "aria-expanded": isOpen ? true : false,
      style: MoreInfoCardGroup_objectSpread({}, fadeOut),
      isOpen: isOpen,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExpandPlus, {
        size: "medium",
        theme: "secondary",
        isOpen: isOpen
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoCardGroup_SrOnly, {
        children: "See more"
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/ui/src/components/buttons/ExpandArrow.tsx



function ExpandArrow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ExpandArrow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ExpandArrow_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ExpandArrow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ExpandArrow_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var Path = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.path,  true ? {
  target: "e1j6jsaw0"
} : 0)( true ? {
  name: "1z94ln",
  styles: "transform-origin:center center;transform:rotate(0deg)"
} : 0);

var ExpandArrow = function ExpandArrow(_ref) {
  var isOpen = _ref.isOpen;
  var rotate = (0,react_spring_esm.useSpring)({
    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "13",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Path, {
      style: ExpandArrow_objectSpread({}, rotate),
      fill: "#1E3D5A",
      fillRule: "evenodd",
      d: "M21.112 0l1.01 1.01L12.07 11.061l.05.05-1.01 1.01-.05-.05-.05.05L10 11.112l.05-.051L0 1.01 1.01 0l10.05 10.05L21.112 0z"
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/MoreInfoCard.tsx




var MoreInfoCard_excluded = ["title", "description", "image", "ar", "backgroundAlt", "imageRef", "isCollapsed", "index"];

function MoreInfoCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MoreInfoCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MoreInfoCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MoreInfoCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function MoreInfoCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var MoreInfoCard_CardHost = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1lb2l936"
} : 0)("position:relative;width:100%;height:", function (props) {
  return props['data-collapsed'] ? props['data-wrapheight'] : '100%';
}, ";overflow:", function (props) {
  return props['data-collapsed'] ? 'hidden' : 'vidible';
}, ";background-color:", function (props) {
  return props['data-backgroundalt'] ? props.theme.colors.backgroundAlt : props.theme.colors.background;
}, ";" + ( true ? "" : 0));

var MoreInfoCard_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lb2l935"
} : 0)( true ? "" : 0);

var MoreInfoCard_Body = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lb2l934"
} : 0)( true ? {
  name: "9dh7ib",
  styles: "padding:64px 36px 36px"
} : 0);

var MoreInfoCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1lb2l933"
} : 0)(typography/* typography.h4 */.cp.h4, ";margin-bottom:3px;" + ( true ? "" : 0));

var MoreInfoCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lb2l932"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:24px;" + ( true ? "" : 0));

var MoreInfoCard_ExpandBtn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.button,  true ? {
  target: "e1lb2l931"
} : 0)( true ? {
  name: "1cx5jx7",
  styles: "position:absolute;bottom:0;right:1px;left:1px;height:125px;width:calc(100% - 2px);overflow:visible;cursor:pointer;background-image:linear-gradient(\n    0deg,\n    rgba(255, 255, 255, 1) 0%,\n    rgba(255, 255, 255, 1) 30%,\n    rgba(255, 255, 255, 0) 100%\n  );svg{position:absolute;left:calc(50% - 11px);bottom:25px;}"
} : 0);

var MoreInfoCard_SrOnly = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1lb2l930"
} : 0)(mixins/* sronly */._7, ";" + ( true ? "" : 0));

function MoreInfoCard(props) {
  var title = props.title,
      description = props.description,
      image = props.image,
      ar = props.ar,
      _props$backgroundAlt = props.backgroundAlt,
      backgroundAlt = _props$backgroundAlt === void 0 ? false : _props$backgroundAlt,
      imageRef = props.imageRef,
      isCollapsed = props.isCollapsed,
      index = props.index,
      rest = (0,objectWithoutProperties/* default */.Z)(props, MoreInfoCard_excluded);

  var _useState = (0,react.useState)(isCollapsed ? false : true),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useMeasure = (0,web/* default */.Z)({
    polyfill: resize_observer/* ResizeObserver */["do"]
  }),
      _useMeasure2 = (0,slicedToArray/* default */.Z)(_useMeasure, 2),
      copyRef = _useMeasure2[0],
      copySize = _useMeasure2[1];

  var hasImage = !!image;
  var wrapHeight = hasImage && isCollapsed ? '670px' : !isCollapsed ? '100%' : '390px';

  var toggle = function toggle() {
    setIsOpen(!isOpen);
  };

  var setHeight = (0,react_spring_esm.useSpring)({
    height: isOpen && isCollapsed ? "".concat(lodash_get_default()(copySize, 'height', 0) + 60, "px") : !isCollapsed ? '100%' : wrapHeight
  });
  var fadeOut = (0,react_spring_esm.useSpring)({
    backgroundImage: isOpen ? "linear-gradient(\n      0deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0) 30%,\n      rgba(255, 255, 255, 0) 100%\n    )" : "linear-gradient(\n      0deg,\n      rgba(255, 255, 255, 1) 0%,\n      rgba(255, 255, 255, 1) 40%,\n      rgba(255, 255, 255, 0) 100%\n    )"
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoCard_CardHost, MoreInfoCard_objectSpread(MoreInfoCard_objectSpread({
    "data-backgroundalt": backgroundAlt,
    "data-collapsed": isCollapsed,
    style: MoreInfoCard_objectSpread({}, setHeight),
    id: "more-info-".concat(index),
    "data-wrapheight": wrapHeight
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MoreInfoCard_Content, {
      ref: copyRef,
      children: [!!image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
        src: image,
        ar: ar,
        ref: imageRef,
        percentage: 0.33
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MoreInfoCard_Body, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoCard_Title, {
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
          margin: "32px 0 36px"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoCard_Copy, {
          children: description
        })]
      }), !!isCollapsed && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MoreInfoCard_ExpandBtn, {
        onClick: toggle,
        role: "button",
        "aria-expanded": isOpen ? true : false,
        "aria-controls": "more-info-".concat(index),
        style: MoreInfoCard_objectSpread({}, fadeOut),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExpandArrow, {
          isOpen: isOpen
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoCard_SrOnly, {
          children: "See more"
        })]
      })]
    })
  }));
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/MoreInfoContainer.tsx


function MoreInfoContainer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var MoreInfoContainer_Background = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  target: "e14dttyy1"
} : 0)("background-color:", function (props) {
  return props.theme.colors.backgroundAlt;
}, ";margin-bottom:60px;" + ( true ? "" : 0));

var Spacing = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Segment/* Segment */.X,  true ? {
  target: "e14dttyy0"
} : 0)( true ? {
  name: "17nmygg",
  styles: "position:relative;>div{position:initial;}"
} : 0);

var MoreInfoContainer = function MoreInfoContainer(_ref) {
  var fields = _ref.fields,
      expandable = _ref.expandable,
      title = _ref.title;

  if ((fields === null || fields === void 0 ? void 0 : fields.length) === 0) {
    return null;
  } // Check if first of three childs has image


  var firstThree = fields === null || fields === void 0 ? void 0 : fields.slice(0, 3).map(function (_ref2) {
    var image = _ref2.image;
    return !!image;
  });
  var childHasImage = firstThree.includes(true);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoContainer_Background, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spacing, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoCardGroup, {
        title: Prismic/* Prismic.text */.X5.text(title),
        columns: 3,
        isCollapsed: expandable,
        hasImage: childHasImage,
        children: fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoCard, {
            image: item.image,
            ar: "ar_1_1",
            title: Prismic/* Prismic.text */.X5.text(item.title),
            description: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
              value: item.copy
            }),
            isCollapsed: item.expandable,
            index: item.index
          }, "info-card-item-".concat(index));
        })
      })
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(31807);
;// CONCATENATED MODULE: ../../packages/slices/src/components/card-group/CardNewsGroup.tsx







var CardNewsGroup_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Segment/* Segment */.X,  true ? {
  target: "en5v39n2"
} : 0)("background-color:", function (props) {
  return props.theme.colors.backgroundAlt;
}, ";margin-top:4em;" + ( true ? "" : 0));

var CardNewsGroup_Group = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "en5v39n1"
} : 0)("margin-bottom:3em;>*{margin-bottom:3em;}>*:last-child{margin-bottom:0;}@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0;display:-ms-grid;display:grid;grid-template-columns:", function (_ref) {
  var featured = _ref.featured,
      length = _ref.length;
  return featured ? '2fr 1fr 1fr' : length === 5 ? '1fr 1fr 1fr 1fr 1fr' : '1fr 1fr';
}, ";--ms-grid-columns:", function (_ref2) {
  var featured = _ref2.featured,
      length = _ref2.length;
  return featured ? '2fr 30px 1fr 30px 1fr' : length === 5 ? '1fr 30px 1fr 30px 1fr 30px 1fr 30px 1fr' : '1fr 30px 1fr 30px 1fr';
}, ";grid-template-rows:", function (_ref3) {
  var featured = _ref3.featured;
  return featured ? '1fr 1fr' : '1fr';
}, ";--ms-grid-rows:", function (_ref4) {
  var featured = _ref4.featured;
  return featured ? '1fr 36px 1fr' : '1fr';
}, ";grid-template-areas:", function (_ref5) {
  var featured = _ref5.featured,
      length = _ref5.length;
  return featured ? "\"featured item2 item3\"\n        \"featured item4 item5\"" : length === 5 ? "\"item1 item2 item3 item4 item5\"" : "\"item1 item2\"\n        \"item3 item4\"";
}, ";grid-gap:36px 30px;>*:first-child{grid-area:", function (_ref6) {
  var featured = _ref6.featured;
  return featured ? 'featured' : 'item1';
}, ";-ms-grid-row:1;-ms-grid-row-span:", function (_ref7) {
  var featured = _ref7.featured;
  return featured ? '3' : '1';
}, ";-ms-grid-column:1;}>*:nth-child(2){-ms-grid-row:1;-ms-grid-column:3;grid-area:item2;}>*:nth-child(3){-ms-grid-row:1;-ms-grid-column:5;grid-area:item3;}>*:nth-child(4){-ms-grid-row:", function (_ref8) {
  var featured = _ref8.featured;
  return featured ? '3' : '1';
}, ";-ms-grid-column:", function (_ref9) {
  var featured = _ref9.featured;
  return featured ? '3' : '7';
}, ";grid-area:item4;}>*:nth-child(5){-ms-grid-row:", function (_ref10) {
  var featured = _ref10.featured;
  return featured ? '3' : '1';
}, ";-ms-grid-column:", function (_ref11) {
  var featured = _ref11.featured;
  return featured ? '5' : '9';
}, ";grid-area:item5;}>*{margin-bottom:2em;}>*:last-child{margin-bottom:0;}}@media ", devices/* device.desktop */.U.desktop, "{grid-template-columns:", function (_ref12) {
  var featured = _ref12.featured,
      length = _ref12.length;
  return featured ? '2fr 1fr 1fr' : length === 5 ? '1fr 1fr 1fr 1fr 1fr' : '1fr 1fr 1fr 1fr';
}, ";--ms-grid-columns:", function (_ref13) {
  var featured = _ref13.featured,
      length = _ref13.length;
  return featured ? '2fr 30px 1fr 30px 1fr' : length === 5 ? '1fr 30px 1fr 30px 1fr 30px 1fr 30px 1fr' : '1fr 30px 1fr 30px 1fr 30px 1fr';
}, ";>*:nth-child(4){display:block;}grid-template-areas:", function (_ref14) {
  var featured = _ref14.featured,
      length = _ref14.length;
  return featured ? "\"featured item2 item3\"\n        \"featured item4 item5\"" : length === 5 ? "\"item1 item2 item3 item4 item5\"" : "\"item1 item2 item3 item4\"";
}, ";}" + ( true ? "" : 0));

var CardNewsGroup_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "en5v39n0"
} : 0)(typography/* typography.h2 */.cp.h2, ";margin-bottom:1.2em;margin-top:1em;@media ", devices/* device.tablet */.U.tablet, "{", typography/* typography.h3 */.cp.h3, ";margin-bottom:60px;margin-top:0;}" + ( true ? "" : 0));

var CardNewsGroup = function CardNewsGroup(_ref15) {
  var children = _ref15.children,
      featured = _ref15.featured,
      heading = _ref15.heading,
      link = _ref15.link,
      length = _ref15.length;

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardNewsGroup_Host, {
    isGray: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      ref: ref,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_link["default"], {
        href: link,
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardNewsGroup_Title, {
            children: heading
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardNewsGroup_Group, {
        featured: featured,
        length: length,
        children: itemsWithStyleProp
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/NewsCard.tsx



var NewsCard_excluded = ["date", "title", "description", "link"];

function NewsCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function NewsCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NewsCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NewsCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function NewsCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var NewsCard_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "eelqji34"
} : 0)( true ? {
  name: "1mwy8pv",
  styles: "display:block;position:relative;width:100%"
} : 0);

var NewsCard_Date = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eelqji33"
} : 0)(typography/* typography.body */.cp.body, " opacity:0.75;color:", function (props) {
  return props.theme.colors.foreground;
}, ";margin-bottom:13px;" + ( true ? "" : 0));

var NewsCard_A = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "eelqji32"
} : 0)("display:block;&:hover{text-decoration:underline;}@media ", devices/* device.tablet */.U.tablet, "{min-height:73px;}" + ( true ? "" : 0));

var NewsCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "eelqji31"
} : 0)(typography/* typography.h4 */.cp.h4, " color:", function (props) {
  return props.theme.colors.foreground;
}, ";margin-bottom:0;", function (props) {
  return props.maxLines && "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: ".concat(props.maxLines, ";\n    -webkit-box-orient: vertical;\n    position: relative;\n    \n    \n    &:after {\n      display: block;\n      content: '';\n      position: absolute;\n      width: 50%;\n      height: 27px;\n      background-image: linear-gradient(90deg, rgba(244,247,247,0) 0%, ").concat(props.theme.colors.backgroundAlt, " 60%);\n      bottom: 0;\n      right: 0;\n    }\n  ");
}, "@media ", devices/* device.tablet */.U.tablet, "{", function (props) {
  return props.maxLines && "\n    height: 96px;\n    ";
}, ";}@media ", devices/* device.desktop */.U.desktop, "{", function (props) {
  return props.maxLines && "\n    margin-bottom: 45px;\n    ";
}, ";}" + ( true ? "" : 0));

var NewsCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eelqji30"
} : 0)(typography/* typography.body */.cp.body, " color:", function (props) {
  return props.theme.colors.foreground;
}, ";", function (props) {
  return props.maxLines && "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: ".concat(props.maxLines, ";\n    -webkit-box-orient: vertical;\n    position: relative;\n    &:after {\n      display: block;\n      content: '';\n      position: absolute;\n      width: 50%;\n      height: 27px;\n      background-image: linear-gradient(90deg, rgba(244,247,247,0) 0%, ").concat(props.theme.colors.backgroundAlt, " 60%);\n      bottom: 0;\n      right: 0;\n    }\n  ");
}, ";" + ( true ? "" : 0));

var NewsCard = /*#__PURE__*/(0,react.forwardRef)(function NCard(_ref, ref) {
  var _link$anchorProps;

  var date = _ref.date,
      title = _ref.title,
      description = _ref.description,
      link = _ref.link,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, NewsCard_excluded);

  var _useResource = (0,src/* useResource */.Wf)(),
      locale = _useResource.locale;

  var anchorProps = link === null || link === void 0 ? void 0 : (_link$anchorProps = link.anchorProps) === null || _link$anchorProps === void 0 ? void 0 : _link$anchorProps.call(link);

  if (title === (anchorProps === null || anchorProps === void 0 ? void 0 : anchorProps.title)) {
    anchorProps.title = undefined;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NewsCard_Host, NewsCard_objectSpread(NewsCard_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsCard_Date, {
      children: (0,src/* formatDateShort */.mn)(locale, date)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_link["default"], NewsCard_objectSpread(NewsCard_objectSpread({}, link), {}, {
      prefetch: false,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsCard_A, NewsCard_objectSpread(NewsCard_objectSpread({}, anchorProps), {}, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsCard_Title, {
          maxLines: 3,
          children: title
        })
      }))
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
      margin: "24px 0",
      style: {
        height: 2
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsCard_Copy, {
      maxLines: 5,
      children: description
    })]
  }));
});
;// CONCATENATED MODULE: ../../packages/slices/src/containers/NewsCardsContainer.tsx


function NewsCardsContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function NewsCardsContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { NewsCardsContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { NewsCardsContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var NewsCardsContainer = function NewsCardsContainer(_ref) {
  var heading = _ref.heading,
      featured = _ref.featured,
      heading_link = _ref.heading_link,
      fields = _ref.fields;

  var _useContext = (0,react.useContext)(prismicContext/* PrismicContext */.Z),
      urlResolver = _useContext.urlResolver;

  var headingLink = Prismic/* Prismic.link */.X5.link(urlResolver, heading_link);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardNewsGroup, {
    heading: Prismic/* Prismic.text */.X5.text(heading),
    link: headingLink.as,
    featured: featured,
    length: Math.min(4, fields.length),
    children: fields === null || fields === void 0 ? void 0 : fields.slice(0, 4).map(function (item, index) {
      var _item$article, _item$article2, _item$article3;

      if (!item.article) {
        return null;
      }

      var link = Prismic/* Prismic.link */.X5.link(urlResolver, NewsCardsContainer_objectSpread({
        _linkType: Prismic/* LinkType.Document */.Un.Document
      }, item === null || item === void 0 ? void 0 : item.article), item === null || item === void 0 ? void 0 : (_item$article = item.article) === null || _item$article === void 0 ? void 0 : _item$article.title);
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsCard, {
        link: link,
        date: (0,parseISO["default"])(item === null || item === void 0 ? void 0 : (_item$article2 = item.article) === null || _item$article2 === void 0 ? void 0 : _item$article2.date),
        title: link.title,
        description: item !== null && item !== void 0 && item.article_abstract && Prismic/* Prismic.text */.X5.text(item === null || item === void 0 ? void 0 : item.article_abstract) !== '' ? Prismic/* Prismic.text */.X5.text(item === null || item === void 0 ? void 0 : item.article_abstract) : Prismic/* Prismic.text */.X5.text(item === null || item === void 0 ? void 0 : (_item$article3 = item.article) === null || _item$article3 === void 0 ? void 0 : _item$article3.abstract)
      }, index);
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/giftCard/giftCardDeliveryPlaces.ts


var giftCardDeliveryPlaces_templateObject;


var GIFT_CARD_DELIVERY_PLACES = (0,lib/* gql */.Ps)(giftCardDeliveryPlaces_templateObject || (giftCardDeliveryPlaces_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query GiftCardDeliveryPlaces {\n    servicePoints(first: 100, service: Branch) {\n      edges {\n        node {\n          id\n          region\n          branches {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/giftCard/orderGiftCard.ts


var orderGiftCard_templateObject;


var ORDER_GIFT_CARD = (0,lib/* gql */.Ps)(orderGiftCard_templateObject || (orderGiftCard_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation OrderGiftCard($data: OrderGiftCardInput!) {\n    orderGiftCard(data: $data) {\n      ... on KennitalaNotFoundError {\n        message\n      }\n      ... on CrmCasePayload {\n        success\n      }\n    }\n  }\n"])));
// EXTERNAL MODULE: ../../packages/ui/src/components/form/number-input/NumberFormatInput.tsx
var NumberFormatInput = __webpack_require__(52541);
;// CONCATENATED MODULE: ../../packages/ui/src/components/form/number-input/AccountInput.tsx



var AccountInput_excluded = ["onChange"];

function AccountInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AccountInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccountInput_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccountInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var onlyNumber = /^\d+$/;
var AccountInput = function AccountInput(_ref) {
  var onChange = _ref.onChange,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, AccountInput_excluded);

  var _React$useState = react.useState(''),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      bankNr = _React$useState2[0],
      setBankNr = _React$useState2[1];

  var _React$useState3 = react.useState(''),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      ledger = _React$useState4[0],
      setLedger = _React$useState4[1];

  var _React$useState5 = react.useState(''),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      accountNr = _React$useState6[0],
      setAccountNr = _React$useState6[1];

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(bankNr, [{
    validation: function validation(val) {
      return val.length === 4;
    }
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 2),
      bankNrRef = _useInputValidation2[0],
      isBankNrValid = _useInputValidation2[1];

  var _useInputValidation3 = (0,useInputValidation/* useInputValidation */.a)(ledger, [{
    validation: function validation(val) {
      return val.length === 2;
    }
  }]),
      _useInputValidation4 = (0,slicedToArray/* default */.Z)(_useInputValidation3, 2),
      ledgerRef = _useInputValidation4[0],
      isLedgerValid = _useInputValidation4[1];

  var _useInputValidation5 = (0,useInputValidation/* useInputValidation */.a)(accountNr, [{
    validation: function validation(val) {
      return val.length === 6;
    }
  }]),
      _useInputValidation6 = (0,slicedToArray/* default */.Z)(_useInputValidation5, 2),
      accountNrRef = _useInputValidation6[0],
      isAccountNumberValid = _useInputValidation6[1];

  react.useEffect(function () {
    onChange("".concat(bankNr).concat(ledger).concat(accountNr));
  }, [bankNr, ledger, accountNr]);

  var onBankNrChange = function onBankNrChange(value) {
    if (value.length <= 4) {
      setBankNr(value);

      if (value.length === 4) {
        setTimeout(function () {
          var _ledgerRef$current;

          (_ledgerRef$current = ledgerRef.current) === null || _ledgerRef$current === void 0 ? void 0 : _ledgerRef$current.focus();
        }, 0);
      }
    }
  };

  var onLedgerChange = function onLedgerChange(value) {
    if (value.length <= 2) {
      setLedger(value);

      if (value.length === 2) {
        setTimeout(function () {
          var _accountNrRef$current;

          (_accountNrRef$current = accountNrRef.current) === null || _accountNrRef$current === void 0 ? void 0 : _accountNrRef$current.focus();
        }, 0);
      }

      if (value.length === 0) {
        setTimeout(function () {
          var _bankNrRef$current;

          (_bankNrRef$current = bankNrRef.current) === null || _bankNrRef$current === void 0 ? void 0 : _bankNrRef$current.focus();
        }, 0);
      }
    }
  };

  var onAccountNrChange = function onAccountNrChange(value) {
    if (value.length <= 6) {
      setAccountNr(value);
    }

    if (value.length === 0) {
      setTimeout(function () {
        var _ledgerRef$current2;

        (_ledgerRef$current2 = ledgerRef.current) === null || _ledgerRef$current2 === void 0 ? void 0 : _ledgerRef$current2.focus();
      }, 0);
    }
  };

  var onPaste = function onPaste(event) {
    var clipboardData = event.clipboardData.getData('Text').trim();
    var accountNumber = clipboardData.replace(/\D/g, '');

    if (accountNumber.length === 12 && onlyNumber.test(accountNumber)) {
      var _accountNrRef$current2;

      var _bankNr = accountNumber.slice(0, 4);

      var _ledger = accountNumber.slice(4, 6);

      var _accountNr = accountNumber.slice(6, 12);

      setBankNr(_bankNr);
      setLedger(_ledger);
      setAccountNr(_accountNr);
      (_accountNrRef$current2 = accountNrRef.current) === null || _accountNrRef$current2 === void 0 ? void 0 : _accountNrRef$current2.focus();
    }
  };

  var onEnter = function onEnter(event) {
    if (event.key === 'Enter') {
      var length = accountNr.length;

      if (length < 6 && length !== 0) {
        setAccountNr("".concat('0'.repeat(6 - length)).concat(accountNr));
      }
    }

    return true;
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
      md: {
        width: 4.5 / 12
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberFormatInput/* NumberFormatInput */.v, AccountInput_objectSpread(AccountInput_objectSpread({}, rest), {}, {
        id: 'bankNr',
        label: "Banki",
        maxLength: 4,
        onValueChange: function onValueChange(_ref2) {
          var value = _ref2.value;
          return onBankNrChange(value);
        },
        value: bankNr,
        onBlur: function onBlur() {
          if (bankNr.length === 3) {
            setBankNr("0".concat(bankNr));
          }
        },
        onPaste: onPaste,
        isValid: isBankNrValid,
        inputRef: bankNrRef,
        allowLeadingZeros: true,
        format: function format(val) {
          return val;
        }
      }))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
      md: {
        width: 3 / 12
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberFormatInput/* NumberFormatInput */.v, AccountInput_objectSpread(AccountInput_objectSpread({}, rest), {}, {
        id: 'hbNr',
        inputRef: ledgerRef,
        label: "H\xF6fu\xF0b\xF3k",
        value: ledger,
        onBlur: function onBlur() {
          if (ledger.length === 1) {
            setLedger("0".concat(ledger));
          }
        },
        maxLength: 2,
        onValueChange: function onValueChange(_ref3) {
          var value = _ref3.value;
          return onLedgerChange(value);
        },
        onPaste: onPaste,
        isValid: isLedgerValid,
        allowLeadingZeros: true,
        format: undefined
      }))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
      md: {
        width: 4.5 / 12
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberFormatInput/* NumberFormatInput */.v, AccountInput_objectSpread(AccountInput_objectSpread({}, rest), {}, {
        id: 'accountNr',
        value: accountNr,
        label: "Reikningsn\xFAmer",
        onKeyDown: onEnter,
        maxLength: 6,
        onValueChange: function onValueChange(_ref4) {
          var value = _ref4.value;
          return onAccountNrChange(value);
        },
        inputRef: accountNrRef,
        onBlur: function onBlur() {
          if (accountNr && accountNr.length < 6 && accountNr.length !== 0) {
            setAccountNr("".concat('0'.repeat(6 - accountNr.length)).concat(accountNr));
          }
        },
        onPaste: onPaste,
        isValid: isAccountNumberValid,
        allowLeadingZeros: true,
        format: function format(val) {
          return val;
        },
        errorMessage: isBankNrValid === false || isLedgerValid === false || isAccountNumberValid === false ? 'Reikningsnúmer ekki á réttu formi' : undefined
      }))
    })]
  });
};
// EXTERNAL MODULE: ../../packages/ui/src/components/form/number-input/MoneyInput.tsx
var MoneyInput = __webpack_require__(90965);
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/form/inputs/Amount.tsx




function Amount(_ref) {
  var amount = _ref.amount,
      setAmount = _ref.setAmount;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(amount, [{
    validation: function validation(amount) {
      return amount > 0;
    },
    message: 'Upphæð vantar'
  }, {
    validation: function validation(amount) {
      return amount <= 200000;
    },
    message: 'Hámarksupphæð er 200.000 kr.'
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 3),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1],
      message = _useInputValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoneyInput/* MoneyInput */.P, {
    inputRef: ref,
    isValid: isValid,
    errorMessage: message,
    onChangeValue: function onChangeValue(amount) {
      return setAmount(amount);
    },
    label: "Upph\xE6\xF0 \xE1 hverju korti",
    labelVariant: "aboveInput",
    textAlign: "center",
    variant: "noBorder",
    inputSize: "big",
    value: amount,
    id: "amountOnCards",
    inputType: "medium"
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/form/inputs/Email.tsx




function Email(_ref) {
  var email = _ref.email,
      setEmail = _ref.setEmail,
      label = _ref.label;

  var _useEmailValidation = (0,useEmailValidation/* useEmailValidation */.$)(email),
      _useEmailValidation2 = (0,slicedToArray/* default */.Z)(_useEmailValidation, 3),
      ref = _useEmailValidation2[0],
      isValid = _useEmailValidation2[1],
      message = _useEmailValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
    inputRef: ref,
    isValid: isValid,
    errorMessage: message,
    label: label !== null && label !== void 0 ? label : 'Netfang',
    value: email,
    onChange: function onChange(event) {
      return setEmail(event.target.value);
    },
    id: "fea",
    variant: "noBorder",
    labelVariant: "aboveInput"
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/form/inputs/Kennitala.tsx




function Kennitala(_ref) {
  var kennitala = _ref.kennitala,
      setKennitala = _ref.setKennitala,
      label = _ref.label,
      kennitalaNotFound = _ref.kennitalaNotFound;

  var _useKennitalaValidati = (0,useKennitalaValidation/* useKennitalaValidation */.S)(kennitala),
      _useKennitalaValidati2 = (0,slicedToArray/* default */.Z)(_useKennitalaValidati, 3),
      ref = _useKennitalaValidati2[0],
      isValid = _useKennitalaValidati2[1],
      message = _useKennitalaValidati2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Kennitalanput/* KennitalaInput */.t, {
    inputRef: ref,
    isValid: isValid && !kennitalaNotFound,
    errorMessage: message || (kennitalaNotFound ? 'Kennitala ekki til' : ''),
    label: label !== null && label !== void 0 ? label : 'Kennitala',
    value: kennitala,
    onValueChange: function onValueChange(kennitala) {
      return setKennitala(kennitala.value);
    },
    variant: "noBorder",
    labelVariant: "aboveInput"
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/form/inputs/Location.tsx




function Location(_ref) {
  var deliveryPlaceOptions = _ref.deliveryPlaceOptions,
      selectedId = _ref.selectedId,
      setSelcetedId = _ref.setSelcetedId;
  var value = (0,react.useMemo)(function () {
    var seletedOption = undefined;

    if (selectedId !== '') {
      deliveryPlaceOptions.forEach(function (i) {
        var item = i.options.find(function (o) {
          return o.value === selectedId;
        });

        if (item) {
          seletedOption = item;
        }
      });
    }

    return seletedOption;
  }, [selectedId, deliveryPlaceOptions]);

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(selectedId, [{
    validation: function validation(id) {
      return id ? id.length > 0 : false;
    }
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 2),
      _ = _useInputValidation2[0],
      isValid = _useInputValidation2[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown, {
    isValid: isValid,
    label: "Hvert viltu s\xE6kja korti\xF0?",
    options: deliveryPlaceOptions,
    placeholder: "Veldu afhendingasta\xF0",
    onChange: function onChange(val) {
      var _val$value;

      setSelcetedId((_val$value = val === null || val === void 0 ? void 0 : val['value']) !== null && _val$value !== void 0 ? _val$value : '');
    },
    value: value,
    buildOption: function buildOption(val) {
      return val;
    },
    variant: "noBorder",
    labelVariant: "aboveInput"
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/form/inputs/Name.tsx




function Name(_ref) {
  var name = _ref.name,
      setName = _ref.setName,
      label = _ref.label;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(name, [{
    validation: function validation(name) {
      return !!name && name.length > 0;
    },
    message: 'Nafn vantar'
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 3),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1],
      message = _useInputValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, {
    inputRef: ref,
    isValid: isValid,
    errorMessage: message,
    label: label !== null && label !== void 0 ? label : 'Nafn',
    onChange: function onChange(event) {
      return setName(event.target.value);
    },
    value: name,
    id: "fea",
    variant: "noBorder",
    labelVariant: "aboveInput"
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/form/inputs/NumberOfCards.tsx



function NumberOfCards(_ref) {
  var numberOfCards = _ref.numberOfCards,
      setNumberOfCards = _ref.setNumberOfCards;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberInput/* NumberInput */.Y, {
    label: "Fj\xF6ldi gjafakorta",
    allowNegatives: false,
    onChange: function onChange(numberOfGiftCards) {
      return setNumberOfCards(numberOfGiftCards);
    },
    value: numberOfCards,
    id: "fea",
    inputSize: "big"
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/form/inputs/PhoneNumber.tsx




function PhoneNumber(_ref) {
  var phoneNumber = _ref.phoneNumber,
      setPhoneNumber = _ref.setPhoneNumber,
      label = _ref.label;

  var _useInputValidation = (0,useInputValidation/* useInputValidation */.a)(phoneNumber, [{
    validation: function validation(v) {
      return v !== undefined && v.replaceAll('-', '').length === 7;
    },
    message: 'Símanúmer er ekki á réttu formi'
  }]),
      _useInputValidation2 = (0,slicedToArray/* default */.Z)(_useInputValidation, 3),
      ref = _useInputValidation2[0],
      isValid = _useInputValidation2[1],
      message = _useInputValidation2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contact_input_PhoneInput/* PhoneInput */.s, {
    inputRef: ref,
    isValid: isValid,
    errorMessage: message,
    label: label !== null && label !== void 0 ? label : 'Símanúmer',
    value: phoneNumber,
    onValueChange: function onValueChange(number) {
      return setPhoneNumber(number.value);
    },
    variant: "noBorder",
    labelVariant: "aboveInput"
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/Corporate.tsx



function Corporate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Corporate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Corporate_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Corporate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var Corporate_FormSpacer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18xsmu21"
} : 0)("height:1px;background:", function (props) {
  return (0,polished_esm/* rgba */.m4)(props.theme.colors.primary, 0.1);
}, ";", function (props) {
  return props.smallTop ? 'margin-top: 20px;' : 'margin-top: 40px;';
}, ";margin-bottom:57px;" + ( true ? "" : 0));

var StyledColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e18xsmu20"
} : 0)("margin-bottom:", function (props) {
  return props.theme.baseline * 8;
}, "px;" + ( true ? "" : 0));

function CorporateForm(_ref) {
  var deliveryPlaceOptions = _ref.deliveryPlaceOptions,
      formData = _ref.formData,
      setKennitalaNotFound = _ref.setKennitalaNotFound,
      kennitalaNotFound = _ref.kennitalaNotFound,
      setOrderGiftCardInput = _ref.setOrderGiftCardInput;
  var numberOfGiftCards = formData.numberOfGiftCards,
      amountOnEachCard = formData.amountOnEachCard,
      name = formData.name,
      kennitala = formData.kennitala,
      phoneNumber = formData.phoneNumber,
      employeeName = formData.employeeName,
      email = formData.email,
      servicePointId = formData.servicePointId;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberOfCards, {
          numberOfCards: numberOfGiftCards,
          setNumberOfCards: function setNumberOfCards(number) {
            return setOrderGiftCardInput(Corporate_objectSpread(Corporate_objectSpread({}, formData), {}, {
              numberOfGiftCards: number
            }));
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Amount, {
          amount: amountOnEachCard,
          setAmount: function setAmount(amount) {
            return setOrderGiftCardInput(Corporate_objectSpread(Corporate_objectSpread({}, formData), {}, {
              amountOnEachCard: amount
            }));
          }
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: deliveryPlaceOptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Location, {
          deliveryPlaceOptions: deliveryPlaceOptions,
          selectedId: servicePointId ? servicePointId : undefined,
          setSelcetedId: function setSelcetedId(id) {
            setOrderGiftCardInput(Corporate_objectSpread(Corporate_objectSpread({}, formData), {}, {
              servicePointId: id
            }));
          }
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 10 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Corporate_FormSpacer, {
          smallTop: true
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Name, {
          label: "Nafn fyrirt\xE6kis",
          name: name,
          setName: function setName(name) {
            return setOrderGiftCardInput(Corporate_objectSpread(Corporate_objectSpread({}, formData), {}, {
              name: name
            }));
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumn, {
        sm: {
          width: 12 / 12
        },
        lg: {
          width: 2.5 / 12
        },
        md: {
          width: 5 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Kennitala, {
          kennitalaNotFound: kennitalaNotFound,
          label: "Kennitala fyrirt\xE6kis",
          kennitala: kennitala,
          setKennitala: function setKennitala(kennitala) {
            setKennitalaNotFound(false);
            setOrderGiftCardInput(Corporate_objectSpread(Corporate_objectSpread({}, formData), {}, {
              kennitala: kennitala
            }));
          }
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumn, {
        sm: {
          width: 12 / 12
        },
        lg: {
          width: 5 / 12,
          offset: 1 / 12
        },
        md: {
          width: 10 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccountInput, {
          onChange: function onChange(withdrawalAccountNumber) {
            return setOrderGiftCardInput(Corporate_objectSpread(Corporate_objectSpread({}, formData), {}, {
              withdrawalAccountNumber: withdrawalAccountNumber
            }));
          },
          labelVariant: "aboveInput",
          variant: "noBorder"
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 10 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Corporate_FormSpacer, {
          smallTop: true
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Name, {
          label: "Nafn tengili\xF0s",
          name: employeeName !== null && employeeName !== void 0 ? employeeName : undefined,
          setName: function setName(employeeName) {
            return setOrderGiftCardInput(Corporate_objectSpread(Corporate_objectSpread({}, formData), {}, {
              employeeName: employeeName
            }));
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumn, {
        sm: {
          width: 12 / 12
        },
        lg: {
          width: 2.5 / 12
        },
        md: {
          width: 5 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneNumber, {
          label: "S\xEDman\xFAmer tengili\xF0s",
          phoneNumber: phoneNumber,
          setPhoneNumber: function setPhoneNumber(phoneNumber) {
            return setOrderGiftCardInput(Corporate_objectSpread(Corporate_objectSpread({}, formData), {}, {
              phoneNumber: phoneNumber
            }));
          }
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Email, {
          label: "Netfang tengili\xF0s",
          email: email,
          setEmail: function setEmail(email) {
            return setOrderGiftCardInput(Corporate_objectSpread(Corporate_objectSpread({}, formData), {}, {
              email: email
            }));
          }
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 10 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Corporate_FormSpacer, {
          smallTop: true
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/Person.tsx



function Person_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Person_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Person_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Person_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var Person_StyledColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e1xlyfcu0"
} : 0)("margin-bottom:", function (props) {
  return props.theme.baseline * 8;
}, "px;" + ( true ? "" : 0));

function PersonForm(_ref) {
  var deliveryPlaceOptions = _ref.deliveryPlaceOptions,
      formData = _ref.formData,
      kennitalaNotFound = _ref.kennitalaNotFound,
      setKennitalaNotFound = _ref.setKennitalaNotFound,
      setOrderGiftCardInput = _ref.setOrderGiftCardInput;
  var numberOfGiftCards = formData.numberOfGiftCards,
      amountOnEachCard = formData.amountOnEachCard,
      name = formData.name,
      kennitala = formData.kennitala,
      phoneNumber = formData.phoneNumber,
      email = formData.email,
      servicePointId = formData.servicePointId;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person_StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberOfCards, {
          numberOfCards: numberOfGiftCards,
          setNumberOfCards: function setNumberOfCards(number) {
            return setOrderGiftCardInput(Person_objectSpread(Person_objectSpread({}, formData), {}, {
              numberOfGiftCards: number
            }));
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person_StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Amount, {
          amount: amountOnEachCard,
          setAmount: function setAmount(amount) {
            return setOrderGiftCardInput(Person_objectSpread(Person_objectSpread({}, formData), {}, {
              amountOnEachCard: amount
            }));
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person_StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Name, {
          name: name,
          label: "Nafn kaupanda",
          setName: function setName(name) {
            return setOrderGiftCardInput(Person_objectSpread(Person_objectSpread({}, formData), {}, {
              name: name
            }));
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person_StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 2.5 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Kennitala, {
          kennitalaNotFound: kennitalaNotFound,
          kennitala: kennitala,
          setKennitala: function setKennitala(kennitala) {
            setKennitalaNotFound(false);
            setOrderGiftCardInput(Person_objectSpread(Person_objectSpread({}, formData), {}, {
              kennitala: kennitala
            }));
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person_StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 2.5 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneNumber, {
          phoneNumber: phoneNumber,
          setPhoneNumber: function setPhoneNumber(phoneNumber) {
            return setOrderGiftCardInput(Person_objectSpread(Person_objectSpread({}, formData), {}, {
              phoneNumber: phoneNumber
            }));
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person_StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Email, {
          email: email,
          setEmail: function setEmail(email) {
            return setOrderGiftCardInput(Person_objectSpread(Person_objectSpread({}, formData), {}, {
              email: email
            }));
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person_StyledColumn, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 5 / 12
        },
        children: deliveryPlaceOptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Location, {
          deliveryPlaceOptions: deliveryPlaceOptions,
          selectedId: servicePointId ? servicePointId : undefined,
          setSelcetedId: function setSelcetedId(id) {
            setOrderGiftCardInput(Person_objectSpread(Person_objectSpread({}, formData), {}, {
              servicePointId: id
            }));
          }
        })
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/Success.tsx


function order_gift_card_Success_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var order_gift_card_Success_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e9e84fy3"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:", function (props) {
  return props.theme.baseline * 7;
}, "px;" + ( true ? "" : 0));

var order_gift_card_Success_StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "e9e84fy2"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var Success_SvgColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e9e84fy1"
} : 0)( true ? {
  name: "1wnowod",
  styles: "display:flex;align-items:center;justify-content:center"
} : 0);

var Success_Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(DatepickerWithCheckmark,  true ? {
  target: "e9e84fy0"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

function Success_Success(_ref) {
  var setStep = _ref.setStep;
  var isDesktop = (0,hooks_useMedia/* useMedia */.G)('lg');
  var ref = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (ref) {
      var _ref$current;

      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
    }
  }, [ref]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      ref: ref,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
        sm: {
          width: 12 / 12
        },
        md: {
          width: 10 / 12,
          offset: 1 / 12
        },
        lg: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormTitle/* FormTitle */.v, {
          text: "P\xF6ntun gjafakorts m\xF3ttekin"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
            sm: {
              width: 12 / 12
            },
            lg: {
              width: 9.8 / 12
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(order_gift_card_Success_Text, {
              children: "Vi\xF0 munum hafa samband til a\xF0 ganga fr\xE1 kaupum og finna t\xEDma sem hentar \xFE\xE9r til afhendingar kortsins. Pantanir \xED desember geta teki\xF0 allt a\xF0 \xFErj\xE1 virka daga \xED afgrei\xF0slu."
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(order_gift_card_Success_StyledButton, {
              title: "Panta anna\xF0 gjafakort",
              bg: theme/* theme.colors.primary */.r.colors.primary,
              onClick: function onClick() {
                return setStep('form');
              }
            })]
          })
        })]
      }), isDesktop && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Success_SvgColumn, {
        md: {
          width: 5 / 12
        },
        lg: {
          width: 6 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Success_Icon, {})
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/gift-card/order-gift-card/OrderGiftCard.tsx



function OrderGiftCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var OrderGiftCard_A = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "er0pczg5"
} : 0)( true ? {
  name: "1wbll7q",
  styles: "text-decoration:underline"
} : 0);

var BlueContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "er0pczg4"
} : 0)("padding-top:", function (props) {
  return props.theme.baseline * 5;
}, "px;background-color:", function (props) {
  return props.theme.shades.primary2;
}, ";&>section{background-color:", function (props) {
  return props.theme.shades.primary2;
}, ";}@media ", devices/* device.tablet */.U.tablet, "{padding-bottom:", function (props) {
  return props.theme.baseline * 26;
}, "px;padding-top:", function (props) {
  return props.theme.baseline * 18;
}, "px;}" + ( true ? "" : 0));

var TitleRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "er0pczg3"
} : 0)("@media ", devices/* device.desktop */.U.desktop, "{margin-bottom:36px;}" + ( true ? "" : 0));

var OrderGiftCard_StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(buttons_Button/* Button */.z,  true ? {
  target: "er0pczg2"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var OrderGiftCard_Host = function Host(_ref) {
  var children = _ref.children;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  if (!isMobile) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlueContainer, {
        children: children
      })
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlueContainer, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
      children: children
    })
  });
};

var OrderGiftCard_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "er0pczg1"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, " margin-bottom:16px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0px;}" + ( true ? "" : 0));

var OrderGiftCard_FormContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "er0pczg0"
} : 0)("margin-bottom:", function (props) {
  return props.theme.baseline * 8;
}, "px;" + ( true ? "" : 0));

var initialFormData = {
  numberOfGiftCards: 1,
  amountOnEachCard: 0,
  name: '',
  kennitala: '',
  phoneNumber: '',
  email: '',
  servicePointId: '',
  description: null,
  employeeName: null,
  withdrawalAccountNumber: null
};
function OrderGiftCard(_ref2) {
  var type = _ref2.type;

  var _useState = (0,react.useState)(initialFormData),
      orderGiftCardInput = _useState[0],
      setOrderGiftCardInput = _useState[1];

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useRegionOptions = useRegionOptions(),
      options = _useRegionOptions.options;

  var _useState2 = (0,react.useState)('form'),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      kennitalaNotFound = _useState3[0],
      setKennitalaNotFound = _useState3[1];

  var _useState4 = (0,react.useState)(undefined),
      deliveryPlacesOptions = _useState4[0],
      setDeliveryPlacesOptions = _useState4[1];

  var orderGiftCardForm = (0,react.useRef)(null);

  var _useMutation = (0,useMutation/* useMutation */.D)(ORDER_GIFT_CARD, {
    client: client,
    onCompleted: function onCompleted(data) {
      if (data.orderGiftCard.__typename === 'CrmCasePayload') {
        setStep('success');
        setOrderGiftCardInput(initialFormData);

        if (orderGiftCardForm !== null && orderGiftCardForm.current !== null) {
          orderGiftCardForm.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }

      if (data.orderGiftCard.__typename === 'KennitalaNotFoundError') {
        setKennitalaNotFound(true);
      }
    }
  }),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 2),
      orderGiftCard = _useMutation2[0],
      loading = _useMutation2[1].loading;

  (0,useQuery/* useQuery */.a)(GIFT_CARD_DELIVERY_PLACES, {
    client: client,
    onCompleted: function onCompleted(data) {
      var branches = data.servicePoints.edges.filter(function (edge) {
        if (type === 'person') {
          return edge.node.id !== 'U2VydmljZVBvaW50OjNiMzVkNWNiLWQzYmUtZWIxMS04MGY0LTAwNTA1NmJlMGNjZA=='; // fyrirtækamiðstöð
        }

        return true;
      });
      var groupedBrances = lodash_groupby_default()(branches, function (b) {
        return b.node.region;
      });
      var places = Object.keys(groupedBrances).map(function (key) {
        var _options$find$label, _options$find;

        return {
          label: (_options$find$label = (_options$find = options.find(function (op) {
            return op.value === globalTypes/* Region */.yp[key];
          })) === null || _options$find === void 0 ? void 0 : _options$find.label) !== null && _options$find$label !== void 0 ? _options$find$label : '',
          options: groupedBrances[key].map(function (item) {
            if (item.node.branches === null) {
              return {
                label: '',
                value: ''
              };
            }

            return {
              label: item.node.branches[0].name,
              value: item.node.branches[0].id
            };
          })
        };
      });
      setDeliveryPlacesOptions(places);
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OrderGiftCard_Host, {
    children: [step === 'form' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form/* Form */.l, {
      ref: orderGiftCardForm,
      onSubmit: function onSubmit() {
        return orderGiftCard({
          variables: {
            data: orderGiftCardInput
          }
        });
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleRow, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
          sm: {
            width: 12 / 12
          },
          md: {
            width: 8 / 12,
            offset: 1 / 12
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormTitle/* FormTitle */.v, {
            text: "Panta gjafakort"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormDescription, {
            children: ["\xDE\xFA getur panta\xF0 gjafakort og s\xF3tt \xED n\xE6sta \xFAtib\xFA. \xDE\xFA getur l\xEDka n\xFDtt \xFE\xE9r gjafakortasj\xE1lfsalana \xED Mj\xF3dd og Vesturb\xE6 sem eru opnir allan s\xF3larhringinn.", type !== 'company' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "Magnpantanir eru ger\xF0ar \xE1", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_link["default"], {
                href: "/fyrirtaeki/kort-og-greidslur/gjafakort",
                passHref: true,
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderGiftCard_A, {
                  children: "gjafakortas\xED\xF0u fyrirt\xE6kja"
                })
              })]
            })]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderGiftCard_FormContainer, {
        children: type === 'company' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CorporateForm, {
          setKennitalaNotFound: setKennitalaNotFound,
          kennitalaNotFound: kennitalaNotFound,
          setOrderGiftCardInput: setOrderGiftCardInput,
          deliveryPlaceOptions: deliveryPlacesOptions,
          formData: orderGiftCardInput
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonForm, {
          setKennitalaNotFound: setKennitalaNotFound,
          kennitalaNotFound: kennitalaNotFound,
          setOrderGiftCardInput: setOrderGiftCardInput,
          deliveryPlaceOptions: deliveryPlacesOptions,
          formData: orderGiftCardInput
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          md: {
            width: 5 / 12,
            offset: 1 / 12
          },
          sm: {
            width: 12 / 12
          },
          align: "center",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderGiftCard_Text, {
            children: "\xC9g sam\xFEykki me\xF0 p\xF6ntuninni a\xF0 framangreindar uppl\xFDsingar s\xE9u unnar \xED samr\xE6mi vi\xF0 pers\xF3nuverndarstefnu bankans."
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
          md: {
            width: 5 / 12
          },
          sm: {
            width: 12 / 12
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderGiftCard_StyledButton, {
            bg: theme/* theme.colors.primary */.r.colors.primary,
            title: "Panta gjafakort",
            loading: loading
          })
        })]
      })]
    }), step === 'success' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Success_Success, {
      setStep: setStep
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/OrderGiftCardContainer.tsx




var OrderGiftCardContainer = function OrderGiftCardContainer(_ref) {
  var type = _ref.type;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    id: "order_gift_card",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reveal/* Reveal */.U, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderGiftCard, {
        type: type
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/ui/src/components/buttons/CardButton.tsx



var CardButton_excluded = ["title", "notLink"];

function CardButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CardButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CardButton_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CardButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function CardButton_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var CardButton_Button = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eyesrka1"
} : 0)("flex:1;display:flex;border:none;background:none;width:100%;cursor:pointer;", typography/* typography.h5 */.cp.h5, " font-family:", function (props) {
  return props.theme.font.family;
}, ";color:", function (props) {
  return props.theme.colors.primary;
}, ";padding-top:12px;padding-bottom:12px;align-items:center;>svg{flex-shrink:0;}" + ( true ? "" : 0));

var ButtonLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CardButton_Button,  true ? {
  target: "eyesrka0"
} : 0)( true ? {
  name: "tadcwa",
  styles: "&:hover{text-decoration:underline;}"
} : 0);

var CardButton = /*#__PURE__*/(0,react.forwardRef)(function CardButton(props, ref) {
  var title = props.title,
      notLink = props.notLink,
      rest = (0,objectWithoutProperties/* default */.Z)(props, CardButton_excluded);

  var content = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
      width: "16",
      height: "12",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        marginTop: -4,
        marginRight: 10
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
        fill: "none",
        fillRule: "evenodd",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
          stroke: "currentColor",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M9.395 1.665l5.32 4.655-5.32 4.655"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            strokeLinejoin: "round",
            d: "M14.05 6.32H.75"
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
      children: title
    })]
  });

  if (notLink) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardButton_Button, CardButton_objectSpread(CardButton_objectSpread({
      ref: ref
    }, rest), {}, {
      children: content
    }));
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonLink, CardButton_objectSpread(CardButton_objectSpread({
    as: "a",
    ref: ref,
    title: title
  }, rest), {}, {
    children: content
  }));
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/card-group/OtherCardGroup.tsx





var OtherCardGroup_Group = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qmgj0w0"
} : 0)(">*{margin-bottom:2em;}>*:last-child{margin-bottom:0;}@media ", devices/* device.tablet */.U.tablet, "{display:", function (_ref) {
  var isSingleFeatured = _ref.isSingleFeatured;
  return isSingleFeatured ? 'block' : '-ms-grid';
}, ";display:", function (_ref2) {
  var isSingleFeatured = _ref2.isSingleFeatured;
  return isSingleFeatured ? 'block' : 'grid';
}, ";grid-template-columns:", function (_ref3) {
  var featured = _ref3.featured,
      isSingleFeatured = _ref3.isSingleFeatured;
  return featured ? '2fr 1fr' : isSingleFeatured ? '1fr' : '1fr 1fr 1fr';
}, ";-ms-grid-columns:", function (_ref4) {
  var featured = _ref4.featured,
      isSingleFeatured = _ref4.isSingleFeatured;
  return featured ? '2fr 20px 1fr' : isSingleFeatured ? '1fr' : '1fr 20px 1fr 20px 1fr';
}, ";grid-template-rows:", function (_ref5) {
  var featured = _ref5.featured;
  return featured ? '1fr 1fr' : '1fr';
}, ";-ms-grid-rows:", function (_ref6) {
  var featured = _ref6.featured;
  return featured ? '1fr 0 1fr' : '1fr';
}, ";grid-template-areas:", function (_ref7) {
  var featured = _ref7.featured;
  return featured ? "\"featured item2\"\n    \"featured2 item3\"" : 'item1 item2 item3';
}, ";grid-gap:0 20px;>*:first-child{grid-area:", function (_ref8) {
  var featured = _ref8.featured,
      isSingleFeatured = _ref8.isSingleFeatured;
  return featured || isSingleFeatured ? 'featured' : 'item1';
}, ";-ms-grid-row:1;-ms-grid-column:1;}>*:nth-child(2){grid-area:", function (_ref9) {
  var featured = _ref9.featured;
  return featured ? 'featured2' : 'item2';
}, ";-ms-grid-row:", function (_ref10) {
  var featured = _ref10.featured;
  return featured ? '3' : '1';
}, ";-ms-grid-column:", function (_ref11) {
  var featured = _ref11.featured;
  return featured ? '1' : '3';
}, ";}>*:nth-child(3){-ms-grid-row:1;-ms-grid-column:", function (_ref12) {
  var featured = _ref12.featured;
  return featured ? '3' : '5';
}, ";grid-area:", function (_ref13) {
  var featured = _ref13.featured;
  return featured ? 'item2' : 'auto';
}, ";}>*:nth-child(4){-ms-grid-row:", function (_ref14) {
  var featured = _ref14.featured;
  return featured ? '3' : 'auto';
}, ";-ms-grid-column:", function (_ref15) {
  var featured = _ref15.featured;
  return featured ? '3' : 'auto';
}, ";grid-area:", function (_ref16) {
  var featured = _ref16.featured;
  return featured ? 'item3' : 'auto';
}, ";}>*:last-child{margin-bottom:30px;}}" + ( true ? "" : 0));

var OtherCardGroup = function OtherCardGroup(_ref17) {
  var children = _ref17.children,
      featured = _ref17.featured,
      isSingleFeatured = _ref17.isSingleFeatured;

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCardGroup_Group, {
    featured: featured,
    isSingleFeatured: isSingleFeatured,
    ref: ref,
    children: itemsWithStyleProp
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/HorizontalOtherCard.tsx


var HorizontalOtherCard_excluded = ["title", "description", "image", "ar", "action", "isSplittedCard"];






var HorizontalOtherCard_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e248soq5"
} : 0)("display:flex;flex-flow:row nowrap;justify-content:flex-start;position:relative;width:100%;background-color:", function (props) {
  return props.theme.colors.background;
}, ";" + ( true ? "" : 0));

var Overflow = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e248soq4"
} : 0)("margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-bottom:36px;", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{overflow:hidden;height:100%;margin:0;>*{height:100%;}}" + ( true ? "" : 0));

var HorizontalOtherCard_Body = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e248soq3"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{display:flex;padding:0 35px;height:100%;flex-flow:column;justify-content:center;}" + ( true ? "" : 0));

var HorizontalOtherCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e248soq2"
} : 0)(typography/* typography.h3 */.cp.h3, ";margin-bottom:30px;@media ", devices/* device.tablet */.U.tablet, "{margin-top:auto;}" + ( true ? "" : 0));

var HorizontalOtherCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e248soq1"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:30px;" + ( true ? "" : 0));

var HorizontalOtherCard_CardAction = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e248soq0"
} : 0)("padding-top:20px;border-top:1px solid ", function (props) {
  return props.theme.colors.primary;
}, ";@media ", devices/* device.tablet */.U.tablet, "{margin-top:auto;}" + ( true ? "" : 0));

var HorizontalOtherCard = /*#__PURE__*/(0,react.forwardRef)(function HOCard(_ref, ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image,
      ar = _ref.ar,
      action = _ref.action,
      isSplittedCard = _ref.isSplittedCard,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, HorizontalOtherCard_excluded);

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  var aspectRatio = isMobile ? 'ar_1_1' : ar;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalOtherCard_Host, {
    ref: ref,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 6 / 12
        },
        lg: {
          width: 8 / 12
        },
        children: !!image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overflow, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
            src: image,
            ar: aspectRatio
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 6 / 12
        },
        lg: {
          width: 4 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HorizontalOtherCard_Body, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalOtherCard_Title, {
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalOtherCard_Copy, {
            children: description
          }), !!action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalOtherCard_CardAction, {
            children: action
          })]
        })
      })]
    })
  });
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/OtherCard.tsx



function OtherCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function OtherCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { OtherCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { OtherCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function OtherCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var OtherCard_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1pb11l7"
} : 0)("display:flex;flex-flow:column nowrap;justify-content:flex-start;position:relative;width:100%;background-color:", function (props) {
  return props.theme.colors.background;
}, ";cursor:pointer;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:30px;}" + ( true ? "" : 0));

var ImageLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(OtherCard_Host,  true ? {
  target: "e1pb11l6"
} : 0)("margin-bottom:0;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0;}&:after{content:'';height:20px;width:100%;position:absolute;bottom:-20px;left:0;right:0;}" + ( true ? "" : 0));

var OtherCard_Overflow = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1pb11l5"
} : 0)("overflow:hidden;margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-bottom:2em;", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{margin:0;}" + ( true ? "" : 0));

var ImgWrap = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1pb11l4"
} : 0)( true ? {
  name: "kwjnie",
  styles: "height:100%;transform:scale(1);>*:first-child{height:100%;}"
} : 0);

var OtherCard_Body = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1pb11l3"
} : 0)( true ? "" : 0);

var OtherCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1pb11l2"
} : 0)(typography/* typography.h3 */.cp.h3, ";margin-bottom:30px;@media ", devices/* device.tablet */.U.tablet, "{margin-top:40px;}" + ( true ? "" : 0));

var OtherCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1pb11l1"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:40px;" + ( true ? "" : 0));

var OtherCard_CardAction = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1pb11l0"
} : 0)("border-top:1px solid ", function (props) {
  return props.theme.colors.primary;
}, ";margin-top:auto;" + ( true ? "" : 0));

var OtherCard = /*#__PURE__*/(0,react.forwardRef)(function OCard(_ref, ref) {
  var link = _ref.link,
      title = _ref.title,
      description = _ref.description,
      image = _ref.image,
      ar = _ref.ar,
      action = _ref.action,
      isSplittedCard = _ref.isSplittedCard,
      style = _ref.style;
  var router = (0,next_router.useRouter)();

  var _useContext = (0,react.useContext)(prismicContext/* PrismicContext */.Z),
      urlResolver = _useContext.urlResolver;

  var url = Prismic/* Prismic.link */.X5.link(urlResolver, link);

  var _useState = (0,react.useState)(false),
      isHover = _useState[0],
      setHover = _useState[1];

  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  var onHover = (0,react_spring_esm.useSpring)({
    transform: isHover ? 'scale(1.025)' : 'scale(1)'
  });

  var onClick = function onClick(e) {
    var _window, _window$getSelection, _window$getSelection$;

    if (((_window = window) === null || _window === void 0 ? void 0 : (_window$getSelection = _window.getSelection) === null || _window$getSelection === void 0 ? void 0 : (_window$getSelection$ = _window$getSelection.call(_window)) === null || _window$getSelection$ === void 0 ? void 0 : _window$getSelection$.type) === 'Range') {
      e.preventDefault();
      return false;
    }

    return router.push(url.href, url.as);
  };

  var aspectRatio = isMobile ? 'ar_1_1' : ar;

  if (isSplittedCard) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [!!image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageLink, {
        ref: ref,
        tabIndex: -1,
        onMouseOver: function onMouseOver() {
          return setHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setHover(false);
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard_Overflow, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImgWrap, {
            style: OtherCard_objectSpread({}, onHover),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
              src: image,
              ar: aspectRatio
            })
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OtherCard_Host, {
        style: style,
        ref: ref,
        onMouseOver: function onMouseOver() {
          return setHover(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setHover(false);
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard_Title, {
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard_Body, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard_Copy, {
            children: description
          })
        }), !!action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard_CardAction, {
          children: action
        })]
      })]
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OtherCard_Host, {
    ref: ref,
    onMouseOver: function onMouseOver() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: onClick,
    style: style,
    children: [!!image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard_Overflow, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImgWrap, {
        style: OtherCard_objectSpread({}, onHover),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
          src: image,
          ar: aspectRatio
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard_Title, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard_Body, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard_Copy, {
        children: description
      })
    }), !!action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard_CardAction, {
      children: action
    })]
  });
});
;// CONCATENATED MODULE: ../../packages/slices/src/containers/slices.res.ts
/* harmony default export */ var slices_res = ({
  readMore: {
    is: 'Lesa nánar'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/containers/OtherCardsContainer.tsx


var OtherCardsContainer_excluded = ["image", "title", "copy", "link", "link_text", "ar", "isSplittedCard", "isSingleFeatured"],
    OtherCardsContainer_excluded2 = ["ar"],
    _excluded3 = ["ar"];

function OtherCardsContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function OtherCardsContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { OtherCardsContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { OtherCardsContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var OtherCardItem = function OtherCardItem(_ref) {
  var _linkdata$title, _linkdata$title3, _linkdata$abstract2, _linkdata$image2;

  var image = _ref.image,
      title = _ref.title,
      copy = _ref.copy,
      link = _ref.link,
      link_text = _ref.link_text,
      ar = _ref.ar,
      isSplittedCard = _ref.isSplittedCard,
      isSingleFeatured = _ref.isSingleFeatured,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, OtherCardsContainer_excluded);

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var linkText = (0,fallback/* fallbackText */.mn)(link_text, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined) || r(slices_res.readMore);

  if (isSingleFeatured) {
    var _linkdata$title2, _linkdata$abstract, _linkdata$image;

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalOtherCard, OtherCardsContainer_objectSpread({
      title: (0,fallback/* fallbackText */.mn)(title, (_linkdata$title2 = linkdata.title) !== null && _linkdata$title2 !== void 0 ? _linkdata$title2 : undefined),
      description: (0,fallback/* fallbackRichText */.K8)(copy, (_linkdata$abstract = linkdata.abstract) !== null && _linkdata$abstract !== void 0 ? _linkdata$abstract : undefined),
      image: (0,fallback/* fallbackImage */.bU)(image, (_linkdata$image = linkdata.image) !== null && _linkdata$image !== void 0 ? _linkdata$image : undefined),
      ar: ar,
      isSplittedCard: true,
      action: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
        value: link,
        title: linkText,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowButton/* ArrowButton */.b, {
          title: linkText,
          isSmall: true
        })
      })
    }, rest));
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCard, OtherCardsContainer_objectSpread({
    link: link,
    title: (0,fallback/* fallbackText */.mn)(title, (_linkdata$title3 = linkdata.title) !== null && _linkdata$title3 !== void 0 ? _linkdata$title3 : undefined),
    description: (0,fallback/* fallbackRichText */.K8)(copy, (_linkdata$abstract2 = linkdata.abstract) !== null && _linkdata$abstract2 !== void 0 ? _linkdata$abstract2 : undefined),
    image: (0,fallback/* fallbackImage */.bU)(image, (_linkdata$image2 = linkdata.image) !== null && _linkdata$image2 !== void 0 ? _linkdata$image2 : undefined),
    ar: ar,
    isSplittedCard: isSplittedCard,
    action: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
      value: link,
      title: linkText,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardButton, {
        title: linkText
      })
    })
  }, rest));
};

var OtherCardsContainer = function OtherCardsContainer(_ref2) {
  var fields = _ref2.fields,
      featured = _ref2.featured;
  var items = fields === null || fields === void 0 ? void 0 : fields.filter(function (_ref3) {
    var link = _ref3.link;
    return link;
  });

  if (items.length === 0) {
    return null;
  }

  var count = fields.length;
  var isSingleFeatured = fields.length === 1;
  var columns = count <= 2 ? 2 : 3;

  if (featured === true && count === 3 || isSingleFeatured) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCardGroup, {
        featured: featured,
        isSingleFeatured: isSingleFeatured,
        children: items.map(function (_ref4, index) {
          var ar = _ref4.ar,
              rest = (0,objectWithoutProperties/* default */.Z)(_ref4, OtherCardsContainer_excluded2);

          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCardItem, OtherCardsContainer_objectSpread({
            ar: featured && index === 0 ? 'ar_1_1' : featured && index === 1 ? 'ar_16_9' : 'ar_4_3',
            isSplittedCard: !!featured && index === 0,
            isSingleFeatured: isSingleFeatured
          }, rest), "other-card-item-".concat(index));
        })
      })
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardGroup, {
      columns: columns,
      children: items.map(function (_ref5, index) {
        var ar = _ref5.ar,
            rest = (0,objectWithoutProperties/* default */.Z)(_ref5, _excluded3);

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCardItem, OtherCardsContainer_objectSpread({
          ar: featured && index === 0 ? 'ar_1_1' : featured && index === 1 ? 'ar_16_9' : 'ar_4_3',
          isSplittedCard: false,
          isSingleFeatured: false
        }, rest), "other-card-item-".concat(index));
      })
    })
  });
};
// EXTERNAL MODULE: ../../packages/prismic/src/InlineExpression.tsx
var InlineExpression = __webpack_require__(20279);
;// CONCATENATED MODULE: ../../packages/slices/src/components/info-card/InfoCard.tsx


function InfoCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var InfoCard_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  target: "epiymir11"
} : 0)("padding:45px 20px;margin:", function (props) {
  return "6em -".concat(props.theme.containerGutter, "px 6em");
}, ";background-color:", function (props) {
  return props.theme.colors.backgroundAlt;
}, ";", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{padding:45px;margin:20px 0;}" + ( true ? "" : 0));

var Spacer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epiymir10"
} : 0)("padding-bottom:40px;@media ", devices/* device.tablet */.U.tablet, "{padding-bottom:0;}" + ( true ? "" : 0));

var InfoCard_ImageWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epiymir9"
} : 0)("margin-top:-100px;@media ", devices/* device.tablet */.U.tablet, "{position:relative;top:0;left:0;max-width:auto;margin:0 -25px 0 -45px;margin-bottom:-50px;}@media ", devices/* device.desktop */.U.desktop, "{margin:0 -25px 0 -45px;}" + ( true ? "" : 0));

var InfoCard_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epiymir8"
} : 0)( true ? {
  name: "g46w8s",
  styles: "margin-bottom:30px"
} : 0);

var InfoCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "epiymir7"
} : 0)(typography/* typography.h3 */.cp.h3, ";" + ( true ? "" : 0));

var InfoCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epiymir6"
} : 0)( true ? "" : 0);

var InfoCard_Table = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epiymir5"
} : 0)("border-top:", function (props) {
  return "1px solid ".concat(props.theme.colors.foreground);
}, ";" + ( true ? "" : 0));

var InfoCard_Item = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epiymir4"
} : 0)("display:flex;flex-wrap:row nowrap;justify-content:space-between;padding:11px 0 9px;border-bottom:", function (props) {
  return "1px solid ".concat(props.theme.colors.foreground);
}, ";" + ( true ? "" : 0));

var InfoCard_Link = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "epiymir3"
} : 0)( true ? {
  name: "dfxwzd",
  styles: "&:hover p{text-decoration:underline;}"
} : 0);

var ItemSubTitle = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "epiymir2"
} : 0)( true ? {
  name: "2qga7i",
  styles: "text-align:right"
} : 0);

var PointsHost = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epiymir1"
} : 0)( true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0);

var Point = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epiymir0"
} : 0)("width:13px;height:13px;margin-left:9px;background-color:", function (props) {
  return props.filled ? props.theme.colors.primary : 'transparent';
}, ";border-radius:20px;border:1px solid ", function (props) {
  return props.theme.colors.primary;
}, ";" + ( true ? "" : 0));

var Points = function Points(_ref) {
  var number = _ref.number;
  var count = Number(number);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PointsHost, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Point, {
      filled: count > 0
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Point, {
      filled: count > 1
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Point, {
      filled: count > 2
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Point, {
      filled: count > 3
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Point, {
      filled: count > 4
    })]
  });
};

var InfoCard = function InfoCard(_ref2) {
  var image = _ref2.image,
      ar = _ref2.ar,
      title = _ref2.title,
      copy = _ref2.copy,
      children = _ref2.children,
      insurance = _ref2.insurance,
      link = _ref2.link;
  var isImage = image;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoCard_Host, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [isImage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 4 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spacer, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoCard_ImageWrap, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
              src: image,
              ar: ar,
              percentage: 0.33
            })
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: !isImage ? 7 / 12 : 3 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoCard_Text, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoCard_Title, {
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoCard_Copy, {
            children: copy
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 4 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoCard_Table, {
          children: [insurance !== '0' && // eslint-disable-next-line react/jsx-no-undef
          (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
            value: link,
            title: "Fer\xF0atryggingar",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoCard_Link, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoCard_Item, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                  children: "Fer\xF0atryggingar"
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Points, {
                  number: insurance
                })]
              })
            })
          }), children]
        })
      })]
    })
  });
};
var ListItem = function ListItem(_ref3) {
  var _Prismic$text;

  var title = _ref3.title,
      subtitle = _ref3.subtitle;
  var source = (0,InlineExpression/* useInlineExpressions */.kP)((_Prismic$text = Prismic/* Prismic.text */.X5.text(subtitle)) !== null && _Prismic$text !== void 0 ? _Prismic$text : undefined);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoCard_Item, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemSubTitle, {
      children: source
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/PaymentCardInfoContainer.tsx






var PaymentCardInfoContainer = function PaymentCardInfoContainer(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      image = _ref.image,
      insurance = _ref.insurance,
      terms = _ref.terms,
      fields = _ref.fields;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* Container */.W, {
    className: 'payment-info',
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoCard, {
      image: image,
      ar: "card",
      title: Prismic/* Prismic.text */.X5.text(title),
      copy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy
      }),
      insurance: insurance,
      link: terms,
      children: !lodash_isempty_default()(fields) && fields.map(function (_ref2, i) {
        var first_text = _ref2.first_text,
            second_text = _ref2.second_text;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
          title: Prismic/* Prismic.text */.X5.text(first_text),
          subtitle: second_text
        }, "".concat(i, "-").concat(Prismic/* Prismic.text */.X5.text(first_text)));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/Points.tsx





var Points_Right = Column/* Column.withComponent */.s.withComponent('aside',  true ? {
  target: "exonhzc4"
} : 0);

var Points_Heading = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "exonhzc3"
} : 0)(typography/* typography.h2 */.cp.h2, " padding-top:14px;padding-bottom:32px;" + ( true ? "" : 0));

var Points_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "exonhzc2"
} : 0)("padding-right:32px;margin-bottom:", function (props) {
  return props.theme.breakpoints.sm.gutter;
}, "px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0;}" + ( true ? "" : 0));

var Points_Top = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "exonhzc1"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:64px;}" + ( true ? "" : 0));

var Points_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  target: "exonhzc0"
} : 0)("background:", function (props) {
  return props.theme.colors.backgroundAlt;
}, ";margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{margin:0;}" + ( true ? "" : 0));

var Points_Points = function Points(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      featured = _ref.featured,
      children = _ref.children,
      isGray = _ref.isGray;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Points_Host, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Segment/* Segment */.X, {
      isGray: isGray,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Points_Top, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
            md: {
              width: 8 / 12
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Points_Heading, {
              children: title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Points_Copy, {
              children: copy
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Points_Right, {
            md: {
              width: 4 / 12
            },
            children: featured
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
        children: children
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/PointsContainer.tsx







var PointsContainer = function PointsContainer(_ref) {
  var title = _ref.title,
      text = _ref.text,
      featured_point_title = _ref.featured_point_title,
      featured_point_text = _ref.featured_point_text,
      fields = _ref.fields,
      template = _ref.template,
      isgray = _ref.isgray;
  var isArticle = template === 'article';

  var renderFeaturedItem = function renderFeaturedItem() {
    if ((0,isEmptyText/* isEmptyText */.W)(featured_point_title)) {
      return null;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card, {
      title: Prismic/* Prismic.text */.X5.text(featured_point_title),
      description: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: featured_point_text,
        isArticle: isArticle
      }),
      notLink: true,
      padding: false,
      backgroundAlt: true
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Points_Points, {
      title: Prismic/* Prismic.text */.X5.text(title),
      copy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: text,
        isArticle: isArticle
      }),
      featured: renderFeaturedItem(),
      isGray: isgray,
      children: fields.length && fields.map(function (_ref2, i) {
        var title = _ref2.title,
            text = _ref2.text;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            md: {
              width: 4 / 12
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card, {
              title: Prismic/* Prismic.text */.X5.text(title),
              description: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
                value: text,
                isArticle: isArticle
              }),
              notLink: true,
              padding: false,
              backgroundAlt: true
            })
          }), fields.length < 5 && i % 2 === 1 && fields.length !== 3 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            md: {
              width: 4 / 12
            }
          }) : null]
        }, "point-".concat(i));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card-group/FeaturedGroup.tsx





var FeaturedGroup_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eogzsvr0"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{display:-ms-grid;display:grid;grid-template-columns:", function (props) {
  return props.align === 'Left' ? '2fr 1fr' : '1fr 2fr';
}, ";-ms-grid-columns:", function (props) {
  return props.align === 'Left' ? '2fr 20px 1fr' : '1fr 20px 2fr';
}, ";grid-template-rows:0.5fr 0.5fr 0.5fr 0.5fr;-ms-grid-rows:0.5fr 20px 0.5fr 20px 0.5fr 20px 0.5fr;gap:20px 20px;grid-template-areas:", function (props) {
  return props.align === 'Left' ? "\n      'item1 item3'\n      'item1 item4'\n      'item1 item5'\n      'item2 item6'" : "\n      'item3 item1'\n      'item4 item1'\n      'item5 item1'\n      'item6 item2'\n      ";
}, ";>*:first-child{", function (props) {
  return props.align === 'Left' ? "-ms-grid-row: 1;\n            -ms-grid-row-span: 5;\n            -ms-grid-column: 1;" : "-ms-grid-row: 1;\n            -ms-grid-row-span: 5;\n            -ms-grid-column: 3;";
}, " grid-area:item1;}>*:nth-child(2){", function (props) {
  return props.align === 'Left' ? "-ms-grid-row:7;\n            -ms-grid-column:1;" : "-ms-grid-row:7;\n            -ms-grid-column:3;";
}, " grid-area:item2;}>*:nth-child(3){", function (props) {
  return props.align === 'Left' ? "-ms-grid-row:1;\n            -ms-grid-column:3;" : "-ms-grid-row:1;\n            -ms-grid-column:1;";
}, " grid-area:item3;}>*:nth-child(4){", function (props) {
  return props.align === 'Left' ? "-ms-grid-row:3;\n            -ms-grid-column:3;" : "-ms-grid-row:3;\n            -ms-grid-column:1;";
}, " grid-area:item4;}>*:nth-child(5){", function (props) {
  return props.align === 'Left' ? "-ms-grid-row:5;\n            -ms-grid-column:3;" : "-ms-grid-row:5;\n            -ms-grid-column:1;";
}, " grid-area:item5;}>*:nth-child(6){", function (props) {
  return props.align === 'Left' ? "-ms-grid-row:7;\n            -ms-grid-column:3;" : "-ms-grid-row:7;\n            -ms-grid-column:1;";
}, " grid-area:item6;}}@media ", devices/* device.desktop */.U.desktop, "{grid-template-rows:1fr 0.5fr 1fr 0.5fr;-ms-grid-rows:1fr 20px 0.5fr 20px 1fr 20px 0.5fr;}" + ( true ? "" : 0));

var FeaturedGroup = function FeaturedGroup(_ref) {
  var children = _ref.children,
      align = _ref.align;

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedGroup_Host, {
    ref: ref,
    align: align,
    children: itemsWithStyleProp
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/SplitedCard.tsx



var SplitedCard_excluded = (/* unused pure expression or super */ null && (["children", "hover"])),
    SplitedCard_excluded2 = ["link", "title", "description", "image", "ar", "action", "imageAspect", "imageRef", "notLink", "isFeatured", "onMouseEnter", "onMouseLeave"];

function SplitedCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SplitedCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SplitedCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SplitedCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SplitedCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var SplitedCard_CardHostLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1x220aj7"
} : 0)("display:block;position:relative;width:100%;cursor:pointer;margin-bottom:4em;&:last-of-type{margin-bottom:2em;}@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0;&:last-of-type{margin-bottom:0;}}" + ( true ? "" : 0));

var SplitedCard_ImageLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SplitedCard_CardHostLink,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1x220aj6"
} : 0)("margin-bottom:36px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0;}&:after{content:'';height:20px;width:100%;position:absolute;bottom:-20px;left:0;right:0;}" + ( true ? "" : 0));

var SplitedCard_Overflow = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x220aj5"
} : 0)("height:100%;margin:", function (props) {
  return "0 -".concat(props.theme.containerGutter, "px");
}, ";overflow:hidden;", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{margin:0;}" + ( true ? "" : 0));

var SplitedCard_ImgWrap = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1x220aj4"
} : 0)( true ? {
  name: "kwjnie",
  styles: "height:100%;transform:scale(1);>*:first-child{height:100%;}"
} : 0);

var SplitedCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1x220aj3"
} : 0)(typography/* typography.h3 */.cp.h3, ";margin-bottom:3px;" + ( true ? "" : 0));

var SplitedCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x220aj2"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:24px;@media ", devices/* device.tablet */.U.tablet, "{padding-right:28px;}@media ", devices/* device.desktop */.U.desktop, "{padding-right:", function (props) {
  return props.isFeatured ? '200px' : '28px';
}, ";}" + ( true ? "" : 0));

var SplitedCard_ActionSpace = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x220aj1"
} : 0)( true ? {
  name: "sem7hj",
  styles: "position:relative;opacity:0;pointer-events:none"
} : 0);

var SplitedCard_ActionPosition = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x220aj0"
} : 0)( true ? {
  name: "1ndduzd",
  styles: "display:flex;flex-direction:row;position:absolute;bottom:0;left:0;right:0"
} : 0);

var SplitedCard_CardAction = function CardAction(_ref) {
  var children = _ref.children,
      hover = _ref.hover,
      rest = _objectWithoutProperties(_ref, SplitedCard_excluded);

  return _jsxs(_Fragment, {
    children: [_jsx(SplitedCard_ActionSpace, {
      children: children
    }), _jsx(SplitedCard_ActionPosition, {
      children: /*#__PURE__*/cloneElement(Children.only(children), SplitedCard_objectSpread({
        hover: hover
      }, rest), SplitedCard_objectSpread({}, children))
    })]
  });
};
var SplittedCard = /*#__PURE__*/(0,react.forwardRef)(function CardFn(props, ref) {
  var link = props.link,
      title = props.title,
      description = props.description,
      image = props.image,
      _props$ar = props.ar,
      ar = _props$ar === void 0 ? 'ar_16_9' : _props$ar,
      action = props.action,
      imageAspect = props.imageAspect,
      imageRef = props.imageRef,
      notLink = props.notLink,
      isFeatured = props.isFeatured,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      rest = (0,objectWithoutProperties/* default */.Z)(props, SplitedCard_excluded2);

  var router = (0,next_router.useRouter)();

  var _useContext = (0,react.useContext)(prismicContext/* PrismicContext */.Z),
      urlResolver = _useContext.urlResolver;

  var url = Prismic/* Prismic.link */.X5.link(urlResolver, link);

  var _useState = (0,react.useState)(false),
      hover = _useState[0],
      setHover = _useState[1];

  var onHover = (0,react_spring_esm.useSpring)({
    transform: hover ? 'scale(1.025)' : 'scale(1)'
  });

  var onEnter = function onEnter(e) {
    setHover(true);

    if (onMouseEnter) {
      onMouseEnter(e);
    }
  };

  var onLeave = function onLeave(e) {
    setHover(false);

    if (onMouseLeave) {
      onMouseLeave(e);
    }
  };

  var onClick = function onClick(e) {
    var _window, _window$getSelection, _window$getSelection$, _url$href;

    if (((_window = window) === null || _window === void 0 ? void 0 : (_window$getSelection = _window.getSelection) === null || _window$getSelection === void 0 ? void 0 : (_window$getSelection$ = _window$getSelection.call(_window)) === null || _window$getSelection$ === void 0 ? void 0 : _window$getSelection$.type) === 'Range') {
      e.preventDefault();
      return false;
    }

    return router.push((_url$href = url.href) !== null && _url$href !== void 0 ? _url$href : '', url.as);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SplitedCard_ImageLink, SplitedCard_objectSpread(SplitedCard_objectSpread({
      ref: ref
    }, rest), {}, {
      onMouseLeave: onLeave,
      onMouseEnter: onEnter,
      onClick: onClick,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SplitedCard_Overflow, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SplitedCard_ImgWrap, {
          style: SplitedCard_objectSpread({}, onHover),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
            src: image,
            ar: ar,
            aspectRatio: imageAspect,
            ref: imageRef,
            percentage: isFeatured ? 0.86 : 0.33
          })
        })
      })
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SplitedCard_CardHostLink, SplitedCard_objectSpread(SplitedCard_objectSpread({
      ref: ref
    }, rest), {}, {
      onMouseOver: function onMouseOver() {
        return setHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(false);
      },
      onClick: onClick,
      children: [!!title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SplitedCard_Title, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
          value: link,
          title: title,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            children: title
          })
        })
      }), !!title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SplitedCard_Copy, {
        isFeatured: isFeatured,
        children: description
      })]
    }))]
  });
});
;// CONCATENATED MODULE: ../../packages/slices/src/containers/ProductCardsContainer.tsx


var ProductCardsContainer_excluded = ["image", "heading", "copy", "link", "count", "video"],
    ProductCardsContainer_excluded2 = ["isFeatured"];

function ProductCardsContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ProductCardsContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductCardsContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductCardsContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var SplittedItem = /*#__PURE__*/(0,react.forwardRef)(function CardItem(_ref, ref) {
  var _linkdata$title, _linkdata$abstract, _linkdata$image;

  var image = _ref.image,
      heading = _ref.heading,
      copy = _ref.copy,
      link = _ref.link,
      isFeatured = _ref.isFeatured,
      style = _ref.style;
  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var title = (0,fallback/* fallbackText */.mn)(heading, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);
  var imageRef = (0,react.useRef)();
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SplittedCard, {
    link: link,
    imageRef: imageRef,
    title: title,
    description: (0,fallback/* fallbackRichText */.K8)(copy, (_linkdata$abstract = linkdata.abstract) !== null && _linkdata$abstract !== void 0 ? _linkdata$abstract : undefined),
    action: link && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowButton/* ArrowButton */.b, {
      hideText: true
    }),
    image: (0,fallback/* fallbackImage */.bU)(image, (_linkdata$image = linkdata.image) !== null && _linkdata$image !== void 0 ? _linkdata$image : undefined),
    padding: false,
    notLink: !link,
    ar: isFeatured ? 'ar_1_1' : isMobile ? 'ar_1_1' : 'ar_4_3',
    imageAspect: isFeatured ? 1 / 1 : isMobile ? 1 / 1 : 4 / 3,
    style: style,
    isFeatured: isFeatured
  });
});
var ProductCardsContainer_CardItem = /*#__PURE__*/(0,react.forwardRef)(function CardItem(_ref2, ref) {
  var _linkdata$title2, _linkdata$abstract2, _linkdata$image2;

  var image = _ref2.image,
      heading = _ref2.heading,
      copy = _ref2.copy,
      link = _ref2.link,
      count = _ref2.count,
      video = _ref2.video,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, ProductCardsContainer_excluded);

  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var title = (0,fallback/* fallbackText */.mn)(heading, (_linkdata$title2 = linkdata.title) !== null && _linkdata$title2 !== void 0 ? _linkdata$title2 : undefined);
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card, ProductCardsContainer_objectSpread({
    link: link,
    title: link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
      value: link,
      title: title !== null && title !== void 0 ? title : undefined,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        children: title
      })
    }) : title,
    description: (0,fallback/* fallbackRichText */.K8)(copy, (_linkdata$abstract2 = linkdata.abstract) !== null && _linkdata$abstract2 !== void 0 ? _linkdata$abstract2 : undefined),
    image: (0,fallback/* fallbackImage */.bU)(image, (_linkdata$image2 = linkdata.image) !== null && _linkdata$image2 !== void 0 ? _linkdata$image2 : undefined),
    ar: count === 2 ? 'ar_1_1' : isMobile ? 'ar_1_1' : 'ar_4_3',
    percentage: 1 / Math.min(3, count),
    padding: false,
    notLink: !link,
    moreBodySpace: count === 2,
    imageAspect: count === 2 ? 1 / 1 : isMobile ? 1 / 1 : 4 / 3,
    video: video
  }, rest));
});
var ProductCardsContainer = function ProductCardsContainer(_ref3) {
  var featured = _ref3.featured,
      align = _ref3.align,
      fields = _ref3.fields,
      four_in_row = _ref3.four_in_row;

  if (!fields) {
    return null;
  }

  var count = fields.length;
  var colSize = four_in_row ? 4 : count <= 2 || count === 4 ? 2 : 3; // rendering featured layout left or right aligned

  if (featured === true && count === 3) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
      paddingBottomMobile: 0,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedGroup, {
        align: align,
        children: fields === null || fields === void 0 ? void 0 : fields.map(function (_ref4, index) {
          var isFeatured = _ref4.isFeatured,
              rest = (0,objectWithoutProperties/* default */.Z)(_ref4, ProductCardsContainer_excluded2);

          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SplittedItem, ProductCardsContainer_objectSpread({
            isFeatured: featured && index === 0
          }, rest), "splitted-item-".concat(index));
        })
      })
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    paddingBottomMobile: 0,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardGroup, {
      columns: colSize,
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductCardsContainer_CardItem, ProductCardsContainer_objectSpread(ProductCardsContainer_objectSpread({}, item), {}, {
          count: count
        }), "product-item-".concat(index));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/QuartersContainer.res.ts
/* harmony default export */ var QuartersContainer_res = ({
  getAllDocument: {
    is: 'Sækja öll skjöl',
    en: 'Download all documents'
  },
  quarter: {
    is: 'F',
    en: 'Q'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/containers/QuartersContainer.tsx



var QuartersContainer_excluded = ["copy", "link", "number"],
    QuartersContainer_excluded2 = ["children"];

function QuartersContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function QuartersContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { QuartersContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { QuartersContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var QuartersContainer_CardItem = function CardItem(_ref) {
  var copy = _ref.copy,
      link = _ref.link,
      number = _ref.number,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, QuartersContainer_excluded);

  var copyText = (0,isEmptyText/* isEmptyText */.W)(copy) ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
    value: copy
  });

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var linkText = r(QuartersContainer_res.getAllDocument);
  var quarter = r(QuartersContainer_res.quarter);
  var action = link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link,
    title: linkText,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowButton/* ArrowButton */.b, {
      title: linkText,
      isSmall: true,
      isArrowDown: true
    })
  }) : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard, QuartersContainer_objectSpread({
    number: "".concat(number).concat(quarter),
    copy: copyText,
    action: action,
    isSplitterLong: true,
    cols: 3,
    pointColor: "Auto",
    pointsType: "Numbers"
  }, rest));
};

var ItemsRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e195lh5j0"
} : 0)("margin-bottom:-2em;>*{margin-bottom:2em;}@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:-4em;>*{margin-bottom:0;}}" + ( true ? "" : 0));

var copy = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
    children: "\xA0"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
    children: "\xA0"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
    children: "\xA0"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
    children: "\xA0"
  })]
});

var disabledPoints = [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard, {
  number: "1F",
  copy: copy,
  isSplitterLong: true,
  cols: 3,
  pointColor: "Auto",
  pointsType: "Numbers",
  isDisabled: true
}, "tempq1"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard, {
  number: "2F",
  copy: copy,
  isSplitterLong: true,
  cols: 3,
  pointColor: "Auto",
  pointsType: "Numbers",
  isDisabled: true
}, "tempq2"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard, {
  number: "3F",
  copy: copy,
  isSplitterLong: true,
  cols: 3,
  pointColor: "Auto",
  pointsType: "Numbers",
  isDisabled: true
}, "tempq3"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard, {
  number: "4F",
  copy: copy,
  isSplitterLong: true,
  cols: 3,
  pointColor: "Auto",
  pointsType: "Numbers",
  isDisabled: true
}, "tempq4")];

var QuartersContainer_Group = function Group(_ref2) {
  var children = _ref2.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, QuartersContainer_excluded2);

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemsRow, QuartersContainer_objectSpread(QuartersContainer_objectSpread({
    ref: ref
  }, rest), {}, {
    children: itemsWithStyleProp
  }));
};

var QuartersContainer_QuartersContainer = function QuartersContainer(_ref3) {
  var fields = _ref3.fields,
      _ref3$hasContainer = _ref3.hasContainer,
      hasContainer = _ref3$hasContainer === void 0 ? true : _ref3$hasContainer;
  var itemsCount = fields === null || fields === void 0 ? void 0 : fields.length;
  var disabledItems = disabledPoints.slice(itemsCount, 4);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    container: hasContainer,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(QuartersContainer_Group, {
      children: [fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuartersContainer_CardItem, QuartersContainer_objectSpread({
          number: index + 1
        }, item), "".concat(index, "-q"));
      }), disabledItems]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/Quote.tsx







var Quote_Wrapper = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efovet53"
} : 0)( true ? "" : 0);

var Quote_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("blockquote",  true ? {
  target: "efovet52"
} : 0)("font-family:'LB Centro Slab';", (0,mixins/* responseFont */.cG)(26, 34), " line-height:", 48 / 34, ";position:relative;margin-bottom:1em;padding-left:30px;border-left:1px solid #000;@media ", devices/* device.tablet */.U.tablet, "{padding-left:50px;}@media ", devices/* device.desktop */.U.desktop, "{padding-left:100px;}" + ( true ? "" : 0));

var Cite = (0,emotion_styled_base_browser_esm/* default */.Z)("cite",  true ? {
  target: "efovet51"
} : 0)(typography/* typography.bodyEditorial */.cp.bodyEditorial, " padding-left:30px;@media ", devices/* device.tablet */.U.tablet, "{padding-left:50px;}@media ", devices/* device.desktop */.U.desktop, "{padding-left:100px;}" + ( true ? "" : 0));

var Quote_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "efovet50"
} : 0)("padding-left:30px;@media ", devices/* device.tablet */.U.tablet, "{padding-left:50px;}@media ", devices/* device.desktop */.U.desktop, "{padding-left:100px;}" + ( true ? "" : 0));

var Quote = function Quote(_ref) {
  var quote = _ref.quote,
      author = _ref.author,
      title = _ref.title,
      isArticle = _ref.isArticle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Quote_Wrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Quote_Copy, {
        children: quote
      }), author && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cite, {
        children: author
      }), title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Quote_Title, {
        children: title
      })]
    }),
    isArticle: isArticle
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/QuoteContainer.tsx





var QuoteContainer = function QuoteContainer(_ref) {
  var quote = _ref.quote,
      author = _ref.author,
      position = _ref.position,
      template = _ref.template;

  if ((0,isEmptyText/* isEmptyText */.W)(quote)) {
    return null;
  }

  var isArticle = template === 'article';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Quote, {
      quote: Prismic/* Prismic.text */.X5.text(quote),
      author: Prismic/* Prismic.text */.X5.text(author),
      title: Prismic/* Prismic.text */.X5.text(position),
      isArticle: isArticle
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/author/Author.tsx


function Author_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Author_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nl8awd4"
} : 0)("display:flex;flex-flow:row nowrap;margin-bottom:36px;@media ", devices/* device.tablet */.U.tablet, "{align-items:center;flex-flow:column nowrap;margin-bottom:50px;}" + ( true ? "" : 0));

var Author_Image = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nl8awd3"
} : 0)("width:50px;height:50px;margin-right:20px;flex-shrink:0;img{border-radius:50%;}@media ", devices/* device.tablet */.U.tablet, "{width:100%;height:auto;max-width:171px;margin-bottom:26px;margin-right:0;}" + ( true ? "" : 0));

var Author_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nl8awd2"
} : 0)("display:flex;flex-flow:column nowrap;justify-content:center;align-items:flex-start;@media ", devices/* device.tablet */.U.tablet, "{flex-flow:column nowrap;flex-flow:column nowrap;justify-content:center;align-items:center;}" + ( true ? "" : 0));

var Author_Name = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nl8awd1"
} : 0)( true ? {
  name: "15leskn",
  styles: "font-weight:500;font-size:14px;line-height:20px"
} : 0);

var Author_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nl8awd0"
} : 0)( true ? {
  name: "244gxd",
  styles: "font-size:14px;line-height:20px"
} : 0);

var Author = function Author(_ref) {
  var image = _ref.image,
      name = _ref.name,
      title = _ref.title;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Author_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Author_Image, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
        src: image,
        percentage: 0.2,
        ar: "ar_1_1",
        aspectRatio: 1 / 1
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Author_Content, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Author_Name, {
        children: name
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Author_Title, {
        children: title
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/QuoteExpand.res.tsx
/* harmony default export */ var QuoteExpand_res = ({
  readMore: {
    is: 'Lesa meira',
    en: 'More'
  },
  readLess: {
    is: 'Lesa minna',
    en: 'Less'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/QuoteExpand.tsx




function QuoteExpand_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function QuoteExpand_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { QuoteExpand_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { QuoteExpand_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function QuoteExpand_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var QuoteExpand_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "el3idmj8"
} : 0)(typography/* typography.h3 */.cp.h3, " margin-bottom:42px;" + ( true ? "" : 0));

var QuoteExpand_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "el3idmj7"
} : 0)( true ? "" : 0);

var Expandable = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "el3idmj6"
} : 0)( true ? "" : 0);

var AuthorWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SliceWrapper,  true ? {
  target: "el3idmj5"
} : 0)(Row/* Row */.X, "{position:relative;flex-flow:column-reverse nowrap;flex-direction:column-reverse;", function (props) {
  return props.topSplitter && "    \n        padding-top: 56px;\n        &::before {\n          content: '';\n          display: block;\n          position: absolute;\n          top: 0px;\n          left: 0;\n          right: 0;\n\n          width: 100%;\n          height: 1px;\n          background-color: ".concat(props.theme.colors.primary, ";\n        }\n    ");
}, " &::after{content:'';display:block;position:absolute;bottom:20px;left:0;right:0;width:100%;height:1px;background-color:", function (props) {
  return props.theme.colors.primary;
}, ";}@media ", devices/* device.tablet */.U.tablet, "{flex-flow:inherit;", function (props) {
  return props.topSplitter && "  \n          &::before {\n            top: 0px;\n            left: 10px;\n            right: -10px;\n            width: calc(100% - 20px);\n          }\n      ";
}, ";&::after{bottom:0;left:10px;right:-10px;width:calc(100% - 20px);}}}" + ( true ? "" : 0));

var CardWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "el3idmj4"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{padding-top:80px;}" + ( true ? "" : 0));

var ExpandButton = (0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "el3idmj3"
} : 0)("display:flex;align-items:center;justify-content:flex-start;position:relative;padding:35px 0;width:100%;text-align:left;background-color:transparent;appearance:none;cursor:pointer;@media ", devices/* device.tablet */.U.tablet, "{padding:45px 0;}" + ( true ? "" : 0));

var QuoteExpand_Heading = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "el3idmj2"
} : 0)( true ? {
  name: "1303l1h",
  styles: "margin-left:24px;font-weight:bold"
} : 0);

var QuoteExpand_Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "el3idmj1"
} : 0)( true ? {
  name: "sm2imb",
  styles: "height:0px;overflow:hidden"
} : 0);

var QuoteExpand_AccordionMarkdown = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "el3idmj0"
} : 0)( true ? {
  name: "1i7o10m",
  styles: "position:relative;padding:40px 0 20px;width:100%;opacity:0"
} : 0);

var QuoteExpand = function QuoteExpand(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      expandableCopy = _ref.expandableCopy,
      topSplitter = _ref.topSplitter,
      cards = _ref.cards,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useMeasure = (0,web/* default */.Z)({
    polyfill: resize_observer/* ResizeObserver */["do"]
  }),
      _useMeasure2 = (0,slicedToArray/* default */.Z)(_useMeasure, 2),
      copyRef = _useMeasure2[0],
      copySize = _useMeasure2[1];

  var _useState2 = (0,react.useState)(false),
      hover = _useState2[0],
      setHover = _useState2[1];

  var setHeight = (0,react_spring_esm.useSpring)({
    height: isOpen ? "".concat(lodash_get_default()(copySize, 'height', 0), "px") : '0px',
    visability: isOpen ? 'visible' : 'hidden'
  });
  var fadeIn = (0,react_spring_esm.useSpring)({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(0px)' : 'translateY(10px)'
  });

  var onEnter = function onEnter(e) {
    setHover(true);

    if (onMouseEnter) {
      onMouseEnter(e);
    }
  };

  var onLeave = function onLeave(e) {
    setHover(false);

    if (onMouseLeave) {
      onMouseLeave(e);
    }
  };

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthorWrapper, {
    topSplitter: topSplitter,
    left: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteExpand_Title, {
        children: title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteExpand_Copy, {
        children: copy
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteExpand_Content, {
        className: isOpen ? 'open' : '',
        style: QuoteExpand_objectSpread(QuoteExpand_objectSpread({}, setHeight), {}, {
          visibility: isOpen ? 'visible' : 'hidden'
        }),
        id: "content",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteExpand_AccordionMarkdown, {
          ref: copyRef,
          style: QuoteExpand_objectSpread({}, fadeIn),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Expandable, {
            children: expandableCopy
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ExpandButton, {
        onClick: function onClick() {
          return setIsOpen(!isOpen);
        },
        role: "button",
        "aria-expanded": isOpen ? true : false,
        "aria-controls": "content",
        onMouseLeave: onLeave,
        onMouseEnter: onEnter,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonPlus, {
          isOpen: isOpen,
          isHover: hover
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteExpand_Heading, {
          children: isOpen ? r(QuoteExpand_res.readLess) : r(QuoteExpand_res.readMore)
        })]
      })]
    }),
    right: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardWrap, {
      children: cards
    }),
    isArticle: false,
    align: "Right"
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/QuoteExpandContainer.tsx







var renderAuthorItem = function renderAuthorItem(_ref, i) {
  var author = _ref.author;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Author, {
    image: author === null || author === void 0 ? void 0 : author.image,
    name: Prismic/* Prismic.text */.X5.text(author === null || author === void 0 ? void 0 : author.name),
    title: Prismic/* Prismic.text */.X5.text(author === null || author === void 0 ? void 0 : author.job_title)
  }, "".concat(author === null || author === void 0 ? void 0 : author.name, "-").concat(i));
};

var QuoteExpandContainer = function QuoteExpandContainer(_ref2) {
  var title = _ref2.title,
      copy = _ref2.copy,
      expandable_copy = _ref2.expandable_copy,
      top_splitter = _ref2.top_splitter,
      fields = _ref2.fields;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteExpand, {
      cards: fields === null || fields === void 0 ? void 0 : fields.map(renderAuthorItem),
      title: Prismic/* Prismic.text */.X5.text(title),
      copy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy,
        isArticle: true
      }),
      topSplitter: top_splitter,
      expandableCopy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: expandable_copy,
        isArticle: true
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/RelatedCard.tsx



var RelatedCard_excluded = ["title", "description", "action", "theme", "icon", "notLink"];

function RelatedCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function RelatedCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { RelatedCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { RelatedCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function RelatedCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var RelatedCard_CardHostLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.a,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('a'),
  target: "efu12bx9"
} : 0)("display:block;position:relative;width:100%;color:#fff;background-color:", function (_ref) {
  var theme = _ref.theme,
      colorTheme = _ref.colorTheme;
  return theme.colors[colorTheme];
}, ";margin-top:", function (_ref2) {
  var hasIcon = _ref2.hasIcon;
  return hasIcon ? '90px' : '0';
}, ";-webkit-user-select:none;-webkit-user-drag:none;-webkit-app-region:no-drag;cursor:pointer;user-select:text;" + ( true ? "" : 0));

var RelatedCard_CardHost = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "efu12bx8"
} : 0)("position:relative;width:100%;background-color:", function (_ref3) {
  var theme = _ref3.theme,
      colorTheme = _ref3.colorTheme;
  return theme.colors[colorTheme];
}, ";" + ( true ? "" : 0));

var Bg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "efu12bx7"
} : 0)(mixins/* fit */.Tj, " background-color:", function (props) {
  return props.theme.colors.primary;
}, ";" + ( true ? "" : 0));

var RelatedCard_Body = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efu12bx6"
} : 0)("position:relative;z-index:1;padding:48px 30px 45px;@media ", devices/* device.tablet */.U.tablet, "{padding:15%;}@media ", devices/* device.pageLimit */.U.pageLimit, "{padding:48px 56px 45px;}" + ( true ? "" : 0));

var RelatedCard_IconWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efu12bx5"
} : 0)( true ? {
  name: "1uuvjee",
  styles: "position:absolute;top:-27%;right:30px;width:28%"
} : 0);

var RelatedCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "efu12bx4"
} : 0)( true ? {
  name: "vv1fu0",
  styles: "line-height:calc(24 / 18);font-weight:bold"
} : 0);

var CustomDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* Divider */.i,  true ? {
  target: "efu12bx3"
} : 0)("margin:31px 0 25px;background-color:currentColor;@media ", devices/* device.tablet */.U.tablet, "{margin:10% 0;}@media ", devices/* device.pageLimit */.U.pageLimit, "{margin:31px 0 25px;}" + ( true ? "" : 0));

var RelatedCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "efu12bx2"
} : 0)(typography/* typography.h3 */.cp.h3, ";" + ( true ? "" : 0));

var RelatedCard_ActionSpace = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efu12bx1"
} : 0)( true ? {
  name: "sem7hj",
  styles: "position:relative;opacity:0;pointer-events:none"
} : 0);

var RelatedCard_ActionPosition = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efu12bx0"
} : 0)( true ? {
  name: "1hkjlab",
  styles: "display:flex;flex-direction:row;position:absolute;bottom:45px;left:35px;right:42px"
} : 0);

var RelatedCard_CardAction = function CardAction(_ref4) {
  var children = _ref4.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedCard_ActionSpace, {
      children: children
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedCard_ActionPosition, {
      children: children
    })]
  });
};
var RelatedCard = /*#__PURE__*/(0,react.forwardRef)(function CardFn(props, ref) {
  var title = props.title,
      description = props.description,
      action = props.action,
      theme = props.theme,
      icon = props.icon,
      notLink = props.notLink,
      rest = (0,objectWithoutProperties/* default */.Z)(props, RelatedCard_excluded);

  var _useState = (0,react.useState)(false),
      isHover = _useState[0],
      setHover = _useState[1];

  var onHover = (0,react_spring_esm.useSpring)({
    transform: isHover ? 'scale(1.025)' : 'scale(1)',
    config: {
      mass: 10,
      tension: 2000,
      friction: 200
    }
  });

  var onClick = function onClick(e) {
    var _window, _window$getSelection, _window$getSelection$;

    if (((_window = window) === null || _window === void 0 ? void 0 : (_window$getSelection = _window.getSelection) === null || _window$getSelection === void 0 ? void 0 : (_window$getSelection$ = _window$getSelection.call(_window)) === null || _window$getSelection$ === void 0 ? void 0 : _window$getSelection$.type) === 'Range') {
      e.preventDefault();
      return false;
    }
  };

  var content = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RelatedCard_Body, {
      children: [icon !== 'Null' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedCard_IconWrap, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons/* Icon */.JO, {
          name: "house"
        })
      }), !!title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedCard_Title, {
        children: title
      }), !!title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedCard_Copy, {
        children: description
      }), !!action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedCard_CardAction, {
        children: action
      })]
    })
  });

  if (notLink) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedCard_CardHost, RelatedCard_objectSpread(RelatedCard_objectSpread({
      colorTheme: theme,
      hasIcon: icon !== 'Null'
    }, rest), {}, {
      children: content
    }));
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RelatedCard_CardHostLink, RelatedCard_objectSpread(RelatedCard_objectSpread({
    colorTheme: theme,
    hasIcon: icon !== 'Null',
    ref: ref
  }, rest), {}, {
    onMouseOver: function onMouseOver() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: onClick,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bg, {
      style: RelatedCard_objectSpread({}, onHover)
    }), content]
  }));
});
;// CONCATENATED MODULE: ../../packages/slices/src/containers/RelatedContainer.tsx


function RelatedContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function RelatedContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { RelatedContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { RelatedContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var RelatedContainer_CardItem = function CardItem(_ref, i) {
  var _link$body, _link$body$filter$, _link$body$filter$$pr, _linkdata$title;

  var title = _ref.title,
      copy = _ref.copy,
      link = _ref.link,
      style = _ref.style,
      icon = _ref.icon;
  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var heroTitle = link === null || link === void 0 ? void 0 : (_link$body = link.body) === null || _link$body === void 0 ? void 0 : (_link$body$filter$ = _link$body.filter(function (x) {
    return x.type === 'hero';
  })[0]) === null || _link$body$filter$ === void 0 ? void 0 : (_link$body$filter$$pr = _link$body$filter$.primary) === null || _link$body$filter$$pr === void 0 ? void 0 : _link$body$filter$$pr.title;
  var boxTitle = (0,fallback/* fallbackText */.mn)(title, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);
  var boxDescription = (0,fallback/* fallbackText */.mn)(copy, heroTitle);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link,
    title: boxTitle !== null && boxTitle !== void 0 ? boxTitle : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedCard, {
      title: boxTitle,
      description: boxDescription,
      theme: "primary",
      style: style,
      icon: icon
    }, "related-".concat(i, "-").concat(Prismic/* Prismic.text */.X5.text(title)))
  }, i);
};

var RelatedContainer = function RelatedContainer(_ref2) {
  var fields = _ref2.fields;

  if (fields.length === 0) {
    return null;
  }

  var fLength = fields.length;
  var count = fLength <= 3 ? 3 : 4;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardGroup, {
      columns: count,
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedContainer_CardItem, RelatedContainer_objectSpread({}, item), index);
      })
    })
  });
};
// EXTERNAL MODULE: ../../packages/ui/src/components/form/radio-button/Radio.tsx
var Radio = __webpack_require__(37047);
;// CONCATENATED MODULE: ../../packages/slices/src/graphql/fetchServicePoints.ts


var fetchServicePoints_templateObject;


var FETCH_SERVICE_POINTS = (0,lib/* gql */.Ps)(fetchServicePoints_templateObject || (fetchServicePoints_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query FetchServicePoints(\n    $service: ServicePointType\n    $region: Region\n    $atmTypes: [AtmType!]\n    $branchServices: [BranchServices!]\n  ) {\n    servicePoints(\n      first: 100\n      service: $service\n      region: $region\n      atmTypes: $atmTypes\n      branchServices: $branchServices\n    ) {\n      totalCount\n      nodes {\n        id\n        name\n        street\n        postalCode\n        city\n        region\n        latitude\n        longitude\n\n        atms {\n          name\n          type\n          currencies\n          openingHours {\n            type\n            text\n          }\n        }\n\n        branches {\n          name\n          phoneNumber\n          hasPostOffice\n          id\n          openingHours\n          branchServices\n          hasWheelchairAccess\n          branchNumber\n        }\n      }\n    }\n  }\n"])));
;// CONCATENATED MODULE: ../../packages/ui/src/components/form/tagFilterCheckbox/TagFilterCheckbox.tsx







var TagFilterCheckbox_CheckboxInput = (0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "ejkv941"
} : 0)(mixins/* dynamicInput */.w$, ";" + ( true ? "" : 0));

var TagButton = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejkv940"
} : 0)("cursor:pointer;border-radius:6px;border:", function (props) {
  return props.checked ? 'none' : '1px solid rgba(30, 60, 90,0.2)';
}, ";background-color:", function (props) {
  return props.checked ? props.theme.colors.primary : '#ffff';
}, ";color:", function (props) {
  return props.checked ? '#ffff' : props.theme.colors.primary;
}, ";height:48px;display:flex;font-size:14px;align-items:center;justify-content:center;padding-top:3px;@media ", devices/* device.tablet */.U.tablet, "{font-size:16px;border-radius:24px;}" + ( true ? "" : 0));

var TagFilterCheckbox = function TagFilterCheckbox(_ref) {
  var id = _ref.id,
      checked = _ref.checked,
      disabled = _ref.disabled,
      label = _ref.label,
      _onChange = _ref.onChange,
      className = _ref.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagFilterCheckbox_CheckboxInput, {
      type: "checkbox",
      id: id,
      checked: checked,
      disabled: disabled,
      onChange: function onChange() {
        return _onChange(!checked);
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
      htmlFor: id,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagButton, {
        checked: checked,
        className: className,
        children: label
      })
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/filters/AtmFilter.res.ts
/* harmony default export */ var AtmFilter_res = ({
  Atm: {
    is: 'Hraðbanki',
    en: 'Atm'
  },
  CurrencyAtm: {
    is: 'Gjaldeyrir',
    en: 'Currency'
  },
  DepositAtm: {
    is: 'Innlögn',
    en: 'Deposit'
  },
  CoinRollAtm: {
    is: 'Myntrúllusjálfsali',
    en: 'Coin roll dispenser'
  },
  CoinCounterAtm: {
    is: 'Mynttalningarvél',
    en: 'Coin count machine'
  },
  GiftCardAtm: {
    is: 'Gjafakortasjálfsali',
    en: 'Gift card'
  },
  CorporateDepositAtm: {
    is: 'Fyrirtækjainnlegg',
    en: 'Corporate deposit'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/filters/AtmFilter.tsx



function AtmFilter_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var AtmFilter_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "ecp5zbe1"
} : 0)( true ? {
  name: "qkomnt",
  styles: "margin-bottom:40px"
} : 0);

var StyledTagFilterCheckbox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TagFilterCheckbox,  true ? {
  target: "ecp5zbe0"
} : 0)("width:100%;margin-right:10px;margin-bottom:20px;@media ", devices/* device.tablet */.U.tablet, "{width:160px;}" + ( true ? "" : 0));

var AtmFilter_CheckboxContainer = function CheckboxContainer(_ref) {
  var children = _ref.children;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  if (isMobile) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
      gutter: 20,
      width: 1 / 2,
      children: children
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: children
  });
};
var AtmTypesFilter = function AtmTypesFilter(_ref2) {
  var selectedAtmTypes = _ref2.selectedAtmTypes,
      setSelectedAtmTypes = _ref2.setSelectedAtmTypes;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var services = function services() {
    var types = [];

    for (var service in globalTypes/* AtmType */._Z) {
      var myService = globalTypes/* AtmType */._Z[service];
      types.push(myService);
    }

    return types.sort(function (a, b) {
      if (b === globalTypes/* AtmType.Atm */._Z.Atm) {
        return 1;
      }

      if (a === globalTypes/* AtmType.DepositAtm */._Z.DepositAtm) {
        return -1;
      }

      if (b === globalTypes/* AtmType.CurrencyAtm */._Z.CurrencyAtm) {
        return 1;
      }

      if (a === globalTypes/* AtmType.GiftCardAtm */._Z.GiftCardAtm) {
        return -1;
      }

      if (a === globalTypes/* AtmType.CoinCounterAtm */._Z.CoinCounterAtm) {
        return 1;
      }

      if (a === globalTypes/* AtmType.CoinRollAtm */._Z.CoinRollAtm) {
        return 1;
      }

      if (a === globalTypes/* AtmType.CorporateDepositAtm */._Z.CorporateDepositAtm) {
        return 1;
      }

      return -1;
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AtmFilter_Host, {
    children: services().map(function (service) {
      if (r(AtmFilter_res[service])) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AtmFilter_CheckboxContainer, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTagFilterCheckbox, {
            id: service,
            checked: selectedAtmTypes.includes(service),
            label: r(AtmFilter_res[service]),
            onChange: function onChange(checked) {
              if (checked) {
                setSelectedAtmTypes([].concat((0,toConsumableArray/* default */.Z)(selectedAtmTypes), [service]));
                return;
              }

              setSelectedAtmTypes(selectedAtmTypes.filter(function (i) {
                return i !== service;
              }));
            }
          })
        });
      }
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/filters/BranchServicesFilter.res.ts
/* harmony default export */ var BranchServicesFilter_res = ({
  CashierService: {
    is: 'Gjaldkeraþjónusta',
    en: 'Cashier service'
  },
  CorporateBankingService: {
    is: 'Fyrirtækjaþjónusta',
    en: 'Corporate banking service'
  },
  FinanceConsultation: {
    is: 'Fjármálaráðgjöf',
    en: 'Finance consultation'
  },
  MailDelivery: {
    is: 'Póstafgreiðsla'
  },
  RetailBankingService: {
    is: 'Einstaklingsþjónusta',
    en: 'Retail banking service'
  },
  ServiceVisit: {
    is: 'Þjónustuheimsóknir',
    en: 'Service visit'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/filters/BranchServicesFilter.tsx



function BranchServicesFilter_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var BranchServicesFilter_StyledTagFilterCheckbox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(TagFilterCheckbox,  true ? {
  target: "e1cigdh71"
} : 0)("width:100%;margin-right:20px;margin-bottom:20px;@media ", devices/* device.tablet */.U.tablet, "{width:220px;}" + ( true ? "" : 0));

var BranchServicesFilter_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e1cigdh70"
} : 0)( true ? {
  name: "qkomnt",
  styles: "margin-bottom:40px"
} : 0);

var BranchServicesFilter = function BranchServicesFilter(_ref) {
  var setBranchServices = _ref.setBranchServices,
      selectedServices = _ref.selectedServices;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var services = function services() {
    var services = [];

    for (var service in globalTypes/* BranchServices */.uv) {
      var myService = globalTypes/* BranchServices */.uv[service];

      if (service !== globalTypes/* BranchServices.MailDelivery */.uv.MailDelivery && service !== globalTypes/* BranchServices.ServiceVisit */.uv.ServiceVisit) {
        services.push(myService);
      }
    }

    return services.sort(function (a, b) {
      if (b === globalTypes/* BranchServices.CorporateBankingService */.uv.CorporateBankingService) {
        return -1;
      }

      if (a === globalTypes/* BranchServices.RetailBankingService */.uv.RetailBankingService || a === globalTypes/* BranchServices.CashierService */.uv.CashierService) {
        return -1;
      }

      return 1;
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BranchServicesFilter_Host, {
    children: services().map(function (service) {
      if (BranchServicesFilter_res[service]) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AtmFilter_CheckboxContainer, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BranchServicesFilter_StyledTagFilterCheckbox, {
            id: service,
            checked: selectedServices.includes(service),
            label: r(BranchServicesFilter_res[service]),
            onChange: function onChange(checked) {
              if (checked) {
                setBranchServices([].concat((0,toConsumableArray/* default */.Z)(selectedServices), [service]));
                return;
              }

              setBranchServices(selectedServices.filter(function (i) {
                return i !== service;
              }));
            }
          })
        }, service);
      }
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(14080);
// EXTERNAL MODULE: ../../packages/slices/src/components/calculators/shared/Seperator.tsx
var Seperator = __webpack_require__(94941);
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/card/CardWrapper.tsx







var CardContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "ef6pfhe2"
} : 0)("flex-direction:column;justify-content:space-between;width:100%;>*{margin-left:0;margin-bottom:24px;max-width:100%;}@media ", devices/* device.tablet */.U.tablet, "{display:flex;flex-direction:row;flex-wrap:wrap;max-width:1200px;>*{margin-bottom:44px;width:100%;max-width:calc((1 / 2) * 100% - 20px);}}@media ", devices/* device.desktop */.U.desktop, "{>*{margin-bottom:44px;max-width:calc((1 / 3) * 100% - 20px);}", function (props) {
  return props.useAfter && ":after {\n      content: '';\n      flex: auto;\n      max-width: calc((1 / 3) * 100% - 20px);\n    }";
}, ";}" + ( true ? "" : 0));

var CardWrapper_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ef6pfhe1"
} : 0)("display:flex;flex-wrap:wrap;margin-bottom:", function (props) {
  return 8 * props.theme.baseline;
}, "px;" + ( true ? "" : 0));

var CardWrapper_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "ef6pfhe0"
} : 0)(typography/* typography.h4 */.cp.h4, ";@media ", devices/* device.tablet */.U.tablet, "{", typography/* typography.h3 */.cp.h3, ";}margin-bottom:", function (props) {
  return 8 * props.theme.baseline;
}, "px;" + ( true ? "" : 0));

function CardWrapper(_ref) {
  var children = _ref.children,
      title = _ref.title;
  var count = react.Children.count(children);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardWrapper_Title, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardWrapper_Host, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContainer, {
        tabIndex: -1,
        "aria-label": title,
        useAfter: count % 3 !== 0,
        children: children
      })
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/LoadingCards.tsx


function LoadingCards_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var LoadingCards_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hnvq4v5"
} : 0)( true ? {
  name: "5gq0cc",
  styles: "width:100%;background-color:white;padding-top:44px;padding-left:44px;padding-right:15px;min-height:284px"
} : 0);

var LoadingCards_Name = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1hnvq4v4"
} : 0)(typography/* typography.h3 */.cp.h3, ";margin-bottom:6px;visibility:hidden;" + ( true ? "" : 0));

var LoadingCards_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e1hnvq4v3"
} : 0)(typography/* typography.h3 */.cp.h3, ";margin-bottom:", function (props) {
  return 15 * props.theme.baseline;
}, "px;visibility:hidden;" + ( true ? "" : 0));

var LoadingCards_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1hnvq4v2"
} : 0)("visibility:hidden;", typography/* typography.body */.cp.body, ";" + ( true ? "" : 0));

var SkeletonContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hnvq4v1"
} : 0)( true ? {
  name: "n48rgu",
  styles: "width:100%;position:relative"
} : 0);

var StyledSkeleton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* default */.Z,  true ? {
  target: "e1hnvq4v0"
} : 0)( true ? {
  name: "1qm1wo2",
  styles: "position:absolute;top:0;height:calc(100% - 4px)"
} : 0);

function LoadingCards_Card() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadingCards_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SkeletonContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingCards_Name, {
        children: "Loading"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {})]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SkeletonContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingCards_Text, {
        children: "Loading"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {})]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SkeletonContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingCards_Text, {
        children: "Loading"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {})]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Seperator/* Seperator */.t, {
      border: true,
      currentTheme: "primary"
    })]
  });
}

function LoadingCards() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingCards_Title, {
      children: "Loading"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingCards_Card, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingCards_Card, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingCards_Card, {})]
    })]
  });
}
// EXTERNAL MODULE: ../../node_modules/lodash.flatten/index.js
var lodash_flatten = __webpack_require__(82193);
var lodash_flatten_default = /*#__PURE__*/__webpack_require__.n(lodash_flatten);
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/card/CardItem.tsx


function CardItem_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var SvgContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ed5ou62"
} : 0)( true ? {
  name: "x1h8k3",
  styles: "display:flex;width:24px;justify-content:center;align-items:center;margin-right:14px"
} : 0);

var CardItem_ListItem = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ed5ou61"
} : 0)( true ? {
  name: "18hstyt",
  styles: "display:flex;align-items:center;padding-bottom:28px"
} : 0);

var CardItem_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "ed5ou60"
} : 0)(function (props) {
  return props.bold ? typography/* typography.body */.cp.body : typography/* typography.bodySmall */.cp.bodySmall;
}, ";", function (props) {
  return props.bold ? 'font-weight: 500;' : '';
}, ";" + ( true ? "" : 0));

function CardItem_CardItem(_ref) {
  var text = _ref.text,
      svg = _ref.svg,
      bold = _ref.bold;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardItem_ListItem, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgContainer, {
      children: svg
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardItem_Text, {
      bold: bold,
      children: text
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/icons/OpeningHours.tsx



function OpeningHours() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    viewBox: "0 0 22 22",
    width: "22px",
    height: "22px",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
      transform: "translate(-1 -1)",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
        cx: 12,
        cy: 12,
        r: 10,
        fill: "none",
        stroke: "#0096aa"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        fill: "none",
        stroke: "#0096aa",
        strokeLinecap: "square",
        d: "M12 7v5l2.3 2.2"
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/icons/arrow.tsx


function arrow_Arrow() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    version: "1.1",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
      id: "v08",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
        id: "Afgrei\xF0slusta\xF0ir/\xDAtib\xFA-og-afgrei\xF0slur/Hra\xF0bankar",
        transform: "translate(-580.000000, -1512.000000)",
        stroke: "#1E3D5A",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
          id: "Group-14-Copy-3",
          transform: "translate(574.000000, 1506.000000)",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            id: "Combined-Shape",
            transform: "translate(6.000000, 7.000000)",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              d: "M5.645,0.005 L10.965,4.66 L5.645,9.315 M10.3,4.66 L-3.64153152e-13,4.66"
            })
          })
        })
      })
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/card/Card.res.ts
/* harmony default export */ var Card_res = ({
  viewServices: {
    is: 'Sjá þjónustu í boði',
    en: 'View on map'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/card/Card.tsx











var Card_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "egrmpxy1"
} : 0)("width:100%;background-color:white;position:relative;padding-top:44px;padding-left:34px;padding-right:34px;cursor:", function (props) {
  return props.isClickable ? 'pointer' : 'initial';
}, ";", function (props) {
  return props.isClickable ? ':hover { box-shadow: 1px 12px 22px 1px rgba(0, 0, 0, 0.15); transition: all 0.5s ease-in-out; }' : '';
}, " box-shadow:0;transition:box-shadow 0.5s;" + ( true ? "" : 0));

var MapLinkContiner = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "egrmpxy0"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{position:absolute;bottom:24px;cursor:pointer;}" + ( true ? "" : 0));

function Card_Card(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_Host, {
    tabIndex: 0,
    onClick: onClick,
    isClickable: onClick !== undefined,
    className: className,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [children, onClick !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapLinkContiner, {
        "aria-hidden": "true",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardItem_CardItem, {
          svg: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(arrow_Arrow, {}),
          text: r(Card_res.viewServices),
          bold: true
        })
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/servicePointCard/servicePointCard.res.ts
/* harmony default export */ var servicePointCard_res = ({
  bankNumber: {
    is: 'Bankanúmer',
    en: 'Bank number'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/servicePointCard/servicePointCard.tsx
















var StyledCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card_Card,  true ? {
  target: "edw1a7j2"
} : 0)("padding-bottom:24px;@media ", devices/* device.tablet */.U.tablet, "{min-height:284px;padding-bottom:0px;}" + ( true ? "" : 0));

var servicePointCard_Name = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "edw1a7j1"
} : 0)(typography/* typography.h3 */.cp.h3, ";margin-bottom:6px;" + ( true ? "" : 0));

var servicePointCard_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "edw1a7j0"
} : 0)(typography/* typography.body */.cp.body, ";" + ( true ? "" : 0));

var Locations = function Locations(_ref) {
  var locations = _ref.locations;

  var _useRegionOptions = useRegionOptions(),
      options = _useRegionOptions.options;

  var regionLocations = (0,react.useMemo)(function () {
    return lodash_groupby_default()(locations, function (location) {
      return location.region;
    });
  }, [locations]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: Object.keys(regionLocations).map(function (key) {
      var _options$find;

      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardWrapper, {
        title: (_options$find = options.find(function (op) {
          return op.value === globalTypes/* Region */.yp[key];
        })) === null || _options$find === void 0 ? void 0 : _options$find.label,
        children: regionLocations[key].map(function (l) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocationCard, {
            location: l,
            showOnMap: true
          }, l.id);
        })
      }, key);
    })
  });
};
var LocationCard = function LocationCard(_ref2) {
  var location = _ref2.location,
      children = _ref2.children,
      showOnMap = _ref2.showOnMap;

  var _useServiceLocationsC = useServiceLocationsContext(),
      setIsMapOpen = _useServiceLocationsC.setIsMapOpen,
      setSelectedServicePoint = _useServiceLocationsC.setSelectedServicePoint,
      selectedType = _useServiceLocationsC.selectedType;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCard, {
      onClick: showOnMap ? function () {
        setSelectedServicePoint === null || setSelectedServicePoint === void 0 ? void 0 : setSelectedServicePoint(location);
        setIsMapOpen === null || setIsMapOpen === void 0 ? void 0 : setIsMapOpen(true);
      } : undefined,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(servicePointCard_Name, {
        children: selectedType === globalTypes/* ServicePointType.Branch */.VF.Branch && location.branches && location.branches.length > 0 ? location.branches[0].name : location.name
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(servicePointCard_Text, {
        children: location.street
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(servicePointCard_Text, {
        children: [location.postalCode, " ", location.city]
      }), !showOnMap && location.branches && location.branches.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(servicePointCard_Text, {
        children: [r(servicePointCard_res.bankNumber), " ", location.branches[0].branchNumber]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Seperator/* Seperator */.t, {
        border: true,
        currentTheme: "primary"
      }), children]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/servicePointDetailCard/servicePointDetailCard.res.ts
/* harmony default export */ var servicePointDetailCard_res = ({
  CashierService: {
    is: 'Gjaldkeraþjónusta',
    en: 'Cashier service'
  },
  CorporateBankingService: {
    is: 'Fyrirtækjaþjónusta',
    en: 'Corporate banking service'
  },
  FinanceConsultation: {
    is: 'Fjármálaráðgjöf',
    en: 'Finance consultation'
  },
  MailDelivery: {
    is: 'Póstafgreiðsla'
  },
  RetailBankingService: {
    is: 'Einstaklingsþjónusta',
    en: 'Retail bankings service'
  },
  ServiceVisit: {
    is: 'Þjónustuheimsóknir',
    en: 'Service visit'
  },
  Atm: {
    is: 'Hraðbanki',
    en: 'Atm'
  },
  CurrencyAtm: {
    is: 'Gjaldeyrir',
    en: 'Currency'
  },
  DepositAtm: {
    is: 'Innlögn',
    en: 'Deposit'
  },
  CoinRollAtm: {
    is: 'Myntrúllusjálfsali',
    en: 'Coin roll dispenser'
  },
  CoinCounterAtm: {
    is: 'Mynttalningarvél',
    en: 'Coin count machine'
  },
  GiftCardAtm: {
    is: 'Gjafakortasjálfsali',
    en: 'Gift card'
  },
  CorporateDepositAtm: {
    is: 'Fyrirtækjainnlegg',
    en: 'Corporate deposit'
  },
  atmsServices: {
    is: 'Hraðbankar og sjálfsafgreiðsla',
    en: 'ATMs'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/servicePointDetailCard/servicePointDetailCard.tsx


function servicePointDetailCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var servicePointDetailCard_Container = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kdd5it3"
} : 0)(function (props) {
  return props.spliter ? "padding-top: 28px; \n      border-top: 1px solid rgba(30, 61, 90, 0.1);" : '';
}, ";" + ( true ? "" : 0));

var servicePointDetailCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e1kdd5it2"
} : 0)(typography/* typography.h5 */.cp.h5, " margin-bottom:8px;" + ( true ? "" : 0));

var ServiceTextContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kdd5it1"
} : 0)( true ? {
  name: "gj08vi",
  styles: "margin-bottom:28px"
} : 0);

var ServiceText = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1kdd5it0"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, " margin-bottom:4px;" + ( true ? "" : 0));

var ServicePointDetailCard = function ServicePointDetailCard(_ref) {
  var _services$branch, _services$branch2, _services$branch3, _services$branch3$atm;

  var location = _ref.location;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var services = react.useMemo(function () {
    var _location$branches, _location$branches2, _location$atms, _location$branches3, _location$atms2;

    return {
      branch: location.branches && ((_location$branches = location.branches) === null || _location$branches === void 0 ? void 0 : _location$branches.length) !== 0 ? {
        services: lodash_flatten_default()((_location$branches2 = location.branches) === null || _location$branches2 === void 0 ? void 0 : _location$branches2.map(function (i) {
          return i.branchServices;
        })),
        openingHours: location.branches[0].openingHours,
        atms: (_location$atms = location.atms) === null || _location$atms === void 0 ? void 0 : _location$atms.filter(function (atm) {
          return atm.openingHours.type === globalTypes/* AtmOpeningHours.BranchHours */.Vg.BranchHours;
        })
      } : undefined,
      atms: lodash_groupby_default()(location.branches && ((_location$branches3 = location.branches) === null || _location$branches3 === void 0 ? void 0 : _location$branches3.length) === 1 ? (_location$atms2 = location.atms) === null || _location$atms2 === void 0 ? void 0 : _location$atms2.filter(function (atm) {
        return atm.openingHours.type !== globalTypes/* AtmOpeningHours.BranchHours */.Vg.BranchHours;
      }) : location.atms, function (atm) {
        return atm.openingHours.text;
      })
    };
  }, [location]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LocationCard, {
      location: location,
      children: [services.branch && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(servicePointDetailCard_Container, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(servicePointDetailCard_Title, {
          children: "\xDEj\xF3nusta \xED \xFAtib\xFAi"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceTextContainer, {
          children: [(_services$branch = services.branch) === null || _services$branch === void 0 ? void 0 : _services$branch.services.map(function (i) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: i && servicePointDetailCard_res[i] && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceText, {
                children: r(servicePointDetailCard_res[i])
              }, i)
            });
          }), ((_services$branch2 = services.branch) === null || _services$branch2 === void 0 ? void 0 : _services$branch2.atms) && services.branch.atms.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: (_services$branch3 = services.branch) === null || _services$branch3 === void 0 ? void 0 : (_services$branch3$atm = _services$branch3.atms) === null || _services$branch3$atm === void 0 ? void 0 : _services$branch3$atm.map(function (i) {
              var _i$currencies;

              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: i.type && servicePointDetailCard_res[i.type] && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceText, {
                  children: [r(servicePointDetailCard_res[i.type]), i.type === globalTypes/* AtmType.CurrencyAtm */._Z.CurrencyAtm && " (".concat((_i$currencies = i.currencies) === null || _i$currencies === void 0 ? void 0 : _i$currencies.toString(), ")")]
                }, i.type + i.name)
              });
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardItem_CardItem, {
          svg: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpeningHours, {}),
          text: services.branch.openingHours
        })]
      }), location.atms && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: Object.keys(services.atms).map(function (key) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(servicePointDetailCard_Container, {
              spliter: services.branch !== undefined,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(servicePointDetailCard_Title, {
                children: r(servicePointDetailCard_res.atmsServices)
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceTextContainer, {
                children: services.atms[key].map(function (a) {
                  var _a$currencies;

                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: a.type && servicePointDetailCard_res[a.type] && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceText, {
                      children: [r(servicePointDetailCard_res[a.type]), a.type === globalTypes/* AtmType.CurrencyAtm */._Z.CurrencyAtm ? " (".concat((_a$currencies = a.currencies) === null || _a$currencies === void 0 ? void 0 : _a$currencies.toString(), ")") : '']
                    }, a.type + a.name)
                  });
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardItem_CardItem, {
                svg: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpeningHours, {}),
                text: services.atms[key][0].openingHours.text
              })]
            }, key)
          });
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/Map/MapBox.tsx





var Map = (0,dynamic["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(538), __webpack_require__.e(133), __webpack_require__.e(18)]).then(__webpack_require__.bind(__webpack_require__, 76018));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76018)];
    }
  }
});
function MapBox(_ref) {
  var defaultServiceLocation = _ref.defaultServiceLocation,
      locations = _ref.locations,
      isMobile = _ref.isMobile;

  var _useServiceLocationsC = useServiceLocationsContext(),
      setIsMapOpen = _useServiceLocationsC.setIsMapOpen,
      setSelectedServicePoint = _useServiceLocationsC.setSelectedServicePoint;

  (0,react.useEffect)(function () {
    return function () {
      setSelectedServicePoint === null || setSelectedServicePoint === void 0 ? void 0 : setSelectedServicePoint(undefined);
    };
  }, [setSelectedServicePoint]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Map, {
    isMobile: isMobile,
    center: defaultServiceLocation ? [defaultServiceLocation.longitude, defaultServiceLocation.latitude] : undefined,
    defaultSelectedLocationId: defaultServiceLocation === null || defaultServiceLocation === void 0 ? void 0 : defaultServiceLocation.id,
    onClose: function onClose() {
      setIsMapOpen === null || setIsMapOpen === void 0 ? void 0 : setIsMapOpen(false);
    },
    markers: [{
      popup: function popup(location) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServicePointDetailCard, {
          location: location
        });
      },
      locations: locations,
      type: 'branch'
    }]
  });
}
;// CONCATENATED MODULE: ../../packages/ui/src/components/icons/NotFound.tsx



function NotFound(_ref) {
  var className = _ref.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
    className: className,
    id: "prefix__b48d11bd-edef-44e5-b622-00da69e86340",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 92 97",
    xmlSpace: "preserve",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
      children: '.prefix__st2{fill:none;stroke:#163e63;stroke-width:2}'
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
      opacity: 0.6,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
        id: "prefix__a1c82103-fa64-46ba-bde6-c3ec1fb128cc",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
          id: "prefix__e4120f49-a5fe-4129-9ffa-1b4100a16ba9",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            id: "prefix__ef97e4aa-5ee2-4fa0-a682-304d39904d32",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              id: "prefix__b285ac04-46ff-4e34-9540-3f4fe0b3e745",
              fill: "none",
              stroke: "#163e63",
              strokeWidth: 2,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              d: "M69 73.7L91 96"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
              id: "prefix__bf3baf16-4f85-4f16-9778-c6c36311a228",
              className: "prefix__st2",
              cx: 41.5,
              cy: 42.4,
              rx: 40.5,
              ry: 41.4
            })]
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        className: "prefix__st2",
        d: "M34.7 28.3s14.1-4.5 15.6 3c1.7 8.2-13.5 9.4-10.5 21.2"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
        cx: 40.9,
        cy: 59.2,
        r: 1.8,
        fill: "#163e63"
      })]
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/notFound/NotFound.res.ts
/* harmony default export */ var NotFound_res = ({
  notfound: {
    is: 'Ekkert fannst',
    en: 'No results'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/notFound/NotFound.tsx


function NotFound_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var NotFound_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e34nccb2"
} : 0)( true ? {
  name: "1hm44ki",
  styles: "width:100%;display:flex;justify-content:center;flex-direction:column;align-items:center"
} : 0);

var NotFound_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e34nccb1"
} : 0)(typography/* typography.body */.cp.body, " opacity:60%;" + ( true ? "" : 0));

var StyledNotFoundIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(NotFound,  true ? {
  target: "e34nccb0"
} : 0)( true ? {
  name: "nsgohy",
  styles: "height:93px;margin-bottom:24px"
} : 0);

var NotFound_NotFound = function NotFound() {
  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NotFound_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledNotFoundIcon, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotFound_Text, {
      children: r(NotFound_res.notfound)
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/ServicePoints.res.ts
/* harmony default export */ var ServicePoints_res = ({
  branches: {
    is: 'Útibúaþjónusta',
    en: 'Branches'
  },
  atms: {
    is: 'Hraðbankar og sjálfsafgreiðsla',
    en: 'ATMs'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/service-points/ServicePoints.tsx



function ServicePoints_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





















var CardsSegment = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Segment/* Segment */.X,  true ? {
  target: "e1icwgkp2"
} : 0)( true ? {
  name: "ak08nq",
  styles: "background:rgb(244, 247, 247)"
} : 0);

var ServicePoints_StyledColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Column/* Column */.s,  true ? {
  target: "e1icwgkp1"
} : 0)("margin-bottom:20px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0px;}" + ( true ? "" : 0));

var ServicePoints_StyledRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e1icwgkp0"
} : 0)( true ? {
  name: "1l2mxrd",
  styles: "margin-bottom:40px;>{margin-bottom:20px;}"
} : 0);

var ServicePointsContext = /*#__PURE__*/(0,react.createContext)({
  isMapOpen: false,
  selectedType: globalTypes/* ServicePointType.Atm */.VF.Atm
});
function ServicePoints() {
  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r,
      locale = _useResource.locale;

  var router = (0,next_router.useRouter)();
  var type = (0,utils_src/* useNextQueryParam */.fR)('type', router.asPath);

  var _useState = (0,react.useState)(globalTypes/* ServicePointType.Branch */.VF.Branch),
      selectedId = _useState[0],
      setSelectedId = _useState[1];

  (0,react.useEffect)(function () {
    if (type === 'hradbankar') {
      setSelectedId(globalTypes/* ServicePointType.Atm */.VF.Atm);
    }
  }, [type]);
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  var _React$useState = react.useState([]),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      branchServices = _React$useState2[0],
      setBranchServices = _React$useState2[1];

  var _React$useState3 = react.useState([]),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      selectedAtmTypes = _React$useState4[0],
      setSelectedAtmTypes = _React$useState4[1];

  var _useState2 = (0,react.useState)(globalTypes/* Region.All */.yp.All),
      selectedRegion = _useState2[0],
      setSelectedRegion = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isMapOpen = _useState3[0],
      setIsMapOpen = _useState3[1];

  var _useState4 = (0,react.useState)(),
      selectedServicePoint = _useState4[0],
      setSelectedServicePoint = _useState4[1];

  (0,react.useEffect)(function () {
    if (true) {
      // allow global access to the map for the link resolver
      // as it's `onClick` handler is outside of the React Context.
      window.serviceLocationMap = {
        setIsMapOpen: setIsMapOpen
      };
    }
  }, []);

  var _useContext = (0,react.useContext)(utils_src/* LandsbankinnContext */.Fz),
      client = _useContext.client;

  var _useQuery = (0,useQuery/* useQuery */.a)(FETCH_SERVICE_POINTS, {
    client: client,
    context: {
      headers: {
        'Accept-Language': locale === 'is' ? 'is' : 'en-GB'
      }
    },
    variables: {
      service: selectedId,
      region: selectedRegion,
      branchServices: selectedId === globalTypes/* ServicePointType.Branch */.VF.Branch && branchServices && branchServices.length > 0 ? branchServices : null,
      atmTypes: selectedId === globalTypes/* ServicePointType.Atm */.VF.Atm && selectedAtmTypes && selectedAtmTypes.length > 0 ? selectedAtmTypes : null
    }
  }),
      data = _useQuery.data,
      loading = _useQuery.loading;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServicePointsContext.Provider, {
    value: {
      isMapOpen: isMapOpen,
      setIsMapOpen: setIsMapOpen,
      setSelectedServicePoint: setSelectedServicePoint,
      selectedType: selectedId
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsSegment, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServicePoints_StyledRow, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServicePoints_StyledColumn, {
            md: {
              width: 4 / 12
            },
            sm: {
              width: 1 / 1
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RegionDropdown, {
              selectedRegion: selectedRegion,
              setSelectedRegion: setSelectedRegion
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServicePoints_StyledColumn, {
            md: {
              width: 4 / 12
            },
            sm: {
              width: 1 / 1
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Radio/* RadioButton */.E, {
              checked: selectedId === globalTypes/* ServicePointType.Branch */.VF.Branch,
              label: r(ServicePoints_res.branches),
              onChange: function onChange() {
                setSelectedId(globalTypes/* ServicePointType.Branch */.VF.Branch);
              },
              theme: "primary",
              variant: "noBorder"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
            md: {
              width: 4 / 12
            },
            sm: {
              width: 1 / 1
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Radio/* RadioButton */.E, {
              checked: selectedId === globalTypes/* ServicePointType.Atm */.VF.Atm,
              label: r(ServicePoints_res.atms),
              onChange: function onChange() {
                setSelectedId(globalTypes/* ServicePointType.Atm */.VF.Atm);
              },
              theme: "primary",
              variant: "noBorder"
            })
          })]
        }), selectedId === globalTypes/* ServicePointType.Branch */.VF.Branch && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BranchServicesFilter, {
          selectedServices: branchServices,
          setBranchServices: setBranchServices
        }), selectedId === globalTypes/* ServicePointType.Atm */.VF.Atm && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AtmTypesFilter, {
          selectedAtmTypes: selectedAtmTypes,
          setSelectedAtmTypes: setSelectedAtmTypes
        }), loading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingCards, {}), !loading && (data === null || data === void 0 ? void 0 : data.servicePoints) && data.servicePoints.totalCount > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Locations, {
          locations: data.servicePoints.nodes
        }), !loading && (data === null || data === void 0 ? void 0 : data.servicePoints.totalCount) === 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotFound_NotFound, {})]
      }), isMapOpen && (data === null || data === void 0 ? void 0 : data.servicePoints.nodes) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapBox, {
        locations: data.servicePoints.nodes,
        selectedType: selectedId,
        isMobile: isMobile,
        defaultServiceLocation: selectedServicePoint
      })]
    })
  });
}
var useServiceLocationsContext = function useServiceLocationsContext() {
  return (0,react.useContext)(ServicePointsContext);
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/ServiceLocationsContainer.tsx



function ServiceLocationsContainer() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServicePoints, {});
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/button/IconLink.tsx



var IconLink_excluded = ["text", "icon"];

function IconLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function IconLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { IconLink_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { IconLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function IconLink_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var IconLink_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.a,  true ? {
  target: "e1xrgcdz3"
} : 0)("display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;padding:20px 30px;position:relative;cursor:pointer;span{transition:transform 200ms ease-in-out;}&:hover,&:focus{span{transform:translateY(-6px);}}@media ", devices/* device.tablet */.U.tablet, "{padding:30px 10px;}@media ", devices/* device.desktop */.U.desktop, "{padding:30px;}" + ( true ? "" : 0));

var IconLink_IconWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1xrgcdz2"
} : 0)("display:block;margin-bottom:13px;@media ", devices/* device.tablet */.U.tablet, "{>svg{width:100%;}}" + ( true ? "" : 0));

var HitArea = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xrgcdz1"
} : 0)( true ? {
  name: "1koyb14",
  styles: "position:absolute;left:0;top:0;height:100%;width:100%;z-index:1"
} : 0);

var IconLink_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1xrgcdz0"
} : 0)("display:block;text-align:center;font-size:14px;@media ", devices/* device.tablet */.U.tablet, "{font-size:14px;}@media ", devices/* device.desktop */.U.desktop, "{font-size:16px;}" + ( true ? "" : 0));

var IconLink = function IconLink(_ref) {
  var text = _ref.text,
      icon = _ref.icon,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, IconLink_excluded);

  var ref = (0,react.useRef)(null);

  function dispatchEvent(name) {
    var _ref$current;

    var obj = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector('object');

    if (obj && obj.contentDocument) {
      var svg = obj.contentDocument.querySelector('svg');

      if (svg) {
        svg.dispatchEvent(new Event(name));
      }
    }
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconLink_Host, IconLink_objectSpread(IconLink_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HitArea, {
      onMouseEnter: function onMouseEnter() {
        return dispatchEvent('mouseenter');
      },
      onMouseLeave: function onMouseLeave() {
        return dispatchEvent('mouseleave');
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconLink_IconWrap, {
      ref: ref,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons/* Icon */.JO, {
        name: icon !== null && icon !== void 0 ? icon : 'facebook'
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconLink_Text, {
      children: text
    })]
  }));
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/shortcuts/Shortcuts.res.ts
/* harmony default export */ var Shortcuts_res = ({
  shortcuts: {
    is: 'Flýtileiðir',
    en: 'Shortcuts'
  }
});
;// CONCATENATED MODULE: ../../packages/slices/src/components/shortcuts/Shortcuts.tsx



var Shortcuts_excluded = ["children"];

function Shortcuts_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Shortcuts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Shortcuts_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Shortcuts_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Shortcuts_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("nav",  true ? {
  target: "e737ipi0"
} : 0)("display:flex;justify-content:space-around;flex-flow:row wrap;margin:0 -10px;@media ", devices/* device.mobile */.U.mobile, "{}>a{flex:1;width:50%;@media ", devices/* device.mobile */.U.mobile, "{width:33%;flex:33%;}@media ", devices/* device.tablet */.U.tablet, "{width:", 100 / 6, "%;flex:", 100 / 6, "%;}@media ", devices/* device.desktop */.U.desktop, "{flex:1;width:auto;}}" + ( true ? "" : 0));

var Shortcuts = function Shortcuts(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Shortcuts_excluded);

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Shortcuts_Host, Shortcuts_objectSpread(Shortcuts_objectSpread({
    ref: ref
  }, rest), {}, {
    "aria-label": r(Shortcuts_res.shortcuts),
    children: itemsWithStyleProp
  }));
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/ShortcutsContainer.tsx






var ShortcutsContainer = function ShortcutsContainer(_ref) {
  var fields = _ref.fields;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    paddingTop: 0,
    paddingBottom: 0,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Shortcuts, {
      children: (fields === null || fields === void 0 ? void 0 : fields.length) && fields.map(function (_ref2, index) {
        var _linkdata$title;

        var icon = _ref2.icon,
            link = _ref2.link,
            link_text = _ref2.link_text;
        var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
        var title = (0,fallback/* fallbackText */.mn)(link_text, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
          value: link,
          title: title !== null && title !== void 0 ? title : undefined,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconLink, {
            text: title,
            icon: icon
          })
        }, "".concat(index, "-").concat(icon));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/StaffBioCard.tsx


function StaffBioCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var StaffBioCard_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  target: "e1gkpn486"
} : 0)("display:flex;flex-flow:row nowrap;justify-content:flex-start;position:relative;width:100%;margin-bottom:90px;background-color:", function (props) {
  return props.theme.colors.background;
}, ";&:last-child{margin-bottom:0;}" + ( true ? "" : 0));

var BigRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e1gkpn485"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var ImageWrapper = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gkpn484"
} : 0)("margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-bottom:30px;", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{margin:0;}" + ( true ? "" : 0));

var StaffBioCard_Header = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gkpn483"
} : 0)("margin-bottom:40px;@media ", devices/* device.tablet */.U.tablet, "{margin-top:54px;}" + ( true ? "" : 0));

var StaffBioCard_Name = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1gkpn482"
} : 0)(typography/* typography.h3 */.cp.h3, ";margin-bottom:20px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:8px;}" + ( true ? "" : 0));

var StaffBioCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gkpn481"
} : 0)("font-family:", function (props) {
  return props.theme.font.familySerifCond;
}, ";font-weight:500;margin-bottom:33px;" + ( true ? "" : 0));

var Bio = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1gkpn480"
} : 0)( true ? "" : 0);

var StaffBioCard = function StaffBioCard(_ref) {
  var image = _ref.image,
      _ref$ar = _ref.ar,
      ar = _ref$ar === void 0 ? 'ar_1_1' : _ref$ar,
      name = _ref.name,
      title = _ref.title,
      bio = _ref.bio;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffBioCard_Host, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BigRow, {
      children: [!!image && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 5 / 12
        },
        lg: {
          width: 6 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
            alt: title !== null && title !== void 0 ? title : undefined,
            src: image,
            ar: ar,
            percentage: 4 / 12
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
        md: {
          width: 6 / 12,
          offset: !!image ? 1 / 12 : 0
        },
        lg: {
          width: 5 / 12,
          offset: !!image ? 1 / 12 : 0
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StaffBioCard_Header, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffBioCard_Name, {
            children: name
          }), title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffBioCard_Title, {
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {})]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bio, {
          children: bio
        })]
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/StaffWithBio.tsx






var StaffWithBio_Heading = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "ecne3ct1"
} : 0)(typography/* typography.h2 */.cp.h2, " margin-bottom:30px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:60px;}" + ( true ? "" : 0));

var StaffWithBio_Wrapper = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecne3ct0"
} : 0)( true ? "" : 0);

var StaffWithBio = function StaffWithBio(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [!!title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffWithBio_Heading, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffWithBio_Wrapper, {
      children: children
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/StaffWithBioContainer.tsx






var StaffWithBioContainer = function StaffWithBioContainer(_ref) {
  var fields = _ref.fields,
      title = _ref.title;
  var items = fields === null || fields === void 0 ? void 0 : fields.filter(function (_ref2) {
    var employee = _ref2.employee;
    return employee;
  });

  if (items.length === 0) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffWithBio, {
      title: Prismic/* Prismic.text */.X5.text(title),
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (_ref3, index) {
        var _ref3$employee = _ref3.employee,
            image = _ref3$employee.image,
            name = _ref3$employee.name,
            title = _ref3$employee.title,
            bio = _ref3$employee.bio;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffBioCard, {
          image: image,
          name: Prismic/* Prismic.text */.X5.text(name),
          title: Prismic/* Prismic.text */.X5.text(title),
          bio: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
            value: bio
          })
        }, "staff-item-".concat(index));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/StaffCard.tsx



var StaffCard_excluded = ["staffImage", "ar", "name", "title", "email", "phone", "location", "hasImage", "percentage"];

function StaffCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function StaffCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { StaffCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { StaffCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function StaffCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var StaffCard_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "ebmxeg6"
} : 0)("display:flex;flex-flow:column nowrap;justify-content:flex-start;position:relative;width:100%;background-color:", function (props) {
  return props.theme.colors.background;
}, ";" + ( true ? "" : 0));

var StaffCard_ImageWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebmxeg5"
} : 0)("margin-left:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-right:", function (props) {
  return "-".concat(props.theme.containerGutter, "px");
}, ";margin-bottom:2em;", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.tablet */.U.tablet, "{margin-left:0;margin-right:0;margin-bottom:24px;}" + ( true ? "" : 0));

var StaffCard_Name = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "ebmxeg4"
} : 0)(typography/* typography.h3 */.cp.h3, ";" + ( true ? "" : 0));

var StaffCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebmxeg3"
} : 0)( true ? "" : 0);

var StaffCard_Location = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebmxeg2"
} : 0)( true ? "" : 0);

var StaffCard_Email = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "ebmxeg1"
} : 0)( true ? {
  name: "mpax7p",
  styles: "text-transform:lowercase;&:hover{opacity:0.8;}"
} : 0);

var Phone = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "ebmxeg0"
} : 0)( true ? {
  name: "zqnfaz",
  styles: "&:hover{opacity:0.8;}"
} : 0);

var StaffCard = function StaffCard(_ref) {
  var staffImage = _ref.staffImage,
      _ref$ar = _ref.ar,
      ar = _ref$ar === void 0 ? 'ar_1_1' : _ref$ar,
      name = _ref.name,
      title = _ref.title,
      email = _ref.email,
      phone = _ref.phone,
      location = _ref.location,
      hasImage = _ref.hasImage,
      percentage = _ref.percentage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, StaffCard_excluded);

  // Remove everything not number
  var strippedNumber = (phone || '').replace(/\D+/g, ''); // Add space after 3rd number

  var formatedNumber = strippedNumber.replace(/^(.{3})(.*)$/, '$1 $2');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StaffCard_Host, StaffCard_objectSpread(StaffCard_objectSpread({}, rest), {}, {
    children: [!!staffImage && hasImage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffCard_ImageWrap, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
        src: staffImage,
        ar: ar,
        percentage: percentage
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffCard_Name, {
      children: name
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
      margin: "18px 0 16px"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffCard_Title, {
      children: title
    }), !!location && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffCard_Location, {
      children: location
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffCard_Email, {
      href: "mailto:".concat(email),
      target: "_blank",
      rel: "noopener",
      children: email
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Phone, {
      href: "tel:".concat(phone),
      children: formatedNumber
    })]
  }));
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/StaffWithContactContainer.tsx


var StaffWithContactContainer_excluded = ["employee", "show_image", "percentage"],
    StaffWithContactContainer_excluded2 = ["percentage"];

function StaffWithContactContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function StaffWithContactContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { StaffWithContactContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { StaffWithContactContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var StaffWithContactContainer_CardItem = function CardItem(_ref, i) {
  var _Prismic$text;

  var _ref$employee = _ref.employee,
      image = _ref$employee.image,
      name = _ref$employee.name,
      title = _ref$employee.title,
      email = _ref$employee.email,
      phone = _ref$employee.phone,
      location = _ref$employee.location,
      show_image = _ref.show_image,
      percentage = _ref.percentage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, StaffWithContactContainer_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffCard, StaffWithContactContainer_objectSpread({
    staffImage: image,
    name: Prismic/* Prismic.text */.X5.text(name),
    title: Prismic/* Prismic.text */.X5.text(title),
    location: (_Prismic$text = Prismic/* Prismic.text */.X5.text(location)) !== null && _Prismic$text !== void 0 ? _Prismic$text : undefined,
    email: Prismic/* Prismic.text */.X5.text(email),
    phone: Prismic/* Prismic.text */.X5.text(phone),
    hasImage: show_image !== false && !!image,
    percentage: percentage
  }, rest));
};

var StaffWithContactContainer = function StaffWithContactContainer(_ref2) {
  var fields = _ref2.fields,
      title = _ref2.title,
      id = _ref2.id,
      three_per_line = _ref2.three_per_line;
  var items = fields === null || fields === void 0 ? void 0 : fields.filter(function (_ref3) {
    var employee = _ref3.employee;
    return employee !== null;
  });

  if (items.length === 0) {
    return null;
  }

  var colCount = fields === null || fields === void 0 ? void 0 : fields.length;
  var columns = colCount <= 2 && three_per_line !== true ? 2 : 3;
  var imgSize = 1 / columns;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Segment/* Segment */.X, {
    id: id,
    children: [!(0,isEmptyText/* isEmptyText */.W)(title) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reveal/* Reveal */.U, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffWithBio_Heading, {
        children: Prismic/* Prismic.text */.X5.text(title)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardGroup, {
      columns: columns,
      children: items === null || items === void 0 ? void 0 : items.map(function (_ref4, index) {
        var percentage = _ref4.percentage,
            rest = (0,objectWithoutProperties/* default */.Z)(_ref4, StaffWithContactContainer_excluded2);

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffWithContactContainer_CardItem, StaffWithContactContainer_objectSpread({
          percentage: imgSize
        }, rest), "staff-item-".concat(index, "-").concat(Prismic/* Prismic.text */.X5.text(rest.employee.name)));
      })
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/icons/Aukakronur.tsx



var Aukakronur = function Aukakronur() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200",
    height: "215",
    viewBox: "0 0 200 215",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
        id: "path-1",
        d: "M0.793793103 0.368694779L118.956724 0.368694779 118.956724 111.645701 0.793793103 111.645701z"
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
        transform: "translate(-224 -371)",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
          transform: "translate(130 270)",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            transform: "translate(94 101)",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
              transform: "translate(35.345 .495)",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mask", {
                id: "mask-2",
                fill: "#fff",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("use", {
                  xlinkHref: "#path-1"
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#163E63",
                d: "M34.11 111.646c3.766-12.412 7.627-25.194 8.274-27.141l16.49-57.027h1.244c5.602 19.01 11.512 38.329 17.115 58.274l7.656 25.894h34.068L82.52.368H38.03C26.319 35.898 13.792 73.061.795 111.646H34.11z",
                mask: "url(#mask-2)"
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M135.865 164.807c5.273 16.813 10.298 33.6 15.601 49.824h36.404l-16.317-49.824h-35.688z"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M18.435 164.807a15253.827 15253.827 0 00-16.618 49.824h35.468l15.596-49.824H18.435z"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M12.776 129.853c-.188-.738-.443-1.474-.666-2.213h-.07l-.701 2.251c-.847 2.653-2.356 7.079-3.126 9.881h7.657a539.48 539.48 0 00-3.094-9.919zm5.262 16.887c-.403-1.29-.918-2.985-1.33-4.166H7.253c-.333 1.033-.92 2.8-1.29 4.166h2.502v2.802H.001v-2.802h2.06l7.622-22.493h5.042c2.395 7.303 5.046 15.23 7.437 22.493h2.062v2.802h-8.616v-2.802h2.43z"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M26.613 144.197v-9.844h-2.575v-2.84h6.514v12.02c0 2.03.256 3.171 2.616 3.171 1.176 0 3.165-.518 4.788-2.027v-10.324h-2.32v-2.84h6.256v15.227h2.54v2.324c-1.36.518-2.724.703-3.57.703-1.806 0-2.616-.555-2.8-2.326-2.17 1.99-4.528 2.508-6.073 2.508-4.564 0-5.377-2.802-5.377-5.752"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M56.693 131.547h7.804v2.658h-1.659l-4.822 4.13 5.23 8.557 2.354.327v2.104c-.924.33-2.173.48-2.946.48-.992 0-1.913-.15-2.652-1.366l-4.742-8.001c-.851.702-1.586 1.366-2.394 2.064v4.425h2.279v2.617h-8.686v-2.617h2.503v-20.98H46.2v-2.618h6.666v15.56l5.445-4.682h-1.618v-2.658z"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M74.627 141.429c-2.058.15-3.163 1.33-3.163 2.843 0 1.917.882 2.803 2.983 2.803 1.324 0 3.016-.776 4.192-1.883v-4.055l-4.012.292zm7.808 5.35h2.798l.217 2.212c-.993.552-3.126.775-4.122.775-1.435 0-2.429-.333-2.464-2.25-.036 0-.036-.037-.078-.037-2.61 2.357-5.004 2.395-6.072 2.395-4.307 0-5.336-3.095-5.336-5.197 0-2.914 1.986-5.053 6.993-5.384l4.342-.296v-1.069c0-2.692-.846-3.725-3.606-3.725-1.766 0-3.793.37-5.522.959a48.914 48.914 0 01-.736-2.507c2.06-.92 4.822-1.437 7.178-1.437 4.013 0 6.408 1.548 6.408 6.083v9.478z"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M97.487 131.547h7.805v2.658h-1.657l-4.825 4.13 5.23 8.557 2.353.327v2.104c-.919.33-2.169.48-2.945.48-.995 0-1.913-.15-2.648-1.366l-4.752-8.001c-.845.702-1.582 1.366-2.39 2.064v4.425h2.28v2.617H87.25v-2.617h2.505v-20.98h-2.76v-2.618h6.663v15.56l5.445-4.682h-1.616v-2.658z"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M108.388 131.512l6.26-.036v2.727c.036 0 .108.038.145.038 1.398-1.547 4.196-3.17 7.106-3.17v3.722c-3.018.222-5.78 1.293-7.18 2.14v9.845h2.721v2.764h-9.129v-2.764h2.504v-12.464h-2.427v-2.802z"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M131.217 129.853l-1.467-1.366 4.893-6.083 2.357 2.323-5.783 5.126zm.739 4.24c-3.644 0-4.564 3.32-4.564 6.526 0 3.357.663 6.304 4.454 6.304 3.534 0 4.344-3.206 4.344-6.304 0-3.02-.697-6.526-4.234-6.526zm-.368 15.746c-6.071 0-8.245-4.24-8.245-9.22 0-4.94 2.429-9.476 8.54-9.476 6.222 0 8.32 4.537 8.32 9.403 0 4.792-2.174 9.293-8.615 9.293z"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M159.878 137.117v9.624h2.723v2.323c-1.028.479-2.648.7-3.642.7-2.91 0-2.983-2.174-2.983-2.914v-8.994c0-2.434-.406-3.578-2.91-3.578-1.512 0-3.493.81-4.858 1.658v13.607h-3.902v-15.228h-2.577v-2.802h6.48v1.585l.182.036c2.064-1.329 4.197-2.026 6.004-2.026 5.19 0 5.483 3.907 5.483 6.009"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M165.647 144.197v-9.844h-2.575v-2.84h6.516v12.02c0 2.03.253 3.171 2.613 3.171 1.177 0 3.167-.518 4.788-2.027v-10.324h-2.325v-2.84h6.26v15.227h2.54v2.324c-1.357.518-2.725.703-3.568.703-1.807 0-2.615-.555-2.8-2.326-2.175 1.99-4.526 2.508-6.074 2.508-4.563 0-5.375-2.802-5.375-5.752"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
              fill: "#163E63",
              d: "M185.685 131.512l6.26-.036v2.727c.036 0 .106.038.144.038 1.4-1.547 4.195-3.17 7.103-3.17v3.722c-3.019.222-5.778 1.293-7.18 2.14v9.845h2.726v2.764h-9.128v-2.764h2.5v-12.464h-2.425v-2.802z"
            })]
          })
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/vertical-reel/VerticalReel.tsx


function VerticalReel_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/* eslint-disable jsx-a11y/alt-text */





var WIDTH = 566;
var HEIGHT = 718; // house 0-200
// apple 0-240
// lemon 0-500
// coffee blue 86-530
// ice cream 110-800
// basketball 245-860
// laptop 433-1004
// ticket 680-1470
// stroller 640-740
// coffee green 662-1226
// noodles 595-1220
// whalesplash 290-354
// golfball 90-280

var VerticalReel_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1acx1pd7"
} : 0)( true ? {
  name: "b9gkxu",
  styles: "width:566px;height:744px;display:flex;flex-direction:row;overflow:hidden;position:relative;margin-top:-40px;margin-bottom:-40px"
} : 0);

var Reel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1acx1pd6"
} : 0)( true ? {
  name: "phm74y",
  styles: "position:relative;width:100%;height:100%;will-change:transform"
} : 0);

var VerticalReel_Box = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1acx1pd5"
} : 0)("position:absolute;width:", function (props) {
  return (props.width || 100) / WIDTH * 100;
}, "%;height:", function (props) {
  return (props.height || 100) / HEIGHT * 100;
}, "%;margin-bottom:20px;top:", function (props) {
  return (props.y || 0) / HEIGHT * 100;
}, "%;left:", function (props) {
  return (props.x || 0) / WIDTH * 100;
}, "%;transform:translate3d(0px, 0px, 0px);" + ( true ? "" : 0));

var VerticalReel_frames = 1500;
var distance = 306.82451253;

var interpolateFrames = function interpolateFrames(y, a1, a2, b1, b2) {
  var neg = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return y.to(function (v) {
    return "".concat(VerticalReel_interpolate(-parseFloat(v), a1 / VerticalReel_frames * distance, a2 / VerticalReel_frames * distance, b1, b2) * (neg ? -1 : 1), "%");
  });
};

var VerticalReel_clamp = function clamp(x, min, max) {
  return Math.max(min, Math.min(max, x));
};

var VerticalReel_interpolate = function interpolate(x, x1, x2, y1, y2) {
  if (x1 === x2) {
    return VerticalReel_clamp((y1 + y2) / 2, y1, y2);
  }

  return VerticalReel_clamp((x - x1) * (y2 - y1) / (x2 - x1) + y1, y1, y2);
};

var BottomWrap = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1acx1pd4"
} : 0)( true ? {
  name: "12czmtd",
  styles: "position:absolute;width:100%;bottom:0;will-change:transform"
} : 0);

function Bottom(_ref) {
  var children = _ref.children,
      from = _ref.from,
      to = _ref.to,
      y = _ref.y;
  var ref = (0,react.useRef)(null);

  var _useState = (0,react.useState)(null),
      ratio = _useState[0],
      setRatio = _useState[1];

  var updateRatio = function updateRatio() {
    if (ref.current && ref.current.parentElement) {
      setRatio(ref.current.parentElement.getBoundingClientRect().height / ref.current.getBoundingClientRect().height);
    }
  };

  (0,react.useEffect)(function () {
    if (ref.current) {
      var img = ref.current.querySelector('img');

      if (img) {
        if (img.complete) updateRatio();else img.onload = function () {
          return updateRatio();
        };
      }
    }
  }, [ref]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomWrap, {
    ref: ref,
    style: ratio && y ? {
      y: interpolateFrames(y, from, to, 0, (ratio - 1) * 100, true)
    } : {},
    children: children
  });
}

var TopWrap = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1acx1pd3"
} : 0)( true ? {
  name: "i2cpri",
  styles: "position:absolute;width:100%;top:0;will-change:transform"
} : 0);

function VerticalReel_Top(_ref2) {
  var children = _ref2.children,
      from = _ref2.from,
      to = _ref2.to,
      y = _ref2.y;
  var ref = (0,react.useRef)(null);

  var _useState2 = (0,react.useState)(null),
      ratio = _useState2[0],
      setRatio = _useState2[1];

  var updateRatio = function updateRatio() {
    if (ref.current && ref.current.parentElement) {
      setRatio(ref.current.parentElement.getBoundingClientRect().height / ref.current.getBoundingClientRect().height);
    }
  };

  (0,react.useEffect)(function () {
    if (ref.current) {
      var img = ref.current.querySelector('img');

      if (img) {
        if (img.complete) updateRatio();else img.onload = function () {
          return updateRatio();
        };
      }
    }
  }, [ref]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopWrap, {
    ref: ref,
    style: ratio && y ? {
      y: interpolateFrames(y, from, to, 0, (ratio - 1) * 100)
    } : {},
    children: children
  });
}

var VerticalReel_Right = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1acx1pd2"
} : 0)( true ? {
  name: "14jxwwp",
  styles: "position:absolute;height:100%;right:0"
} : 0);

var GradientTop = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1acx1pd1"
} : 0)( true ? {
  name: "1hwcp48",
  styles: "position:absolute;top:6px;left:0;right:0;height:34px;z-index:99;background-image:linear-gradient(\n    0deg,\n    rgba(255, 255, 225, 0) 0%,\n    rgba(255, 255, 255, 1) 75%\n  )"
} : 0);

var GradientBottom = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(GradientTop,  true ? {
  target: "e1acx1pd0"
} : 0)( true ? {
  name: "7yqkwu",
  styles: "top:auto;bottom:-1px;background-image:linear-gradient(\n    180deg,\n    rgba(255, 255, 225, 0) 0%,\n    rgba(255, 255, 255, 1) 75%\n  )"
} : 0);

function VerticalReel() {
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm', true);

  var _useSpring = (0,react_spring_esm.useSpring)({
    loop: true,
    from: {
      y: '-0%'
    },
    to: {
      y: "-".concat(distance, "%")
    },
    config: {
      duration: 25000,
      easing: function easing(t) {
        return t;
      } // linear

    }
  }),
      y = _useSpring.y;

  if (isMobile) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VerticalReel_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GradientTop, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GradientBottom, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Reel, {
      style: {
        y: y
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 0,
        y: -25,
        width: 182,
        height: 195,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Flokkar_Matvara.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 220,
        y: 30,
        width: 140,
        height: 140,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Record.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 396,
        y: 0,
        width: 170,
        height: 170,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Flokkar_Billinn.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 0,
        y: 184,
        width: 154,
        height: 178,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Flokkar_Ferdalog.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 160,
        y: 170,
        width: 260,
        height: 230,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Top, {
          from: 0,
          to: 200,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Flokkar_Heimilid.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 420,
        y: 170,
        width: 146,
        height: 230,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bottom, {
          from: 0,
          to: 240,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Flokkar_Heilsan.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 0,
        y: 415,
        width: 130,
        height: 130,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Dragonfruit.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VerticalReel_Box, {
        color: "blue",
        x: 147,
        y: 450,
        width: 132,
        height: 395,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Top, {
          from: 90,
          to: 280,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Golfball.svg"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Golfgreen.svg",
          style: {
            width: '100%',
            height: '102.6%'
          }
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 315,
        y: 400,
        width: 214,
        height: 316,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Sub.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 0,
        y: 545,
        width: 130,
        height: 350,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bottom, {
          from: 0,
          to: 500,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Lemon.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 279,
        y: 772,
        width: 130,
        height: 130,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Tire_quarter.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 431,
        y: 680,
        width: 135,
        height: 226,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bottom, {
          from: 86,
          to: 530,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Coffee_blue.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VerticalReel_Box, {
        color: "blue",
        x: 0,
        y: 914,
        width: 260,
        height: 177,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_spring_esm.animated.div, {
          id: "dot",
          style: {
            position: 'absolute',
            bottom: 96,
            width: '6.153846154%',
            height: '9.039548023%',
            left: '52%',
            y: interpolateFrames(y, 290, 381, 0, 1000, true),
            zIndex: 80
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Whale_03-01.svg"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_spring_esm.animated.div, {
          id: "squish",
          style: {
            position: 'absolute',
            bottom: 0,
            width: "".concat(60 / 260 * 100, "%"),
            height: "".concat(110 / 177 * 100, "%"),
            left: '50%',
            marginLeft: "-".concat(60 / 260 * 50, "%"),
            y: interpolateFrames(y, 290, 354, 0, 118, true),
            zIndex: 90
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Whale_02.svg"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Whale_01.svg",
          style: {
            position: 'relative',
            zIndex: 100
          }
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 434,
        y: 919,
        width: 132,
        height: 132,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Watermelon.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 279,
        y: 902,
        width: 130,
        height: 356,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bottom, {
          from: 110,
          to: 800,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/IceCream.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 0,
        y: 1120,
        width: 260,
        height: 262,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Basketball.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 434,
        y: 1051,
        width: 132,
        height: 265,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bottom, {
          from: 272,
          to: 810,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Plant.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 434,
        y: 1316,
        width: 132,
        height: 132,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Fruitbox.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 276,
        y: 1259,
        width: 131,
        height: 194,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Paperclip.svg",
          style: {
            height: '100%',
            width: '100%'
          }
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 0,
        y: 1402,
        width: 260,
        height: 189,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Top, {
          from: 433,
          to: 1004,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Laptop.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 260,
        y: 1445,
        width: 306,
        height: 282,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Right, {
          style: {
            x: interpolateFrames(y, 640, 740, 0, 10, true)
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Stroller.svg",
            style: {
              height: '100%'
            }
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 0,
        y: 1591,
        width: 140,
        height: 140,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Record.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 0,
        y: 1649,
        width: 260,
        height: 292,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bottom, {
          from: 595,
          to: 1220,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Noodles.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 0,
        y: 1915,
        width: 148,
        height: 196,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bottom, {
          from: 820,
          to: 1426,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Flokkar_Gjafavara.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 276,
        y: 1727,
        width: 131,
        height: 231,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Top, {
          from: 662,
          to: 1226,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Coffee_green.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 435,
        y: 1737,
        width: 131,
        height: 438,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Top, {
          from: 680,
          to: 1470,
          y: y,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Ticket.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 181,
        y: 1958,
        width: 226,
        height: 245,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Flokkar_Fatnadur.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 0,
        y: -25 + 2203,
        width: 182,
        height: 195,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Flokkar_Matvara.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 220,
        y: 30 + 2203,
        width: 140,
        height: 140,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Record.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 396,
        y: 0 + 2203,
        width: 170,
        height: 170,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Flokkar_Billinn.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 0,
        y: 184 + 2203,
        width: 154,
        height: 178,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Flokkar_Ferdalog.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 160,
        y: 170 + 2203,
        width: 260,
        height: 230,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Top, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Flokkar_Heimilid.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 420,
        y: 170 + 2203,
        width: 146,
        height: 230,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bottom, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Flokkar_Heilsan.svg"
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 0,
        y: 415 + 2203,
        width: 130,
        height: 130,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Dragonfruit.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VerticalReel_Box, {
        color: "blue",
        x: 147,
        y: 450 + 2203,
        width: 132,
        height: 395,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Top, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Golfball.svg"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Golfgreen.svg"
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "#a0a0a0",
        x: 315,
        y: 400 + 2203,
        width: 214,
        height: 316,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
          src: "/svgs/Sub.svg"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel_Box, {
        color: "blue",
        x: 0,
        y: 545 + 2203,
        width: 130,
        height: 350,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bottom, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: "/svgs/Lemon.svg"
          })
        })
      })]
    })]
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/components/video/Video.tsx


function Video_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var Video_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eer2jz61"
} : 0)("margin:0 -20px;@media ", devices/* device.tablet */.U.tablet, "{margin:0;}" + ( true ? "" : 0));

var VideoEl = (0,emotion_styled_base_browser_esm/* default */.Z)("video",  true ? {
  target: "eer2jz60"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var Video_Video = function Video(_ref) {
  var src = _ref.src,
      muted = _ref.muted,
      poster = _ref.poster,
      loop = _ref.loop,
      width = _ref.width,
      autoPlay = _ref.autoPlay;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video_Host, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoEl, {
      width: width,
      loop: loop,
      poster: poster,
      muted: muted,
      playsInline: true,
      autoPlay: autoPlay,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        src: src,
        type: "video/mp4"
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/hero-sub/SubPageHero.tsx



function SubPageHero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var BackgroundColor;

(function (BackgroundColor) {
  BackgroundColor["BLUE_GRADIENT"] = "Blue Gradient";
  BackgroundColor["LIGHT_BLUE"] = "Light Blue";
  BackgroundColor["LIGHT_ORANGE"] = "Light Orange";
  BackgroundColor["AUKAKRONUR"] = "Aukakronur";
  BackgroundColor["TRANSPARENT"] = "Transparent";
})(BackgroundColor || (BackgroundColor = {}));

var SubPageHero_isEmpty = function isEmpty(value) {
  if (react.Children.count(value) === 0) {
    return true;
  }

  return String(value !== null && value !== void 0 ? value : '').trim() === '';
};

var SubPageHero_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ccpdk113"
} : 0)("position:relative;padding-bottom:1px;margin-bottom:", function (props) {
  return props.hasButton ? '116px' : '72px';
}, ";color:", function (props) {
  return props.backgroundColor === BackgroundColor.BLUE_GRADIENT || !props.backgroundColor ? props.theme.colors.background : props.theme.colors.foreground;
}, ";@media ", devices/* device.tablet */.U.tablet, "{padding-top:28px;margin-bottom:116px;", function (props) {
  return props.interactive ? 'padding-top: 52px;' : '';
}, ";}" + ( true ? "" : 0));

var SubPageHero_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1ccpdk112"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{", mixins/* container */.nC, ";}" + ( true ? "" : 0));

var SubPageHero_P = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1ccpdk111"
} : 0)(typography/* typography.p2 */.cp.p2, " margin-left:28px;letter-spacing:0.38px;max-width:500px;margin-top:", function (props) {
  return props.top ? '24px' : '0';
}, ";" + ( true ? "" : 0));

var Aukakronurnar = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1ccpdk110"
} : 0)("display:flex;justify-content:center;@media ", devices/* device.tablet */.U.tablet, "{justify-content:flex-start;margin-top:-13px;margin-left:34px;margin-bottom:15px;}" + ( true ? "" : 0));

var SubPageHero_Image = (0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1ccpdk19"
} : 0)( true ? {
  name: "1vfhcql",
  styles: "object-fit:cover"
} : 0).withComponent(Img,  true ? {
  target: "e1ccpdk114"
} : 0);

var SubPageHero_AspectRatio = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ccpdk18"
} : 0)("position:relative;display:flex;flex-flow:column nowrap;margin-bottom:-50px;@media ", devices/* device.tablet */.U.tablet, "{flex-direction:row-reverse;&:before{padding-bottom:", function () {
  return 1 / (16 / 9) * 100;
}, "%;content:'';float:left;}&:after{display:table;content:'';clear:both;}}" + ( true ? "" : 0));

var SubPageHero_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e1ccpdk17"
} : 0)(function (props) {
  return props.smallerFont ? typography/* typography.heroSmall */.cp.heroSmall : typography/* typography.h1 */.cp.h1;
}, " max-width:calc((690 / ", typography/* sizes.h2Size */.J7.h2Size, ") * 1em);color:#fff;margin:0;margin-bottom:36px;@media ", devices/* device.tablet */.U.tablet, "{", typography/* typography.h2 */.cp.h2, " margin-bottom:30px;color:inherit;}@media ", devices/* device.desktop */.U.desktop, "{", function (props) {
  return props.smallerFont ? typography/* typography.heroSmall */.cp.heroSmall : typography/* typography.h1 */.cp.h1;
}, " margin-bottom:50px;}" + ( true ? "" : 0));

var SubPageHero_Description = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ccpdk16"
} : 0)("font-family:", function (props) {
  return props.theme.font.family;
}, ";font-size:24px;letter-spacing:0.38px;text-align:left;line-height:34px;color:#fff;@media ", devices/* device.tablet */.U.tablet, "{color:inherit;}div{", typography/* typography.p2 */.cp.p2, " ul li{", typography/* typography.heroListStyle */.cp.heroListStyle, " &:before{color:", function (props) {
  return props.backgroundColor === BackgroundColor.BLUE_GRADIENT ? props.theme.colors.secondary : 'currentColor';
}, ";}}}" + ( true ? "" : 0));

var SubPageHero_Background = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ccpdk15"
} : 0)("position:absolute;top:0;left:0;right:0;bottom:0;", function (props) {
  switch (props.backgroundColor) {
    case BackgroundColor.BLUE_GRADIENT:
      return "background-image: ".concat(props.theme.gradients.primary, ";");

    case BackgroundColor.LIGHT_BLUE:
      return "background-color: ".concat(props.theme.shades.ternary2, ";");

    case BackgroundColor.LIGHT_ORANGE:
      return "background-color: #FFE7D5;";

    case BackgroundColor.AUKAKRONUR:
      return "background: ".concat(props.theme.gradients.aukakronur);
  }
}, ";" + ( true ? "" : 0));

var SubPageHero_ImageAspect = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ccpdk14"
} : 0)("width:100%;&:before{content:'';display:block;padding-top:100%;@media ", devices/* device.tablet */.U.tablet, "{", function (props) {
  return props.imgOverflow ? 'display: none;' : 'display: block;';
}, ";}}>:first-child{position:absolute;top:0;left:0;height:100%;width:100%;", function (props) {
  return props.imgOverflow ? 'max-width: none;' : '';
}, ";}@media ", devices/* device.tablet */.U.tablet, "{position:absolute;bottom:-31px;right:-40px;", function (props) {
  if (props.imgOverflow) {
    return "\n        bottom: -64px;\n        left: 0;\n        width: calc(100% + 50px);\n        top: -44px;\n\n        * {\n          height: 100%;\n        }\n\n        img {\n          height: 100%;\n          object-fit: contain;\n        }\n      ";
  }
}, ";}@media ", devices/* device.desktop */.U.desktop, "{right:-63px;", function (props) {
  if (props.imgOverflow) {
    return "\n        width: calc(100% + 70px);\n\n        img {\n          object-fit: cover;\n        }\n      ";
  }
}, ";}" + ( true ? "" : 0));

var SubPageHero_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ccpdk13"
} : 0)("position:relative;padding:34px 34px 30px;", mixins/* container */.nC, ";display:flex;flex-direction:column;", function (props) {
  switch (props.backgroundColor) {
    case BackgroundColor.LIGHT_BLUE:
      return "background-color: ".concat(props.theme.shades.ternary2, ";");

    case BackgroundColor.LIGHT_ORANGE:
      return "background-color: #FFE7D5;";

    case BackgroundColor.TRANSPARENT:
      return "background-color: transparent;";

    default:
      return "background-color: ".concat(props.theme.colors.primary, ";");
  }
}, "@media ", devices/* device.mobile */.U.mobile, "{padding:34px 44px 30px;}@media ", devices/* device.tablet */.U.tablet, "{padding:115px 0 63px 44px;background-color:transparent;width:calc(50% + 60px);}@media ", devices/* device.desktop */.U.desktop, "{padding:115px 0 63px 63px;}" + ( true ? "" : 0));

var SubPageHero_Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1ccpdk12"
} : 0)("display:flex;flex:1;flex-direction:column;padding-bottom:56px;color:", function (props) {
  return props.backgroundColor === BackgroundColor.BLUE_GRADIENT || !props.backgroundColor ? props.theme.colors.background : props.theme.colors.foreground;
}, ";@media ", devices/* device.tablet */.U.tablet, "{padding-bottom:36px;}" + ( true ? "" : 0));

var SubPageHero_Actions = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1ccpdk11"
} : 0)("margin-bottom:-60px;display:flex;flex-direction:column;align-items:flex-start;>a{margin-top:20px;width:100%;}>*:first-child{margin-top:0;}@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:-94px;>a{margin-top:30px;width:296px;}}" + ( true ? "" : 0));

var SubPageHero_Column = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ccpdk10"
} : 0)("position:relative;width:100%;@media ", devices/* device.tablet */.U.tablet, "{width:51%;}" + ( true ? "" : 0));

function SubPageHero(props) {
  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)(useReveal/* inViewConfig */.BT),
      _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  var isAnimated = props.isAnimated,
      specialHero = props.specialHero,
      image = props.image,
      video = props.video,
      title = props.title,
      _props$backgroundColo = props.backgroundColor,
      backgroundColor = _props$backgroundColo === void 0 ? BackgroundColor.BLUE_GRADIENT : _props$backgroundColo,
      actions = props.actions,
      actions2 = props.actions2,
      description = props.description,
      overflow = props.overflow,
      smallerFont = props.smallerFont;
  var hasButton = !!actions || !!actions2;
  var visible = isAnimated !== null && isAnimated !== void 0 ? isAnimated : inView;
  var delay = 0;
  var copyStyle = (0,react_spring_esm.useSpring)({
    opacity: visible ? 1 : 0,
    y: visible ? 0 : 20,
    delay: delay
  });
  var actionsStyle = (0,react_spring_esm.useSpring)({
    opacity: visible ? 1 : 0,
    overflow: 'hidden',
    delay: delay + 100,
    config: {
      tension: 320
    }
  });
  var imageStyle = (0,react_spring_esm.useSpring)({
    x: visible ? '0%' : '101%'
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_Host, {
    ref: ref,
    backgroundColor: backgroundColor,
    hasButton: hasButton,
    interactive: specialHero === 'aukakronur',
    id: "hero",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_Container, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SubPageHero_AspectRatio, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_Background, {
          backgroundColor: backgroundColor
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_Column, {
          children: specialHero === 'aukakronur' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalReel, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_ImageAspect, {
            imgOverflow: overflow,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_spring_esm.animated.div, {
              style: overflow ? actionsStyle : {
                overflow: 'hidden',
                transform: imageStyle.x.to(function (v) {
                  return "translateX(-".concat(v, ")");
                })
              },
              children: video !== undefined && video !== null ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video_Video, {
                src: video.url,
                poster: image === null || image === void 0 ? void 0 : image.url,
                autoPlay: true,
                loop: true
              }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_Image, {
                src: image,
                ar: "ar_1_1",
                isFit: !overflow,
                containerStyle: imageStyle,
                percentage: overflow ? 0.6 : 0.5
              })
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SubPageHero_Content, {
          backgroundColor: specialHero === 'aukakronur' ? BackgroundColor.TRANSPARENT : undefined,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_Copy, {
            backgroundColor: backgroundColor,
            style: copyStyle,
            children: specialHero !== 'aukakronur' ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [!SubPageHero_isEmpty(title) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_Title, {
                image: image,
                smallerFont: smallerFont,
                children: title
              }), !SubPageHero_isEmpty(description) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_Description, {
                backgroundColor: backgroundColor,
                children: description
              })]
            }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aukakronurnar, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Aukakronur, {})
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_P, {
                top: true,
                children: "Aukakr\xF3nur er fr\xED\xF0indakerfi Landsbankans."
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero_P, {
                children: "\xDE\xFA safnar Aukakr\xF3num \xFEegar \xFE\xFA notar kreditkort tengt Aukakr\xF3nus\xF6fnun."
              })]
            })
          }), !SubPageHero_isEmpty(actions || actions2) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SubPageHero_Actions, {
            style: actionsStyle,
            children: [actions, actions2]
          })]
        })]
      })
    })
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/SubPageHeroContainer.tsx






var BackgroundColorMap = {
  'Blue Gradient': BackgroundColor.BLUE_GRADIENT,
  'Light Blue': BackgroundColor.LIGHT_BLUE,
  'Light Orange': BackgroundColor.LIGHT_ORANGE,
  Aukakronur: BackgroundColor.AUKAKRONUR
};
var SubPageHeroContainer = function SubPageHeroContainer(_ref) {
  var _buttonLinkdata$title, _buttonLinkdata2$titl, _;

  var background_color = _ref.background_color,
      title = _ref.title,
      copy = _ref.copy,
      special_hero = _ref.special_hero,
      smaller_font = _ref.smaller_font,
      image = _ref.image,
      hero_video = _ref.hero_video,
      video = _ref.video,
      image_overflow = _ref.image_overflow,
      button_text = _ref.button_text,
      link = _ref.link,
      button_text_2 = _ref.button_text_2,
      link_2 = _ref.link_2;
  var buttonLinkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var buttonTitle = (0,fallback/* fallbackText */.mn)(button_text, (_buttonLinkdata$title = buttonLinkdata.title) !== null && _buttonLinkdata$title !== void 0 ? _buttonLinkdata$title : undefined);
  var buttonLinkdata2 = (0,fallback/* getDataFromLink */.rm)(link_2);
  var buttonTitle2 = (0,fallback/* fallbackText */.mn)(button_text_2, (_buttonLinkdata2$titl = buttonLinkdata2.title) !== null && _buttonLinkdata2$titl !== void 0 ? _buttonLinkdata2$titl : undefined);
  var action2 = link_2 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link_2,
    title: buttonTitle2 !== null && buttonTitle2 !== void 0 ? buttonTitle2 : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_Button/* Button */.z, {
      as: "a",
      title: buttonTitle2 !== null && buttonTitle2 !== void 0 ? buttonTitle2 : undefined,
      id: "main_cta_button"
    })
  }) : null;
  var action = link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link,
    title: buttonTitle !== null && buttonTitle !== void 0 ? buttonTitle : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttons_Button/* Button */.z, {
      as: "a",
      title: buttonTitle !== null && buttonTitle !== void 0 ? buttonTitle : undefined,
      bordered: !!action2,
      bg: !!action2 && background_color !== 'Blue Gradient' ? theme/* theme.colors.primary */.r.colors.primary : !!action2 && background_color === 'Blue Gradient' ? '#fff' : theme/* theme.colors.secondary */.r.colors.secondary,
      id: !!action2 ? 'secondary_cta_button' : 'main_cta_button'
    })
  }) : null;
  var titleEl = (0,utils_src/* hyphenate */.rs)(Prismic/* Prismic.text */.X5.text(title)); // check for image as title

  if ((title === null || title === void 0 ? void 0 : (_ = title[0]) === null || _ === void 0 ? void 0 : _.type) === 'image') {
    titleEl = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
      src: title[0].url,
      alt: title[0].alt,
      style: {
        height: 57
      }
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHero, {
    title: titleEl,
    description: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
      value: copy,
      hyphenate: true
    }),
    image: image,
    video: hero_video !== null && hero_video !== void 0 ? hero_video : video,
    backgroundColor: BackgroundColorMap[background_color],
    actions: action,
    actions2: action2,
    smallerFont: smaller_font,
    overflow: image_overflow,
    specialHero: special_hero
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TableContainer.tsx






var TableContainer_TableContainer = function TableContainer(_ref) {
  var _Prismic$text;

  var bg = _ref.bg,
      layout = _ref.layout,
      zebra_color = _ref.zebra_color,
      text = _ref.text,
      table_title = _ref.table_title,
      table = _ref.table;
  var source = (0,InlineExpression/* useInlineExpressions */.kP)((_Prismic$text = Prismic/* Prismic.text */.X5.text(table)) !== null && _Prismic$text !== void 0 ? _Prismic$text : '');

  if ((0,isEmptyText/* isEmptyText */.W)(table)) {
    return null;
  }

  var themeColor = function themeColor(type) {
    switch (type) {
      case 'Gray':
        return 'primary';

      case 'White':
        return 'primary';

      case 'Blue':
        return 'ternary';

      case 'Orange':
        return 'secondary';

      default:
        'primary';
    }
  };

  var copy = !(0,isEmptyText/* isEmptyText */.W)(text) ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
    value: text
  }) : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Segment/* Segment */.X, {
    children: [!(0,isEmptyText/* isEmptyText */.W)(table_title) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
      value: table_title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrismicTable, {
      background: bg,
      layout: layout,
      theme: themeColor(zebra_color),
      copy: copy,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        dangerouslySetInnerHTML: {
          __html: source !== null && source !== void 0 ? source : ''
        }
      })
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/ui/src/components/table/TableWithImages.tsx








var TableWithImages_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  target: "ek5oygs0"
} : 0)((0,mixins/* standardTable */._L)('White', true), " width:100%;table thead th{font-weight:bold;border-bottom:1px solid ", function (props) {
  return props.theme.colors.primary;
}, ";padding-bottom:10px;font-family:", function (props) {
  return props.theme.font.family;
}, ";font-size:12px;padding-left:6px;text-align:left;@media ", devices/* device.tablet */.U.tablet, "{font-size:", typography/* typography.sizes.bodySmallSize */.cp.sizes.bodySmallSize, "px;padding-left:0;text-align:center;}}table tbody tr>td{border-bottom:1px solid ", function (props) {
  return props.theme.colors.primary;
}, ";padding:20px 0px;}>div>div>table{width:", function (props) {
  return props.theme.pageWidth;
}, "px;}td{font-size:24px;font-weight:500;text-align:center;border-bottom:1px solid ", function (props) {
  return props.theme.colors.primary;
}, ";font-family:", function (props) {
  return props.theme.font.familySlab;
}, ";@media ", devices/* device.tablet */.U.tablet, "{font-size:", typography/* typography.sizes.numbersMSize */.cp.sizes.numbersMSize, "px;}}tr>td:nth-child(2){text-align:left;}tr>td:nth-child(2)>div{min-height:135px;display:flex;align-items:center;}tr>td:nth-child(2) *{font-size:14px;}tr>td:nth-child(1) *{font-size:12px;@media ", devices/* device.tablet */.U.tablet, "{padding-right:inherit;}}tr>td:nth-child(2) strong{font-weight:700;padding-bottom:5px;display:block;}table tbody tr>td:first-child{width:155px;padding-right:12px;box-sizing:content-box;@media ", devices/* device.tablet */.U.tablet, "{padding-right:88px;}}table thead th:first-child:after{content:initial;}tfoot td{border:0;font-size:", typography/* typography.sizes.bodySmallSize */.cp.sizes.bodySmallSize, "px;padding-top:15px;font-family:", function (props) {
  return props.theme.font.family;
}, ";font-weight:400;}" + ( true ? "" : 0));

function TableWithImages(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableWithImages_Host, {
    children: children
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TableWithImagesContainer.tsx





var TableWithImagesContainer = function TableWithImagesContainer(_ref) {
  var fields = _ref.fields,
      footer_text = _ref.footer_text,
      has_header = _ref.has_header;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  if (fields === null) {
    return null;
  }

  var header = fields.find(function (x) {
    return x.isheader;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableWithImages, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("table", {
        children: [has_header && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {}), !isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
              children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_1)
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
              align: "center",
              children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_2)
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
              align: "center",
              children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_3)
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
              align: "center",
              children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_4)
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
              align: "center",
              children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_5)
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
          children: fields.map(function (item, index) {
            if (item.isheader) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
            } else {
              var _item$image, _Prismic$text;

              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                children: [!isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    src: (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url,
                    width: "155px",
                    alt: (_Prismic$text = Prismic/* Prismic.text */.X5.text(item.text_1)) !== null && _Prismic$text !== void 0 ? _Prismic$text : 'Mynd'
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
                    value: item.text_1,
                    hyphenate: true
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                  children: Prismic/* Prismic.text */.X5.text(item.text_2)
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                  children: Prismic/* Prismic.text */.X5.text(item.text_3)
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                  children: Prismic/* Prismic.text */.X5.text(item.text_4)
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                  children: Prismic/* Prismic.text */.X5.text(item.text_5)
                })]
              }, "tr-".concat(index));
            }
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tfoot", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
              colSpan: 6,
              children: Prismic/* Prismic.text */.X5.text(footer_text)
            })
          })
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/table/TableWithLargeText.tsx




var HeadingText = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e18vvrks1"
} : 0)(typography/* typography.p2 */.cp.p2, " margin-bottom:60px;padding:0px 20px;" + ( true ? "" : 0));

var TableWithLargeText_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  target: "e18vvrks0"
} : 0)((0,mixins/* standardTable */._L)('Gray', true), " width:100%;padding:0px 20px;table{table-layout:fixed;}&>h2{font-size:18px;font-weight:500;text-align:left;font-family:", function (props) {
  return props.theme.font.familySlab;
}, ";margin-bottom:30px;}table thead th{border-bottom:3px solid ", function (props) {
  return props.theme.colors.primary;
}, ";padding-bottom:10px;text-align:right;font-family:", function (props) {
  return props.theme.font.family;
}, ";font-size:14px;padding-left:0px;@media ", devices/* device.tablet */.U.tablet, "{font-size:", typography/* typography.sizes.bodySmallSize */.cp.sizes.bodySmallSize, "px;padding-left:0;min-width:100px;}&:nth-child(1){font-size:14px;font-weight:400;text-align:left;font-family:", function (props) {
  return props.theme.font.family;
}, ";width:250px;&:after{display:none;}}@media ", devices/* device.tablet */.U.tablet, "{&:nth-child(1){font-size:18px;font-weight:500;text-align:left;font-family:", function (props) {
  return props.theme.font.familySlab;
}, ";&:after{display:none;}}}}table tbody tr{>td{border-bottom:1px solid rgba(30, 61, 90, 0.1);padding-top:10px;padding-bottom:3px;text-align:right;width:25%;}&:first-child{td{padding-top:20px;}}}table tbody tr:last-child td{border-color:rgba(30, 61, 90, 0.1);padding-bottom:3px;}>div>div>table{width:", function (props) {
  return props.theme.pageWidth;
}, "px;}td{font-size:14px;font-weight:400;text-align:center;border-bottom:1px solid ", function (props) {
  return props.theme.colors.primary;
}, ";font-family:", function (props) {
  return props.theme.font.family;
}, ";@media ", devices/* device.tablet */.U.tablet, "{font-size:14px;}}tr>td:nth-child(1){text-align:left;}tfoot td{border:0;font-size:", typography/* typography.sizes.bodySmallSize */.cp.sizes.bodySmallSize, "px;padding-top:11px;font-family:", function (props) {
  return props.theme.font.family;
}, ";font-weight:600;text-align:right;&:nth-child(1){text-align:left;}}" + ( true ? "" : 0));

function TableWithLargeText(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableWithLargeText_Host, {
    children: children
  });
}
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TableWithLargeTextContainer.tsx


function TableWithLargeTextContainer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var TableWithLargeTextContainer_Div = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1yzps6f3"
} : 0)( true ? {
  name: "v71xpc",
  styles: "max-width:979px;margin:0 auto"
} : 0);

var GrayBackground = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1yzps6f2"
} : 0)("background-color:", function (props) {
  return props.theme.colors.backgroundAlt;
}, ";padding-top:80px;padding-bottom:80px;" + ( true ? "" : 0));

var TableWithLargeTextContainer_Table = (0,emotion_styled_base_browser_esm/* default */.Z)("table",  true ? {
  target: "e1yzps6f1"
} : 0)( true ? {
  name: "1azpx8r",
  styles: "margin-bottom:20px"
} : 0);

var BoldTR = (0,emotion_styled_base_browser_esm/* default */.Z)("tr",  true ? {
  target: "e1yzps6f0"
} : 0)(function (props) {
  return props.bold ? 'td{font-weight:bold;}' : '';
}, ";" + ( true ? "" : 0));

var TableWithLargeTextContainer = function TableWithLargeTextContainer(_ref) {
  var _Prismic$text$length, _Prismic$text, _Prismic$text2, _Prismic$text3, _Prismic$text4, _Prismic$text5, _Prismic$text11, _Prismic$text12, _Prismic$text13, _Prismic$text14, _Prismic$text15, _Prismic$text16, _Prismic$text17, _Prismic$text18, _Prismic$text19;

  var fields = _ref.fields,
      text = _ref.text;
  var isMobile = (0,hooks_useMedia/* useMedia */.G)('sm');

  if (fields === null) {
    return null;
  }

  var header = fields.find(function (x) {
    return x.isheader;
  });
  var footer = fields.find(function (x) {
    return x.isfooter;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GrayBackground, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TableWithLargeTextContainer_Div, {
        children: [Prismic/* Prismic.text */.X5.text(text) && ((_Prismic$text$length = (_Prismic$text = Prismic/* Prismic.text */.X5.text(text)) === null || _Prismic$text === void 0 ? void 0 : _Prismic$text.length) !== null && _Prismic$text$length !== void 0 ? _Prismic$text$length : 0) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeadingText, {
          children: Prismic/* Prismic.text */.X5.text(text)
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableWithLargeText, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [!isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("table", {
              children: [header !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                    children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_1)
                  }), Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_2) && ((_Prismic$text2 = Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_2)) === null || _Prismic$text2 === void 0 ? void 0 : _Prismic$text2.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                    align: "center",
                    children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_2)
                  }), Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_3) && ((_Prismic$text3 = Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_3)) === null || _Prismic$text3 === void 0 ? void 0 : _Prismic$text3.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                    align: "center",
                    children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_3)
                  }), Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_4) && ((_Prismic$text4 = Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_4)) === null || _Prismic$text4 === void 0 ? void 0 : _Prismic$text4.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                    align: "center",
                    children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_4)
                  }), Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_5) && ((_Prismic$text5 = Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_5)) === null || _Prismic$text5 === void 0 ? void 0 : _Prismic$text5.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                    align: "center",
                    children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_5)
                  })]
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                children: fields.map(function (item, index) {
                  if (item.isheader) {
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
                  } else if (item.isfooter) {
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
                  } else {
                    var _Prismic$text6, _Prismic$text7, _Prismic$text8, _Prismic$text9, _Prismic$text10;

                    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BoldTR, {
                      bold: item.bold,
                      children: [Prismic/* Prismic.text */.X5.text(item.text_1) && ((_Prismic$text6 = Prismic/* Prismic.text */.X5.text(item.text_1)) === null || _Prismic$text6 === void 0 ? void 0 : _Prismic$text6.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                        children: Prismic/* Prismic.text */.X5.text(item.text_1)
                      }), Prismic/* Prismic.text */.X5.text(item.text_2) && ((_Prismic$text7 = Prismic/* Prismic.text */.X5.text(item.text_2)) === null || _Prismic$text7 === void 0 ? void 0 : _Prismic$text7.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                        children: Prismic/* Prismic.text */.X5.text(item.text_2)
                      }), Prismic/* Prismic.text */.X5.text(item.text_3) && ((_Prismic$text8 = Prismic/* Prismic.text */.X5.text(item.text_3)) === null || _Prismic$text8 === void 0 ? void 0 : _Prismic$text8.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                        children: Prismic/* Prismic.text */.X5.text(item.text_3)
                      }), Prismic/* Prismic.text */.X5.text(item.text_4) && ((_Prismic$text9 = Prismic/* Prismic.text */.X5.text(item.text_4)) === null || _Prismic$text9 === void 0 ? void 0 : _Prismic$text9.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                        children: Prismic/* Prismic.text */.X5.text(item.text_4)
                      }), Prismic/* Prismic.text */.X5.text(item.text_5) && ((_Prismic$text10 = Prismic/* Prismic.text */.X5.text(item.text_5)) === null || _Prismic$text10 === void 0 ? void 0 : _Prismic$text10.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                        children: Prismic/* Prismic.text */.X5.text(item.text_5)
                      })]
                    }, "tr-".concat(index));
                  }
                })
              }), footer !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tfoot", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                  children: [Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_1) && ((_Prismic$text11 = Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_1)) === null || _Prismic$text11 === void 0 ? void 0 : _Prismic$text11.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                    children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_1)
                  }), Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_2) && ((_Prismic$text12 = Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_2)) === null || _Prismic$text12 === void 0 ? void 0 : _Prismic$text12.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                    align: "center",
                    children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_2)
                  }), Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_3) && ((_Prismic$text13 = Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_3)) === null || _Prismic$text13 === void 0 ? void 0 : _Prismic$text13.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                    align: "center",
                    children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_3)
                  }), Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_4) && ((_Prismic$text14 = Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_4)) === null || _Prismic$text14 === void 0 ? void 0 : _Prismic$text14.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                    align: "center",
                    children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_4)
                  }), Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_5) && ((_Prismic$text15 = Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_5)) === null || _Prismic$text15 === void 0 ? void 0 : _Prismic$text15.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                    align: "center",
                    children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_5)
                  })]
                })
              })]
            }), isMobile && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [header != undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                children: Prismic/* Prismic.text */.X5.text(header.text_1)
              }), Prismic/* Prismic.text */.X5.text(fields[0].text_2) != undefined && ((_Prismic$text16 = Prismic/* Prismic.text */.X5.text(fields[0].text_2)) === null || _Prismic$text16 === void 0 ? void 0 : _Prismic$text16.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TableWithLargeTextContainer_Table, {
                children: [header !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                      colSpan: 2,
                      align: "center",
                      children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_2)
                    })
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                  children: fields.map(function (item, index) {
                    if (item.isheader) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
                    } else if (item.isfooter) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
                    } else {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BoldTR, {
                        bold: item.bold,
                        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                          children: Prismic/* Prismic.text */.X5.text(item.text_1)
                        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                          children: Prismic/* Prismic.text */.X5.text(item.text_2)
                        })]
                      }, "tr-".concat(index));
                    }
                  })
                }), footer !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tfoot", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                      children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_1)
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                      align: "center",
                      children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_2)
                    })]
                  })
                })]
              }), Prismic/* Prismic.text */.X5.text(fields[0].text_3) != undefined && ((_Prismic$text17 = Prismic/* Prismic.text */.X5.text(fields[0].text_3)) === null || _Prismic$text17 === void 0 ? void 0 : _Prismic$text17.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TableWithLargeTextContainer_Table, {
                children: [header !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                      colSpan: 2,
                      align: "center",
                      children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_3)
                    })
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                  children: fields.map(function (item, index) {
                    if (item.isheader) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
                    } else if (item.isfooter) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
                    } else {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BoldTR, {
                        bold: item.bold,
                        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                          children: Prismic/* Prismic.text */.X5.text(item.text_1)
                        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                          children: Prismic/* Prismic.text */.X5.text(item.text_3)
                        })]
                      }, "tr-".concat(index));
                    }
                  })
                }), footer !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tfoot", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                      children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_1)
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                      align: "center",
                      children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_3)
                    })]
                  })
                })]
              }), Prismic/* Prismic.text */.X5.text(fields[0].text_4) != undefined && ((_Prismic$text18 = Prismic/* Prismic.text */.X5.text(fields[0].text_4)) === null || _Prismic$text18 === void 0 ? void 0 : _Prismic$text18.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TableWithLargeTextContainer_Table, {
                children: [header !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                      colSpan: 2,
                      align: "center",
                      children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_4)
                    })
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                  children: fields.map(function (item, index) {
                    if (item.isheader) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
                    } else if (item.isfooter) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
                    } else {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BoldTR, {
                        bold: item.bold,
                        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                          children: Prismic/* Prismic.text */.X5.text(item.text_1)
                        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                          children: Prismic/* Prismic.text */.X5.text(item.text_4)
                        })]
                      }, "tr-".concat(index));
                    }
                  })
                }), footer !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tfoot", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                      children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_1)
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                      align: "center",
                      children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_4)
                    })]
                  })
                })]
              }), Prismic/* Prismic.text */.X5.text(fields[0].text_5) != undefined && ((_Prismic$text19 = Prismic/* Prismic.text */.X5.text(fields[0].text_5)) === null || _Prismic$text19 === void 0 ? void 0 : _Prismic$text19.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("table", {
                children: [header !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                      colSpan: 2,
                      align: "center",
                      children: Prismic/* Prismic.text */.X5.text(header === null || header === void 0 ? void 0 : header.text_5)
                    })
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                  children: fields.map(function (item, index) {
                    if (item.isheader) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
                    } else if (item.isfooter) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {}, "tr-".concat(index));
                    } else {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BoldTR, {
                        bold: item.bold,
                        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                          children: Prismic/* Prismic.text */.X5.text(item.text_1)
                        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                          children: Prismic/* Prismic.text */.X5.text(item.text_5)
                        })]
                      }, "tr-".concat(index));
                    }
                  })
                }), footer !== undefined && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tfoot", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                      children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_1)
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                      align: "center",
                      children: Prismic/* Prismic.text */.X5.text(footer === null || footer === void 0 ? void 0 : footer.text_5)
                    })]
                  })
                })]
              })]
            })]
          })
        })]
      })
    })
  });
};
// EXTERNAL MODULE: ../../packages/ui/src/components/dialog/Dialog.tsx + 1 modules
var dialog_Dialog = __webpack_require__(31388);
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TermsDialogContainer.tsx








var TermsDialogContainer_res = {
  declineUrl: {
    is: 'https://www.landsbankinn.is',
    en: 'https://www.landsbankinn.com'
  },
  text: {
    is: 'Ég samþykki',
    en: 'I aggree'
  },
  declineText: {
    is: 'Ég samþykki ekki',
    en: "I don't agree"
  }
};

var TermsDialogContainer_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e2cv1dl3"
} : 0)("font-family:", function (props) {
  return props.theme.font.familySerifCond;
}, ";font-size:28px;font-weight:500;letter-spacing:0.23px;line-height:36px;margin-top:65px;margin-bottom:50px;@media ", devices/* device.tablet */.U.tablet, "{text-align:center;}" + ( true ? "" : 0));

var TermsDialogContainer_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2cv1dl2"
} : 0)("p{font-family:", function (props) {
  return props.theme.font.family;
}, ";font-size:16px;font-weight:normal;letter-spacing:0.22px;margin-bottom:26px;}strong{font-family:", function (props) {
  return props.theme.font.family;
}, ";font-size:16px;font-weight:700;letter-spacing:0.22px;margin-bottom:26px;margin-top:9px;display:inline-block;}" + ( true ? "" : 0));

var ConfirmButtonContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2cv1dl1"
} : 0)("position:fixed;display:flex;bottom:0;left:0;padding:18px 20px 41px 20px;width:100%;height:123px;background:rgba(255, 255, 255, 0.97);justify-content:space-between;box-shadow:0px -4px 12px 0px rgba(67, 76, 90, 0.15);@media ", devices/* device.desktop */.U.desktop, "{justify-content:center;left:130px;max-width:calc(100vw - 260px);}" + ( true ? "" : 0));

var ConfirmButton = (0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e2cv1dl0"
} : 0)("height:64px;padding-top:20px;padding-bottom:25px;min-width:180px;border:1px solid rgb(27, 60, 88);background:", function (props) {
  return props.noBackground ? 'white' : 'rgb(27, 61, 89);';
}, ";color:", function (props) {
  return props.noBackground ? 'rgb(27, 61, 89)' : 'white';
}, ";font-weight:500;font-size:16px;&:hover{cursor:pointer;}@media ", devices/* device.tablet */.U.tablet, "{margin:0 10px;min-width:300px;font-size:18px;}@media ", devices/* device.desktop */.U.desktop, "{min-width:380px;}" + ( true ? "" : 0));

function TermsDialogContainer(_ref) {
  var _Prismic$text;

  var title = _ref.title,
      content = _ref.content,
      open_on_load = _ref.open_on_load;

  var _useState = (0,react.useState)(open_on_load),
      isOpen = _useState[0],
      setIsopen = _useState[1];

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: isOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dialog_Dialog/* Dialog */.V, {
      title: {
        label: (_Prismic$text = Prismic/* Prismic.text */.X5.text(title)) !== null && _Prismic$text !== void 0 ? _Prismic$text : '',
        hidden: true
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TermsDialogContainer_Title, {
        children: Prismic/* Prismic.text */.X5.text(title)
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TermsDialogContainer_Content, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
          value: content
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ConfirmButtonContainer, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConfirmButton, {
          noBackground: true,
          onClick: function onClick() {
            window.location.href = r(TermsDialogContainer_res.declineUrl);
          },
          children: r(TermsDialogContainer_res.declineText)
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConfirmButton, {
          onClick: function onClick() {
            return setIsopen(!isOpen);
          },
          children: r(TermsDialogContainer_res.text)
        })]
      })]
    })
  });
}
;// CONCATENATED MODULE: ../../packages/ui/src/components/buttons/TextCardButton.tsx



var TextCardButton_excluded = ["title", "isHover"];

function TextCardButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TextCardButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TextCardButton_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TextCardButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function TextCardButton_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var ArrowLine = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "efpv25b4"
} : 0)("display:inline-block;width:22px;height:1px;background-color:", function (props) {
  return props.theme.colors.primary;
}, ";transition:transform 300ms ease-in-out;transform-origin:right center;transform:", function (props) {
  return props.isHover ? 'scaleX(1.5)' : 'scaleX(1)';
}, ";" + ( true ? "" : 0));

var TextCardButton_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "efpv25b3"
} : 0)("position:relative;display:flex;align-items:center;padding-top:12px;padding-bottom:12px;padding-right:85px;cursor:pointer;font-weight:500;&:hover{", ArrowLine, "{transform:scaleX(1.5);}}" + ( true ? "" : 0));

var TextCardButton_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "efpv25b2"
} : 0)( true ? "" : 0);

var TextCardButton_Arrow = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "efpv25b1"
} : 0)( true ? {
  name: "14nqgdd",
  styles: "position:absolute;right:15px;display:flex;align-items:center"
} : 0);

var ArrowOdd = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "efpv25b0"
} : 0)("width:0;height:0;border-style:solid;border-width:3px 0 3px 6px;border-color:", function (props) {
  return "transparent transparent transparent ".concat(props.theme.colors.primary);
}, ";" + ( true ? "" : 0));

var TextCardButton = function TextCardButton(_ref) {
  var title = _ref.title,
      isHover = _ref.isHover,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TextCardButton_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextCardButton_Host, TextCardButton_objectSpread(TextCardButton_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextCardButton_Text, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextCardButton_Arrow, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowLine, {
        isHover: isHover
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowOdd, {})]
    })]
  }));
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/card/TextCard.tsx



var TextCard_excluded = ["title", "description", "action"];

function TextCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TextCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TextCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TextCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function TextCard_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var TextCard_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e1k5knj3"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var TextCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1k5knj2"
} : 0)(typography/* typography.h3 */.cp.h3, " color:", function (props) {
  return props.theme.colors.foreground;
}, ";margin-bottom:40px;" + ( true ? "" : 0));

var TextCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1k5knj1"
} : 0)(typography/* typography.body */.cp.body, " margin-bottom:2em;color:", function (props) {
  return props.theme.colors.foreground;
}, ";" + ( true ? "" : 0));

var TextCard_Action = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1k5knj0"
} : 0)( true ? {
  name: "idfvfs",
  styles: "display:flex;justify-content:flex-start"
} : 0);

var TextCard = /*#__PURE__*/(0,react.forwardRef)(function TCard(_ref, ref) {
  var title = _ref.title,
      description = _ref.description,
      action = _ref.action,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TextCard_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextCard_Host, TextCard_objectSpread(TextCard_objectSpread({}, rest), {}, {
    title: title !== null && title !== void 0 ? title : undefined,
    ref: ref,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextCard_Title, {
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
      margin: "0 0 17px 0"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextCard_Copy, {
      children: description
    }), action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextCard_Action, {
      children: action
    })]
  }));
});
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextCardsContainer.tsx


function TextCardsContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TextCardsContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TextCardsContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TextCardsContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var TextCardItem = function TextCardItem(_ref) {
  var _linkdata$title, _linkdata$abstract, _fallbackText, _linkdata$title2, _fallbackText2, _linkdata$title3;

  var title = _ref.title,
      copy = _ref.copy,
      link = _ref.link,
      link_text = _ref.link_text,
      style = _ref.style;
  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextCard, {
    title: (0,fallback/* fallbackText */.mn)(title, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined),
    description: (0,fallback/* fallbackRichText */.K8)(copy, (_linkdata$abstract = linkdata.abstract) !== null && _linkdata$abstract !== void 0 ? _linkdata$abstract : undefined),
    action: link && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
      value: link,
      title: (_fallbackText = (0,fallback/* fallbackText */.mn)(link_text, (_linkdata$title2 = linkdata.title) !== null && _linkdata$title2 !== void 0 ? _linkdata$title2 : undefined)) !== null && _fallbackText !== void 0 ? _fallbackText : undefined,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextCardButton, {
        title: (_fallbackText2 = (0,fallback/* fallbackText */.mn)(link_text, (_linkdata$title3 = linkdata.title) !== null && _linkdata$title3 !== void 0 ? _linkdata$title3 : undefined)) !== null && _fallbackText2 !== void 0 ? _fallbackText2 : undefined
      })
    }),
    style: style
  });
};

var TextCardsContainer = function TextCardsContainer(_ref2) {
  var fields = _ref2.fields;

  if (fields.length === 0) {
    return null;
  }

  var fLength = fields.length;
  var count = fLength <= 4 ? fLength : 4;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardGroup, {
      columns: count,
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextCardItem, TextCardsContainer_objectSpread({}, item), "text-card-item-".concat(index));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithAuthors.tsx






var TextWithAuthors_AuthorWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SliceWrapper,  true ? {
  target: "e1jtpwhu1"
} : 0)("&>div{flex-flow:column-reverse nowrap;flex-direction:column-reverse;@media ", devices/* device.tablet */.U.tablet, "{flex-flow:inherit;}}" + ( true ? "" : 0));

var TextWithAuthors_CardWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jtpwhu0"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{margin-top:-60px;}@media ", devices/* device.desktop */.U.desktop, "{margin-top:-90px;}" + ( true ? "" : 0));

var TextWithAuthors = function TextWithAuthors(_ref) {
  var children = _ref.children,
      cards = _ref.cards,
      isArticle = _ref.isArticle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithAuthors_AuthorWrapper, {
    left: children,
    right: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithAuthors_CardWrap, {
      children: cards
    }),
    isArticle: isArticle,
    align: "Right"
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithAuthorContainer.tsx







var TextWithAuthorContainer_renderAuthorItem = function renderAuthorItem(_ref, i) {
  var author = _ref.twa_author;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Author, {
    image: author === null || author === void 0 ? void 0 : author.image,
    name: Prismic/* Prismic.text */.X5.text(author === null || author === void 0 ? void 0 : author.name),
    title: Prismic/* Prismic.text */.X5.text(author === null || author === void 0 ? void 0 : author.job_title)
  }, "".concat(author === null || author === void 0 ? void 0 : author.name, "-").concat(i));
};

var TextWithAuthorContainer = function TextWithAuthorContainer(_ref2) {
  var copy = _ref2.copy,
      fields = _ref2.fields,
      template = _ref2.template;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var isArticle = template === 'article';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithAuthors, {
      cards: fields === null || fields === void 0 ? void 0 : fields.map(TextWithAuthorContainer_renderAuthorItem),
      isArticle: isArticle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy,
        isArticle: isArticle
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithIcon.tsx







var TextWithIcon_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e1q0l7sb3"
} : 0)("padding:", function (props) {
  return props.mergeTop ? "".concat(props.theme.breakpoints.sm.gutter, "px ").concat(props.theme.breakpoints.sm.gutter, "px") : "".concat(props.theme.breakpoints.sm.gutter * 2, "px ").concat(props.theme.breakpoints.sm.gutter, "px");
}, ";background:", function (props) {
  return props.isGray ? props.theme.colors.backgroundAlt : 'transparent';
}, ";@media ", devices/* device.tablet */.U.tablet, "{padding:", function (props) {
  return props.mergeTop ? "".concat(props.theme.breakpoints.md.gutter, "px 0") : "".concat(props.theme.breakpoints.md.gutter * 2, "px 0");
}, ";}@media ", devices/* device.desktop */.U.desktop, "{padding:", function (props) {
  return props.mergeTop ? "".concat(props.theme.breakpoints.lg.gutter, "px 0") : "".concat(props.theme.breakpoints.lg.gutter * 2, "px 0");
}, ";}" + ( true ? "" : 0));

var TextWithIcon_ImageWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1q0l7sb2"
} : 0)( true ? "" : 0);

var TextWithIcon_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1q0l7sb1"
} : 0)( true ? "" : 0);

var TextWithIcon_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1q0l7sb0"
} : 0)("margin-bottom:60px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0;}" + ( true ? "" : 0));

var TextWithIcon = function TextWithIcon(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      image = _ref.image,
      isGray = _ref.isGray,
      mergeTop = _ref.mergeTop;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithIcon_Host, {
    isGray: isGray,
    mergeTop: mergeTop,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 6 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWithIcon_Copy, {
          children: [!!title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithIcon_Title, {
            children: title
          }), !!title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
            margin: "40px 0"
          }), copy]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 3 / 12,
          offset: 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithIcon_ImageWrap, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
            src: image,
            ar: "ar_1_1",
            percentage: 3 / 12
          })
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithIconContainer.tsx





var TextWithIconContainer = function TextWithIconContainer(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      image = _ref.image,
      background = _ref.background,
      merge_top = _ref.merge_top;
  var titleText = (0,isEmptyText/* isEmptyText */.W)(title) ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
    value: title
  });
  var copyText = (0,isEmptyText/* isEmptyText */.W)(copy) ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
    value: copy
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    mergeTop: merge_top,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithIcon, {
      title: titleText,
      copy: copyText,
      image: image,
      isGray: background,
      mergeTop: merge_top
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithImage.tsx


function TextWithImage_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var TextWithImage_ImageWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1eg54t0"
} : 0)( true ? {
  name: "vabva8",
  styles: "position:relative;overflow:hidden"
} : 0);

var TextWithImage = function TextWithImage(_ref) {
  var children = _ref.children,
      images = _ref.images,
      isArticle = _ref.isArticle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: children,
    right: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithImage_ImageWrap, {
      children: images
    }),
    isArticle: isArticle
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithImageContainer.tsx






var TextWithImageContainer = function TextWithImageContainer(_ref) {
  var _image$aside, _image$aside2;

  var copy = _ref.copy,
      image = _ref.image,
      template = _ref.template;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var isArticle = template === 'article';
  var imgHeight = image === null || image === void 0 ? void 0 : (_image$aside = image.aside) === null || _image$aside === void 0 ? void 0 : _image$aside.dimensions.height;
  var imgWith = image === null || image === void 0 ? void 0 : (_image$aside2 = image.aside) === null || _image$aside2 === void 0 ? void 0 : _image$aside2.dimensions.width;
  var imgRatio = (imgWith !== null && imgWith !== void 0 ? imgWith : 4) / (imgHeight !== null && imgHeight !== void 0 ? imgHeight : 3);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithImage, {
      images: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
        src: image,
        ar: "aside",
        aspectRatio: imgRatio
      }),
      isArticle: isArticle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy,
        isArticle: isArticle
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithImages.tsx


function TextWithImages_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var TextWithImages_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e162ppml5"
} : 0)( true ? "" : 0);

var TextWithImages_ImageWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e162ppml4"
} : 0)("position:relative;overflow:hidden;margin:", function (props) {
  return "0 -".concat(props.theme.containerGutter, "px");
}, ";margin-bottom:2em;", mixins/* mobileGutterMargin */.HW, "@media ", devices/* device.mobile */.U.mobile, "{margin-bottom:2em;}@media ", devices/* device.tablet */.U.tablet, "{position:sticky;top:120px;margin:0;}@media ", devices/* device.desktop */.U.desktop, "{position:relative;top:0;}" + ( true ? "" : 0));

var TextWithImages_Content = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e162ppml3"
} : 0)("display:flex;flex-flow:column nowrap;align-items:flex-start;justify-content:center;height:100%;@media ", devices/* device.desktop */.U.desktop, "{padding-right:35px;", function (props) {
  return props.hasPadding && 'padding: 0 35px;';
}, ";}" + ( true ? "" : 0));

var TextWithImages_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e162ppml2"
} : 0)(typography/* typography.h3 */.cp.h3, " ", function (props) {
  return props.hasLink && 'margin-top: auto;';
}, " margin-bottom:calc((44 / ", typography/* typography.sizes.h3Size */.cp.sizes.h3Size, ") * 1em);max-width:75%;@media ", devices/* device.desktop */.U.desktop, "{margin-bottom:44px;}" + ( true ? "" : 0));

var TextWithImages_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e162ppml1"
} : 0)( true ? {
  name: "g46w8s",
  styles: "margin-bottom:30px"
} : 0);

var Links = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e162ppml0"
} : 0)("display:flex;flex-flow:row wrap;width:100%;margin-top:80px;margin-top:auto;border-top:", function (props) {
  return "1px solid ".concat(props.theme.colors.primary);
}, ";>a{width:auto;flex:0 0 auto;margin-right:30px;margin-top:20px;&:last-child{margin-right:0;}}" + ( true ? "" : 0));

var TextWithImages = function TextWithImages(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      images = _ref.images,
      align = _ref.align,
      mergeTop = _ref.mergeTop,
      link = _ref.link,
      link2 = _ref.link2;
  var hasLink = !!link;
  var isDefault = align === 'Default';
  var isRight = align === 'Right';
  var isTablet = (0,hooks_useMedia/* useMedia */.G)('md');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithImages_Host, {
    mergeTop: mergeTop,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      reverse: align === 'Right',
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: isDefault && !isTablet ? 7 / 12 : 6 / 12,
          offset: isRight && !isTablet ? 1 / 12 : 0
        },
        lg: {
          width: isDefault ? 7 / 12 : 6 / 12,
          offset: isRight ? 1 / 12 : 0
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithImages_ImageWrap, {
          children: images
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: isTablet ? 6 / 12 : 5 / 12,
          offset: isDefault || isRight || isTablet ? 0 : 1 / 12
        },
        lg: {
          width: 5 / 12,
          offset: isDefault || isRight ? 0 : 1 / 12
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWithImages_Content, {
          hasPadding: isDefault,
          children: [!!title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithImages_Title, {
            hasLink: hasLink,
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithImages_Copy, {
            children: copy
          }), hasLink && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Links, {
            children: [link, link2]
          })]
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithImagesContainer.tsx


function TextWithImagesContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TextWithImagesContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TextWithImagesContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TextWithImagesContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var ImageItem = function ImageItem(_ref, i) {
  var image = _ref.image,
      video = _ref.video,
      embed = _ref.embed,
      infogramid = _ref.infogramid,
      _ref$ar = _ref.ar,
      ar = _ref$ar === void 0 ? 'Ar 4:3' : _ref$ar,
      infogram_background = _ref.infogram_background;
  var isDesktop = (0,hooks_useMedia/* useMedia */.G)('lg');
  var AspectRatioMap = {
    'Ar 1:1': 'ar_1_1',
    'Ar 4:3': 'ar_4_3',
    'Ar 16:9': 'ar_16_9'
  };
  var aspectRatio = !isDesktop ? 'ar_1_1' : AspectRatioMap[ar];

  if (infogramid) {
    var source = Prismic/* Prismic.text */.X5.text(infogramid);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Infogram, {
      url: source !== null && source !== void 0 ? source : undefined,
      background: infogram_background
    });
  }

  if (embed) {
    var html = (0,Embed/* getRichTextEmbedHtml */.h)(embed);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Embed/* Embed */.c, {
      type: "inline",
      html: html
    });
  }

  if (video) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageVideo, {
      image: image,
      video: video,
      ar: aspectRatio
    }, "video-".concat(i));
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
    src: image,
    ar: aspectRatio
  }, "image-".concat(i));
};

var TextWithImagesContainer_TextWithImagesContainer = function TextWithImagesContainer(_ref2) {
  var _linkdata$title, _link2data$title;

  var title = _ref2.title,
      copy = _ref2.copy,
      fields = _ref2.fields,
      align = _ref2.align,
      aspect_ratio = _ref2.aspect_ratio,
      link_text = _ref2.link_text,
      link = _ref2.link,
      link_2_text = _ref2.link_2_text,
      link_2 = _ref2.link_2,
      _ref2$hasContainer = _ref2.hasContainer,
      hasContainer = _ref2$hasContainer === void 0 ? true : _ref2$hasContainer;

  if (!fields) {
    return null;
  }

  var copyText = (0,isEmptyText/* isEmptyText */.W)(copy) ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
    value: copy
  });
  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var linkText = (0,fallback/* fallbackText */.mn)(link_text, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);
  var link2data = (0,fallback/* getDataFromLink */.rm)(link_2);
  var link2Text = (0,fallback/* fallbackText */.mn)(link_2_text, (_link2data$title = link2data.title) !== null && _link2data$title !== void 0 ? _link2data$title : undefined);
  var action = link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link,
    title: linkText !== null && linkText !== void 0 ? linkText : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowButton/* ArrowButton */.b, {
      title: linkText !== null && linkText !== void 0 ? linkText : '',
      isSmall: true
    })
  }) : null;
  var action2 = link_2 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link_2,
    title: link2Text !== null && link2Text !== void 0 ? link2Text : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowButton/* ArrowButton */.b, {
      title: link2Text !== null && link2Text !== void 0 ? link2Text : '',
      isSmall: true
    })
  }) : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    container: hasContainer,
    className: "text-images",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithImages, {
      images: fields === null || fields === void 0 ? void 0 : fields.slice(0, 1).map(function (item, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageItem, TextWithImagesContainer_objectSpread({
          ar: aspect_ratio
        }, item), "image-".concat(index));
      }),
      title: Prismic/* Prismic.text */.X5.text(title),
      copy: copyText,
      align: align,
      link: action,
      link2: action2
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithLinks.tsx


function TextWithLinks_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var TextWithLinks_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e185e6xe1"
} : 0)(typography/* typography.bodyEditorial */.cp.bodyEditorial, " font-weight:500;margin-bottom:15px;" + ( true ? "" : 0));

var TextWithLinks_List = (0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e185e6xe0"
} : 0)( true ? {
  name: "nfnmca",
  styles: "li{margin-bottom:5px;}"
} : 0);

var TextWithLinks = function TextWithLinks(_ref) {
  var children = _ref.children,
      copy = _ref.copy,
      boxTitle = _ref.boxTitle,
      isArticle = _ref.isArticle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: copy,
    right: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWithLinks_Title, {
        children: [boxTitle, "\xA0"]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithLinks_List, {
        children: children
      })]
    }),
    isArticle: isArticle
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithLinksContainer.tsx






var renderLink = function renderLink(_ref, i) {
  var _linkdata$title;

  var link_text = _ref.link_text,
      link = _ref.link;
  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var title = (0,fallback/* fallbackText */.mn)(link_text, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
      value: link,
      title: title !== null && title !== void 0 ? title : undefined,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardButton, {
        title: title
      })
    })
  }, "link-".concat(i, "-").concat(title));
};

var TextWithLinksContainer = function TextWithLinksContainer(_ref2) {
  var copy = _ref2.copy,
      title = _ref2.title,
      fields = _ref2.fields,
      template = _ref2.template;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var isArticle = template === 'article';
  var links = fields === null || fields === void 0 ? void 0 : fields.filter(function (_ref3) {
    var link = _ref3.link;
    return !!link;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithLinks, {
      copy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy,
        isArticle: isArticle
      }),
      boxTitle: Prismic/* Prismic.text */.X5.text(title),
      isArticle: isArticle,
      children: (links === null || links === void 0 ? void 0 : links.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
        children: links.map(renderLink)
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithNumbers.tsx








var TextWithNumbers_PointColor;

(function (PointColor) {
  PointColor["AUTO"] = "Auto";
  PointColor["BLUE"] = "Blue";
  PointColor["LIGHTBLUE"] = "LightBlue";
  PointColor["CYAN"] = "Cyan";
  PointColor["ORANGE"] = "Orange";
})(TextWithNumbers_PointColor || (TextWithNumbers_PointColor = {}));

var TextWithNumbers_autoColor = function autoColor(props) {
  var colors = [props.theme.shades.primary4, props.theme.shades.secondary4, props.theme.shades.ternary4, props.theme.shades.primary4, props.theme.shades.secondary4, props.theme.shades.ternary4];
  var styles = {};

  for (var index = 0; index < colors.length; index++) {
    styles["&:nth-of-type(".concat(index + 1, ")")] = {
      color: colors[index]
    };
  }

  return styles;
};

var TextWithNumbers_Header = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eh5tspt6"
} : 0)("margin-bottom:20px;", function (props) {
  switch (props.color) {
    case TextWithNumbers_PointColor.AUTO:
      return TextWithNumbers_autoColor;

    case TextWithNumbers_PointColor.BLUE:
      return props.theme.colors.primary;

    case TextWithNumbers_PointColor.LIGHTBLUE:
      return props.theme.shades.primary4;

    case TextWithNumbers_PointColor.CYAN:
      return props.theme.shades.ternary4;

    case TextWithNumbers_PointColor.ORANGE:
      return props.theme.shades.secondary4;
  }

  return props.theme.colors.primary;
}, ";h3{color:currentColor;}div{background-color:currentColor;}" + ( true ? "" : 0));

var TextWithNumbers_Label = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "eh5tspt5"
} : 0)(typography/* typography.bodyEditorial */.cp.bodyEditorial, " font-weight:bold;margin-bottom:28px;line-height:", 24 / 22, ";color:currentColor;" + ( true ? "" : 0));

var TextWithNumbers_List = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eh5tspt4"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{margin-top:", function (props) {
  return props.noLabel ? '-12px' : 0;
}, ";}" + ( true ? "" : 0));

var TextWithNumbers_Description = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eh5tspt3"
} : 0)( true ? "" : 0);

var TextWithNumbers_Item = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eh5tspt2"
} : 0)("padding-top:12px;padding-bottom:44px;margin-bottom:20px;border-bottom:1px solid currentColor;", function (props) {
  switch (props.color) {
    case TextWithNumbers_PointColor.AUTO:
      return TextWithNumbers_autoColor;

    case TextWithNumbers_PointColor.BLUE:
      return props.theme.colors.primary;

    case TextWithNumbers_PointColor.LIGHTBLUE:
      return props.theme.shades.primary4;

    case TextWithNumbers_PointColor.CYAN:
      return props.theme.shades.ternary4;

    case TextWithNumbers_PointColor.ORANGE:
      return props.theme.shades.secondary4;
  }

  return props.theme.colors.primary;
}, ";" + ( true ? "" : 0));

var TextWithNumbers_Number = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eh5tspt1"
} : 0)(typography/* typography.numbersBig */.cp.numbersBig, " margin-bottom:10px;" + ( true ? "" : 0));

var TextWithNumbers_Text = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eh5tspt0"
} : 0)(typography/* typography.bodyEditorial */.cp.bodyEditorial, " font-weight:bold;line-height:", 24 / 22, ";" + ( true ? "" : 0));

var TextWithNumbers_NumberItem = function NumberItem(_ref) {
  var number = _ref.number,
      text = _ref.text,
      color = _ref.color,
      link = _ref.link;

  if (!!link) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbers_Item, {
      color: color,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
        value: link,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbers_Number, {
            children: number
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbers_Text, {
            children: text
          })]
        })
      })
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWithNumbers_Item, {
    color: color,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbers_Number, {
      children: number
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbers_Text, {
      children: text
    })]
  });
};
var TextWithNumbers = function TextWithNumbers(_ref2) {
  var children = _ref2.children,
      copy = _ref2.copy,
      label = _ref2.label,
      description = _ref2.description,
      color = _ref2.color;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: copy,
    right: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [label && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWithNumbers_Header, {
        color: color,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbers_Label, {
          children: label
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbers_List, {
        noLabel: !label,
        children: children
      }), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbers_Description, {
        children: description
      })]
    }),
    isArticle: true
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithNumbersContainer.tsx





var TextWithNumbersContainer = function TextWithNumbersContainer(_ref) {
  var _Prismic$text;

  var copy = _ref.copy,
      label = _ref.label,
      description = _ref.description,
      color = _ref.color,
      fields = _ref.fields;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var isArticle = true;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbers, {
      copy: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy,
        isArticle: isArticle
      }),
      label: (0,isEmptyText/* isEmptyText */.W)(label) ? undefined : (_Prismic$text = Prismic/* Prismic.text */.X5.text(label)) !== null && _Prismic$text !== void 0 ? _Prismic$text : undefined,
      color: color,
      description: (0,isEmptyText/* isEmptyText */.W)(description) ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: description
      }),
      children: (fields === null || fields === void 0 ? void 0 : fields.length) && fields.map(function (item, i) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbers_NumberItem, {
          number: Prismic/* Prismic.text */.X5.text(item === null || item === void 0 ? void 0 : item.number),
          text: Prismic/* Prismic.text */.X5.text(item === null || item === void 0 ? void 0 : item.text),
          color: color,
          link: item.link
        }, "number-".concat(i));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithPoints.tsx








var TextWithPoints_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e2pggx72"
} : 0)(typography/* typography.bodyEditorial */.cp.bodyEditorial, " font-weight:500;margin-bottom:25px;" + ( true ? "" : 0));

var Ol = (0,emotion_styled_base_browser_esm/* default */.Z)("ol",  true ? {
  target: "e2pggx71"
} : 0)("list-style-type:decimal;list-style:none;counter-reset:custom-counter;li{counter-increment:custom-counter;", typography/* typography.olListStyle */.cp.olListStyle, ";}" + ( true ? "" : 0));

var Ul = (0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e2pggx70"
} : 0)("li{", typography/* typography.listStyle */.cp.listStyle, ";}" + ( true ? "" : 0));

var TextWithPoints = function TextWithPoints(_ref) {
  var children = _ref.children,
      copy = _ref.copy,
      listStyle = _ref.listStyle,
      boxTitle = _ref.boxTitle,
      isArticle = _ref.isArticle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: copy,
    right: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWithPoints_Title, {
        children: [boxTitle, "\xA0"]
      }), listStyle !== 'Ordered Lists' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ul, {
        children: children
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ol, {
        children: children
      })]
    }),
    isArticle: isArticle
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithPointsPage.tsx







var BulletsColor;

(function (BulletsColor) {
  BulletsColor["BLUE"] = "Blue";
  BulletsColor["CYAN"] = "Cyan";
  BulletsColor["ORANGE"] = "Orange";
})(BulletsColor || (BulletsColor = {}));

var TitleSize;

(function (TitleSize) {
  TitleSize["MEDIUM"] = "Medium";
  TitleSize["BIG"] = "Big";
  TitleSize["SMALL"] = "Small";
})(TitleSize || (TitleSize = {}));

var TextWithPointsPage_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Reveal/* Reveal */.U,  true ? {
  target: "e2sk2pt8"
} : 0)( true ? "" : 0);

var TextWithPointsPage_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2sk2pt7"
} : 0)("margin-bottom:30px;h1,h2{", function (props) {
  switch (props.titleSize) {
    case TitleSize.MEDIUM:
      return typography/* typography.h2 */.cp.h2;

    case TitleSize.BIG:
      return typography/* typography.h2Big */.cp.h2Big;

    case TitleSize.SMALL:
      return typography/* typography.h3 */.cp.h3;
  }

  return '';
}, ";}@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:40px;}" + ( true ? "" : 0));

var TextWithPointsPage_CustomDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* Divider */.i,  true ? {
  target: "e2sk2pt6"
} : 0)("margin:16px 0 30px;@media ", devices/* device.tablet */.U.tablet, "{margin:16px 0 40px;}" + ( true ? "" : 0));

var TextWithPointsPage_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2sk2pt5"
} : 0)("margin-bottom:4em;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0;}div{", function (props) {
  return !props.isLarge ? typography/* typography.p2 */.cp.p2 : typography/* typography.body */.cp.body;
}, ";}" + ( true ? "" : 0));

var TextWithPointsPage_Action = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2sk2pt4"
} : 0)("border-top:", function (props) {
  return "1px solid ".concat(props.theme.colors.primary);
}, ";padding-top:20px;margin-bottom:30px;@media ", devices/* device.tablet */.U.tablet, "{margin-bottom:0;margin-top:30px;}" + ( true ? "" : 0));

var TextWithPointsPage_Items = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2sk2pt3"
} : 0)("display:flex;flex-flow:row wrap;margin-top:20px;@media ", devices/* device.tablet */.U.tablet, "{margin-top:0;", function (props) {
  return !props.isBullets && 'margin-bottom: -4em';
}, ";padding-top:", function (props) {
  return props.isLarge ? '5px' : 0;
}, ";}li{&:before{background:", function (props) {
  switch (props.pointsColor) {
    case BulletsColor.BLUE:
      return props.theme.shades.primary3;

    case BulletsColor.CYAN:
      return props.theme.shades.ternary5;

    case BulletsColor.ORANGE:
      return props.theme.colors.secondary;
  }

  return '';
}, ";}}" + ( true ? "" : 0));

var TextWithPointsPage_Ul = (0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e2sk2pt2"
} : 0)( true ? "" : 0);

var Li = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.li,  true ? {
  target: "e2sk2pt1"
} : 0)(typography/* typography.body */.cp.body, " ", typography/* typography.listStyle */.cp.listStyle, ";" + ( true ? "" : 0));

var TextWithPointsPage_ItemsRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Row/* Row */.X,  true ? {
  target: "e2sk2pt0"
} : 0)("margin-bottom:", function (props) {
  return props.noTop ? '-2em' : '2em';
}, ";a{margin-bottom:2em;}@media ", devices/* device.tablet */.U.tablet, "{margin-top:", function (props) {
  return props.noTop ? '10px' : '4em';
}, ";margin-bottom:", function (props) {
  return props.noTop ? '-4em' : '2em';
}, ";a{margin-bottom:0;}}" + ( true ? "" : 0));

var TextWithPointsPage_ListItem = function ListItem(_ref) {
  var content = _ref.content;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Li, {
    children: content
  });
};
var TextWithPointsPage = function TextWithPointsPage(_ref2) {
  var title = _ref2.title,
      titleString = _ref2.titleString,
      titleSize = _ref2.titleSize,
      copy = _ref2.copy,
      copySize = _ref2.copySize,
      action = _ref2.action,
      pointsType = _ref2.pointsType,
      pointsColor = _ref2.pointsColor,
      isBottomAligned = _ref2.pointsLocation,
      children = _ref2.children,
      noTop = _ref2.noTop;

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TextWithPointsPage_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
        md: {
          width: 6 / 12
        },
        children: [title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_Title, {
          titleSize: titleSize !== null && titleSize !== void 0 ? titleSize : 'Medium',
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
            value: title
          })
        }), titleString && !title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_Title, {
          titleSize: titleSize !== null && titleSize !== void 0 ? titleSize : 'Medium',
          children: titleString
        }), !isBottomAligned && copy && title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_CustomDivider, {}), !isBottomAligned && pointsType !== 'Bullets' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_Copy, {
          isLarge: !!copySize,
          children: copy
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
        md: {
          width: !isBottomAligned && pointsType === 'Empty' ? 5 / 12 : 6 / 12,
          offset: !isBottomAligned && pointsType === 'Empty' ? 1 / 12 : 0
        },
        children: [isBottomAligned && copy && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_Copy, {
          isLarge: !!copySize,
          children: copy
        }), isBottomAligned && action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_Action, {
          children: action
        }), !isBottomAligned && pointsType !== 'Bullets' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_Items, {
            ref: ref,
            pointsColor: pointsColor !== null && pointsColor !== void 0 ? pointsColor : 'Default',
            isLarge: !copySize,
            children: itemsWithStyleProp
          })
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Column/* Column */.s, {
        md: {
          width: 6 / 12
        },
        children: [!isBottomAligned && copy && pointsType === 'Bullets' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_Copy, {
          isLarge: !!copySize,
          children: copy
        }), !isBottomAligned && action && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_Action, {
          children: action
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Column/* Column */.s, {
        md: {
          width: 5 / 12,
          offset: 1 / 12
        },
        children: !isBottomAligned && pointsType === 'Bullets' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_Items, {
          ref: ref,
          isBullets: true,
          pointsColor: pointsColor !== null && pointsColor !== void 0 ? pointsColor : 'Default',
          isLarge: !copySize,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_Ul, {
            children: itemsWithStyleProp
          })
        })
      })]
    }), isBottomAligned && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_ItemsRow, {
      noTop: noTop,
      ref: ref,
      children: itemsWithStyleProp
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithPointsContainer.tsx


var TextWithPointsContainer_excluded = ["copy", "icon", "label", "isSplitterLong", "cols", "pointColor", "number", "pointsType", "isBottomAligned", "isBodySize", "point_link"];

function TextWithPointsContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TextWithPointsContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TextWithPointsContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TextWithPointsContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var renderPoints = function renderPoints(_ref, i) {
  var copy = _ref.copy,
      point_link = _ref.point_link;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
    children: [point_link && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
      value: point_link,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_ListItem, {
          content: (0,htmlSerializer/* parseTariff */.aC)(Prismic/* Prismic.text */.X5.text(copy))
        })
      })
    }), !point_link && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage_ListItem, {
      content: (0,htmlSerializer/* parseTariff */.aC)(Prismic/* Prismic.text */.X5.text(copy))
    })]
  }, "".concat(i, "-").concat(Prismic/* Prismic.text */.X5.text(copy)));
};

var TextWithPointsContainer_CardItem = function CardItem(_ref2) {
  var _Prismic$text;

  var copy = _ref2.copy,
      icon = _ref2.icon,
      label = _ref2.label,
      isSplitterLong = _ref2.isSplitterLong,
      cols = _ref2.cols,
      pointColor = _ref2.pointColor,
      number = _ref2.number,
      pointsType = _ref2.pointsType,
      isBottomAligned = _ref2.isBottomAligned,
      isBodySize = _ref2.isBodySize,
      point_link = _ref2.point_link,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, TextWithPointsContainer_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointCard, TextWithPointsContainer_objectSpread({
    icon: icon,
    copy: (0,htmlSerializer/* parseTariff */.aC)(Prismic/* Prismic.text */.X5.text(copy)),
    label: (_Prismic$text = Prismic/* Prismic.text */.X5.text(label)) !== null && _Prismic$text !== void 0 ? _Prismic$text : undefined,
    isSplitterLong: isSplitterLong,
    cols: cols,
    pointColor: pointColor,
    number: number,
    pointsType: pointsType,
    isBottomAligned: isBottomAligned,
    isBodySize: isBodySize,
    pointLink: point_link
  }, rest));
};

var TextWithPointsContainer = function TextWithPointsContainer(_ref3) {
  var _linkdata$title;

  var title = _ref3.title,
      title_size = _ref3.title_size,
      copy = _ref3.copy,
      copy_size = _ref3.copy_size,
      link = _ref3.link,
      link_text = _ref3.link_text,
      points_type = _ref3.points_type,
      points_color = _ref3.points_color,
      isSplitterLong = _ref3.line_splitter,
      columns_count = _ref3.columns_count,
      isBottomAligned = _ref3.points_location,
      fields = _ref3.fields,
      list_style = _ref3.list_style,
      template = _ref3.template,
      point_copy_size = _ref3.point_copy_size,
      isArticle = _ref3.isArticle;
  var pointsCount = fields === null || fields === void 0 ? void 0 : fields.length;
  var copyText = (0,isEmptyText/* isEmptyText */.W)(copy) ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
    value: copy,
    isArticle: isArticle
  });
  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var linkText = (0,fallback/* fallbackText */.mn)(link_text, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);
  var action = link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
    value: link,
    title: linkText !== null && linkText !== void 0 ? linkText : undefined,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowButton/* ArrowButton */.b, {
      title: linkText !== null && linkText !== void 0 ? linkText : '',
      isSmall: true
    })
  }) : null;

  if (isArticle) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
      isArticle: isArticle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPoints, {
        copy: copyText,
        boxTitle: Prismic/* Prismic.text */.X5.text(title),
        listStyle: list_style,
        isArticle: isArticle,
        children: fields === null || fields === void 0 ? void 0 : fields.map(renderPoints)
      })
    });
  }

  var noTop = (0,isEmptyText/* isEmptyText */.W)(title) && (0,isEmptyText/* isEmptyText */.W)(copy);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    className: "text-points",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsPage, {
      title: title,
      titleSize: title_size,
      copy: copyText,
      copySize: copy_size,
      action: action,
      pointsColor: points_color,
      pointsLocation: isBottomAligned,
      pointsType: points_type,
      noTop: noTop,
      children: points_type === 'Bullets' && !isBottomAligned ? fields === null || fields === void 0 ? void 0 : fields.map(renderPoints) : fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
        var colCount = !isBottomAligned ? 6 : columns_count !== 'Auto' ? 12 / Number(columns_count) : pointsCount >= 6 ? 2 : 12 / pointsCount;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsContainer_CardItem, TextWithPointsContainer_objectSpread({
          isSplitterLong: isSplitterLong,
          cols: colCount,
          pointColor: points_color,
          number: index + 1,
          pointsType: points_type,
          isBottomAligned: isBottomAligned,
          isBodySize: point_copy_size
        }, item), "".concat(index, "-").concat(Prismic/* Prismic.text */.X5.text(item.copy)));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithPullOut.tsx






var TextWithPullOut_Quote = (0,emotion_styled_base_browser_esm/* default */.Z)("blockquote",  true ? {
  target: "e1hduovu0"
} : 0)(typography/* typography.bodyEditorial */.cp.bodyEditorial, " font-weight:500;" + ( true ? "" : 0));

var TextWithPullOut = function TextWithPullOut(_ref) {
  var children = _ref.children,
      pullout = _ref.pullout,
      isArticle = _ref.isArticle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: children,
    right: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPullOut_Quote, {
      children: pullout
    }),
    isArticle: isArticle
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithPullOutContainer.tsx





var TextWithPullOutContainer = function TextWithPullOutContainer(_ref) {
  var copy = _ref.copy,
      pullout = _ref.pullout,
      template = _ref.template;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var isArticle = template === 'article';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPullOut, {
      isArticle: isArticle,
      pullout: Prismic/* Prismic.text */.X5.text(pullout),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy,
        isArticle: isArticle
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithRelated.tsx





var TextWithRelated_CardWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eacvkqc0"
} : 0)( true ? "" : 0);

var TextWithRelated = function TextWithRelated(_ref) {
  var children = _ref.children,
      cards = _ref.cards,
      isArticle = _ref.isArticle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: children,
    right: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithRelated_CardWrap, {
      children: cards
    }),
    isArticle: isArticle
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithRelatedContainer.tsx







var renderRelatedItem = function renderRelatedItem(_ref, i) {
  var _linkdata$title, _linkdata$image, _linkdata$abstract;

  var image = _ref.image,
      title = _ref.title,
      copy = _ref.copy,
      link = _ref.link;
  var linkdata = (0,fallback/* getDataFromLink */.rm)(link);
  var cardTitle = (0,fallback/* fallbackText */.mn)(title, (_linkdata$title = linkdata.title) !== null && _linkdata$title !== void 0 ? _linkdata$title : undefined);
  var img = !!image || !!link ? (0,fallback/* fallbackImage */.bU)(image, (_linkdata$image = linkdata.image) !== null && _linkdata$image !== void 0 ? _linkdata$image : undefined) : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card, {
    link: link,
    title: link ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
      value: link,
      title: cardTitle !== null && cardTitle !== void 0 ? cardTitle : undefined,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        children: cardTitle
      })
    }) : cardTitle,
    description: (0,fallback/* fallbackRichText */.K8)(copy, (_linkdata$abstract = linkdata.abstract) !== null && _linkdata$abstract !== void 0 ? _linkdata$abstract : undefined),
    image: img !== null && img !== void 0 ? img : undefined,
    ar: "ar_1_1",
    padding: false,
    backgroundAlt: false,
    notLink: !link
  }, "card-".concat(i));
};

var TextWithRelatedContainer = function TextWithRelatedContainer(_ref2) {
  var copy = _ref2.copy,
      fields = _ref2.fields,
      template = _ref2.template;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var isArticle = template === 'article';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithRelated, {
      cards: fields === null || fields === void 0 ? void 0 : fields.map(renderRelatedItem),
      isArticle: isArticle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy,
        isArticle: isArticle
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithSideText.tsx


function TextWithSideText_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var SideBar = (0,emotion_styled_base_browser_esm/* default */.Z)("blockquote",  true ? {
  target: "e1wrcnkn2"
} : 0)( true ? "" : 0);

var TextWithSideText_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1wrcnkn1"
} : 0)(typography/* typography.bodyEditorial */.cp.bodyEditorial, " font-weight:bold;margin-bottom:40px;" + ( true ? "" : 0));

var SideText = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wrcnkn0"
} : 0)( true ? {
  name: "1lum4a0",
  styles: "div{font-size:14px;}"
} : 0);

var TextWithSideText = function TextWithSideText(_ref) {
  var children = _ref.children,
      title = _ref.title,
      sideText = _ref.sideText,
      isArticle = _ref.isArticle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: children,
    right: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SideBar, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithSideText_Title, {
        children: title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SideText, {
        children: sideText
      })]
    }),
    isArticle: isArticle
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithSideTextContainer.tsx





var TextWithSideTextContainer = function TextWithSideTextContainer(_ref) {
  var copy = _ref.copy,
      side_title = _ref.side_title,
      side_text = _ref.side_text,
      template = _ref.template;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var isArticle = template === 'article';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithSideText, {
      isArticle: isArticle,
      sideText: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: side_text
      }),
      title: Prismic/* Prismic.text */.X5.text(side_title),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy,
        isArticle: isArticle
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/slices/TextWithEmbed.tsx





var EmbedWrap = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bbkrz50"
} : 0)( true ? "" : 0);

var TextWithEmbed = function TextWithEmbed(_ref) {
  var children = _ref.children,
      embed = _ref.embed,
      isArticle = _ref.isArticle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SliceWrapper, {
    left: children,
    right: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbedWrap, {
      children: embed
    }),
    isArticle: isArticle
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TextWithVideoContainer.tsx





var TextWithVideoContainer = function TextWithVideoContainer(_ref) {
  var _, _$oembed;

  var copy = _ref.copy,
      video = _ref.video,
      template = _ref.template;

  if ((0,isEmptyText/* isEmptyText */.W)(copy)) {
    return null;
  }

  var isArticle = template === 'article';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: isArticle,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithEmbed, {
      embed: video && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Embed/* Embed */.c, {
        html: (_ = video[0]) === null || _ === void 0 ? void 0 : (_$oembed = _.oembed) === null || _$oembed === void 0 ? void 0 : _$oembed.html,
        type: "inline",
        noSpace: true
      }),
      isArticle: isArticle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
        value: copy,
        isArticle: isArticle
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/tiles/TileCard.tsx



var TileCard_excluded = ["number", "title", "copy", "icon", "layout", "iconName", "link"];

function TileCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TileCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TileCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TileCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var TileLayout;

(function (TileLayout) {
  TileLayout["Horizontal"] = "horizontal";
  TileLayout["Vertical"] = "vertical";
})(TileLayout || (TileLayout = {}));

var TileCard_Host = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  shouldForwardProp: (0,shouldForwardProp/* shouldForwardProp */.x)('div'),
  target: "e17xt1466"
} : 0)("display:flex;flex-direction:column;justify-content:center;align-items:center;padding:68px 0;margin-bottom:10px;min-height:95vw;@media ", devices/* device.tablet */.U.tablet, "{min-height:201px;padding:", function (props) {
  return props.layout === TileLayout.Vertical ? '0' : '27px 0';
}, ";margin-bottom:0;flex-direction:", function (props) {
  return props.layout === TileLayout.Horizontal ? 'row' : 'column';
}, ";justify-content:", function (props) {
  return props.layout === TileLayout.Vertical ? 'space-between' : 'center';
}, ";}@media ", devices/* device.ipadPro */.U.ipadPro, "{padding:", function (props) {
  return props.layout === TileLayout.Vertical ? '0' : '44px 0';
}, ";min-height:298px;}@media ", devices/* device.desktop */.U.desktop, "{min-height:380px;padding:", function (props) {
  return props.layout === TileLayout.Vertical ? '0 0 40px' : '80px 0';
}, ";}" + ( true ? "" : 0));

var TileCard_Icon = (0,emotion_styled_base_browser_esm/* default */.Z)("figure",  true ? {
  target: "e17xt1465"
} : 0)("margin-bottom:10px;width:70px;height:70px;", function (props) {
  return props.name === 'blueyoutube' || props.name === 'bluespotify' ? 'display:flex;' : '';
}, "@media ", devices/* device.mobile */.U.mobile, "{", function (props) {
  return props.name === 'blueyoutube' ? // eslint-disable-next-line sonarjs/no-duplicate-string
  'width:112px;display:flex;' : props.name === 'bluespotify' ? 'width:112px;display:flex;' : "\n    width: 112px;\n    height: 112px;\n    ";
}, ";}@media ", devices/* device.tablet */.U.tablet, "{", function (props) {
  return props.name === 'blueyoutube' ? 'width:112px;display:flex;' : props.name === 'bluespotify' ? 'width:112px;display:flex;' : props.name === 'icelandairwaves' ? 'width:112px;' : "\n    width: 70px;\n    height: 70px;\n    ";
}, ";}@media ", devices/* device.ipadPro */.U.ipadPro, "{", function (props) {
  return props.name === 'blueyoutube' ? 'width:112px;display:flex;' : props.name === 'bluespotify' ? 'width:112px;display:flex;' : props.name === 'icelandairwaves' ? 'width:112px;' : props.name === 'landsbankinn' ? 'width:112px;' : props.name === 'airwaves' ? 'width:112px;' : "\n    width: 70px;\n    height: 70px;\n    ";
}, ";}@media ", devices/* device.desktop */.U.desktop, "{", function (props) {
  return props.name === 'Anaegjuvogin' ? 'height:139px;width:92px;margin-bottom:25px;' : props.name === 'blueyoutube' ? 'width:180px' : props.name === 'bluespotify' ? 'width:210px' : props.name === 'airwaves' ? 'width:160px;' : props.name === 'landsbankinn' ? 'width:80px;' : props.name === 'icelandairwaves' ? 'width:240px;' : "width: 112px;\n    height: 112px;";
}, ";}svg{object-fit:contain;width:100%;height:100%;}" + ( true ? "" : 0));

var TileCard_Top = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e17xt1464"
} : 0)("display:flex;flex-direction:column;justify-content:center;align-items:center;padding:0 20px;margin-bottom:", function (props) {
  return props.layout === TileLayout.Horizontal || props.layout === TileLayout.Vertical ? '105px' : '0';
}, ";@media ", devices/* device.tablet */.U.tablet, "{padding:0 44px;margin-bottom:0;width:", function (props) {
  return props.layout === TileLayout.Horizontal ? '50%' : 'auto';
}, ";height:", function (props) {
  return props.layout === TileLayout.Vertical ? 'calc(50% + 15px)' : 'auto';
}, ";}" + ( true ? "" : 0));

var TileCard_Number = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e17xt1463"
} : 0)(typography/* typography.numbers2 */.cp.numbers2, " ", (0,mixins/* responseFont */.cG)(30, 55), ";" + ( true ? "" : 0));

var TileCard_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e17xt1462"
} : 0)("font-weight:bold;text-align:center;@media ", devices/* device.tablet */.U.tablet, "{font-size:14px;text-align:", function (props) {
  return props.layout === TileLayout.Horizontal ? 'left' : 'center';
}, ";}@media ", devices/* device.desktop */.U.desktop, "{font-size:18px;}" + ( true ? "" : 0));

var TileCard_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e17xt1461"
} : 0)("display:", function (props) {
  return props.layout ? 'block' : 'none';
}, ";margin-top:", function (props) {
  return props.layout === TileLayout.Horizontal || props.layout === TileLayout.Vertical ? '48px' : '10px';
}, ";text-align:center;@media ", devices/* device.tablet */.U.tablet, "{margin-top:20px;div{font-size:14px;}text-align:", function (props) {
  return props.layout === TileLayout.Horizontal ? 'left' : 'center';
}, ";}@media ", devices/* device.desktop */.U.desktop, "{div{font-size:18px;}}" + ( true ? "" : 0));

var TileCard_Bottom = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e17xt1460"
} : 0)("padding:0 20px;@media ", devices/* device.tablet */.U.tablet, "{padding:", function (props) {
  return props.layout === TileLayout.Vertical ? '0 20px' : '0';
}, ";padding-right:", function (props) {
  return props.layout === TileLayout.Horizontal && '44px';
}, ";width:", function (props) {
  return props.layout === TileLayout.Horizontal ? '50%' : 'auto';
}, ";height:", function (props) {
  return props.layout === TileLayout.Vertical && 'calc(50% - 30px)';
}, ";}" + ( true ? "" : 0));

var TileCard = function TileCard(_ref) {
  var number = _ref.number,
      title = _ref.title,
      copy = _ref.copy,
      icon = _ref.icon,
      layout = _ref.layout,
      iconName = _ref.iconName,
      link = _ref.link,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TileCard_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TileCard_Host, TileCard_objectSpread(TileCard_objectSpread({
    layout: layout
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TileCard_Top, {
      layout: layout,
      children: [link ? iconName === 'blueyoutube' || iconName === 'bluespotify' || iconName === 'airwaves' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: link.url,
        target: "_blank",
        rel: "noreferrer",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TileCard_Icon, {
          name: iconName,
          children: icon
        })
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicLink */.wK, {
        value: link,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TileCard_Icon, {
          name: iconName,
          children: icon
        })
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TileCard_Icon, {
        name: iconName,
        children: icon
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TileCard_Number, {
        children: number
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TileCard_Bottom, {
      layout: layout,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TileCard_Title, {
        layout: layout,
        children: title
      }), copy && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TileCard_Copy, {
        layout: layout,
        children: copy
      })]
    })]
  }));
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/tiles/TilesGroup.tsx





var TilesGroup_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e129075k0"
} : 0)("@media ", devices/* device.tablet */.U.tablet, "{display:-ms-grid;display:grid;gap:15px 15px;}@media ", devices/* device.desktop */.U.desktop, "{gap:20px 20px;}", function (props) {
  switch (props.count) {
    case 2:
      return "\n          grid-template-columns: 1fr 1fr 1fr;\n          grid-template-rows: 1fr;\n          grid-template-areas: 'item1 item1 item2';\n\n          > *:first-child {\n            grid-area: item1;\n            background-color: ".concat(props.theme.shades.secondary2, ";\n          }\n\n          > *:nth-child(2) {\n            grid-area: item2;\n            background-color: ").concat(props.theme.shades.ternary2, ";\n          }\n        ");

    case 3:
      return "\n          grid-template-columns: 1fr 1fr 1fr;\n          grid-template-rows: 1fr;\n          grid-template-areas: 'item1 item2 item3';\n\n          > *:first-child {\n            grid-area: item1;\n            background-color: ".concat(props.theme.shades.primary2, ";\n          }\n\n          > *:nth-child(2) {\n            grid-area: item2;\n            background-color: ").concat(props.theme.shades.secondary2, ";\n          }\n\n          > *:nth-child(3) {\n            grid-area: item3;\n            background-color: ").concat(props.theme.shades.ternary2, ";\n          }\n        ");

    case 4:
      return "\n          grid-template-columns: 1fr 1fr 1fr;\n          grid-template-rows: 1fr 1fr;\n          grid-template-areas:\n            'item1 item1 item2'\n            'item3 item4 item4';\n\n          > *:first-child {\n            grid-area: item1;\n            background-color: ".concat(props.theme.shades.secondary2, ";\n          }\n\n          > *:nth-child(2) {\n            grid-area: item2;\n            background-color: ").concat(props.theme.shades.ternary2, ";\n          }\n\n          > *:nth-child(3) {\n            grid-area: item3;\n            background-color: ").concat(props.theme.shades.primary2, ";\n          }\n\n          > *:nth-child(4) {\n            grid-area: item4;\n            background-color: ").concat(props.theme.colors.backgroundAlt, ";\n          }\n        ");

    case 5:
      return "\n          grid-template-columns: 1fr 1fr 1fr;\n          grid-template-rows: 1fr 1fr;\n          grid-template-areas:\n            'item1 item2 item3'\n            'item4 item5 item5';\n\n          > *:first-child {\n            grid-area: item1;\n            background-color: ".concat(props.theme.shades.primary2, ";\n          }\n\n          > *:nth-child(2) {\n            grid-area: item2;\n            background-color: ").concat(props.theme.shades.secondary2, ";\n          }\n\n          > *:nth-child(3) {\n            grid-area: item3;\n            background-color: ").concat(props.theme.shades.ternary2, ";\n          }\n\n          > *:nth-child(4) {\n            grid-area: item4;\n            background-color: #e3fbff;\n          }\n\n          > *:nth-child(5) {\n            grid-area: item5;\n            background-color: ").concat(props.theme.colors.backgroundAlt, ";\n          }\n        ");

    case 6:
      return "\n          grid-template-columns: 1fr 1fr 1fr;\n          grid-template-rows: 1fr 1fr 1fr;\n          grid-template-areas:\n            'item1 item1 item2'\n            'item3 item4 item4'\n            'item3 item5 item6';\n\n          > *:first-child {\n            grid-area: item1;\n            background-color: ".concat(props.theme.shades.secondary2, ";\n          }\n\n          > *:nth-child(2) {\n            grid-area: item2;\n            background-color: ").concat(props.theme.shades.ternary2, ";\n          }\n\n          > *:nth-child(3) {\n            grid-area: item3;\n            background-color: ").concat(props.theme.shades.primary2, ";\n          }\n\n          > *:nth-child(4) {\n            grid-area: item4;\n            background-color: ").concat(props.theme.colors.backgroundAlt, ";\n          }\n\n          > *:nth-child(5) {\n            grid-area: item5;\n            background-color: #ffc9a0;\n          }\n\n          > *:nth-child(6) {\n            grid-area: item6;\n            background-color: ").concat(props.theme.shades.primary2, ";\n          }\n        ");
  }
}, ";" + ( true ? "" : 0));

var TilesGroup = function TilesGroup(_ref) {
  var children = _ref.children,
      count = _ref.count;

  var _useRevealTrail = (0,useReveal/* useRevealTrail */.xk)(children),
      ref = _useRevealTrail.ref,
      itemsWithStyleProp = _useRevealTrail.itemsWithStyleProp;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TilesGroup_Host, {
    ref: ref,
    count: count,
    children: itemsWithStyleProp
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/TilesContainer.tsx


var TilesContainer_excluded = ["number", "title", "copy", "icon", "index", "count"],
    TilesContainer_excluded2 = ["count"];

function TilesContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TilesContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TilesContainer_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TilesContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function getTileLayout(count, item) {
  // count 2
  if (count === 2 && item === 1) {
    return TileLayout.Horizontal;
  } // count 43


  if (count === 4 && (item === 1 || item === 4)) {
    return TileLayout.Horizontal;
  } // count 5


  if (count === 5 && item === 5) {
    return TileLayout.Horizontal;
  } // count 6


  if (count === 6 && (item === 1 || item === 4)) {
    return TileLayout.Horizontal;
  }

  if (count === 6 && item === 3) {
    return TileLayout.Vertical;
  }

  return null;
}
var TileCardItem = function TileCardItem(_ref) {
  var number = _ref.number,
      title = _ref.title,
      copy = _ref.copy,
      icon = _ref.icon,
      index = _ref.index,
      count = _ref.count,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TilesContainer_excluded);

  var isEmpty = (0,isEmptyText/* isEmptyText */.W)(copy);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TileCard, TilesContainer_objectSpread({
    number: Prismic/* Prismic.text */.X5.text(number),
    title: Prismic/* Prismic.text */.X5.text(title),
    copy: !isEmpty && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prismic/* PrismicText */.Kv, {
      value: copy
    }),
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons/* Icon */.JO, {
      name: icon
    }),
    iconName: icon,
    layout: getTileLayout(count, index + 1)
  }, rest));
};
var TilesContainer = function TilesContainer(_ref2) {
  var fields = _ref2.fields,
      className = _ref2.className;
  var count = fields.length;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    isArticle: true,
    className: className,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TilesGroup, {
      count: count,
      children: fields === null || fields === void 0 ? void 0 : fields.map(function (_ref3, index) {
        var count = _ref3.count,
            rest = (0,objectWithoutProperties/* default */.Z)(_ref3, TilesContainer_excluded2);

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TileCardItem, TilesContainer_objectSpread(TilesContainer_objectSpread({
          count: fields.length
        }, rest), {}, {
          index: index
        }), "tile-".concat(index));
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/components/media-item/MediaItem.tsx






var MediaItem_Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "erm5hqm4"
} : 0)( true ? "" : 0);

var MediaItem_Body = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "erm5hqm3"
} : 0)("padding-top:", function (props) {
  return 8 * props.theme.baseline;
}, "px;@media ", devices/* device.tablet */.U.tablet, "{max-width:910px;padding-right:120px;}" + ( true ? "" : 0));

var MediaItem_Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "erm5hqm2"
} : 0)(typography/* typography.h4 */.cp.h4, " margin-bottom:4px;" + ( true ? "" : 0));

var MediaItem_Copy = (0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "erm5hqm1"
} : 0)( true ? "" : 0);

var Child = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "erm5hqm0"
} : 0)( true ? "" : 0);

var MediaItem = function MediaItem(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MediaItem_Host, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Child, {
      children: children
    }), (!!title || !!copy) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MediaItem_Body, {
      children: [!!title && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MediaItem_Title, {
        children: title
      }), !!copy && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MediaItem_Copy, {
        children: copy
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/VideoContainer.tsx





var VideoContainer = function VideoContainer(_ref) {
  var _, _$oembed;

  var video = _ref.video,
      title = _ref.title,
      title1 = _ref.title1,
      copy = _ref.copy;

  if (!video) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MediaItem, {
      title: Prismic/* Prismic.text */.X5.text(title) || Prismic/* Prismic.text */.X5.text(title1),
      copy: Prismic/* Prismic.text */.X5.text(copy),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Embed/* Embed */.c, {
        html: (_ = video[0]) === null || _ === void 0 ? void 0 : (_$oembed = _.oembed) === null || _$oembed === void 0 ? void 0 : _$oembed.html,
        noSpace: true,
        type: "inline"
      })
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/VideoElContainer.tsx




var VideoElContainer = function VideoElContainer(_ref) {
  var body_video = _ref.body_video;

  if (!(body_video !== null && body_video !== void 0 && body_video.url)) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Segment/* Segment */.X, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video_Video, {
      src: body_video === null || body_video === void 0 ? void 0 : body_video.url,
      muted: true,
      loop: true,
      width: 1180,
      autoPlay: true
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/Slices.tsx


function Slices_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Slices_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Slices_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Slices_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












































































var CustomModuleContainer = (0,dynamic["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(82), __webpack_require__.e(273), __webpack_require__.e(505)]).then(__webpack_require__.bind(__webpack_require__, 45505));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(45505)];
    }
  }
});
var HousingLoanCalculatorContainer = (0,dynamic["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(674), __webpack_require__.e(273), __webpack_require__.e(477)]).then(__webpack_require__.bind(__webpack_require__, 44477));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(44477)];
    }
  }
});
var SliceType;

(function (SliceType) {
  SliceType["AnnualHero"] = "annual_report_hero";
  SliceType["SUBHERO"] = "hero";
  SliceType["FRONTPAGEHERO"] = "frontpage_hero";
  SliceType["COMPACTHERO"] = "compact_hero";
  SliceType["TEXT"] = "text";
  SliceType["TEXT_WITH_AUTHORS"] = "text_with_authors";
  SliceType["TEXT_WITH_SIDE_TEXT"] = "text_with_side_text";
  SliceType["TEXT_WITH_IMAGE"] = "text_with_image";
  SliceType["TEXT_WITH_IMAGES"] = "text_with_images";
  SliceType["TEXT_WITH_VIDEO"] = "text_with_video";
  SliceType["TEXT_WITH_RELATED"] = "text_with_related";
  SliceType["TEXT_WITH_LINKS"] = "text_with_links";
  SliceType["TEXT_WITH_POINTS"] = "text_with_points";
  SliceType["TEXT_WITH_PULL_OUT"] = "text_with_pull_out";
  SliceType["TEXT_WITH_ICON"] = "text_with_icon";
  SliceType["POINTS"] = "points";
  SliceType["INTRO_TEXT"] = "intro_text";
  SliceType["EMPHASIS_TEXT"] = "emphasis_text";
  SliceType["QUOTE"] = "quote";
  SliceType["IMAGES"] = "images";
  SliceType["VIDEO"] = "video";
  SliceType["EMBED"] = "embed";
  SliceType["TABLE"] = "table";
  SliceType["TABLE_WITH_IMAGES"] = "table_with_images";
  SliceType["FAQ"] = "faq";
  SliceType["CONTENT_INDEX_NAV"] = "content_nav";
  SliceType["INTEREST_CALLOUT"] = "interest_callout";
  SliceType["STAFF_WITH_CONTACT"] = "staff_with_contact";
  SliceType["STAFF_WITH_BIO"] = "staff_with_bio";
  SliceType["RELATED_CONTENT"] = "related_content";
  SliceType["PRODUCT_CARDS"] = "product_cards";
  SliceType["ARTICLE_CARDS"] = "article_cards";
  SliceType["NEWS_CARDS"] = "news_cards";
  SliceType["OTHER_CARDS"] = "other_cards";
  SliceType["MORE_INFO"] = "more_info";
  SliceType["TEXT_CARDS"] = "text_cards";
  SliceType["CARD_INFO"] = "card_info";
  SliceType["CUSTOM_MODULE"] = "custom_module";
  SliceType["BECOME_A_CUSTOMER"] = "become_a_customer";
  SliceType["HOUSING_LOAN_CALCULATOR"] = "housing_loan_calculator";
  SliceType["DOWNLOAD_LINKS"] = "download_links";
  SliceType["IFRAME"] = "iframe";
  SliceType["MAILING_LIST"] = "mailing_list";
  SliceType["MARKETS"] = "markets";
  SliceType["INFOGRAM"] = "infogram";
  SliceType["BUZZSPROUT"] = "buzzsprout";
  SliceType["EVENT_REGISTRATION"] = "event_sign_up";
  SliceType["SERVICE_LOCATIONS"] = "service_locations";
  SliceType["ACCORDION"] = "accordion";
  SliceType["QUARTERTS"] = "quarters";
  SliceType["HIGHLIGHT_NUMBERS"] = "highlight_numbers";
  SliceType["SHORTCUTS"] = "shortcuts";
  SliceType["VIDEOEL"] = "video_el";
  SliceType["GDPR"] = "gdprrequest";
  SliceType["ARTICLE_HERO"] = "article_hero";
  SliceType["FEATURED_ARTICLES"] = "featured_articles";
  SliceType["FEATURED_PODCASTS"] = "featured_podcasts";
  SliceType["ORDER_GIFT_CARD"] = "order_gift_card";
  SliceType["ANNUAL_MODULE"] = "annual_module";
  SliceType["TILES"] = "tiles";
  SliceType["ANNUAL_INTRO"] = "annual_intro";
  SliceType["ANNUAL_QUOTE"] = "annual_quote";
  SliceType["QUOTE_EXPAND"] = "quote_expand";
  SliceType["TEXT_WITH_NUMBERS"] = "text_with_numbers";
  SliceType["BOXES"] = "boxes";
  SliceType["TABLE_WITH_LARGE_TEXT"] = "table_with_large_text";
  SliceType["BOOK_APPOINTMENT"] = "book_appointment";
  SliceType["TERMS_DIALOG"] = "terms_dialog";
  SliceType["KAUPHOLL_NEWS"] = "kaupholl_news";
  SliceType["JOTFORM"] = "jotform";
  SliceType["IMAGE_LINK"] = "image_link";
  SliceType["SJODIR"] = "sjodir";
})(SliceType || (SliceType = {}));

var Slices_Slices = function Slices(_ref) {
  var data = _ref.data,
      template = _ref.template;
  var router = (0,next_router.useRouter)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (data || []).map(function (s, i) {
      var _router$query, _router$query2;

      var key = "slice".concat(s.type, "-").concat(i);

      var props = Slices_objectSpread(Slices_objectSpread({}, s), s.primary);

      if (router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.onlyslicetype && (router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.onlyslicetype) !== s.type) {
        return null;
      } // eslint-disable-next-line sonarjs/max-switch-cases


      switch (s.type) {
        case SliceType.AnnualHero:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualHeroContainer, Slices_objectSpread({}, props), key);

        case SliceType.SUBHERO:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubPageHeroContainer, Slices_objectSpread({}, props), key);

        case SliceType.FRONTPAGEHERO:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FrontPageHeroContainer, Slices_objectSpread({}, props), key);

        case SliceType.COMPACTHERO:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompactHeroContainer, Slices_objectSpread({}, props), key);

        case SliceType.TEXT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichTextContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.TEXT_WITH_IMAGE:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithImageContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.TEXT_WITH_IMAGES:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithImagesContainer_TextWithImagesContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.TEXT_WITH_RELATED:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithRelatedContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.TEXT_WITH_AUTHORS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithAuthorContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.TEXT_WITH_SIDE_TEXT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithSideTextContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.TEXT_WITH_VIDEO:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithVideoContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.TEXT_WITH_LINKS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithLinksContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.TEXT_WITH_POINTS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPointsContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.TEXT_WITH_PULL_OUT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithPullOutContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.TEXT_WITH_ICON:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithIconContainer, Slices_objectSpread({}, props), key);

        case SliceType.POINTS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PointsContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.INTRO_TEXT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntroTextContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.EMPHASIS_TEXT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmphasisContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.QUOTE:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.IMAGES:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImagesContainer, Slices_objectSpread(Slices_objectSpread({}, props), {}, {
            template: template
          }), key);

        case SliceType.VIDEO:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoContainer, Slices_objectSpread({}, props), key);

        case SliceType.EMBED:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmbedContainer, Slices_objectSpread({}, props), key);

        case SliceType.TABLE:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableContainer_TableContainer, Slices_objectSpread({}, props), key);

        case SliceType.TABLE_WITH_IMAGES:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableWithImagesContainer, Slices_objectSpread({
            props: true
          }, props), key);

        case SliceType.FAQ:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FaqContainer, Slices_objectSpread({}, props), key);

        case SliceType.CONTENT_INDEX_NAV:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentNavContainer, Slices_objectSpread({}, props), key);

        case SliceType.INTEREST_CALLOUT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InterestCalloutContainer, Slices_objectSpread({}, props), key);

        case SliceType.STAFF_WITH_CONTACT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffWithContactContainer, Slices_objectSpread({
            id: "Staff_with_Contact"
          }, props), key);

        case SliceType.STAFF_WITH_BIO:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StaffWithBioContainer, Slices_objectSpread({}, props), key);

        case SliceType.RELATED_CONTENT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedContainer, Slices_objectSpread({}, props), key);

        case SliceType.PRODUCT_CARDS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductCardsContainer, Slices_objectSpread({}, props), key);

        case SliceType.ARTICLE_CARDS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleContainer, Slices_objectSpread({}, props), key);

        case SliceType.NEWS_CARDS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsCardsContainer, Slices_objectSpread({}, props), key);

        case SliceType.OTHER_CARDS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherCardsContainer, Slices_objectSpread({}, props), key);

        case SliceType.MORE_INFO:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreInfoContainer, Slices_objectSpread({}, props), key);

        case SliceType.TEXT_CARDS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextCardsContainer, Slices_objectSpread({}, props), key);

        case SliceType.CUSTOM_MODULE:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomModuleContainer, Slices_objectSpread({}, props), key);

        case SliceType.DOWNLOAD_LINKS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DownloadLinksContainer, Slices_objectSpread({}, props), key);

        case SliceType.IFRAME:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IframeContainer, Slices_objectSpread({}, props), key);

        case SliceType.INFOGRAM:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfogramContainer, Slices_objectSpread({}, props), key);

        case SliceType.BUZZSPROUT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BuzzsproutContainer, Slices_objectSpread({}, props), key);

        case SliceType.ACCORDION:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionContainer, Slices_objectSpread({}, props), key);

        case SliceType.QUARTERTS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuartersContainer_QuartersContainer, Slices_objectSpread({}, props), key);

        case SliceType.HIGHLIGHT_NUMBERS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightNumbersContainer, Slices_objectSpread({}, props), key);

        case SliceType.SHORTCUTS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShortcutsContainer, Slices_objectSpread({}, props), key);

        case SliceType.VIDEOEL:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VideoElContainer, Slices_objectSpread({}, props), key);

        case SliceType.ARTICLE_HERO:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleHeroContainer, Slices_objectSpread({}, props), key);

        case SliceType.FEATURED_ARTICLES:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedArticlesContainer, Slices_objectSpread({}, props), key);

        case SliceType.FEATURED_PODCASTS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturedPodcastsContainer, Slices_objectSpread({}, props), key);

        case SliceType.ANNUAL_MODULE:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualModuleContainer, Slices_objectSpread({}, props), key);

        case SliceType.TILES:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TilesContainer, Slices_objectSpread({}, props), key);

        case SliceType.ANNUAL_INTRO:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualIntroContainer, Slices_objectSpread({}, props), key);

        case SliceType.ANNUAL_QUOTE:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnnualQuoteContainer, Slices_objectSpread({}, props), key);

        case SliceType.QUOTE_EXPAND:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuoteExpandContainer, Slices_objectSpread({}, props), key);

        case SliceType.TEXT_WITH_NUMBERS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextWithNumbersContainer, Slices_objectSpread({}, props), key);

        case SliceType.BOXES:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BoxesContainer, Slices_objectSpread({}, props), key);

        case SliceType.TABLE_WITH_LARGE_TEXT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TableWithLargeTextContainer, Slices_objectSpread({}, props), key);

        case SliceType.BECOME_A_CUSTOMER:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BecomeACustomerContainer, Slices_objectSpread({}, props), key);

        case SliceType.HOUSING_LOAN_CALCULATOR:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HousingLoanCalculatorContainer, Slices_objectSpread({}, props), key);

        case SliceType.CARD_INFO:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaymentCardInfoContainer, Slices_objectSpread({
            className: "payment-info"
          }, props), key);

        case SliceType.CUSTOM_MODULE:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomModuleContainer, Slices_objectSpread({}, props), key);

        case SliceType.MAILING_LIST:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MailingListContainer, Slices_objectSpread({}, props), key);

        case SliceType.MARKETS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketsContainer, Slices_objectSpread({}, props), key);

        case SliceType.ORDER_GIFT_CARD:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OrderGiftCardContainer, Slices_objectSpread({}, props), key);

        case SliceType.BOOK_APPOINTMENT:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookAppointmentContainer, Slices_objectSpread({}, props), key);

        case SliceType.EVENT_REGISTRATION:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventRegistrationContainer, Slices_objectSpread({}, props), key);

        case SliceType.GDPR:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GdprRequestContainer, Slices_objectSpread({}, props), key);

        case SliceType.SERVICE_LOCATIONS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceLocationsContainer, Slices_objectSpread({}, props), key);

        case SliceType.JOTFORM:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JotFormContainer, Slices_objectSpread({}, props), key);

        case SliceType.TERMS_DIALOG:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TermsDialogContainer, Slices_objectSpread({}, props), key);

        case SliceType.KAUPHOLL_NEWS:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KauphollNewsContainer, Slices_objectSpread({}, props), key);

        case SliceType.IMAGE_LINK:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AukakronurCardsContainer, Slices_objectSpread({}, props), key);

        case SliceType.SJODIR:
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FundsContainer, Slices_objectSpread({}, props), key);

        default:
          if (s.type) {
            console.warn('No slice available for %s %o', s.type, s); // tslint:disable-line
          }

          return null;
      }
    })
  });
};
;// CONCATENATED MODULE: ../../packages/slices/src/containers/SlicesContainer.tsx


function SlicesContainer_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var SlicesContainer_ref =  true ? {
  name: "1sawbps",
  styles: ">section:first-child .left{p:first-child::first-letter{font-family:'LB-font-serif-bold';float:left;font-size:120px;margin-right:10px;margin-top:6px;padding:0;line-height:90px;}}"
} : 0;

var _ref2 =  true ? {
  name: "1xf3iwm",
  styles: "section:first-child{padding-bottom:2px;}"
} : 0;

var SpacingRules = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xbkeqd0"
} : 0)(".intro{&:first-child{padding-top:72px;@media ", devices/* device.tablet */.U.tablet, "{padding-top:130px;}}}.payment-info{@media (max-width: 767px){margin-top:12em;}}.payment-info+.payment-info{@media (max-width: 767px){margin-top:6em;}}.intro+.text-points{padding-top:0;}.text-images+.text-images{padding-top:0;}", function (props) {
  return props.articleAbstract ? _ref2 : '';
}, ";", function (props) {
  return props.isArticle && !props.skipBigLetter && SlicesContainer_ref;
}, ";" + ( true ? "" : 0));

function SlicesContainer(_ref3) {
  var data = _ref3.data,
      template = _ref3.template,
      articleAbstract = _ref3.articleAbstract,
      skipBigLetter = _ref3.skipBigLetter;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SpacingRules, {
    isArticle: template === 'article',
    skipBigLetter: skipBigLetter,
    articleAbstract: articleAbstract !== undefined,
    children: [articleAbstract && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichTextContainer, {
      text: articleAbstract,
      template: "article"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Slices_Slices, {
      data: data,
      template: template
    })]
  });
}

/***/ }),

/***/ 31388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ Dialog; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../packages/l16n/src/index.ts + 9 modules
var src = __webpack_require__(63762);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../packages/ui/src/components/icons/Close.tsx
var Close = __webpack_require__(32634);
// EXTERNAL MODULE: ../../packages/ui/src/styles/devices.ts
var devices = __webpack_require__(7949);
// EXTERNAL MODULE: ../../packages/ui/src/styles/typography.tsx
var typography = __webpack_require__(52539);
// EXTERNAL MODULE: ../../packages/ui/src/styles/mixins.ts
var mixins = __webpack_require__(2522);
// EXTERNAL MODULE: ../../packages/ui/src/styles/theme.ts
var theme = __webpack_require__(58176);
;// CONCATENATED MODULE: ../../packages/ui/src/components/dialog/Dialog.res.ts
/* harmony default export */ var Dialog_res = ({
  closeAriaLabel: {
    is: 'Loka glugga',
    en: 'Close window',
    pl: 'Zamknij okno'
  }
});
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../packages/ui/src/components/dialog/Dialog.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var Host = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "esgcagf6"
} : 0)("background-color:", theme/* theme.colors.background */.r.colors.background, ";position:fixed;overflow:scroll;top:0;left:0;min-width:100vw;min-height:100vh;z-index:101;@media ", devices/* device.desktop */.U.desktop, "{background:rgba(21, 46, 72, 0.9);}" + ( true ? "" : 0));

var AbsoluteContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "esgcagf5"
} : 0)("position:absolute;top:0;left:0;width:100%;z-index:101;background:white;@media ", devices/* device.desktop */.U.desktop, "{margin:90px 130px 90px 130px;width:calc(100% - 260px);}" + ( true ? "" : 0));

var Container = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "esgcagf4"
} : 0)("margin-left:44px;margin-right:44px;display:flex;flex-direction:column;flex-wrap:wrap;min-height:100vh;flex:1;padding-bottom:144px;@media ", devices/* device.desktop */.U.desktop, "{margin-left:100px;margin-right:100px;}" + ( true ? "" : 0));

var Header = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "esgcagf3"
} : 0)("position:fixed;display:flex;justify-content:space-between;align-items:center;width:100%;background-color:", theme/* theme.shades.primary2 */.r.shades.primary2, ";z-index:101;padding:23px 44px 25px 44px;" + ( true ? "" : 0));

var Title = (0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "esgcagf2"
} : 0)(typography/* typography.body */.cp.body, " cursor:pointer;font-weight:bold;", function (props) {
  return props.hidden ? mixins/* sronly */._7 : '';
}, ";" + ( true ? "" : 0));

var HeaderBackButton = (0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "esgcagf1"
} : 0)( true ? {
  name: "1ur36im",
  styles: "cursor:pointer;width:30px"
} : 0);

var ChildContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "esgcagf0"
} : 0)("padding-top:", function (props) {
  if (!props.noHeader) {
    return props.removeConatinerTopPadding ? '72px;' : '156px;';
  }

  return '20px;';
}, ";" + ( true ? "" : 0));

function Dialog(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      title = _ref.title,
      removeContainarTopPadding = _ref.removeContainarTopPadding;

  var _useResource = (0,src/* useResource */.Wf)(),
      r = _useResource.r;

  var titleRef = (0,react.useRef)(null);
  var root = (0,react.useMemo)(function () {
    if (true) {
      return document.getElementById('portal');
    }
  }, []);
  (0,react.useEffect)(function () {
    if (true) {
      document.body.style.overflow = 'hidden';
      root === null || root === void 0 ? void 0 : root.setAttribute('inert', 'true');
      return function () {
        document.documentElement.style.overflow = '';
        root === null || root === void 0 ? void 0 : root.setAttribute('inert', 'false');
      };
    }
  }, [root]);
  (0,react.useEffect)(function () {
    if (titleRef && titleRef.current) {
      titleRef.current.focus();
    }
  }, [titleRef]);

  if (!root) {
    return null;
  }

  return /*#__PURE__*/(0,react_dom.createPortal)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Host, {
    role: "dialog",
    "aria-modal": true,
    "data-cy": "overlayDialog",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AbsoluteContainer, {
      children: [onClose !== undefined ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Header, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
          tabIndex: -1,
          ref: titleRef,
          hidden: title.hidden,
          children: title.label
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderBackButton, {
          onClick: onClose,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Close/* Close */.x, {
            "aria-label": r(Dialog_res.closeAriaLabel)
          })
        })]
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
        tabIndex: -1,
        ref: titleRef,
        hidden: true,
        children: title.label
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChildContainer, {
          removeConatinerTopPadding: removeContainarTopPadding,
          noHeader: onClose === undefined,
          children: children
        })
      })]
    })
  }), root);
}

/***/ }),

/***/ 49505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);


var fnCall = function fnCall(variable, props) {
  return typeof variable === 'function' ? variable(props) : variable;
};

var Divider = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1axu5he0"
} : 0)("width:", function (props) {
  var _props$width;

  return (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '27px';
}, ";height:1px;background-color:", function (props) {
  var _fnCall;

  return (_fnCall = fnCall(props.color, props)) !== null && _fnCall !== void 0 ? _fnCall : props.theme.colors.foreground;
}, ";margin:", function (props) {
  var _props$margin;

  return (_props$margin = props.margin) !== null && _props$margin !== void 0 ? _props$margin : '16px 0';
}, ";" + ( true ? "" : 0));

/***/ }),

/***/ 51250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ InputHost; },
/* harmony export */   "u3": function() { return /* binding */ inputCss; },
/* harmony export */   "II": function() { return /* binding */ Input; }
/* harmony export */ });
/* unused harmony export SuffixLabel */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20406);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8529);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28526);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28165);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32706);
/* harmony import */ var react_use_measure__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(731);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6804);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52539);
/* harmony import */ var _validation_Form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(37330);
/* harmony import */ var _Label__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92527);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52903);





var _excluded = ["inputRef", "isValid", "label", "errorMessage", "variant", "labelVariant", "textAlign", "errorMessageVariant", "hackSuffix"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var InputHost = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eyixvtn2"
} : 0)( true ? {
  name: "1z08ima",
  styles: "display:flex;flex-direction:column;position:relative;&>*+*{margin-top:8px;}"
} : 0);
var inputCss = function inputCss(_ref) {
  var _theme$colors$foregro;

  var inputSize = _ref.inputSize,
      variant = _ref.variant,
      theme = _ref.theme,
      isValid = _ref.isValid;
  return /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("width:100%;height:", inputSize === 'small' ? '40px' : '64px', ";color:", theme.shades.primary5, ";padding:20px 16px;", variant === 'fullBorder' && "box-shadow: 0 0 0 1px\n     ".concat((0,polished__WEBPACK_IMPORTED_MODULE_6__/* .rgba */ .m4)(theme.colors.foreground, 0.7)), ";", variant === 'bottomBorder' && "border-bottom: 1px solid\n     ".concat((0,polished__WEBPACK_IMPORTED_MODULE_6__/* .rgba */ .m4)(theme === null || theme === void 0 ? void 0 : theme.colors.foreground, 0.7)), ";&:hover{box-shadow:0 0 0 1px ", theme === null || theme === void 0 ? void 0 : theme.colors.foreground, ";", variant === 'fullBorder' && "box-shadow: 0 0 0 1px\n     ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.foreground), ";", variant === 'bottomBorder' && "border-bottom: 1px solid\n     ".concat((0,polished__WEBPACK_IMPORTED_MODULE_6__/* .rgba */ .m4)(theme.colors.foreground, 0.3)), ";&::placeholder{color:", theme.shades.primary5, ";}}&:focus+label{color:", (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .rgba */ .m4)(theme.shades.primary5, 0.6), ";}&:active,&:focus{box-shadow:0 0 0 2px ", theme.shades.primary3, ";}", isValid === false && "\n    box-shadow: 0 0 0 2px ".concat(theme.colors.secondary, ";\n  "), " &::placeholder{color:", (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .rgba */ .m4)(theme.shades.primary5, 0.6), ";}&:disabled{opacity:0.5;background-color:", (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .rgba */ .m4)((_theme$colors$foregro = theme.colors.foreground) !== null && _theme$colors$foregro !== void 0 ? _theme$colors$foregro : '', 0.05), ";}transition:box-shadow 0.1s ease-in;" + ( true ? "" : 0),  true ? "" : 0);
};

var BaseInput = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("input",  true ? {
  target: "eyixvtn1"
} : 0)(inputCss, ";", function (props) {
  return props.inputSize === 'small' ? _styles_typography__WEBPACK_IMPORTED_MODULE_7__/* .typography.numbers */ .cp.numbers : props.inputSize === 'big' ? _styles_typography__WEBPACK_IMPORTED_MODULE_7__/* .typography.input2 */ .cp.input2 : _styles_typography__WEBPACK_IMPORTED_MODULE_7__/* .typography.body */ .cp.body;
}, ";" + ( true ? "" : 0));

var SuffixLabel = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "eyixvtn0"
} : 0)("position:absolute;", _styles_typography__WEBPACK_IMPORTED_MODULE_7__/* .typography.body */ .cp.body, ";top:52%;transform:translateY(-50%);right:16px;opacity:", function (props) {
  return props.isActive ? '30%' : '100%';
}, ";margin-top:0px;color:", function (_ref2) {
  var theme = _ref2.theme;
  return (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .rgba */ .m4)(theme.shades.primary5, 1);
}, ";height:24px;text-decoration:none;&:hover{color:", function (_ref3) {
  var theme = _ref3.theme;
  return (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .rgba */ .m4)(theme.shades.primary5, 0.6);
}, ";}" + ( true ? "" : 0));
function Input(_ref4) {
  var _rest$id, _rest$id2;

  var inputRef = _ref4.inputRef,
      isValid = _ref4.isValid,
      label = _ref4.label,
      errorMessage = _ref4.errorMessage,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'fullBorder' : _ref4$variant,
      _ref4$labelVariant = _ref4.labelVariant,
      labelVariant = _ref4$labelVariant === void 0 ? 'aboveInput' : _ref4$labelVariant,
      _ref4$textAlign = _ref4.textAlign,
      textAlign = _ref4$textAlign === void 0 ? 'left' : _ref4$textAlign,
      _ref4$errorMessageVar = _ref4.errorMessageVariant,
      errorMessageVariant = _ref4$errorMessageVar === void 0 ? 'belowInput' : _ref4$errorMessageVar,
      hackSuffix = _ref4.hackSuffix,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref4, _excluded);

  var _useMeasure = (0,react_use_measure__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(),
      _useMeasure2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useMeasure, 2),
      innerRef = _useMeasure2[0],
      inner = _useMeasure2[1];

  var formContext = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_validation_Form__WEBPACK_IMPORTED_MODULE_11__/* .FormContext */ .q);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      visited = _useState[0],
      setVisited = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)((0,uuid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)()),
      uuid = _useState3[0];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)((0,uuid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)()),
      errorLabelId = _useState4[0];

  var showValidState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () {
    return !focused && formContext.validate && !isValid || !focused && visited && !!rest.value && rest.value !== hackSuffix;
  }, [visited, isValid, focused, rest.value, hackSuffix, formContext.validate]);
  var errorTransition = (0,react_spring__WEBPACK_IMPORTED_MODULE_4__.useTransition)(errorMessage && errorMessageVariant === 'belowInput', {
    enter: function enter() {
      return /*#__PURE__*/function () {
        var _ref5 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee(next) {
          return _app_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return next({
                    height: inner.height,
                    opacity: 1,
                    overflow: 'hidden'
                  });

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref5.apply(this, arguments);
        };
      }();
    },
    leave: function leave() {
      return /*#__PURE__*/function () {
        var _ref6 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee2(next) {
          return _app_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return next({
                    opacity: 0,
                    height: 0,
                    overflow: 'hidden'
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref6.apply(this, arguments);
        };
      }();
    },
    update: {
      height: inner.height
    },
    config: _objectSpread(_objectSpread({}, react_spring__WEBPACK_IMPORTED_MODULE_4__.config.stiff), {}, {
      clamp: true
    })
  });
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(InputHost, {
    children: [label && labelVariant === 'aboveInput' && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_Label__WEBPACK_IMPORTED_MODULE_15__/* .Label */ .__, {
      size: rest.inputSize,
      htmlFor: (_rest$id = rest.id) !== null && _rest$id !== void 0 ? _rest$id : uuid,
      disabled: rest.disabled,
      isValid: showValidState ? isValid : undefined,
      children: label
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)("div", {
      style: {
        position: 'relative'
      },
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(BaseInput, _objectSpread(_objectSpread({
        ref: inputRef,
        id: (_rest$id2 = rest.id) !== null && _rest$id2 !== void 0 ? _rest$id2 : uuid,
        isValid: showValidState ? isValid : undefined,
        "aria-invalid": !isValid,
        visited: visited,
        "aria-describedby": errorLabelId,
        variant: variant,
        labelVariant: labelVariant,
        style: {
          textAlign: textAlign
        }
      }, rest), {}, {
        onFocus: function onFocus(e) {
          setFocused(true);

          if (rest.onFocus) {
            rest.onFocus(e);
          }
        },
        onBlur: function onBlur(e) {
          setVisited(true);
          setFocused(false);

          if (rest.onBlur) {
            rest.onBlur(e);
          }
        }
      })), hackSuffix && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(SuffixLabel, {
        isActive: focused,
        children: hackSuffix
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_Label__WEBPACK_IMPORTED_MODULE_15__/* .AnimatedErrorLabel */ .P3, {
      visible: !!errorMessage && errorMessageVariant === 'belowInput',
      id: errorLabelId,
      errorMessage: errorMessage
    })]
  });
}

/***/ }),

/***/ 90917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ KennitalaInput; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9462);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51250);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);



var _excluded = ["inputSize", "input", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1ctk7tq1"
} : 0)( true ? "" : 0);

var FormattedInput = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_Input__WEBPACK_IMPORTED_MODULE_4__/* .Input */ .II,  true ? {
  target: "e1ctk7tq0"
} : 0)( true ? {
  name: "wz1gv9",
  styles: "text-align:center;width:100%"
} : 0);

function KennitalaInput(_ref) {
  var inputSize = _ref.inputSize,
      input = _ref.input,
      value = _ref.value,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Host, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({
      customInput: input !== null && input !== void 0 ? input : FormattedInput,
      displayType: "input",
      format: value !== undefined && value !== null && (value === null || value === void 0 ? void 0 : value.toString().length) > 6 ? '######-####' : undefined,
      inputSize: inputSize,
      value: value
    }, rest))
  });
}

/***/ }),

/***/ 8422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PhoneInput; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9462);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51250);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);



var _excluded = ["inputSize", "input", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1bo2g241"
} : 0)( true ? "" : 0);

var FormattedInput = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_Input__WEBPACK_IMPORTED_MODULE_4__/* .Input */ .II,  true ? {
  target: "e1bo2g240"
} : 0)( true ? {
  name: "wz1gv9",
  styles: "text-align:center;width:100%"
} : 0);

function PhoneInput(_ref) {
  var inputSize = _ref.inputSize,
      input = _ref.input,
      value = _ref.value,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Host, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({
      customInput: input !== null && input !== void 0 ? input : FormattedInput,
      displayType: "input",
      format: value !== undefined && value !== null && value.toString().trim().length > 3 ? '###-####' : undefined,
      inputSize: inputSize,
      value: value
    }, rest))
  });
}

/***/ }),

/***/ 43032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ DateInput; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../packages/l16n/src/index.ts + 9 modules
var src = __webpack_require__(63762);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/locale/en-GB/index.js + 1 modules
var en_GB = __webpack_require__(66476);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/locale/is/index.js + 5 modules
var is = __webpack_require__(82215);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(37726);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../packages/ui/src/components/icons/Datepicker.tsx





var Svg = (0,emotion_styled_base_browser_esm/* default */.Z)("svg",  true ? {
  target: "evp2ate0"
} : 0)("& path{fill:transparent;", function (_ref) {
  var active = _ref.active;
  return active && 'fill: #cee1ea;';
}, ";}& rect,& line{stroke:#bbc4cd;", function (_ref2) {
  var active = _ref2.active,
      hover = _ref2.hover;
  return (active || hover) && 'stroke: #20446a';
}, ";}&:hover path{fill:#cee1ea;}" + ( true ? "" : 0));

function Datepicker(_ref3) {
  var active = _ref3.active,
      hover = _ref3.hover;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Svg, {
    width: "28px",
    height: "26px",
    viewBox: "0 0 28 26",
    version: "1.1",
    active: active,
    hover: hover,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
      id: "Gengi",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
        id: "Artboard",
        transform: "translate(-144.000000, -71.000000)",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
          id: "Group",
          transform: "translate(145.000000, 72.000000)",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M2.18181818,2.18181818 L24,2.18181818 C25.2049849,2.18181818 26.1818182,3.15865145 26.1818182,4.36363636 L26.1818182,9.45454545 L26.1818182,9.45454545 L0,9.45454545 L0,4.36363636 C-1.47568091e-16,3.15865145 0.976833273,2.18181818 2.18181818,2.18181818 Z",
            id: "Rectangle-Copy-16"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
            id: "Rectangle-Copy-17",
            stroke: "#20446A",
            strokeLinejoin: "round",
            x: "0",
            y: "2.18181818",
            width: "26.1818182",
            height: "21.8181818",
            rx: "2.18181818"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
            x1: "6.90909091",
            y1: "0.363636364",
            x2: "6.90909091",
            y2: "4",
            id: "Line-7-Copy-4",
            stroke: "#20446A",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
            x1: "19.2727273",
            y1: "0.363636364",
            x2: "19.2727273",
            y2: "4",
            id: "Line-7-Copy-5",
            stroke: "#20446A",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("line", {
            x1: "0.622314453",
            y1: "9.5",
            x2: "25.5",
            y2: "9.5",
            id: "Line-Copy",
            stroke: "#20446A",
            strokeLinecap: "square"
          })]
        })
      })
    })
  });
}
// EXTERNAL MODULE: ../../packages/ui/src/components/form/Input.tsx
var Input = __webpack_require__(51250);
;// CONCATENATED MODULE: ../../packages/ui/src/components/form/date-input/DateInput.tsx



var _excluded = ["value", "onChange", "placeholder", "disabled", "filterDate", "includeDates"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var InputHost = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ej96h6r2"
} : 0)( true ? {
  name: "13h6lvl",
  styles: "display:flex;position:relative;flex-direction:column;& input{overflow:hidden;width:100%;}.react-datepicker-popper{z-index:10;}svg:hover path{fill:#cee1ea;}"
} : 0);

var IconContainer = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ej96h6r1"
} : 0)( true ? {
  name: "rbe4e7",
  styles: "position:absolute;z-index:9;right:21px;top:50%;pointer-events:none"
} : 0);

var DatePicker = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((react_datepicker_min_default()),  true ? {
  target: "ej96h6r0"
} : 0)( true ? "" : 0);

var DateInput = function DateInput(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      filterDate = _ref.filterDate,
      includeDates = _ref.includeDates,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useState = (0,react.useState)(false),
      hover = _useState[0],
      setHover = _useState[1];

  var _useState2 = (0,react.useState)(false),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useResource = (0,src/* useResource */.Wf)(),
      locale = _useResource.locale;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InputHost, _objectSpread(_objectSpread({}, rest), {}, {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DatePicker, {
      disabled: disabled,
      selected: value,
      placeholderText: placeholder,
      onChange: function onChange(val) {
        return _onChange(val);
      },
      onFocus: function onFocus() {
        return setActive(true);
      },
      onBlur: function onBlur() {
        return setActive(false);
      },
      filterDate: filterDate,
      includeDates: includeDates,
      customInput: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* Input */.II, _objectSpread({}, rest)),
      dateFormat: locale === 'en' ? 'dd/MM/yyyy' : 'dd.MM.yyyy',
      locale: locale === 'en' ? en_GB/* default */.Z : is/* default */.Z
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconContainer, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Datepicker, {
        active: active,
        hover: hover
      })
    })]
  }));
};

/***/ }),

/***/ 90965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ MoneyInput; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var _landsbankinn_l16n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63762);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _NumberFormatInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52541);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);


var _excluded = ["onChangeValue", "currency", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var MoneyInput = function MoneyInput(_ref) {
  var onChangeValue = _ref.onChangeValue,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'ISK' : _ref$currency,
      value = _ref.value,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var _useResource = (0,_landsbankinn_l16n__WEBPACK_IMPORTED_MODULE_1__/* .useResource */ .Wf)(),
      locale = _useResource.locale;

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_NumberFormatInput__WEBPACK_IMPORTED_MODULE_5__/* .NumberFormatInput */ .v, _objectSpread({
    isAllowed: function isAllowed(_ref2) {
      var floatValue = _ref2.floatValue;
      return floatValue === undefined || floatValue >= 0 && floatValue < 10e8;
    },
    onChange: function onChange(e) {
      /* We use on change because onValueChange triggers when value prop changes, creating a loop */
      onChangeValue(parseFloat(locale === 'is' ? e.currentTarget.value.replace(/\./g, '').replace(/,/g, '.') : e.currentTarget.value.replace(/,/g, '')));
    },
    displayType: "input",
    allowEmptyFormatting: true,
    suffix: currency,
    value: value,
    decimalScale: currency === 'ISK' ? 0 : 2
  }, rest));
};

/***/ }),

/***/ 52541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ NumberFormatInput; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _landsbankinn_l16n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63762);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9462);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51250);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52903);



var _excluded = ["inputSize", "input", "suffix"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var FormattedInput = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_Input__WEBPACK_IMPORTED_MODULE_5__/* .Input */ .II,  true ? {
  target: "earr1ed1"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var InputContainer = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "earr1ed0"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

function NumberFormatInput(_ref) {
  var inputSize = _ref.inputSize,
      input = _ref.input,
      suffix = _ref.suffix,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, _excluded);

  var _useResource = (0,_landsbankinn_l16n__WEBPACK_IMPORTED_MODULE_2__/* .useResource */ .Wf)(),
      locale = _useResource.locale;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      focused = _useState[0],
      setFocused = _useState[1];
  /*   const formatSuffix = input || inputSize === 'small' ? suffix : undefined; */


  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(InputContainer, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(react_number_format__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
      customInput: input !== null && input !== void 0 ? input : FormattedInput,
      thousandSeparator: locale === 'is' ? '.' : ',',
      decimalSeparator: locale === 'is' ? ',' : '.',
      displayType: "input",
      inputSize: inputSize,
      allowEmptyFormatting: true
      /*         suffix={
        rest.labelVariant !== 'aboveInput' && !rest.value && !focused
          ? undefined
          : suffix
      } */

      /* Need to send in suffix under new name so custom input can work with it */
      ,
      hackSuffix: suffix,
      onFocus: function onFocus(e) {
        setFocused(true);

        if (rest.onFocus) {
          rest.onFocus(e);
        }
      },
      onBlur: function onBlur(e) {
        setFocused(false);

        if (rest.onBlur) {
          rest.onBlur(e);
        }
      }
    }, rest))
  });
}

/***/ }),

/***/ 90242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ NumberInput; }
/* harmony export */ });
/* unused harmony export NumberHost */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51250);
/* harmony import */ var _NumberFormatInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52541);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);



var _excluded = ["allowNegatives", "onChange", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1rmuf303"
} : 0)( true ? "" : 0);
/*const Input = styled.input`
  width: 44px;
  text-align: center;
  ${typography.input2};
  padding-top: 5px;
`;*/


var MinusButton = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button",  true ? {
  target: "e1rmuf302"
} : 0)("border:1px solid ", function (props) {
  return (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rgba */ .m4)(props.theme.colors.primary, 0.3);
}, ";border-radius:100px;height:30px;width:30px;color:transparent;display:inline-block;position:absolute;cursor:pointer;left:20px;top:50%;z-index:10;cursor:pointer;&::after{content:'';display:block;border-bottom:1px solid ", function (props) {
  return (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rgba */ .m4)(props.theme.colors.primary, 0.3);
}, ";position:absolute;top:50%;left:calc(50% - 4px);width:9px;}" + ( true ? "" : 0));

var PlusButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(MinusButton,  true ? {
  target: "e1rmuf301"
} : 0)("left:initial;right:20px;&::before{content:'';display:block;border-bottom:1px solid ", function (props) {
  return (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rgba */ .m4)(props.theme.colors.primary, 0.3);
}, ";position:absolute;top:50%;left:calc(50% - 4px);width:9px;transform:rotate(90deg);}" + ( true ? "" : 0));

var NumberHost = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1rmuf300"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
function NumberInput(_ref) {
  var allowNegatives = _ref.allowNegatives,
      onChange = _ref.onChange,
      value = _ref.value,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  function changeValue(newVal) {
    if (allowNegatives || newVal >= 0) {
      onChange(newVal);
    }
  }

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Host, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(NumberHost, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(MinusButton, {
        onClick: function onClick(e) {
          e.preventDefault();
          var nn = value - 1;

          if (allowNegatives || nn >= 0) {
            changeValue(nn);
          }
        },
        children: "-"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_NumberFormatInput__WEBPACK_IMPORTED_MODULE_6__/* .NumberFormatInput */ .v, _objectSpread({
        customInput: _Input__WEBPACK_IMPORTED_MODULE_7__/* .Input */ .II,
        displayType: "input",
        allowEmptyFormatting: true,
        value: value,
        textAlign: "center",
        labelVariant: "aboveInput",
        variant: "noBorder",
        onValueChange: function onValueChange(values) {
          if (values.floatValue !== undefined && values.floatValue > -1) {
            changeValue(values.floatValue);
          }
        }
      }, rest)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(PlusButton, {
        onClick: function onClick(e) {
          e.preventDefault();
          changeValue(value + 1);
        },
        children: "+"
      })]
    })
  });
}

/***/ }),

/***/ 37047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ Radiogroup; },
/* harmony export */   "E": function() { return /* binding */ RadioButton; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32706);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52539);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56818);
/* harmony import */ var _Label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92527);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var RadiogroupHost = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "ez1j8yc5"
} : 0)( true ? {
  name: "1nzeh8k",
  styles: "width:100%;position:relative;display:flex;flex-direction:column;&>*+*{margin-top:8px;}"
} : 0);

function Radiogroup(_ref) {
  var children = _ref.children,
      errorMessage = _ref.errorMessage;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(RadiogroupHost, {
    role: "radiogroup",
    children: [children, errorMessage && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_Label__WEBPACK_IMPORTED_MODULE_5__/* .ErrorLabel */ .hW, {
      children: errorMessage
    })]
  });
}

var Radio = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("input",  true ? {
  target: "ez1j8yc4"
} : 0)( true ? {
  name: "5p6uli",
  styles: "opacity:0;position:absolute;transform:translateX(-50000px);&:focus+label{outline:rgba(77, 97, 171, 0.5) auto 3px;}"
} : 0);

var Circle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(react_spring__WEBPACK_IMPORTED_MODULE_3__.animated.span,  true ? {
  shouldForwardProp: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .shouldForwardProp */ .x)('span'),
  target: "ez1j8yc3"
} : 0)("border:1px solid ", function (_ref2) {
  var _theme$colors$current;

  var theme = _ref2.theme,
      checked = _ref2.checked,
      currentTheme = _ref2.currentTheme;
  return checked ? 'transparent' : (0,polished__WEBPACK_IMPORTED_MODULE_7__/* .rgba */ .m4)((_theme$colors$current = theme.colors[currentTheme]) !== null && _theme$colors$current !== void 0 ? _theme$colors$current : '', 0.3);
}, ";height:24px;width:24px;left:0px;top:calc(50% - 12px);position:absolute;border-radius:100px;background:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.background;
}, ";" + ( true ? "" : 0));

var AnimatedCircle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(react_spring__WEBPACK_IMPORTED_MODULE_3__.animated.span,  true ? {
  shouldForwardProp: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .shouldForwardProp */ .x)('span'),
  target: "ez1j8yc2"
} : 0)("border-color:", function (_ref4) {
  var theme = _ref4.theme,
      checked = _ref4.checked,
      currentTheme = _ref4.currentTheme;
  return checked ? theme.colors[currentTheme] : 'transparent';
}, ";height:22px;border-style:solid;width:22px;left:0px;top:calc(50% - 11px);position:absolute;border-radius:100px;" + ( true ? "" : 0));

var Label = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("label",  true ? {
  target: "ez1j8yc1"
} : 0)("cursor:pointer;", _styles_typography__WEBPACK_IMPORTED_MODULE_8__/* .typography.numbers2 */ .cp.numbers2, ";color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.foreground;
}, ";position:relative;padding-left:39px;padding-top:4px;display:flex;flex-direction:column;justify-content:center;height:100%;&:hover>span>span{background:", function (_ref6) {
  var theme = _ref6.theme,
      checked = _ref6.checked,
      currentTheme = _ref6.currentTheme;
  return checked ? 'transparent' : theme.colors[currentTheme];
}, ";border:8px solid ", function (_ref7) {
  var theme = _ref7.theme,
      checked = _ref7.checked,
      currentTheme = _ref7.currentTheme;
  return !checked ? theme.colors.background : theme.colors[currentTheme];
}, ";}&>span{border-color:", function (_ref8) {
  var _theme$colors$current2;

  var theme = _ref8.theme,
      isValid = _ref8.isValid,
      currentTheme = _ref8.currentTheme;
  return isValid === false ? theme.colors.warning : (0,polished__WEBPACK_IMPORTED_MODULE_7__/* .rgba */ .m4)((_theme$colors$current2 = theme.colors[currentTheme]) !== null && _theme$colors$current2 !== void 0 ? _theme$colors$current2 : '', 0.3);
}, ";", function (_ref9) {
  var isValid = _ref9.isValid,
      theme = _ref9.theme;
  return isValid === false && "background-color: ".concat((0,polished__WEBPACK_IMPORTED_MODULE_7__/* .rgba */ .m4)(theme.colors.warning, 0.1));
}, ";}&:hover>span{border-color:", function (_ref10) {
  var theme = _ref10.theme,
      currentTheme = _ref10.currentTheme;
  return theme.colors[currentTheme];
}, ";}" + ( true ? "" : 0));

var RadioHost = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "ez1j8yc0"
} : 0)("height:64px;padding-left:15px;box-shadow:0 0 0 1px ", function (_ref11) {
  var _theme$colors$foregro;

  var variant = _ref11.variant,
      theme = _ref11.theme;
  return variant === 'fullBorder' || variant === 'bottomBorder' ? (0,polished__WEBPACK_IMPORTED_MODULE_7__/* .rgba */ .m4)((_theme$colors$foregro = theme === null || theme === void 0 ? void 0 : theme.colors.foreground) !== null && _theme$colors$foregro !== void 0 ? _theme$colors$foregro : '', 0.8) : 'transparent';
}, ";background-color:", function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.background;
}, ";", function (_ref13) {
  var theme = _ref13.theme,
      isValid = _ref13.isValid;
  return isValid !== undefined && isValid === false && "box-shadow: 0 0 0 2px ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.warning);
}, ";&:hover{", function (_ref14) {
  var _theme$colors$foregro2;

  var variant = _ref14.variant,
      theme = _ref14.theme;
  return variant === 'fullBorder' && "box-shadow: 0 0 0 1px ".concat((0,polished__WEBPACK_IMPORTED_MODULE_7__/* .rgba */ .m4)((_theme$colors$foregro2 = theme === null || theme === void 0 ? void 0 : theme.colors.foreground) !== null && _theme$colors$foregro2 !== void 0 ? _theme$colors$foregro2 : '', 0.5));
}, ";&>span{border-color:", function (props) {
  var _props$theme;

  return (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.colors.foreground;
}, ";}}&:active{box-shadow:0 0 0 2px ", function (props) {
  var _props$theme2;

  return (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.shades.primary3;
}, ";}" + ( true ? "" : 0));

var RadioButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function RButton(_ref15, ref) {
  var label = _ref15.label,
      checked = _ref15.checked,
      _onChange = _ref15.onChange,
      _ref15$theme = _ref15.theme,
      theme = _ref15$theme === void 0 ? 'primary' : _ref15$theme,
      className = _ref15.className,
      _ref15$variant = _ref15.variant,
      variant = _ref15$variant === void 0 ? 'fullBorder' : _ref15$variant,
      isValid = _ref15.isValid;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var animatingCircle = (0,react_spring__WEBPACK_IMPORTED_MODULE_3__.useSpring)({
    borderWidth: checked || focused ? '8px' : '0px',
    config: {
      duration: 150
    }
  });
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(RadioHost, {
    variant: variant,
    isValid: isValid,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Label, {
      currentTheme: theme,
      checked: checked,
      className: className,
      htmlFor: "radio_".concat(label, "_").concat(theme),
      "aria-checked": checked,
      isValid: isValid,
      onMouseEnter: function onMouseEnter() {
        setFocused(true);
      },
      onMouseLeave: function onMouseLeave() {
        setFocused(false);
      },
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Circle, {
        currentTheme: theme,
        checked: checked,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(AnimatedCircle, {
          currentTheme: theme,
          checked: checked,
          style: _objectSpread({}, animatingCircle)
        })
      }), label]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Radio, {
      id: "radio_".concat(label, "_").concat(theme),
      type: "radio",
      checked: checked,
      onChange: function onChange(e) {
        _onChange(e.currentTarget.checked);
      },
      ref: ref
    })]
  });
});

/***/ }),

/***/ 36704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FormTitle; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_divider_Divider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49505);
/* harmony import */ var _styles_devices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7949);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52539);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);









var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h2",  true ? {
  target: "e1w5txq21"
} : 0)(_styles_typography__WEBPACK_IMPORTED_MODULE_2__/* .typography.h2 */ .cp.h2, ";" + ( true ? "" : 0));

var CustomDivider = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_components_divider_Divider__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .i,  true ? {
  target: "e1w5txq20"
} : 0)("margin:31px 0 25px;background-color:currentColor;@media ", _styles_devices__WEBPACK_IMPORTED_MODULE_4__/* .device.tablet */ .U.tablet, "{margin:10% 0;}@media ", _styles_devices__WEBPACK_IMPORTED_MODULE_4__/* .device.pageLimit */ .U.pageLimit, "{margin:31px 0 25px;}" + ( true ? "" : 0));

function FormTitle(_ref) {
  var text = _ref.text;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Host, {
      children: text
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(CustomDivider, {})]
  });
}

/***/ }),

/***/ 51599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Table; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _styles_devices__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7949);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);



var _excluded = ["children", "isZebra", "isClickable", "isSelectable", "colorTheme"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eglfrtr1"
} : 0)( true ? {
  name: "q33xhg",
  styles: "overflow-x:auto;overflow-y:hidden"
} : 0);

var TableHost = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("table",  true ? {
  target: "eglfrtr0"
} : 0)("width:100%;text-align:right;border-collapse:separate;th{&:first-child{text-align:left;", function (props) {
  return !props.isZebra && "padding-left: 0px;";
}, "@media ", _styles_devices__WEBPACK_IMPORTED_MODULE_3__/* .device.tablet */ .U.tablet, "{", function (props) {
  return !props.isZebra && !props.isSelectable ? "padding-left: 0px;" : "padding-left: 10px;";
}, ";}}&:last-child{text-align:right;", function (props) {
  return !props.isZebra && "padding-right: 0px;";
}, "@media ", _styles_devices__WEBPACK_IMPORTED_MODULE_3__/* .device.tablet */ .U.tablet, "{", function (props) {
  return !props.isZebra && !props.isSelectable ? "padding-right: 0px;" : "padding-right: 10px;";
}, ";}}}td{z-index:2;position:relative;", function (props) {
  return props.compact ? 'padding: 8px 0' : undefined;
}, ";transition:border-color 100ms ease-in;border-bottom:1px solid ", function (props) {
  return (0,polished__WEBPACK_IMPORTED_MODULE_4__/* .rgba */ .m4)(props.theme.colors.primary, 0.1);
}, ";padding-bottom:", function (props) {
  return props.compact ? '12px;' : '8px';
}, ";&:after{content:'';position:absolute;bottom:-1px;left:0;right:0;height:2px;width:100%;transition:background-color 100ms ease-in;}&:first-child{text-align:left;", function (props) {
  return !props.isZebra && "padding-left: 0px;";
}, "@media ", _styles_devices__WEBPACK_IMPORTED_MODULE_3__/* .device.tablet */ .U.tablet, "{", function (props) {
  return !props.isZebra && !props.isSelectable ? "padding-left: 0px;" : "padding-left: 11px;";
}, ";}}&:last-child{text-align:right;", function (props) {
  return !props.isZebra && "padding-right: 0px;";
}, "@media ", _styles_devices__WEBPACK_IMPORTED_MODULE_3__/* .device.tablet */ .U.tablet, "{", function (props) {
  return !props.isZebra && !props.isSelectable ? "padding-right: 0px;" : "padding-right: 11px;";
}, ";}}}tr:nth-child(2n){td{", function (props) {
  if (props.isZebra) return "\n          background-color: ".concat(props.theme.shades["".concat(props.colorTheme, "1")], ";\n        ");
}, ";}}tr:hover td{", function (props) {
  if (props.isClickable && props.colorTheme !== undefined) return "\n        z-index: 2;\n        position:relative;\n        cursor: pointer;\n        padding-bottom:".concat(props.compact ? '11px' : '7px', ";\n        border-bottom: 2px solid ").concat(props.colorTheme !== 'primary' ? props.theme.shades["".concat(props.colorTheme, "3")] : '#cadbf0', ";            \n      ");
}, ";}" + ( true ? "" : 0));

var Table = function Table(_ref) {
  var children = _ref.children,
      _ref$isZebra = _ref.isZebra,
      isZebra = _ref$isZebra === void 0 ? false : _ref$isZebra,
      _ref$isClickable = _ref.isClickable,
      isClickable = _ref$isClickable === void 0 ? false : _ref$isClickable,
      _ref$isSelectable = _ref.isSelectable,
      isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
      _ref$colorTheme = _ref.colorTheme,
      colorTheme = _ref$colorTheme === void 0 ? 'primary' : _ref$colorTheme,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Host, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(TableHost, _objectSpread(_objectSpread({
      isZebra: isZebra,
      isClickable: isClickable,
      isSelectable: isSelectable,
      colorTheme: colorTheme
    }, rest), {}, {
      children: children
    }))
  });
};

/***/ }),

/***/ 40535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Tbody; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);



var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("tbody",  true ? {
  target: "eipcc7i0"
} : 0)( true ? "" : 0);

var Tbody = function Tbody(_ref) {
  var children = _ref.children,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Host, _objectSpread(_objectSpread({}, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 39345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Td": function() { return /* binding */ Td; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);



var _excluded = ["align", "children", "colSpan"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("td",  true ? {
  target: "e1ioqjip0"
} : 0)("padding:11px 11px;text-align:", function (props) {
  return props.align ? props.align : 'left';
}, ";border-bottom:", function (props) {
  return "1px solid ".concat((0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rgba */ .m4)(props.theme.colors.primary, 0.1));
}, ";" + ( true ? "" : 0));

var Td = function Td(_ref) {
  var align = _ref.align,
      children = _ref.children,
      colSpan = _ref.colSpan,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Host, _objectSpread(_objectSpread({
    align: align,
    colSpan: colSpan
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 36433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Th": function() { return /* binding */ Th; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52539);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);



var _excluded = ["align", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("th",  true ? {
  target: "e1hg8uis0"
} : 0)("padding:12px 10px 5px;", _styles_typography__WEBPACK_IMPORTED_MODULE_3__/* .typography.bodySmall */ .cp.bodySmall, " text-align:", function (props) {
  return props.align ? props.align : 'left';
}, ";border-bottom:", function (props) {
  return "3px solid ".concat(props.theme.shades.primary5);
}, ";" + ( true ? "" : 0));

var Th = function Th(_ref) {
  var align = _ref.align,
      children = _ref.children,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Host, _objectSpread(_objectSpread({
    align: align
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 81617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Thead; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);



var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("thead",  true ? {
  target: "e1mj2w010"
} : 0)( true ? {
  name: "xtzknd",
  styles: "tr{height:40px;vertical-align:bottom;}"
} : 0);

var Thead = function Thead(_ref) {
  var children = _ref.children,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Host, _objectSpread(_objectSpread({}, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 5766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tr": function() { return /* binding */ Tr; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74704);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52539);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);



var _excluded = ["children", "firstColumnTitle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var Host = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("tr",  true ? {
  target: "e1ozloo10"
} : 0)("min-height:68px;&:last-child td{border-color:", function (props) {
  return (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rgba */ .m4)(props.theme.colors.foreground, 0.5);
}, ";}&:first-child td{&:before{top:0px;}}th:first-child{", function (_ref) {
  var firstColumnTitle = _ref.firstColumnTitle;
  return firstColumnTitle && _styles_typography__WEBPACK_IMPORTED_MODULE_4__/* .typography.h5 */ .cp.h5;
}, ";}td{border-color:", function (props) {
  return (0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rgba */ .m4)(props.theme.colors.primary, 0.1);
}, ";transition:border-color 100ms ease-in;", function (props) {
  if (props.active && props.colorTheme !== undefined) return "\n        \n        background-color: ".concat(props.colorTheme !== 'primary' ? props.theme.shades["".concat(props.colorTheme, "1")] : '#f0f4fb', ";\n        \n        position: relative;\n\n\n        &:before {\n          content: '';\n\n          position: absolute;\n          top: -1px;\n          left: 0;\n          right: 0;\n\n          height: 1px;\n          width: 100%;\n\n          background-color: ").concat(props.colorTheme !== 'primary' ? props.theme.shades["".concat(props.colorTheme, "1")] : '#f0f4fb', ";\n        }\n\n          &:after {\n            content: '';\n\n            position: absolute;\n            bottom: -1px;\n            left: 0;\n            right: 0;\n\n            height: 2px;\n            width: 100%;\n\n            background-color: ").concat(props.colorTheme !== 'primary' ? props.theme.shades["".concat(props.colorTheme, "3")] : '#cadbf0', ";\n          }    \n      ");
}, ";&:before{content:'';position:absolute;top:0;left:0;right:0;height:1px;width:100%;transition:border-color 100ms ease-in;}&:after{content:'';position:absolute;bottom:-1px;left:0;right:0;height:2px;width:100%;}}" + ( true ? "" : 0));

var Tr = function Tr(_ref2) {
  var children = _ref2.children,
      _ref2$firstColumnTitl = _ref2.firstColumnTitle,
      firstColumnTitle = _ref2$firstColumnTitl === void 0 ? true : _ref2$firstColumnTitl,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Host, _objectSpread(_objectSpread({
    firstColumnTitle: firstColumnTitle
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 97602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ SelectorTabs; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 7 modules
var polished_esm = __webpack_require__(74704);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(32706);
// EXTERNAL MODULE: ../../packages/ui/src/components/dialog/Dialog.tsx + 1 modules
var Dialog = __webpack_require__(31388);
// EXTERNAL MODULE: ../../packages/ui/src/styles/typography.tsx
var typography = __webpack_require__(52539);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../packages/ui/src/components/form/dropdown/MobileDropdown.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var Button = (0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "et8w9v64"
} : 0)("font-size:16px;line-height:24px;cursor:pointer;font-weight:500;background:", function (props) {
  return props.inset ? props.theme.shades.primary1 : '#fff';
}, ";position:relative;width:100%;border:", function (props) {
  return props.bordered ? "1px solid ".concat(props.theme.colors.primary) : 'none';
}, ";text-align:start;padding:", function (props) {
  return props.bordered ? ' 21px 20px 17px 12px' : ' 15px 20px 15px 12px';
}, ";display:flex;justify-content:space-between;align-items:center;" + ( true ? "" : 0));

var Ul = (0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "et8w9v63"
} : 0)( true ? {
  name: "12mkfdx",
  styles: "outline:none"
} : 0);

var ListItem = (0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "et8w9v62"
} : 0)("border-bottom:1px solid rgba(30, 61, 90, 0.2);&:hover{box-shadow:0 3px 0 0 ", function (props) {
  return (0,polished_esm/* rgba */.m4)(props.theme.colors.primary, 1);
}, ";border-color:transparent;cursor:pointer;}" + ( true ? "" : 0));

var ListButton = (0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "et8w9v61"
} : 0)(typography/* typography.body */.cp.body, " width:100%;text-align:start;padding:", function (props) {
  return props.hasSubtext ? '14px 0 13px 0' : '23px 0 22px 0';
}, ";line-height:18px;cursor:pointer;font-weight:bold;opacity:", function (props) {
  return props.selected ? '0.3' : '1';
}, ";" + ( true ? "" : 0));

var SubText = (0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "et8w9v60"
} : 0)(typography/* typography.bodySmall */.cp.bodySmall, " opacity:", function (props) {
  return props.selected ? '1' : '0.6';
}, ";" + ( true ? "" : 0));

var MobileDropdown = function MobileDropdown(_ref) {
  var _options$find$label, _options$find;

  var onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value,
      placeholder = _ref.placeholder,
      dialogTitle = _ref.dialogTitle,
      bordered = _ref.bordered,
      inset = _ref.inset;

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var ref = (0,react.useRef)(null);
  var buttonRef = (0,react.useRef)(null);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button, {
      bordered: bordered,
      ref: buttonRef,
      inset: inset,
      onClick: function onClick() {
        return setOpen(true);
      },
      "aria-haspopup": "listbox",
      children: [(_options$find$label = (_options$find = options.find(function (i) {
        return i.value === value;
      })) === null || _options$find === void 0 ? void 0 : _options$find.label) !== null && _options$find$label !== void 0 ? _options$find$label : placeholder, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "16",
        height: "10",
        viewBox: "0 0 16 10",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
          fill: "none",
          fillRule: "evenodd",
          stroke: "#163E63",
          strokeWidth: "2",
          d: "M14.545455.909091L8 8.272727 1.454545.909091"
        })
      })]
    }), open && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
      onClose: function onClose() {
        return setOpen(false);
      },
      title: {
        label: dialogTitle
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ul, {
        ref: ref,
        tabIndex: -1,
        role: "listbox",
        children: options.map(function (option) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
            role: "option",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListButton, {
              hasSubtext: !!option.subText,
              selected: option.value === value,
              onClick: function onClick() {
                var _buttonRef$current;

                onChange(option.value);
                setOpen(false);
                buttonRef === null || buttonRef === void 0 ? void 0 : (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.focus();
              },
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                children: option.label
              }), option.subText && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubText, {
                children: option.subText
              })]
            })
          }, option.value);
        })
      })
    })]
  });
};
// EXTERNAL MODULE: ../../packages/ui/src/hooks/useMedia.ts
var useMedia = __webpack_require__(5728);
// EXTERNAL MODULE: ../../packages/ui/src/styles/theme.ts
var theme = __webpack_require__(58176);
// EXTERNAL MODULE: ../../packages/ui/src/styles/devices.ts
var devices = __webpack_require__(7949);
;// CONCATENATED MODULE: ../../packages/ui/src/components/tabs/SelectorTabs.tsx




var _excluded = ["items", "selectedItemId", "onSelectTab", "mobileLabel", "mobileInset", "mobileVariant", "variant", "fontVariant", "lineColor", "tabSpacing"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ButtonGroup = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18k210n3"
} : 0)("position:relative;width:100%;display:flex;&>*+*:not(:last-child){margin-left:", function (_ref) {
  var tabSpacing = _ref.tabSpacing;
  return tabSpacing;
}, ";}@media ", devices/* device.tablet */.U.tablet, "{border-bottom:", function (_ref2) {
  var variant = _ref2.variant,
      theme = _ref2.theme;
  return variant === 'block' ? '0px;' : "1px solid ".concat((0,polished_esm/* rgba */.m4)(theme.colors.foreground, 0.3));
}, ";flex-direction:row;}" + ( true ? "" : 0));

var TabHost = (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18k210n2"
} : 0)( true ? "" : 0);

var Tab = (0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e18k210n1"
} : 0)("padding-bottom:26px;text-align:left;display:flex;align-items:center;", typography/* typography.h5 */.cp.h5, ";", function (_ref3) {
  var block = _ref3.block,
      fontVariant = _ref3.fontVariant;
  return (block || fontVariant === 'small') && typography/* typography.bodySmall */.cp.bodySmall;
}, ";", function (_ref4) {
  var fontVariant = _ref4.fontVariant;
  return fontVariant === 'secondary' && typography/* typography.body */.cp.body;
}, ";", function (_ref5) {
  var selected = _ref5.selected,
      fontVariant = _ref5.fontVariant;
  return !selected && fontVariant === 'secondary' && 'opacity: 0.6;';
}, " ", function (_ref6) {
  var selected = _ref6.selected,
      fontVariant = _ref6.fontVariant;
  return selected && fontVariant === 'small' && 'font-weight: 500;';
}, " ", function (_ref7) {
  var fontVariant = _ref7.fontVariant;
  return fontVariant === 'small' && 'padding-bottom: 16px';
}, ";", function (props) {
  if (props.block) {
    return "color: ".concat(props.selected ? theme/* theme.colors.primary */.r.colors.primary : 'white', ";\n      background: ").concat(props.selected ? 'white' : 'rgb(30, 105, 176)', ";\n      justify-content: center;\n      padding: 11px 10px 8px 10px;\n      font-weight: bold;\n      min-height: auto;\n      width: 100%;\n    ");
  }
}, ";cursor:pointer;@media ", devices/* device.tablet */.U.tablet, "{margin-top:0;}&>svg{margin-right:10px;}" + ( true ? "" : 0));

var Underline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(react_spring_esm.animated.div,  true ? {
  target: "e18k210n0"
} : 0)("width:100%;height:4px;background:", function (_ref8) {
  var theme = _ref8.theme,
      lineColor = _ref8.lineColor;
  return theme.colors[lineColor];
}, ";position:absolute;bottom:-1px;left:0;" + ( true ? "" : 0));

function SelectorTabs(_ref9) {
  var items = _ref9.items,
      selectedItemId = _ref9.selectedItemId,
      onSelectTab = _ref9.onSelectTab,
      mobileLabel = _ref9.mobileLabel,
      mobileInset = _ref9.mobileInset,
      _ref9$mobileVariant = _ref9.mobileVariant,
      mobileVariant = _ref9$mobileVariant === void 0 ? 'dropdown' : _ref9$mobileVariant,
      _ref9$variant = _ref9.variant,
      variant = _ref9$variant === void 0 ? 'underline' : _ref9$variant,
      _ref9$fontVariant = _ref9.fontVariant,
      fontVariant = _ref9$fontVariant === void 0 ? 'primary' : _ref9$fontVariant,
      _ref9$lineColor = _ref9.lineColor,
      lineColor = _ref9$lineColor === void 0 ? 'foreground' : _ref9$lineColor,
      _ref9$tabSpacing = _ref9.tabSpacing,
      tabSpacing = _ref9$tabSpacing === void 0 ? '24px' : _ref9$tabSpacing,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref9, _excluded);

  var _React$useState = react.useState([]),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      elRefs = _React$useState2[0],
      setElRefs = _React$useState2[1];

  var isMobile = (0,useMedia/* useMedia */.G)('sm');
  var ref = (0,react.useRef)(null);

  var _useSpring = (0,react_spring_esm.useSpring)(function () {
    return {
      x: 0,
      width: 0
    };
  }),
      _useSpring2 = (0,slicedToArray/* default */.Z)(_useSpring, 2),
      underline = _useSpring2[0],
      spring = _useSpring2[1];

  react.useEffect(function () {
    // add or remove refs
    setElRefs(function (elRefs) {
      return Array(items.length).fill(null).map(function (_, i) {
        return elRefs[i] || /*#__PURE__*/(0,react.createRef)();
      });
    });
  }, [items.length]);
  var selectedRef = react.useMemo(function () {
    return elRefs ? elRefs[items.findIndex(function (x) {
      return x.id === selectedItemId;
    })] : null;
  }, [elRefs, selectedItemId, items]);
  var reset = react.useCallback(function (_ref10) {
    var _ref10$immediate = _ref10.immediate,
        immediate = _ref10$immediate === void 0 ? false : _ref10$immediate;

    if (ref.current) {
      var host = ref.current; // const activeIndex = items.findIndex((x) => x.id === selectedItemId);

      var item = selectedRef;
      var hostRect = host.getBoundingClientRect();

      if (item) {
        var itemRect = item.getBoundingClientRect();
        spring.start({
          x: itemRect.x - hostRect.x,
          width: itemRect.width,
          immediate: immediate
        });
      } else {
        spring.start({
          width: 0
        });
      }
    }
  }, [selectedRef, spring]);
  var onMouseOver = react.useCallback(function (e) {
    if (ref.current) {
      var item = e.currentTarget.getBoundingClientRect();
      var host = ref.current.getBoundingClientRect();
      spring.start({
        x: item.x - host.x,
        width: item.width
      });
    }
  }, [spring]);

  var onMouseOut = function onMouseOut() {
    reset({
      immediate: false
    });
  };

  (0,react.useEffect)(function () {
    reset({
      immediate: true
    });
  }, [reset, selectedRef]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonGroup, _objectSpread(_objectSpread({
    ref: ref,
    tabSpacing: tabSpacing
  }, rest), {}, {
    children: !isMobile || variant === 'block' || mobileVariant === 'tabs' ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [items.map(function (x, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabHost, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tab, {
            selected: x.id === selectedItemId,
            onClick: function onClick(e) {
              onSelectTab(x.id);
              return onMouseOver(e);
            },
            onMouseOver: variant !== 'block' ? onMouseOver : undefined,
            onMouseOut: variant !== 'block' ? onMouseOut : undefined,
            block: variant === 'block',
            ref: function ref(_ref11) {
              if (_ref11) elRefs[index] = _ref11;
            },
            fontVariant: fontVariant,
            children: [x.icon, x.label]
          })
        }, x.id);
      }), variant === 'underline' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Underline, {
        style: underline,
        lineColor: lineColor
      })]
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileDropdown, {
      inset: mobileInset,
      bordered: !mobileInset,
      dialogTitle: mobileLabel !== null && mobileLabel !== void 0 ? mobileLabel : '',
      options: items.map(function (i) {
        return {
          value: i.id,
          label: i.label
        };
      }),
      value: selectedItemId,
      onChange: function onChange(val) {
        return onSelectTab(val);
      }
    })
  }));
}

/***/ }),

/***/ 16172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8529);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44711);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var react_laag__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4960);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32706);
/* harmony import */ var _components_dialog_Dialog__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31388);
/* harmony import */ var _components_divider_Divider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49505);
/* harmony import */ var _hooks_useMedia__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5728);
/* harmony import */ var _styles_devices__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7949);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58176);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52539);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56818);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52903);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var Host = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(react_spring__WEBPACK_IMPORTED_MODULE_4__.animated.div,  true ? {
  shouldForwardProp: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .shouldForwardProp */ .x)('div'),
  target: "e17rv6tv7"
} : 0)("padding:44px;width:500px;background:", function (props) {
  return props.bg;
}, ";z-index:3;pointer-events:", function (props) {
  return props.isOpen ? 'auto' : 'none';
}, ";", function (props) {
  return props.side === 'top' ? 'margin-top: -32px;' : '';
}, ";" + ( true ? "" : 0));

var Title = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h3",  true ? {
  target: "e17rv6tv6"
} : 0)(_styles_typography__WEBPACK_IMPORTED_MODULE_6__/* .typography.h2 */ .cp.h2, " margin-top:80px;@media ", _styles_devices__WEBPACK_IMPORTED_MODULE_7__/* .device.tablet */ .U.tablet, "{", _styles_typography__WEBPACK_IMPORTED_MODULE_6__/* .typography.h4 */ .cp.h4, " margin-top:0px;}" + ( true ? "" : 0));

var Text = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p",  true ? {
  target: "e17rv6tv5"
} : 0)( true ? "" : 0);

var Triangle = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e17rv6tv4"
} : 0)("width:0;height:0;border-style:solid;border-width:16px 16px 0 16px;border-color:", function (props) {
  return "".concat(props.bg, " transparent transparent transparent");
}, ";" + ( true ? "" : 0));

var Link = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("a",  true ? {
  target: "e17rv6tv3"
} : 0)( true ? {
  name: "5ni3h",
  styles: "position:relative;z-index:1;cursor:pointer;display:inline-block"
} : 0);

var ButtonText = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e17rv6tv2"
} : 0)( true ? {
  name: "179t5g5",
  styles: "position:relative;z-index:1"
} : 0);

var BorderBottom = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(react_spring__WEBPACK_IMPORTED_MODULE_4__.animated.div,  true ? {
  target: "e17rv6tv1"
} : 0)("position:absolute;bottom:2px;left:0;z-index:0;height:4px;width:100%;background-color:", function (props) {
  return props.theme.shades.primary2;
}, ";transform-origin:bottom;" + ( true ? "" : 0));

var QuestionMark = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e17rv6tv0"
} : 0)("background:", function (props) {
  return props.theme.colors.background;
}, ";border-radius:100px;height:20px;width:20px;text-align:center;", _styles_typography__WEBPACK_IMPORTED_MODULE_6__/* .typography.bodySmall */ .cp.bodySmall, " line-height:24px;" + ( true ? "" : 0));

function getArrowTranslate(layerSide) {
  var x = '-50%';
  var y = '0';
  var OFFSET = 8;

  if (layerSide === 'left') {
    x = -OFFSET + 'px';
    y = '-100%';
  } else if (layerSide === 'right') {
    x = OFFSET + 'px';
    y = '-100%';
  }

  var rotation = {
    top: 0,
    right: 90,
    left: -90,
    bottom: 180
  };
  return "translate(".concat(x, ", ").concat(y, ") rotate(").concat(rotation[layerSide], "deg)");
}

function Content(_ref) {
  var isOpen = _ref.isOpen,
      layerProps = _ref.layerProps,
      layerSide = _ref.layerSide,
      bg = _ref.bg,
      title = _ref.title,
      copy = _ref.copy,
      arrowStyle = _ref.arrowStyle;
  var fadeIn = (0,react_spring__WEBPACK_IMPORTED_MODULE_4__.useSpring)({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? 'translateY(15px)' : 'translateY(0px)'
  });

  if (isOpen) {
    var _arrowStyle$top;

    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(Host, {
      ref: layerProps.ref,
      side: layerSide,
      style: _objectSpread(_objectSpread({}, fadeIn), layerProps.style),
      isOpen: isOpen,
      bg: bg,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Title, {
        children: title
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_divider_Divider__WEBPACK_IMPORTED_MODULE_9__/* .Divider */ .i, {
        margin: "23px 0 20px"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Text, {
        children: copy
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Triangle, {
        bg: bg,
        style: _objectSpread(_objectSpread({}, arrowStyle), {}, {
          top: (layerSide === 'left' || layerSide === 'right') && ((_arrowStyle$top = arrowStyle === null || arrowStyle === void 0 ? void 0 : arrowStyle.top) !== null && _arrowStyle$top !== void 0 ? _arrowStyle$top : 0) < 32 ? 32 : arrowStyle.top,
          position: 'absolute',
          transformOrigin: 'center',
          transform: getArrowTranslate(layerSide)
        })
      })]
    });
  }

  return null;
}

var Tooltip = function Tooltip(_ref2) {
  var title = _ref2.title,
      copy = _ref2.copy,
      placement = _ref2.placement,
      anchor = _ref2.anchor,
      useQuestionMark = _ref2.useQuestionMark,
      _ref2$bg = _ref2.bg,
      bg = _ref2$bg === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_10__/* .theme.shades.primary2 */ .r.shades.primary2 : _ref2$bg;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      clicked = _useState[0],
      setClicked = _useState[1];

  var isMobile = (0,_hooks_useMedia__WEBPACK_IMPORTED_MODULE_11__/* .useMedia */ .G)('sm');

  var _useTooltip = (0,react_laag__WEBPACK_IMPORTED_MODULE_12__/* .useTooltip */ .lL)(function (props) {
    return !isMobile && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Content, _objectSpread(_objectSpread({}, props), {}, {
      bg: bg,
      title: title,
      copy: copy
    }));
  }, {
    delayEnter: 100,
    delayLeave: 100,
    ResizeObserver: _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_2__/* .ResizeObserver */ ["do"],
    closeOnOutsideClick: true,
    closeOnDisappear: 'partial',
    placement: placement !== null && placement !== void 0 ? placement : {
      anchor: anchor !== null && anchor !== void 0 ? anchor : 'TOP_CENTER',
      autoAdjust: true,
      snapToAnchor: false,
      triggerOffset: 16,
      scrollOffset: 16,
      preferX: 'RIGHT'
    }
  }),
      _useTooltip2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useTooltip, 2),
      element = _useTooltip2[0],
      triggerProps = _useTooltip2[1];
  /*   const expand = useSpring({
    transform: isHover || isOpen ? 'scaleY(2)' : 'scaleY(1)',
  }); */


  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
    children: [element, (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Link, _objectSpread(_objectSpread({}, triggerProps), {}, {
      children: useQuestionMark ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(QuestionMark, {
        onClick: function onClick() {
          return setClicked(!clicked);
        },
        children: "?"
      }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ButtonText, {
          children: title
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(BorderBottom
        /* style={expand} */
        , {})]
      })
    })), clicked && isMobile && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_components_dialog_Dialog__WEBPACK_IMPORTED_MODULE_14__/* .Dialog */ .V, {
      onClose: function onClose() {
        return setClicked(false);
      },
      title: {
        label: title !== null && title !== void 0 ? title : ''
      },
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Title, {
        children: title
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_divider_Divider__WEBPACK_IMPORTED_MODULE_9__/* .Divider */ .i, {
        margin: "23px 0 20px"
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(Text, {
        children: copy
      })]
    })]
  });
};

/***/ }),

/***/ 37330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ FormContext; },
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8529);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var use_immer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54492);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);



var _excluded = ["validation", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable @typescript-eslint/no-empty-function */



var FormContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createContext({
  inputs: [],
  addInput: function addInput() {},
  removeInput: function removeInput() {},
  updateInput: function updateInput() {},
  isInputGroupValid: function isInputGroupValid() {
    return true;
  },
  validate: true,
  hasSubmitted: false
});
var Form = function Form(_ref) {
  var validation = _ref.validation,
      children = _ref.children,
      rest = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(false),
      _React$useState2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_React$useState, 2),
      hasSubmitted = _React$useState2[0],
      setHasSubmitted = _React$useState2[1];

  var _useImmer = (0,use_immer__WEBPACK_IMPORTED_MODULE_4__/* .useImmer */ .x)({
    inputs: [],
    validate: false
  }),
      _useImmer2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useImmer, 2),
      _useImmer2$ = _useImmer2[0],
      inputs = _useImmer2$.inputs,
      validate = _useImmer2$.validate,
      setState = _useImmer2[1];

  var resetSubmit = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function () {
    setHasSubmitted(false);
  }, [setHasSubmitted]);
  /* Add input to watch for and run validators for */

  var addInput = function addInput(input) {
    setState(function (draft) {
      draft.inputs.push(input);
    });
  };
  /* Remove input to watch for and run validators for */


  var removeInput = function removeInput(name) {
    setState(function (draft) {
      draft.inputs = draft.inputs.filter(function (x) {
        return x.name !== name;
      });
    });
  };
  /* Runs validation on form submit */


  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    var errors = [];
    validateInputs(errors);
    setHasSubmitted(true);

    if (errors.length > 0) {
      setTimeout(function () {
        return errors[0].onFocus();
      });
    } else if (rest.onSubmit) {
      rest.onSubmit(e);
    }

    return false;
  };
  /* Map through all registered inputs and run validators for them */


  var validateInputs = function validateInputs(errors) {
    setState(function (draft) {
      draft.validate = true;
      draft.inputs = draft.inputs.map(function (input) {
        var errorMessage;
        input.isValid = input.validators.reduce(function (current, validator) {
          if (!validator.validation(input.value)) {
            errors.push({
              onFocus: input.onFocus,
              message: validator.message,
              isValid: false
            });

            if (errorMessage === undefined) {
              errorMessage = validator.message;
            }

            return false;
          }

          return current;
        }, true);
        input.invalidMessge = errorMessage;
        return input;
      });
    });
  };
  /* update an already registered input */


  var updateInput = function updateInput(input) {
    setState(function (draft) {
      var index = draft.inputs.findIndex(function (x) {
        return x.name === input.name;
      });

      if (index > -1) {
        draft.inputs[index] = input;
      }
    });
  };

  var isInputGroupValid = function isInputGroupValid(validationGroup) {
    return inputs.filter(function (x) {
      return x.validationGroup === validationGroup;
    }).reduce(function (current, item) {
      return current && item.isValid;
    }, true);
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(FormContext.Provider, {
    value: {
      inputs: inputs,
      validate: validate,
      removeInput: removeInput,
      addInput: addInput,
      updateInput: updateInput,
      isInputGroupValid: isInputGroupValid,
      hasSubmitted: hasSubmitted
    },
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("form", _objectSpread(_objectSpread({}, rest), {}, {
      onSubmit: onSubmit,
      style: {
        width: '100%'
      },
      children: children
    }))
  });
};

/***/ }),

/***/ 90152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useEmailValidation; }
/* harmony export */ });
/* harmony import */ var _useInputValidation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46309);

var re = // eslint-disable-next-line regexp/no-unused-capturing-group
/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/; // taken from chromium

var useEmailValidation = function useEmailValidation(email) {
  return (0,_useInputValidation__WEBPACK_IMPORTED_MODULE_0__/* .useInputValidation */ .a)(email, [{
    validation: function validation(v) {
      return v !== undefined && re.test(String(v).toLowerCase());
    },
    message: 'Netfang er ekki á réttu formi.'
  }]);
};

/***/ }),

/***/ 46309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useInputValidation; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8529);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6804);
/* harmony import */ var _Form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37330);





/**
 *
 * @param value Value to validate
 * @param validators array of validators that will be run for the value
 * @param deps Rerender dependencies for the validators, will update the validators when changed
 * @param validationGroup used to group multiple input validations together
 */
var useInputValidation = function useInputValidation(value, validators) {
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var validationGroup = arguments.length > 3 ? arguments[3] : undefined;
  var validationContext = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_Form__WEBPACK_IMPORTED_MODULE_1__/* .FormContext */ .q);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(undefined),
      _React$useState2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState, 2),
      isValid = _React$useState2[0],
      setIsValid = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState(undefined),
      _React$useState4 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState3, 2),
      isFocused = _React$useState4[0],
      setIsFocused = _React$useState4[1];

  var _React$useState5 = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
      _React$useState6 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState5, 2),
      isDirty = _React$useState6[0],
      setIsDirty = _React$useState6[1];

  var _React$useState7 = react__WEBPACK_IMPORTED_MODULE_0__.useState(undefined),
      _React$useState8 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState7, 2),
      message = _React$useState8[0],
      setMessage = _React$useState8[1];

  var _React$useState9 = react__WEBPACK_IMPORTED_MODULE_0__.useState((0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()),
      _React$useState10 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState9, 1),
      inputId = _React$useState10[0];

  var _React$useState11 = react__WEBPACK_IMPORTED_MODULE_0__.useState(undefined),
      _React$useState12 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState11, 2),
      contextInput = _React$useState12[0],
      setContextInput = _React$useState12[1];

  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null); // Create a memoized callback for the validators, prevents rerendering

  var cb = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    return validators;
  }, deps);
  var setFocus = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    var _ref$current;

    (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
  }, [ref]);
  /* On mount and unmount we register the input with the form contet */

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var _ref$current2, _ref$current3;

    validationContext.addInput({
      value: value,
      validationGroup: validationGroup,
      validators: cb(),
      name: inputId,
      isValid: true,
      onFocus: setFocus
    });

    var onBlur = function onBlur() {
      setIsFocused(false);
    };

    var onFocus = function onFocus() {
      setIsFocused(true);
    }; // © Trúðalestin™ - 2020 make Landsbankinn great again


    (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.addEventListener('blur', onBlur);
    (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.addEventListener('focus', onFocus);
    return function () {
      var _ref$current4, _ref$current5;

      validationContext.removeInput(inputId);
      (_ref$current4 = ref.current) === null || _ref$current4 === void 0 ? void 0 : _ref$current4.removeEventListener('blur', onBlur);
      (_ref$current5 = ref.current) === null || _ref$current5 === void 0 ? void 0 : _ref$current5.removeEventListener('focus', onFocus);
    };
  }, []);
  /* Update the current input when value or validators change */

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var _validate = validate(),
        isValid = _validate.isValid,
        newMessage = _validate.newMessage;

    setIsValid(isValid);

    if (!isFocused || validationContext.hasSubmitted) {
      setMessage(newMessage);
    }

    validationContext.updateInput({
      validationGroup: validationGroup,
      value: value,
      isValid: isValid,
      validators: cb(),
      name: inputId,
      onFocus: setFocus
    });
  }, [value, cb, isFocused, validationContext.hasSubmitted]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    setContextInput(validationContext.inputs.find(function (x) {
      return x.name === inputId;
    }));
  }, [validationContext.inputs, inputId]);

  function validate() {
    if ((value === 0 || value) && !isDirty) {
      setIsDirty(true);
    }

    if (!validationContext.hasSubmitted && !isDirty) {
      return {
        isValid: true
      };
    }

    var message;
    var isValid = validators.reduce(function (current, validator) {
      if (!current) {
        return false;
      }

      if (!validator.validation(value)) {
        message = validator.message;
        return false;
      }

      return true;
    }, true);
    return {
      newMessage: message,
      isValid: isValid
    };
  }

  var isContextInputValid = contextInput !== undefined ? contextInput.isValid : true;
  var contextMessage = contextInput !== undefined ? contextInput.invalidMessge : undefined;
  return [ref, // fugly hack
  isValid !== false && isContextInputValid, message || contextMessage || ''];
};

/***/ }),

/***/ 11776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useKennitalaValidation; }
/* harmony export */ });
/* harmony import */ var _useInputValidation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46309);

var useKennitalaValidation = function useKennitalaValidation(email) {
  return (0,_useInputValidation__WEBPACK_IMPORTED_MODULE_0__/* .useInputValidation */ .a)(email, [{
    validation: function validation(v) {
      return v !== undefined && v.length === 10;
    },
    message: 'Kennitala er ekki á réttu formi'
  }]);
};

/***/ }),

/***/ 51539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ usePhoneValidation; }
/* harmony export */ });
/* harmony import */ var _useInputValidation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46309);

var usePhoneValidation = function usePhoneValidation(email) {
  return (0,_useInputValidation__WEBPACK_IMPORTED_MODULE_0__/* .useInputValidation */ .a)(email, [{
    validation: function validation(v) {
      return v !== undefined && v.replaceAll('-', '').length === 7;
    },
    // including the dash.
    message: 'Símanúmer er ekki á réttu formi'
  }]);
};

/***/ })

}]);